import * as d from "react";
import l, { useLayoutEffect as Pf, useEffect as le, useState as de, useRef as Te, forwardRef as jt, useMemo as Le, useCallback as _e, createContext as Cs, createElement as ze, useContext as Nf, Children as rr, isValidElement as Es, cloneElement as Yl, Fragment as Z_, useReducer as J_ } from "react";
import * as yr from "react-dom";
import ja, { flushSync as xs, createPortal as ro } from "react-dom";
import { flexRender as Df } from "@tanstack/react-table";
import { $isCodeNode as Q_, $createCodeNode as ep, CodeNode as tp } from "@lexical/code";
import { $isLinkNode as Ss, TOGGLE_LINK_COMMAND as Li, LinkNode as np } from "@lexical/link";
import { REMOVE_LIST_COMMAND as rp, INSERT_UNORDERED_LIST_COMMAND as ap, INSERT_ORDERED_LIST_COMMAND as sp, $isListNode as op, ListNode as If, ListItemNode as ip } from "@lexical/list";
import { CHECK_LIST as lp, ELEMENT_TRANSFORMERS as cp, MULTILINE_ELEMENT_TRANSFORMERS as up, TEXT_FORMAT_TRANSFORMERS as dp, TEXT_MATCH_TRANSFORMERS as fp, TRANSFORMERS as Gl, $convertToMarkdownString as Kl, $convertFromMarkdownString as Xl } from "@lexical/markdown";
import { TableNode as Zl, TableRowNode as $f, TableCellNode as Jl, $isTableNode as Kr, $isTableRowNode as dr, $isTableCellNode as vt, TableCellHeaderStates as bt, $createTableNode as bp, $createTableRowNode as mp, $createTableCellNode as _p, $getTableCellNodeFromLexicalNode as pp, $isTableSelection as Sn, $getTableNodeFromLexicalNodeOrThrow as tn, getTableObserverFromTableElement as jp, $insertTableRow__EXPERIMENTAL as vp, $insertTableColumn__EXPERIMENTAL as hp, $deleteTableRow__EXPERIMENTAL as gp, $deleteTableColumn__EXPERIMENTAL as yp, $getTableRowIndexFromTableCellNode as Lf, $getTableColumnIndexFromTableCellNode as wp, $getNodeTriplet as Ql, $unmergeCell as Cp, $computeTableMapSkipCellCheck as Ep, getDOMCellFromTarget as xp, INSERT_TABLE_COMMAND as Sp } from "@lexical/table";
import { CheckListPlugin as kp } from "@lexical/react/LexicalCheckListPlugin";
import { LexicalComposer as Tp } from "@lexical/react/LexicalComposer";
import { useLexicalComposerContext as Ze } from "@lexical/react/LexicalComposerContext";
import { ContentEditable as Rp } from "@lexical/react/LexicalContentEditable";
import Op from "@lexical/react/LexicalErrorBoundary";
import { HistoryPlugin as Mp } from "@lexical/react/LexicalHistoryPlugin";
import { LinkPlugin as Ap } from "@lexical/react/LexicalLinkPlugin";
import { ListPlugin as Pp } from "@lexical/react/LexicalListPlugin";
import { MarkdownShortcutPlugin as Np } from "@lexical/react/LexicalMarkdownShortcutPlugin";
import { RichTextPlugin as Dp } from "@lexical/react/LexicalRichTextPlugin";
import { TabIndentationPlugin as Ip } from "@lexical/react/LexicalTabIndentationPlugin";
import { TablePlugin as $p } from "@lexical/react/LexicalTablePlugin";
import { $createQuoteNode as Lp, $createHeadingNode as zp, $isHeadingNode as Fp, HeadingNode as Hp, QuoteNode as Bp } from "@lexical/rich-text";
import { HorizontalRuleNode as zf, $isHorizontalRuleNode as qp, $createHorizontalRuleNode as Up } from "@lexical/react/LexicalHorizontalRuleNode";
import { $isParagraphNode as ec, $isTextNode as Ff, $getRoot as ea, BLUR_COMMAND as Wp, COMMAND_PRIORITY_LOW as ta, $getSelection as wt, $isRangeSelection as Ct, $createParagraphNode as tc, $isElementNode as Vp, $getNearestNodeFromDOMNode as qo, createCommand as Yp, FORMAT_ELEMENT_COMMAND as Gp, FORMAT_TEXT_COMMAND as Hf, KEY_MODIFIER_COMMAND as nc, COMMAND_PRIORITY_NORMAL as rc, SELECTION_CHANGE_COMMAND as Bf, $createTextNode as qf, CAN_UNDO_COMMAND as Kp, CAN_REDO_COMMAND as Xp, UNDO_COMMAND as Zp, REDO_COMMAND as Jp, $isRootOrShadowRoot as Qp } from "lexical";
import { $generateHtmlFromNodes as ej } from "@lexical/html";
import { OnChangePlugin as tj } from "@lexical/react/LexicalOnChangePlugin";
import { useLexicalEditable as Uf } from "@lexical/react/useLexicalEditable";
import { calculateZoomLevel as zi, mergeRegister as ac, $findMatchingParent as Lu, $getNearestNodeOfType as nj } from "@lexical/utils";
import { $isAtNodeEnd as ks, $setBlocksType as Uo } from "@lexical/selection";
function Wf(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = Wf(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function q() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = Wf(e)) && (r && (r += " "), r += t);
  return r;
}
const Xe = (e, t, { checkForDefaultPrevented: n = !0 } = {}) => function(a) {
  if (e == null || e(a), n === !1 || !a.defaultPrevented)
    return t == null ? void 0 : t(a);
};
function Vf(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function We(e) {
  return l.useCallback(Vf(e), e);
}
var sc = "_1byayhm0";
const Yf = () => {
  const e = document.querySelector("body");
  e && e.classList.remove(sc);
}, Xr = () => {
  const e = document.querySelector("body");
  e && (e.style.top = `-${document.documentElement.scrollTop}px`, e.style.overflowY = document.documentElement.scrollHeight > document.documentElement.clientHeight ? "scroll" : "auto", e.classList.add(sc), window.addEventListener("popstate", Yf));
}, oc = () => {
  var t;
  const e = document.querySelector("body");
  if (e) {
    const n = ((t = e.getBoundingClientRect()) == null ? void 0 : t.top) * -1;
    e.classList.remove(sc), window.scrollBy({
      left: 0,
      top: n,
      behavior: "instant"
    }), e.style.top = "", e.style.overflowY = "", window.removeEventListener("popstate", Yf);
  }
}, rj = (e) => {
  const t = l.useRef(!0), n = l.useRef(0), r = l.useRef(0), a = l.useCallback((i) => {
    if (r.current) {
      const c = i - r.current;
      e(c);
    }
    r.current = i, t.current && (n.current = requestAnimationFrame(a));
  }, []), s = l.useCallback(() => {
    t.current = !0, n.current = requestAnimationFrame(a);
  }, []), o = l.useCallback(() => {
    t.current = !1, cancelAnimationFrame(n.current);
  }, [n.current]);
  return l.useEffect(() => () => {
    n.current && cancelAnimationFrame(n.current);
  }, []), {
    start: s,
    stop: o
  };
};
function aj(e, t) {
  return Object.defineProperty(e, "__recipe__", {
    value: t,
    writable: !1
  }), e;
}
var Gf = aj;
function sj(e) {
  var {
    conditions: t
  } = e;
  if (!t)
    throw new Error("Styles have no conditions");
  function n(r) {
    if (typeof r == "string" || typeof r == "number" || typeof r == "boolean") {
      if (!t.defaultCondition)
        throw new Error("No default condition");
      return {
        [t.defaultCondition]: r
      };
    }
    if (Array.isArray(r)) {
      if (!("responsiveArray" in t))
        throw new Error("Responsive arrays are not supported");
      var a = {};
      for (var s in t.responsiveArray)
        r[s] != null && (a[t.responsiveArray[s]] = r[s]);
      return a;
    }
    return r;
  }
  return Gf(n, {
    importPath: "@vanilla-extract/sprinkles/createUtils",
    importName: "createNormalizeValueFn",
    args: [{
      conditions: e.conditions
    }]
  });
}
function oj(e) {
  var {
    conditions: t
  } = e;
  if (!t)
    throw new Error("Styles have no conditions");
  var n = sj(e);
  function r(a, s) {
    if (typeof a == "string" || typeof a == "number" || typeof a == "boolean") {
      if (!t.defaultCondition)
        throw new Error("No default condition");
      return s(a, t.defaultCondition);
    }
    var o = Array.isArray(a) ? n(a) : a, i = {};
    for (var c in o)
      o[c] != null && (i[c] = s(o[c], c));
    return i;
  }
  return Gf(r, {
    importPath: "@vanilla-extract/sprinkles/createUtils",
    importName: "createMapValueFn",
    args: [{
      conditions: e.conditions
    }]
  });
}
function ij(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function lj(e) {
  var t = ij(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function cj(e, t, n) {
  return t = lj(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function zu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Wo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zu(Object(n), !0).forEach(function(r) {
      cj(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var uj = (e) => function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var a = Object.assign({}, ...n.map((c) => c.styles)), s = Object.keys(a), o = s.filter((c) => "mappings" in a[c]), i = (c) => {
    var u = [], f = {}, m = Wo({}, c), b = !1;
    for (var _ of o) {
      var j = c[_];
      if (j != null) {
        var p = a[_];
        b = !0;
        for (var v of p.mappings)
          f[v] = j, m[v] == null && delete m[v];
      }
    }
    var h = b ? Wo(Wo({}, f), m) : c, g = function() {
      var E = h[w], C = a[w];
      try {
        if (C.mappings)
          return "continue";
        if (typeof E == "string" || typeof E == "number") {
          if (process.env.NODE_ENV !== "production" && !C.values[E].defaultClass)
            throw new Error();
          u.push(C.values[E].defaultClass);
        } else if (Array.isArray(E))
          for (var S = 0; S < E.length; S++) {
            var k = E[S];
            if (k != null) {
              var O = C.responsiveArray[S];
              if (process.env.NODE_ENV !== "production" && !C.values[k].conditions[O])
                throw new Error();
              u.push(C.values[k].conditions[O]);
            }
          }
        else
          for (var L in E) {
            var H = E[L];
            if (H != null) {
              if (process.env.NODE_ENV !== "production" && !C.values[H].conditions[L])
                throw new Error();
              u.push(C.values[H].conditions[L]);
            }
          }
      } catch (P) {
        if (process.env.NODE_ENV !== "production") {
          class A extends Error {
            constructor(B) {
              super(B), this.name = "SprinklesError";
            }
          }
          var T = ($) => typeof $ == "string" ? '"'.concat($, '"') : $, R = ($, B, Y) => {
            throw new A('"'.concat($, '" has no value ').concat(T(B), ". Possible values are ").concat(Object.keys(Y).map(T).join(", ")));
          };
          if (!C)
            throw new A('"'.concat(w, '" is not a valid sprinkle'));
          if ((typeof E == "string" || typeof E == "number") && (E in C.values || R(w, E, C.values), !C.values[E].defaultClass))
            throw new A('"'.concat(w, '" has no default condition. You must specify which conditions to target explicitly. Possible options are ').concat(Object.keys(C.values[E].conditions).map(T).join(", ")));
          if (typeof E == "object") {
            if (!("conditions" in C.values[Object.keys(C.values)[0]]))
              throw new A('"'.concat(w, '" is not a conditional property'));
            if (Array.isArray(E)) {
              if (!("responsiveArray" in C))
                throw new A('"'.concat(w, '" does not support responsive arrays'));
              var M = C.responsiveArray.length;
              if (M < E.length)
                throw new A('"'.concat(w, '" only supports up to ').concat(M, " breakpoints. You passed ").concat(E.length));
              for (var D of E)
                C.values[D] || R(w, D, C.values);
            } else
              for (var I in E) {
                var F = E[I];
                if (F != null && (C.values[F] || R(w, F, C.values), !C.values[F].conditions[I]))
                  throw new A('"'.concat(w, '" has no condition named ').concat(T(I), ". Possible values are ").concat(Object.keys(C.values[F].conditions).map(T).join(", ")));
              }
          }
        }
        throw P;
      }
    };
    for (var w in h)
      var x = g();
    return e(u.join(" "));
  };
  return Object.assign(i, {
    properties: new Set(s)
  });
}, dj = (e) => e, fj = function() {
  return uj(dj)(...arguments);
}, bj = { mobile: "0", tablet: "600px", laptop: "960px", monitor: "1280px", ultrawide: "1920px" }, EN = { heading: "var(--aw-text-default-heading)", body: "var(--aw-text-default-body)", secondary: "var(--aw-text-default-secondary)", placeholder: "var(--aw-text-default-placeholder)", brandDefault: "var(--aw-text-brand-default)", brandSecondary: "var(--aw-text-brand-secondary)", brandTertiary: "var(--aw-text-brand-tertiary)", dangerDefault: "var(--aw-text-danger-default)", dangerSecondary: "var(--aw-text-danger-secondary)", dangerTertiary: "var(--aw-text-danger-tertiary)", warningDefault: "var(--aw-text-warning-default)", warningSecondary: "var(--aw-text-warning-secondary)", warningTertiary: "var(--aw-text-warning-tertiary)", successDefault: "var(--aw-text-success-default)", successSecondary: "var(--aw-text-success-secondary)", successTertiary: "var(--aw-text-success-tertiary)", infoDefault: "var(--aw-text-info-default)", infoSecondary: "var(--aw-text-info-secondary)", infoTertiary: "var(--aw-text-info-tertiary)", neutralDefault: "var(--aw-icon-neutral-default)", neutralSecondary: "var(--aw-icon-neutral-secondary)", neutralTertiary: "var(--aw-icon-neutral-tertiary)", onBrand: "var(--aw-text-on-brand)", onDanger: "var(--aw-text-on-danger)", onSuccess: "var(--aw-text-on-success)", onWarning: "var(--aw-text-on-warning)", onInfo: "var(--aw-text-on-info)", monoBlack: "var(--aw-mono-black)", monoWhite: "var(--aw-mono-white)", accentBlueDefault: "var(--aw-accent-blue-default)", accentBlueSecondary: "var(--aw-accent-blue-secondary)", accentGreenDefault: "var(--aw-accent-green-default)", accentGreenSecondary: "var(--aw-accent-green-secondary)", accentGreyDefault: "var(--aw-accent-grey-default)", accentGreySecondary: "var(--aw-accent-grey-secondary)", accentOrangeDefault: "var(--aw-accent-orange-default)", accentOrangeSecondary: "var(--aw-accent-orange-secondary)", accentPinkDefault: "var(--aw-accent-pink-default)", accentPinkSecondary: "var(--aw-accent-pink-secondary)", accentRedDefault: "var(--aw-accent-red-default)", accentRedSecondary: "var(--aw-accent-red-secondary)", accentVioletDefault: "var(--aw-accent-violet-default)", accentVioletSecondary: "var(--aw-accent-violet-secondary)", accentYellowDefault: "var(--aw-accent-yellow-default)", accentYellowSecondary: "var(--aw-accent-yellow-secondary)", inherit: "inherit" }, xN = { brandDefault: "var(--aw-background-brand-default)", brandSecondary: "var(--aw-background-brand-secondary)", brandTertiary: "var(--aw-background-brand-tertiary)", brandHighlight: "var(--aw-background-brand-highlight)", dangerDefault: "var(--aw-background-danger-default)", dangerSecondary: "var(--aw-background-danger-secondary)", dangerTertiary: "var(--aw-background-danger-tertiary)", dangerHighlight: "var(--aw-background-danger-highlight)", warningDefault: "var(--aw-background-warning-default)", warningSecondary: "var(--aw-background-warning-secondary)", warningTertiary: "var(--aw-background-warning-tertiary)", warningHighlight: "var(--aw-background-warning-highlight)", successDefault: "var(--aw-background-success-default)", successSecondary: "var(--aw-background-success-secondary)", successTertiary: "var(--aw-background-success-tertiary)", successHighlight: "var(--aw-background-success-highlight)", infoDefault: "var(--aw-background-info-default)", infoSecondary: "var(--aw-background-info-secondary)", infoTertiary: "var(--aw-background-info-tertiary)", infoHighlight: "var(--aw-background-info-highlight)", neutralDefault: "var(--aw-icon-neutral-default)", neutralSecondary: "var(--aw-icon-neutral-secondary)", neutralTertiary: "var(--aw-icon-neutral-tertiary)", widgetDefault: "var(--aw-background-widget-default)", widgetSecondary: "var(--aw-background-widget-secondary)", widgetTertiary: "var(--aw-background-widget-tertiary)", widgetPronounced: "var(--aw-background-widget-pronounced)", widgetHighlight: "var(--aw-background-widget-highlight)", widgetBlue: "var(--aw-background-blue)", accentBlueDefault: "var(--aw-accent-blue-default)", accentBlueSecondary: "var(--aw-accent-blue-secondary)", accentGreenDefault: "var(--aw-accent-green-default)", accentGreenSecondary: "var(--aw-accent-green-secondary)", accentGreyDefault: "var(--aw-accent-grey-default)", accentGreySecondary: "var(--aw-accent-grey-secondary)", accentOrangeDefault: "var(--aw-accent-orange-default)", accentOrangeSecondary: "var(--aw-accent-orange-secondary)", accentPinkDefault: "var(--aw-accent-pink-default)", accentPinkSecondary: "var(--aw-accent-pink-secondary)", accentRedDefault: "var(--aw-accent-red-default)", accentRedSecondary: "var(--aw-accent-red-secondary)", accentVioletDefault: "var(--aw-accent-violet-default)", accentVioletSecondary: "var(--aw-accent-violet-secondary)", accentYellowDefault: "var(--aw-accent-yellow-default)", accentYellowSecondary: "var(--aw-accent-yellow-secondary)", monoBlack: "var(--aw-mono-black)", monoWhite: "var(--aw-mono-white)", transparent: "transparent" }, SN = { brandDefault: "var(--aw-border-brand-default)", brandSecondary: "var(--aw-border-brand-secondary)", brandTertiary: "var(--aw-border-brand-tertiary)", dangerDefault: "var(--aw-border-danger-default)", dangerSecondary: "var(--aw-border-danger-secondary)", dangerTertiary: "var(--aw-border-danger-tertiary)", warningDefault: "var(--aw-border-warning-default)", warningSecondary: "var(--aw-border-warning-secondary)", warningTertiary: "var(--aw-border-warning-tertiary)", successDefault: "var(--aw-border-success-default)", successSecondary: "var(--aw-border-success-secondary)", successTertiary: "var(--aw-border-success-tertiary)", infoDefault: "var(--aw-border-info-default)", infoSecondary: "var(--aw-border-info-secondary)", infoTertiary: "var(--aw-border-info-tertiary)", neutralDefault: "var(--aw-border-neutral-default)", neutralSecondary: "var(--aw-border-neutral-secondary)", neutralTertiary: "var(--aw-border-neutral-tertiary)", neutralSubtle: "var(--aw-border-neutral-subtle)", accentBlueDefault: "var(--aw-accent-blue-default)", accentBlueSecondary: "var(--aw-accent-blue-secondary)", accentGreenDefault: "var(--aw-accent-green-default)", accentGreenSecondary: "var(--aw-accent-green-secondary)", accentGreyDefault: "var(--aw-accent-grey-default)", accentGreySecondary: "var(--aw-accent-grey-secondary)", accentOrangeDefault: "var(--aw-accent-orange-default)", accentOrangeSecondary: "var(--aw-accent-orange-secondary)", accentPinkDefault: "var(--aw-accent-pink-default)", accentPinkSecondary: "var(--aw-accent-pink-secondary)", accentRedDefault: "var(--aw-accent-red-default)", accentRedSecondary: "var(--aw-accent-red-secondary)", accentVioletDefault: "var(--aw-accent-violet-default)", accentVioletSecondary: "var(--aw-accent-violet-secondary)", accentYellowDefault: "var(--aw-accent-yellow-default)", accentYellowSecondary: "var(--aw-accent-yellow-secondary)", monoBlack: "var(--aw-mono-black)", monoWhite: "var(--aw-mono-white)", transparent: "transparent" }, kN = { 0: "var(--g800ir0)", "0.25rem": "var(--g800ir1)", "0.5rem": "var(--g800ir2)", "0.75rem": "var(--g800ir3)", "1rem": "var(--g800ir4)", "1.25rem": "var(--g800ir5)", "1.5rem": "var(--g800ir6)", "1.75rem": "var(--g800ir7)", "2rem": "var(--g800ir8)", "2.25rem": "var(--g800ir9)", "2.5rem": "var(--g800ira)", "2.75rem": "var(--g800irb)", "3rem": "var(--g800irc)", "3.25rem": "var(--g800ird)", "3.5rem": "var(--g800ire)", "3.75rem": "var(--g800irf)", "4rem": "var(--g800irg)", "4.25rem": "var(--g800irh)", "4.5rem": "var(--g800iri)", "4.75rem": "var(--g800irj)", "5rem": "var(--g800irk)", "5.25rem": "var(--g800irl)", "5.5rem": "var(--g800irm)", "5.75rem": "var(--g800irn)", "6rem": "var(--g800iro)", "7rem": "var(--g800irp)", "8rem": "var(--g800irq)", "9rem": "var(--g800irr)", "10rem": "var(--g800irs)", "12rem": "var(--g800irt)", "14rem": "var(--g800iru)", "16rem": "var(--g800irv)", "18rem": "var(--g800irw)", "20rem": "var(--g800irx)", "25rem": "var(--g800iry)", "30rem": "var(--g800irz)", "35rem": "var(--g800ir10)", "40rem": "var(--g800ir11)", "45rem": "var(--g800ir12)", "50rem": "var(--g800ir13)", "16%": "16.666667%", "20%": "20%", "25%": "25%", "33%": "33.333333%", "40%": "40%", "50%": "50%", "60%": "60%", "66%": "66.666667%", "75%": "75%", "80%": "80%", "83%": "83.333333%", full: "100%" }, TN = { auto: "auto", zero: "0px", xsmall: "var(--g800ir1)", small: "var(--g800ir2)", smedium: "var(--g800ir3)", default: "var(--g800ir4)", medium: "var(--g800ir6)", large: "var(--g800ir8)", xlarge: "var(--g800irc)", xxlarge: "var(--g800irg)" }, mj = { conditions: { defaultCondition: "focus", conditionNames: ["focus", "focusWithin", "focusVisible"], responsiveArray: void 0 }, styles: { padding: { values: {} }, focusOutline: { values: { default: { conditions: { focus: "_1s8b37j0", focusWithin: "_1s8b37j1", focusVisible: "_1s8b37j2" }, defaultClass: "_1s8b37j0" }, danger: { conditions: { focus: "_1s8b37j3", focusWithin: "_1s8b37j4", focusVisible: "_1s8b37j5" }, defaultClass: "_1s8b37j3" }, warning: { conditions: { focus: "_1s8b37j6", focusWithin: "_1s8b37j7", focusVisible: "_1s8b37j8" }, defaultClass: "_1s8b37j6" }, success: { conditions: { focus: "_1s8b37j9", focusWithin: "_1s8b37ja", focusVisible: "_1s8b37jb" }, defaultClass: "_1s8b37j9" } } } } }, _j = { conditions: { defaultCondition: "default", conditionNames: ["default", "hover", "focus", "active"], responsiveArray: void 0 }, styles: { textColor: { values: { heading: { conditions: { default: "_1s8b37jc", hover: "_1s8b37jd", focus: "_1s8b37je", active: "_1s8b37jf" }, defaultClass: "_1s8b37jc" }, body: { conditions: { default: "_1s8b37jg", hover: "_1s8b37jh", focus: "_1s8b37ji", active: "_1s8b37jj" }, defaultClass: "_1s8b37jg" }, secondary: { conditions: { default: "_1s8b37jk", hover: "_1s8b37jl", focus: "_1s8b37jm", active: "_1s8b37jn" }, defaultClass: "_1s8b37jk" }, placeholder: { conditions: { default: "_1s8b37jo", hover: "_1s8b37jp", focus: "_1s8b37jq", active: "_1s8b37jr" }, defaultClass: "_1s8b37jo" }, brandDefault: { conditions: { default: "_1s8b37js", hover: "_1s8b37jt", focus: "_1s8b37ju", active: "_1s8b37jv" }, defaultClass: "_1s8b37js" }, brandSecondary: { conditions: { default: "_1s8b37jw", hover: "_1s8b37jx", focus: "_1s8b37jy", active: "_1s8b37jz" }, defaultClass: "_1s8b37jw" }, brandTertiary: { conditions: { default: "_1s8b37j10", hover: "_1s8b37j11", focus: "_1s8b37j12", active: "_1s8b37j13" }, defaultClass: "_1s8b37j10" }, dangerDefault: { conditions: { default: "_1s8b37j14", hover: "_1s8b37j15", focus: "_1s8b37j16", active: "_1s8b37j17" }, defaultClass: "_1s8b37j14" }, dangerSecondary: { conditions: { default: "_1s8b37j18", hover: "_1s8b37j19", focus: "_1s8b37j1a", active: "_1s8b37j1b" }, defaultClass: "_1s8b37j18" }, dangerTertiary: { conditions: { default: "_1s8b37j1c", hover: "_1s8b37j1d", focus: "_1s8b37j1e", active: "_1s8b37j1f" }, defaultClass: "_1s8b37j1c" }, warningDefault: { conditions: { default: "_1s8b37j1g", hover: "_1s8b37j1h", focus: "_1s8b37j1i", active: "_1s8b37j1j" }, defaultClass: "_1s8b37j1g" }, warningSecondary: { conditions: { default: "_1s8b37j1k", hover: "_1s8b37j1l", focus: "_1s8b37j1m", active: "_1s8b37j1n" }, defaultClass: "_1s8b37j1k" }, warningTertiary: { conditions: { default: "_1s8b37j1o", hover: "_1s8b37j1p", focus: "_1s8b37j1q", active: "_1s8b37j1r" }, defaultClass: "_1s8b37j1o" }, successDefault: { conditions: { default: "_1s8b37j1s", hover: "_1s8b37j1t", focus: "_1s8b37j1u", active: "_1s8b37j1v" }, defaultClass: "_1s8b37j1s" }, successSecondary: { conditions: { default: "_1s8b37j1w", hover: "_1s8b37j1x", focus: "_1s8b37j1y", active: "_1s8b37j1z" }, defaultClass: "_1s8b37j1w" }, successTertiary: { conditions: { default: "_1s8b37j20", hover: "_1s8b37j21", focus: "_1s8b37j22", active: "_1s8b37j23" }, defaultClass: "_1s8b37j20" }, infoDefault: { conditions: { default: "_1s8b37j24", hover: "_1s8b37j25", focus: "_1s8b37j26", active: "_1s8b37j27" }, defaultClass: "_1s8b37j24" }, infoSecondary: { conditions: { default: "_1s8b37j28", hover: "_1s8b37j29", focus: "_1s8b37j2a", active: "_1s8b37j2b" }, defaultClass: "_1s8b37j28" }, infoTertiary: { conditions: { default: "_1s8b37j2c", hover: "_1s8b37j2d", focus: "_1s8b37j2e", active: "_1s8b37j2f" }, defaultClass: "_1s8b37j2c" }, neutralDefault: { conditions: { default: "_1s8b37j2g", hover: "_1s8b37j2h", focus: "_1s8b37j2i", active: "_1s8b37j2j" }, defaultClass: "_1s8b37j2g" }, neutralSecondary: { conditions: { default: "_1s8b37j2k", hover: "_1s8b37j2l", focus: "_1s8b37j2m", active: "_1s8b37j2n" }, defaultClass: "_1s8b37j2k" }, neutralTertiary: { conditions: { default: "_1s8b37j2o", hover: "_1s8b37j2p", focus: "_1s8b37j2q", active: "_1s8b37j2r" }, defaultClass: "_1s8b37j2o" }, onBrand: { conditions: { default: "_1s8b37j2s", hover: "_1s8b37j2t", focus: "_1s8b37j2u", active: "_1s8b37j2v" }, defaultClass: "_1s8b37j2s" }, onDanger: { conditions: { default: "_1s8b37j2w", hover: "_1s8b37j2x", focus: "_1s8b37j2y", active: "_1s8b37j2z" }, defaultClass: "_1s8b37j2w" }, onSuccess: { conditions: { default: "_1s8b37j30", hover: "_1s8b37j31", focus: "_1s8b37j32", active: "_1s8b37j33" }, defaultClass: "_1s8b37j30" }, onWarning: { conditions: { default: "_1s8b37j34", hover: "_1s8b37j35", focus: "_1s8b37j36", active: "_1s8b37j37" }, defaultClass: "_1s8b37j34" }, onInfo: { conditions: { default: "_1s8b37j38", hover: "_1s8b37j39", focus: "_1s8b37j3a", active: "_1s8b37j3b" }, defaultClass: "_1s8b37j38" }, monoBlack: { conditions: { default: "_1s8b37j3c", hover: "_1s8b37j3d", focus: "_1s8b37j3e", active: "_1s8b37j3f" }, defaultClass: "_1s8b37j3c" }, monoWhite: { conditions: { default: "_1s8b37j3g", hover: "_1s8b37j3h", focus: "_1s8b37j3i", active: "_1s8b37j3j" }, defaultClass: "_1s8b37j3g" }, accentBlueDefault: { conditions: { default: "_1s8b37j3k", hover: "_1s8b37j3l", focus: "_1s8b37j3m", active: "_1s8b37j3n" }, defaultClass: "_1s8b37j3k" }, accentBlueSecondary: { conditions: { default: "_1s8b37j3o", hover: "_1s8b37j3p", focus: "_1s8b37j3q", active: "_1s8b37j3r" }, defaultClass: "_1s8b37j3o" }, accentGreenDefault: { conditions: { default: "_1s8b37j3s", hover: "_1s8b37j3t", focus: "_1s8b37j3u", active: "_1s8b37j3v" }, defaultClass: "_1s8b37j3s" }, accentGreenSecondary: { conditions: { default: "_1s8b37j3w", hover: "_1s8b37j3x", focus: "_1s8b37j3y", active: "_1s8b37j3z" }, defaultClass: "_1s8b37j3w" }, accentGreyDefault: { conditions: { default: "_1s8b37j40", hover: "_1s8b37j41", focus: "_1s8b37j42", active: "_1s8b37j43" }, defaultClass: "_1s8b37j40" }, accentGreySecondary: { conditions: { default: "_1s8b37j44", hover: "_1s8b37j45", focus: "_1s8b37j46", active: "_1s8b37j47" }, defaultClass: "_1s8b37j44" }, accentOrangeDefault: { conditions: { default: "_1s8b37j48", hover: "_1s8b37j49", focus: "_1s8b37j4a", active: "_1s8b37j4b" }, defaultClass: "_1s8b37j48" }, accentOrangeSecondary: { conditions: { default: "_1s8b37j4c", hover: "_1s8b37j4d", focus: "_1s8b37j4e", active: "_1s8b37j4f" }, defaultClass: "_1s8b37j4c" }, accentPinkDefault: { conditions: { default: "_1s8b37j4g", hover: "_1s8b37j4h", focus: "_1s8b37j4i", active: "_1s8b37j4j" }, defaultClass: "_1s8b37j4g" }, accentPinkSecondary: { conditions: { default: "_1s8b37j4k", hover: "_1s8b37j4l", focus: "_1s8b37j4m", active: "_1s8b37j4n" }, defaultClass: "_1s8b37j4k" }, accentRedDefault: { conditions: { default: "_1s8b37j4o", hover: "_1s8b37j4p", focus: "_1s8b37j4q", active: "_1s8b37j4r" }, defaultClass: "_1s8b37j4o" }, accentRedSecondary: { conditions: { default: "_1s8b37j4s", hover: "_1s8b37j4t", focus: "_1s8b37j4u", active: "_1s8b37j4v" }, defaultClass: "_1s8b37j4s" }, accentVioletDefault: { conditions: { default: "_1s8b37j4w", hover: "_1s8b37j4x", focus: "_1s8b37j4y", active: "_1s8b37j4z" }, defaultClass: "_1s8b37j4w" }, accentVioletSecondary: { conditions: { default: "_1s8b37j50", hover: "_1s8b37j51", focus: "_1s8b37j52", active: "_1s8b37j53" }, defaultClass: "_1s8b37j50" }, accentYellowDefault: { conditions: { default: "_1s8b37j54", hover: "_1s8b37j55", focus: "_1s8b37j56", active: "_1s8b37j57" }, defaultClass: "_1s8b37j54" }, accentYellowSecondary: { conditions: { default: "_1s8b37j58", hover: "_1s8b37j59", focus: "_1s8b37j5a", active: "_1s8b37j5b" }, defaultClass: "_1s8b37j58" }, inherit: { conditions: { default: "_1s8b37j5c", hover: "_1s8b37j5d", focus: "_1s8b37j5e", active: "_1s8b37j5f" }, defaultClass: "_1s8b37j5c" } } }, backgroundColor: { values: { brandDefault: { conditions: { default: "_1s8b37j5g", hover: "_1s8b37j5h", focus: "_1s8b37j5i", active: "_1s8b37j5j" }, defaultClass: "_1s8b37j5g" }, brandSecondary: { conditions: { default: "_1s8b37j5k", hover: "_1s8b37j5l", focus: "_1s8b37j5m", active: "_1s8b37j5n" }, defaultClass: "_1s8b37j5k" }, brandTertiary: { conditions: { default: "_1s8b37j5o", hover: "_1s8b37j5p", focus: "_1s8b37j5q", active: "_1s8b37j5r" }, defaultClass: "_1s8b37j5o" }, brandHighlight: { conditions: { default: "_1s8b37j5s", hover: "_1s8b37j5t", focus: "_1s8b37j5u", active: "_1s8b37j5v" }, defaultClass: "_1s8b37j5s" }, dangerDefault: { conditions: { default: "_1s8b37j5w", hover: "_1s8b37j5x", focus: "_1s8b37j5y", active: "_1s8b37j5z" }, defaultClass: "_1s8b37j5w" }, dangerSecondary: { conditions: { default: "_1s8b37j60", hover: "_1s8b37j61", focus: "_1s8b37j62", active: "_1s8b37j63" }, defaultClass: "_1s8b37j60" }, dangerTertiary: { conditions: { default: "_1s8b37j64", hover: "_1s8b37j65", focus: "_1s8b37j66", active: "_1s8b37j67" }, defaultClass: "_1s8b37j64" }, dangerHighlight: { conditions: { default: "_1s8b37j68", hover: "_1s8b37j69", focus: "_1s8b37j6a", active: "_1s8b37j6b" }, defaultClass: "_1s8b37j68" }, warningDefault: { conditions: { default: "_1s8b37j6c", hover: "_1s8b37j6d", focus: "_1s8b37j6e", active: "_1s8b37j6f" }, defaultClass: "_1s8b37j6c" }, warningSecondary: { conditions: { default: "_1s8b37j6g", hover: "_1s8b37j6h", focus: "_1s8b37j6i", active: "_1s8b37j6j" }, defaultClass: "_1s8b37j6g" }, warningTertiary: { conditions: { default: "_1s8b37j6k", hover: "_1s8b37j6l", focus: "_1s8b37j6m", active: "_1s8b37j6n" }, defaultClass: "_1s8b37j6k" }, warningHighlight: { conditions: { default: "_1s8b37j6o", hover: "_1s8b37j6p", focus: "_1s8b37j6q", active: "_1s8b37j6r" }, defaultClass: "_1s8b37j6o" }, successDefault: { conditions: { default: "_1s8b37j6s", hover: "_1s8b37j6t", focus: "_1s8b37j6u", active: "_1s8b37j6v" }, defaultClass: "_1s8b37j6s" }, successSecondary: { conditions: { default: "_1s8b37j6w", hover: "_1s8b37j6x", focus: "_1s8b37j6y", active: "_1s8b37j6z" }, defaultClass: "_1s8b37j6w" }, successTertiary: { conditions: { default: "_1s8b37j70", hover: "_1s8b37j71", focus: "_1s8b37j72", active: "_1s8b37j73" }, defaultClass: "_1s8b37j70" }, successHighlight: { conditions: { default: "_1s8b37j74", hover: "_1s8b37j75", focus: "_1s8b37j76", active: "_1s8b37j77" }, defaultClass: "_1s8b37j74" }, infoDefault: { conditions: { default: "_1s8b37j78", hover: "_1s8b37j79", focus: "_1s8b37j7a", active: "_1s8b37j7b" }, defaultClass: "_1s8b37j78" }, infoSecondary: { conditions: { default: "_1s8b37j7c", hover: "_1s8b37j7d", focus: "_1s8b37j7e", active: "_1s8b37j7f" }, defaultClass: "_1s8b37j7c" }, infoTertiary: { conditions: { default: "_1s8b37j7g", hover: "_1s8b37j7h", focus: "_1s8b37j7i", active: "_1s8b37j7j" }, defaultClass: "_1s8b37j7g" }, infoHighlight: { conditions: { default: "_1s8b37j7k", hover: "_1s8b37j7l", focus: "_1s8b37j7m", active: "_1s8b37j7n" }, defaultClass: "_1s8b37j7k" }, neutralDefault: { conditions: { default: "_1s8b37j7o", hover: "_1s8b37j7p", focus: "_1s8b37j7q", active: "_1s8b37j7r" }, defaultClass: "_1s8b37j7o" }, neutralSecondary: { conditions: { default: "_1s8b37j7s", hover: "_1s8b37j7t", focus: "_1s8b37j7u", active: "_1s8b37j7v" }, defaultClass: "_1s8b37j7s" }, neutralTertiary: { conditions: { default: "_1s8b37j7w", hover: "_1s8b37j7x", focus: "_1s8b37j7y", active: "_1s8b37j7z" }, defaultClass: "_1s8b37j7w" }, widgetDefault: { conditions: { default: "_1s8b37j80", hover: "_1s8b37j81", focus: "_1s8b37j82", active: "_1s8b37j83" }, defaultClass: "_1s8b37j80" }, widgetSecondary: { conditions: { default: "_1s8b37j84", hover: "_1s8b37j85", focus: "_1s8b37j86", active: "_1s8b37j87" }, defaultClass: "_1s8b37j84" }, widgetTertiary: { conditions: { default: "_1s8b37j88", hover: "_1s8b37j89", focus: "_1s8b37j8a", active: "_1s8b37j8b" }, defaultClass: "_1s8b37j88" }, widgetPronounced: { conditions: { default: "_1s8b37j8c", hover: "_1s8b37j8d", focus: "_1s8b37j8e", active: "_1s8b37j8f" }, defaultClass: "_1s8b37j8c" }, widgetHighlight: { conditions: { default: "_1s8b37j8g", hover: "_1s8b37j8h", focus: "_1s8b37j8i", active: "_1s8b37j8j" }, defaultClass: "_1s8b37j8g" }, widgetBlue: { conditions: { default: "_1s8b37j8k", hover: "_1s8b37j8l", focus: "_1s8b37j8m", active: "_1s8b37j8n" }, defaultClass: "_1s8b37j8k" }, accentBlueDefault: { conditions: { default: "_1s8b37j8o", hover: "_1s8b37j8p", focus: "_1s8b37j8q", active: "_1s8b37j8r" }, defaultClass: "_1s8b37j8o" }, accentBlueSecondary: { conditions: { default: "_1s8b37j8s", hover: "_1s8b37j8t", focus: "_1s8b37j8u", active: "_1s8b37j8v" }, defaultClass: "_1s8b37j8s" }, accentGreenDefault: { conditions: { default: "_1s8b37j8w", hover: "_1s8b37j8x", focus: "_1s8b37j8y", active: "_1s8b37j8z" }, defaultClass: "_1s8b37j8w" }, accentGreenSecondary: { conditions: { default: "_1s8b37j90", hover: "_1s8b37j91", focus: "_1s8b37j92", active: "_1s8b37j93" }, defaultClass: "_1s8b37j90" }, accentGreyDefault: { conditions: { default: "_1s8b37j94", hover: "_1s8b37j95", focus: "_1s8b37j96", active: "_1s8b37j97" }, defaultClass: "_1s8b37j94" }, accentGreySecondary: { conditions: { default: "_1s8b37j98", hover: "_1s8b37j99", focus: "_1s8b37j9a", active: "_1s8b37j9b" }, defaultClass: "_1s8b37j98" }, accentOrangeDefault: { conditions: { default: "_1s8b37j9c", hover: "_1s8b37j9d", focus: "_1s8b37j9e", active: "_1s8b37j9f" }, defaultClass: "_1s8b37j9c" }, accentOrangeSecondary: { conditions: { default: "_1s8b37j9g", hover: "_1s8b37j9h", focus: "_1s8b37j9i", active: "_1s8b37j9j" }, defaultClass: "_1s8b37j9g" }, accentPinkDefault: { conditions: { default: "_1s8b37j9k", hover: "_1s8b37j9l", focus: "_1s8b37j9m", active: "_1s8b37j9n" }, defaultClass: "_1s8b37j9k" }, accentPinkSecondary: { conditions: { default: "_1s8b37j9o", hover: "_1s8b37j9p", focus: "_1s8b37j9q", active: "_1s8b37j9r" }, defaultClass: "_1s8b37j9o" }, accentRedDefault: { conditions: { default: "_1s8b37j9s", hover: "_1s8b37j9t", focus: "_1s8b37j9u", active: "_1s8b37j9v" }, defaultClass: "_1s8b37j9s" }, accentRedSecondary: { conditions: { default: "_1s8b37j9w", hover: "_1s8b37j9x", focus: "_1s8b37j9y", active: "_1s8b37j9z" }, defaultClass: "_1s8b37j9w" }, accentVioletDefault: { conditions: { default: "_1s8b37ja0", hover: "_1s8b37ja1", focus: "_1s8b37ja2", active: "_1s8b37ja3" }, defaultClass: "_1s8b37ja0" }, accentVioletSecondary: { conditions: { default: "_1s8b37ja4", hover: "_1s8b37ja5", focus: "_1s8b37ja6", active: "_1s8b37ja7" }, defaultClass: "_1s8b37ja4" }, accentYellowDefault: { conditions: { default: "_1s8b37ja8", hover: "_1s8b37ja9", focus: "_1s8b37jaa", active: "_1s8b37jab" }, defaultClass: "_1s8b37ja8" }, accentYellowSecondary: { conditions: { default: "_1s8b37jac", hover: "_1s8b37jad", focus: "_1s8b37jae", active: "_1s8b37jaf" }, defaultClass: "_1s8b37jac" }, monoBlack: { conditions: { default: "_1s8b37jag", hover: "_1s8b37jah", focus: "_1s8b37jai", active: "_1s8b37jaj" }, defaultClass: "_1s8b37jag" }, monoWhite: { conditions: { default: "_1s8b37jak", hover: "_1s8b37jal", focus: "_1s8b37jam", active: "_1s8b37jan" }, defaultClass: "_1s8b37jak" }, transparent: { conditions: { default: "_1s8b37jao", hover: "_1s8b37jap", focus: "_1s8b37jaq", active: "_1s8b37jar" }, defaultClass: "_1s8b37jao" } } }, borderColor: { values: { brandDefault: { conditions: { default: "_1s8b37jas", hover: "_1s8b37jat", focus: "_1s8b37jau", active: "_1s8b37jav" }, defaultClass: "_1s8b37jas" }, brandSecondary: { conditions: { default: "_1s8b37jaw", hover: "_1s8b37jax", focus: "_1s8b37jay", active: "_1s8b37jaz" }, defaultClass: "_1s8b37jaw" }, brandTertiary: { conditions: { default: "_1s8b37jb0", hover: "_1s8b37jb1", focus: "_1s8b37jb2", active: "_1s8b37jb3" }, defaultClass: "_1s8b37jb0" }, dangerDefault: { conditions: { default: "_1s8b37jb4", hover: "_1s8b37jb5", focus: "_1s8b37jb6", active: "_1s8b37jb7" }, defaultClass: "_1s8b37jb4" }, dangerSecondary: { conditions: { default: "_1s8b37jb8", hover: "_1s8b37jb9", focus: "_1s8b37jba", active: "_1s8b37jbb" }, defaultClass: "_1s8b37jb8" }, dangerTertiary: { conditions: { default: "_1s8b37jbc", hover: "_1s8b37jbd", focus: "_1s8b37jbe", active: "_1s8b37jbf" }, defaultClass: "_1s8b37jbc" }, warningDefault: { conditions: { default: "_1s8b37jbg", hover: "_1s8b37jbh", focus: "_1s8b37jbi", active: "_1s8b37jbj" }, defaultClass: "_1s8b37jbg" }, warningSecondary: { conditions: { default: "_1s8b37jbk", hover: "_1s8b37jbl", focus: "_1s8b37jbm", active: "_1s8b37jbn" }, defaultClass: "_1s8b37jbk" }, warningTertiary: { conditions: { default: "_1s8b37jbo", hover: "_1s8b37jbp", focus: "_1s8b37jbq", active: "_1s8b37jbr" }, defaultClass: "_1s8b37jbo" }, successDefault: { conditions: { default: "_1s8b37jbs", hover: "_1s8b37jbt", focus: "_1s8b37jbu", active: "_1s8b37jbv" }, defaultClass: "_1s8b37jbs" }, successSecondary: { conditions: { default: "_1s8b37jbw", hover: "_1s8b37jbx", focus: "_1s8b37jby", active: "_1s8b37jbz" }, defaultClass: "_1s8b37jbw" }, successTertiary: { conditions: { default: "_1s8b37jc0", hover: "_1s8b37jc1", focus: "_1s8b37jc2", active: "_1s8b37jc3" }, defaultClass: "_1s8b37jc0" }, infoDefault: { conditions: { default: "_1s8b37jc4", hover: "_1s8b37jc5", focus: "_1s8b37jc6", active: "_1s8b37jc7" }, defaultClass: "_1s8b37jc4" }, infoSecondary: { conditions: { default: "_1s8b37jc8", hover: "_1s8b37jc9", focus: "_1s8b37jca", active: "_1s8b37jcb" }, defaultClass: "_1s8b37jc8" }, infoTertiary: { conditions: { default: "_1s8b37jcc", hover: "_1s8b37jcd", focus: "_1s8b37jce", active: "_1s8b37jcf" }, defaultClass: "_1s8b37jcc" }, neutralDefault: { conditions: { default: "_1s8b37jcg", hover: "_1s8b37jch", focus: "_1s8b37jci", active: "_1s8b37jcj" }, defaultClass: "_1s8b37jcg" }, neutralSecondary: { conditions: { default: "_1s8b37jck", hover: "_1s8b37jcl", focus: "_1s8b37jcm", active: "_1s8b37jcn" }, defaultClass: "_1s8b37jck" }, neutralTertiary: { conditions: { default: "_1s8b37jco", hover: "_1s8b37jcp", focus: "_1s8b37jcq", active: "_1s8b37jcr" }, defaultClass: "_1s8b37jco" }, neutralSubtle: { conditions: { default: "_1s8b37jcs", hover: "_1s8b37jct", focus: "_1s8b37jcu", active: "_1s8b37jcv" }, defaultClass: "_1s8b37jcs" }, accentBlueDefault: { conditions: { default: "_1s8b37jcw", hover: "_1s8b37jcx", focus: "_1s8b37jcy", active: "_1s8b37jcz" }, defaultClass: "_1s8b37jcw" }, accentBlueSecondary: { conditions: { default: "_1s8b37jd0", hover: "_1s8b37jd1", focus: "_1s8b37jd2", active: "_1s8b37jd3" }, defaultClass: "_1s8b37jd0" }, accentGreenDefault: { conditions: { default: "_1s8b37jd4", hover: "_1s8b37jd5", focus: "_1s8b37jd6", active: "_1s8b37jd7" }, defaultClass: "_1s8b37jd4" }, accentGreenSecondary: { conditions: { default: "_1s8b37jd8", hover: "_1s8b37jd9", focus: "_1s8b37jda", active: "_1s8b37jdb" }, defaultClass: "_1s8b37jd8" }, accentGreyDefault: { conditions: { default: "_1s8b37jdc", hover: "_1s8b37jdd", focus: "_1s8b37jde", active: "_1s8b37jdf" }, defaultClass: "_1s8b37jdc" }, accentGreySecondary: { conditions: { default: "_1s8b37jdg", hover: "_1s8b37jdh", focus: "_1s8b37jdi", active: "_1s8b37jdj" }, defaultClass: "_1s8b37jdg" }, accentOrangeDefault: { conditions: { default: "_1s8b37jdk", hover: "_1s8b37jdl", focus: "_1s8b37jdm", active: "_1s8b37jdn" }, defaultClass: "_1s8b37jdk" }, accentOrangeSecondary: { conditions: { default: "_1s8b37jdo", hover: "_1s8b37jdp", focus: "_1s8b37jdq", active: "_1s8b37jdr" }, defaultClass: "_1s8b37jdo" }, accentPinkDefault: { conditions: { default: "_1s8b37jds", hover: "_1s8b37jdt", focus: "_1s8b37jdu", active: "_1s8b37jdv" }, defaultClass: "_1s8b37jds" }, accentPinkSecondary: { conditions: { default: "_1s8b37jdw", hover: "_1s8b37jdx", focus: "_1s8b37jdy", active: "_1s8b37jdz" }, defaultClass: "_1s8b37jdw" }, accentRedDefault: { conditions: { default: "_1s8b37je0", hover: "_1s8b37je1", focus: "_1s8b37je2", active: "_1s8b37je3" }, defaultClass: "_1s8b37je0" }, accentRedSecondary: { conditions: { default: "_1s8b37je4", hover: "_1s8b37je5", focus: "_1s8b37je6", active: "_1s8b37je7" }, defaultClass: "_1s8b37je4" }, accentVioletDefault: { conditions: { default: "_1s8b37je8", hover: "_1s8b37je9", focus: "_1s8b37jea", active: "_1s8b37jeb" }, defaultClass: "_1s8b37je8" }, accentVioletSecondary: { conditions: { default: "_1s8b37jec", hover: "_1s8b37jed", focus: "_1s8b37jee", active: "_1s8b37jef" }, defaultClass: "_1s8b37jec" }, accentYellowDefault: { conditions: { default: "_1s8b37jeg", hover: "_1s8b37jeh", focus: "_1s8b37jei", active: "_1s8b37jej" }, defaultClass: "_1s8b37jeg" }, accentYellowSecondary: { conditions: { default: "_1s8b37jek", hover: "_1s8b37jel", focus: "_1s8b37jem", active: "_1s8b37jen" }, defaultClass: "_1s8b37jek" }, monoBlack: { conditions: { default: "_1s8b37jeo", hover: "_1s8b37jep", focus: "_1s8b37jeq", active: "_1s8b37jer" }, defaultClass: "_1s8b37jeo" }, monoWhite: { conditions: { default: "_1s8b37jes", hover: "_1s8b37jet", focus: "_1s8b37jeu", active: "_1s8b37jev" }, defaultClass: "_1s8b37jes" }, transparent: { conditions: { default: "_1s8b37jew", hover: "_1s8b37jex", focus: "_1s8b37jey", active: "_1s8b37jez" }, defaultClass: "_1s8b37jew" } } }, opacity: { values: { 0: { conditions: { default: "_1s8b37jf0", hover: "_1s8b37jf1", focus: "_1s8b37jf2", active: "_1s8b37jf3" }, defaultClass: "_1s8b37jf0" }, 10: { conditions: { default: "_1s8b37jf4", hover: "_1s8b37jf5", focus: "_1s8b37jf6", active: "_1s8b37jf7" }, defaultClass: "_1s8b37jf4" }, 20: { conditions: { default: "_1s8b37jf8", hover: "_1s8b37jf9", focus: "_1s8b37jfa", active: "_1s8b37jfb" }, defaultClass: "_1s8b37jf8" }, 30: { conditions: { default: "_1s8b37jfc", hover: "_1s8b37jfd", focus: "_1s8b37jfe", active: "_1s8b37jff" }, defaultClass: "_1s8b37jfc" }, 40: { conditions: { default: "_1s8b37jfg", hover: "_1s8b37jfh", focus: "_1s8b37jfi", active: "_1s8b37jfj" }, defaultClass: "_1s8b37jfg" }, 50: { conditions: { default: "_1s8b37jfk", hover: "_1s8b37jfl", focus: "_1s8b37jfm", active: "_1s8b37jfn" }, defaultClass: "_1s8b37jfk" }, 60: { conditions: { default: "_1s8b37jfo", hover: "_1s8b37jfp", focus: "_1s8b37jfq", active: "_1s8b37jfr" }, defaultClass: "_1s8b37jfo" }, 70: { conditions: { default: "_1s8b37jfs", hover: "_1s8b37jft", focus: "_1s8b37jfu", active: "_1s8b37jfv" }, defaultClass: "_1s8b37jfs" }, 80: { conditions: { default: "_1s8b37jfw", hover: "_1s8b37jfx", focus: "_1s8b37jfy", active: "_1s8b37jfz" }, defaultClass: "_1s8b37jfw" }, 90: { conditions: { default: "_1s8b37jg0", hover: "_1s8b37jg1", focus: "_1s8b37jg2", active: "_1s8b37jg3" }, defaultClass: "_1s8b37jg0" }, 100: { conditions: { default: "_1s8b37jg4", hover: "_1s8b37jg5", focus: "_1s8b37jg6", active: "_1s8b37jg7" }, defaultClass: "_1s8b37jg4" } } }, backgroundOpacity: { values: { 0: { conditions: { default: "_1s8b37jg8", hover: "_1s8b37jg9", focus: "_1s8b37jga", active: "_1s8b37jgb" }, defaultClass: "_1s8b37jg8" }, 10: { conditions: { default: "_1s8b37jgc", hover: "_1s8b37jgd", focus: "_1s8b37jge", active: "_1s8b37jgf" }, defaultClass: "_1s8b37jgc" }, 20: { conditions: { default: "_1s8b37jgg", hover: "_1s8b37jgh", focus: "_1s8b37jgi", active: "_1s8b37jgj" }, defaultClass: "_1s8b37jgg" }, 30: { conditions: { default: "_1s8b37jgk", hover: "_1s8b37jgl", focus: "_1s8b37jgm", active: "_1s8b37jgn" }, defaultClass: "_1s8b37jgk" }, 40: { conditions: { default: "_1s8b37jgo", hover: "_1s8b37jgp", focus: "_1s8b37jgq", active: "_1s8b37jgr" }, defaultClass: "_1s8b37jgo" }, 50: { conditions: { default: "_1s8b37jgs", hover: "_1s8b37jgt", focus: "_1s8b37jgu", active: "_1s8b37jgv" }, defaultClass: "_1s8b37jgs" }, 60: { conditions: { default: "_1s8b37jgw", hover: "_1s8b37jgx", focus: "_1s8b37jgy", active: "_1s8b37jgz" }, defaultClass: "_1s8b37jgw" }, 70: { conditions: { default: "_1s8b37jh0", hover: "_1s8b37jh1", focus: "_1s8b37jh2", active: "_1s8b37jh3" }, defaultClass: "_1s8b37jh0" }, 80: { conditions: { default: "_1s8b37jh4", hover: "_1s8b37jh5", focus: "_1s8b37jh6", active: "_1s8b37jh7" }, defaultClass: "_1s8b37jh4" }, 90: { conditions: { default: "_1s8b37jh8", hover: "_1s8b37jh9", focus: "_1s8b37jha", active: "_1s8b37jhb" }, defaultClass: "_1s8b37jh8" }, 100: { conditions: { default: "_1s8b37jhc", hover: "_1s8b37jhd", focus: "_1s8b37jhe", active: "_1s8b37jhf" }, defaultClass: "_1s8b37jhc" } } }, textOpacity: { values: { 0: { conditions: { default: "_1s8b37jhg", hover: "_1s8b37jhh", focus: "_1s8b37jhi", active: "_1s8b37jhj" }, defaultClass: "_1s8b37jhg" }, 10: { conditions: { default: "_1s8b37jhk", hover: "_1s8b37jhl", focus: "_1s8b37jhm", active: "_1s8b37jhn" }, defaultClass: "_1s8b37jhk" }, 20: { conditions: { default: "_1s8b37jho", hover: "_1s8b37jhp", focus: "_1s8b37jhq", active: "_1s8b37jhr" }, defaultClass: "_1s8b37jho" }, 30: { conditions: { default: "_1s8b37jhs", hover: "_1s8b37jht", focus: "_1s8b37jhu", active: "_1s8b37jhv" }, defaultClass: "_1s8b37jhs" }, 40: { conditions: { default: "_1s8b37jhw", hover: "_1s8b37jhx", focus: "_1s8b37jhy", active: "_1s8b37jhz" }, defaultClass: "_1s8b37jhw" }, 50: { conditions: { default: "_1s8b37ji0", hover: "_1s8b37ji1", focus: "_1s8b37ji2", active: "_1s8b37ji3" }, defaultClass: "_1s8b37ji0" }, 60: { conditions: { default: "_1s8b37ji4", hover: "_1s8b37ji5", focus: "_1s8b37ji6", active: "_1s8b37ji7" }, defaultClass: "_1s8b37ji4" }, 70: { conditions: { default: "_1s8b37ji8", hover: "_1s8b37ji9", focus: "_1s8b37jia", active: "_1s8b37jib" }, defaultClass: "_1s8b37ji8" }, 80: { conditions: { default: "_1s8b37jic", hover: "_1s8b37jid", focus: "_1s8b37jie", active: "_1s8b37jif" }, defaultClass: "_1s8b37jic" }, 90: { conditions: { default: "_1s8b37jig", hover: "_1s8b37jih", focus: "_1s8b37jii", active: "_1s8b37jij" }, defaultClass: "_1s8b37jig" }, 100: { conditions: { default: "_1s8b37jik", hover: "_1s8b37jil", focus: "_1s8b37jim", active: "_1s8b37jin" }, defaultClass: "_1s8b37jik" } } }, borderOpacity: { values: { 0: { conditions: { default: "_1s8b37jio", hover: "_1s8b37jip", focus: "_1s8b37jiq", active: "_1s8b37jir" }, defaultClass: "_1s8b37jio" }, 10: { conditions: { default: "_1s8b37jis", hover: "_1s8b37jit", focus: "_1s8b37jiu", active: "_1s8b37jiv" }, defaultClass: "_1s8b37jis" }, 20: { conditions: { default: "_1s8b37jiw", hover: "_1s8b37jix", focus: "_1s8b37jiy", active: "_1s8b37jiz" }, defaultClass: "_1s8b37jiw" }, 30: { conditions: { default: "_1s8b37jj0", hover: "_1s8b37jj1", focus: "_1s8b37jj2", active: "_1s8b37jj3" }, defaultClass: "_1s8b37jj0" }, 40: { conditions: { default: "_1s8b37jj4", hover: "_1s8b37jj5", focus: "_1s8b37jj6", active: "_1s8b37jj7" }, defaultClass: "_1s8b37jj4" }, 50: { conditions: { default: "_1s8b37jj8", hover: "_1s8b37jj9", focus: "_1s8b37jja", active: "_1s8b37jjb" }, defaultClass: "_1s8b37jj8" }, 60: { conditions: { default: "_1s8b37jjc", hover: "_1s8b37jjd", focus: "_1s8b37jje", active: "_1s8b37jjf" }, defaultClass: "_1s8b37jjc" }, 70: { conditions: { default: "_1s8b37jjg", hover: "_1s8b37jjh", focus: "_1s8b37jji", active: "_1s8b37jjj" }, defaultClass: "_1s8b37jjg" }, 80: { conditions: { default: "_1s8b37jjk", hover: "_1s8b37jjl", focus: "_1s8b37jjm", active: "_1s8b37jjn" }, defaultClass: "_1s8b37jjk" }, 90: { conditions: { default: "_1s8b37jjo", hover: "_1s8b37jjp", focus: "_1s8b37jjq", active: "_1s8b37jjr" }, defaultClass: "_1s8b37jjo" }, 100: { conditions: { default: "_1s8b37jjs", hover: "_1s8b37jjt", focus: "_1s8b37jju", active: "_1s8b37jjv" }, defaultClass: "_1s8b37jjs" } } } } }, pj = { conditions: { defaultCondition: "default", conditionNames: ["default", "hover", "active"], responsiveArray: void 0 }, styles: { boxShadow: { values: { small: { conditions: { default: "_1s8b37jjw", hover: "_1s8b37jjx", active: "_1s8b37jjy" }, defaultClass: "_1s8b37jjw" }, default: { conditions: { default: "_1s8b37jjz", hover: "_1s8b37jk0", active: "_1s8b37jk1" }, defaultClass: "_1s8b37jjz" }, large: { conditions: { default: "_1s8b37jk2", hover: "_1s8b37jk3", active: "_1s8b37jk4" }, defaultClass: "_1s8b37jk2" } } } } }, RN = { zero: "0", default: "1px", large: "2px", xlarge: "4px" }, ON = { 0: "var(--g800ir0)", "0.25rem": "var(--g800ir1)", "0.5rem": "var(--g800ir2)", "0.75rem": "var(--g800ir3)", "1rem": "var(--g800ir4)", "1.25rem": "var(--g800ir5)", "1.5rem": "var(--g800ir6)", "1.75rem": "var(--g800ir7)", "2rem": "var(--g800ir8)", "2.25rem": "var(--g800ir9)", "2.5rem": "var(--g800ira)", "2.75rem": "var(--g800irb)", "3rem": "var(--g800irc)", "3.25rem": "var(--g800ird)", "3.5rem": "var(--g800ire)", "3.75rem": "var(--g800irf)", "4rem": "var(--g800irg)", "4.25rem": "var(--g800irh)", "4.5rem": "var(--g800iri)", "4.75rem": "var(--g800irj)", "5rem": "var(--g800irk)", "5.25rem": "var(--g800irl)", "5.5rem": "var(--g800irm)", "5.75rem": "var(--g800irn)", "6rem": "var(--g800iro)", "7rem": "var(--g800irp)", "8rem": "var(--g800irq)", "9rem": "var(--g800irr)", "10rem": "var(--g800irs)", "12rem": "var(--g800irt)", "14rem": "var(--g800iru)", "16rem": "var(--g800irv)", "18rem": "var(--g800irw)", "20rem": "var(--g800irx)", "25rem": "var(--g800iry)", "30rem": "var(--g800irz)", "35rem": "var(--g800ir10)", "40rem": "var(--g800ir11)", "45rem": "var(--g800ir12)", "50rem": "var(--g800ir13)", "16%": "16.666667%", "20%": "20%", "25%": "25%", "33%": "33.333333%", "40%": "40%", "50%": "50%", "60%": "60%", "66%": "66.666667%", "75%": "75%", "80%": "80%", "83%": "83.333333%", full: "100%", auto: "auto" }, MN = { 0: "var(--g800ir0)", "0.25rem": "var(--g800ir1)", "0.5rem": "var(--g800ir2)", "0.75rem": "var(--g800ir3)", "1rem": "var(--g800ir4)", "1.25rem": "var(--g800ir5)", "1.5rem": "var(--g800ir6)", "1.75rem": "var(--g800ir7)", "2rem": "var(--g800ir8)", "2.25rem": "var(--g800ir9)", "2.5rem": "var(--g800ira)", "2.75rem": "var(--g800irb)", "3rem": "var(--g800irc)", "3.25rem": "var(--g800ird)", "3.5rem": "var(--g800ire)", "3.75rem": "var(--g800irf)", "4rem": "var(--g800irg)", "4.25rem": "var(--g800irh)", "4.5rem": "var(--g800iri)", "4.75rem": "var(--g800irj)", "5rem": "var(--g800irk)", "5.25rem": "var(--g800irl)", "5.5rem": "var(--g800irm)", "5.75rem": "var(--g800irn)", "6rem": "var(--g800iro)", "7rem": "var(--g800irp)", "8rem": "var(--g800irq)", "9rem": "var(--g800irr)", "10rem": "var(--g800irs)", "12rem": "var(--g800irt)", "14rem": "var(--g800iru)", "16rem": "var(--g800irv)", "18rem": "var(--g800irw)", "20rem": "var(--g800irx)", "25rem": "var(--g800iry)", "30rem": "var(--g800irz)", "35rem": "var(--g800ir10)", "40rem": "var(--g800ir11)", "45rem": "var(--g800ir12)", "50rem": "var(--g800ir13)", "16%": "16.666667%", "20%": "20%", "25%": "25%", "33%": "33.333333%", "40%": "40%", "50%": "50%", "60%": "60%", "66%": "66.666667%", "75%": "75%", "80%": "80%", "83%": "83.333333%", full: "100%", "min-content": "min-content", "max-content": "max-content", prose: "65ch" }, AN = { 0: "0px", full: "100%" }, PN = { "0px": "0px", full: "100%", "min-content": "min-content", "max-content": "max-content" }, NN = { backgroundFast: "background-color 0.1s ease-in-out", backgroundDefault: "background-color 0.2s ease-in-out", boxShadowFast: "box-shadow 0.1s ease-in-out", boxShadowDefault: "box-shadow 0.2s ease-in-out", textColorDefault: "color 0.2s ease-in-out" }, jj = { conditions: void 0, styles: { borderRadius: { mappings: ["borderTopRightRadius", "borderTopLeftRadius", "borderBottomLeftRadius", "borderBottomRightRadius"] }, borderWidth: { mappings: ["borderTopWidth", "borderRightWidth", "borderBottomWidth", "borderLeftWidth"] }, borderTopRightRadius: { values: { small: { defaultClass: "_1s8b37jk5" }, default: { defaultClass: "_1s8b37jk6" }, large: { defaultClass: "_1s8b37jk7" }, round: { defaultClass: "_1s8b37jk8" } } }, borderTopLeftRadius: { values: { small: { defaultClass: "_1s8b37jk9" }, default: { defaultClass: "_1s8b37jka" }, large: { defaultClass: "_1s8b37jkb" }, round: { defaultClass: "_1s8b37jkc" } } }, borderBottomLeftRadius: { values: { small: { defaultClass: "_1s8b37jkd" }, default: { defaultClass: "_1s8b37jke" }, large: { defaultClass: "_1s8b37jkf" }, round: { defaultClass: "_1s8b37jkg" } } }, borderBottomRightRadius: { values: { small: { defaultClass: "_1s8b37jkh" }, default: { defaultClass: "_1s8b37jki" }, large: { defaultClass: "_1s8b37jkj" }, round: { defaultClass: "_1s8b37jkk" } } }, borderTopWidth: { values: { zero: { defaultClass: "_1s8b37jkl" }, default: { defaultClass: "_1s8b37jkm" }, large: { defaultClass: "_1s8b37jkn" }, xlarge: { defaultClass: "_1s8b37jko" } } }, borderRightWidth: { values: { zero: { defaultClass: "_1s8b37jkp" }, default: { defaultClass: "_1s8b37jkq" }, large: { defaultClass: "_1s8b37jkr" }, xlarge: { defaultClass: "_1s8b37jks" } } }, borderBottomWidth: { values: { zero: { defaultClass: "_1s8b37jkt" }, default: { defaultClass: "_1s8b37jku" }, large: { defaultClass: "_1s8b37jkv" }, xlarge: { defaultClass: "_1s8b37jkw" } } }, borderLeftWidth: { values: { zero: { defaultClass: "_1s8b37jkx" }, default: { defaultClass: "_1s8b37jky" }, large: { defaultClass: "_1s8b37jkz" }, xlarge: { defaultClass: "_1s8b37jl0" } } }, borderStyle: { values: { dotted: { defaultClass: "_1s8b37jl1" }, none: { defaultClass: "_1s8b37jl2" }, solid: { defaultClass: "_1s8b37jl3" }, dashed: { defaultClass: "_1s8b37jl4" } } }, boxSizing: { values: { "border-box": { defaultClass: "_1s8b37jl5" } } }, cursor: { values: { auto: { defaultClass: "_1s8b37jl6" }, pointer: { defaultClass: "_1s8b37jl7" } } }, fontFamily: { values: { body: { defaultClass: "_1s8b37jl8" }, heading: { defaultClass: "_1s8b37jl9" }, code: { defaultClass: "_1s8b37jla" } } }, fontWeight: { values: { normal: { defaultClass: "_1s8b37jlb" }, bold: { defaultClass: "_1s8b37jlc" }, black: { defaultClass: "_1s8b37jld" } } }, lineHeight: { values: { 0: { defaultClass: "_1s8b37jle" }, 1: { defaultClass: "_1s8b37jlf" }, "1.5": { defaultClass: "_1s8b37jlg" } } }, overflow: { values: { hidden: { defaultClass: "_1s8b37jlh" }, auto: { defaultClass: "_1s8b37jli" }, scroll: { defaultClass: "_1s8b37jlj" } } }, placeContent: { values: { center: { defaultClass: "_1s8b37jlk" } } }, pointerEvents: { values: { none: { defaultClass: "_1s8b37jll" }, all: { defaultClass: "_1s8b37jlm" } } }, reset: { values: { all: { defaultClass: "_1s8b37jln" } } }, textDecoration: { values: { none: { defaultClass: "_1s8b37jlo" }, underline: { defaultClass: "_1s8b37jlp" } } }, textTransform: { values: { lowercase: { defaultClass: "_1s8b37jlq" }, uppercase: { defaultClass: "_1s8b37jlr" }, capitalize: { defaultClass: "_1s8b37jls" } } }, transition: { values: { backgroundFast: { defaultClass: "_1s8b37jlt" }, backgroundDefault: { defaultClass: "_1s8b37jlu" }, boxShadowFast: { defaultClass: "_1s8b37jlv" }, boxShadowDefault: { defaultClass: "_1s8b37jlw" }, textColorDefault: { defaultClass: "_1s8b37jlx" } } }, userSelect: { values: { none: { defaultClass: "_1s8b37jly" }, all: { defaultClass: "_1s8b37jlz" }, text: { defaultClass: "_1s8b37jm0" } } }, whiteSpace: { values: { nowrap: { defaultClass: "_1s8b37jm1" }, pre: { defaultClass: "_1s8b37jm2" }, "pre-line": { defaultClass: "_1s8b37jm3" } } }, wordBreak: { values: { "break-word": { defaultClass: "_1s8b37jm4" }, "break-all": { defaultClass: "_1s8b37jm5" } } }, zIndex: { values: { 0: { defaultClass: "_1s8b37jm6" }, 1: { defaultClass: "_1s8b37jm7" }, 2: { defaultClass: "_1s8b37jm8" }, 3: { defaultClass: "_1s8b37jm9" }, 4: { defaultClass: "_1s8b37jma" }, 5: { defaultClass: "_1s8b37jmb" } } } } }, vj = { conditions: { defaultCondition: "mobile", conditionNames: ["mobile", "tablet", "laptop", "monitor", "ultrawide"], responsiveArray: void 0 }, styles: { margin: { mappings: ["marginTop", "marginBottom", "marginLeft", "marginRight"] }, marginX: { mappings: ["marginLeft", "marginRight"] }, marginY: { mappings: ["marginTop", "marginBottom"] }, padding: { mappings: ["paddingTop", "paddingBottom", "paddingLeft", "paddingRight"] }, paddingX: { mappings: ["paddingLeft", "paddingRight"] }, paddingY: { mappings: ["paddingTop", "paddingBottom"] }, alignItems: { values: { "flex-start": { conditions: { mobile: "_1s8b37jmc", tablet: "_1s8b37jmd", laptop: "_1s8b37jme", monitor: "_1s8b37jmf", ultrawide: "_1s8b37jmg" }, defaultClass: "_1s8b37jmc" }, center: { conditions: { mobile: "_1s8b37jmh", tablet: "_1s8b37jmi", laptop: "_1s8b37jmj", monitor: "_1s8b37jmk", ultrawide: "_1s8b37jml" }, defaultClass: "_1s8b37jmh" }, "flex-end": { conditions: { mobile: "_1s8b37jmm", tablet: "_1s8b37jmn", laptop: "_1s8b37jmo", monitor: "_1s8b37jmp", ultrawide: "_1s8b37jmq" }, defaultClass: "_1s8b37jmm" }, stretch: { conditions: { mobile: "_1s8b37jmr", tablet: "_1s8b37jms", laptop: "_1s8b37jmt", monitor: "_1s8b37jmu", ultrawide: "_1s8b37jmv" }, defaultClass: "_1s8b37jmr" }, "space-between": { conditions: { mobile: "_1s8b37jmw", tablet: "_1s8b37jmx", laptop: "_1s8b37jmy", monitor: "_1s8b37jmz", ultrawide: "_1s8b37jn0" }, defaultClass: "_1s8b37jmw" }, "space-around": { conditions: { mobile: "_1s8b37jn1", tablet: "_1s8b37jn2", laptop: "_1s8b37jn3", monitor: "_1s8b37jn4", ultrawide: "_1s8b37jn5" }, defaultClass: "_1s8b37jn1" }, "space-evenly": { conditions: { mobile: "_1s8b37jn6", tablet: "_1s8b37jn7", laptop: "_1s8b37jn8", monitor: "_1s8b37jn9", ultrawide: "_1s8b37jna" }, defaultClass: "_1s8b37jn6" } } }, alignSelf: { values: { "flex-start": { conditions: { mobile: "_1s8b37jnb", tablet: "_1s8b37jnc", laptop: "_1s8b37jnd", monitor: "_1s8b37jne", ultrawide: "_1s8b37jnf" }, defaultClass: "_1s8b37jnb" }, center: { conditions: { mobile: "_1s8b37jng", tablet: "_1s8b37jnh", laptop: "_1s8b37jni", monitor: "_1s8b37jnj", ultrawide: "_1s8b37jnk" }, defaultClass: "_1s8b37jng" }, "flex-end": { conditions: { mobile: "_1s8b37jnl", tablet: "_1s8b37jnm", laptop: "_1s8b37jnn", monitor: "_1s8b37jno", ultrawide: "_1s8b37jnp" }, defaultClass: "_1s8b37jnl" }, stretch: { conditions: { mobile: "_1s8b37jnq", tablet: "_1s8b37jnr", laptop: "_1s8b37jns", monitor: "_1s8b37jnt", ultrawide: "_1s8b37jnu" }, defaultClass: "_1s8b37jnq" }, "space-between": { conditions: { mobile: "_1s8b37jnv", tablet: "_1s8b37jnw", laptop: "_1s8b37jnx", monitor: "_1s8b37jny", ultrawide: "_1s8b37jnz" }, defaultClass: "_1s8b37jnv" }, "space-around": { conditions: { mobile: "_1s8b37jo0", tablet: "_1s8b37jo1", laptop: "_1s8b37jo2", monitor: "_1s8b37jo3", ultrawide: "_1s8b37jo4" }, defaultClass: "_1s8b37jo0" }, "space-evenly": { conditions: { mobile: "_1s8b37jo5", tablet: "_1s8b37jo6", laptop: "_1s8b37jo7", monitor: "_1s8b37jo8", ultrawide: "_1s8b37jo9" }, defaultClass: "_1s8b37jo5" } } }, bottom: { values: { 0: { conditions: { mobile: "_1s8b37joa", tablet: "_1s8b37job", laptop: "_1s8b37joc", monitor: "_1s8b37jod", ultrawide: "_1s8b37joe" }, defaultClass: "_1s8b37joa" }, "0.25rem": { conditions: { mobile: "_1s8b37jof", tablet: "_1s8b37jog", laptop: "_1s8b37joh", monitor: "_1s8b37joi", ultrawide: "_1s8b37joj" }, defaultClass: "_1s8b37jof" }, "0.5rem": { conditions: { mobile: "_1s8b37jok", tablet: "_1s8b37jol", laptop: "_1s8b37jom", monitor: "_1s8b37jon", ultrawide: "_1s8b37joo" }, defaultClass: "_1s8b37jok" }, "0.75rem": { conditions: { mobile: "_1s8b37jop", tablet: "_1s8b37joq", laptop: "_1s8b37jor", monitor: "_1s8b37jos", ultrawide: "_1s8b37jot" }, defaultClass: "_1s8b37jop" }, "1rem": { conditions: { mobile: "_1s8b37jou", tablet: "_1s8b37jov", laptop: "_1s8b37jow", monitor: "_1s8b37jox", ultrawide: "_1s8b37joy" }, defaultClass: "_1s8b37jou" }, "1.25rem": { conditions: { mobile: "_1s8b37joz", tablet: "_1s8b37jp0", laptop: "_1s8b37jp1", monitor: "_1s8b37jp2", ultrawide: "_1s8b37jp3" }, defaultClass: "_1s8b37joz" }, "1.5rem": { conditions: { mobile: "_1s8b37jp4", tablet: "_1s8b37jp5", laptop: "_1s8b37jp6", monitor: "_1s8b37jp7", ultrawide: "_1s8b37jp8" }, defaultClass: "_1s8b37jp4" }, "1.75rem": { conditions: { mobile: "_1s8b37jp9", tablet: "_1s8b37jpa", laptop: "_1s8b37jpb", monitor: "_1s8b37jpc", ultrawide: "_1s8b37jpd" }, defaultClass: "_1s8b37jp9" }, "2rem": { conditions: { mobile: "_1s8b37jpe", tablet: "_1s8b37jpf", laptop: "_1s8b37jpg", monitor: "_1s8b37jph", ultrawide: "_1s8b37jpi" }, defaultClass: "_1s8b37jpe" }, "2.25rem": { conditions: { mobile: "_1s8b37jpj", tablet: "_1s8b37jpk", laptop: "_1s8b37jpl", monitor: "_1s8b37jpm", ultrawide: "_1s8b37jpn" }, defaultClass: "_1s8b37jpj" }, "2.5rem": { conditions: { mobile: "_1s8b37jpo", tablet: "_1s8b37jpp", laptop: "_1s8b37jpq", monitor: "_1s8b37jpr", ultrawide: "_1s8b37jps" }, defaultClass: "_1s8b37jpo" }, "2.75rem": { conditions: { mobile: "_1s8b37jpt", tablet: "_1s8b37jpu", laptop: "_1s8b37jpv", monitor: "_1s8b37jpw", ultrawide: "_1s8b37jpx" }, defaultClass: "_1s8b37jpt" }, "3rem": { conditions: { mobile: "_1s8b37jpy", tablet: "_1s8b37jpz", laptop: "_1s8b37jq0", monitor: "_1s8b37jq1", ultrawide: "_1s8b37jq2" }, defaultClass: "_1s8b37jpy" }, "3.25rem": { conditions: { mobile: "_1s8b37jq3", tablet: "_1s8b37jq4", laptop: "_1s8b37jq5", monitor: "_1s8b37jq6", ultrawide: "_1s8b37jq7" }, defaultClass: "_1s8b37jq3" }, "3.5rem": { conditions: { mobile: "_1s8b37jq8", tablet: "_1s8b37jq9", laptop: "_1s8b37jqa", monitor: "_1s8b37jqb", ultrawide: "_1s8b37jqc" }, defaultClass: "_1s8b37jq8" }, "3.75rem": { conditions: { mobile: "_1s8b37jqd", tablet: "_1s8b37jqe", laptop: "_1s8b37jqf", monitor: "_1s8b37jqg", ultrawide: "_1s8b37jqh" }, defaultClass: "_1s8b37jqd" }, "4rem": { conditions: { mobile: "_1s8b37jqi", tablet: "_1s8b37jqj", laptop: "_1s8b37jqk", monitor: "_1s8b37jql", ultrawide: "_1s8b37jqm" }, defaultClass: "_1s8b37jqi" }, "4.25rem": { conditions: { mobile: "_1s8b37jqn", tablet: "_1s8b37jqo", laptop: "_1s8b37jqp", monitor: "_1s8b37jqq", ultrawide: "_1s8b37jqr" }, defaultClass: "_1s8b37jqn" }, "4.5rem": { conditions: { mobile: "_1s8b37jqs", tablet: "_1s8b37jqt", laptop: "_1s8b37jqu", monitor: "_1s8b37jqv", ultrawide: "_1s8b37jqw" }, defaultClass: "_1s8b37jqs" }, "4.75rem": { conditions: { mobile: "_1s8b37jqx", tablet: "_1s8b37jqy", laptop: "_1s8b37jqz", monitor: "_1s8b37jr0", ultrawide: "_1s8b37jr1" }, defaultClass: "_1s8b37jqx" }, "5rem": { conditions: { mobile: "_1s8b37jr2", tablet: "_1s8b37jr3", laptop: "_1s8b37jr4", monitor: "_1s8b37jr5", ultrawide: "_1s8b37jr6" }, defaultClass: "_1s8b37jr2" }, "5.25rem": { conditions: { mobile: "_1s8b37jr7", tablet: "_1s8b37jr8", laptop: "_1s8b37jr9", monitor: "_1s8b37jra", ultrawide: "_1s8b37jrb" }, defaultClass: "_1s8b37jr7" }, "5.5rem": { conditions: { mobile: "_1s8b37jrc", tablet: "_1s8b37jrd", laptop: "_1s8b37jre", monitor: "_1s8b37jrf", ultrawide: "_1s8b37jrg" }, defaultClass: "_1s8b37jrc" }, "5.75rem": { conditions: { mobile: "_1s8b37jrh", tablet: "_1s8b37jri", laptop: "_1s8b37jrj", monitor: "_1s8b37jrk", ultrawide: "_1s8b37jrl" }, defaultClass: "_1s8b37jrh" }, "6rem": { conditions: { mobile: "_1s8b37jrm", tablet: "_1s8b37jrn", laptop: "_1s8b37jro", monitor: "_1s8b37jrp", ultrawide: "_1s8b37jrq" }, defaultClass: "_1s8b37jrm" }, "7rem": { conditions: { mobile: "_1s8b37jrr", tablet: "_1s8b37jrs", laptop: "_1s8b37jrt", monitor: "_1s8b37jru", ultrawide: "_1s8b37jrv" }, defaultClass: "_1s8b37jrr" }, "8rem": { conditions: { mobile: "_1s8b37jrw", tablet: "_1s8b37jrx", laptop: "_1s8b37jry", monitor: "_1s8b37jrz", ultrawide: "_1s8b37js0" }, defaultClass: "_1s8b37jrw" }, "9rem": { conditions: { mobile: "_1s8b37js1", tablet: "_1s8b37js2", laptop: "_1s8b37js3", monitor: "_1s8b37js4", ultrawide: "_1s8b37js5" }, defaultClass: "_1s8b37js1" }, "10rem": { conditions: { mobile: "_1s8b37js6", tablet: "_1s8b37js7", laptop: "_1s8b37js8", monitor: "_1s8b37js9", ultrawide: "_1s8b37jsa" }, defaultClass: "_1s8b37js6" }, "12rem": { conditions: { mobile: "_1s8b37jsb", tablet: "_1s8b37jsc", laptop: "_1s8b37jsd", monitor: "_1s8b37jse", ultrawide: "_1s8b37jsf" }, defaultClass: "_1s8b37jsb" }, "14rem": { conditions: { mobile: "_1s8b37jsg", tablet: "_1s8b37jsh", laptop: "_1s8b37jsi", monitor: "_1s8b37jsj", ultrawide: "_1s8b37jsk" }, defaultClass: "_1s8b37jsg" }, "16rem": { conditions: { mobile: "_1s8b37jsl", tablet: "_1s8b37jsm", laptop: "_1s8b37jsn", monitor: "_1s8b37jso", ultrawide: "_1s8b37jsp" }, defaultClass: "_1s8b37jsl" }, "18rem": { conditions: { mobile: "_1s8b37jsq", tablet: "_1s8b37jsr", laptop: "_1s8b37jss", monitor: "_1s8b37jst", ultrawide: "_1s8b37jsu" }, defaultClass: "_1s8b37jsq" }, "20rem": { conditions: { mobile: "_1s8b37jsv", tablet: "_1s8b37jsw", laptop: "_1s8b37jsx", monitor: "_1s8b37jsy", ultrawide: "_1s8b37jsz" }, defaultClass: "_1s8b37jsv" }, "25rem": { conditions: { mobile: "_1s8b37jt0", tablet: "_1s8b37jt1", laptop: "_1s8b37jt2", monitor: "_1s8b37jt3", ultrawide: "_1s8b37jt4" }, defaultClass: "_1s8b37jt0" }, "30rem": { conditions: { mobile: "_1s8b37jt5", tablet: "_1s8b37jt6", laptop: "_1s8b37jt7", monitor: "_1s8b37jt8", ultrawide: "_1s8b37jt9" }, defaultClass: "_1s8b37jt5" }, "35rem": { conditions: { mobile: "_1s8b37jta", tablet: "_1s8b37jtb", laptop: "_1s8b37jtc", monitor: "_1s8b37jtd", ultrawide: "_1s8b37jte" }, defaultClass: "_1s8b37jta" }, "40rem": { conditions: { mobile: "_1s8b37jtf", tablet: "_1s8b37jtg", laptop: "_1s8b37jth", monitor: "_1s8b37jti", ultrawide: "_1s8b37jtj" }, defaultClass: "_1s8b37jtf" }, "45rem": { conditions: { mobile: "_1s8b37jtk", tablet: "_1s8b37jtl", laptop: "_1s8b37jtm", monitor: "_1s8b37jtn", ultrawide: "_1s8b37jto" }, defaultClass: "_1s8b37jtk" }, "50rem": { conditions: { mobile: "_1s8b37jtp", tablet: "_1s8b37jtq", laptop: "_1s8b37jtr", monitor: "_1s8b37jts", ultrawide: "_1s8b37jtt" }, defaultClass: "_1s8b37jtp" }, "16%": { conditions: { mobile: "_1s8b37jtu", tablet: "_1s8b37jtv", laptop: "_1s8b37jtw", monitor: "_1s8b37jtx", ultrawide: "_1s8b37jty" }, defaultClass: "_1s8b37jtu" }, "20%": { conditions: { mobile: "_1s8b37jtz", tablet: "_1s8b37ju0", laptop: "_1s8b37ju1", monitor: "_1s8b37ju2", ultrawide: "_1s8b37ju3" }, defaultClass: "_1s8b37jtz" }, "25%": { conditions: { mobile: "_1s8b37ju4", tablet: "_1s8b37ju5", laptop: "_1s8b37ju6", monitor: "_1s8b37ju7", ultrawide: "_1s8b37ju8" }, defaultClass: "_1s8b37ju4" }, "33%": { conditions: { mobile: "_1s8b37ju9", tablet: "_1s8b37jua", laptop: "_1s8b37jub", monitor: "_1s8b37juc", ultrawide: "_1s8b37jud" }, defaultClass: "_1s8b37ju9" }, "40%": { conditions: { mobile: "_1s8b37jue", tablet: "_1s8b37juf", laptop: "_1s8b37jug", monitor: "_1s8b37juh", ultrawide: "_1s8b37jui" }, defaultClass: "_1s8b37jue" }, "50%": { conditions: { mobile: "_1s8b37juj", tablet: "_1s8b37juk", laptop: "_1s8b37jul", monitor: "_1s8b37jum", ultrawide: "_1s8b37jun" }, defaultClass: "_1s8b37juj" }, "60%": { conditions: { mobile: "_1s8b37juo", tablet: "_1s8b37jup", laptop: "_1s8b37juq", monitor: "_1s8b37jur", ultrawide: "_1s8b37jus" }, defaultClass: "_1s8b37juo" }, "66%": { conditions: { mobile: "_1s8b37jut", tablet: "_1s8b37juu", laptop: "_1s8b37juv", monitor: "_1s8b37juw", ultrawide: "_1s8b37jux" }, defaultClass: "_1s8b37jut" }, "75%": { conditions: { mobile: "_1s8b37juy", tablet: "_1s8b37juz", laptop: "_1s8b37jv0", monitor: "_1s8b37jv1", ultrawide: "_1s8b37jv2" }, defaultClass: "_1s8b37juy" }, "80%": { conditions: { mobile: "_1s8b37jv3", tablet: "_1s8b37jv4", laptop: "_1s8b37jv5", monitor: "_1s8b37jv6", ultrawide: "_1s8b37jv7" }, defaultClass: "_1s8b37jv3" }, "83%": { conditions: { mobile: "_1s8b37jv8", tablet: "_1s8b37jv9", laptop: "_1s8b37jva", monitor: "_1s8b37jvb", ultrawide: "_1s8b37jvc" }, defaultClass: "_1s8b37jv8" }, full: { conditions: { mobile: "_1s8b37jvd", tablet: "_1s8b37jve", laptop: "_1s8b37jvf", monitor: "_1s8b37jvg", ultrawide: "_1s8b37jvh" }, defaultClass: "_1s8b37jvd" } } }, display: { values: { block: { conditions: { mobile: "_1s8b37jvi", tablet: "_1s8b37jvj", laptop: "_1s8b37jvk", monitor: "_1s8b37jvl", ultrawide: "_1s8b37jvm" }, defaultClass: "_1s8b37jvi" }, flex: { conditions: { mobile: "_1s8b37jvn", tablet: "_1s8b37jvo", laptop: "_1s8b37jvp", monitor: "_1s8b37jvq", ultrawide: "_1s8b37jvr" }, defaultClass: "_1s8b37jvn" }, grid: { conditions: { mobile: "_1s8b37jvs", tablet: "_1s8b37jvt", laptop: "_1s8b37jvu", monitor: "_1s8b37jvv", ultrawide: "_1s8b37jvw" }, defaultClass: "_1s8b37jvs" }, inline: { conditions: { mobile: "_1s8b37jvx", tablet: "_1s8b37jvy", laptop: "_1s8b37jvz", monitor: "_1s8b37jw0", ultrawide: "_1s8b37jw1" }, defaultClass: "_1s8b37jvx" }, "inline-block": { conditions: { mobile: "_1s8b37jw2", tablet: "_1s8b37jw3", laptop: "_1s8b37jw4", monitor: "_1s8b37jw5", ultrawide: "_1s8b37jw6" }, defaultClass: "_1s8b37jw2" }, "inline-flex": { conditions: { mobile: "_1s8b37jw7", tablet: "_1s8b37jw8", laptop: "_1s8b37jw9", monitor: "_1s8b37jwa", ultrawide: "_1s8b37jwb" }, defaultClass: "_1s8b37jw7" }, "inline-grid": { conditions: { mobile: "_1s8b37jwc", tablet: "_1s8b37jwd", laptop: "_1s8b37jwe", monitor: "_1s8b37jwf", ultrawide: "_1s8b37jwg" }, defaultClass: "_1s8b37jwc" }, none: { conditions: { mobile: "_1s8b37jwh", tablet: "_1s8b37jwi", laptop: "_1s8b37jwj", monitor: "_1s8b37jwk", ultrawide: "_1s8b37jwl" }, defaultClass: "_1s8b37jwh" } } }, flex: { values: { 1: { conditions: { mobile: "_1s8b37jwm", tablet: "_1s8b37jwn", laptop: "_1s8b37jwo", monitor: "_1s8b37jwp", ultrawide: "_1s8b37jwq" }, defaultClass: "_1s8b37jwm" }, auto: { conditions: { mobile: "_1s8b37jwr", tablet: "_1s8b37jws", laptop: "_1s8b37jwt", monitor: "_1s8b37jwu", ultrawide: "_1s8b37jwv" }, defaultClass: "_1s8b37jwr" }, initial: { conditions: { mobile: "_1s8b37jww", tablet: "_1s8b37jwx", laptop: "_1s8b37jwy", monitor: "_1s8b37jwz", ultrawide: "_1s8b37jx0" }, defaultClass: "_1s8b37jww" }, none: { conditions: { mobile: "_1s8b37jx1", tablet: "_1s8b37jx2", laptop: "_1s8b37jx3", monitor: "_1s8b37jx4", ultrawide: "_1s8b37jx5" }, defaultClass: "_1s8b37jx1" } } }, flexDirection: { values: { column: { conditions: { mobile: "_1s8b37jx6", tablet: "_1s8b37jx7", laptop: "_1s8b37jx8", monitor: "_1s8b37jx9", ultrawide: "_1s8b37jxa" }, defaultClass: "_1s8b37jx6" }, "column-reverse": { conditions: { mobile: "_1s8b37jxb", tablet: "_1s8b37jxc", laptop: "_1s8b37jxd", monitor: "_1s8b37jxe", ultrawide: "_1s8b37jxf" }, defaultClass: "_1s8b37jxb" }, row: { conditions: { mobile: "_1s8b37jxg", tablet: "_1s8b37jxh", laptop: "_1s8b37jxi", monitor: "_1s8b37jxj", ultrawide: "_1s8b37jxk" }, defaultClass: "_1s8b37jxg" }, "row-reverse": { conditions: { mobile: "_1s8b37jxl", tablet: "_1s8b37jxm", laptop: "_1s8b37jxn", monitor: "_1s8b37jxo", ultrawide: "_1s8b37jxp" }, defaultClass: "_1s8b37jxl" } } }, flexWrap: { values: { wrap: { conditions: { mobile: "_1s8b37jxq", tablet: "_1s8b37jxr", laptop: "_1s8b37jxs", monitor: "_1s8b37jxt", ultrawide: "_1s8b37jxu" }, defaultClass: "_1s8b37jxq" }, nowrap: { conditions: { mobile: "_1s8b37jxv", tablet: "_1s8b37jxw", laptop: "_1s8b37jxx", monitor: "_1s8b37jxy", ultrawide: "_1s8b37jxz" }, defaultClass: "_1s8b37jxv" }, "wrap-reverse": { conditions: { mobile: "_1s8b37jy0", tablet: "_1s8b37jy1", laptop: "_1s8b37jy2", monitor: "_1s8b37jy3", ultrawide: "_1s8b37jy4" }, defaultClass: "_1s8b37jy0" } } }, fontSize: { values: { xsmall: { conditions: { mobile: "_1s8b37jy5", tablet: "_1s8b37jy6", laptop: "_1s8b37jy7", monitor: "_1s8b37jy8", ultrawide: "_1s8b37jy9" }, defaultClass: "_1s8b37jy5" }, small: { conditions: { mobile: "_1s8b37jya", tablet: "_1s8b37jyb", laptop: "_1s8b37jyc", monitor: "_1s8b37jyd", ultrawide: "_1s8b37jye" }, defaultClass: "_1s8b37jya" }, default: { conditions: { mobile: "_1s8b37jyf", tablet: "_1s8b37jyg", laptop: "_1s8b37jyh", monitor: "_1s8b37jyi", ultrawide: "_1s8b37jyj" }, defaultClass: "_1s8b37jyf" }, large: { conditions: { mobile: "_1s8b37jyk", tablet: "_1s8b37jyl", laptop: "_1s8b37jym", monitor: "_1s8b37jyn", ultrawide: "_1s8b37jyo" }, defaultClass: "_1s8b37jyk" }, xlarge: { conditions: { mobile: "_1s8b37jyp", tablet: "_1s8b37jyq", laptop: "_1s8b37jyr", monitor: "_1s8b37jys", ultrawide: "_1s8b37jyt" }, defaultClass: "_1s8b37jyp" }, xxlarge: { conditions: { mobile: "_1s8b37jyu", tablet: "_1s8b37jyv", laptop: "_1s8b37jyw", monitor: "_1s8b37jyx", ultrawide: "_1s8b37jyy" }, defaultClass: "_1s8b37jyu" }, xxxlarge: { conditions: { mobile: "_1s8b37jyz", tablet: "_1s8b37jz0", laptop: "_1s8b37jz1", monitor: "_1s8b37jz2", ultrawide: "_1s8b37jz3" }, defaultClass: "_1s8b37jyz" }, xxxxlarge: { conditions: { mobile: "_1s8b37jz4", tablet: "_1s8b37jz5", laptop: "_1s8b37jz6", monitor: "_1s8b37jz7", ultrawide: "_1s8b37jz8" }, defaultClass: "_1s8b37jz4" }, xxxxxlarge: { conditions: { mobile: "_1s8b37jz9", tablet: "_1s8b37jza", laptop: "_1s8b37jzb", monitor: "_1s8b37jzc", ultrawide: "_1s8b37jzd" }, defaultClass: "_1s8b37jz9" }, xxxxxxlarge: { conditions: { mobile: "_1s8b37jze", tablet: "_1s8b37jzf", laptop: "_1s8b37jzg", monitor: "_1s8b37jzh", ultrawide: "_1s8b37jzi" }, defaultClass: "_1s8b37jze" }, h1: { conditions: { mobile: "_1s8b37jzj", tablet: "_1s8b37jzk", laptop: "_1s8b37jzl", monitor: "_1s8b37jzm", ultrawide: "_1s8b37jzn" }, defaultClass: "_1s8b37jzj" }, h2: { conditions: { mobile: "_1s8b37jzo", tablet: "_1s8b37jzp", laptop: "_1s8b37jzq", monitor: "_1s8b37jzr", ultrawide: "_1s8b37jzs" }, defaultClass: "_1s8b37jzo" }, h3: { conditions: { mobile: "_1s8b37jzt", tablet: "_1s8b37jzu", laptop: "_1s8b37jzv", monitor: "_1s8b37jzw", ultrawide: "_1s8b37jzx" }, defaultClass: "_1s8b37jzt" }, h4: { conditions: { mobile: "_1s8b37jzy", tablet: "_1s8b37jzz", laptop: "_1s8b37j100", monitor: "_1s8b37j101", ultrawide: "_1s8b37j102" }, defaultClass: "_1s8b37jzy" }, h5: { conditions: { mobile: "_1s8b37j103", tablet: "_1s8b37j104", laptop: "_1s8b37j105", monitor: "_1s8b37j106", ultrawide: "_1s8b37j107" }, defaultClass: "_1s8b37j103" }, h6: { conditions: { mobile: "_1s8b37j108", tablet: "_1s8b37j109", laptop: "_1s8b37j10a", monitor: "_1s8b37j10b", ultrawide: "_1s8b37j10c" }, defaultClass: "_1s8b37j108" } } }, gap: { values: { auto: { conditions: { mobile: "_1s8b37j10d", tablet: "_1s8b37j10e", laptop: "_1s8b37j10f", monitor: "_1s8b37j10g", ultrawide: "_1s8b37j10h" }, defaultClass: "_1s8b37j10d" }, zero: { conditions: { mobile: "_1s8b37j10i", tablet: "_1s8b37j10j", laptop: "_1s8b37j10k", monitor: "_1s8b37j10l", ultrawide: "_1s8b37j10m" }, defaultClass: "_1s8b37j10i" }, xsmall: { conditions: { mobile: "_1s8b37j10n", tablet: "_1s8b37j10o", laptop: "_1s8b37j10p", monitor: "_1s8b37j10q", ultrawide: "_1s8b37j10r" }, defaultClass: "_1s8b37j10n" }, small: { conditions: { mobile: "_1s8b37j10s", tablet: "_1s8b37j10t", laptop: "_1s8b37j10u", monitor: "_1s8b37j10v", ultrawide: "_1s8b37j10w" }, defaultClass: "_1s8b37j10s" }, smedium: { conditions: { mobile: "_1s8b37j10x", tablet: "_1s8b37j10y", laptop: "_1s8b37j10z", monitor: "_1s8b37j110", ultrawide: "_1s8b37j111" }, defaultClass: "_1s8b37j10x" }, default: { conditions: { mobile: "_1s8b37j112", tablet: "_1s8b37j113", laptop: "_1s8b37j114", monitor: "_1s8b37j115", ultrawide: "_1s8b37j116" }, defaultClass: "_1s8b37j112" }, medium: { conditions: { mobile: "_1s8b37j117", tablet: "_1s8b37j118", laptop: "_1s8b37j119", monitor: "_1s8b37j11a", ultrawide: "_1s8b37j11b" }, defaultClass: "_1s8b37j117" }, large: { conditions: { mobile: "_1s8b37j11c", tablet: "_1s8b37j11d", laptop: "_1s8b37j11e", monitor: "_1s8b37j11f", ultrawide: "_1s8b37j11g" }, defaultClass: "_1s8b37j11c" }, xlarge: { conditions: { mobile: "_1s8b37j11h", tablet: "_1s8b37j11i", laptop: "_1s8b37j11j", monitor: "_1s8b37j11k", ultrawide: "_1s8b37j11l" }, defaultClass: "_1s8b37j11h" }, xxlarge: { conditions: { mobile: "_1s8b37j11m", tablet: "_1s8b37j11n", laptop: "_1s8b37j11o", monitor: "_1s8b37j11p", ultrawide: "_1s8b37j11q" }, defaultClass: "_1s8b37j11m" } } }, height: { values: { 0: { conditions: { mobile: "_1s8b37j11r", tablet: "_1s8b37j11s", laptop: "_1s8b37j11t", monitor: "_1s8b37j11u", ultrawide: "_1s8b37j11v" }, defaultClass: "_1s8b37j11r" }, "0.25rem": { conditions: { mobile: "_1s8b37j11w", tablet: "_1s8b37j11x", laptop: "_1s8b37j11y", monitor: "_1s8b37j11z", ultrawide: "_1s8b37j120" }, defaultClass: "_1s8b37j11w" }, "0.5rem": { conditions: { mobile: "_1s8b37j121", tablet: "_1s8b37j122", laptop: "_1s8b37j123", monitor: "_1s8b37j124", ultrawide: "_1s8b37j125" }, defaultClass: "_1s8b37j121" }, "0.75rem": { conditions: { mobile: "_1s8b37j126", tablet: "_1s8b37j127", laptop: "_1s8b37j128", monitor: "_1s8b37j129", ultrawide: "_1s8b37j12a" }, defaultClass: "_1s8b37j126" }, "1rem": { conditions: { mobile: "_1s8b37j12b", tablet: "_1s8b37j12c", laptop: "_1s8b37j12d", monitor: "_1s8b37j12e", ultrawide: "_1s8b37j12f" }, defaultClass: "_1s8b37j12b" }, "1.25rem": { conditions: { mobile: "_1s8b37j12g", tablet: "_1s8b37j12h", laptop: "_1s8b37j12i", monitor: "_1s8b37j12j", ultrawide: "_1s8b37j12k" }, defaultClass: "_1s8b37j12g" }, "1.5rem": { conditions: { mobile: "_1s8b37j12l", tablet: "_1s8b37j12m", laptop: "_1s8b37j12n", monitor: "_1s8b37j12o", ultrawide: "_1s8b37j12p" }, defaultClass: "_1s8b37j12l" }, "1.75rem": { conditions: { mobile: "_1s8b37j12q", tablet: "_1s8b37j12r", laptop: "_1s8b37j12s", monitor: "_1s8b37j12t", ultrawide: "_1s8b37j12u" }, defaultClass: "_1s8b37j12q" }, "2rem": { conditions: { mobile: "_1s8b37j12v", tablet: "_1s8b37j12w", laptop: "_1s8b37j12x", monitor: "_1s8b37j12y", ultrawide: "_1s8b37j12z" }, defaultClass: "_1s8b37j12v" }, "2.25rem": { conditions: { mobile: "_1s8b37j130", tablet: "_1s8b37j131", laptop: "_1s8b37j132", monitor: "_1s8b37j133", ultrawide: "_1s8b37j134" }, defaultClass: "_1s8b37j130" }, "2.5rem": { conditions: { mobile: "_1s8b37j135", tablet: "_1s8b37j136", laptop: "_1s8b37j137", monitor: "_1s8b37j138", ultrawide: "_1s8b37j139" }, defaultClass: "_1s8b37j135" }, "2.75rem": { conditions: { mobile: "_1s8b37j13a", tablet: "_1s8b37j13b", laptop: "_1s8b37j13c", monitor: "_1s8b37j13d", ultrawide: "_1s8b37j13e" }, defaultClass: "_1s8b37j13a" }, "3rem": { conditions: { mobile: "_1s8b37j13f", tablet: "_1s8b37j13g", laptop: "_1s8b37j13h", monitor: "_1s8b37j13i", ultrawide: "_1s8b37j13j" }, defaultClass: "_1s8b37j13f" }, "3.25rem": { conditions: { mobile: "_1s8b37j13k", tablet: "_1s8b37j13l", laptop: "_1s8b37j13m", monitor: "_1s8b37j13n", ultrawide: "_1s8b37j13o" }, defaultClass: "_1s8b37j13k" }, "3.5rem": { conditions: { mobile: "_1s8b37j13p", tablet: "_1s8b37j13q", laptop: "_1s8b37j13r", monitor: "_1s8b37j13s", ultrawide: "_1s8b37j13t" }, defaultClass: "_1s8b37j13p" }, "3.75rem": { conditions: { mobile: "_1s8b37j13u", tablet: "_1s8b37j13v", laptop: "_1s8b37j13w", monitor: "_1s8b37j13x", ultrawide: "_1s8b37j13y" }, defaultClass: "_1s8b37j13u" }, "4rem": { conditions: { mobile: "_1s8b37j13z", tablet: "_1s8b37j140", laptop: "_1s8b37j141", monitor: "_1s8b37j142", ultrawide: "_1s8b37j143" }, defaultClass: "_1s8b37j13z" }, "4.25rem": { conditions: { mobile: "_1s8b37j144", tablet: "_1s8b37j145", laptop: "_1s8b37j146", monitor: "_1s8b37j147", ultrawide: "_1s8b37j148" }, defaultClass: "_1s8b37j144" }, "4.5rem": { conditions: { mobile: "_1s8b37j149", tablet: "_1s8b37j14a", laptop: "_1s8b37j14b", monitor: "_1s8b37j14c", ultrawide: "_1s8b37j14d" }, defaultClass: "_1s8b37j149" }, "4.75rem": { conditions: { mobile: "_1s8b37j14e", tablet: "_1s8b37j14f", laptop: "_1s8b37j14g", monitor: "_1s8b37j14h", ultrawide: "_1s8b37j14i" }, defaultClass: "_1s8b37j14e" }, "5rem": { conditions: { mobile: "_1s8b37j14j", tablet: "_1s8b37j14k", laptop: "_1s8b37j14l", monitor: "_1s8b37j14m", ultrawide: "_1s8b37j14n" }, defaultClass: "_1s8b37j14j" }, "5.25rem": { conditions: { mobile: "_1s8b37j14o", tablet: "_1s8b37j14p", laptop: "_1s8b37j14q", monitor: "_1s8b37j14r", ultrawide: "_1s8b37j14s" }, defaultClass: "_1s8b37j14o" }, "5.5rem": { conditions: { mobile: "_1s8b37j14t", tablet: "_1s8b37j14u", laptop: "_1s8b37j14v", monitor: "_1s8b37j14w", ultrawide: "_1s8b37j14x" }, defaultClass: "_1s8b37j14t" }, "5.75rem": { conditions: { mobile: "_1s8b37j14y", tablet: "_1s8b37j14z", laptop: "_1s8b37j150", monitor: "_1s8b37j151", ultrawide: "_1s8b37j152" }, defaultClass: "_1s8b37j14y" }, "6rem": { conditions: { mobile: "_1s8b37j153", tablet: "_1s8b37j154", laptop: "_1s8b37j155", monitor: "_1s8b37j156", ultrawide: "_1s8b37j157" }, defaultClass: "_1s8b37j153" }, "7rem": { conditions: { mobile: "_1s8b37j158", tablet: "_1s8b37j159", laptop: "_1s8b37j15a", monitor: "_1s8b37j15b", ultrawide: "_1s8b37j15c" }, defaultClass: "_1s8b37j158" }, "8rem": { conditions: { mobile: "_1s8b37j15d", tablet: "_1s8b37j15e", laptop: "_1s8b37j15f", monitor: "_1s8b37j15g", ultrawide: "_1s8b37j15h" }, defaultClass: "_1s8b37j15d" }, "9rem": { conditions: { mobile: "_1s8b37j15i", tablet: "_1s8b37j15j", laptop: "_1s8b37j15k", monitor: "_1s8b37j15l", ultrawide: "_1s8b37j15m" }, defaultClass: "_1s8b37j15i" }, "10rem": { conditions: { mobile: "_1s8b37j15n", tablet: "_1s8b37j15o", laptop: "_1s8b37j15p", monitor: "_1s8b37j15q", ultrawide: "_1s8b37j15r" }, defaultClass: "_1s8b37j15n" }, "12rem": { conditions: { mobile: "_1s8b37j15s", tablet: "_1s8b37j15t", laptop: "_1s8b37j15u", monitor: "_1s8b37j15v", ultrawide: "_1s8b37j15w" }, defaultClass: "_1s8b37j15s" }, "14rem": { conditions: { mobile: "_1s8b37j15x", tablet: "_1s8b37j15y", laptop: "_1s8b37j15z", monitor: "_1s8b37j160", ultrawide: "_1s8b37j161" }, defaultClass: "_1s8b37j15x" }, "16rem": { conditions: { mobile: "_1s8b37j162", tablet: "_1s8b37j163", laptop: "_1s8b37j164", monitor: "_1s8b37j165", ultrawide: "_1s8b37j166" }, defaultClass: "_1s8b37j162" }, "18rem": { conditions: { mobile: "_1s8b37j167", tablet: "_1s8b37j168", laptop: "_1s8b37j169", monitor: "_1s8b37j16a", ultrawide: "_1s8b37j16b" }, defaultClass: "_1s8b37j167" }, "20rem": { conditions: { mobile: "_1s8b37j16c", tablet: "_1s8b37j16d", laptop: "_1s8b37j16e", monitor: "_1s8b37j16f", ultrawide: "_1s8b37j16g" }, defaultClass: "_1s8b37j16c" }, "25rem": { conditions: { mobile: "_1s8b37j16h", tablet: "_1s8b37j16i", laptop: "_1s8b37j16j", monitor: "_1s8b37j16k", ultrawide: "_1s8b37j16l" }, defaultClass: "_1s8b37j16h" }, "30rem": { conditions: { mobile: "_1s8b37j16m", tablet: "_1s8b37j16n", laptop: "_1s8b37j16o", monitor: "_1s8b37j16p", ultrawide: "_1s8b37j16q" }, defaultClass: "_1s8b37j16m" }, "35rem": { conditions: { mobile: "_1s8b37j16r", tablet: "_1s8b37j16s", laptop: "_1s8b37j16t", monitor: "_1s8b37j16u", ultrawide: "_1s8b37j16v" }, defaultClass: "_1s8b37j16r" }, "40rem": { conditions: { mobile: "_1s8b37j16w", tablet: "_1s8b37j16x", laptop: "_1s8b37j16y", monitor: "_1s8b37j16z", ultrawide: "_1s8b37j170" }, defaultClass: "_1s8b37j16w" }, "45rem": { conditions: { mobile: "_1s8b37j171", tablet: "_1s8b37j172", laptop: "_1s8b37j173", monitor: "_1s8b37j174", ultrawide: "_1s8b37j175" }, defaultClass: "_1s8b37j171" }, "50rem": { conditions: { mobile: "_1s8b37j176", tablet: "_1s8b37j177", laptop: "_1s8b37j178", monitor: "_1s8b37j179", ultrawide: "_1s8b37j17a" }, defaultClass: "_1s8b37j176" }, "16%": { conditions: { mobile: "_1s8b37j17b", tablet: "_1s8b37j17c", laptop: "_1s8b37j17d", monitor: "_1s8b37j17e", ultrawide: "_1s8b37j17f" }, defaultClass: "_1s8b37j17b" }, "20%": { conditions: { mobile: "_1s8b37j17g", tablet: "_1s8b37j17h", laptop: "_1s8b37j17i", monitor: "_1s8b37j17j", ultrawide: "_1s8b37j17k" }, defaultClass: "_1s8b37j17g" }, "25%": { conditions: { mobile: "_1s8b37j17l", tablet: "_1s8b37j17m", laptop: "_1s8b37j17n", monitor: "_1s8b37j17o", ultrawide: "_1s8b37j17p" }, defaultClass: "_1s8b37j17l" }, "33%": { conditions: { mobile: "_1s8b37j17q", tablet: "_1s8b37j17r", laptop: "_1s8b37j17s", monitor: "_1s8b37j17t", ultrawide: "_1s8b37j17u" }, defaultClass: "_1s8b37j17q" }, "40%": { conditions: { mobile: "_1s8b37j17v", tablet: "_1s8b37j17w", laptop: "_1s8b37j17x", monitor: "_1s8b37j17y", ultrawide: "_1s8b37j17z" }, defaultClass: "_1s8b37j17v" }, "50%": { conditions: { mobile: "_1s8b37j180", tablet: "_1s8b37j181", laptop: "_1s8b37j182", monitor: "_1s8b37j183", ultrawide: "_1s8b37j184" }, defaultClass: "_1s8b37j180" }, "60%": { conditions: { mobile: "_1s8b37j185", tablet: "_1s8b37j186", laptop: "_1s8b37j187", monitor: "_1s8b37j188", ultrawide: "_1s8b37j189" }, defaultClass: "_1s8b37j185" }, "66%": { conditions: { mobile: "_1s8b37j18a", tablet: "_1s8b37j18b", laptop: "_1s8b37j18c", monitor: "_1s8b37j18d", ultrawide: "_1s8b37j18e" }, defaultClass: "_1s8b37j18a" }, "75%": { conditions: { mobile: "_1s8b37j18f", tablet: "_1s8b37j18g", laptop: "_1s8b37j18h", monitor: "_1s8b37j18i", ultrawide: "_1s8b37j18j" }, defaultClass: "_1s8b37j18f" }, "80%": { conditions: { mobile: "_1s8b37j18k", tablet: "_1s8b37j18l", laptop: "_1s8b37j18m", monitor: "_1s8b37j18n", ultrawide: "_1s8b37j18o" }, defaultClass: "_1s8b37j18k" }, "83%": { conditions: { mobile: "_1s8b37j18p", tablet: "_1s8b37j18q", laptop: "_1s8b37j18r", monitor: "_1s8b37j18s", ultrawide: "_1s8b37j18t" }, defaultClass: "_1s8b37j18p" }, full: { conditions: { mobile: "_1s8b37j18u", tablet: "_1s8b37j18v", laptop: "_1s8b37j18w", monitor: "_1s8b37j18x", ultrawide: "_1s8b37j18y" }, defaultClass: "_1s8b37j18u" }, auto: { conditions: { mobile: "_1s8b37j18z", tablet: "_1s8b37j190", laptop: "_1s8b37j191", monitor: "_1s8b37j192", ultrawide: "_1s8b37j193" }, defaultClass: "_1s8b37j18z" } } }, justifyContent: { values: { "flex-start": { conditions: { mobile: "_1s8b37j194", tablet: "_1s8b37j195", laptop: "_1s8b37j196", monitor: "_1s8b37j197", ultrawide: "_1s8b37j198" }, defaultClass: "_1s8b37j194" }, center: { conditions: { mobile: "_1s8b37j199", tablet: "_1s8b37j19a", laptop: "_1s8b37j19b", monitor: "_1s8b37j19c", ultrawide: "_1s8b37j19d" }, defaultClass: "_1s8b37j199" }, "flex-end": { conditions: { mobile: "_1s8b37j19e", tablet: "_1s8b37j19f", laptop: "_1s8b37j19g", monitor: "_1s8b37j19h", ultrawide: "_1s8b37j19i" }, defaultClass: "_1s8b37j19e" }, stretch: { conditions: { mobile: "_1s8b37j19j", tablet: "_1s8b37j19k", laptop: "_1s8b37j19l", monitor: "_1s8b37j19m", ultrawide: "_1s8b37j19n" }, defaultClass: "_1s8b37j19j" }, "space-between": { conditions: { mobile: "_1s8b37j19o", tablet: "_1s8b37j19p", laptop: "_1s8b37j19q", monitor: "_1s8b37j19r", ultrawide: "_1s8b37j19s" }, defaultClass: "_1s8b37j19o" }, "space-around": { conditions: { mobile: "_1s8b37j19t", tablet: "_1s8b37j19u", laptop: "_1s8b37j19v", monitor: "_1s8b37j19w", ultrawide: "_1s8b37j19x" }, defaultClass: "_1s8b37j19t" }, "space-evenly": { conditions: { mobile: "_1s8b37j19y", tablet: "_1s8b37j19z", laptop: "_1s8b37j1a0", monitor: "_1s8b37j1a1", ultrawide: "_1s8b37j1a2" }, defaultClass: "_1s8b37j19y" } } }, justifySelf: { values: { "flex-start": { conditions: { mobile: "_1s8b37j1a3", tablet: "_1s8b37j1a4", laptop: "_1s8b37j1a5", monitor: "_1s8b37j1a6", ultrawide: "_1s8b37j1a7" }, defaultClass: "_1s8b37j1a3" }, center: { conditions: { mobile: "_1s8b37j1a8", tablet: "_1s8b37j1a9", laptop: "_1s8b37j1aa", monitor: "_1s8b37j1ab", ultrawide: "_1s8b37j1ac" }, defaultClass: "_1s8b37j1a8" }, "flex-end": { conditions: { mobile: "_1s8b37j1ad", tablet: "_1s8b37j1ae", laptop: "_1s8b37j1af", monitor: "_1s8b37j1ag", ultrawide: "_1s8b37j1ah" }, defaultClass: "_1s8b37j1ad" }, stretch: { conditions: { mobile: "_1s8b37j1ai", tablet: "_1s8b37j1aj", laptop: "_1s8b37j1ak", monitor: "_1s8b37j1al", ultrawide: "_1s8b37j1am" }, defaultClass: "_1s8b37j1ai" }, "space-between": { conditions: { mobile: "_1s8b37j1an", tablet: "_1s8b37j1ao", laptop: "_1s8b37j1ap", monitor: "_1s8b37j1aq", ultrawide: "_1s8b37j1ar" }, defaultClass: "_1s8b37j1an" }, "space-around": { conditions: { mobile: "_1s8b37j1as", tablet: "_1s8b37j1at", laptop: "_1s8b37j1au", monitor: "_1s8b37j1av", ultrawide: "_1s8b37j1aw" }, defaultClass: "_1s8b37j1as" }, "space-evenly": { conditions: { mobile: "_1s8b37j1ax", tablet: "_1s8b37j1ay", laptop: "_1s8b37j1az", monitor: "_1s8b37j1b0", ultrawide: "_1s8b37j1b1" }, defaultClass: "_1s8b37j1ax" } } }, left: { values: { 0: { conditions: { mobile: "_1s8b37j1b2", tablet: "_1s8b37j1b3", laptop: "_1s8b37j1b4", monitor: "_1s8b37j1b5", ultrawide: "_1s8b37j1b6" }, defaultClass: "_1s8b37j1b2" }, "0.25rem": { conditions: { mobile: "_1s8b37j1b7", tablet: "_1s8b37j1b8", laptop: "_1s8b37j1b9", monitor: "_1s8b37j1ba", ultrawide: "_1s8b37j1bb" }, defaultClass: "_1s8b37j1b7" }, "0.5rem": { conditions: { mobile: "_1s8b37j1bc", tablet: "_1s8b37j1bd", laptop: "_1s8b37j1be", monitor: "_1s8b37j1bf", ultrawide: "_1s8b37j1bg" }, defaultClass: "_1s8b37j1bc" }, "0.75rem": { conditions: { mobile: "_1s8b37j1bh", tablet: "_1s8b37j1bi", laptop: "_1s8b37j1bj", monitor: "_1s8b37j1bk", ultrawide: "_1s8b37j1bl" }, defaultClass: "_1s8b37j1bh" }, "1rem": { conditions: { mobile: "_1s8b37j1bm", tablet: "_1s8b37j1bn", laptop: "_1s8b37j1bo", monitor: "_1s8b37j1bp", ultrawide: "_1s8b37j1bq" }, defaultClass: "_1s8b37j1bm" }, "1.25rem": { conditions: { mobile: "_1s8b37j1br", tablet: "_1s8b37j1bs", laptop: "_1s8b37j1bt", monitor: "_1s8b37j1bu", ultrawide: "_1s8b37j1bv" }, defaultClass: "_1s8b37j1br" }, "1.5rem": { conditions: { mobile: "_1s8b37j1bw", tablet: "_1s8b37j1bx", laptop: "_1s8b37j1by", monitor: "_1s8b37j1bz", ultrawide: "_1s8b37j1c0" }, defaultClass: "_1s8b37j1bw" }, "1.75rem": { conditions: { mobile: "_1s8b37j1c1", tablet: "_1s8b37j1c2", laptop: "_1s8b37j1c3", monitor: "_1s8b37j1c4", ultrawide: "_1s8b37j1c5" }, defaultClass: "_1s8b37j1c1" }, "2rem": { conditions: { mobile: "_1s8b37j1c6", tablet: "_1s8b37j1c7", laptop: "_1s8b37j1c8", monitor: "_1s8b37j1c9", ultrawide: "_1s8b37j1ca" }, defaultClass: "_1s8b37j1c6" }, "2.25rem": { conditions: { mobile: "_1s8b37j1cb", tablet: "_1s8b37j1cc", laptop: "_1s8b37j1cd", monitor: "_1s8b37j1ce", ultrawide: "_1s8b37j1cf" }, defaultClass: "_1s8b37j1cb" }, "2.5rem": { conditions: { mobile: "_1s8b37j1cg", tablet: "_1s8b37j1ch", laptop: "_1s8b37j1ci", monitor: "_1s8b37j1cj", ultrawide: "_1s8b37j1ck" }, defaultClass: "_1s8b37j1cg" }, "2.75rem": { conditions: { mobile: "_1s8b37j1cl", tablet: "_1s8b37j1cm", laptop: "_1s8b37j1cn", monitor: "_1s8b37j1co", ultrawide: "_1s8b37j1cp" }, defaultClass: "_1s8b37j1cl" }, "3rem": { conditions: { mobile: "_1s8b37j1cq", tablet: "_1s8b37j1cr", laptop: "_1s8b37j1cs", monitor: "_1s8b37j1ct", ultrawide: "_1s8b37j1cu" }, defaultClass: "_1s8b37j1cq" }, "3.25rem": { conditions: { mobile: "_1s8b37j1cv", tablet: "_1s8b37j1cw", laptop: "_1s8b37j1cx", monitor: "_1s8b37j1cy", ultrawide: "_1s8b37j1cz" }, defaultClass: "_1s8b37j1cv" }, "3.5rem": { conditions: { mobile: "_1s8b37j1d0", tablet: "_1s8b37j1d1", laptop: "_1s8b37j1d2", monitor: "_1s8b37j1d3", ultrawide: "_1s8b37j1d4" }, defaultClass: "_1s8b37j1d0" }, "3.75rem": { conditions: { mobile: "_1s8b37j1d5", tablet: "_1s8b37j1d6", laptop: "_1s8b37j1d7", monitor: "_1s8b37j1d8", ultrawide: "_1s8b37j1d9" }, defaultClass: "_1s8b37j1d5" }, "4rem": { conditions: { mobile: "_1s8b37j1da", tablet: "_1s8b37j1db", laptop: "_1s8b37j1dc", monitor: "_1s8b37j1dd", ultrawide: "_1s8b37j1de" }, defaultClass: "_1s8b37j1da" }, "4.25rem": { conditions: { mobile: "_1s8b37j1df", tablet: "_1s8b37j1dg", laptop: "_1s8b37j1dh", monitor: "_1s8b37j1di", ultrawide: "_1s8b37j1dj" }, defaultClass: "_1s8b37j1df" }, "4.5rem": { conditions: { mobile: "_1s8b37j1dk", tablet: "_1s8b37j1dl", laptop: "_1s8b37j1dm", monitor: "_1s8b37j1dn", ultrawide: "_1s8b37j1do" }, defaultClass: "_1s8b37j1dk" }, "4.75rem": { conditions: { mobile: "_1s8b37j1dp", tablet: "_1s8b37j1dq", laptop: "_1s8b37j1dr", monitor: "_1s8b37j1ds", ultrawide: "_1s8b37j1dt" }, defaultClass: "_1s8b37j1dp" }, "5rem": { conditions: { mobile: "_1s8b37j1du", tablet: "_1s8b37j1dv", laptop: "_1s8b37j1dw", monitor: "_1s8b37j1dx", ultrawide: "_1s8b37j1dy" }, defaultClass: "_1s8b37j1du" }, "5.25rem": { conditions: { mobile: "_1s8b37j1dz", tablet: "_1s8b37j1e0", laptop: "_1s8b37j1e1", monitor: "_1s8b37j1e2", ultrawide: "_1s8b37j1e3" }, defaultClass: "_1s8b37j1dz" }, "5.5rem": { conditions: { mobile: "_1s8b37j1e4", tablet: "_1s8b37j1e5", laptop: "_1s8b37j1e6", monitor: "_1s8b37j1e7", ultrawide: "_1s8b37j1e8" }, defaultClass: "_1s8b37j1e4" }, "5.75rem": { conditions: { mobile: "_1s8b37j1e9", tablet: "_1s8b37j1ea", laptop: "_1s8b37j1eb", monitor: "_1s8b37j1ec", ultrawide: "_1s8b37j1ed" }, defaultClass: "_1s8b37j1e9" }, "6rem": { conditions: { mobile: "_1s8b37j1ee", tablet: "_1s8b37j1ef", laptop: "_1s8b37j1eg", monitor: "_1s8b37j1eh", ultrawide: "_1s8b37j1ei" }, defaultClass: "_1s8b37j1ee" }, "7rem": { conditions: { mobile: "_1s8b37j1ej", tablet: "_1s8b37j1ek", laptop: "_1s8b37j1el", monitor: "_1s8b37j1em", ultrawide: "_1s8b37j1en" }, defaultClass: "_1s8b37j1ej" }, "8rem": { conditions: { mobile: "_1s8b37j1eo", tablet: "_1s8b37j1ep", laptop: "_1s8b37j1eq", monitor: "_1s8b37j1er", ultrawide: "_1s8b37j1es" }, defaultClass: "_1s8b37j1eo" }, "9rem": { conditions: { mobile: "_1s8b37j1et", tablet: "_1s8b37j1eu", laptop: "_1s8b37j1ev", monitor: "_1s8b37j1ew", ultrawide: "_1s8b37j1ex" }, defaultClass: "_1s8b37j1et" }, "10rem": { conditions: { mobile: "_1s8b37j1ey", tablet: "_1s8b37j1ez", laptop: "_1s8b37j1f0", monitor: "_1s8b37j1f1", ultrawide: "_1s8b37j1f2" }, defaultClass: "_1s8b37j1ey" }, "12rem": { conditions: { mobile: "_1s8b37j1f3", tablet: "_1s8b37j1f4", laptop: "_1s8b37j1f5", monitor: "_1s8b37j1f6", ultrawide: "_1s8b37j1f7" }, defaultClass: "_1s8b37j1f3" }, "14rem": { conditions: { mobile: "_1s8b37j1f8", tablet: "_1s8b37j1f9", laptop: "_1s8b37j1fa", monitor: "_1s8b37j1fb", ultrawide: "_1s8b37j1fc" }, defaultClass: "_1s8b37j1f8" }, "16rem": { conditions: { mobile: "_1s8b37j1fd", tablet: "_1s8b37j1fe", laptop: "_1s8b37j1ff", monitor: "_1s8b37j1fg", ultrawide: "_1s8b37j1fh" }, defaultClass: "_1s8b37j1fd" }, "18rem": { conditions: { mobile: "_1s8b37j1fi", tablet: "_1s8b37j1fj", laptop: "_1s8b37j1fk", monitor: "_1s8b37j1fl", ultrawide: "_1s8b37j1fm" }, defaultClass: "_1s8b37j1fi" }, "20rem": { conditions: { mobile: "_1s8b37j1fn", tablet: "_1s8b37j1fo", laptop: "_1s8b37j1fp", monitor: "_1s8b37j1fq", ultrawide: "_1s8b37j1fr" }, defaultClass: "_1s8b37j1fn" }, "25rem": { conditions: { mobile: "_1s8b37j1fs", tablet: "_1s8b37j1ft", laptop: "_1s8b37j1fu", monitor: "_1s8b37j1fv", ultrawide: "_1s8b37j1fw" }, defaultClass: "_1s8b37j1fs" }, "30rem": { conditions: { mobile: "_1s8b37j1fx", tablet: "_1s8b37j1fy", laptop: "_1s8b37j1fz", monitor: "_1s8b37j1g0", ultrawide: "_1s8b37j1g1" }, defaultClass: "_1s8b37j1fx" }, "35rem": { conditions: { mobile: "_1s8b37j1g2", tablet: "_1s8b37j1g3", laptop: "_1s8b37j1g4", monitor: "_1s8b37j1g5", ultrawide: "_1s8b37j1g6" }, defaultClass: "_1s8b37j1g2" }, "40rem": { conditions: { mobile: "_1s8b37j1g7", tablet: "_1s8b37j1g8", laptop: "_1s8b37j1g9", monitor: "_1s8b37j1ga", ultrawide: "_1s8b37j1gb" }, defaultClass: "_1s8b37j1g7" }, "45rem": { conditions: { mobile: "_1s8b37j1gc", tablet: "_1s8b37j1gd", laptop: "_1s8b37j1ge", monitor: "_1s8b37j1gf", ultrawide: "_1s8b37j1gg" }, defaultClass: "_1s8b37j1gc" }, "50rem": { conditions: { mobile: "_1s8b37j1gh", tablet: "_1s8b37j1gi", laptop: "_1s8b37j1gj", monitor: "_1s8b37j1gk", ultrawide: "_1s8b37j1gl" }, defaultClass: "_1s8b37j1gh" }, "16%": { conditions: { mobile: "_1s8b37j1gm", tablet: "_1s8b37j1gn", laptop: "_1s8b37j1go", monitor: "_1s8b37j1gp", ultrawide: "_1s8b37j1gq" }, defaultClass: "_1s8b37j1gm" }, "20%": { conditions: { mobile: "_1s8b37j1gr", tablet: "_1s8b37j1gs", laptop: "_1s8b37j1gt", monitor: "_1s8b37j1gu", ultrawide: "_1s8b37j1gv" }, defaultClass: "_1s8b37j1gr" }, "25%": { conditions: { mobile: "_1s8b37j1gw", tablet: "_1s8b37j1gx", laptop: "_1s8b37j1gy", monitor: "_1s8b37j1gz", ultrawide: "_1s8b37j1h0" }, defaultClass: "_1s8b37j1gw" }, "33%": { conditions: { mobile: "_1s8b37j1h1", tablet: "_1s8b37j1h2", laptop: "_1s8b37j1h3", monitor: "_1s8b37j1h4", ultrawide: "_1s8b37j1h5" }, defaultClass: "_1s8b37j1h1" }, "40%": { conditions: { mobile: "_1s8b37j1h6", tablet: "_1s8b37j1h7", laptop: "_1s8b37j1h8", monitor: "_1s8b37j1h9", ultrawide: "_1s8b37j1ha" }, defaultClass: "_1s8b37j1h6" }, "50%": { conditions: { mobile: "_1s8b37j1hb", tablet: "_1s8b37j1hc", laptop: "_1s8b37j1hd", monitor: "_1s8b37j1he", ultrawide: "_1s8b37j1hf" }, defaultClass: "_1s8b37j1hb" }, "60%": { conditions: { mobile: "_1s8b37j1hg", tablet: "_1s8b37j1hh", laptop: "_1s8b37j1hi", monitor: "_1s8b37j1hj", ultrawide: "_1s8b37j1hk" }, defaultClass: "_1s8b37j1hg" }, "66%": { conditions: { mobile: "_1s8b37j1hl", tablet: "_1s8b37j1hm", laptop: "_1s8b37j1hn", monitor: "_1s8b37j1ho", ultrawide: "_1s8b37j1hp" }, defaultClass: "_1s8b37j1hl" }, "75%": { conditions: { mobile: "_1s8b37j1hq", tablet: "_1s8b37j1hr", laptop: "_1s8b37j1hs", monitor: "_1s8b37j1ht", ultrawide: "_1s8b37j1hu" }, defaultClass: "_1s8b37j1hq" }, "80%": { conditions: { mobile: "_1s8b37j1hv", tablet: "_1s8b37j1hw", laptop: "_1s8b37j1hx", monitor: "_1s8b37j1hy", ultrawide: "_1s8b37j1hz" }, defaultClass: "_1s8b37j1hv" }, "83%": { conditions: { mobile: "_1s8b37j1i0", tablet: "_1s8b37j1i1", laptop: "_1s8b37j1i2", monitor: "_1s8b37j1i3", ultrawide: "_1s8b37j1i4" }, defaultClass: "_1s8b37j1i0" }, full: { conditions: { mobile: "_1s8b37j1i5", tablet: "_1s8b37j1i6", laptop: "_1s8b37j1i7", monitor: "_1s8b37j1i8", ultrawide: "_1s8b37j1i9" }, defaultClass: "_1s8b37j1i5" } } }, marginBottom: { values: { auto: { conditions: { mobile: "_1s8b37j1ia", tablet: "_1s8b37j1ib", laptop: "_1s8b37j1ic", monitor: "_1s8b37j1id", ultrawide: "_1s8b37j1ie" }, defaultClass: "_1s8b37j1ia" }, zero: { conditions: { mobile: "_1s8b37j1if", tablet: "_1s8b37j1ig", laptop: "_1s8b37j1ih", monitor: "_1s8b37j1ii", ultrawide: "_1s8b37j1ij" }, defaultClass: "_1s8b37j1if" }, xsmall: { conditions: { mobile: "_1s8b37j1ik", tablet: "_1s8b37j1il", laptop: "_1s8b37j1im", monitor: "_1s8b37j1in", ultrawide: "_1s8b37j1io" }, defaultClass: "_1s8b37j1ik" }, small: { conditions: { mobile: "_1s8b37j1ip", tablet: "_1s8b37j1iq", laptop: "_1s8b37j1ir", monitor: "_1s8b37j1is", ultrawide: "_1s8b37j1it" }, defaultClass: "_1s8b37j1ip" }, smedium: { conditions: { mobile: "_1s8b37j1iu", tablet: "_1s8b37j1iv", laptop: "_1s8b37j1iw", monitor: "_1s8b37j1ix", ultrawide: "_1s8b37j1iy" }, defaultClass: "_1s8b37j1iu" }, default: { conditions: { mobile: "_1s8b37j1iz", tablet: "_1s8b37j1j0", laptop: "_1s8b37j1j1", monitor: "_1s8b37j1j2", ultrawide: "_1s8b37j1j3" }, defaultClass: "_1s8b37j1iz" }, medium: { conditions: { mobile: "_1s8b37j1j4", tablet: "_1s8b37j1j5", laptop: "_1s8b37j1j6", monitor: "_1s8b37j1j7", ultrawide: "_1s8b37j1j8" }, defaultClass: "_1s8b37j1j4" }, large: { conditions: { mobile: "_1s8b37j1j9", tablet: "_1s8b37j1ja", laptop: "_1s8b37j1jb", monitor: "_1s8b37j1jc", ultrawide: "_1s8b37j1jd" }, defaultClass: "_1s8b37j1j9" }, xlarge: { conditions: { mobile: "_1s8b37j1je", tablet: "_1s8b37j1jf", laptop: "_1s8b37j1jg", monitor: "_1s8b37j1jh", ultrawide: "_1s8b37j1ji" }, defaultClass: "_1s8b37j1je" }, xxlarge: { conditions: { mobile: "_1s8b37j1jj", tablet: "_1s8b37j1jk", laptop: "_1s8b37j1jl", monitor: "_1s8b37j1jm", ultrawide: "_1s8b37j1jn" }, defaultClass: "_1s8b37j1jj" } } }, marginLeft: { values: { auto: { conditions: { mobile: "_1s8b37j1jo", tablet: "_1s8b37j1jp", laptop: "_1s8b37j1jq", monitor: "_1s8b37j1jr", ultrawide: "_1s8b37j1js" }, defaultClass: "_1s8b37j1jo" }, zero: { conditions: { mobile: "_1s8b37j1jt", tablet: "_1s8b37j1ju", laptop: "_1s8b37j1jv", monitor: "_1s8b37j1jw", ultrawide: "_1s8b37j1jx" }, defaultClass: "_1s8b37j1jt" }, xsmall: { conditions: { mobile: "_1s8b37j1jy", tablet: "_1s8b37j1jz", laptop: "_1s8b37j1k0", monitor: "_1s8b37j1k1", ultrawide: "_1s8b37j1k2" }, defaultClass: "_1s8b37j1jy" }, small: { conditions: { mobile: "_1s8b37j1k3", tablet: "_1s8b37j1k4", laptop: "_1s8b37j1k5", monitor: "_1s8b37j1k6", ultrawide: "_1s8b37j1k7" }, defaultClass: "_1s8b37j1k3" }, smedium: { conditions: { mobile: "_1s8b37j1k8", tablet: "_1s8b37j1k9", laptop: "_1s8b37j1ka", monitor: "_1s8b37j1kb", ultrawide: "_1s8b37j1kc" }, defaultClass: "_1s8b37j1k8" }, default: { conditions: { mobile: "_1s8b37j1kd", tablet: "_1s8b37j1ke", laptop: "_1s8b37j1kf", monitor: "_1s8b37j1kg", ultrawide: "_1s8b37j1kh" }, defaultClass: "_1s8b37j1kd" }, medium: { conditions: { mobile: "_1s8b37j1ki", tablet: "_1s8b37j1kj", laptop: "_1s8b37j1kk", monitor: "_1s8b37j1kl", ultrawide: "_1s8b37j1km" }, defaultClass: "_1s8b37j1ki" }, large: { conditions: { mobile: "_1s8b37j1kn", tablet: "_1s8b37j1ko", laptop: "_1s8b37j1kp", monitor: "_1s8b37j1kq", ultrawide: "_1s8b37j1kr" }, defaultClass: "_1s8b37j1kn" }, xlarge: { conditions: { mobile: "_1s8b37j1ks", tablet: "_1s8b37j1kt", laptop: "_1s8b37j1ku", monitor: "_1s8b37j1kv", ultrawide: "_1s8b37j1kw" }, defaultClass: "_1s8b37j1ks" }, xxlarge: { conditions: { mobile: "_1s8b37j1kx", tablet: "_1s8b37j1ky", laptop: "_1s8b37j1kz", monitor: "_1s8b37j1l0", ultrawide: "_1s8b37j1l1" }, defaultClass: "_1s8b37j1kx" } } }, marginRight: { values: { auto: { conditions: { mobile: "_1s8b37j1l2", tablet: "_1s8b37j1l3", laptop: "_1s8b37j1l4", monitor: "_1s8b37j1l5", ultrawide: "_1s8b37j1l6" }, defaultClass: "_1s8b37j1l2" }, zero: { conditions: { mobile: "_1s8b37j1l7", tablet: "_1s8b37j1l8", laptop: "_1s8b37j1l9", monitor: "_1s8b37j1la", ultrawide: "_1s8b37j1lb" }, defaultClass: "_1s8b37j1l7" }, xsmall: { conditions: { mobile: "_1s8b37j1lc", tablet: "_1s8b37j1ld", laptop: "_1s8b37j1le", monitor: "_1s8b37j1lf", ultrawide: "_1s8b37j1lg" }, defaultClass: "_1s8b37j1lc" }, small: { conditions: { mobile: "_1s8b37j1lh", tablet: "_1s8b37j1li", laptop: "_1s8b37j1lj", monitor: "_1s8b37j1lk", ultrawide: "_1s8b37j1ll" }, defaultClass: "_1s8b37j1lh" }, smedium: { conditions: { mobile: "_1s8b37j1lm", tablet: "_1s8b37j1ln", laptop: "_1s8b37j1lo", monitor: "_1s8b37j1lp", ultrawide: "_1s8b37j1lq" }, defaultClass: "_1s8b37j1lm" }, default: { conditions: { mobile: "_1s8b37j1lr", tablet: "_1s8b37j1ls", laptop: "_1s8b37j1lt", monitor: "_1s8b37j1lu", ultrawide: "_1s8b37j1lv" }, defaultClass: "_1s8b37j1lr" }, medium: { conditions: { mobile: "_1s8b37j1lw", tablet: "_1s8b37j1lx", laptop: "_1s8b37j1ly", monitor: "_1s8b37j1lz", ultrawide: "_1s8b37j1m0" }, defaultClass: "_1s8b37j1lw" }, large: { conditions: { mobile: "_1s8b37j1m1", tablet: "_1s8b37j1m2", laptop: "_1s8b37j1m3", monitor: "_1s8b37j1m4", ultrawide: "_1s8b37j1m5" }, defaultClass: "_1s8b37j1m1" }, xlarge: { conditions: { mobile: "_1s8b37j1m6", tablet: "_1s8b37j1m7", laptop: "_1s8b37j1m8", monitor: "_1s8b37j1m9", ultrawide: "_1s8b37j1ma" }, defaultClass: "_1s8b37j1m6" }, xxlarge: { conditions: { mobile: "_1s8b37j1mb", tablet: "_1s8b37j1mc", laptop: "_1s8b37j1md", monitor: "_1s8b37j1me", ultrawide: "_1s8b37j1mf" }, defaultClass: "_1s8b37j1mb" } } }, marginTop: { values: { auto: { conditions: { mobile: "_1s8b37j1mg", tablet: "_1s8b37j1mh", laptop: "_1s8b37j1mi", monitor: "_1s8b37j1mj", ultrawide: "_1s8b37j1mk" }, defaultClass: "_1s8b37j1mg" }, zero: { conditions: { mobile: "_1s8b37j1ml", tablet: "_1s8b37j1mm", laptop: "_1s8b37j1mn", monitor: "_1s8b37j1mo", ultrawide: "_1s8b37j1mp" }, defaultClass: "_1s8b37j1ml" }, xsmall: { conditions: { mobile: "_1s8b37j1mq", tablet: "_1s8b37j1mr", laptop: "_1s8b37j1ms", monitor: "_1s8b37j1mt", ultrawide: "_1s8b37j1mu" }, defaultClass: "_1s8b37j1mq" }, small: { conditions: { mobile: "_1s8b37j1mv", tablet: "_1s8b37j1mw", laptop: "_1s8b37j1mx", monitor: "_1s8b37j1my", ultrawide: "_1s8b37j1mz" }, defaultClass: "_1s8b37j1mv" }, smedium: { conditions: { mobile: "_1s8b37j1n0", tablet: "_1s8b37j1n1", laptop: "_1s8b37j1n2", monitor: "_1s8b37j1n3", ultrawide: "_1s8b37j1n4" }, defaultClass: "_1s8b37j1n0" }, default: { conditions: { mobile: "_1s8b37j1n5", tablet: "_1s8b37j1n6", laptop: "_1s8b37j1n7", monitor: "_1s8b37j1n8", ultrawide: "_1s8b37j1n9" }, defaultClass: "_1s8b37j1n5" }, medium: { conditions: { mobile: "_1s8b37j1na", tablet: "_1s8b37j1nb", laptop: "_1s8b37j1nc", monitor: "_1s8b37j1nd", ultrawide: "_1s8b37j1ne" }, defaultClass: "_1s8b37j1na" }, large: { conditions: { mobile: "_1s8b37j1nf", tablet: "_1s8b37j1ng", laptop: "_1s8b37j1nh", monitor: "_1s8b37j1ni", ultrawide: "_1s8b37j1nj" }, defaultClass: "_1s8b37j1nf" }, xlarge: { conditions: { mobile: "_1s8b37j1nk", tablet: "_1s8b37j1nl", laptop: "_1s8b37j1nm", monitor: "_1s8b37j1nn", ultrawide: "_1s8b37j1no" }, defaultClass: "_1s8b37j1nk" }, xxlarge: { conditions: { mobile: "_1s8b37j1np", tablet: "_1s8b37j1nq", laptop: "_1s8b37j1nr", monitor: "_1s8b37j1ns", ultrawide: "_1s8b37j1nt" }, defaultClass: "_1s8b37j1np" } } }, maxHeight: { values: { 0: { conditions: { mobile: "_1s8b37j1nu", tablet: "_1s8b37j1nv", laptop: "_1s8b37j1nw", monitor: "_1s8b37j1nx", ultrawide: "_1s8b37j1ny" }, defaultClass: "_1s8b37j1nu" }, "0.25rem": { conditions: { mobile: "_1s8b37j1nz", tablet: "_1s8b37j1o0", laptop: "_1s8b37j1o1", monitor: "_1s8b37j1o2", ultrawide: "_1s8b37j1o3" }, defaultClass: "_1s8b37j1nz" }, "0.5rem": { conditions: { mobile: "_1s8b37j1o4", tablet: "_1s8b37j1o5", laptop: "_1s8b37j1o6", monitor: "_1s8b37j1o7", ultrawide: "_1s8b37j1o8" }, defaultClass: "_1s8b37j1o4" }, "0.75rem": { conditions: { mobile: "_1s8b37j1o9", tablet: "_1s8b37j1oa", laptop: "_1s8b37j1ob", monitor: "_1s8b37j1oc", ultrawide: "_1s8b37j1od" }, defaultClass: "_1s8b37j1o9" }, "1rem": { conditions: { mobile: "_1s8b37j1oe", tablet: "_1s8b37j1of", laptop: "_1s8b37j1og", monitor: "_1s8b37j1oh", ultrawide: "_1s8b37j1oi" }, defaultClass: "_1s8b37j1oe" }, "1.25rem": { conditions: { mobile: "_1s8b37j1oj", tablet: "_1s8b37j1ok", laptop: "_1s8b37j1ol", monitor: "_1s8b37j1om", ultrawide: "_1s8b37j1on" }, defaultClass: "_1s8b37j1oj" }, "1.5rem": { conditions: { mobile: "_1s8b37j1oo", tablet: "_1s8b37j1op", laptop: "_1s8b37j1oq", monitor: "_1s8b37j1or", ultrawide: "_1s8b37j1os" }, defaultClass: "_1s8b37j1oo" }, "1.75rem": { conditions: { mobile: "_1s8b37j1ot", tablet: "_1s8b37j1ou", laptop: "_1s8b37j1ov", monitor: "_1s8b37j1ow", ultrawide: "_1s8b37j1ox" }, defaultClass: "_1s8b37j1ot" }, "2rem": { conditions: { mobile: "_1s8b37j1oy", tablet: "_1s8b37j1oz", laptop: "_1s8b37j1p0", monitor: "_1s8b37j1p1", ultrawide: "_1s8b37j1p2" }, defaultClass: "_1s8b37j1oy" }, "2.25rem": { conditions: { mobile: "_1s8b37j1p3", tablet: "_1s8b37j1p4", laptop: "_1s8b37j1p5", monitor: "_1s8b37j1p6", ultrawide: "_1s8b37j1p7" }, defaultClass: "_1s8b37j1p3" }, "2.5rem": { conditions: { mobile: "_1s8b37j1p8", tablet: "_1s8b37j1p9", laptop: "_1s8b37j1pa", monitor: "_1s8b37j1pb", ultrawide: "_1s8b37j1pc" }, defaultClass: "_1s8b37j1p8" }, "2.75rem": { conditions: { mobile: "_1s8b37j1pd", tablet: "_1s8b37j1pe", laptop: "_1s8b37j1pf", monitor: "_1s8b37j1pg", ultrawide: "_1s8b37j1ph" }, defaultClass: "_1s8b37j1pd" }, "3rem": { conditions: { mobile: "_1s8b37j1pi", tablet: "_1s8b37j1pj", laptop: "_1s8b37j1pk", monitor: "_1s8b37j1pl", ultrawide: "_1s8b37j1pm" }, defaultClass: "_1s8b37j1pi" }, "3.25rem": { conditions: { mobile: "_1s8b37j1pn", tablet: "_1s8b37j1po", laptop: "_1s8b37j1pp", monitor: "_1s8b37j1pq", ultrawide: "_1s8b37j1pr" }, defaultClass: "_1s8b37j1pn" }, "3.5rem": { conditions: { mobile: "_1s8b37j1ps", tablet: "_1s8b37j1pt", laptop: "_1s8b37j1pu", monitor: "_1s8b37j1pv", ultrawide: "_1s8b37j1pw" }, defaultClass: "_1s8b37j1ps" }, "3.75rem": { conditions: { mobile: "_1s8b37j1px", tablet: "_1s8b37j1py", laptop: "_1s8b37j1pz", monitor: "_1s8b37j1q0", ultrawide: "_1s8b37j1q1" }, defaultClass: "_1s8b37j1px" }, "4rem": { conditions: { mobile: "_1s8b37j1q2", tablet: "_1s8b37j1q3", laptop: "_1s8b37j1q4", monitor: "_1s8b37j1q5", ultrawide: "_1s8b37j1q6" }, defaultClass: "_1s8b37j1q2" }, "4.25rem": { conditions: { mobile: "_1s8b37j1q7", tablet: "_1s8b37j1q8", laptop: "_1s8b37j1q9", monitor: "_1s8b37j1qa", ultrawide: "_1s8b37j1qb" }, defaultClass: "_1s8b37j1q7" }, "4.5rem": { conditions: { mobile: "_1s8b37j1qc", tablet: "_1s8b37j1qd", laptop: "_1s8b37j1qe", monitor: "_1s8b37j1qf", ultrawide: "_1s8b37j1qg" }, defaultClass: "_1s8b37j1qc" }, "4.75rem": { conditions: { mobile: "_1s8b37j1qh", tablet: "_1s8b37j1qi", laptop: "_1s8b37j1qj", monitor: "_1s8b37j1qk", ultrawide: "_1s8b37j1ql" }, defaultClass: "_1s8b37j1qh" }, "5rem": { conditions: { mobile: "_1s8b37j1qm", tablet: "_1s8b37j1qn", laptop: "_1s8b37j1qo", monitor: "_1s8b37j1qp", ultrawide: "_1s8b37j1qq" }, defaultClass: "_1s8b37j1qm" }, "5.25rem": { conditions: { mobile: "_1s8b37j1qr", tablet: "_1s8b37j1qs", laptop: "_1s8b37j1qt", monitor: "_1s8b37j1qu", ultrawide: "_1s8b37j1qv" }, defaultClass: "_1s8b37j1qr" }, "5.5rem": { conditions: { mobile: "_1s8b37j1qw", tablet: "_1s8b37j1qx", laptop: "_1s8b37j1qy", monitor: "_1s8b37j1qz", ultrawide: "_1s8b37j1r0" }, defaultClass: "_1s8b37j1qw" }, "5.75rem": { conditions: { mobile: "_1s8b37j1r1", tablet: "_1s8b37j1r2", laptop: "_1s8b37j1r3", monitor: "_1s8b37j1r4", ultrawide: "_1s8b37j1r5" }, defaultClass: "_1s8b37j1r1" }, "6rem": { conditions: { mobile: "_1s8b37j1r6", tablet: "_1s8b37j1r7", laptop: "_1s8b37j1r8", monitor: "_1s8b37j1r9", ultrawide: "_1s8b37j1ra" }, defaultClass: "_1s8b37j1r6" }, "7rem": { conditions: { mobile: "_1s8b37j1rb", tablet: "_1s8b37j1rc", laptop: "_1s8b37j1rd", monitor: "_1s8b37j1re", ultrawide: "_1s8b37j1rf" }, defaultClass: "_1s8b37j1rb" }, "8rem": { conditions: { mobile: "_1s8b37j1rg", tablet: "_1s8b37j1rh", laptop: "_1s8b37j1ri", monitor: "_1s8b37j1rj", ultrawide: "_1s8b37j1rk" }, defaultClass: "_1s8b37j1rg" }, "9rem": { conditions: { mobile: "_1s8b37j1rl", tablet: "_1s8b37j1rm", laptop: "_1s8b37j1rn", monitor: "_1s8b37j1ro", ultrawide: "_1s8b37j1rp" }, defaultClass: "_1s8b37j1rl" }, "10rem": { conditions: { mobile: "_1s8b37j1rq", tablet: "_1s8b37j1rr", laptop: "_1s8b37j1rs", monitor: "_1s8b37j1rt", ultrawide: "_1s8b37j1ru" }, defaultClass: "_1s8b37j1rq" }, "12rem": { conditions: { mobile: "_1s8b37j1rv", tablet: "_1s8b37j1rw", laptop: "_1s8b37j1rx", monitor: "_1s8b37j1ry", ultrawide: "_1s8b37j1rz" }, defaultClass: "_1s8b37j1rv" }, "14rem": { conditions: { mobile: "_1s8b37j1s0", tablet: "_1s8b37j1s1", laptop: "_1s8b37j1s2", monitor: "_1s8b37j1s3", ultrawide: "_1s8b37j1s4" }, defaultClass: "_1s8b37j1s0" }, "16rem": { conditions: { mobile: "_1s8b37j1s5", tablet: "_1s8b37j1s6", laptop: "_1s8b37j1s7", monitor: "_1s8b37j1s8", ultrawide: "_1s8b37j1s9" }, defaultClass: "_1s8b37j1s5" }, "18rem": { conditions: { mobile: "_1s8b37j1sa", tablet: "_1s8b37j1sb", laptop: "_1s8b37j1sc", monitor: "_1s8b37j1sd", ultrawide: "_1s8b37j1se" }, defaultClass: "_1s8b37j1sa" }, "20rem": { conditions: { mobile: "_1s8b37j1sf", tablet: "_1s8b37j1sg", laptop: "_1s8b37j1sh", monitor: "_1s8b37j1si", ultrawide: "_1s8b37j1sj" }, defaultClass: "_1s8b37j1sf" }, "25rem": { conditions: { mobile: "_1s8b37j1sk", tablet: "_1s8b37j1sl", laptop: "_1s8b37j1sm", monitor: "_1s8b37j1sn", ultrawide: "_1s8b37j1so" }, defaultClass: "_1s8b37j1sk" }, "30rem": { conditions: { mobile: "_1s8b37j1sp", tablet: "_1s8b37j1sq", laptop: "_1s8b37j1sr", monitor: "_1s8b37j1ss", ultrawide: "_1s8b37j1st" }, defaultClass: "_1s8b37j1sp" }, "35rem": { conditions: { mobile: "_1s8b37j1su", tablet: "_1s8b37j1sv", laptop: "_1s8b37j1sw", monitor: "_1s8b37j1sx", ultrawide: "_1s8b37j1sy" }, defaultClass: "_1s8b37j1su" }, "40rem": { conditions: { mobile: "_1s8b37j1sz", tablet: "_1s8b37j1t0", laptop: "_1s8b37j1t1", monitor: "_1s8b37j1t2", ultrawide: "_1s8b37j1t3" }, defaultClass: "_1s8b37j1sz" }, "45rem": { conditions: { mobile: "_1s8b37j1t4", tablet: "_1s8b37j1t5", laptop: "_1s8b37j1t6", monitor: "_1s8b37j1t7", ultrawide: "_1s8b37j1t8" }, defaultClass: "_1s8b37j1t4" }, "50rem": { conditions: { mobile: "_1s8b37j1t9", tablet: "_1s8b37j1ta", laptop: "_1s8b37j1tb", monitor: "_1s8b37j1tc", ultrawide: "_1s8b37j1td" }, defaultClass: "_1s8b37j1t9" }, "16%": { conditions: { mobile: "_1s8b37j1te", tablet: "_1s8b37j1tf", laptop: "_1s8b37j1tg", monitor: "_1s8b37j1th", ultrawide: "_1s8b37j1ti" }, defaultClass: "_1s8b37j1te" }, "20%": { conditions: { mobile: "_1s8b37j1tj", tablet: "_1s8b37j1tk", laptop: "_1s8b37j1tl", monitor: "_1s8b37j1tm", ultrawide: "_1s8b37j1tn" }, defaultClass: "_1s8b37j1tj" }, "25%": { conditions: { mobile: "_1s8b37j1to", tablet: "_1s8b37j1tp", laptop: "_1s8b37j1tq", monitor: "_1s8b37j1tr", ultrawide: "_1s8b37j1ts" }, defaultClass: "_1s8b37j1to" }, "33%": { conditions: { mobile: "_1s8b37j1tt", tablet: "_1s8b37j1tu", laptop: "_1s8b37j1tv", monitor: "_1s8b37j1tw", ultrawide: "_1s8b37j1tx" }, defaultClass: "_1s8b37j1tt" }, "40%": { conditions: { mobile: "_1s8b37j1ty", tablet: "_1s8b37j1tz", laptop: "_1s8b37j1u0", monitor: "_1s8b37j1u1", ultrawide: "_1s8b37j1u2" }, defaultClass: "_1s8b37j1ty" }, "50%": { conditions: { mobile: "_1s8b37j1u3", tablet: "_1s8b37j1u4", laptop: "_1s8b37j1u5", monitor: "_1s8b37j1u6", ultrawide: "_1s8b37j1u7" }, defaultClass: "_1s8b37j1u3" }, "60%": { conditions: { mobile: "_1s8b37j1u8", tablet: "_1s8b37j1u9", laptop: "_1s8b37j1ua", monitor: "_1s8b37j1ub", ultrawide: "_1s8b37j1uc" }, defaultClass: "_1s8b37j1u8" }, "66%": { conditions: { mobile: "_1s8b37j1ud", tablet: "_1s8b37j1ue", laptop: "_1s8b37j1uf", monitor: "_1s8b37j1ug", ultrawide: "_1s8b37j1uh" }, defaultClass: "_1s8b37j1ud" }, "75%": { conditions: { mobile: "_1s8b37j1ui", tablet: "_1s8b37j1uj", laptop: "_1s8b37j1uk", monitor: "_1s8b37j1ul", ultrawide: "_1s8b37j1um" }, defaultClass: "_1s8b37j1ui" }, "80%": { conditions: { mobile: "_1s8b37j1un", tablet: "_1s8b37j1uo", laptop: "_1s8b37j1up", monitor: "_1s8b37j1uq", ultrawide: "_1s8b37j1ur" }, defaultClass: "_1s8b37j1un" }, "83%": { conditions: { mobile: "_1s8b37j1us", tablet: "_1s8b37j1ut", laptop: "_1s8b37j1uu", monitor: "_1s8b37j1uv", ultrawide: "_1s8b37j1uw" }, defaultClass: "_1s8b37j1us" }, full: { conditions: { mobile: "_1s8b37j1ux", tablet: "_1s8b37j1uy", laptop: "_1s8b37j1uz", monitor: "_1s8b37j1v0", ultrawide: "_1s8b37j1v1" }, defaultClass: "_1s8b37j1ux" } } }, maxWidth: { values: { 0: { conditions: { mobile: "_1s8b37j1v2", tablet: "_1s8b37j1v3", laptop: "_1s8b37j1v4", monitor: "_1s8b37j1v5", ultrawide: "_1s8b37j1v6" }, defaultClass: "_1s8b37j1v2" }, "0.25rem": { conditions: { mobile: "_1s8b37j1v7", tablet: "_1s8b37j1v8", laptop: "_1s8b37j1v9", monitor: "_1s8b37j1va", ultrawide: "_1s8b37j1vb" }, defaultClass: "_1s8b37j1v7" }, "0.5rem": { conditions: { mobile: "_1s8b37j1vc", tablet: "_1s8b37j1vd", laptop: "_1s8b37j1ve", monitor: "_1s8b37j1vf", ultrawide: "_1s8b37j1vg" }, defaultClass: "_1s8b37j1vc" }, "0.75rem": { conditions: { mobile: "_1s8b37j1vh", tablet: "_1s8b37j1vi", laptop: "_1s8b37j1vj", monitor: "_1s8b37j1vk", ultrawide: "_1s8b37j1vl" }, defaultClass: "_1s8b37j1vh" }, "1rem": { conditions: { mobile: "_1s8b37j1vm", tablet: "_1s8b37j1vn", laptop: "_1s8b37j1vo", monitor: "_1s8b37j1vp", ultrawide: "_1s8b37j1vq" }, defaultClass: "_1s8b37j1vm" }, "1.25rem": { conditions: { mobile: "_1s8b37j1vr", tablet: "_1s8b37j1vs", laptop: "_1s8b37j1vt", monitor: "_1s8b37j1vu", ultrawide: "_1s8b37j1vv" }, defaultClass: "_1s8b37j1vr" }, "1.5rem": { conditions: { mobile: "_1s8b37j1vw", tablet: "_1s8b37j1vx", laptop: "_1s8b37j1vy", monitor: "_1s8b37j1vz", ultrawide: "_1s8b37j1w0" }, defaultClass: "_1s8b37j1vw" }, "1.75rem": { conditions: { mobile: "_1s8b37j1w1", tablet: "_1s8b37j1w2", laptop: "_1s8b37j1w3", monitor: "_1s8b37j1w4", ultrawide: "_1s8b37j1w5" }, defaultClass: "_1s8b37j1w1" }, "2rem": { conditions: { mobile: "_1s8b37j1w6", tablet: "_1s8b37j1w7", laptop: "_1s8b37j1w8", monitor: "_1s8b37j1w9", ultrawide: "_1s8b37j1wa" }, defaultClass: "_1s8b37j1w6" }, "2.25rem": { conditions: { mobile: "_1s8b37j1wb", tablet: "_1s8b37j1wc", laptop: "_1s8b37j1wd", monitor: "_1s8b37j1we", ultrawide: "_1s8b37j1wf" }, defaultClass: "_1s8b37j1wb" }, "2.5rem": { conditions: { mobile: "_1s8b37j1wg", tablet: "_1s8b37j1wh", laptop: "_1s8b37j1wi", monitor: "_1s8b37j1wj", ultrawide: "_1s8b37j1wk" }, defaultClass: "_1s8b37j1wg" }, "2.75rem": { conditions: { mobile: "_1s8b37j1wl", tablet: "_1s8b37j1wm", laptop: "_1s8b37j1wn", monitor: "_1s8b37j1wo", ultrawide: "_1s8b37j1wp" }, defaultClass: "_1s8b37j1wl" }, "3rem": { conditions: { mobile: "_1s8b37j1wq", tablet: "_1s8b37j1wr", laptop: "_1s8b37j1ws", monitor: "_1s8b37j1wt", ultrawide: "_1s8b37j1wu" }, defaultClass: "_1s8b37j1wq" }, "3.25rem": { conditions: { mobile: "_1s8b37j1wv", tablet: "_1s8b37j1ww", laptop: "_1s8b37j1wx", monitor: "_1s8b37j1wy", ultrawide: "_1s8b37j1wz" }, defaultClass: "_1s8b37j1wv" }, "3.5rem": { conditions: { mobile: "_1s8b37j1x0", tablet: "_1s8b37j1x1", laptop: "_1s8b37j1x2", monitor: "_1s8b37j1x3", ultrawide: "_1s8b37j1x4" }, defaultClass: "_1s8b37j1x0" }, "3.75rem": { conditions: { mobile: "_1s8b37j1x5", tablet: "_1s8b37j1x6", laptop: "_1s8b37j1x7", monitor: "_1s8b37j1x8", ultrawide: "_1s8b37j1x9" }, defaultClass: "_1s8b37j1x5" }, "4rem": { conditions: { mobile: "_1s8b37j1xa", tablet: "_1s8b37j1xb", laptop: "_1s8b37j1xc", monitor: "_1s8b37j1xd", ultrawide: "_1s8b37j1xe" }, defaultClass: "_1s8b37j1xa" }, "4.25rem": { conditions: { mobile: "_1s8b37j1xf", tablet: "_1s8b37j1xg", laptop: "_1s8b37j1xh", monitor: "_1s8b37j1xi", ultrawide: "_1s8b37j1xj" }, defaultClass: "_1s8b37j1xf" }, "4.5rem": { conditions: { mobile: "_1s8b37j1xk", tablet: "_1s8b37j1xl", laptop: "_1s8b37j1xm", monitor: "_1s8b37j1xn", ultrawide: "_1s8b37j1xo" }, defaultClass: "_1s8b37j1xk" }, "4.75rem": { conditions: { mobile: "_1s8b37j1xp", tablet: "_1s8b37j1xq", laptop: "_1s8b37j1xr", monitor: "_1s8b37j1xs", ultrawide: "_1s8b37j1xt" }, defaultClass: "_1s8b37j1xp" }, "5rem": { conditions: { mobile: "_1s8b37j1xu", tablet: "_1s8b37j1xv", laptop: "_1s8b37j1xw", monitor: "_1s8b37j1xx", ultrawide: "_1s8b37j1xy" }, defaultClass: "_1s8b37j1xu" }, "5.25rem": { conditions: { mobile: "_1s8b37j1xz", tablet: "_1s8b37j1y0", laptop: "_1s8b37j1y1", monitor: "_1s8b37j1y2", ultrawide: "_1s8b37j1y3" }, defaultClass: "_1s8b37j1xz" }, "5.5rem": { conditions: { mobile: "_1s8b37j1y4", tablet: "_1s8b37j1y5", laptop: "_1s8b37j1y6", monitor: "_1s8b37j1y7", ultrawide: "_1s8b37j1y8" }, defaultClass: "_1s8b37j1y4" }, "5.75rem": { conditions: { mobile: "_1s8b37j1y9", tablet: "_1s8b37j1ya", laptop: "_1s8b37j1yb", monitor: "_1s8b37j1yc", ultrawide: "_1s8b37j1yd" }, defaultClass: "_1s8b37j1y9" }, "6rem": { conditions: { mobile: "_1s8b37j1ye", tablet: "_1s8b37j1yf", laptop: "_1s8b37j1yg", monitor: "_1s8b37j1yh", ultrawide: "_1s8b37j1yi" }, defaultClass: "_1s8b37j1ye" }, "7rem": { conditions: { mobile: "_1s8b37j1yj", tablet: "_1s8b37j1yk", laptop: "_1s8b37j1yl", monitor: "_1s8b37j1ym", ultrawide: "_1s8b37j1yn" }, defaultClass: "_1s8b37j1yj" }, "8rem": { conditions: { mobile: "_1s8b37j1yo", tablet: "_1s8b37j1yp", laptop: "_1s8b37j1yq", monitor: "_1s8b37j1yr", ultrawide: "_1s8b37j1ys" }, defaultClass: "_1s8b37j1yo" }, "9rem": { conditions: { mobile: "_1s8b37j1yt", tablet: "_1s8b37j1yu", laptop: "_1s8b37j1yv", monitor: "_1s8b37j1yw", ultrawide: "_1s8b37j1yx" }, defaultClass: "_1s8b37j1yt" }, "10rem": { conditions: { mobile: "_1s8b37j1yy", tablet: "_1s8b37j1yz", laptop: "_1s8b37j1z0", monitor: "_1s8b37j1z1", ultrawide: "_1s8b37j1z2" }, defaultClass: "_1s8b37j1yy" }, "12rem": { conditions: { mobile: "_1s8b37j1z3", tablet: "_1s8b37j1z4", laptop: "_1s8b37j1z5", monitor: "_1s8b37j1z6", ultrawide: "_1s8b37j1z7" }, defaultClass: "_1s8b37j1z3" }, "14rem": { conditions: { mobile: "_1s8b37j1z8", tablet: "_1s8b37j1z9", laptop: "_1s8b37j1za", monitor: "_1s8b37j1zb", ultrawide: "_1s8b37j1zc" }, defaultClass: "_1s8b37j1z8" }, "16rem": { conditions: { mobile: "_1s8b37j1zd", tablet: "_1s8b37j1ze", laptop: "_1s8b37j1zf", monitor: "_1s8b37j1zg", ultrawide: "_1s8b37j1zh" }, defaultClass: "_1s8b37j1zd" }, "18rem": { conditions: { mobile: "_1s8b37j1zi", tablet: "_1s8b37j1zj", laptop: "_1s8b37j1zk", monitor: "_1s8b37j1zl", ultrawide: "_1s8b37j1zm" }, defaultClass: "_1s8b37j1zi" }, "20rem": { conditions: { mobile: "_1s8b37j1zn", tablet: "_1s8b37j1zo", laptop: "_1s8b37j1zp", monitor: "_1s8b37j1zq", ultrawide: "_1s8b37j1zr" }, defaultClass: "_1s8b37j1zn" }, "25rem": { conditions: { mobile: "_1s8b37j1zs", tablet: "_1s8b37j1zt", laptop: "_1s8b37j1zu", monitor: "_1s8b37j1zv", ultrawide: "_1s8b37j1zw" }, defaultClass: "_1s8b37j1zs" }, "30rem": { conditions: { mobile: "_1s8b37j1zx", tablet: "_1s8b37j1zy", laptop: "_1s8b37j1zz", monitor: "_1s8b37j200", ultrawide: "_1s8b37j201" }, defaultClass: "_1s8b37j1zx" }, "35rem": { conditions: { mobile: "_1s8b37j202", tablet: "_1s8b37j203", laptop: "_1s8b37j204", monitor: "_1s8b37j205", ultrawide: "_1s8b37j206" }, defaultClass: "_1s8b37j202" }, "40rem": { conditions: { mobile: "_1s8b37j207", tablet: "_1s8b37j208", laptop: "_1s8b37j209", monitor: "_1s8b37j20a", ultrawide: "_1s8b37j20b" }, defaultClass: "_1s8b37j207" }, "45rem": { conditions: { mobile: "_1s8b37j20c", tablet: "_1s8b37j20d", laptop: "_1s8b37j20e", monitor: "_1s8b37j20f", ultrawide: "_1s8b37j20g" }, defaultClass: "_1s8b37j20c" }, "50rem": { conditions: { mobile: "_1s8b37j20h", tablet: "_1s8b37j20i", laptop: "_1s8b37j20j", monitor: "_1s8b37j20k", ultrawide: "_1s8b37j20l" }, defaultClass: "_1s8b37j20h" }, "16%": { conditions: { mobile: "_1s8b37j20m", tablet: "_1s8b37j20n", laptop: "_1s8b37j20o", monitor: "_1s8b37j20p", ultrawide: "_1s8b37j20q" }, defaultClass: "_1s8b37j20m" }, "20%": { conditions: { mobile: "_1s8b37j20r", tablet: "_1s8b37j20s", laptop: "_1s8b37j20t", monitor: "_1s8b37j20u", ultrawide: "_1s8b37j20v" }, defaultClass: "_1s8b37j20r" }, "25%": { conditions: { mobile: "_1s8b37j20w", tablet: "_1s8b37j20x", laptop: "_1s8b37j20y", monitor: "_1s8b37j20z", ultrawide: "_1s8b37j210" }, defaultClass: "_1s8b37j20w" }, "33%": { conditions: { mobile: "_1s8b37j211", tablet: "_1s8b37j212", laptop: "_1s8b37j213", monitor: "_1s8b37j214", ultrawide: "_1s8b37j215" }, defaultClass: "_1s8b37j211" }, "40%": { conditions: { mobile: "_1s8b37j216", tablet: "_1s8b37j217", laptop: "_1s8b37j218", monitor: "_1s8b37j219", ultrawide: "_1s8b37j21a" }, defaultClass: "_1s8b37j216" }, "50%": { conditions: { mobile: "_1s8b37j21b", tablet: "_1s8b37j21c", laptop: "_1s8b37j21d", monitor: "_1s8b37j21e", ultrawide: "_1s8b37j21f" }, defaultClass: "_1s8b37j21b" }, "60%": { conditions: { mobile: "_1s8b37j21g", tablet: "_1s8b37j21h", laptop: "_1s8b37j21i", monitor: "_1s8b37j21j", ultrawide: "_1s8b37j21k" }, defaultClass: "_1s8b37j21g" }, "66%": { conditions: { mobile: "_1s8b37j21l", tablet: "_1s8b37j21m", laptop: "_1s8b37j21n", monitor: "_1s8b37j21o", ultrawide: "_1s8b37j21p" }, defaultClass: "_1s8b37j21l" }, "75%": { conditions: { mobile: "_1s8b37j21q", tablet: "_1s8b37j21r", laptop: "_1s8b37j21s", monitor: "_1s8b37j21t", ultrawide: "_1s8b37j21u" }, defaultClass: "_1s8b37j21q" }, "80%": { conditions: { mobile: "_1s8b37j21v", tablet: "_1s8b37j21w", laptop: "_1s8b37j21x", monitor: "_1s8b37j21y", ultrawide: "_1s8b37j21z" }, defaultClass: "_1s8b37j21v" }, "83%": { conditions: { mobile: "_1s8b37j220", tablet: "_1s8b37j221", laptop: "_1s8b37j222", monitor: "_1s8b37j223", ultrawide: "_1s8b37j224" }, defaultClass: "_1s8b37j220" }, full: { conditions: { mobile: "_1s8b37j225", tablet: "_1s8b37j226", laptop: "_1s8b37j227", monitor: "_1s8b37j228", ultrawide: "_1s8b37j229" }, defaultClass: "_1s8b37j225" }, "min-content": { conditions: { mobile: "_1s8b37j22a", tablet: "_1s8b37j22b", laptop: "_1s8b37j22c", monitor: "_1s8b37j22d", ultrawide: "_1s8b37j22e" }, defaultClass: "_1s8b37j22a" }, "max-content": { conditions: { mobile: "_1s8b37j22f", tablet: "_1s8b37j22g", laptop: "_1s8b37j22h", monitor: "_1s8b37j22i", ultrawide: "_1s8b37j22j" }, defaultClass: "_1s8b37j22f" }, prose: { conditions: { mobile: "_1s8b37j22k", tablet: "_1s8b37j22l", laptop: "_1s8b37j22m", monitor: "_1s8b37j22n", ultrawide: "_1s8b37j22o" }, defaultClass: "_1s8b37j22k" } } }, minHeight: { values: { 0: { conditions: { mobile: "_1s8b37j22p", tablet: "_1s8b37j22q", laptop: "_1s8b37j22r", monitor: "_1s8b37j22s", ultrawide: "_1s8b37j22t" }, defaultClass: "_1s8b37j22p" }, full: { conditions: { mobile: "_1s8b37j22u", tablet: "_1s8b37j22v", laptop: "_1s8b37j22w", monitor: "_1s8b37j22x", ultrawide: "_1s8b37j22y" }, defaultClass: "_1s8b37j22u" } } }, minWidth: { values: { "0px": { conditions: { mobile: "_1s8b37j22z", tablet: "_1s8b37j230", laptop: "_1s8b37j231", monitor: "_1s8b37j232", ultrawide: "_1s8b37j233" }, defaultClass: "_1s8b37j22z" }, full: { conditions: { mobile: "_1s8b37j234", tablet: "_1s8b37j235", laptop: "_1s8b37j236", monitor: "_1s8b37j237", ultrawide: "_1s8b37j238" }, defaultClass: "_1s8b37j234" }, "min-content": { conditions: { mobile: "_1s8b37j239", tablet: "_1s8b37j23a", laptop: "_1s8b37j23b", monitor: "_1s8b37j23c", ultrawide: "_1s8b37j23d" }, defaultClass: "_1s8b37j239" }, "max-content": { conditions: { mobile: "_1s8b37j23e", tablet: "_1s8b37j23f", laptop: "_1s8b37j23g", monitor: "_1s8b37j23h", ultrawide: "_1s8b37j23i" }, defaultClass: "_1s8b37j23e" } } }, paddingBottom: { values: { auto: { conditions: { mobile: "_1s8b37j23j", tablet: "_1s8b37j23k", laptop: "_1s8b37j23l", monitor: "_1s8b37j23m", ultrawide: "_1s8b37j23n" }, defaultClass: "_1s8b37j23j" }, zero: { conditions: { mobile: "_1s8b37j23o", tablet: "_1s8b37j23p", laptop: "_1s8b37j23q", monitor: "_1s8b37j23r", ultrawide: "_1s8b37j23s" }, defaultClass: "_1s8b37j23o" }, xsmall: { conditions: { mobile: "_1s8b37j23t", tablet: "_1s8b37j23u", laptop: "_1s8b37j23v", monitor: "_1s8b37j23w", ultrawide: "_1s8b37j23x" }, defaultClass: "_1s8b37j23t" }, small: { conditions: { mobile: "_1s8b37j23y", tablet: "_1s8b37j23z", laptop: "_1s8b37j240", monitor: "_1s8b37j241", ultrawide: "_1s8b37j242" }, defaultClass: "_1s8b37j23y" }, smedium: { conditions: { mobile: "_1s8b37j243", tablet: "_1s8b37j244", laptop: "_1s8b37j245", monitor: "_1s8b37j246", ultrawide: "_1s8b37j247" }, defaultClass: "_1s8b37j243" }, default: { conditions: { mobile: "_1s8b37j248", tablet: "_1s8b37j249", laptop: "_1s8b37j24a", monitor: "_1s8b37j24b", ultrawide: "_1s8b37j24c" }, defaultClass: "_1s8b37j248" }, medium: { conditions: { mobile: "_1s8b37j24d", tablet: "_1s8b37j24e", laptop: "_1s8b37j24f", monitor: "_1s8b37j24g", ultrawide: "_1s8b37j24h" }, defaultClass: "_1s8b37j24d" }, large: { conditions: { mobile: "_1s8b37j24i", tablet: "_1s8b37j24j", laptop: "_1s8b37j24k", monitor: "_1s8b37j24l", ultrawide: "_1s8b37j24m" }, defaultClass: "_1s8b37j24i" }, xlarge: { conditions: { mobile: "_1s8b37j24n", tablet: "_1s8b37j24o", laptop: "_1s8b37j24p", monitor: "_1s8b37j24q", ultrawide: "_1s8b37j24r" }, defaultClass: "_1s8b37j24n" }, xxlarge: { conditions: { mobile: "_1s8b37j24s", tablet: "_1s8b37j24t", laptop: "_1s8b37j24u", monitor: "_1s8b37j24v", ultrawide: "_1s8b37j24w" }, defaultClass: "_1s8b37j24s" } } }, paddingLeft: { values: { auto: { conditions: { mobile: "_1s8b37j24x", tablet: "_1s8b37j24y", laptop: "_1s8b37j24z", monitor: "_1s8b37j250", ultrawide: "_1s8b37j251" }, defaultClass: "_1s8b37j24x" }, zero: { conditions: { mobile: "_1s8b37j252", tablet: "_1s8b37j253", laptop: "_1s8b37j254", monitor: "_1s8b37j255", ultrawide: "_1s8b37j256" }, defaultClass: "_1s8b37j252" }, xsmall: { conditions: { mobile: "_1s8b37j257", tablet: "_1s8b37j258", laptop: "_1s8b37j259", monitor: "_1s8b37j25a", ultrawide: "_1s8b37j25b" }, defaultClass: "_1s8b37j257" }, small: { conditions: { mobile: "_1s8b37j25c", tablet: "_1s8b37j25d", laptop: "_1s8b37j25e", monitor: "_1s8b37j25f", ultrawide: "_1s8b37j25g" }, defaultClass: "_1s8b37j25c" }, smedium: { conditions: { mobile: "_1s8b37j25h", tablet: "_1s8b37j25i", laptop: "_1s8b37j25j", monitor: "_1s8b37j25k", ultrawide: "_1s8b37j25l" }, defaultClass: "_1s8b37j25h" }, default: { conditions: { mobile: "_1s8b37j25m", tablet: "_1s8b37j25n", laptop: "_1s8b37j25o", monitor: "_1s8b37j25p", ultrawide: "_1s8b37j25q" }, defaultClass: "_1s8b37j25m" }, medium: { conditions: { mobile: "_1s8b37j25r", tablet: "_1s8b37j25s", laptop: "_1s8b37j25t", monitor: "_1s8b37j25u", ultrawide: "_1s8b37j25v" }, defaultClass: "_1s8b37j25r" }, large: { conditions: { mobile: "_1s8b37j25w", tablet: "_1s8b37j25x", laptop: "_1s8b37j25y", monitor: "_1s8b37j25z", ultrawide: "_1s8b37j260" }, defaultClass: "_1s8b37j25w" }, xlarge: { conditions: { mobile: "_1s8b37j261", tablet: "_1s8b37j262", laptop: "_1s8b37j263", monitor: "_1s8b37j264", ultrawide: "_1s8b37j265" }, defaultClass: "_1s8b37j261" }, xxlarge: { conditions: { mobile: "_1s8b37j266", tablet: "_1s8b37j267", laptop: "_1s8b37j268", monitor: "_1s8b37j269", ultrawide: "_1s8b37j26a" }, defaultClass: "_1s8b37j266" } } }, paddingRight: { values: { auto: { conditions: { mobile: "_1s8b37j26b", tablet: "_1s8b37j26c", laptop: "_1s8b37j26d", monitor: "_1s8b37j26e", ultrawide: "_1s8b37j26f" }, defaultClass: "_1s8b37j26b" }, zero: { conditions: { mobile: "_1s8b37j26g", tablet: "_1s8b37j26h", laptop: "_1s8b37j26i", monitor: "_1s8b37j26j", ultrawide: "_1s8b37j26k" }, defaultClass: "_1s8b37j26g" }, xsmall: { conditions: { mobile: "_1s8b37j26l", tablet: "_1s8b37j26m", laptop: "_1s8b37j26n", monitor: "_1s8b37j26o", ultrawide: "_1s8b37j26p" }, defaultClass: "_1s8b37j26l" }, small: { conditions: { mobile: "_1s8b37j26q", tablet: "_1s8b37j26r", laptop: "_1s8b37j26s", monitor: "_1s8b37j26t", ultrawide: "_1s8b37j26u" }, defaultClass: "_1s8b37j26q" }, smedium: { conditions: { mobile: "_1s8b37j26v", tablet: "_1s8b37j26w", laptop: "_1s8b37j26x", monitor: "_1s8b37j26y", ultrawide: "_1s8b37j26z" }, defaultClass: "_1s8b37j26v" }, default: { conditions: { mobile: "_1s8b37j270", tablet: "_1s8b37j271", laptop: "_1s8b37j272", monitor: "_1s8b37j273", ultrawide: "_1s8b37j274" }, defaultClass: "_1s8b37j270" }, medium: { conditions: { mobile: "_1s8b37j275", tablet: "_1s8b37j276", laptop: "_1s8b37j277", monitor: "_1s8b37j278", ultrawide: "_1s8b37j279" }, defaultClass: "_1s8b37j275" }, large: { conditions: { mobile: "_1s8b37j27a", tablet: "_1s8b37j27b", laptop: "_1s8b37j27c", monitor: "_1s8b37j27d", ultrawide: "_1s8b37j27e" }, defaultClass: "_1s8b37j27a" }, xlarge: { conditions: { mobile: "_1s8b37j27f", tablet: "_1s8b37j27g", laptop: "_1s8b37j27h", monitor: "_1s8b37j27i", ultrawide: "_1s8b37j27j" }, defaultClass: "_1s8b37j27f" }, xxlarge: { conditions: { mobile: "_1s8b37j27k", tablet: "_1s8b37j27l", laptop: "_1s8b37j27m", monitor: "_1s8b37j27n", ultrawide: "_1s8b37j27o" }, defaultClass: "_1s8b37j27k" } } }, paddingTop: { values: { auto: { conditions: { mobile: "_1s8b37j27p", tablet: "_1s8b37j27q", laptop: "_1s8b37j27r", monitor: "_1s8b37j27s", ultrawide: "_1s8b37j27t" }, defaultClass: "_1s8b37j27p" }, zero: { conditions: { mobile: "_1s8b37j27u", tablet: "_1s8b37j27v", laptop: "_1s8b37j27w", monitor: "_1s8b37j27x", ultrawide: "_1s8b37j27y" }, defaultClass: "_1s8b37j27u" }, xsmall: { conditions: { mobile: "_1s8b37j27z", tablet: "_1s8b37j280", laptop: "_1s8b37j281", monitor: "_1s8b37j282", ultrawide: "_1s8b37j283" }, defaultClass: "_1s8b37j27z" }, small: { conditions: { mobile: "_1s8b37j284", tablet: "_1s8b37j285", laptop: "_1s8b37j286", monitor: "_1s8b37j287", ultrawide: "_1s8b37j288" }, defaultClass: "_1s8b37j284" }, smedium: { conditions: { mobile: "_1s8b37j289", tablet: "_1s8b37j28a", laptop: "_1s8b37j28b", monitor: "_1s8b37j28c", ultrawide: "_1s8b37j28d" }, defaultClass: "_1s8b37j289" }, default: { conditions: { mobile: "_1s8b37j28e", tablet: "_1s8b37j28f", laptop: "_1s8b37j28g", monitor: "_1s8b37j28h", ultrawide: "_1s8b37j28i" }, defaultClass: "_1s8b37j28e" }, medium: { conditions: { mobile: "_1s8b37j28j", tablet: "_1s8b37j28k", laptop: "_1s8b37j28l", monitor: "_1s8b37j28m", ultrawide: "_1s8b37j28n" }, defaultClass: "_1s8b37j28j" }, large: { conditions: { mobile: "_1s8b37j28o", tablet: "_1s8b37j28p", laptop: "_1s8b37j28q", monitor: "_1s8b37j28r", ultrawide: "_1s8b37j28s" }, defaultClass: "_1s8b37j28o" }, xlarge: { conditions: { mobile: "_1s8b37j28t", tablet: "_1s8b37j28u", laptop: "_1s8b37j28v", monitor: "_1s8b37j28w", ultrawide: "_1s8b37j28x" }, defaultClass: "_1s8b37j28t" }, xxlarge: { conditions: { mobile: "_1s8b37j28y", tablet: "_1s8b37j28z", laptop: "_1s8b37j290", monitor: "_1s8b37j291", ultrawide: "_1s8b37j292" }, defaultClass: "_1s8b37j28y" } } }, position: { values: { absolute: { conditions: { mobile: "_1s8b37j293", tablet: "_1s8b37j294", laptop: "_1s8b37j295", monitor: "_1s8b37j296", ultrawide: "_1s8b37j297" }, defaultClass: "_1s8b37j293" }, fixed: { conditions: { mobile: "_1s8b37j298", tablet: "_1s8b37j299", laptop: "_1s8b37j29a", monitor: "_1s8b37j29b", ultrawide: "_1s8b37j29c" }, defaultClass: "_1s8b37j298" }, relative: { conditions: { mobile: "_1s8b37j29d", tablet: "_1s8b37j29e", laptop: "_1s8b37j29f", monitor: "_1s8b37j29g", ultrawide: "_1s8b37j29h" }, defaultClass: "_1s8b37j29d" }, static: { conditions: { mobile: "_1s8b37j29i", tablet: "_1s8b37j29j", laptop: "_1s8b37j29k", monitor: "_1s8b37j29l", ultrawide: "_1s8b37j29m" }, defaultClass: "_1s8b37j29i" }, sticky: { conditions: { mobile: "_1s8b37j29n", tablet: "_1s8b37j29o", laptop: "_1s8b37j29p", monitor: "_1s8b37j29q", ultrawide: "_1s8b37j29r" }, defaultClass: "_1s8b37j29n" } } }, right: { values: { 0: { conditions: { mobile: "_1s8b37j29s", tablet: "_1s8b37j29t", laptop: "_1s8b37j29u", monitor: "_1s8b37j29v", ultrawide: "_1s8b37j29w" }, defaultClass: "_1s8b37j29s" }, "0.25rem": { conditions: { mobile: "_1s8b37j29x", tablet: "_1s8b37j29y", laptop: "_1s8b37j29z", monitor: "_1s8b37j2a0", ultrawide: "_1s8b37j2a1" }, defaultClass: "_1s8b37j29x" }, "0.5rem": { conditions: { mobile: "_1s8b37j2a2", tablet: "_1s8b37j2a3", laptop: "_1s8b37j2a4", monitor: "_1s8b37j2a5", ultrawide: "_1s8b37j2a6" }, defaultClass: "_1s8b37j2a2" }, "0.75rem": { conditions: { mobile: "_1s8b37j2a7", tablet: "_1s8b37j2a8", laptop: "_1s8b37j2a9", monitor: "_1s8b37j2aa", ultrawide: "_1s8b37j2ab" }, defaultClass: "_1s8b37j2a7" }, "1rem": { conditions: { mobile: "_1s8b37j2ac", tablet: "_1s8b37j2ad", laptop: "_1s8b37j2ae", monitor: "_1s8b37j2af", ultrawide: "_1s8b37j2ag" }, defaultClass: "_1s8b37j2ac" }, "1.25rem": { conditions: { mobile: "_1s8b37j2ah", tablet: "_1s8b37j2ai", laptop: "_1s8b37j2aj", monitor: "_1s8b37j2ak", ultrawide: "_1s8b37j2al" }, defaultClass: "_1s8b37j2ah" }, "1.5rem": { conditions: { mobile: "_1s8b37j2am", tablet: "_1s8b37j2an", laptop: "_1s8b37j2ao", monitor: "_1s8b37j2ap", ultrawide: "_1s8b37j2aq" }, defaultClass: "_1s8b37j2am" }, "1.75rem": { conditions: { mobile: "_1s8b37j2ar", tablet: "_1s8b37j2as", laptop: "_1s8b37j2at", monitor: "_1s8b37j2au", ultrawide: "_1s8b37j2av" }, defaultClass: "_1s8b37j2ar" }, "2rem": { conditions: { mobile: "_1s8b37j2aw", tablet: "_1s8b37j2ax", laptop: "_1s8b37j2ay", monitor: "_1s8b37j2az", ultrawide: "_1s8b37j2b0" }, defaultClass: "_1s8b37j2aw" }, "2.25rem": { conditions: { mobile: "_1s8b37j2b1", tablet: "_1s8b37j2b2", laptop: "_1s8b37j2b3", monitor: "_1s8b37j2b4", ultrawide: "_1s8b37j2b5" }, defaultClass: "_1s8b37j2b1" }, "2.5rem": { conditions: { mobile: "_1s8b37j2b6", tablet: "_1s8b37j2b7", laptop: "_1s8b37j2b8", monitor: "_1s8b37j2b9", ultrawide: "_1s8b37j2ba" }, defaultClass: "_1s8b37j2b6" }, "2.75rem": { conditions: { mobile: "_1s8b37j2bb", tablet: "_1s8b37j2bc", laptop: "_1s8b37j2bd", monitor: "_1s8b37j2be", ultrawide: "_1s8b37j2bf" }, defaultClass: "_1s8b37j2bb" }, "3rem": { conditions: { mobile: "_1s8b37j2bg", tablet: "_1s8b37j2bh", laptop: "_1s8b37j2bi", monitor: "_1s8b37j2bj", ultrawide: "_1s8b37j2bk" }, defaultClass: "_1s8b37j2bg" }, "3.25rem": { conditions: { mobile: "_1s8b37j2bl", tablet: "_1s8b37j2bm", laptop: "_1s8b37j2bn", monitor: "_1s8b37j2bo", ultrawide: "_1s8b37j2bp" }, defaultClass: "_1s8b37j2bl" }, "3.5rem": { conditions: { mobile: "_1s8b37j2bq", tablet: "_1s8b37j2br", laptop: "_1s8b37j2bs", monitor: "_1s8b37j2bt", ultrawide: "_1s8b37j2bu" }, defaultClass: "_1s8b37j2bq" }, "3.75rem": { conditions: { mobile: "_1s8b37j2bv", tablet: "_1s8b37j2bw", laptop: "_1s8b37j2bx", monitor: "_1s8b37j2by", ultrawide: "_1s8b37j2bz" }, defaultClass: "_1s8b37j2bv" }, "4rem": { conditions: { mobile: "_1s8b37j2c0", tablet: "_1s8b37j2c1", laptop: "_1s8b37j2c2", monitor: "_1s8b37j2c3", ultrawide: "_1s8b37j2c4" }, defaultClass: "_1s8b37j2c0" }, "4.25rem": { conditions: { mobile: "_1s8b37j2c5", tablet: "_1s8b37j2c6", laptop: "_1s8b37j2c7", monitor: "_1s8b37j2c8", ultrawide: "_1s8b37j2c9" }, defaultClass: "_1s8b37j2c5" }, "4.5rem": { conditions: { mobile: "_1s8b37j2ca", tablet: "_1s8b37j2cb", laptop: "_1s8b37j2cc", monitor: "_1s8b37j2cd", ultrawide: "_1s8b37j2ce" }, defaultClass: "_1s8b37j2ca" }, "4.75rem": { conditions: { mobile: "_1s8b37j2cf", tablet: "_1s8b37j2cg", laptop: "_1s8b37j2ch", monitor: "_1s8b37j2ci", ultrawide: "_1s8b37j2cj" }, defaultClass: "_1s8b37j2cf" }, "5rem": { conditions: { mobile: "_1s8b37j2ck", tablet: "_1s8b37j2cl", laptop: "_1s8b37j2cm", monitor: "_1s8b37j2cn", ultrawide: "_1s8b37j2co" }, defaultClass: "_1s8b37j2ck" }, "5.25rem": { conditions: { mobile: "_1s8b37j2cp", tablet: "_1s8b37j2cq", laptop: "_1s8b37j2cr", monitor: "_1s8b37j2cs", ultrawide: "_1s8b37j2ct" }, defaultClass: "_1s8b37j2cp" }, "5.5rem": { conditions: { mobile: "_1s8b37j2cu", tablet: "_1s8b37j2cv", laptop: "_1s8b37j2cw", monitor: "_1s8b37j2cx", ultrawide: "_1s8b37j2cy" }, defaultClass: "_1s8b37j2cu" }, "5.75rem": { conditions: { mobile: "_1s8b37j2cz", tablet: "_1s8b37j2d0", laptop: "_1s8b37j2d1", monitor: "_1s8b37j2d2", ultrawide: "_1s8b37j2d3" }, defaultClass: "_1s8b37j2cz" }, "6rem": { conditions: { mobile: "_1s8b37j2d4", tablet: "_1s8b37j2d5", laptop: "_1s8b37j2d6", monitor: "_1s8b37j2d7", ultrawide: "_1s8b37j2d8" }, defaultClass: "_1s8b37j2d4" }, "7rem": { conditions: { mobile: "_1s8b37j2d9", tablet: "_1s8b37j2da", laptop: "_1s8b37j2db", monitor: "_1s8b37j2dc", ultrawide: "_1s8b37j2dd" }, defaultClass: "_1s8b37j2d9" }, "8rem": { conditions: { mobile: "_1s8b37j2de", tablet: "_1s8b37j2df", laptop: "_1s8b37j2dg", monitor: "_1s8b37j2dh", ultrawide: "_1s8b37j2di" }, defaultClass: "_1s8b37j2de" }, "9rem": { conditions: { mobile: "_1s8b37j2dj", tablet: "_1s8b37j2dk", laptop: "_1s8b37j2dl", monitor: "_1s8b37j2dm", ultrawide: "_1s8b37j2dn" }, defaultClass: "_1s8b37j2dj" }, "10rem": { conditions: { mobile: "_1s8b37j2do", tablet: "_1s8b37j2dp", laptop: "_1s8b37j2dq", monitor: "_1s8b37j2dr", ultrawide: "_1s8b37j2ds" }, defaultClass: "_1s8b37j2do" }, "12rem": { conditions: { mobile: "_1s8b37j2dt", tablet: "_1s8b37j2du", laptop: "_1s8b37j2dv", monitor: "_1s8b37j2dw", ultrawide: "_1s8b37j2dx" }, defaultClass: "_1s8b37j2dt" }, "14rem": { conditions: { mobile: "_1s8b37j2dy", tablet: "_1s8b37j2dz", laptop: "_1s8b37j2e0", monitor: "_1s8b37j2e1", ultrawide: "_1s8b37j2e2" }, defaultClass: "_1s8b37j2dy" }, "16rem": { conditions: { mobile: "_1s8b37j2e3", tablet: "_1s8b37j2e4", laptop: "_1s8b37j2e5", monitor: "_1s8b37j2e6", ultrawide: "_1s8b37j2e7" }, defaultClass: "_1s8b37j2e3" }, "18rem": { conditions: { mobile: "_1s8b37j2e8", tablet: "_1s8b37j2e9", laptop: "_1s8b37j2ea", monitor: "_1s8b37j2eb", ultrawide: "_1s8b37j2ec" }, defaultClass: "_1s8b37j2e8" }, "20rem": { conditions: { mobile: "_1s8b37j2ed", tablet: "_1s8b37j2ee", laptop: "_1s8b37j2ef", monitor: "_1s8b37j2eg", ultrawide: "_1s8b37j2eh" }, defaultClass: "_1s8b37j2ed" }, "25rem": { conditions: { mobile: "_1s8b37j2ei", tablet: "_1s8b37j2ej", laptop: "_1s8b37j2ek", monitor: "_1s8b37j2el", ultrawide: "_1s8b37j2em" }, defaultClass: "_1s8b37j2ei" }, "30rem": { conditions: { mobile: "_1s8b37j2en", tablet: "_1s8b37j2eo", laptop: "_1s8b37j2ep", monitor: "_1s8b37j2eq", ultrawide: "_1s8b37j2er" }, defaultClass: "_1s8b37j2en" }, "35rem": { conditions: { mobile: "_1s8b37j2es", tablet: "_1s8b37j2et", laptop: "_1s8b37j2eu", monitor: "_1s8b37j2ev", ultrawide: "_1s8b37j2ew" }, defaultClass: "_1s8b37j2es" }, "40rem": { conditions: { mobile: "_1s8b37j2ex", tablet: "_1s8b37j2ey", laptop: "_1s8b37j2ez", monitor: "_1s8b37j2f0", ultrawide: "_1s8b37j2f1" }, defaultClass: "_1s8b37j2ex" }, "45rem": { conditions: { mobile: "_1s8b37j2f2", tablet: "_1s8b37j2f3", laptop: "_1s8b37j2f4", monitor: "_1s8b37j2f5", ultrawide: "_1s8b37j2f6" }, defaultClass: "_1s8b37j2f2" }, "50rem": { conditions: { mobile: "_1s8b37j2f7", tablet: "_1s8b37j2f8", laptop: "_1s8b37j2f9", monitor: "_1s8b37j2fa", ultrawide: "_1s8b37j2fb" }, defaultClass: "_1s8b37j2f7" }, "16%": { conditions: { mobile: "_1s8b37j2fc", tablet: "_1s8b37j2fd", laptop: "_1s8b37j2fe", monitor: "_1s8b37j2ff", ultrawide: "_1s8b37j2fg" }, defaultClass: "_1s8b37j2fc" }, "20%": { conditions: { mobile: "_1s8b37j2fh", tablet: "_1s8b37j2fi", laptop: "_1s8b37j2fj", monitor: "_1s8b37j2fk", ultrawide: "_1s8b37j2fl" }, defaultClass: "_1s8b37j2fh" }, "25%": { conditions: { mobile: "_1s8b37j2fm", tablet: "_1s8b37j2fn", laptop: "_1s8b37j2fo", monitor: "_1s8b37j2fp", ultrawide: "_1s8b37j2fq" }, defaultClass: "_1s8b37j2fm" }, "33%": { conditions: { mobile: "_1s8b37j2fr", tablet: "_1s8b37j2fs", laptop: "_1s8b37j2ft", monitor: "_1s8b37j2fu", ultrawide: "_1s8b37j2fv" }, defaultClass: "_1s8b37j2fr" }, "40%": { conditions: { mobile: "_1s8b37j2fw", tablet: "_1s8b37j2fx", laptop: "_1s8b37j2fy", monitor: "_1s8b37j2fz", ultrawide: "_1s8b37j2g0" }, defaultClass: "_1s8b37j2fw" }, "50%": { conditions: { mobile: "_1s8b37j2g1", tablet: "_1s8b37j2g2", laptop: "_1s8b37j2g3", monitor: "_1s8b37j2g4", ultrawide: "_1s8b37j2g5" }, defaultClass: "_1s8b37j2g1" }, "60%": { conditions: { mobile: "_1s8b37j2g6", tablet: "_1s8b37j2g7", laptop: "_1s8b37j2g8", monitor: "_1s8b37j2g9", ultrawide: "_1s8b37j2ga" }, defaultClass: "_1s8b37j2g6" }, "66%": { conditions: { mobile: "_1s8b37j2gb", tablet: "_1s8b37j2gc", laptop: "_1s8b37j2gd", monitor: "_1s8b37j2ge", ultrawide: "_1s8b37j2gf" }, defaultClass: "_1s8b37j2gb" }, "75%": { conditions: { mobile: "_1s8b37j2gg", tablet: "_1s8b37j2gh", laptop: "_1s8b37j2gi", monitor: "_1s8b37j2gj", ultrawide: "_1s8b37j2gk" }, defaultClass: "_1s8b37j2gg" }, "80%": { conditions: { mobile: "_1s8b37j2gl", tablet: "_1s8b37j2gm", laptop: "_1s8b37j2gn", monitor: "_1s8b37j2go", ultrawide: "_1s8b37j2gp" }, defaultClass: "_1s8b37j2gl" }, "83%": { conditions: { mobile: "_1s8b37j2gq", tablet: "_1s8b37j2gr", laptop: "_1s8b37j2gs", monitor: "_1s8b37j2gt", ultrawide: "_1s8b37j2gu" }, defaultClass: "_1s8b37j2gq" }, full: { conditions: { mobile: "_1s8b37j2gv", tablet: "_1s8b37j2gw", laptop: "_1s8b37j2gx", monitor: "_1s8b37j2gy", ultrawide: "_1s8b37j2gz" }, defaultClass: "_1s8b37j2gv" } } }, textAlign: { values: { center: { conditions: { mobile: "_1s8b37j2h0", tablet: "_1s8b37j2h1", laptop: "_1s8b37j2h2", monitor: "_1s8b37j2h3", ultrawide: "_1s8b37j2h4" }, defaultClass: "_1s8b37j2h0" }, left: { conditions: { mobile: "_1s8b37j2h5", tablet: "_1s8b37j2h6", laptop: "_1s8b37j2h7", monitor: "_1s8b37j2h8", ultrawide: "_1s8b37j2h9" }, defaultClass: "_1s8b37j2h5" }, right: { conditions: { mobile: "_1s8b37j2ha", tablet: "_1s8b37j2hb", laptop: "_1s8b37j2hc", monitor: "_1s8b37j2hd", ultrawide: "_1s8b37j2he" }, defaultClass: "_1s8b37j2ha" } } }, top: { values: { 0: { conditions: { mobile: "_1s8b37j2hf", tablet: "_1s8b37j2hg", laptop: "_1s8b37j2hh", monitor: "_1s8b37j2hi", ultrawide: "_1s8b37j2hj" }, defaultClass: "_1s8b37j2hf" }, "0.25rem": { conditions: { mobile: "_1s8b37j2hk", tablet: "_1s8b37j2hl", laptop: "_1s8b37j2hm", monitor: "_1s8b37j2hn", ultrawide: "_1s8b37j2ho" }, defaultClass: "_1s8b37j2hk" }, "0.5rem": { conditions: { mobile: "_1s8b37j2hp", tablet: "_1s8b37j2hq", laptop: "_1s8b37j2hr", monitor: "_1s8b37j2hs", ultrawide: "_1s8b37j2ht" }, defaultClass: "_1s8b37j2hp" }, "0.75rem": { conditions: { mobile: "_1s8b37j2hu", tablet: "_1s8b37j2hv", laptop: "_1s8b37j2hw", monitor: "_1s8b37j2hx", ultrawide: "_1s8b37j2hy" }, defaultClass: "_1s8b37j2hu" }, "1rem": { conditions: { mobile: "_1s8b37j2hz", tablet: "_1s8b37j2i0", laptop: "_1s8b37j2i1", monitor: "_1s8b37j2i2", ultrawide: "_1s8b37j2i3" }, defaultClass: "_1s8b37j2hz" }, "1.25rem": { conditions: { mobile: "_1s8b37j2i4", tablet: "_1s8b37j2i5", laptop: "_1s8b37j2i6", monitor: "_1s8b37j2i7", ultrawide: "_1s8b37j2i8" }, defaultClass: "_1s8b37j2i4" }, "1.5rem": { conditions: { mobile: "_1s8b37j2i9", tablet: "_1s8b37j2ia", laptop: "_1s8b37j2ib", monitor: "_1s8b37j2ic", ultrawide: "_1s8b37j2id" }, defaultClass: "_1s8b37j2i9" }, "1.75rem": { conditions: { mobile: "_1s8b37j2ie", tablet: "_1s8b37j2if", laptop: "_1s8b37j2ig", monitor: "_1s8b37j2ih", ultrawide: "_1s8b37j2ii" }, defaultClass: "_1s8b37j2ie" }, "2rem": { conditions: { mobile: "_1s8b37j2ij", tablet: "_1s8b37j2ik", laptop: "_1s8b37j2il", monitor: "_1s8b37j2im", ultrawide: "_1s8b37j2in" }, defaultClass: "_1s8b37j2ij" }, "2.25rem": { conditions: { mobile: "_1s8b37j2io", tablet: "_1s8b37j2ip", laptop: "_1s8b37j2iq", monitor: "_1s8b37j2ir", ultrawide: "_1s8b37j2is" }, defaultClass: "_1s8b37j2io" }, "2.5rem": { conditions: { mobile: "_1s8b37j2it", tablet: "_1s8b37j2iu", laptop: "_1s8b37j2iv", monitor: "_1s8b37j2iw", ultrawide: "_1s8b37j2ix" }, defaultClass: "_1s8b37j2it" }, "2.75rem": { conditions: { mobile: "_1s8b37j2iy", tablet: "_1s8b37j2iz", laptop: "_1s8b37j2j0", monitor: "_1s8b37j2j1", ultrawide: "_1s8b37j2j2" }, defaultClass: "_1s8b37j2iy" }, "3rem": { conditions: { mobile: "_1s8b37j2j3", tablet: "_1s8b37j2j4", laptop: "_1s8b37j2j5", monitor: "_1s8b37j2j6", ultrawide: "_1s8b37j2j7" }, defaultClass: "_1s8b37j2j3" }, "3.25rem": { conditions: { mobile: "_1s8b37j2j8", tablet: "_1s8b37j2j9", laptop: "_1s8b37j2ja", monitor: "_1s8b37j2jb", ultrawide: "_1s8b37j2jc" }, defaultClass: "_1s8b37j2j8" }, "3.5rem": { conditions: { mobile: "_1s8b37j2jd", tablet: "_1s8b37j2je", laptop: "_1s8b37j2jf", monitor: "_1s8b37j2jg", ultrawide: "_1s8b37j2jh" }, defaultClass: "_1s8b37j2jd" }, "3.75rem": { conditions: { mobile: "_1s8b37j2ji", tablet: "_1s8b37j2jj", laptop: "_1s8b37j2jk", monitor: "_1s8b37j2jl", ultrawide: "_1s8b37j2jm" }, defaultClass: "_1s8b37j2ji" }, "4rem": { conditions: { mobile: "_1s8b37j2jn", tablet: "_1s8b37j2jo", laptop: "_1s8b37j2jp", monitor: "_1s8b37j2jq", ultrawide: "_1s8b37j2jr" }, defaultClass: "_1s8b37j2jn" }, "4.25rem": { conditions: { mobile: "_1s8b37j2js", tablet: "_1s8b37j2jt", laptop: "_1s8b37j2ju", monitor: "_1s8b37j2jv", ultrawide: "_1s8b37j2jw" }, defaultClass: "_1s8b37j2js" }, "4.5rem": { conditions: { mobile: "_1s8b37j2jx", tablet: "_1s8b37j2jy", laptop: "_1s8b37j2jz", monitor: "_1s8b37j2k0", ultrawide: "_1s8b37j2k1" }, defaultClass: "_1s8b37j2jx" }, "4.75rem": { conditions: { mobile: "_1s8b37j2k2", tablet: "_1s8b37j2k3", laptop: "_1s8b37j2k4", monitor: "_1s8b37j2k5", ultrawide: "_1s8b37j2k6" }, defaultClass: "_1s8b37j2k2" }, "5rem": { conditions: { mobile: "_1s8b37j2k7", tablet: "_1s8b37j2k8", laptop: "_1s8b37j2k9", monitor: "_1s8b37j2ka", ultrawide: "_1s8b37j2kb" }, defaultClass: "_1s8b37j2k7" }, "5.25rem": { conditions: { mobile: "_1s8b37j2kc", tablet: "_1s8b37j2kd", laptop: "_1s8b37j2ke", monitor: "_1s8b37j2kf", ultrawide: "_1s8b37j2kg" }, defaultClass: "_1s8b37j2kc" }, "5.5rem": { conditions: { mobile: "_1s8b37j2kh", tablet: "_1s8b37j2ki", laptop: "_1s8b37j2kj", monitor: "_1s8b37j2kk", ultrawide: "_1s8b37j2kl" }, defaultClass: "_1s8b37j2kh" }, "5.75rem": { conditions: { mobile: "_1s8b37j2km", tablet: "_1s8b37j2kn", laptop: "_1s8b37j2ko", monitor: "_1s8b37j2kp", ultrawide: "_1s8b37j2kq" }, defaultClass: "_1s8b37j2km" }, "6rem": { conditions: { mobile: "_1s8b37j2kr", tablet: "_1s8b37j2ks", laptop: "_1s8b37j2kt", monitor: "_1s8b37j2ku", ultrawide: "_1s8b37j2kv" }, defaultClass: "_1s8b37j2kr" }, "7rem": { conditions: { mobile: "_1s8b37j2kw", tablet: "_1s8b37j2kx", laptop: "_1s8b37j2ky", monitor: "_1s8b37j2kz", ultrawide: "_1s8b37j2l0" }, defaultClass: "_1s8b37j2kw" }, "8rem": { conditions: { mobile: "_1s8b37j2l1", tablet: "_1s8b37j2l2", laptop: "_1s8b37j2l3", monitor: "_1s8b37j2l4", ultrawide: "_1s8b37j2l5" }, defaultClass: "_1s8b37j2l1" }, "9rem": { conditions: { mobile: "_1s8b37j2l6", tablet: "_1s8b37j2l7", laptop: "_1s8b37j2l8", monitor: "_1s8b37j2l9", ultrawide: "_1s8b37j2la" }, defaultClass: "_1s8b37j2l6" }, "10rem": { conditions: { mobile: "_1s8b37j2lb", tablet: "_1s8b37j2lc", laptop: "_1s8b37j2ld", monitor: "_1s8b37j2le", ultrawide: "_1s8b37j2lf" }, defaultClass: "_1s8b37j2lb" }, "12rem": { conditions: { mobile: "_1s8b37j2lg", tablet: "_1s8b37j2lh", laptop: "_1s8b37j2li", monitor: "_1s8b37j2lj", ultrawide: "_1s8b37j2lk" }, defaultClass: "_1s8b37j2lg" }, "14rem": { conditions: { mobile: "_1s8b37j2ll", tablet: "_1s8b37j2lm", laptop: "_1s8b37j2ln", monitor: "_1s8b37j2lo", ultrawide: "_1s8b37j2lp" }, defaultClass: "_1s8b37j2ll" }, "16rem": { conditions: { mobile: "_1s8b37j2lq", tablet: "_1s8b37j2lr", laptop: "_1s8b37j2ls", monitor: "_1s8b37j2lt", ultrawide: "_1s8b37j2lu" }, defaultClass: "_1s8b37j2lq" }, "18rem": { conditions: { mobile: "_1s8b37j2lv", tablet: "_1s8b37j2lw", laptop: "_1s8b37j2lx", monitor: "_1s8b37j2ly", ultrawide: "_1s8b37j2lz" }, defaultClass: "_1s8b37j2lv" }, "20rem": { conditions: { mobile: "_1s8b37j2m0", tablet: "_1s8b37j2m1", laptop: "_1s8b37j2m2", monitor: "_1s8b37j2m3", ultrawide: "_1s8b37j2m4" }, defaultClass: "_1s8b37j2m0" }, "25rem": { conditions: { mobile: "_1s8b37j2m5", tablet: "_1s8b37j2m6", laptop: "_1s8b37j2m7", monitor: "_1s8b37j2m8", ultrawide: "_1s8b37j2m9" }, defaultClass: "_1s8b37j2m5" }, "30rem": { conditions: { mobile: "_1s8b37j2ma", tablet: "_1s8b37j2mb", laptop: "_1s8b37j2mc", monitor: "_1s8b37j2md", ultrawide: "_1s8b37j2me" }, defaultClass: "_1s8b37j2ma" }, "35rem": { conditions: { mobile: "_1s8b37j2mf", tablet: "_1s8b37j2mg", laptop: "_1s8b37j2mh", monitor: "_1s8b37j2mi", ultrawide: "_1s8b37j2mj" }, defaultClass: "_1s8b37j2mf" }, "40rem": { conditions: { mobile: "_1s8b37j2mk", tablet: "_1s8b37j2ml", laptop: "_1s8b37j2mm", monitor: "_1s8b37j2mn", ultrawide: "_1s8b37j2mo" }, defaultClass: "_1s8b37j2mk" }, "45rem": { conditions: { mobile: "_1s8b37j2mp", tablet: "_1s8b37j2mq", laptop: "_1s8b37j2mr", monitor: "_1s8b37j2ms", ultrawide: "_1s8b37j2mt" }, defaultClass: "_1s8b37j2mp" }, "50rem": { conditions: { mobile: "_1s8b37j2mu", tablet: "_1s8b37j2mv", laptop: "_1s8b37j2mw", monitor: "_1s8b37j2mx", ultrawide: "_1s8b37j2my" }, defaultClass: "_1s8b37j2mu" }, "16%": { conditions: { mobile: "_1s8b37j2mz", tablet: "_1s8b37j2n0", laptop: "_1s8b37j2n1", monitor: "_1s8b37j2n2", ultrawide: "_1s8b37j2n3" }, defaultClass: "_1s8b37j2mz" }, "20%": { conditions: { mobile: "_1s8b37j2n4", tablet: "_1s8b37j2n5", laptop: "_1s8b37j2n6", monitor: "_1s8b37j2n7", ultrawide: "_1s8b37j2n8" }, defaultClass: "_1s8b37j2n4" }, "25%": { conditions: { mobile: "_1s8b37j2n9", tablet: "_1s8b37j2na", laptop: "_1s8b37j2nb", monitor: "_1s8b37j2nc", ultrawide: "_1s8b37j2nd" }, defaultClass: "_1s8b37j2n9" }, "33%": { conditions: { mobile: "_1s8b37j2ne", tablet: "_1s8b37j2nf", laptop: "_1s8b37j2ng", monitor: "_1s8b37j2nh", ultrawide: "_1s8b37j2ni" }, defaultClass: "_1s8b37j2ne" }, "40%": { conditions: { mobile: "_1s8b37j2nj", tablet: "_1s8b37j2nk", laptop: "_1s8b37j2nl", monitor: "_1s8b37j2nm", ultrawide: "_1s8b37j2nn" }, defaultClass: "_1s8b37j2nj" }, "50%": { conditions: { mobile: "_1s8b37j2no", tablet: "_1s8b37j2np", laptop: "_1s8b37j2nq", monitor: "_1s8b37j2nr", ultrawide: "_1s8b37j2ns" }, defaultClass: "_1s8b37j2no" }, "60%": { conditions: { mobile: "_1s8b37j2nt", tablet: "_1s8b37j2nu", laptop: "_1s8b37j2nv", monitor: "_1s8b37j2nw", ultrawide: "_1s8b37j2nx" }, defaultClass: "_1s8b37j2nt" }, "66%": { conditions: { mobile: "_1s8b37j2ny", tablet: "_1s8b37j2nz", laptop: "_1s8b37j2o0", monitor: "_1s8b37j2o1", ultrawide: "_1s8b37j2o2" }, defaultClass: "_1s8b37j2ny" }, "75%": { conditions: { mobile: "_1s8b37j2o3", tablet: "_1s8b37j2o4", laptop: "_1s8b37j2o5", monitor: "_1s8b37j2o6", ultrawide: "_1s8b37j2o7" }, defaultClass: "_1s8b37j2o3" }, "80%": { conditions: { mobile: "_1s8b37j2o8", tablet: "_1s8b37j2o9", laptop: "_1s8b37j2oa", monitor: "_1s8b37j2ob", ultrawide: "_1s8b37j2oc" }, defaultClass: "_1s8b37j2o8" }, "83%": { conditions: { mobile: "_1s8b37j2od", tablet: "_1s8b37j2oe", laptop: "_1s8b37j2of", monitor: "_1s8b37j2og", ultrawide: "_1s8b37j2oh" }, defaultClass: "_1s8b37j2od" }, full: { conditions: { mobile: "_1s8b37j2oi", tablet: "_1s8b37j2oj", laptop: "_1s8b37j2ok", monitor: "_1s8b37j2ol", ultrawide: "_1s8b37j2om" }, defaultClass: "_1s8b37j2oi" } } }, width: { values: { 0: { conditions: { mobile: "_1s8b37j2on", tablet: "_1s8b37j2oo", laptop: "_1s8b37j2op", monitor: "_1s8b37j2oq", ultrawide: "_1s8b37j2or" }, defaultClass: "_1s8b37j2on" }, "0.25rem": { conditions: { mobile: "_1s8b37j2os", tablet: "_1s8b37j2ot", laptop: "_1s8b37j2ou", monitor: "_1s8b37j2ov", ultrawide: "_1s8b37j2ow" }, defaultClass: "_1s8b37j2os" }, "0.5rem": { conditions: { mobile: "_1s8b37j2ox", tablet: "_1s8b37j2oy", laptop: "_1s8b37j2oz", monitor: "_1s8b37j2p0", ultrawide: "_1s8b37j2p1" }, defaultClass: "_1s8b37j2ox" }, "0.75rem": { conditions: { mobile: "_1s8b37j2p2", tablet: "_1s8b37j2p3", laptop: "_1s8b37j2p4", monitor: "_1s8b37j2p5", ultrawide: "_1s8b37j2p6" }, defaultClass: "_1s8b37j2p2" }, "1rem": { conditions: { mobile: "_1s8b37j2p7", tablet: "_1s8b37j2p8", laptop: "_1s8b37j2p9", monitor: "_1s8b37j2pa", ultrawide: "_1s8b37j2pb" }, defaultClass: "_1s8b37j2p7" }, "1.25rem": { conditions: { mobile: "_1s8b37j2pc", tablet: "_1s8b37j2pd", laptop: "_1s8b37j2pe", monitor: "_1s8b37j2pf", ultrawide: "_1s8b37j2pg" }, defaultClass: "_1s8b37j2pc" }, "1.5rem": { conditions: { mobile: "_1s8b37j2ph", tablet: "_1s8b37j2pi", laptop: "_1s8b37j2pj", monitor: "_1s8b37j2pk", ultrawide: "_1s8b37j2pl" }, defaultClass: "_1s8b37j2ph" }, "1.75rem": { conditions: { mobile: "_1s8b37j2pm", tablet: "_1s8b37j2pn", laptop: "_1s8b37j2po", monitor: "_1s8b37j2pp", ultrawide: "_1s8b37j2pq" }, defaultClass: "_1s8b37j2pm" }, "2rem": { conditions: { mobile: "_1s8b37j2pr", tablet: "_1s8b37j2ps", laptop: "_1s8b37j2pt", monitor: "_1s8b37j2pu", ultrawide: "_1s8b37j2pv" }, defaultClass: "_1s8b37j2pr" }, "2.25rem": { conditions: { mobile: "_1s8b37j2pw", tablet: "_1s8b37j2px", laptop: "_1s8b37j2py", monitor: "_1s8b37j2pz", ultrawide: "_1s8b37j2q0" }, defaultClass: "_1s8b37j2pw" }, "2.5rem": { conditions: { mobile: "_1s8b37j2q1", tablet: "_1s8b37j2q2", laptop: "_1s8b37j2q3", monitor: "_1s8b37j2q4", ultrawide: "_1s8b37j2q5" }, defaultClass: "_1s8b37j2q1" }, "2.75rem": { conditions: { mobile: "_1s8b37j2q6", tablet: "_1s8b37j2q7", laptop: "_1s8b37j2q8", monitor: "_1s8b37j2q9", ultrawide: "_1s8b37j2qa" }, defaultClass: "_1s8b37j2q6" }, "3rem": { conditions: { mobile: "_1s8b37j2qb", tablet: "_1s8b37j2qc", laptop: "_1s8b37j2qd", monitor: "_1s8b37j2qe", ultrawide: "_1s8b37j2qf" }, defaultClass: "_1s8b37j2qb" }, "3.25rem": { conditions: { mobile: "_1s8b37j2qg", tablet: "_1s8b37j2qh", laptop: "_1s8b37j2qi", monitor: "_1s8b37j2qj", ultrawide: "_1s8b37j2qk" }, defaultClass: "_1s8b37j2qg" }, "3.5rem": { conditions: { mobile: "_1s8b37j2ql", tablet: "_1s8b37j2qm", laptop: "_1s8b37j2qn", monitor: "_1s8b37j2qo", ultrawide: "_1s8b37j2qp" }, defaultClass: "_1s8b37j2ql" }, "3.75rem": { conditions: { mobile: "_1s8b37j2qq", tablet: "_1s8b37j2qr", laptop: "_1s8b37j2qs", monitor: "_1s8b37j2qt", ultrawide: "_1s8b37j2qu" }, defaultClass: "_1s8b37j2qq" }, "4rem": { conditions: { mobile: "_1s8b37j2qv", tablet: "_1s8b37j2qw", laptop: "_1s8b37j2qx", monitor: "_1s8b37j2qy", ultrawide: "_1s8b37j2qz" }, defaultClass: "_1s8b37j2qv" }, "4.25rem": { conditions: { mobile: "_1s8b37j2r0", tablet: "_1s8b37j2r1", laptop: "_1s8b37j2r2", monitor: "_1s8b37j2r3", ultrawide: "_1s8b37j2r4" }, defaultClass: "_1s8b37j2r0" }, "4.5rem": { conditions: { mobile: "_1s8b37j2r5", tablet: "_1s8b37j2r6", laptop: "_1s8b37j2r7", monitor: "_1s8b37j2r8", ultrawide: "_1s8b37j2r9" }, defaultClass: "_1s8b37j2r5" }, "4.75rem": { conditions: { mobile: "_1s8b37j2ra", tablet: "_1s8b37j2rb", laptop: "_1s8b37j2rc", monitor: "_1s8b37j2rd", ultrawide: "_1s8b37j2re" }, defaultClass: "_1s8b37j2ra" }, "5rem": { conditions: { mobile: "_1s8b37j2rf", tablet: "_1s8b37j2rg", laptop: "_1s8b37j2rh", monitor: "_1s8b37j2ri", ultrawide: "_1s8b37j2rj" }, defaultClass: "_1s8b37j2rf" }, "5.25rem": { conditions: { mobile: "_1s8b37j2rk", tablet: "_1s8b37j2rl", laptop: "_1s8b37j2rm", monitor: "_1s8b37j2rn", ultrawide: "_1s8b37j2ro" }, defaultClass: "_1s8b37j2rk" }, "5.5rem": { conditions: { mobile: "_1s8b37j2rp", tablet: "_1s8b37j2rq", laptop: "_1s8b37j2rr", monitor: "_1s8b37j2rs", ultrawide: "_1s8b37j2rt" }, defaultClass: "_1s8b37j2rp" }, "5.75rem": { conditions: { mobile: "_1s8b37j2ru", tablet: "_1s8b37j2rv", laptop: "_1s8b37j2rw", monitor: "_1s8b37j2rx", ultrawide: "_1s8b37j2ry" }, defaultClass: "_1s8b37j2ru" }, "6rem": { conditions: { mobile: "_1s8b37j2rz", tablet: "_1s8b37j2s0", laptop: "_1s8b37j2s1", monitor: "_1s8b37j2s2", ultrawide: "_1s8b37j2s3" }, defaultClass: "_1s8b37j2rz" }, "7rem": { conditions: { mobile: "_1s8b37j2s4", tablet: "_1s8b37j2s5", laptop: "_1s8b37j2s6", monitor: "_1s8b37j2s7", ultrawide: "_1s8b37j2s8" }, defaultClass: "_1s8b37j2s4" }, "8rem": { conditions: { mobile: "_1s8b37j2s9", tablet: "_1s8b37j2sa", laptop: "_1s8b37j2sb", monitor: "_1s8b37j2sc", ultrawide: "_1s8b37j2sd" }, defaultClass: "_1s8b37j2s9" }, "9rem": { conditions: { mobile: "_1s8b37j2se", tablet: "_1s8b37j2sf", laptop: "_1s8b37j2sg", monitor: "_1s8b37j2sh", ultrawide: "_1s8b37j2si" }, defaultClass: "_1s8b37j2se" }, "10rem": { conditions: { mobile: "_1s8b37j2sj", tablet: "_1s8b37j2sk", laptop: "_1s8b37j2sl", monitor: "_1s8b37j2sm", ultrawide: "_1s8b37j2sn" }, defaultClass: "_1s8b37j2sj" }, "12rem": { conditions: { mobile: "_1s8b37j2so", tablet: "_1s8b37j2sp", laptop: "_1s8b37j2sq", monitor: "_1s8b37j2sr", ultrawide: "_1s8b37j2ss" }, defaultClass: "_1s8b37j2so" }, "14rem": { conditions: { mobile: "_1s8b37j2st", tablet: "_1s8b37j2su", laptop: "_1s8b37j2sv", monitor: "_1s8b37j2sw", ultrawide: "_1s8b37j2sx" }, defaultClass: "_1s8b37j2st" }, "16rem": { conditions: { mobile: "_1s8b37j2sy", tablet: "_1s8b37j2sz", laptop: "_1s8b37j2t0", monitor: "_1s8b37j2t1", ultrawide: "_1s8b37j2t2" }, defaultClass: "_1s8b37j2sy" }, "18rem": { conditions: { mobile: "_1s8b37j2t3", tablet: "_1s8b37j2t4", laptop: "_1s8b37j2t5", monitor: "_1s8b37j2t6", ultrawide: "_1s8b37j2t7" }, defaultClass: "_1s8b37j2t3" }, "20rem": { conditions: { mobile: "_1s8b37j2t8", tablet: "_1s8b37j2t9", laptop: "_1s8b37j2ta", monitor: "_1s8b37j2tb", ultrawide: "_1s8b37j2tc" }, defaultClass: "_1s8b37j2t8" }, "25rem": { conditions: { mobile: "_1s8b37j2td", tablet: "_1s8b37j2te", laptop: "_1s8b37j2tf", monitor: "_1s8b37j2tg", ultrawide: "_1s8b37j2th" }, defaultClass: "_1s8b37j2td" }, "30rem": { conditions: { mobile: "_1s8b37j2ti", tablet: "_1s8b37j2tj", laptop: "_1s8b37j2tk", monitor: "_1s8b37j2tl", ultrawide: "_1s8b37j2tm" }, defaultClass: "_1s8b37j2ti" }, "35rem": { conditions: { mobile: "_1s8b37j2tn", tablet: "_1s8b37j2to", laptop: "_1s8b37j2tp", monitor: "_1s8b37j2tq", ultrawide: "_1s8b37j2tr" }, defaultClass: "_1s8b37j2tn" }, "40rem": { conditions: { mobile: "_1s8b37j2ts", tablet: "_1s8b37j2tt", laptop: "_1s8b37j2tu", monitor: "_1s8b37j2tv", ultrawide: "_1s8b37j2tw" }, defaultClass: "_1s8b37j2ts" }, "45rem": { conditions: { mobile: "_1s8b37j2tx", tablet: "_1s8b37j2ty", laptop: "_1s8b37j2tz", monitor: "_1s8b37j2u0", ultrawide: "_1s8b37j2u1" }, defaultClass: "_1s8b37j2tx" }, "50rem": { conditions: { mobile: "_1s8b37j2u2", tablet: "_1s8b37j2u3", laptop: "_1s8b37j2u4", monitor: "_1s8b37j2u5", ultrawide: "_1s8b37j2u6" }, defaultClass: "_1s8b37j2u2" }, "16%": { conditions: { mobile: "_1s8b37j2u7", tablet: "_1s8b37j2u8", laptop: "_1s8b37j2u9", monitor: "_1s8b37j2ua", ultrawide: "_1s8b37j2ub" }, defaultClass: "_1s8b37j2u7" }, "20%": { conditions: { mobile: "_1s8b37j2uc", tablet: "_1s8b37j2ud", laptop: "_1s8b37j2ue", monitor: "_1s8b37j2uf", ultrawide: "_1s8b37j2ug" }, defaultClass: "_1s8b37j2uc" }, "25%": { conditions: { mobile: "_1s8b37j2uh", tablet: "_1s8b37j2ui", laptop: "_1s8b37j2uj", monitor: "_1s8b37j2uk", ultrawide: "_1s8b37j2ul" }, defaultClass: "_1s8b37j2uh" }, "33%": { conditions: { mobile: "_1s8b37j2um", tablet: "_1s8b37j2un", laptop: "_1s8b37j2uo", monitor: "_1s8b37j2up", ultrawide: "_1s8b37j2uq" }, defaultClass: "_1s8b37j2um" }, "40%": { conditions: { mobile: "_1s8b37j2ur", tablet: "_1s8b37j2us", laptop: "_1s8b37j2ut", monitor: "_1s8b37j2uu", ultrawide: "_1s8b37j2uv" }, defaultClass: "_1s8b37j2ur" }, "50%": { conditions: { mobile: "_1s8b37j2uw", tablet: "_1s8b37j2ux", laptop: "_1s8b37j2uy", monitor: "_1s8b37j2uz", ultrawide: "_1s8b37j2v0" }, defaultClass: "_1s8b37j2uw" }, "60%": { conditions: { mobile: "_1s8b37j2v1", tablet: "_1s8b37j2v2", laptop: "_1s8b37j2v3", monitor: "_1s8b37j2v4", ultrawide: "_1s8b37j2v5" }, defaultClass: "_1s8b37j2v1" }, "66%": { conditions: { mobile: "_1s8b37j2v6", tablet: "_1s8b37j2v7", laptop: "_1s8b37j2v8", monitor: "_1s8b37j2v9", ultrawide: "_1s8b37j2va" }, defaultClass: "_1s8b37j2v6" }, "75%": { conditions: { mobile: "_1s8b37j2vb", tablet: "_1s8b37j2vc", laptop: "_1s8b37j2vd", monitor: "_1s8b37j2ve", ultrawide: "_1s8b37j2vf" }, defaultClass: "_1s8b37j2vb" }, "80%": { conditions: { mobile: "_1s8b37j2vg", tablet: "_1s8b37j2vh", laptop: "_1s8b37j2vi", monitor: "_1s8b37j2vj", ultrawide: "_1s8b37j2vk" }, defaultClass: "_1s8b37j2vg" }, "83%": { conditions: { mobile: "_1s8b37j2vl", tablet: "_1s8b37j2vm", laptop: "_1s8b37j2vn", monitor: "_1s8b37j2vo", ultrawide: "_1s8b37j2vp" }, defaultClass: "_1s8b37j2vl" }, full: { conditions: { mobile: "_1s8b37j2vq", tablet: "_1s8b37j2vr", laptop: "_1s8b37j2vs", monitor: "_1s8b37j2vt", ultrawide: "_1s8b37j2vu" }, defaultClass: "_1s8b37j2vq" }, auto: { conditions: { mobile: "_1s8b37j2vv", tablet: "_1s8b37j2vw", laptop: "_1s8b37j2vx", monitor: "_1s8b37j2vy", ultrawide: "_1s8b37j2vz" }, defaultClass: "_1s8b37j2vv" } } } } }, Ts = oj({ conditions: { defaultCondition: "mobile", conditionNames: ["mobile", "tablet", "laptop", "monitor", "ultrawide"], responsiveArray: void 0 } }), Kf = fj(pj, _j, mj, vj, jj), DN = { small: "var(--aw-shadow-small)", default: "var(--aw-shadow-default)", large: "var(--aw-shadow-large)" }, IN = { small: "var(--aw-border-radius-small)", default: "var(--aw-border-radius-default)", large: "var(--aw-border-radius-large)", round: "var(--aw-border-radius-round)" }, be = { accent: { blue: { default: "var(--aw-accent-blue-default)", secondary: "var(--aw-accent-blue-secondary)" }, green: { default: "var(--aw-accent-green-default)", secondary: "var(--aw-accent-green-secondary)" }, grey: { default: "var(--aw-accent-grey-default)", secondary: "var(--aw-accent-grey-secondary)" }, orange: { default: "var(--aw-accent-orange-default)", secondary: "var(--aw-accent-orange-secondary)" }, pink: { default: "var(--aw-accent-pink-default)", secondary: "var(--aw-accent-pink-secondary)" }, red: { default: "var(--aw-accent-red-default)", secondary: "var(--aw-accent-red-secondary)" }, violet: { default: "var(--aw-accent-violet-default)", secondary: "var(--aw-accent-violet-secondary)" }, yellow: { default: "var(--aw-accent-yellow-default)", secondary: "var(--aw-accent-yellow-secondary)" } }, background: { blue: "var(--aw-background-blue)", brand: { default: "var(--aw-background-brand-default)", secondary: "var(--aw-background-brand-secondary)", tertiary: "var(--aw-background-brand-tertiary)", highlight: "var(--aw-background-brand-highlight)" }, danger: { default: "var(--aw-background-danger-default)", secondary: "var(--aw-background-danger-secondary)", tertiary: "var(--aw-background-danger-tertiary)", highlight: "var(--aw-background-danger-highlight)" }, success: { default: "var(--aw-background-success-default)", secondary: "var(--aw-background-success-secondary)", tertiary: "var(--aw-background-success-tertiary)", highlight: "var(--aw-background-success-highlight)" }, widget: { default: "var(--aw-background-widget-default)", secondary: "var(--aw-background-widget-secondary)", tertiary: "var(--aw-background-widget-tertiary)", highlight: "var(--aw-background-widget-highlight)", pronounced: "var(--aw-background-widget-pronounced)" }, warning: { default: "var(--aw-background-warning-default)", secondary: "var(--aw-background-warning-secondary)", tertiary: "var(--aw-background-warning-tertiary)", highlight: "var(--aw-background-warning-highlight)" }, info: { default: "var(--aw-background-info-default)", secondary: "var(--aw-background-info-secondary)", tertiary: "var(--aw-background-info-tertiary)", highlight: "var(--aw-background-info-highlight)" } }, border: { brand: { default: "var(--aw-border-brand-default)", secondary: "var(--aw-border-brand-secondary)", tertiary: "var(--aw-border-brand-tertiary)" }, danger: { default: "var(--aw-border-danger-default)", secondary: "var(--aw-border-danger-secondary)", tertiary: "var(--aw-border-danger-tertiary)" }, info: { default: "var(--aw-border-info-default)", secondary: "var(--aw-border-info-secondary)", tertiary: "var(--aw-border-info-tertiary)" }, neutral: { default: "var(--aw-border-neutral-default)", secondary: "var(--aw-border-neutral-secondary)", tertiary: "var(--aw-border-neutral-tertiary)", subtle: "var(--aw-border-neutral-subtle)" }, success: { default: "var(--aw-border-success-default)", secondary: "var(--aw-border-success-secondary)", tertiary: "var(--aw-border-success-tertiary)" }, warning: { default: "var(--aw-border-warning-default)", secondary: "var(--aw-border-warning-secondary)", tertiary: "var(--aw-border-warning-tertiary)" } }, mono: { black: "var(--aw-mono-black)", white: "var(--aw-mono-white)" }, icon: { brand: { default: "var(--aw-icon-brand-default)", secondary: "var(--aw-icon-brand-secondary)", tertiary: "var(--aw-icon-brand-tertiary)" }, danger: { default: "var(--aw-icon-danger-default)", secondary: "var(--aw-icon-danger-secondary)", tertiary: "var(--aw-icon-danger-tertiary)" }, info: { default: "var(--aw-icon-info-default)", secondary: "var(--aw-icon-info-secondary)", tertiary: "var(--aw-icon-info-tertiary)" }, neutral: { default: "var(--aw-icon-neutral-default)", secondary: "var(--aw-icon-neutral-secondary)", tertiary: "var(--aw-icon-neutral-tertiary)" }, success: { default: "var(--aw-icon-success-default)", secondary: "var(--aw-icon-success-secondary)", tertiary: "var(--aw-icon-success-tertiary)" }, warning: { default: "var(--aw-icon-warning-default)", secondary: "var(--aw-icon-warning-secondary)", tertiary: "var(--aw-icon-warning-tertiary)" } }, text: { default: { body: "var(--aw-text-default-body)", heading: "var(--aw-text-default-heading)", secondary: "var(--aw-text-default-secondary)", placeholder: "var(--aw-text-default-placeholder)" }, brand: { default: "var(--aw-text-brand-default)", secondary: "var(--aw-text-brand-secondary)", tertiary: "var(--aw-text-brand-tertiary)" }, danger: { default: "var(--aw-text-danger-default)", secondary: "var(--aw-text-danger-secondary)", tertiary: "var(--aw-text-danger-tertiary)" }, info: { default: "var(--aw-text-info-default)", secondary: "var(--aw-text-info-secondary)", tertiary: "var(--aw-text-info-tertiary)" }, success: { default: "var(--aw-text-success-default)", secondary: "var(--aw-text-success-secondary)", tertiary: "var(--aw-text-success-tertiary)" }, warning: { default: "var(--aw-text-warning-default)", secondary: "var(--aw-text-warning-secondary)", tertiary: "var(--aw-text-warning-tertiary)" }, on: { brand: "var(--aw-text-on-brand)", danger: "var(--aw-text-on-danger)", warning: "var(--aw-text-on-warning)", success: "var(--aw-text-on-success)", info: "var(--aw-text-on-info)" } } }, $N = { accent: { blue: { default: "49,149,210", secondary: "158,215,255" }, green: { default: "97,189,79", secondary: "129,202,114" }, grey: { default: "179,179,179", secondary: "235,235,235" }, orange: { default: "245,130,32", secondary: "249,180,121" }, pink: { default: "255,128,206", secondary: "255,179,226" }, red: { default: "235,90,70", secondary: "241,140,126" }, violet: { default: "195,119,224", secondary: "219,173,236" }, yellow: { default: "242,214,0", secondary: "247,230,102" } }, background: { blue: "239,242,247", brand: { default: "var(--aw-brand-default)", secondary: "var(--aw-brand-secondary)", tertiary: "var(--aw-brand-tertiary)", highlight: "var(--aw-brand-highlight)" }, danger: { default: "165,63,49", secondary: "141,54,42", tertiary: "47,18,14", highlight: "253,239,237" }, info: { default: "49,149,210", secondary: "39,119,168", tertiary: "15,45,63", highlight: "236,247,255" }, success: { default: "68,132,55", secondary: "58,113,47", tertiary: "19,38,16", highlight: "223,242,220" }, warning: { default: "172,91,22", secondary: "147,78,19", tertiary: "49,26,6", highlight: "254,243,233" }, widget: { default: "255,255,255", secondary: "250,250,250", tertiary: "241,241,241", pronounced: "204,204,204", highlight: "245,245,245" } }, border: { brand: { default: "var(--aw-brand-default)", secondary: "var(--aw-brand-secondary)", tertiary: "var(--aw-brand-tertiary)" }, danger: { default: "165,63,49", secondary: "141,54,42", tertiary: "47,18,14" }, info: { default: "49,149,210", secondary: "39,119,168", tertiary: "15,45,63" }, neutral: { default: "179,179,179", secondary: "235,235,235", tertiary: "88,89,91", subtle: "250,250,250" }, success: { default: "68,132,55", secondary: "58,113,47", tertiary: "19,38,16" }, warning: { default: "172,91,22", secondary: "147,78,19", tertiary: "49,26,6" } }, mono: { black: "0,0,0", white: "255,255,255" }, icon: { brand: { default: "var(--aw-brand-default)", secondary: "var(--aw-brand-secondary)", tertiary: "var(--aw-brand-tertiary)" }, danger: { default: "165,63,49", secondary: "141,54,42", tertiary: "47,18,14" }, info: { default: "49,149,210", secondary: "39,119,168", tertiary: "15,45,63" }, neutral: { default: "88,89,91", secondary: "62,62,64", tertiary: "0,0,0" }, success: { default: "68,132,55", secondary: "58,113,47", tertiary: "19,38,16" }, warning: { default: "172,91,22", secondary: "147,78,19", tertiary: "49,26,6" } }, text: { default: { body: "62,62,64", heading: "0,0,0", secondary: "88,89,91", placeholder: "140,140,140" }, brand: { default: "var(--aw-brand-default)", secondary: "var(--aw-brand-secondary)", tertiary: "var(--aw-brand-tertiary)" }, danger: { default: "165,63,49", secondary: "141,54,42", tertiary: "47,18,14" }, info: { default: "49,149,210", secondary: "39,119,168", tertiary: "15,45,63" }, success: { default: "68,132,55", secondary: "58,113,47", tertiary: "19,38,16" }, warning: { default: "172,91,22", secondary: "147,78,19", tertiary: "49,26,6" }, on: { brand: "255,255,255", danger: "255,255,255", warning: "255,255,255", success: "255,255,255", info: "255,255,255" } } }, LN = { accent: { blue: { default: "49,149,210", secondary: "158,215,255" }, green: { default: "97,189,79", secondary: "129,202,114" }, grey: { default: "179,179,179", secondary: "235,235,235" }, orange: { default: "245,130,32", secondary: "249,180,121" }, pink: { default: "255,128,206", secondary: "255,179,226" }, red: { default: "235,90,70", secondary: "241,140,126" }, violet: { default: "195,119,224", secondary: "219,173,236" }, yellow: { default: "242,214,0", secondary: "247,230,102" } }, background: { blue: "239,242,247", brand: { default: "var(--aw-brand-default)", secondary: "var(--aw-brand-secondary)", tertiary: "var(--aw-brand-tertiary)", highlight: "var(--aw-brand-highlight)" }, danger: { default: "241,140,126", secondary: "235,90,70", tertiary: "141,54,42", highlight: "94,26,28" }, info: { default: "49,149,210", secondary: "39,119,168", tertiary: "14,94,151", highlight: "18,71,109" }, success: { default: "129,202,114", secondary: "97,189,79", tertiary: "58,113,47", highlight: "29,57,24" }, warning: { default: "249,180,121", secondary: "245,130,32", tertiary: "147,78,19", highlight: "98,52,13" }, widget: { default: "33,33,33", secondary: "51,51,51", tertiary: "54,54,54", pronounced: "114,114,114", highlight: "88,89,91" } }, border: { brand: { default: "var(--aw-brand-default)", secondary: "var(--aw-brand-secondary)", tertiary: "var(--aw-brand-tertiary)" }, danger: { default: "241,140,126", secondary: "235,90,70", tertiary: "141,54,42" }, info: { default: "49,149,210", secondary: "39,119,168", tertiary: "14,94,151" }, neutral: { default: "114,114,114", secondary: "88,89,91", tertiary: "188,189,189", subtle: "51,51,51" }, success: { default: "129,202,114", secondary: "97,189,79", tertiary: "58,113,47" }, warning: { default: "249,180,121", secondary: "245,130,32", tertiary: "147,78,19" } }, mono: { black: "0,0,0", white: "255,255,255" }, icon: { brand: { default: "var(--aw-brand-default)", secondary: "var(--aw-brand-secondary)", tertiary: "var(--aw-brand-tertiary)" }, danger: { default: "241,140,126", secondary: "235,90,70", tertiary: "141,54,42" }, info: { default: "49,149,210", secondary: "39,119,168", tertiary: "14,94,151" }, neutral: { default: "188,189,189", secondary: "114,114,114", tertiary: "88,89,91" }, success: { default: "129,202,114", secondary: "97,189,79", tertiary: "58,113,47" }, warning: { default: "249,180,121", secondary: "245,130,32", tertiary: "147,78,19" } }, text: { default: { body: "235,235,235", heading: "255,255,255", secondary: "188,189,189", placeholder: "183,183,183" }, brand: { default: "var(--aw-brand-default)", secondary: "var(--aw-brand-secondary)", tertiary: "var(--aw-brand-tertiary)" }, danger: { default: "241,140,126", secondary: "235,90,70", tertiary: "141,54,42" }, info: { default: "49,149,210", secondary: "39,119,168", tertiary: "14,94,151" }, success: { default: "129,202,114", secondary: "97,189,79", tertiary: "58,113,47" }, warning: { default: "249,180,121", secondary: "245,130,32", tertiary: "147,78,19" }, on: { brand: "0,0,0", danger: "0,0,0", warning: "0,0,0", success: "0,0,0", info: "0,0,0" } } }, zN = { font: { size: { xsmall: "0.75rem", small: "0.875rem", default: "1rem", large: "1.125rem", xlarge: "1.25rem", xxlarge: "1.5rem", xxxlarge: "1.875rem", xxxxlarge: "2.25rem", xxxxxlarge: "3rem", xxxxxxlarge: "3.75rem", h1: "22px", h2: "20px", h3: "18px", h4: "16px", h5: "14px", h6: "12px" }, family: { body: "'Lato', sans-serif", heading: "'Encode sans', sans-serif", code: "'Courier Prime', monospace" }, weight: { normal: "400", bold: "700", black: "900" } } }, FN = { font: { size: { xsmall: "var(--aw-font-size-xsmall)", small: "var(--aw-font-size-small)", default: "var(--aw-font-size-default)", large: "var(--aw-font-size-large)", xlarge: "var(--aw-font-size-xlarge)", xxlarge: "var(--aw-font-size-xxlarge)", xxxlarge: "var(--aw-font-size-xxxlarge)", xxxxlarge: "var(--aw-font-size-xxxxlarge)", xxxxxlarge: "var(--aw-font-size-xxxxxlarge)", xxxxxxlarge: "var(--aw-font-size-xxxxxxlarge)", h1: "var(--aw-font-size-h1)", h2: "var(--aw-font-size-h2)", h3: "var(--aw-font-size-h3)", h4: "var(--aw-font-size-h4)", h5: "var(--aw-font-size-h5)", h6: "var(--aw-font-size-h6)" }, family: { body: "var(--aw-font-family-body)", heading: "var(--aw-font-family-heading)", code: "var(--aw-font-family-code)" }, weight: { normal: "var(--aw-font-weight-normal)", bold: "var(--aw-font-weight-bold)", black: "var(--aw-font-weight-black)" } } }, HN = { 0: "0rem", "0.25rem": "0.25rem", "0.5rem": "0.5rem", "0.75rem": "0.75rem", "1rem": "1rem", "1.25rem": "1.25rem", "1.5rem": "1.5rem", "1.75rem": "1.75rem", "2rem": "2rem", "2.25rem": "2.25rem", "2.5rem": "2.5rem", "2.75rem": "2.75rem", "3rem": "3rem", "3.25rem": "3.25rem", "3.5rem": "3.5rem", "3.75rem": "3.75rem", "4rem": "4rem", "4.25rem": "4.25rem", "4.5rem": "4.5rem", "4.75rem": "4.75rem", "5rem": "5rem", "5.25rem": "5.25rem", "5.5rem": "5.5rem", "5.75rem": "5.75rem", "6rem": "6rem", "7rem": "7rem", "8rem": "8rem", "9rem": "9rem", "10rem": "10rem", "12rem": "12rem", "14rem": "14rem", "16rem": "16rem", "18rem": "18rem", "20rem": "20rem", "25rem": "25rem", "30rem": "30rem", "35rem": "35rem", "40rem": "40rem", "45rem": "45rem", "50rem": "50rem" }, BN = { 0: "var(--g800ir0)", "0.25rem": "var(--g800ir1)", "0.5rem": "var(--g800ir2)", "0.75rem": "var(--g800ir3)", "1rem": "var(--g800ir4)", "1.25rem": "var(--g800ir5)", "1.5rem": "var(--g800ir6)", "1.75rem": "var(--g800ir7)", "2rem": "var(--g800ir8)", "2.25rem": "var(--g800ir9)", "2.5rem": "var(--g800ira)", "2.75rem": "var(--g800irb)", "3rem": "var(--g800irc)", "3.25rem": "var(--g800ird)", "3.5rem": "var(--g800ire)", "3.75rem": "var(--g800irf)", "4rem": "var(--g800irg)", "4.25rem": "var(--g800irh)", "4.5rem": "var(--g800iri)", "4.75rem": "var(--g800irj)", "5rem": "var(--g800irk)", "5.25rem": "var(--g800irl)", "5.5rem": "var(--g800irm)", "5.75rem": "var(--g800irn)", "6rem": "var(--g800iro)", "7rem": "var(--g800irp)", "8rem": "var(--g800irq)", "9rem": "var(--g800irr)", "10rem": "var(--g800irs)", "12rem": "var(--g800irt)", "14rem": "var(--g800iru)", "16rem": "var(--g800irv)", "18rem": "var(--g800irw)", "20rem": "var(--g800irx)", "25rem": "var(--g800iry)", "30rem": "var(--g800irz)", "35rem": "var(--g800ir10)", "40rem": "var(--g800ir11)", "45rem": "var(--g800ir12)", "50rem": "var(--g800ir13)" };
function hj(e) {
  return Kf.properties.has(e);
}
function gj(e) {
  const t = {}, n = {};
  for (const r in e)
    hj(r) ? t[r] = e[r] : n[r] = e[r];
  return {
    atomProps: t,
    nativeProps: n
  };
}
const qN = (e) => {
  const t = e.split(",").map((n) => Number(n));
  return t.length != 3 || t.includes(NaN) ? "" : "#" + t.map((n) => n.toString(16).padStart(2, "0")).join("").toUpperCase();
}, nn = (e) => {
  const [t, n] = l.useState(!1);
  return l.useEffect(() => {
    const r = window.matchMedia(
      `screen and (min-width: ${bj[e]})`
    );
    function a(s) {
      n(s.matches);
    }
    return a(r), r.addEventListener("change", a), () => r.removeEventListener("change", a);
  }, []), t;
}, yj = () => {
  const e = nn("tablet"), t = nn("laptop"), n = nn("monitor");
  return nn("ultrawide") ? "ultrawide" : n ? "monitor" : t ? "laptop" : e ? "tablet" : "mobile";
};
function Xf(e) {
  const t = l.useRef(e);
  return l.useEffect(() => {
    t.current = e;
  }), l.useMemo(
    () => (...n) => {
      var r;
      return (r = t.current) == null ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function nt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = wj({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, o = s ? e : r, i = Xf(n), c = l.useCallback(
    (u) => {
      if (s) {
        const m = typeof u == "function" ? u(e) : u;
        m !== e && i(m);
      } else
        a(u);
    },
    [s, e, a, i]
  );
  return [o, c];
}
function wj({
  defaultProp: e,
  onChange: t
}) {
  const n = l.useState(e), [r] = n, a = l.useRef(r), s = Xf(t);
  return l.useEffect(() => {
    a.current !== r && (s(r), a.current = r);
  }, [r, a, s]), n;
}
let Cj = 0;
function kt(e) {
  return l.useMemo(() => `${e}-${++Cj}`, []);
}
const ao = ({
  onArrowUp: e,
  onArrowDown: t,
  onArrowRight: n,
  onArrowLeft: r,
  onPageUp: a,
  onPageDown: s,
  onEnter: o,
  onSpace: i
}) => l.useCallback(
  (c) => {
    switch (c.code) {
      case "ArrowUp": {
        e == null || e(c);
        break;
      }
      case "ArrowDown": {
        t == null || t(c);
        break;
      }
      case "ArrowRight": {
        n == null || n(c);
        break;
      }
      case "ArrowLeft": {
        r == null || r(c);
        break;
      }
      case "PageUp": {
        a == null || a(c);
        break;
      }
      case "PageDown": {
        s == null || s(c);
        break;
      }
      case "Enter": {
        o == null || o(c);
        break;
      }
      case "Space": {
        i == null || i(c);
        break;
      }
      default:
        return;
    }
  },
  [
    t,
    e,
    r,
    n,
    a,
    s,
    o,
    i
  ]
), Fu = (e, t = 0) => {
  let n;
  return function(...r) {
    clearTimeout(n), n = setTimeout(() => e.apply(this, r), t);
  };
}, Ej = (e = {}, t = 0, n) => {
  const r = (n ?? navigator.language).toLocaleLowerCase();
  return new Intl.NumberFormat(r, {
    ...e,
    maximumFractionDigits: t,
    minimumFractionDigits: t
  });
}, Vo = (e, t = 0, n) => {
  if (e)
    return Ej({}, t, n).format(e);
}, xj = (e) => {
  const [t, n] = l.useState(), [r, a] = l.useState();
  return {
    handleDragStart: (f) => n(f),
    handleDragOver: (f, m) => {
      m.preventDefault(), m.dataTransfer.dropEffect = "move", a(f);
    },
    handleDragLeave: () => a(void 0),
    handleDragEnd: () => {
      n(void 0), a(void 0);
    },
    handleDrop: (f, m) => {
      var b;
      m.stopPropagation(), n(void 0), a(void 0), (b = e == null ? void 0 : e.onDrop) == null || b.call(e, t, f);
    },
    dragOverData: r,
    dragStartData: t
  };
}, va = l.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  return l.Children.toArray(n).some(Hu) ? /* @__PURE__ */ l.createElement(l.Fragment, null, l.Children.map(n, (a) => Hu(a) ? /* @__PURE__ */ l.createElement(Fi, { ...r, ref: t }, a.props.children) : a)) : /* @__PURE__ */ l.createElement(Fi, { ...r, ref: t }, n);
});
va.displayName = "Slot";
const Fi = l.forwardRef(
  (e, t) => {
    const { children: n, ...r } = e;
    return l.isValidElement(n) ? l.cloneElement(n, {
      ...kj(r, n.props),
      ref: Vf([t, n.ref])
    }) : l.Children.count(n) > 1 ? l.Children.only(null) : null;
  }
);
Fi.displayName = "SlotClone";
const Sj = ({ children: e }) => /* @__PURE__ */ l.createElement(l.Fragment, null, e);
function Hu(e) {
  return l.isValidElement(e) && e.type === Sj;
}
function kj(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? n[r] = (...i) => {
      s == null || s(...i), a == null || a(...i);
    } : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
const Tj = [
  "a",
  "button",
  "div",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "img",
  "li",
  "nav",
  "p",
  "section",
  "span",
  "svg",
  "ul",
  "label",
  "input",
  "textarea",
  "table",
  "tr",
  "th",
  "td",
  "tbody",
  "thead",
  "tfoot"
], U = Tj.reduce(
  (e, t) => ({
    ...e,
    [t]: l.forwardRef(
      (n, r) => {
        const { asChild: a, className: s = "", ...o } = n, { atomProps: i, nativeProps: c } = gj(o), u = Kf(i), f = a ? va : t;
        return n.as && console.error(Rj), /* @__PURE__ */ l.createElement(
          f,
          {
            ...c,
            className: q(u, s),
            ref: r
          }
        );
      }
    )
  }),
  {}
), Rj = "Warning: The `as` prop has been removed in favour of `asChild`.", Oj = {
  top: "flex-start",
  center: "center",
  bottom: "flex-end",
  stretch: "stretch"
}, Mj = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
  between: "space-between",
  evenly: "space-evenly",
  around: "space-around"
}, re = l.forwardRef(
  (e, t) => {
    const {
      xAlign: n = "left",
      yAlign: r = "center",
      direction: a = "forward",
      gap: s = "default",
      wrap: o = "nowrap",
      ...i
    } = e, c = Ts(
      r,
      (f) => Oj[f]
    ), u = Ts(
      n,
      (f) => Mj[f]
    );
    return /* @__PURE__ */ l.createElement(
      U.div,
      {
        ref: t,
        display: "flex",
        flexDirection: a === "forward" ? "row" : "row-reverse",
        alignItems: c,
        justifyContent: u,
        flexWrap: o,
        gap: s,
        ...i
      }
    );
  }
);
re.displayName = "HStack";
var Aj = "akvj6k1 akvj6k0 _1s8b37jm1";
const Zf = l.forwardRef(({ children: e, className: t }, n) => /* @__PURE__ */ l.createElement(
  U.span,
  {
    className: q(t, Aj),
    ref: n,
    "data-testid": "truncate",
    display: "block",
    overflow: "hidden"
  },
  e
));
var Pj = "fp6kwz3 fp6kwz1 _1q6d0sx4 fp6kwz0 fp6kwz2 _1s8b37jl8", Nj = "fp6kwz5 fp6kwz1 _1q6d0sx4 fp6kwz0 fp6kwz4 _1s8b37jl8 _1s8b37jlc", Dj = "fp6kwz9 fp6kwz7 _1q6d0sx4 fp6kwz6 fp6kwz8 _1s8b37jl8", Ij = "fp6kwzb fp6kwz7 _1q6d0sx4 fp6kwz6 fp6kwza _1s8b37jl8 _1s8b37jlc", $j = "fp6kwzf fp6kwzd _1q6d0sx4 fp6kwzc fp6kwze _1s8b37jl8", Lj = "fp6kwzj fp6kwzh _1q6d0sx4 fp6kwzg fp6kwzi _1s8b37jla", zj = "fp6kwzl fp6kwzh _1q6d0sx4 fp6kwzg fp6kwzk _1s8b37jla _1s8b37jlc";
const Fj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  body1: Pj,
  body2: Nj,
  body3: Dj,
  body4: Ij,
  body5: $j,
  code1: Lj,
  code2: zj
}, Symbol.toStringTag, { value: "Module" })), ne = l.forwardRef(
  ({ className: e, children: t, styledAs: n = "body1", truncate: r = !1, ...a }, s) => {
    const o = l.useMemo(() => n === "custom" ? q(e) : n ? q(e, Fj[n]) : q(e), [e, n]);
    return /* @__PURE__ */ l.createElement(
      U.span,
      {
        ref: s,
        className: o,
        reset: "all",
        textColor: a.textColor ?? "body",
        ...a
      },
      r ? /* @__PURE__ */ l.createElement(Zf, null, t) : t
    );
  }
);
var Hj = "eqr5a11 eqr5a10 _1s8b37j25c _1s8b37j26q _1s8b37j27z _1s8b37j23t _1s8b37jk8 _1s8b37jkc _1s8b37jkg _1s8b37jkk _1s8b37jmh _1s8b37jl5 _1s8b37jw7 _1s8b37jxg _1s8b37j199 _1s8b37j29d _1s8b37j3c _1s8b37jm1 _1s8b37j12l", Bj = "eqr5a12", qj = { danger: "eqr5a13 _1s8b37j9w", warning: "eqr5a14 _1s8b37j9g", success: "eqr5a15 _1s8b37j90", info: "eqr5a16 _1s8b37j8s", attention: "eqr5a17 _1s8b37jac", default: "eqr5a18 _1s8b37j98" };
const Uj = l.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(re, { asChild: !0, xAlign: "center" }, /* @__PURE__ */ l.createElement(
    U.span,
    {
      ref: r,
      className: q(Bj, t),
      ...n
    },
    e
  ))
), Wj = l.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(
    ne,
    {
      styledAs: "body3",
      textColor: "inherit",
      fontWeight: "bold",
      ref: n,
      ...t
    },
    e
  )
), Vj = l.forwardRef(
  (e, t) => {
    const { children: n, className: r, appearance: a = "default", ...s } = e;
    return /* @__PURE__ */ l.createElement(
      re,
      {
        ...s,
        className: q(
          Hj,
          qj[a],
          r
        ),
        gap: "xsmall",
        ref: t
      },
      n
    );
  }
), UN = {
  Root: Vj,
  Text: Wj,
  Icon: Uj
}, Yj = {
  top: "flex-start",
  center: "center",
  bottom: "flex-end",
  between: "space-between",
  evenly: "space-evenly",
  around: "space-around"
}, Gj = {
  left: "flex-start",
  center: "center",
  right: "flex-end"
}, ye = l.forwardRef(
  (e, t) => {
    const {
      xAlign: n = "left",
      yAlign: r = "center",
      direction: a = "forward",
      gap: s = "default",
      wrap: o = "nowrap",
      ...i
    } = e, c = Ts(
      r,
      (f) => Yj[f]
    ), u = Ts(
      n,
      (f) => Gj[f]
    );
    return /* @__PURE__ */ l.createElement(
      U.div,
      {
        ref: t,
        display: "flex",
        flexDirection: a === "forward" ? "column" : "column-reverse",
        alignItems: u,
        justifyContent: c,
        flexWrap: o,
        gap: s,
        ...i
      }
    );
  }
);
ye.displayName = "VStack";
const na = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "calendar",
    className: q("svg-inline--fa fa-calendar fa-w-16", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    "data-testid": "calendar"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32zM0 192H448V464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192zM64 304C64 312.8 71.16 320 80 320H112C120.8 320 128 312.8 128 304V272C128 263.2 120.8 256 112 256H80C71.16 256 64 263.2 64 272V304zM192 304C192 312.8 199.2 320 208 320H240C248.8 320 256 312.8 256 304V272C256 263.2 248.8 256 240 256H208C199.2 256 192 263.2 192 272V304zM336 256C327.2 256 320 263.2 320 272V304C320 312.8 327.2 320 336 320H368C376.8 320 384 312.8 384 304V272C384 263.2 376.8 256 368 256H336zM64 432C64 440.8 71.16 448 80 448H112C120.8 448 128 440.8 128 432V400C128 391.2 120.8 384 112 384H80C71.16 384 64 391.2 64 400V432zM208 384C199.2 384 192 391.2 192 400V432C192 440.8 199.2 448 208 448H240C248.8 448 256 440.8 256 432V400C256 391.2 248.8 384 240 384H208zM320 432C320 440.8 327.2 448 336 448H368C376.8 448 384 440.8 384 432V400C384 391.2 376.8 384 368 384H336C327.2 384 320 391.2 320 400V432z"
    }
  )
), ic = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "caret-up",
    className: q("svg-inline--fa fa-caret-up fa-w-16", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    "data-testid": "caret-up"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M9.39 265.4l127.1-128C143.6 131.1 151.8 128 160 128s16.38 3.125 22.63 9.375l127.1 128c9.156 9.156 11.9 22.91 6.943 34.88S300.9 320 287.1 320H32.01c-12.94 0-24.62-7.781-29.58-19.75S.2333 274.5 9.39 265.4z"
    }
  )
), lc = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "caret-down",
    className: q("svg-inline--fa fa-caret-down fa-w-16", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    "data-testid": "caret-down"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z"
    }
  )
), Kj = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "circle-check",
    className: q("svg-inline--fa fa-circle-check fa-w-16", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "data-testid": "check-circle"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z"
    }
  )
), Jf = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "chevron-right",
    className: q("svg-inline--fa fa-chevron-right", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    "data-testid": "chevron-right"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"
    }
  )
), Xj = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "chevron-left",
    className: q("svg-inline--fa fa-chevron-left", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    "data-testid": "chevron-left"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"
    }
  )
), Zj = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "chevron-up",
    className: q("svg-inline--fa fa-chevron-up fa-w-16", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "data-testid": "chevron-up"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M416 352c-8.188 0-16.38-3.125-22.62-9.375L224 173.3l-169.4 169.4c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25C432.4 348.9 424.2 352 416 352z"
    }
  )
), Jj = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "chevron-down",
    className: q("svg-inline--fa fa-chevron-down fa-w-16", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "data-testid": "chevron-down"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
    }
  )
), ha = ({ className: e, ...t }) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "check",
    className: q("svg-inline--fa fa-check fa-w-16", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "data-testid": "check"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
    }
  )
), Hi = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "clock",
    className: q("svg-inline--fa fa-clock fa-w-16", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "data-testid": "clock"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"
    }
  )
), Qf = (e) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...e,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "exclamation",
    className: "svg-inline--fa fa-exclamation fa-w-6",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    "data-testid": "exclamation"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
    }
  )
), eb = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "circle-exclamation",
    className: q("svg-inline--fa fa-circle-exclamation fa-w-16", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "data-testid": "exclamation-circle"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  )
), tb = ({ className: e, ...t }) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "triangle-exclamation",
    className: q(
      "svg-inline--fa fa-triangle-exclamation fa-w-16",
      e
    ),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "data-testid": "exclamation-triangle"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"
    }
  )
), nb = (e) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...e,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "external-link-alt",
    className: "svg-inline--fa fa-external-link-alt fa-w-16",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "data-testid": "external-link"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
    }
  )
), Qj = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "circle-info",
    className: q("svg-inline--fa fa-circle-info fa-w-16", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "data-testid": "info-circle"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 128c17.67 0 32 14.33 32 32c0 17.67-14.33 32-32 32S224 177.7 224 160C224 142.3 238.3 128 256 128zM296 384h-80C202.8 384 192 373.3 192 360s10.75-24 24-24h16v-64H224c-13.25 0-24-10.75-24-24S210.8 224 224 224h32c13.25 0 24 10.75 24 24v88h16c13.25 0 24 10.75 24 24S309.3 384 296 384z"
    }
  )
), e2 = ({ className: e, ...t }) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "minus",
    className: q("svg-inline--fa fa-link", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "data-testid": "link"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
    }
  )
);
var t2 = "_10wo4sd1";
const so = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-testid": "loading-icon",
    "data-prefix": "fas",
    "data-icon": "circle-notch",
    className: q(e, t2),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
    }
  )
), WN = ({ className: e, ...t }) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "minus",
    className: q("svg-inline--fa fa-minus fa-w-14", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    "data-testid": "minus"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    }
  )
), Bu = ({ className: e, ...t }) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "search",
    className: q("svg-inline--fa fa-magnifying-glass fa-w-16", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    "data-testid": "Search"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      shapeRendering: "geometricPrecision",
      fill: "currentColor",
      d: "M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"
    }
  )
), wr = ({ className: e, ...t }) => /* @__PURE__ */ l.createElement(
  U.svg,
  {
    ...t,
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "times",
    className: q("svg-inline--fa fa-times fa-w-11", e),
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 352 512",
    "data-testid": "times"
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  )
);
var n2 = "_146ql6q2 _146ql6q0 _146ql6q1 _1s8b37j27u _1s8b37j23o _1s8b37j252 _1s8b37j26g _1s8b37jk8 _1s8b37jkc _1s8b37jkg _1s8b37jkk _1s8b37jkl _1s8b37jkp _1s8b37jkt _1s8b37jkx _1s8b37jmh _1s8b37jao _1s8b37jg8 _1s8b37jgd _1s8b37jgj _1s8b37jl7 _1s8b37jvn _1s8b37j199 _1s8b37j2", r2 = "_146ql6q3 _1s8b37jll", a2 = { default: "_146ql6q5 _146ql6q4" }, s2 = { default: "_146ql6q6 _1s8b37jao _1s8b37j5h _1s8b37j5j _1s8b37j2 _1s8b37js", neutral: "_146ql6q7 _1s8b37jao _1s8b37j7p _1s8b37j7r _1s8b37j2 _1s8b37j2g", danger: "_146ql6q8 _1s8b37jao _1s8b37j5x _1s8b37j5z _1s8b37j5 _1s8b37j14 _1s8b37j19 _1s8b37j1b", warning: "_146ql6q9 _1s8b37jao _1s8b37j6d _1s8b37j6f _1s8b37j8 _1s8b37j1g _1s8b37j1l _1s8b37j1n", success: "_146ql6qa _1s8b37jao _1s8b37j6t _1s8b37j6v _1s8b37jb _1s8b37j1s _1s8b37j1x _1s8b37j1z" }, qu = { default: "_146ql6qc _146ql6qb", small: "_146ql6qe _146ql6qd" };
const o2 = "default", Me = l.forwardRef((e, t) => {
  const {
    appearance: n = "neutral",
    className: r,
    children: a,
    isDisabled: s,
    isLoading: o,
    size: i = "default",
    onClick: c,
    ...u
  } = e;
  return /* @__PURE__ */ l.createElement(
    U.button,
    {
      ...u,
      type: u.type ? u.type : "button",
      className: q(
        r,
        n2,
        a2[o2],
        s2[n],
        {
          [r2]: o
        }
      ),
      disabled: s,
      onClick: o || s ? void 0 : c,
      "aria-disabled": s,
      "aria-label": u["aria-label"],
      ref: t
    },
    o ? /* @__PURE__ */ l.createElement(so, { className: qu[i] }) : l.cloneElement(a, {
      className: qu[i]
    })
  );
});
Me.displayName = "IconButton";
var i2 = "_1s7r4hc1 _1s7r4hc0 _1s8b37j25m _1s8b37j270 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37jmh _1s8b37jl3 _1s8b37jl5 _1s8b37jl7 _1s8b37jw7 _1s8b37jxg _1s8b37jl8 _1s8b37jya _1s8b37jlc _1s8b37j12v _1s8b37j199 _1s8b37j29d _1s8b37j2 _1s8b37jlo", l2 = "_1s7r4hc2 _1s8b37jmh _1s8b37jw7 _1s8b37jxg _1s8b37j10s _1s8b37j18u _1s8b37j199", c2 = "_1s7r4hc3 _1s8b37j12b _1s8b37j293 _1s8b37j2p7 _1s8b37jlf", u2 = "_1s7r4hc4", d2 = "_1s7r4hc5 _1s8b37jf4", f2 = "_1s7r4hc7 _1s8b37jll", b2 = { primary: { default: "_1s7r4hc8 _1s8b37j5g _1s8b37j5l _1s8b37j5r _1s8b37jew _1s8b37j2s", danger: "_1s7r4hc9 _1s8b37j5w _1s8b37j61 _1s8b37j67 _1s8b37jew _1s8b37j2w", success: "_1s7r4hca _1s8b37j6s _1s8b37j6x _1s8b37j73 _1s8b37jew _1s8b37j30", warning: "_1s7r4hcb _1s8b37j6c _1s8b37j6h _1s8b37j6n _1s8b37jew _1s8b37j34" }, secondary: { default: "_1s7r4hcc _1s8b37j80 _1s8b37j5l _1s8b37j5r _1s8b37jas _1s8b37jax _1s8b37jb3 _1s8b37js _1s8b37j2t _1s8b37j2v", danger: "_1s7r4hcd _1s8b37j80 _1s8b37j61 _1s8b37j67 _1s8b37jb4 _1s8b37jb9 _1s8b37jbf _1s8b37j14 _1s8b37j2x _1s8b37j2z", success: "_1s7r4hce _1s8b37j80 _1s8b37j6x _1s8b37j73 _1s8b37jbs _1s8b37jbx _1s8b37jc3 _1s8b37j1s _1s8b37j31 _1s8b37j33", warning: "_1s7r4hcf _1s8b37j80 _1s8b37j6h _1s8b37j6n _1s8b37jbg _1s8b37jbl _1s8b37jbr _1s8b37j1g _1s8b37j35 _1s8b37j37" }, tertiary: { default: "_1s7r4hcg _1s8b37jao _1s8b37jew _1s8b37jax _1s8b37jb3 _1s8b37js _1s8b37jx _1s8b37j13", danger: "_1s7r4hch _1s8b37jao _1s8b37jew _1s8b37jb9 _1s8b37jbf _1s8b37j14 _1s8b37j19 _1s8b37j1f", success: "_1s7r4hci _1s8b37jao _1s8b37jew _1s8b37jbx _1s8b37jc3 _1s8b37j1s _1s8b37j1x _1s8b37j23", warning: "_1s7r4hcj _1s8b37jao _1s8b37jew _1s8b37jbl _1s8b37jbr _1s8b37j1g _1s8b37j1l _1s8b37j1r" }, link: { default: "_1s7r4hck _1s8b37jao _1s8b37jew _1s8b37js _1s8b37jx _1s8b37j13", danger: "_1s7r4hcl _1s8b37jao _1s8b37jew _1s8b37j14 _1s8b37j19 _1s8b37j1f", success: "_1s7r4hcm _1s8b37jao _1s8b37jew _1s8b37j1s _1s8b37j1x _1s8b37j23", warning: "_1s7r4hcn _1s8b37jao _1s8b37jew _1s8b37j1g _1s8b37j1l _1s8b37j1r" } };
const Et = l.forwardRef(
  (e, t) => {
    const {
      appearance: n = "default",
      className: r,
      children: a,
      variant: s = "primary",
      isLoading: o = !1,
      isDisabled: i = !1,
      iconLeft: c,
      iconRight: u,
      label: f,
      onClick: m,
      ...b
    } = e;
    return /* @__PURE__ */ l.createElement(re, { asChild: !0, gap: "zero", xAlign: "center" }, /* @__PURE__ */ l.createElement(
      U.button,
      {
        ...b,
        type: b.type ? b.type : "button",
        className: q(
          i2,
          r,
          b2[s][n],
          {
            [u2]: s === "link",
            [f2]: o
          }
        ),
        ref: t,
        disabled: i,
        onClick: o || i ? void 0 : m,
        "aria-label": f || a,
        "aria-disabled": i || o
      },
      o && /* @__PURE__ */ l.createElement("span", { className: c2 }, /* @__PURE__ */ l.createElement(so, null)),
      /* @__PURE__ */ l.createElement(
        re,
        {
          gap: "small",
          xAlign: "center",
          className: q(l2, {
            [d2]: o
          })
        },
        c && c,
        a && /* @__PURE__ */ l.createElement(ne, { styledAs: "body4", whiteSpace: "nowrap", textColor: "inherit" }, a),
        u && u
      )
    ));
  }
);
var m2 = { danger: "qcxu132 qcxu130 qcxu131", warning: "qcxu134 qcxu130 qcxu133", success: "qcxu136 qcxu130 qcxu135", info: "qcxu138 qcxu130 qcxu137" }, _2 = "qcxu139", p2 = { danger: "qcxu13b qcxu139 qcxu13a", warning: "qcxu13d qcxu139 qcxu13c", success: "qcxu13f qcxu139 qcxu13e", info: "qcxu13h qcxu139 qcxu13g" }, j2 = "qcxu13i", v2 = "qcxu13j", h2 = "qcxu13k", rb = "qcxu13l", g2 = "qcxu13m";
const ga = "info", y2 = {
  info: "default",
  danger: "danger",
  success: "success",
  warning: "warning"
}, ab = l.createContext({
  appearance: ga
}), sb = () => l.useContext(ab), cc = l.forwardRef(
  ({ appearance: e = ga, children: t, className: n, ...r }, a) => /* @__PURE__ */ l.createElement(ab.Provider, { value: { appearance: e } }, /* @__PURE__ */ l.createElement(
    re,
    {
      ...r,
      ref: a,
      gap: "small",
      xAlign: "between",
      yAlign: "stretch",
      className: q(n, m2[e]),
      "data-appearance": e
    },
    t
  ))
), uc = l.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(
  re,
  {
    ...n,
    ref: r,
    yAlign: "top",
    className: q(t, j2),
    "data-testid": "bannerContent"
  },
  e
)), dc = l.forwardRef(
  ({ children: e, className: t, ...n }, r) => {
    const { appearance: a } = sb(), s = l.useMemo(() => {
      switch (a) {
        case "info":
          return /* @__PURE__ */ l.createElement(Qj, null);
        case "danger":
          return /* @__PURE__ */ l.createElement(tb, null);
        case "success":
          return /* @__PURE__ */ l.createElement(Kj, null);
        case "warning":
          return /* @__PURE__ */ l.createElement(eb, null);
      }
    }, [a]);
    return /* @__PURE__ */ l.createElement(
      U.div,
      {
        ...n,
        ref: r,
        "data-testid": "bannerIcon",
        className: q(
          t,
          _2,
          p2[a ?? ga]
        )
      },
      e || s
    );
  }
), fc = l.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(
  ye,
  {
    ...n,
    gap: "xsmall",
    className: q(t, v2),
    ref: r,
    "data-testid": "bannerTextContent"
  },
  e
)), bc = l.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(
    ne,
    {
      ...n,
      styledAs: "body4",
      className: q(t, h2),
      ref: r,
      "data-testid": "bannerTitle"
    },
    e
  )
), mc = l.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(
  ne,
  {
    ...n,
    ref: r,
    className: q(t, rb)
  },
  e
)), ob = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(re, { yAlign: "center", ...t, ref: n }, e)), w2 = l.forwardRef(({ children: e, variant: t, ...n }, r) => {
  const { appearance: a } = sb();
  return /* @__PURE__ */ l.createElement(
    Et,
    {
      ...n,
      ref: r,
      variant: t ?? "secondary",
      appearance: y2[a ?? ga],
      "data-testid": "bannerButton"
    },
    e
  );
}), ib = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.createElement(
  Me,
  {
    ...t,
    className: q(e, g2),
    ref: n,
    "aria-label": "Dismiss",
    "data-testid": "bannerDismiss"
  },
  /* @__PURE__ */ l.createElement(wr, null)
)), VN = l.forwardRef(
  ({
    children: e,
    appearance: t = ga,
    isDismissible: n = !1,
    onDismissClick: r,
    title: a,
    description: s,
    ...o
  }, i) => /* @__PURE__ */ l.createElement(
    cc,
    {
      appearance: t,
      role: t === "danger" ? "alert" : "status",
      tabIndex: -1,
      ...o,
      ref: i
    },
    /* @__PURE__ */ l.createElement(uc, null, /* @__PURE__ */ l.createElement(dc, null), /* @__PURE__ */ l.createElement(fc, null, a && /* @__PURE__ */ l.createElement(bc, null, a), s && /* @__PURE__ */ l.createElement(mc, null, s))),
    /* @__PURE__ */ l.createElement(ob, null, e),
    n && /* @__PURE__ */ l.createElement(ib, { onClick: r })
  )
);
function Uu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ae(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Uu(Object(n), !0).forEach(function(r) {
      Ge(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Uu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Rs(e) {
  "@babel/helpers - typeof";
  return Rs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rs(e);
}
function C2(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function E2(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function x2(e, t, n) {
  return t && E2(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ge(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function _c(e, t) {
  return k2(e) || R2(e, t) || lb(e, t) || M2();
}
function ya(e) {
  return S2(e) || T2(e) || lb(e) || O2();
}
function S2(e) {
  if (Array.isArray(e)) return Bi(e);
}
function k2(e) {
  if (Array.isArray(e)) return e;
}
function T2(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function R2(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, s = !1, o, i;
    try {
      for (n = n.call(e); !(a = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); a = !0)
        ;
    } catch (c) {
      s = !0, i = c;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (s) throw i;
      }
    }
    return r;
  }
}
function lb(e, t) {
  if (e) {
    if (typeof e == "string") return Bi(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Bi(e, t);
  }
}
function Bi(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function O2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function M2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Wu = function() {
}, pc = {}, cb = {}, ub = null, db = {
  mark: Wu,
  measure: Wu
};
try {
  typeof window < "u" && (pc = window), typeof document < "u" && (cb = document), typeof MutationObserver < "u" && (ub = MutationObserver), typeof performance < "u" && (db = performance);
} catch {
}
var A2 = pc.navigator || {}, Vu = A2.userAgent, Yu = Vu === void 0 ? "" : Vu, cn = pc, De = cb, Gu = ub, za = db;
cn.document;
var Yt = !!De.documentElement && !!De.head && typeof De.addEventListener == "function" && typeof De.createElement == "function", fb = ~Yu.indexOf("MSIE") || ~Yu.indexOf("Trident/"), Fa, Ha, Ba, qa, Ua, Ht = "___FONT_AWESOME___", qi = 16, bb = "fa", mb = "svg-inline--fa", On = "data-fa-i2svg", Ui = "data-fa-pseudo-element", P2 = "data-fa-pseudo-element-pending", jc = "data-prefix", vc = "data-icon", Ku = "fontawesome-i2svg", N2 = "async", D2 = ["HTML", "HEAD", "STYLE", "SCRIPT"], _b = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), Ne = "classic", qe = "sharp", hc = [Ne, qe];
function wa(e) {
  return new Proxy(e, {
    get: function(n, r) {
      return r in n ? n[r] : n[Ne];
    }
  });
}
var ra = wa((Fa = {}, Ge(Fa, Ne, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  fakd: "kit",
  "fa-kit": "kit",
  "fa-kit-duotone": "kit"
}), Ge(Fa, qe, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light",
  fast: "thin",
  "fa-thin": "thin"
}), Fa)), aa = wa((Ha = {}, Ge(Ha, Ne, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), Ge(Ha, qe, {
  solid: "fass",
  regular: "fasr",
  light: "fasl",
  thin: "fast"
}), Ha)), sa = wa((Ba = {}, Ge(Ba, Ne, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), Ge(Ba, qe, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light",
  fast: "fa-thin"
}), Ba)), I2 = wa((qa = {}, Ge(qa, Ne, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), Ge(qa, qe, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl",
  "fa-thin": "fast"
}), qa)), $2 = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/, pb = "fa-layers-text", L2 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, z2 = wa((Ua = {}, Ge(Ua, Ne, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), Ge(Ua, qe, {
  900: "fass",
  400: "fasr",
  300: "fasl",
  100: "fast"
}), Ua)), jb = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], F2 = jb.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), H2 = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], kn = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, oa = /* @__PURE__ */ new Set();
Object.keys(aa[Ne]).map(oa.add.bind(oa));
Object.keys(aa[qe]).map(oa.add.bind(oa));
var B2 = [].concat(hc, ya(oa), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", kn.GROUP, kn.SWAP_OPACITY, kn.PRIMARY, kn.SECONDARY]).concat(jb.map(function(e) {
  return "".concat(e, "x");
})).concat(F2.map(function(e) {
  return "w-".concat(e);
})), Zr = cn.FontAwesomeConfig || {};
function q2(e) {
  var t = De.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function U2(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
if (De && typeof De.querySelector == "function") {
  var W2 = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  W2.forEach(function(e) {
    var t = _c(e, 2), n = t[0], r = t[1], a = U2(q2(n));
    a != null && (Zr[r] = a);
  });
}
var vb = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: bb,
  replacementClass: mb,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
Zr.familyPrefix && (Zr.cssPrefix = Zr.familyPrefix);
var fr = ae(ae({}, vb), Zr);
fr.autoReplaceSvg || (fr.observeMutations = !1);
var oe = {};
Object.keys(vb).forEach(function(e) {
  Object.defineProperty(oe, e, {
    enumerable: !0,
    set: function(n) {
      fr[e] = n, Jr.forEach(function(r) {
        return r(oe);
      });
    },
    get: function() {
      return fr[e];
    }
  });
});
Object.defineProperty(oe, "familyPrefix", {
  enumerable: !0,
  set: function(t) {
    fr.cssPrefix = t, Jr.forEach(function(n) {
      return n(oe);
    });
  },
  get: function() {
    return fr.cssPrefix;
  }
});
cn.FontAwesomeConfig = oe;
var Jr = [];
function V2(e) {
  return Jr.push(e), function() {
    Jr.splice(Jr.indexOf(e), 1);
  };
}
var Jt = qi, Ot = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function Y2(e) {
  if (!(!e || !Yt)) {
    var t = De.createElement("style");
    t.setAttribute("type", "text/css"), t.innerHTML = e;
    for (var n = De.head.childNodes, r = null, a = n.length - 1; a > -1; a--) {
      var s = n[a], o = (s.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(o) > -1 && (r = s);
    }
    return De.head.insertBefore(t, r), e;
  }
}
var G2 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function ia() {
  for (var e = 12, t = ""; e-- > 0; )
    t += G2[Math.random() * 62 | 0];
  return t;
}
function Cr(e) {
  for (var t = [], n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function gc(e) {
  return e.classList ? Cr(e.classList) : (e.getAttribute("class") || "").split(" ").filter(function(t) {
    return t;
  });
}
function hb(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function K2(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t + "".concat(n, '="').concat(hb(e[n]), '" ');
  }, "").trim();
}
function oo(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t + "".concat(n, ": ").concat(e[n].trim(), ";");
  }, "");
}
function yc(e) {
  return e.size !== Ot.size || e.x !== Ot.x || e.y !== Ot.y || e.rotate !== Ot.rotate || e.flipX || e.flipY;
}
function X2(e) {
  var t = e.transform, n = e.containerWidth, r = e.iconWidth, a = {
    transform: "translate(".concat(n / 2, " 256)")
  }, s = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), o = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), i = "rotate(".concat(t.rotate, " 0 0)"), c = {
    transform: "".concat(s, " ").concat(o, " ").concat(i)
  }, u = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: a,
    inner: c,
    path: u
  };
}
function Z2(e) {
  var t = e.transform, n = e.width, r = n === void 0 ? qi : n, a = e.height, s = a === void 0 ? qi : a, o = e.startCentered, i = o === void 0 ? !1 : o, c = "";
  return i && fb ? c += "translate(".concat(t.x / Jt - r / 2, "em, ").concat(t.y / Jt - s / 2, "em) ") : i ? c += "translate(calc(-50% + ".concat(t.x / Jt, "em), calc(-50% + ").concat(t.y / Jt, "em)) ") : c += "translate(".concat(t.x / Jt, "em, ").concat(t.y / Jt, "em) "), c += "scale(".concat(t.size / Jt * (t.flipX ? -1 : 1), ", ").concat(t.size / Jt * (t.flipY ? -1 : 1), ") "), c += "rotate(".concat(t.rotate, "deg) "), c;
}
var J2 = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function gb() {
  var e = bb, t = mb, n = oe.cssPrefix, r = oe.replacementClass, a = J2;
  if (n !== e || r !== t) {
    var s = new RegExp("\\.".concat(e, "\\-"), "g"), o = new RegExp("\\--".concat(e, "\\-"), "g"), i = new RegExp("\\.".concat(t), "g");
    a = a.replace(s, ".".concat(n, "-")).replace(o, "--".concat(n, "-")).replace(i, ".".concat(r));
  }
  return a;
}
var Xu = !1;
function Yo() {
  oe.autoAddCss && !Xu && (Y2(gb()), Xu = !0);
}
var Q2 = {
  mixout: function() {
    return {
      dom: {
        css: gb,
        insertCss: Yo
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        Yo();
      },
      beforeI2svg: function() {
        Yo();
      }
    };
  }
}, Bt = cn || {};
Bt[Ht] || (Bt[Ht] = {});
Bt[Ht].styles || (Bt[Ht].styles = {});
Bt[Ht].hooks || (Bt[Ht].hooks = {});
Bt[Ht].shims || (Bt[Ht].shims = []);
var yt = Bt[Ht], yb = [], ev = function e() {
  De.removeEventListener("DOMContentLoaded", e), Os = 1, yb.map(function(t) {
    return t();
  });
}, Os = !1;
Yt && (Os = (De.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(De.readyState), Os || De.addEventListener("DOMContentLoaded", ev));
function tv(e) {
  Yt && (Os ? setTimeout(e, 0) : yb.push(e));
}
function Ca(e) {
  var t = e.tag, n = e.attributes, r = n === void 0 ? {} : n, a = e.children, s = a === void 0 ? [] : a;
  return typeof e == "string" ? hb(e) : "<".concat(t, " ").concat(K2(r), ">").concat(s.map(Ca).join(""), "</").concat(t, ">");
}
function Zu(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var Go = function(t, n, r, a) {
  var s = Object.keys(t), o = s.length, i = n, c, u, f;
  for (r === void 0 ? (c = 1, f = t[s[0]]) : (c = 0, f = r); c < o; c++)
    u = s[c], f = i(f, t[u], u, t);
  return f;
};
function nv(e) {
  for (var t = [], n = 0, r = e.length; n < r; ) {
    var a = e.charCodeAt(n++);
    if (a >= 55296 && a <= 56319 && n < r) {
      var s = e.charCodeAt(n++);
      (s & 64512) == 56320 ? t.push(((a & 1023) << 10) + (s & 1023) + 65536) : (t.push(a), n--);
    } else
      t.push(a);
  }
  return t;
}
function Wi(e) {
  var t = nv(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function rv(e, t) {
  var n = e.length, r = e.charCodeAt(t), a;
  return r >= 55296 && r <= 56319 && n > t + 1 && (a = e.charCodeAt(t + 1), a >= 56320 && a <= 57343) ? (r - 55296) * 1024 + a - 56320 + 65536 : r;
}
function Ju(e) {
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n], a = !!r.icon;
    return a ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function Vi(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.skipHooks, a = r === void 0 ? !1 : r, s = Ju(t);
  typeof yt.hooks.addPack == "function" && !a ? yt.hooks.addPack(e, Ju(t)) : yt.styles[e] = ae(ae({}, yt.styles[e] || {}), s), e === "fas" && Vi("fa", t);
}
var Wa, Va, Ya, Jn = yt.styles, av = yt.shims, sv = (Wa = {}, Ge(Wa, Ne, Object.values(sa[Ne])), Ge(Wa, qe, Object.values(sa[qe])), Wa), wc = null, wb = {}, Cb = {}, Eb = {}, xb = {}, Sb = {}, ov = (Va = {}, Ge(Va, Ne, Object.keys(ra[Ne])), Ge(Va, qe, Object.keys(ra[qe])), Va);
function iv(e) {
  return ~B2.indexOf(e);
}
function lv(e, t) {
  var n = t.split("-"), r = n[0], a = n.slice(1).join("-");
  return r === e && a !== "" && !iv(a) ? a : null;
}
var kb = function() {
  var t = function(s) {
    return Go(Jn, function(o, i, c) {
      return o[c] = Go(i, s, {}), o;
    }, {});
  };
  wb = t(function(a, s, o) {
    if (s[3] && (a[s[3]] = o), s[2]) {
      var i = s[2].filter(function(c) {
        return typeof c == "number";
      });
      i.forEach(function(c) {
        a[c.toString(16)] = o;
      });
    }
    return a;
  }), Cb = t(function(a, s, o) {
    if (a[o] = o, s[2]) {
      var i = s[2].filter(function(c) {
        return typeof c == "string";
      });
      i.forEach(function(c) {
        a[c] = o;
      });
    }
    return a;
  }), Sb = t(function(a, s, o) {
    var i = s[2];
    return a[o] = o, i.forEach(function(c) {
      a[c] = o;
    }), a;
  });
  var n = "far" in Jn || oe.autoFetchSvg, r = Go(av, function(a, s) {
    var o = s[0], i = s[1], c = s[2];
    return i === "far" && !n && (i = "fas"), typeof o == "string" && (a.names[o] = {
      prefix: i,
      iconName: c
    }), typeof o == "number" && (a.unicodes[o.toString(16)] = {
      prefix: i,
      iconName: c
    }), a;
  }, {
    names: {},
    unicodes: {}
  });
  Eb = r.names, xb = r.unicodes, wc = io(oe.styleDefault, {
    family: oe.familyDefault
  });
};
V2(function(e) {
  wc = io(e.styleDefault, {
    family: oe.familyDefault
  });
});
kb();
function Cc(e, t) {
  return (wb[e] || {})[t];
}
function cv(e, t) {
  return (Cb[e] || {})[t];
}
function Tn(e, t) {
  return (Sb[e] || {})[t];
}
function Tb(e) {
  return Eb[e] || {
    prefix: null,
    iconName: null
  };
}
function uv(e) {
  var t = xb[e], n = Cc("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function un() {
  return wc;
}
var Ec = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function io(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.family, r = n === void 0 ? Ne : n, a = ra[r][e], s = aa[r][e] || aa[r][a], o = e in yt.styles ? e : null;
  return s || o || null;
}
var Qu = (Ya = {}, Ge(Ya, Ne, Object.keys(sa[Ne])), Ge(Ya, qe, Object.keys(sa[qe])), Ya);
function lo(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.skipLookups, a = r === void 0 ? !1 : r, s = (t = {}, Ge(t, Ne, "".concat(oe.cssPrefix, "-").concat(Ne)), Ge(t, qe, "".concat(oe.cssPrefix, "-").concat(qe)), t), o = null, i = Ne;
  (e.includes(s[Ne]) || e.some(function(u) {
    return Qu[Ne].includes(u);
  })) && (i = Ne), (e.includes(s[qe]) || e.some(function(u) {
    return Qu[qe].includes(u);
  })) && (i = qe);
  var c = e.reduce(function(u, f) {
    var m = lv(oe.cssPrefix, f);
    if (Jn[f] ? (f = sv[i].includes(f) ? I2[i][f] : f, o = f, u.prefix = f) : ov[i].indexOf(f) > -1 ? (o = f, u.prefix = io(f, {
      family: i
    })) : m ? u.iconName = m : f !== oe.replacementClass && f !== s[Ne] && f !== s[qe] && u.rest.push(f), !a && u.prefix && u.iconName) {
      var b = o === "fa" ? Tb(u.iconName) : {}, _ = Tn(u.prefix, u.iconName);
      b.prefix && (o = null), u.iconName = b.iconName || _ || u.iconName, u.prefix = b.prefix || u.prefix, u.prefix === "far" && !Jn.far && Jn.fas && !oe.autoFetchSvg && (u.prefix = "fas");
    }
    return u;
  }, Ec());
  return (e.includes("fa-brands") || e.includes("fab")) && (c.prefix = "fab"), (e.includes("fa-duotone") || e.includes("fad")) && (c.prefix = "fad"), !c.prefix && i === qe && (Jn.fass || oe.autoFetchSvg) && (c.prefix = "fass", c.iconName = Tn(c.prefix, c.iconName) || c.iconName), (c.prefix === "fa" || o === "fa") && (c.prefix = un() || "fas"), c;
}
var dv = /* @__PURE__ */ function() {
  function e() {
    C2(this, e), this.definitions = {};
  }
  return x2(e, [{
    key: "add",
    value: function() {
      for (var n = this, r = arguments.length, a = new Array(r), s = 0; s < r; s++)
        a[s] = arguments[s];
      var o = a.reduce(this._pullDefinitions, {});
      Object.keys(o).forEach(function(i) {
        n.definitions[i] = ae(ae({}, n.definitions[i] || {}), o[i]), Vi(i, o[i]);
        var c = sa[Ne][i];
        c && Vi(c, o[i]), kb();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(n, r) {
      var a = r.prefix && r.iconName && r.icon ? {
        0: r
      } : r;
      return Object.keys(a).map(function(s) {
        var o = a[s], i = o.prefix, c = o.iconName, u = o.icon, f = u[2];
        n[i] || (n[i] = {}), f.length > 0 && f.forEach(function(m) {
          typeof m == "string" && (n[i][m] = u);
        }), n[i][c] = u;
      }), n;
    }
  }]), e;
}(), e1 = [], Qn = {}, ar = {}, fv = Object.keys(ar);
function bv(e, t) {
  var n = t.mixoutsTo;
  return e1 = e, Qn = {}, Object.keys(ar).forEach(function(r) {
    fv.indexOf(r) === -1 && delete ar[r];
  }), e1.forEach(function(r) {
    var a = r.mixout ? r.mixout() : {};
    if (Object.keys(a).forEach(function(o) {
      typeof a[o] == "function" && (n[o] = a[o]), Rs(a[o]) === "object" && Object.keys(a[o]).forEach(function(i) {
        n[o] || (n[o] = {}), n[o][i] = a[o][i];
      });
    }), r.hooks) {
      var s = r.hooks();
      Object.keys(s).forEach(function(o) {
        Qn[o] || (Qn[o] = []), Qn[o].push(s[o]);
      });
    }
    r.provides && r.provides(ar);
  }), n;
}
function Yi(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    r[a - 2] = arguments[a];
  var s = Qn[e] || [];
  return s.forEach(function(o) {
    t = o.apply(null, [t].concat(r));
  }), t;
}
function Mn(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var a = Qn[e] || [];
  a.forEach(function(s) {
    s.apply(null, n);
  });
}
function qt() {
  var e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return ar[e] ? ar[e].apply(null, t) : void 0;
}
function Gi(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  var t = e.iconName, n = e.prefix || un();
  if (t)
    return t = Tn(n, t) || t, Zu(Rb.definitions, n, t) || Zu(yt.styles, n, t);
}
var Rb = new dv(), mv = function() {
  oe.autoReplaceSvg = !1, oe.observeMutations = !1, Mn("noAuto");
}, _v = {
  i2svg: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Yt ? (Mn("beforeI2svg", t), qt("pseudoElements2svg", t), qt("i2svg", t)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.autoReplaceSvgRoot;
    oe.autoReplaceSvg === !1 && (oe.autoReplaceSvg = !0), oe.observeMutations = !0, tv(function() {
      jv({
        autoReplaceSvgRoot: n
      }), Mn("watch", t);
    });
  }
}, pv = {
  icon: function(t) {
    if (t === null)
      return null;
    if (Rs(t) === "object" && t.prefix && t.iconName)
      return {
        prefix: t.prefix,
        iconName: Tn(t.prefix, t.iconName) || t.iconName
      };
    if (Array.isArray(t) && t.length === 2) {
      var n = t[1].indexOf("fa-") === 0 ? t[1].slice(3) : t[1], r = io(t[0]);
      return {
        prefix: r,
        iconName: Tn(r, n) || n
      };
    }
    if (typeof t == "string" && (t.indexOf("".concat(oe.cssPrefix, "-")) > -1 || t.match($2))) {
      var a = lo(t.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: a.prefix || un(),
        iconName: Tn(a.prefix, a.iconName) || a.iconName
      };
    }
    if (typeof t == "string") {
      var s = un();
      return {
        prefix: s,
        iconName: Tn(s, t) || t
      };
    }
  }
}, ct = {
  noAuto: mv,
  config: oe,
  dom: _v,
  parse: pv,
  library: Rb,
  findIconDefinition: Gi,
  toHtml: Ca
}, jv = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.autoReplaceSvgRoot, r = n === void 0 ? De : n;
  (Object.keys(yt.styles).length > 0 || oe.autoFetchSvg) && Yt && oe.autoReplaceSvg && ct.dom.i2svg({
    node: r
  });
};
function co(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map(function(r) {
        return Ca(r);
      });
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (Yt) {
        var r = De.createElement("div");
        return r.innerHTML = e.html, r.children;
      }
    }
  }), e;
}
function vv(e) {
  var t = e.children, n = e.main, r = e.mask, a = e.attributes, s = e.styles, o = e.transform;
  if (yc(o) && n.found && !r.found) {
    var i = n.width, c = n.height, u = {
      x: i / c / 2,
      y: 0.5
    };
    a.style = oo(ae(ae({}, s), {}, {
      "transform-origin": "".concat(u.x + o.x / 16, "em ").concat(u.y + o.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: a,
    children: t
  }];
}
function hv(e) {
  var t = e.prefix, n = e.iconName, r = e.children, a = e.attributes, s = e.symbol, o = s === !0 ? "".concat(t, "-").concat(oe.cssPrefix, "-").concat(n) : s;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: ae(ae({}, a), {}, {
        id: o
      }),
      children: r
    }]
  }];
}
function xc(e) {
  var t = e.icons, n = t.main, r = t.mask, a = e.prefix, s = e.iconName, o = e.transform, i = e.symbol, c = e.title, u = e.maskId, f = e.titleId, m = e.extra, b = e.watchable, _ = b === void 0 ? !1 : b, j = r.found ? r : n, p = j.width, v = j.height, h = a === "fak", g = [oe.replacementClass, s ? "".concat(oe.cssPrefix, "-").concat(s) : ""].filter(function(k) {
    return m.classes.indexOf(k) === -1;
  }).filter(function(k) {
    return k !== "" || !!k;
  }).concat(m.classes).join(" "), w = {
    children: [],
    attributes: ae(ae({}, m.attributes), {}, {
      "data-prefix": a,
      "data-icon": s,
      class: g,
      role: m.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(p, " ").concat(v)
    })
  }, x = h && !~m.classes.indexOf("fa-fw") ? {
    width: "".concat(p / v * 16 * 0.0625, "em")
  } : {};
  _ && (w.attributes[On] = ""), c && (w.children.push({
    tag: "title",
    attributes: {
      id: w.attributes["aria-labelledby"] || "title-".concat(f || ia())
    },
    children: [c]
  }), delete w.attributes.title);
  var y = ae(ae({}, w), {}, {
    prefix: a,
    iconName: s,
    main: n,
    mask: r,
    maskId: u,
    transform: o,
    symbol: i,
    styles: ae(ae({}, x), m.styles)
  }), E = r.found && n.found ? qt("generateAbstractMask", y) || {
    children: [],
    attributes: {}
  } : qt("generateAbstractIcon", y) || {
    children: [],
    attributes: {}
  }, C = E.children, S = E.attributes;
  return y.children = C, y.attributes = S, i ? hv(y) : vv(y);
}
function t1(e) {
  var t = e.content, n = e.width, r = e.height, a = e.transform, s = e.title, o = e.extra, i = e.watchable, c = i === void 0 ? !1 : i, u = ae(ae(ae({}, o.attributes), s ? {
    title: s
  } : {}), {}, {
    class: o.classes.join(" ")
  });
  c && (u[On] = "");
  var f = ae({}, o.styles);
  yc(a) && (f.transform = Z2({
    transform: a,
    startCentered: !0,
    width: n,
    height: r
  }), f["-webkit-transform"] = f.transform);
  var m = oo(f);
  m.length > 0 && (u.style = m);
  var b = [];
  return b.push({
    tag: "span",
    attributes: u,
    children: [t]
  }), s && b.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [s]
  }), b;
}
function gv(e) {
  var t = e.content, n = e.title, r = e.extra, a = ae(ae(ae({}, r.attributes), n ? {
    title: n
  } : {}), {}, {
    class: r.classes.join(" ")
  }), s = oo(r.styles);
  s.length > 0 && (a.style = s);
  var o = [];
  return o.push({
    tag: "span",
    attributes: a,
    children: [t]
  }), n && o.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), o;
}
var Ko = yt.styles;
function Ki(e) {
  var t = e[0], n = e[1], r = e.slice(4), a = _c(r, 1), s = a[0], o = null;
  return Array.isArray(s) ? o = {
    tag: "g",
    attributes: {
      class: "".concat(oe.cssPrefix, "-").concat(kn.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(oe.cssPrefix, "-").concat(kn.SECONDARY),
        fill: "currentColor",
        d: s[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(oe.cssPrefix, "-").concat(kn.PRIMARY),
        fill: "currentColor",
        d: s[1]
      }
    }]
  } : o = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: s
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: o
  };
}
var yv = {
  found: !1,
  width: 512,
  height: 512
};
function wv(e, t) {
  !_b && !oe.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function Xi(e, t) {
  var n = t;
  return t === "fa" && oe.styleDefault !== null && (t = un()), new Promise(function(r, a) {
    if (qt("missingIconAbstract"), n === "fa") {
      var s = Tb(e) || {};
      e = s.iconName || e, t = s.prefix || t;
    }
    if (e && t && Ko[t] && Ko[t][e]) {
      var o = Ko[t][e];
      return r(Ki(o));
    }
    wv(e, t), r(ae(ae({}, yv), {}, {
      icon: oe.showMissingIcons && e ? qt("missingIconAbstract") || {} : {}
    }));
  });
}
var n1 = function() {
}, Zi = oe.measurePerformance && za && za.mark && za.measure ? za : {
  mark: n1,
  measure: n1
}, Vr = 'FA "6.5.1"', Cv = function(t) {
  return Zi.mark("".concat(Vr, " ").concat(t, " begins")), function() {
    return Ob(t);
  };
}, Ob = function(t) {
  Zi.mark("".concat(Vr, " ").concat(t, " ends")), Zi.measure("".concat(Vr, " ").concat(t), "".concat(Vr, " ").concat(t, " begins"), "".concat(Vr, " ").concat(t, " ends"));
}, Sc = {
  begin: Cv,
  end: Ob
}, js = function() {
};
function r1(e) {
  var t = e.getAttribute ? e.getAttribute(On) : null;
  return typeof t == "string";
}
function Ev(e) {
  var t = e.getAttribute ? e.getAttribute(jc) : null, n = e.getAttribute ? e.getAttribute(vc) : null;
  return t && n;
}
function xv(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(oe.replacementClass);
}
function Sv() {
  if (oe.autoReplaceSvg === !0)
    return vs.replace;
  var e = vs[oe.autoReplaceSvg];
  return e || vs.replace;
}
function kv(e) {
  return De.createElementNS("http://www.w3.org/2000/svg", e);
}
function Tv(e) {
  return De.createElement(e);
}
function Mb(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.ceFn, r = n === void 0 ? e.tag === "svg" ? kv : Tv : n;
  if (typeof e == "string")
    return De.createTextNode(e);
  var a = r(e.tag);
  Object.keys(e.attributes || []).forEach(function(o) {
    a.setAttribute(o, e.attributes[o]);
  });
  var s = e.children || [];
  return s.forEach(function(o) {
    a.appendChild(Mb(o, {
      ceFn: r
    }));
  }), a;
}
function Rv(e) {
  var t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
var vs = {
  replace: function(t) {
    var n = t[0];
    if (n.parentNode)
      if (t[1].forEach(function(a) {
        n.parentNode.insertBefore(Mb(a), n);
      }), n.getAttribute(On) === null && oe.keepOriginalSource) {
        var r = De.createComment(Rv(n));
        n.parentNode.replaceChild(r, n);
      } else
        n.remove();
  },
  nest: function(t) {
    var n = t[0], r = t[1];
    if (~gc(n).indexOf(oe.replacementClass))
      return vs.replace(t);
    var a = new RegExp("".concat(oe.cssPrefix, "-.*"));
    if (delete r[0].attributes.id, r[0].attributes.class) {
      var s = r[0].attributes.class.split(" ").reduce(function(i, c) {
        return c === oe.replacementClass || c.match(a) ? i.toSvg.push(c) : i.toNode.push(c), i;
      }, {
        toNode: [],
        toSvg: []
      });
      r[0].attributes.class = s.toSvg.join(" "), s.toNode.length === 0 ? n.removeAttribute("class") : n.setAttribute("class", s.toNode.join(" "));
    }
    var o = r.map(function(i) {
      return Ca(i);
    }).join(`
`);
    n.setAttribute(On, ""), n.innerHTML = o;
  }
};
function a1(e) {
  e();
}
function Ab(e, t) {
  var n = typeof t == "function" ? t : js;
  if (e.length === 0)
    n();
  else {
    var r = a1;
    oe.mutateApproach === N2 && (r = cn.requestAnimationFrame || a1), r(function() {
      var a = Sv(), s = Sc.begin("mutate");
      e.map(a), s(), n();
    });
  }
}
var kc = !1;
function Pb() {
  kc = !0;
}
function Ji() {
  kc = !1;
}
var Ms = null;
function s1(e) {
  if (Gu && oe.observeMutations) {
    var t = e.treeCallback, n = t === void 0 ? js : t, r = e.nodeCallback, a = r === void 0 ? js : r, s = e.pseudoElementsCallback, o = s === void 0 ? js : s, i = e.observeMutationsRoot, c = i === void 0 ? De : i;
    Ms = new Gu(function(u) {
      if (!kc) {
        var f = un();
        Cr(u).forEach(function(m) {
          if (m.type === "childList" && m.addedNodes.length > 0 && !r1(m.addedNodes[0]) && (oe.searchPseudoElements && o(m.target), n(m.target)), m.type === "attributes" && m.target.parentNode && oe.searchPseudoElements && o(m.target.parentNode), m.type === "attributes" && r1(m.target) && ~H2.indexOf(m.attributeName))
            if (m.attributeName === "class" && Ev(m.target)) {
              var b = lo(gc(m.target)), _ = b.prefix, j = b.iconName;
              m.target.setAttribute(jc, _ || f), j && m.target.setAttribute(vc, j);
            } else xv(m.target) && a(m.target);
        });
      }
    }), Yt && Ms.observe(c, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function Ov() {
  Ms && Ms.disconnect();
}
function Mv(e) {
  var t = e.getAttribute("style"), n = [];
  return t && (n = t.split(";").reduce(function(r, a) {
    var s = a.split(":"), o = s[0], i = s.slice(1);
    return o && i.length > 0 && (r[o] = i.join(":").trim()), r;
  }, {})), n;
}
function Av(e) {
  var t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "", a = lo(gc(e));
  return a.prefix || (a.prefix = un()), t && n && (a.prefix = t, a.iconName = n), a.iconName && a.prefix || (a.prefix && r.length > 0 && (a.iconName = cv(a.prefix, e.innerText) || Cc(a.prefix, Wi(e.innerText))), !a.iconName && oe.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (a.iconName = e.firstChild.data)), a;
}
function Pv(e) {
  var t = Cr(e.attributes).reduce(function(a, s) {
    return a.name !== "class" && a.name !== "style" && (a[s.name] = s.value), a;
  }, {}), n = e.getAttribute("title"), r = e.getAttribute("data-fa-title-id");
  return oe.autoA11y && (n ? t["aria-labelledby"] = "".concat(oe.replacementClass, "-title-").concat(r || ia()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function Nv() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Ot,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function o1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, n = Av(e), r = n.iconName, a = n.prefix, s = n.rest, o = Pv(e), i = Yi("parseNodeAttributes", {}, e), c = t.styleParser ? Mv(e) : [];
  return ae({
    iconName: r,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: a,
    transform: Ot,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: s,
      styles: c,
      attributes: o
    }
  }, i);
}
var Dv = yt.styles;
function Nb(e) {
  var t = oe.autoReplaceSvg === "nest" ? o1(e, {
    styleParser: !1
  }) : o1(e);
  return ~t.extra.classes.indexOf(pb) ? qt("generateLayersText", e, t) : qt("generateSvgReplacementMutation", e, t);
}
var dn = /* @__PURE__ */ new Set();
hc.map(function(e) {
  dn.add("fa-".concat(e));
});
Object.keys(ra[Ne]).map(dn.add.bind(dn));
Object.keys(ra[qe]).map(dn.add.bind(dn));
dn = ya(dn);
function i1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!Yt) return Promise.resolve();
  var n = De.documentElement.classList, r = function(m) {
    return n.add("".concat(Ku, "-").concat(m));
  }, a = function(m) {
    return n.remove("".concat(Ku, "-").concat(m));
  }, s = oe.autoFetchSvg ? dn : hc.map(function(f) {
    return "fa-".concat(f);
  }).concat(Object.keys(Dv));
  s.includes("fa") || s.push("fa");
  var o = [".".concat(pb, ":not([").concat(On, "])")].concat(s.map(function(f) {
    return ".".concat(f, ":not([").concat(On, "])");
  })).join(", ");
  if (o.length === 0)
    return Promise.resolve();
  var i = [];
  try {
    i = Cr(e.querySelectorAll(o));
  } catch {
  }
  if (i.length > 0)
    r("pending"), a("complete");
  else
    return Promise.resolve();
  var c = Sc.begin("onTree"), u = i.reduce(function(f, m) {
    try {
      var b = Nb(m);
      b && f.push(b);
    } catch (_) {
      _b || _.name === "MissingIcon" && console.error(_);
    }
    return f;
  }, []);
  return new Promise(function(f, m) {
    Promise.all(u).then(function(b) {
      Ab(b, function() {
        r("active"), r("complete"), a("pending"), typeof t == "function" && t(), c(), f();
      });
    }).catch(function(b) {
      c(), m(b);
    });
  });
}
function Iv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  Nb(e).then(function(n) {
    n && Ab([n], t);
  });
}
function $v(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = (t || {}).icon ? t : Gi(t || {}), a = n.mask;
    return a && (a = (a || {}).icon ? a : Gi(a || {})), e(r, ae(ae({}, n), {}, {
      mask: a
    }));
  };
}
var Lv = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.transform, a = r === void 0 ? Ot : r, s = n.symbol, o = s === void 0 ? !1 : s, i = n.mask, c = i === void 0 ? null : i, u = n.maskId, f = u === void 0 ? null : u, m = n.title, b = m === void 0 ? null : m, _ = n.titleId, j = _ === void 0 ? null : _, p = n.classes, v = p === void 0 ? [] : p, h = n.attributes, g = h === void 0 ? {} : h, w = n.styles, x = w === void 0 ? {} : w;
  if (t) {
    var y = t.prefix, E = t.iconName, C = t.icon;
    return co(ae({
      type: "icon"
    }, t), function() {
      return Mn("beforeDOMElementCreation", {
        iconDefinition: t,
        params: n
      }), oe.autoA11y && (b ? g["aria-labelledby"] = "".concat(oe.replacementClass, "-title-").concat(j || ia()) : (g["aria-hidden"] = "true", g.focusable = "false")), xc({
        icons: {
          main: Ki(C),
          mask: c ? Ki(c.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: y,
        iconName: E,
        transform: ae(ae({}, Ot), a),
        symbol: o,
        title: b,
        maskId: f,
        titleId: j,
        extra: {
          attributes: g,
          styles: x,
          classes: v
        }
      });
    });
  }
}, zv = {
  mixout: function() {
    return {
      icon: $v(Lv)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.treeCallback = i1, n.nodeCallback = Iv, n;
      }
    };
  },
  provides: function(t) {
    t.i2svg = function(n) {
      var r = n.node, a = r === void 0 ? De : r, s = n.callback, o = s === void 0 ? function() {
      } : s;
      return i1(a, o);
    }, t.generateSvgReplacementMutation = function(n, r) {
      var a = r.iconName, s = r.title, o = r.titleId, i = r.prefix, c = r.transform, u = r.symbol, f = r.mask, m = r.maskId, b = r.extra;
      return new Promise(function(_, j) {
        Promise.all([Xi(a, i), f.iconName ? Xi(f.iconName, f.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(p) {
          var v = _c(p, 2), h = v[0], g = v[1];
          _([n, xc({
            icons: {
              main: h,
              mask: g
            },
            prefix: i,
            iconName: a,
            transform: c,
            symbol: u,
            maskId: m,
            title: s,
            titleId: o,
            extra: b,
            watchable: !0
          })]);
        }).catch(j);
      });
    }, t.generateAbstractIcon = function(n) {
      var r = n.children, a = n.attributes, s = n.main, o = n.transform, i = n.styles, c = oo(i);
      c.length > 0 && (a.style = c);
      var u;
      return yc(o) && (u = qt("generateAbstractTransformGrouping", {
        main: s,
        transform: o,
        containerWidth: s.width,
        iconWidth: s.width
      })), r.push(u || s.icon), {
        children: r,
        attributes: a
      };
    };
  }
}, Fv = {
  mixout: function() {
    return {
      layer: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.classes, s = a === void 0 ? [] : a;
        return co({
          type: "layer"
        }, function() {
          Mn("beforeDOMElementCreation", {
            assembler: n,
            params: r
          });
          var o = [];
          return n(function(i) {
            Array.isArray(i) ? i.map(function(c) {
              o = o.concat(c.abstract);
            }) : o = o.concat(i.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(oe.cssPrefix, "-layers")].concat(ya(s)).join(" ")
            },
            children: o
          }];
        });
      }
    };
  }
}, Hv = {
  mixout: function() {
    return {
      counter: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.title, s = a === void 0 ? null : a, o = r.classes, i = o === void 0 ? [] : o, c = r.attributes, u = c === void 0 ? {} : c, f = r.styles, m = f === void 0 ? {} : f;
        return co({
          type: "counter",
          content: n
        }, function() {
          return Mn("beforeDOMElementCreation", {
            content: n,
            params: r
          }), gv({
            content: n.toString(),
            title: s,
            extra: {
              attributes: u,
              styles: m,
              classes: ["".concat(oe.cssPrefix, "-layers-counter")].concat(ya(i))
            }
          });
        });
      }
    };
  }
}, Bv = {
  mixout: function() {
    return {
      text: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.transform, s = a === void 0 ? Ot : a, o = r.title, i = o === void 0 ? null : o, c = r.classes, u = c === void 0 ? [] : c, f = r.attributes, m = f === void 0 ? {} : f, b = r.styles, _ = b === void 0 ? {} : b;
        return co({
          type: "text",
          content: n
        }, function() {
          return Mn("beforeDOMElementCreation", {
            content: n,
            params: r
          }), t1({
            content: n,
            transform: ae(ae({}, Ot), s),
            title: i,
            extra: {
              attributes: m,
              styles: _,
              classes: ["".concat(oe.cssPrefix, "-layers-text")].concat(ya(u))
            }
          });
        });
      }
    };
  },
  provides: function(t) {
    t.generateLayersText = function(n, r) {
      var a = r.title, s = r.transform, o = r.extra, i = null, c = null;
      if (fb) {
        var u = parseInt(getComputedStyle(n).fontSize, 10), f = n.getBoundingClientRect();
        i = f.width / u, c = f.height / u;
      }
      return oe.autoA11y && !a && (o.attributes["aria-hidden"] = "true"), Promise.resolve([n, t1({
        content: n.innerHTML,
        width: i,
        height: c,
        transform: s,
        title: a,
        extra: o,
        watchable: !0
      })]);
    };
  }
}, qv = new RegExp('"', "ug"), l1 = [1105920, 1112319];
function Uv(e) {
  var t = e.replace(qv, ""), n = rv(t, 0), r = n >= l1[0] && n <= l1[1], a = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: Wi(a ? t[0] : t),
    isSecondary: r || a
  };
}
function c1(e, t) {
  var n = "".concat(P2).concat(t.replace(":", "-"));
  return new Promise(function(r, a) {
    if (e.getAttribute(n) !== null)
      return r();
    var s = Cr(e.children), o = s.filter(function(C) {
      return C.getAttribute(Ui) === t;
    })[0], i = cn.getComputedStyle(e, t), c = i.getPropertyValue("font-family").match(L2), u = i.getPropertyValue("font-weight"), f = i.getPropertyValue("content");
    if (o && !c)
      return e.removeChild(o), r();
    if (c && f !== "none" && f !== "") {
      var m = i.getPropertyValue("content"), b = ~["Sharp"].indexOf(c[2]) ? qe : Ne, _ = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(c[2]) ? aa[b][c[2].toLowerCase()] : z2[b][u], j = Uv(m), p = j.value, v = j.isSecondary, h = c[0].startsWith("FontAwesome"), g = Cc(_, p), w = g;
      if (h) {
        var x = uv(p);
        x.iconName && x.prefix && (g = x.iconName, _ = x.prefix);
      }
      if (g && !v && (!o || o.getAttribute(jc) !== _ || o.getAttribute(vc) !== w)) {
        e.setAttribute(n, w), o && e.removeChild(o);
        var y = Nv(), E = y.extra;
        E.attributes[Ui] = t, Xi(g, _).then(function(C) {
          var S = xc(ae(ae({}, y), {}, {
            icons: {
              main: C,
              mask: Ec()
            },
            prefix: _,
            iconName: w,
            extra: E,
            watchable: !0
          })), k = De.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(k, e.firstChild) : e.appendChild(k), k.outerHTML = S.map(function(O) {
            return Ca(O);
          }).join(`
`), e.removeAttribute(n), r();
        }).catch(a);
      } else
        r();
    } else
      r();
  });
}
function Wv(e) {
  return Promise.all([c1(e, "::before"), c1(e, "::after")]);
}
function Vv(e) {
  return e.parentNode !== document.head && !~D2.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Ui) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function u1(e) {
  if (Yt)
    return new Promise(function(t, n) {
      var r = Cr(e.querySelectorAll("*")).filter(Vv).map(Wv), a = Sc.begin("searchPseudoElements");
      Pb(), Promise.all(r).then(function() {
        a(), Ji(), t();
      }).catch(function() {
        a(), Ji(), n();
      });
    });
}
var Yv = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.pseudoElementsCallback = u1, n;
      }
    };
  },
  provides: function(t) {
    t.pseudoElements2svg = function(n) {
      var r = n.node, a = r === void 0 ? De : r;
      oe.searchPseudoElements && u1(a);
    };
  }
}, d1 = !1, Gv = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          Pb(), d1 = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        s1(Yi("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        Ov();
      },
      watch: function(n) {
        var r = n.observeMutationsRoot;
        d1 ? Ji() : s1(Yi("mutationObserverCallbacks", {
          observeMutationsRoot: r
        }));
      }
    };
  }
}, f1 = function(t) {
  var n = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return t.toLowerCase().split(" ").reduce(function(r, a) {
    var s = a.toLowerCase().split("-"), o = s[0], i = s.slice(1).join("-");
    if (o && i === "h")
      return r.flipX = !0, r;
    if (o && i === "v")
      return r.flipY = !0, r;
    if (i = parseFloat(i), isNaN(i))
      return r;
    switch (o) {
      case "grow":
        r.size = r.size + i;
        break;
      case "shrink":
        r.size = r.size - i;
        break;
      case "left":
        r.x = r.x - i;
        break;
      case "right":
        r.x = r.x + i;
        break;
      case "up":
        r.y = r.y - i;
        break;
      case "down":
        r.y = r.y + i;
        break;
      case "rotate":
        r.rotate = r.rotate + i;
        break;
    }
    return r;
  }, n);
}, Kv = {
  mixout: function() {
    return {
      parse: {
        transform: function(n) {
          return f1(n);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var a = r.getAttribute("data-fa-transform");
        return a && (n.transform = f1(a)), n;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractTransformGrouping = function(n) {
      var r = n.main, a = n.transform, s = n.containerWidth, o = n.iconWidth, i = {
        transform: "translate(".concat(s / 2, " 256)")
      }, c = "translate(".concat(a.x * 32, ", ").concat(a.y * 32, ") "), u = "scale(".concat(a.size / 16 * (a.flipX ? -1 : 1), ", ").concat(a.size / 16 * (a.flipY ? -1 : 1), ") "), f = "rotate(".concat(a.rotate, " 0 0)"), m = {
        transform: "".concat(c, " ").concat(u, " ").concat(f)
      }, b = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, _ = {
        outer: i,
        inner: m,
        path: b
      };
      return {
        tag: "g",
        attributes: ae({}, _.outer),
        children: [{
          tag: "g",
          attributes: ae({}, _.inner),
          children: [{
            tag: r.icon.tag,
            children: r.icon.children,
            attributes: ae(ae({}, r.icon.attributes), _.path)
          }]
        }]
      };
    };
  }
}, Xo = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function b1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function Xv(e) {
  return e.tag === "g" ? e.children : [e];
}
var Zv = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var a = r.getAttribute("data-fa-mask"), s = a ? lo(a.split(" ").map(function(o) {
          return o.trim();
        })) : Ec();
        return s.prefix || (s.prefix = un()), n.mask = s, n.maskId = r.getAttribute("data-fa-mask-id"), n;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractMask = function(n) {
      var r = n.children, a = n.attributes, s = n.main, o = n.mask, i = n.maskId, c = n.transform, u = s.width, f = s.icon, m = o.width, b = o.icon, _ = X2({
        transform: c,
        containerWidth: m,
        iconWidth: u
      }), j = {
        tag: "rect",
        attributes: ae(ae({}, Xo), {}, {
          fill: "white"
        })
      }, p = f.children ? {
        children: f.children.map(b1)
      } : {}, v = {
        tag: "g",
        attributes: ae({}, _.inner),
        children: [b1(ae({
          tag: f.tag,
          attributes: ae(ae({}, f.attributes), _.path)
        }, p))]
      }, h = {
        tag: "g",
        attributes: ae({}, _.outer),
        children: [v]
      }, g = "mask-".concat(i || ia()), w = "clip-".concat(i || ia()), x = {
        tag: "mask",
        attributes: ae(ae({}, Xo), {}, {
          id: g,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [j, h]
      }, y = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: w
          },
          children: Xv(b)
        }, x]
      };
      return r.push(y, {
        tag: "rect",
        attributes: ae({
          fill: "currentColor",
          "clip-path": "url(#".concat(w, ")"),
          mask: "url(#".concat(g, ")")
        }, Xo)
      }), {
        children: r,
        attributes: a
      };
    };
  }
}, Jv = {
  provides: function(t) {
    var n = !1;
    cn.matchMedia && (n = cn.matchMedia("(prefers-reduced-motion: reduce)").matches), t.missingIconAbstract = function() {
      var r = [], a = {
        fill: "currentColor"
      }, s = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      r.push({
        tag: "path",
        attributes: ae(ae({}, a), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var o = ae(ae({}, s), {}, {
        attributeName: "opacity"
      }), i = {
        tag: "circle",
        attributes: ae(ae({}, a), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return n || i.children.push({
        tag: "animate",
        attributes: ae(ae({}, s), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: ae(ae({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), r.push(i), r.push({
        tag: "path",
        attributes: ae(ae({}, a), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: n ? [] : [{
          tag: "animate",
          attributes: ae(ae({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), n || r.push({
        tag: "path",
        attributes: ae(ae({}, a), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: ae(ae({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: r
      };
    };
  }
}, Qv = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var a = r.getAttribute("data-fa-symbol"), s = a === null ? !1 : a === "" ? !0 : a;
        return n.symbol = s, n;
      }
    };
  }
}, eh = [Q2, zv, Fv, Hv, Bv, Yv, Gv, Kv, Zv, Jv, Qv];
bv(eh, {
  mixoutsTo: ct
});
ct.noAuto;
ct.config;
ct.library;
ct.dom;
var Qi = ct.parse;
ct.findIconDefinition;
ct.toHtml;
var th = ct.icon;
ct.layer;
ct.text;
ct.counter;
var In = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function jn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var el = { exports: {} }, Ga = { exports: {} }, Se = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m1;
function nh() {
  if (m1) return Se;
  m1 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, j = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, h = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function w(y) {
    if (typeof y == "object" && y !== null) {
      var E = y.$$typeof;
      switch (E) {
        case t:
          switch (y = y.type, y) {
            case c:
            case u:
            case r:
            case s:
            case a:
            case m:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case i:
                case f:
                case j:
                case _:
                case o:
                  return y;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function x(y) {
    return w(y) === u;
  }
  return Se.AsyncMode = c, Se.ConcurrentMode = u, Se.ContextConsumer = i, Se.ContextProvider = o, Se.Element = t, Se.ForwardRef = f, Se.Fragment = r, Se.Lazy = j, Se.Memo = _, Se.Portal = n, Se.Profiler = s, Se.StrictMode = a, Se.Suspense = m, Se.isAsyncMode = function(y) {
    return x(y) || w(y) === c;
  }, Se.isConcurrentMode = x, Se.isContextConsumer = function(y) {
    return w(y) === i;
  }, Se.isContextProvider = function(y) {
    return w(y) === o;
  }, Se.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, Se.isForwardRef = function(y) {
    return w(y) === f;
  }, Se.isFragment = function(y) {
    return w(y) === r;
  }, Se.isLazy = function(y) {
    return w(y) === j;
  }, Se.isMemo = function(y) {
    return w(y) === _;
  }, Se.isPortal = function(y) {
    return w(y) === n;
  }, Se.isProfiler = function(y) {
    return w(y) === s;
  }, Se.isStrictMode = function(y) {
    return w(y) === a;
  }, Se.isSuspense = function(y) {
    return w(y) === m;
  }, Se.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === u || y === s || y === a || y === m || y === b || typeof y == "object" && y !== null && (y.$$typeof === j || y.$$typeof === _ || y.$$typeof === o || y.$$typeof === i || y.$$typeof === f || y.$$typeof === v || y.$$typeof === h || y.$$typeof === g || y.$$typeof === p);
  }, Se.typeOf = w, Se;
}
var ke = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _1;
function rh() {
  return _1 || (_1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, j = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, h = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function w(X) {
      return typeof X == "string" || typeof X == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      X === r || X === u || X === s || X === a || X === m || X === b || typeof X == "object" && X !== null && (X.$$typeof === j || X.$$typeof === _ || X.$$typeof === o || X.$$typeof === i || X.$$typeof === f || X.$$typeof === v || X.$$typeof === h || X.$$typeof === g || X.$$typeof === p);
    }
    function x(X) {
      if (typeof X == "object" && X !== null) {
        var ie = X.$$typeof;
        switch (ie) {
          case t:
            var Ce = X.type;
            switch (Ce) {
              case c:
              case u:
              case r:
              case s:
              case a:
              case m:
                return Ce;
              default:
                var ge = Ce && Ce.$$typeof;
                switch (ge) {
                  case i:
                  case f:
                  case j:
                  case _:
                  case o:
                    return ge;
                  default:
                    return ie;
                }
            }
          case n:
            return ie;
        }
      }
    }
    var y = c, E = u, C = i, S = o, k = t, O = f, L = r, H = j, T = _, R = n, M = s, D = a, I = m, F = !1;
    function P(X) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(X) || x(X) === c;
    }
    function A(X) {
      return x(X) === u;
    }
    function $(X) {
      return x(X) === i;
    }
    function B(X) {
      return x(X) === o;
    }
    function Y(X) {
      return typeof X == "object" && X !== null && X.$$typeof === t;
    }
    function J(X) {
      return x(X) === f;
    }
    function W(X) {
      return x(X) === r;
    }
    function V(X) {
      return x(X) === j;
    }
    function K(X) {
      return x(X) === _;
    }
    function te(X) {
      return x(X) === n;
    }
    function Z(X) {
      return x(X) === s;
    }
    function se(X) {
      return x(X) === a;
    }
    function ue(X) {
      return x(X) === m;
    }
    ke.AsyncMode = y, ke.ConcurrentMode = E, ke.ContextConsumer = C, ke.ContextProvider = S, ke.Element = k, ke.ForwardRef = O, ke.Fragment = L, ke.Lazy = H, ke.Memo = T, ke.Portal = R, ke.Profiler = M, ke.StrictMode = D, ke.Suspense = I, ke.isAsyncMode = P, ke.isConcurrentMode = A, ke.isContextConsumer = $, ke.isContextProvider = B, ke.isElement = Y, ke.isForwardRef = J, ke.isFragment = W, ke.isLazy = V, ke.isMemo = K, ke.isPortal = te, ke.isProfiler = Z, ke.isStrictMode = se, ke.isSuspense = ue, ke.isValidElementType = w, ke.typeOf = x;
  }()), ke;
}
var p1;
function Db() {
  return p1 || (p1 = 1, process.env.NODE_ENV === "production" ? Ga.exports = nh() : Ga.exports = rh()), Ga.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Zo, j1;
function ah() {
  if (j1) return Zo;
  j1 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var o = {}, i = 0; i < 10; i++)
        o["_" + String.fromCharCode(i)] = i;
      var c = Object.getOwnPropertyNames(o).map(function(f) {
        return o[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        u[f] = f;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Zo = a() ? Object.assign : function(s, o) {
    for (var i, c = r(s), u, f = 1; f < arguments.length; f++) {
      i = Object(arguments[f]);
      for (var m in i)
        t.call(i, m) && (c[m] = i[m]);
      if (e) {
        u = e(i);
        for (var b = 0; b < u.length; b++)
          n.call(i, u[b]) && (c[u[b]] = i[u[b]]);
      }
    }
    return c;
  }, Zo;
}
var Jo, v1;
function Tc() {
  if (v1) return Jo;
  v1 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Jo = e, Jo;
}
var Qo, h1;
function Ib() {
  return h1 || (h1 = 1, Qo = Function.call.bind(Object.prototype.hasOwnProperty)), Qo;
}
var ei, g1;
function sh() {
  if (g1) return ei;
  g1 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Tc(), n = {}, r = Ib();
    e = function(s) {
      var o = "Warning: " + s;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(s, o, i, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in s)
        if (r(s, f)) {
          var m;
          try {
            if (typeof s[f] != "function") {
              var b = Error(
                (c || "React class") + ": " + i + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw b.name = "Invariant Violation", b;
            }
            m = s[f](o, f, c, i, null, t);
          } catch (j) {
            m = j;
          }
          if (m && !(m instanceof Error) && e(
            (c || "React class") + ": type specification of " + i + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), m instanceof Error && !(m.message in n)) {
            n[m.message] = !0;
            var _ = u ? u() : "";
            e(
              "Failed " + i + " type: " + m.message + (_ ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, ei = a, ei;
}
var ti, y1;
function oh() {
  if (y1) return ti;
  y1 = 1;
  var e = Db(), t = ah(), n = Tc(), r = Ib(), a = sh(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(i) {
    var c = "Warning: " + i;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return ti = function(i, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function m(A) {
      var $ = A && (u && A[u] || A[f]);
      if (typeof $ == "function")
        return $;
    }
    var b = "<<anonymous>>", _ = {
      array: h("array"),
      bigint: h("bigint"),
      bool: h("boolean"),
      func: h("function"),
      number: h("number"),
      object: h("object"),
      string: h("string"),
      symbol: h("symbol"),
      any: g(),
      arrayOf: w,
      element: x(),
      elementType: y(),
      instanceOf: E,
      node: O(),
      objectOf: S,
      oneOf: C,
      oneOfType: k,
      shape: H,
      exact: T
    };
    function j(A, $) {
      return A === $ ? A !== 0 || 1 / A === 1 / $ : A !== A && $ !== $;
    }
    function p(A, $) {
      this.message = A, this.data = $ && typeof $ == "object" ? $ : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function v(A) {
      if (process.env.NODE_ENV !== "production")
        var $ = {}, B = 0;
      function Y(W, V, K, te, Z, se, ue) {
        if (te = te || b, se = se || K, ue !== n) {
          if (c) {
            var X = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw X.name = "Invariant Violation", X;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ie = te + ":" + K;
            !$[ie] && // Avoid spamming the console because they are often not actionable except for lib authors
            B < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + se + "` prop on `" + te + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), $[ie] = !0, B++);
          }
        }
        return V[K] == null ? W ? V[K] === null ? new p("The " + Z + " `" + se + "` is marked as required " + ("in `" + te + "`, but its value is `null`.")) : new p("The " + Z + " `" + se + "` is marked as required in " + ("`" + te + "`, but its value is `undefined`.")) : null : A(V, K, te, Z, se);
      }
      var J = Y.bind(null, !1);
      return J.isRequired = Y.bind(null, !0), J;
    }
    function h(A) {
      function $(B, Y, J, W, V, K) {
        var te = B[Y], Z = D(te);
        if (Z !== A) {
          var se = I(te);
          return new p(
            "Invalid " + W + " `" + V + "` of type " + ("`" + se + "` supplied to `" + J + "`, expected ") + ("`" + A + "`."),
            { expectedType: A }
          );
        }
        return null;
      }
      return v($);
    }
    function g() {
      return v(o);
    }
    function w(A) {
      function $(B, Y, J, W, V) {
        if (typeof A != "function")
          return new p("Property `" + V + "` of component `" + J + "` has invalid PropType notation inside arrayOf.");
        var K = B[Y];
        if (!Array.isArray(K)) {
          var te = D(K);
          return new p("Invalid " + W + " `" + V + "` of type " + ("`" + te + "` supplied to `" + J + "`, expected an array."));
        }
        for (var Z = 0; Z < K.length; Z++) {
          var se = A(K, Z, J, W, V + "[" + Z + "]", n);
          if (se instanceof Error)
            return se;
        }
        return null;
      }
      return v($);
    }
    function x() {
      function A($, B, Y, J, W) {
        var V = $[B];
        if (!i(V)) {
          var K = D(V);
          return new p("Invalid " + J + " `" + W + "` of type " + ("`" + K + "` supplied to `" + Y + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(A);
    }
    function y() {
      function A($, B, Y, J, W) {
        var V = $[B];
        if (!e.isValidElementType(V)) {
          var K = D(V);
          return new p("Invalid " + J + " `" + W + "` of type " + ("`" + K + "` supplied to `" + Y + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(A);
    }
    function E(A) {
      function $(B, Y, J, W, V) {
        if (!(B[Y] instanceof A)) {
          var K = A.name || b, te = P(B[Y]);
          return new p("Invalid " + W + " `" + V + "` of type " + ("`" + te + "` supplied to `" + J + "`, expected ") + ("instance of `" + K + "`."));
        }
        return null;
      }
      return v($);
    }
    function C(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), o;
      function $(B, Y, J, W, V) {
        for (var K = B[Y], te = 0; te < A.length; te++)
          if (j(K, A[te]))
            return null;
        var Z = JSON.stringify(A, function(ue, X) {
          var ie = I(X);
          return ie === "symbol" ? String(X) : X;
        });
        return new p("Invalid " + W + " `" + V + "` of value `" + String(K) + "` " + ("supplied to `" + J + "`, expected one of " + Z + "."));
      }
      return v($);
    }
    function S(A) {
      function $(B, Y, J, W, V) {
        if (typeof A != "function")
          return new p("Property `" + V + "` of component `" + J + "` has invalid PropType notation inside objectOf.");
        var K = B[Y], te = D(K);
        if (te !== "object")
          return new p("Invalid " + W + " `" + V + "` of type " + ("`" + te + "` supplied to `" + J + "`, expected an object."));
        for (var Z in K)
          if (r(K, Z)) {
            var se = A(K, Z, J, W, V + "." + Z, n);
            if (se instanceof Error)
              return se;
          }
        return null;
      }
      return v($);
    }
    function k(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var $ = 0; $ < A.length; $++) {
        var B = A[$];
        if (typeof B != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + F(B) + " at index " + $ + "."
          ), o;
      }
      function Y(J, W, V, K, te) {
        for (var Z = [], se = 0; se < A.length; se++) {
          var ue = A[se], X = ue(J, W, V, K, te, n);
          if (X == null)
            return null;
          X.data && r(X.data, "expectedType") && Z.push(X.data.expectedType);
        }
        var ie = Z.length > 0 ? ", expected one of type [" + Z.join(", ") + "]" : "";
        return new p("Invalid " + K + " `" + te + "` supplied to " + ("`" + V + "`" + ie + "."));
      }
      return v(Y);
    }
    function O() {
      function A($, B, Y, J, W) {
        return R($[B]) ? null : new p("Invalid " + J + " `" + W + "` supplied to " + ("`" + Y + "`, expected a ReactNode."));
      }
      return v(A);
    }
    function L(A, $, B, Y, J) {
      return new p(
        (A || "React class") + ": " + $ + " type `" + B + "." + Y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + J + "`."
      );
    }
    function H(A) {
      function $(B, Y, J, W, V) {
        var K = B[Y], te = D(K);
        if (te !== "object")
          return new p("Invalid " + W + " `" + V + "` of type `" + te + "` " + ("supplied to `" + J + "`, expected `object`."));
        for (var Z in A) {
          var se = A[Z];
          if (typeof se != "function")
            return L(J, W, V, Z, I(se));
          var ue = se(K, Z, J, W, V + "." + Z, n);
          if (ue)
            return ue;
        }
        return null;
      }
      return v($);
    }
    function T(A) {
      function $(B, Y, J, W, V) {
        var K = B[Y], te = D(K);
        if (te !== "object")
          return new p("Invalid " + W + " `" + V + "` of type `" + te + "` " + ("supplied to `" + J + "`, expected `object`."));
        var Z = t({}, B[Y], A);
        for (var se in Z) {
          var ue = A[se];
          if (r(A, se) && typeof ue != "function")
            return L(J, W, V, se, I(ue));
          if (!ue)
            return new p(
              "Invalid " + W + " `" + V + "` key `" + se + "` supplied to `" + J + "`.\nBad object: " + JSON.stringify(B[Y], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(A), null, "  ")
            );
          var X = ue(K, se, J, W, V + "." + se, n);
          if (X)
            return X;
        }
        return null;
      }
      return v($);
    }
    function R(A) {
      switch (typeof A) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !A;
        case "object":
          if (Array.isArray(A))
            return A.every(R);
          if (A === null || i(A))
            return !0;
          var $ = m(A);
          if ($) {
            var B = $.call(A), Y;
            if ($ !== A.entries) {
              for (; !(Y = B.next()).done; )
                if (!R(Y.value))
                  return !1;
            } else
              for (; !(Y = B.next()).done; ) {
                var J = Y.value;
                if (J && !R(J[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function M(A, $) {
      return A === "symbol" ? !0 : $ ? $["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && $ instanceof Symbol : !1;
    }
    function D(A) {
      var $ = typeof A;
      return Array.isArray(A) ? "array" : A instanceof RegExp ? "object" : M($, A) ? "symbol" : $;
    }
    function I(A) {
      if (typeof A > "u" || A === null)
        return "" + A;
      var $ = D(A);
      if ($ === "object") {
        if (A instanceof Date)
          return "date";
        if (A instanceof RegExp)
          return "regexp";
      }
      return $;
    }
    function F(A) {
      var $ = I(A);
      switch ($) {
        case "array":
        case "object":
          return "an " + $;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + $;
        default:
          return $;
      }
    }
    function P(A) {
      return !A.constructor || !A.constructor.name ? b : A.constructor.name;
    }
    return _.checkPropTypes = a, _.resetWarningCache = a.resetWarningCache, _.PropTypes = _, _;
  }, ti;
}
var ni, w1;
function ih() {
  if (w1) return ni;
  w1 = 1;
  var e = Tc();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, ni = function() {
    function r(o, i, c, u, f, m) {
      if (m !== e) {
        var b = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw b.name = "Invariant Violation", b;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, ni;
}
if (process.env.NODE_ENV !== "production") {
  var lh = Db(), ch = !0;
  el.exports = oh()(lh.isElement, ch);
} else
  el.exports = ih()();
var uh = el.exports;
const pe = /* @__PURE__ */ jn(uh);
function C1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function rn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? C1(Object(n), !0).forEach(function(r) {
      er(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : C1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function As(e) {
  "@babel/helpers - typeof";
  return As = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, As(e);
}
function er(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function dh(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, s;
  for (s = 0; s < r.length; s++)
    a = r[s], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function fh(e, t) {
  if (e == null) return {};
  var n = dh(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (a = 0; a < s.length; a++)
      r = s[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function tl(e) {
  return bh(e) || mh(e) || _h(e) || ph();
}
function bh(e) {
  if (Array.isArray(e)) return nl(e);
}
function mh(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function _h(e, t) {
  if (e) {
    if (typeof e == "string") return nl(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nl(e, t);
  }
}
function nl(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function ph() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jh(e) {
  var t, n = e.beat, r = e.fade, a = e.beatFade, s = e.bounce, o = e.shake, i = e.flash, c = e.spin, u = e.spinPulse, f = e.spinReverse, m = e.pulse, b = e.fixedWidth, _ = e.inverse, j = e.border, p = e.listItem, v = e.flip, h = e.size, g = e.rotation, w = e.pull, x = (t = {
    "fa-beat": n,
    "fa-fade": r,
    "fa-beat-fade": a,
    "fa-bounce": s,
    "fa-shake": o,
    "fa-flash": i,
    "fa-spin": c,
    "fa-spin-reverse": f,
    "fa-spin-pulse": u,
    "fa-pulse": m,
    "fa-fw": b,
    "fa-inverse": _,
    "fa-border": j,
    "fa-li": p,
    "fa-flip": v === !0,
    "fa-flip-horizontal": v === "horizontal" || v === "both",
    "fa-flip-vertical": v === "vertical" || v === "both"
  }, er(t, "fa-".concat(h), typeof h < "u" && h !== null), er(t, "fa-rotate-".concat(g), typeof g < "u" && g !== null && g !== 0), er(t, "fa-pull-".concat(w), typeof w < "u" && w !== null), er(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(x).map(function(y) {
    return x[y] ? y : null;
  }).filter(function(y) {
    return y;
  });
}
function vh(e) {
  return e = e - 0, e === e;
}
function $b(e) {
  return vh(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, n) {
    return n ? n.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var hh = ["style"];
function gh(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function yh(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var r = n.indexOf(":"), a = $b(n.slice(0, r)), s = n.slice(r + 1).trim();
    return a.startsWith("webkit") ? t[gh(a)] = s : t[a] = s, t;
  }, {});
}
function Lb(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var r = (t.children || []).map(function(c) {
    return Lb(e, c);
  }), a = Object.keys(t.attributes || {}).reduce(function(c, u) {
    var f = t.attributes[u];
    switch (u) {
      case "class":
        c.attrs.className = f, delete t.attributes.class;
        break;
      case "style":
        c.attrs.style = yh(f);
        break;
      default:
        u.indexOf("aria-") === 0 || u.indexOf("data-") === 0 ? c.attrs[u.toLowerCase()] = f : c.attrs[$b(u)] = f;
    }
    return c;
  }, {
    attrs: {}
  }), s = n.style, o = s === void 0 ? {} : s, i = fh(n, hh);
  return a.attrs.style = rn(rn({}, a.attrs.style), o), e.apply(void 0, [t.tag, rn(rn({}, a.attrs), i)].concat(tl(r)));
}
var zb = !1;
try {
  zb = process.env.NODE_ENV === "production";
} catch {
}
function wh() {
  if (!zb && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function E1(e) {
  if (e && As(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (Qi.icon)
    return Qi.icon(e);
  if (e === null)
    return null;
  if (e && As(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function ri(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? er({}, e, t) : {};
}
var me = /* @__PURE__ */ l.forwardRef(function(e, t) {
  var n = e.icon, r = e.mask, a = e.symbol, s = e.className, o = e.title, i = e.titleId, c = e.maskId, u = E1(n), f = ri("classes", [].concat(tl(jh(e)), tl(s.split(" ")))), m = ri("transform", typeof e.transform == "string" ? Qi.transform(e.transform) : e.transform), b = ri("mask", E1(r)), _ = th(u, rn(rn(rn(rn({}, f), m), b), {}, {
    symbol: a,
    title: o,
    titleId: i,
    maskId: c
  }));
  if (!_)
    return wh("Could not find icon", u), null;
  var j = _.abstract, p = {
    ref: t
  };
  return Object.keys(e).forEach(function(v) {
    me.defaultProps.hasOwnProperty(v) || (p[v] = e[v]);
  }), Ch(j[0], p);
});
me.displayName = "FontAwesomeIcon";
me.propTypes = {
  beat: pe.bool,
  border: pe.bool,
  beatFade: pe.bool,
  bounce: pe.bool,
  className: pe.string,
  fade: pe.bool,
  flash: pe.bool,
  mask: pe.oneOfType([pe.object, pe.array, pe.string]),
  maskId: pe.string,
  fixedWidth: pe.bool,
  inverse: pe.bool,
  flip: pe.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: pe.oneOfType([pe.object, pe.array, pe.string]),
  listItem: pe.bool,
  pull: pe.oneOf(["right", "left"]),
  pulse: pe.bool,
  rotation: pe.oneOf([0, 90, 180, 270]),
  shake: pe.bool,
  size: pe.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: pe.bool,
  spinPulse: pe.bool,
  spinReverse: pe.bool,
  symbol: pe.oneOfType([pe.bool, pe.string]),
  title: pe.string,
  titleId: pe.string,
  transform: pe.oneOfType([pe.string, pe.object]),
  swapOpacity: pe.bool
};
me.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var Ch = Lb.bind(null, l.createElement);
/*!
 * Font Awesome Pro 5.15.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
var Eh = {
  prefix: "fas",
  iconName: "align-center",
  icon: [448, 512, [], "f037", "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"]
}, xh = {
  prefix: "fas",
  iconName: "align-justify",
  icon: [448, 512, [], "f039", "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
}, Sh = {
  prefix: "fas",
  iconName: "align-left",
  icon: [448, 512, [], "f036", "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
}, kh = {
  prefix: "fas",
  iconName: "align-right",
  icon: [448, 512, [], "f038", "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"]
}, Th = {
  prefix: "fas",
  iconName: "check-circle",
  icon: [512, 512, [], "f058", "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"]
}, Rh = {
  prefix: "fas",
  iconName: "chevron-circle-down",
  icon: [512, 512, [], "f13a", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"]
}, Oh = {
  prefix: "fas",
  iconName: "chevron-double-left",
  icon: [512, 512, [], "f323", "M34.5 239L228.9 44.7c9.4-9.4 24.6-9.4 33.9 0l22.7 22.7c9.4 9.4 9.4 24.5 0 33.9L131.5 256l154 154.7c9.3 9.4 9.3 24.5 0 33.9l-22.7 22.7c-9.4 9.4-24.6 9.4-33.9 0L34.5 273c-9.3-9.4-9.3-24.6 0-34zm192 34l194.3 194.3c9.4 9.4 24.6 9.4 33.9 0l22.7-22.7c9.4-9.4 9.4-24.5 0-33.9L323.5 256l154-154.7c9.3-9.4 9.3-24.5 0-33.9l-22.7-22.7c-9.4-9.4-24.6-9.4-33.9 0L226.5 239c-9.3 9.4-9.3 24.6 0 34z"]
}, Mh = {
  prefix: "fas",
  iconName: "chevron-double-right",
  icon: [512, 512, [], "f324", "M477.5 273L283.1 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.7-22.7c-9.4-9.4-9.4-24.5 0-33.9l154-154.7-154-154.7c-9.3-9.4-9.3-24.5 0-33.9l22.7-22.7c9.4-9.4 24.6-9.4 33.9 0L477.5 239c9.3 9.4 9.3 24.6 0 34zm-192-34L91.1 44.7c-9.4-9.4-24.6-9.4-33.9 0L34.5 67.4c-9.4 9.4-9.4 24.5 0 33.9l154 154.7-154 154.7c-9.3 9.4-9.3 24.5 0 33.9l22.7 22.7c9.4 9.4 24.6 9.4 33.9 0L285.5 273c9.3-9.4 9.3-24.6 0-34z"]
}, Ah = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [448, 512, [], "f078", "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"]
}, Fb = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [320, 512, [], "f053", "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"]
}, Ph = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [320, 512, [], "f054", "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"]
}, Nh = {
  prefix: "fas",
  iconName: "ellipsis-h",
  icon: [512, 512, [], "f141", "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"]
}, Dh = {
  prefix: "fas",
  iconName: "ellipsis-v",
  icon: [192, 512, [], "f142", "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"]
}, x1 = {
  prefix: "fas",
  iconName: "exclamation-triangle",
  icon: [576, 512, [], "f071", "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"]
}, Ih = {
  prefix: "fas",
  iconName: "file-code",
  icon: [384, 512, [], "f1c9", "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"]
}, $h = {
  prefix: "fas",
  iconName: "filter",
  icon: [512, 512, [], "f0b0", "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"]
}, Lh = {
  prefix: "fas",
  iconName: "h1",
  icon: [576, 512, [], "f313", "M304 96h-98.94A13.06 13.06 0 0 0 192 109.06v37.88A13.06 13.06 0 0 0 205.06 160H224v64H96v-64h18.94A13.06 13.06 0 0 0 128 146.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v34.94A13.06 13.06 0 0 0 13.06 160H32v192H13.06A13.06 13.06 0 0 0 0 365.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-37.88A13.06 13.06 0 0 0 114.94 352H96v-64h128v64h-18.94A13.06 13.06 0 0 0 192 365.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-34.94A13.06 13.06 0 0 0 306.94 352H288V160h18.94A13.06 13.06 0 0 0 320 146.94V112a16 16 0 0 0-16-16zm256 256h-48V120a24 24 0 0 0-24-24h-40a24 24 0 0 0-21.44 13.26l-24 48A24 24 0 0 0 424 192h24v160h-48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
}, zh = {
  prefix: "fas",
  iconName: "h2",
  icon: [576, 512, [], "f314", "M560 352H440.79c17-42.95 135.21-66.57 135.21-159.62C576 132.55 528.33 96 469.14 96c-43.83 0-81.41 21.38-103.42 57a15.66 15.66 0 0 0 4.75 21.4l28.26 18.6a16.15 16.15 0 0 0 21.86-3.83c10.77-14.86 24.94-26 43.85-26s38.22 10.46 38.22 33.84c0 52.18-142.1 73.21-142.1 184.56a155.06 155.06 0 0 0 1.71 20.66A15.94 15.94 0 0 0 378.14 416H560a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM304 96h-98.94A13.06 13.06 0 0 0 192 109.06v37.88A13.06 13.06 0 0 0 205.06 160H224v64H96v-64h18.94A13.06 13.06 0 0 0 128 146.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v34.94A13.06 13.06 0 0 0 13.06 160H32v192H13.06A13.06 13.06 0 0 0 0 365.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-37.88A13.06 13.06 0 0 0 114.94 352H96v-64h128v64h-18.94A13.06 13.06 0 0 0 192 365.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-34.94A13.06 13.06 0 0 0 306.94 352H288V160h18.94A13.06 13.06 0 0 0 320 146.94V112a16 16 0 0 0-16-16z"]
}, Fh = {
  prefix: "fas",
  iconName: "h3",
  icon: [576, 512, [], "f315", "M499 217.69l64.4-72.31a15.48 15.48 0 0 0 4-10.31v-23.32A16 16 0 0 0 551.12 96H384a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h85.18c-2.29 2.45-4.65 5-7.19 7.9l-53.1 61.1a18 18 0 0 0-3.83 10.17 18.36 18.36 0 0 0 1.38 6.34l8.41 18.59c2.35 5.21 9 9.42 14.84 9.42h15.95c28.94 0 57.79 10.32 57.79 38.48 0 21.32-19.93 36.79-47.39 36.79-22.08 0-41.18-9.17-57.7-22.83a16.46 16.46 0 0 0-23.87 3.34l-19.75 28.8a15.46 15.46 0 0 0 2.53 20.35C384.9 403.21 422 416 459.51 416c71 0 116.49-48.86 116.49-106.06 0-47.3-32.73-80.89-77-92.25zM304 96h-98.94A13.06 13.06 0 0 0 192 109.06v37.88A13.06 13.06 0 0 0 205.06 160H224v64H96v-64h18.94A13.06 13.06 0 0 0 128 146.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v34.94A13.06 13.06 0 0 0 13.06 160H32v192H13.06A13.06 13.06 0 0 0 0 365.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-37.88A13.06 13.06 0 0 0 114.94 352H96v-64h128v64h-18.94A13.06 13.06 0 0 0 192 365.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-34.94A13.06 13.06 0 0 0 306.94 352H288V160h18.94A13.06 13.06 0 0 0 320 146.94V112a16 16 0 0 0-16-16z"]
}, Hh = {
  prefix: "fas",
  iconName: "h4",
  icon: [576, 512, [], "f86a", "M304 96h-98.94A13.06 13.06 0 0 0 192 109.06v37.88A13.06 13.06 0 0 0 205.06 160H224v64H96v-64h18.94A13.06 13.06 0 0 0 128 146.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v34.94A13.06 13.06 0 0 0 13.06 160H32v192H13.06A13.06 13.06 0 0 0 0 365.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-37.88A13.06 13.06 0 0 0 114.94 352H96v-64h128v64h-18.94A13.06 13.06 0 0 0 192 365.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-34.94A13.06 13.06 0 0 0 306.94 352H288V160h18.94A13.06 13.06 0 0 0 320 146.94V112a16 16 0 0 0-16-16zm256 128h-16V112a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v112h-64V112a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v144a32 32 0 0 0 32 32h96v112a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
}, S1 = {
  prefix: "fas",
  iconName: "heading",
  icon: [512, 512, [], "f1dc", "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"]
}, Bh = {
  prefix: "fas",
  iconName: "link",
  icon: [512, 512, [], "f0c1", "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"]
}, qh = {
  prefix: "fas",
  iconName: "paragraph",
  icon: [448, 512, [], "f1dd", "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"]
}, Uh = {
  prefix: "fas",
  iconName: "sync-alt",
  icon: [512, 512, [], "f2f1", "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"]
}, Wh = {
  prefix: "fas",
  iconName: "table",
  icon: [512, 512, [], "f0ce", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"]
}, Vh = {
  prefix: "fas",
  iconName: "times",
  icon: [352, 512, [], "f00d", "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"]
}, Yh = {
  prefix: "fas",
  iconName: "unlink",
  icon: [512, 512, [], "f127", "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"]
};
function Ps(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function Gh(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Hb(...e) {
  return (t) => e.forEach((n) => Gh(n, t));
}
var rl = { exports: {} }, Hr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k1;
function Kh() {
  if (k1) return Hr;
  k1 = 1;
  var e = l, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(i, c, u) {
    var f, m = {}, b = null, _ = null;
    u !== void 0 && (b = "" + u), c.key !== void 0 && (b = "" + c.key), c.ref !== void 0 && (_ = c.ref);
    for (f in c) r.call(c, f) && !s.hasOwnProperty(f) && (m[f] = c[f]);
    if (i && i.defaultProps) for (f in c = i.defaultProps, c) m[f] === void 0 && (m[f] = c[f]);
    return { $$typeof: t, type: i, key: b, ref: _, props: m, _owner: a.current };
  }
  return Hr.Fragment = n, Hr.jsx = o, Hr.jsxs = o, Hr;
}
var Br = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var T1;
function Xh() {
  return T1 || (T1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = l, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), i = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), j = Symbol.iterator, p = "@@iterator";
    function v(N) {
      if (N === null || typeof N != "object")
        return null;
      var G = j && N[j] || N[p];
      return typeof G == "function" ? G : null;
    }
    var h = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(N) {
      {
        for (var G = arguments.length, ee = new Array(G > 1 ? G - 1 : 0), fe = 1; fe < G; fe++)
          ee[fe - 1] = arguments[fe];
        w("error", N, ee);
      }
    }
    function w(N, G, ee) {
      {
        var fe = h.ReactDebugCurrentFrame, xe = fe.getStackAddendum();
        xe !== "" && (G += "%s", ee = ee.concat([xe]));
        var Oe = ee.map(function(he) {
          return String(he);
        });
        Oe.unshift("Warning: " + G), Function.prototype.apply.call(console[N], console, Oe);
      }
    }
    var x = !1, y = !1, E = !1, C = !1, S = !1, k;
    k = Symbol.for("react.module.reference");
    function O(N) {
      return !!(typeof N == "string" || typeof N == "function" || N === r || N === s || S || N === a || N === u || N === f || C || N === _ || x || y || E || typeof N == "object" && N !== null && (N.$$typeof === b || N.$$typeof === m || N.$$typeof === o || N.$$typeof === i || N.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      N.$$typeof === k || N.getModuleId !== void 0));
    }
    function L(N, G, ee) {
      var fe = N.displayName;
      if (fe)
        return fe;
      var xe = G.displayName || G.name || "";
      return xe !== "" ? ee + "(" + xe + ")" : ee;
    }
    function H(N) {
      return N.displayName || "Context";
    }
    function T(N) {
      if (N == null)
        return null;
      if (typeof N.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof N == "function")
        return N.displayName || N.name || null;
      if (typeof N == "string")
        return N;
      switch (N) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case a:
          return "StrictMode";
        case u:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof N == "object")
        switch (N.$$typeof) {
          case i:
            var G = N;
            return H(G) + ".Consumer";
          case o:
            var ee = N;
            return H(ee._context) + ".Provider";
          case c:
            return L(N, N.render, "ForwardRef");
          case m:
            var fe = N.displayName || null;
            return fe !== null ? fe : T(N.type) || "Memo";
          case b: {
            var xe = N, Oe = xe._payload, he = xe._init;
            try {
              return T(he(Oe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var R = Object.assign, M = 0, D, I, F, P, A, $, B;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function J() {
      {
        if (M === 0) {
          D = console.log, I = console.info, F = console.warn, P = console.error, A = console.group, $ = console.groupCollapsed, B = console.groupEnd;
          var N = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: N,
            log: N,
            warn: N,
            error: N,
            group: N,
            groupCollapsed: N,
            groupEnd: N
          });
        }
        M++;
      }
    }
    function W() {
      {
        if (M--, M === 0) {
          var N = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: R({}, N, {
              value: D
            }),
            info: R({}, N, {
              value: I
            }),
            warn: R({}, N, {
              value: F
            }),
            error: R({}, N, {
              value: P
            }),
            group: R({}, N, {
              value: A
            }),
            groupCollapsed: R({}, N, {
              value: $
            }),
            groupEnd: R({}, N, {
              value: B
            })
          });
        }
        M < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var V = h.ReactCurrentDispatcher, K;
    function te(N, G, ee) {
      {
        if (K === void 0)
          try {
            throw Error();
          } catch (xe) {
            var fe = xe.stack.trim().match(/\n( *(at )?)/);
            K = fe && fe[1] || "";
          }
        return `
` + K + N;
      }
    }
    var Z = !1, se;
    {
      var ue = typeof WeakMap == "function" ? WeakMap : Map;
      se = new ue();
    }
    function X(N, G) {
      if (!N || Z)
        return "";
      {
        var ee = se.get(N);
        if (ee !== void 0)
          return ee;
      }
      var fe;
      Z = !0;
      var xe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Oe;
      Oe = V.current, V.current = null, J();
      try {
        if (G) {
          var he = function() {
            throw Error();
          };
          if (Object.defineProperty(he.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(he, []);
            } catch (st) {
              fe = st;
            }
            Reflect.construct(N, [], he);
          } else {
            try {
              he.call();
            } catch (st) {
              fe = st;
            }
            N.call(he.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (st) {
            fe = st;
          }
          N();
        }
      } catch (st) {
        if (st && fe && typeof st.stack == "string") {
          for (var je = st.stack.split(`
`), Qe = fe.stack.split(`
`), Ve = je.length - 1, Ye = Qe.length - 1; Ve >= 1 && Ye >= 0 && je[Ve] !== Qe[Ye]; )
            Ye--;
          for (; Ve >= 1 && Ye >= 0; Ve--, Ye--)
            if (je[Ve] !== Qe[Ye]) {
              if (Ve !== 1 || Ye !== 1)
                do
                  if (Ve--, Ye--, Ye < 0 || je[Ve] !== Qe[Ye]) {
                    var ft = `
` + je[Ve].replace(" at new ", " at ");
                    return N.displayName && ft.includes("<anonymous>") && (ft = ft.replace("<anonymous>", N.displayName)), typeof N == "function" && se.set(N, ft), ft;
                  }
                while (Ve >= 1 && Ye >= 0);
              break;
            }
        }
      } finally {
        Z = !1, V.current = Oe, W(), Error.prepareStackTrace = xe;
      }
      var Fn = N ? N.displayName || N.name : "", wn = Fn ? te(Fn) : "";
      return typeof N == "function" && se.set(N, wn), wn;
    }
    function ie(N, G, ee) {
      return X(N, !1);
    }
    function Ce(N) {
      var G = N.prototype;
      return !!(G && G.isReactComponent);
    }
    function ge(N, G, ee) {
      if (N == null)
        return "";
      if (typeof N == "function")
        return X(N, Ce(N));
      if (typeof N == "string")
        return te(N);
      switch (N) {
        case u:
          return te("Suspense");
        case f:
          return te("SuspenseList");
      }
      if (typeof N == "object")
        switch (N.$$typeof) {
          case c:
            return ie(N.render);
          case m:
            return ge(N.type, G, ee);
          case b: {
            var fe = N, xe = fe._payload, Oe = fe._init;
            try {
              return ge(Oe(xe), G, ee);
            } catch {
            }
          }
        }
      return "";
    }
    var Ee = Object.prototype.hasOwnProperty, He = {}, Re = h.ReactDebugCurrentFrame;
    function Ie(N) {
      if (N) {
        var G = N._owner, ee = ge(N.type, N._source, G ? G.type : null);
        Re.setExtraStackFrame(ee);
      } else
        Re.setExtraStackFrame(null);
    }
    function at(N, G, ee, fe, xe) {
      {
        var Oe = Function.call.bind(Ee);
        for (var he in N)
          if (Oe(N, he)) {
            var je = void 0;
            try {
              if (typeof N[he] != "function") {
                var Qe = Error((fe || "React class") + ": " + ee + " type `" + he + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof N[he] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Qe.name = "Invariant Violation", Qe;
              }
              je = N[he](G, he, fe, ee, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ve) {
              je = Ve;
            }
            je && !(je instanceof Error) && (Ie(xe), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", fe || "React class", ee, he, typeof je), Ie(null)), je instanceof Error && !(je.message in He) && (He[je.message] = !0, Ie(xe), g("Failed %s type: %s", ee, je.message), Ie(null));
          }
      }
    }
    var gn = Array.isArray;
    function Xt(N) {
      return gn(N);
    }
    function Dr(N) {
      {
        var G = typeof Symbol == "function" && Symbol.toStringTag, ee = G && N[Symbol.toStringTag] || N.constructor.name || "Object";
        return ee;
      }
    }
    function $o(N) {
      try {
        return Ir(N), !1;
      } catch {
        return !0;
      }
    }
    function Ir(N) {
      return "" + N;
    }
    function $r(N) {
      if ($o(N))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Dr(N)), Ir(N);
    }
    var Zt = h.ReactCurrentOwner, $a = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Lr, ce, Ke;
    Ke = {};
    function dt(N) {
      if (Ee.call(N, "ref")) {
        var G = Object.getOwnPropertyDescriptor(N, "ref").get;
        if (G && G.isReactWarning)
          return !1;
      }
      return N.ref !== void 0;
    }
    function Je(N) {
      if (Ee.call(N, "key")) {
        var G = Object.getOwnPropertyDescriptor(N, "key").get;
        if (G && G.isReactWarning)
          return !1;
      }
      return N.key !== void 0;
    }
    function yn(N, G) {
      if (typeof N.ref == "string" && Zt.current && G && Zt.current.stateNode !== G) {
        var ee = T(Zt.current.type);
        Ke[ee] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', T(Zt.current.type), N.ref), Ke[ee] = !0);
      }
    }
    function zr(N, G) {
      {
        var ee = function() {
          Lr || (Lr = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
        };
        ee.isReactWarning = !0, Object.defineProperty(N, "key", {
          get: ee,
          configurable: !0
        });
      }
    }
    function Fr(N, G) {
      {
        var ee = function() {
          ce || (ce = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
        };
        ee.isReactWarning = !0, Object.defineProperty(N, "ref", {
          get: ee,
          configurable: !0
        });
      }
    }
    var Lo = function(N, G, ee, fe, xe, Oe, he) {
      var je = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: N,
        key: G,
        ref: ee,
        props: he,
        // Record the component responsible for creating this element.
        _owner: Oe
      };
      return je._store = {}, Object.defineProperty(je._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(je, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: fe
      }), Object.defineProperty(je, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xe
      }), Object.freeze && (Object.freeze(je.props), Object.freeze(je)), je;
    };
    function La(N, G, ee, fe, xe) {
      {
        var Oe, he = {}, je = null, Qe = null;
        ee !== void 0 && ($r(ee), je = "" + ee), Je(G) && ($r(G.key), je = "" + G.key), dt(G) && (Qe = G.ref, yn(G, xe));
        for (Oe in G)
          Ee.call(G, Oe) && !$a.hasOwnProperty(Oe) && (he[Oe] = G[Oe]);
        if (N && N.defaultProps) {
          var Ve = N.defaultProps;
          for (Oe in Ve)
            he[Oe] === void 0 && (he[Oe] = Ve[Oe]);
        }
        if (je || Qe) {
          var Ye = typeof N == "function" ? N.displayName || N.name || "Unknown" : N;
          je && zr(he, Ye), Qe && Fr(he, Ye);
        }
        return Lo(N, je, Qe, xe, fe, Zt.current, he);
      }
    }
    var zo = h.ReactCurrentOwner, Mu = h.ReactDebugCurrentFrame;
    function zn(N) {
      if (N) {
        var G = N._owner, ee = ge(N.type, N._source, G ? G.type : null);
        Mu.setExtraStackFrame(ee);
      } else
        Mu.setExtraStackFrame(null);
    }
    var Fo;
    Fo = !1;
    function Ho(N) {
      return typeof N == "object" && N !== null && N.$$typeof === t;
    }
    function Au() {
      {
        if (zo.current) {
          var N = T(zo.current.type);
          if (N)
            return `

Check the render method of \`` + N + "`.";
        }
        return "";
      }
    }
    function H_(N) {
      return "";
    }
    var Pu = {};
    function B_(N) {
      {
        var G = Au();
        if (!G) {
          var ee = typeof N == "string" ? N : N.displayName || N.name;
          ee && (G = `

Check the top-level render call using <` + ee + ">.");
        }
        return G;
      }
    }
    function Nu(N, G) {
      {
        if (!N._store || N._store.validated || N.key != null)
          return;
        N._store.validated = !0;
        var ee = B_(G);
        if (Pu[ee])
          return;
        Pu[ee] = !0;
        var fe = "";
        N && N._owner && N._owner !== zo.current && (fe = " It was passed a child from " + T(N._owner.type) + "."), zn(N), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ee, fe), zn(null);
      }
    }
    function Du(N, G) {
      {
        if (typeof N != "object")
          return;
        if (Xt(N))
          for (var ee = 0; ee < N.length; ee++) {
            var fe = N[ee];
            Ho(fe) && Nu(fe, G);
          }
        else if (Ho(N))
          N._store && (N._store.validated = !0);
        else if (N) {
          var xe = v(N);
          if (typeof xe == "function" && xe !== N.entries)
            for (var Oe = xe.call(N), he; !(he = Oe.next()).done; )
              Ho(he.value) && Nu(he.value, G);
        }
      }
    }
    function q_(N) {
      {
        var G = N.type;
        if (G == null || typeof G == "string")
          return;
        var ee;
        if (typeof G == "function")
          ee = G.propTypes;
        else if (typeof G == "object" && (G.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        G.$$typeof === m))
          ee = G.propTypes;
        else
          return;
        if (ee) {
          var fe = T(G);
          at(ee, N.props, "prop", fe, N);
        } else if (G.PropTypes !== void 0 && !Fo) {
          Fo = !0;
          var xe = T(G);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", xe || "Unknown");
        }
        typeof G.getDefaultProps == "function" && !G.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function U_(N) {
      {
        for (var G = Object.keys(N.props), ee = 0; ee < G.length; ee++) {
          var fe = G[ee];
          if (fe !== "children" && fe !== "key") {
            zn(N), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", fe), zn(null);
            break;
          }
        }
        N.ref !== null && (zn(N), g("Invalid attribute `ref` supplied to `React.Fragment`."), zn(null));
      }
    }
    var Iu = {};
    function $u(N, G, ee, fe, xe, Oe) {
      {
        var he = O(N);
        if (!he) {
          var je = "";
          (N === void 0 || typeof N == "object" && N !== null && Object.keys(N).length === 0) && (je += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Qe = H_();
          Qe ? je += Qe : je += Au();
          var Ve;
          N === null ? Ve = "null" : Xt(N) ? Ve = "array" : N !== void 0 && N.$$typeof === t ? (Ve = "<" + (T(N.type) || "Unknown") + " />", je = " Did you accidentally export a JSX literal instead of a component?") : Ve = typeof N, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ve, je);
        }
        var Ye = La(N, G, ee, xe, Oe);
        if (Ye == null)
          return Ye;
        if (he) {
          var ft = G.children;
          if (ft !== void 0)
            if (fe)
              if (Xt(ft)) {
                for (var Fn = 0; Fn < ft.length; Fn++)
                  Du(ft[Fn], N);
                Object.freeze && Object.freeze(ft);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Du(ft, N);
        }
        if (Ee.call(G, "key")) {
          var wn = T(N), st = Object.keys(G).filter(function(X_) {
            return X_ !== "key";
          }), Bo = st.length > 0 ? "{key: someKey, " + st.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Iu[wn + Bo]) {
            var K_ = st.length > 0 ? "{" + st.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Bo, wn, K_, wn), Iu[wn + Bo] = !0;
          }
        }
        return N === r ? U_(Ye) : q_(Ye), Ye;
      }
    }
    function W_(N, G, ee) {
      return $u(N, G, ee, !0);
    }
    function V_(N, G, ee) {
      return $u(N, G, ee, !1);
    }
    var Y_ = V_, G_ = W_;
    Br.Fragment = r, Br.jsx = Y_, Br.jsxs = G_;
  }()), Br;
}
process.env.NODE_ENV === "production" ? rl.exports = Kh() : rl.exports = Xh();
var z = rl.exports;
function Zh(e, t = []) {
  let n = [];
  function r(s, o) {
    const i = d.createContext(o), c = n.length;
    n = [...n, o];
    function u(m) {
      const { scope: b, children: _, ...j } = m, p = (b == null ? void 0 : b[e][c]) || i, v = d.useMemo(() => j, Object.values(j));
      return /* @__PURE__ */ z.jsx(p.Provider, { value: v, children: _ });
    }
    function f(m, b) {
      const _ = (b == null ? void 0 : b[e][c]) || i, j = d.useContext(_);
      if (j) return j;
      if (o !== void 0) return o;
      throw new Error(`\`${m}\` must be used within \`${s}\``);
    }
    return u.displayName = s + "Provider", [u, f];
  }
  const a = () => {
    const s = n.map((o) => d.createContext(o));
    return function(i) {
      const c = (i == null ? void 0 : i[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: c } }),
        [i, c]
      );
    };
  };
  return a.scopeName = e, [r, Jh(a, ...t)];
}
function Jh(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(s) {
      const o = r.reduce((i, { useScope: c, scopeName: u }) => {
        const m = c(s)[`__scope${u}`];
        return { ...i, ...m };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Bb(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Qh({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = e0({ defaultProp: t, onChange: n }), s = e !== void 0, o = s ? e : r, i = Bb(n), c = d.useCallback(
    (u) => {
      if (s) {
        const m = typeof u == "function" ? u(e) : u;
        m !== e && i(m);
      } else
        a(u);
    },
    [s, e, a, i]
  );
  return [o, c];
}
function e0({
  defaultProp: e,
  onChange: t
}) {
  const n = d.useState(e), [r] = n, a = d.useRef(r), s = Bb(t);
  return d.useEffect(() => {
    a.current !== r && (s(r), a.current = r);
  }, [r, a, s]), n;
}
var qb = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = d.Children.toArray(n), s = a.find(n0);
  if (s) {
    const o = s.props.children, i = a.map((c) => c === s ? d.Children.count(o) > 1 ? d.Children.only(null) : d.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z.jsx(al, { ...r, ref: t, children: d.isValidElement(o) ? d.cloneElement(o, void 0, i) : null });
  }
  return /* @__PURE__ */ z.jsx(al, { ...r, ref: t, children: n });
});
qb.displayName = "Slot";
var al = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const a = a0(n);
    return d.cloneElement(n, {
      ...r0(r, n.props),
      // @ts-ignore
      ref: t ? Hb(t, a) : a
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
al.displayName = "SlotClone";
var t0 = ({ children: e }) => /* @__PURE__ */ z.jsx(z.Fragment, { children: e });
function n0(e) {
  return d.isValidElement(e) && e.type === t0;
}
function r0(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? a && s ? n[r] = (...i) => {
      s(...i), a(...i);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function a0(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var s0 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], o0 = s0.reduce((e, t) => {
  const n = d.forwardRef((r, a) => {
    const { asChild: s, ...o } = r, i = s ? qb : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ z.jsx(i, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function $e(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function i0(e, t = []) {
  let n = [];
  function r(s, o) {
    const i = d.createContext(o), c = n.length;
    n = [...n, o];
    function u(m) {
      const { scope: b, children: _, ...j } = m, p = (b == null ? void 0 : b[e][c]) || i, v = d.useMemo(() => j, Object.values(j));
      return /* @__PURE__ */ z.jsx(p.Provider, { value: v, children: _ });
    }
    function f(m, b) {
      const _ = (b == null ? void 0 : b[e][c]) || i, j = d.useContext(_);
      if (j) return j;
      if (o !== void 0) return o;
      throw new Error(`\`${m}\` must be used within \`${s}\``);
    }
    return u.displayName = s + "Provider", [u, f];
  }
  const a = () => {
    const s = n.map((o) => d.createContext(o));
    return function(i) {
      const c = (i == null ? void 0 : i[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: c } }),
        [i, c]
      );
    };
  };
  return a.scopeName = e, [r, l0(a, ...t)];
}
function l0(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(s) {
      const o = r.reduce((i, { useScope: c, scopeName: u }) => {
        const m = c(s)[`__scope${u}`];
        return { ...i, ...m };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function c0(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ub(...e) {
  return (t) => e.forEach((n) => c0(n, t));
}
function R1(...e) {
  return d.useCallback(Ub(...e), e);
}
var sl = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = d.Children.toArray(n), s = a.find(d0);
  if (s) {
    const o = s.props.children, i = a.map((c) => c === s ? d.Children.count(o) > 1 ? d.Children.only(null) : d.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z.jsx(ol, { ...r, ref: t, children: d.isValidElement(o) ? d.cloneElement(o, void 0, i) : null });
  }
  return /* @__PURE__ */ z.jsx(ol, { ...r, ref: t, children: n });
});
sl.displayName = "Slot";
var ol = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const a = b0(n);
    return d.cloneElement(n, {
      ...f0(r, n.props),
      // @ts-ignore
      ref: t ? Ub(t, a) : a
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
ol.displayName = "SlotClone";
var u0 = ({ children: e }) => /* @__PURE__ */ z.jsx(z.Fragment, { children: e });
function d0(e) {
  return d.isValidElement(e) && e.type === u0;
}
function f0(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? a && s ? n[r] = (...i) => {
      s(...i), a(...i);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function b0(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Wb(e) {
  const t = e + "CollectionProvider", [n, r] = i0(t), [a, s] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (_) => {
    const { scope: j, children: p } = _, v = l.useRef(null), h = l.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ z.jsx(a, { scope: j, itemMap: h, collectionRef: v, children: p });
  };
  o.displayName = t;
  const i = e + "CollectionSlot", c = l.forwardRef(
    (_, j) => {
      const { scope: p, children: v } = _, h = s(i, p), g = R1(j, h.collectionRef);
      return /* @__PURE__ */ z.jsx(sl, { ref: g, children: v });
    }
  );
  c.displayName = i;
  const u = e + "CollectionItemSlot", f = "data-radix-collection-item", m = l.forwardRef(
    (_, j) => {
      const { scope: p, children: v, ...h } = _, g = l.useRef(null), w = R1(j, g), x = s(u, p);
      return l.useEffect(() => (x.itemMap.set(g, { ref: g, ...h }), () => void x.itemMap.delete(g))), /* @__PURE__ */ z.jsx(sl, { [f]: "", ref: w, children: v });
    }
  );
  m.displayName = u;
  function b(_) {
    const j = s(e + "CollectionConsumer", _);
    return l.useCallback(() => {
      const v = j.collectionRef.current;
      if (!v) return [];
      const h = Array.from(v.querySelectorAll(`[${f}]`));
      return Array.from(j.itemMap.values()).sort(
        (x, y) => h.indexOf(x.ref.current) - h.indexOf(y.ref.current)
      );
    }, [j.collectionRef, j.itemMap]);
  }
  return [
    { Provider: o, Slot: c, ItemSlot: m },
    b,
    r
  ];
}
function m0(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Rc(...e) {
  return (t) => e.forEach((n) => m0(n, t));
}
function Gt(...e) {
  return d.useCallback(Rc(...e), e);
}
function _0(e, t = []) {
  let n = [];
  function r(s, o) {
    const i = d.createContext(o), c = n.length;
    n = [...n, o];
    function u(m) {
      const { scope: b, children: _, ...j } = m, p = (b == null ? void 0 : b[e][c]) || i, v = d.useMemo(() => j, Object.values(j));
      return /* @__PURE__ */ z.jsx(p.Provider, { value: v, children: _ });
    }
    function f(m, b) {
      const _ = (b == null ? void 0 : b[e][c]) || i, j = d.useContext(_);
      if (j) return j;
      if (o !== void 0) return o;
      throw new Error(`\`${m}\` must be used within \`${s}\``);
    }
    return u.displayName = s + "Provider", [u, f];
  }
  const a = () => {
    const s = n.map((o) => d.createContext(o));
    return function(i) {
      const c = (i == null ? void 0 : i[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: c } }),
        [i, c]
      );
    };
  };
  return a.scopeName = e, [r, p0(a, ...t)];
}
function p0(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(s) {
      const o = r.reduce((i, { useScope: c, scopeName: u }) => {
        const m = c(s)[`__scope${u}`];
        return { ...i, ...m };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var j0 = d.createContext(void 0);
function Vb(e) {
  const t = d.useContext(j0);
  return e || t || "ltr";
}
var Oc = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = d.Children.toArray(n), s = a.find(h0);
  if (s) {
    const o = s.props.children, i = a.map((c) => c === s ? d.Children.count(o) > 1 ? d.Children.only(null) : d.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z.jsx(il, { ...r, ref: t, children: d.isValidElement(o) ? d.cloneElement(o, void 0, i) : null });
  }
  return /* @__PURE__ */ z.jsx(il, { ...r, ref: t, children: n });
});
Oc.displayName = "Slot";
var il = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const a = y0(n);
    return d.cloneElement(n, {
      ...g0(r, n.props),
      // @ts-ignore
      ref: t ? Rc(t, a) : a
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
il.displayName = "SlotClone";
var v0 = ({ children: e }) => /* @__PURE__ */ z.jsx(z.Fragment, { children: e });
function h0(e) {
  return d.isValidElement(e) && e.type === v0;
}
function g0(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? a && s ? n[r] = (...i) => {
      s(...i), a(...i);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function y0(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var w0 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Kt = w0.reduce((e, t) => {
  const n = d.forwardRef((r, a) => {
    const { asChild: s, ...o } = r, i = s ? Oc : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ z.jsx(i, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Yb(e, t) {
  e && yr.flushSync(() => e.dispatchEvent(t));
}
function An(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function C0(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = An(e);
  d.useEffect(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var E0 = "DismissableLayer", ll = "dismissableLayer.update", x0 = "dismissableLayer.pointerDownOutside", S0 = "dismissableLayer.focusOutside", O1, Gb = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Kb = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: a,
      onFocusOutside: s,
      onInteractOutside: o,
      onDismiss: i,
      ...c
    } = e, u = d.useContext(Gb), [f, m] = d.useState(null), b = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, _] = d.useState({}), j = Gt(t, (C) => m(C)), p = Array.from(u.layers), [v] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), h = p.indexOf(v), g = f ? p.indexOf(f) : -1, w = u.layersWithOutsidePointerEventsDisabled.size > 0, x = g >= h, y = R0((C) => {
      const S = C.target, k = [...u.branches].some((O) => O.contains(S));
      !x || k || (a == null || a(C), o == null || o(C), C.defaultPrevented || i == null || i());
    }, b), E = O0((C) => {
      const S = C.target;
      [...u.branches].some((O) => O.contains(S)) || (s == null || s(C), o == null || o(C), C.defaultPrevented || i == null || i());
    }, b);
    return C0((C) => {
      g === u.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && i && (C.preventDefault(), i()));
    }, b), d.useEffect(() => {
      if (f)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (O1 = b.body.style.pointerEvents, b.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(f)), u.layers.add(f), M1(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (b.body.style.pointerEvents = O1);
        };
    }, [f, b, n, u]), d.useEffect(() => () => {
      f && (u.layers.delete(f), u.layersWithOutsidePointerEventsDisabled.delete(f), M1());
    }, [f, u]), d.useEffect(() => {
      const C = () => _({});
      return document.addEventListener(ll, C), () => document.removeEventListener(ll, C);
    }, []), /* @__PURE__ */ z.jsx(
      Kt.div,
      {
        ...c,
        ref: j,
        style: {
          pointerEvents: w ? x ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: $e(e.onFocusCapture, E.onFocusCapture),
        onBlurCapture: $e(e.onBlurCapture, E.onBlurCapture),
        onPointerDownCapture: $e(
          e.onPointerDownCapture,
          y.onPointerDownCapture
        )
      }
    );
  }
);
Kb.displayName = E0;
var k0 = "DismissableLayerBranch", T0 = d.forwardRef((e, t) => {
  const n = d.useContext(Gb), r = d.useRef(null), a = Gt(t, r);
  return d.useEffect(() => {
    const s = r.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ z.jsx(Kt.div, { ...e, ref: a });
});
T0.displayName = k0;
function R0(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = An(e), r = d.useRef(!1), a = d.useRef(() => {
  });
  return d.useEffect(() => {
    const s = (i) => {
      if (i.target && !r.current) {
        let c = function() {
          Xb(
            x0,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = c, t.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", s), t.removeEventListener("click", a.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function O0(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = An(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const a = (s) => {
      s.target && !r.current && Xb(S0, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function M1() {
  const e = new CustomEvent(ll);
  document.dispatchEvent(e);
}
function Xb(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), r ? Yb(a, s) : a.dispatchEvent(s);
}
var ai = 0;
function M0() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? A1()), document.body.insertAdjacentElement("beforeend", e[1] ?? A1()), ai++, () => {
      ai === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), ai--;
    };
  }, []);
}
function A1() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var si = "focusScope.autoFocusOnMount", oi = "focusScope.autoFocusOnUnmount", P1 = { bubbles: !1, cancelable: !0 }, A0 = "FocusScope", Zb = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: s,
    ...o
  } = e, [i, c] = d.useState(null), u = An(a), f = An(s), m = d.useRef(null), b = Gt(t, (p) => c(p)), _ = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (r) {
      let p = function(w) {
        if (_.paused || !i) return;
        const x = w.target;
        i.contains(x) ? m.current = x : Qt(m.current, { select: !0 });
      }, v = function(w) {
        if (_.paused || !i) return;
        const x = w.relatedTarget;
        x !== null && (i.contains(x) || Qt(m.current, { select: !0 }));
      }, h = function(w) {
        if (document.activeElement === document.body)
          for (const y of w)
            y.removedNodes.length > 0 && Qt(i);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", v);
      const g = new MutationObserver(h);
      return i && g.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", v), g.disconnect();
      };
    }
  }, [r, i, _.paused]), d.useEffect(() => {
    if (i) {
      D1.add(_);
      const p = document.activeElement;
      if (!i.contains(p)) {
        const h = new CustomEvent(si, P1);
        i.addEventListener(si, u), i.dispatchEvent(h), h.defaultPrevented || (P0(L0(Jb(i)), { select: !0 }), document.activeElement === p && Qt(i));
      }
      return () => {
        i.removeEventListener(si, u), setTimeout(() => {
          const h = new CustomEvent(oi, P1);
          i.addEventListener(oi, f), i.dispatchEvent(h), h.defaultPrevented || Qt(p ?? document.body, { select: !0 }), i.removeEventListener(oi, f), D1.remove(_);
        }, 0);
      };
    }
  }, [i, u, f, _]);
  const j = d.useCallback(
    (p) => {
      if (!n && !r || _.paused) return;
      const v = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, h = document.activeElement;
      if (v && h) {
        const g = p.currentTarget, [w, x] = N0(g);
        w && x ? !p.shiftKey && h === x ? (p.preventDefault(), n && Qt(w, { select: !0 })) : p.shiftKey && h === w && (p.preventDefault(), n && Qt(x, { select: !0 })) : h === g && p.preventDefault();
      }
    },
    [n, r, _.paused]
  );
  return /* @__PURE__ */ z.jsx(Kt.div, { tabIndex: -1, ...o, ref: b, onKeyDown: j });
});
Zb.displayName = A0;
function P0(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Qt(r, { select: t }), document.activeElement !== n) return;
}
function N0(e) {
  const t = Jb(e), n = N1(t, e), r = N1(t.reverse(), e);
  return [n, r];
}
function Jb(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function N1(e, t) {
  for (const n of e)
    if (!D0(n, { upTo: t })) return n;
}
function D0(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function I0(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Qt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && I0(e) && t && e.select();
  }
}
var D1 = $0();
function $0() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = I1(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = I1(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function I1(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function L0(e) {
  return e.filter((t) => t.tagName !== "A");
}
var cl = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
};
const z0 = ["top", "right", "bottom", "left"], fn = Math.min, it = Math.max, Ns = Math.round, Ka = Math.floor, Mt = (e) => ({
  x: e,
  y: e
}), F0 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, H0 = {
  start: "end",
  end: "start"
};
function ul(e, t, n) {
  return it(e, fn(t, n));
}
function Ut(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Wt(e) {
  return e.split("-")[0];
}
function Er(e) {
  return e.split("-")[1];
}
function Mc(e) {
  return e === "x" ? "y" : "x";
}
function Ac(e) {
  return e === "y" ? "height" : "width";
}
function bn(e) {
  return ["top", "bottom"].includes(Wt(e)) ? "y" : "x";
}
function Pc(e) {
  return Mc(bn(e));
}
function B0(e, t, n) {
  n === void 0 && (n = !1);
  const r = Er(e), a = Pc(e), s = Ac(a);
  let o = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (o = Ds(o)), [o, Ds(o)];
}
function q0(e) {
  const t = Ds(e);
  return [dl(e), t, dl(t)];
}
function dl(e) {
  return e.replace(/start|end/g, (t) => H0[t]);
}
function U0(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], s = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? s : o;
    default:
      return [];
  }
}
function W0(e, t, n, r) {
  const a = Er(e);
  let s = U0(Wt(e), n === "start", r);
  return a && (s = s.map((o) => o + "-" + a), t && (s = s.concat(s.map(dl)))), s;
}
function Ds(e) {
  return e.replace(/left|right|bottom|top/g, (t) => F0[t]);
}
function V0(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Qb(e) {
  return typeof e != "number" ? V0(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Is(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: a
  } = e;
  return {
    width: r,
    height: a,
    top: n,
    left: t,
    right: t + r,
    bottom: n + a,
    x: t,
    y: n
  };
}
function $1(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const s = bn(t), o = Pc(t), i = Ac(o), c = Wt(t), u = s === "y", f = r.x + r.width / 2 - a.width / 2, m = r.y + r.height / 2 - a.height / 2, b = r[i] / 2 - a[i] / 2;
  let _;
  switch (c) {
    case "top":
      _ = {
        x: f,
        y: r.y - a.height
      };
      break;
    case "bottom":
      _ = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      _ = {
        x: r.x + r.width,
        y: m
      };
      break;
    case "left":
      _ = {
        x: r.x - a.width,
        y: m
      };
      break;
    default:
      _ = {
        x: r.x,
        y: r.y
      };
  }
  switch (Er(t)) {
    case "start":
      _[o] -= b * (n && u ? -1 : 1);
      break;
    case "end":
      _[o] += b * (n && u ? -1 : 1);
      break;
  }
  return _;
}
const Y0 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: s = [],
    platform: o
  } = n, i = s.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: f,
    y: m
  } = $1(u, r, c), b = r, _ = {}, j = 0;
  for (let p = 0; p < i.length; p++) {
    const {
      name: v,
      fn: h
    } = i[p], {
      x: g,
      y: w,
      data: x,
      reset: y
    } = await h({
      x: f,
      y: m,
      initialPlacement: r,
      placement: b,
      strategy: a,
      middlewareData: _,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = g ?? f, m = w ?? m, _ = {
      ..._,
      [v]: {
        ..._[v],
        ...x
      }
    }, y && j <= 50 && (j++, typeof y == "object" && (y.placement && (b = y.placement), y.rects && (u = y.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : y.rects), {
      x: f,
      y: m
    } = $1(u, b, c)), p = -1);
  }
  return {
    x: f,
    y: m,
    placement: b,
    strategy: a,
    middlewareData: _
  };
};
async function la(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: s,
    rects: o,
    elements: i,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: m = "floating",
    altBoundary: b = !1,
    padding: _ = 0
  } = Ut(t, e), j = Qb(_), v = i[b ? m === "floating" ? "reference" : "floating" : m], h = Is(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(v))) == null || n ? v : v.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(i.floating)),
    boundary: u,
    rootBoundary: f,
    strategy: c
  })), g = m === "floating" ? {
    x: r,
    y: a,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, w = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(i.floating)), x = await (s.isElement == null ? void 0 : s.isElement(w)) ? await (s.getScale == null ? void 0 : s.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, y = Is(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: g,
    offsetParent: w,
    strategy: c
  }) : g);
  return {
    top: (h.top - y.top + j.top) / x.y,
    bottom: (y.bottom - h.bottom + j.bottom) / x.y,
    left: (h.left - y.left + j.left) / x.x,
    right: (y.right - h.right + j.right) / x.x
  };
}
const G0 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: a,
      rects: s,
      platform: o,
      elements: i,
      middlewareData: c
    } = t, {
      element: u,
      padding: f = 0
    } = Ut(e, t) || {};
    if (u == null)
      return {};
    const m = Qb(f), b = {
      x: n,
      y: r
    }, _ = Pc(a), j = Ac(_), p = await o.getDimensions(u), v = _ === "y", h = v ? "top" : "left", g = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", x = s.reference[j] + s.reference[_] - b[_] - s.floating[j], y = b[_] - s.reference[_], E = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(u));
    let C = E ? E[w] : 0;
    (!C || !await (o.isElement == null ? void 0 : o.isElement(E))) && (C = i.floating[w] || s.floating[j]);
    const S = x / 2 - y / 2, k = C / 2 - p[j] / 2 - 1, O = fn(m[h], k), L = fn(m[g], k), H = O, T = C - p[j] - L, R = C / 2 - p[j] / 2 + S, M = ul(H, R, T), D = !c.arrow && Er(a) != null && R !== M && s.reference[j] / 2 - (R < H ? O : L) - p[j] / 2 < 0, I = D ? R < H ? R - H : R - T : 0;
    return {
      [_]: b[_] + I,
      data: {
        [_]: M,
        centerOffset: R - M - I,
        ...D && {
          alignmentOffset: I
        }
      },
      reset: D
    };
  }
}), K0 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: s,
        rects: o,
        initialPlacement: i,
        platform: c,
        elements: u
      } = t, {
        mainAxis: f = !0,
        crossAxis: m = !0,
        fallbackPlacements: b,
        fallbackStrategy: _ = "bestFit",
        fallbackAxisSideDirection: j = "none",
        flipAlignment: p = !0,
        ...v
      } = Ut(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const h = Wt(a), g = bn(i), w = Wt(i) === i, x = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), y = b || (w || !p ? [Ds(i)] : q0(i)), E = j !== "none";
      !b && E && y.push(...W0(i, p, j, x));
      const C = [i, ...y], S = await la(t, v), k = [];
      let O = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (f && k.push(S[h]), m) {
        const R = B0(a, o, x);
        k.push(S[R[0]], S[R[1]]);
      }
      if (O = [...O, {
        placement: a,
        overflows: k
      }], !k.every((R) => R <= 0)) {
        var L, H;
        const R = (((L = s.flip) == null ? void 0 : L.index) || 0) + 1, M = C[R];
        if (M)
          return {
            data: {
              index: R,
              overflows: O
            },
            reset: {
              placement: M
            }
          };
        let D = (H = O.filter((I) => I.overflows[0] <= 0).sort((I, F) => I.overflows[1] - F.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!D)
          switch (_) {
            case "bestFit": {
              var T;
              const I = (T = O.filter((F) => {
                if (E) {
                  const P = bn(F.placement);
                  return P === g || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  P === "y";
                }
                return !0;
              }).map((F) => [F.placement, F.overflows.filter((P) => P > 0).reduce((P, A) => P + A, 0)]).sort((F, P) => F[1] - P[1])[0]) == null ? void 0 : T[0];
              I && (D = I);
              break;
            }
            case "initialPlacement":
              D = i;
              break;
          }
        if (a !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
function L1(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function z1(e) {
  return z0.some((t) => e[t] >= 0);
}
const X0 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = Ut(e, t);
      switch (r) {
        case "referenceHidden": {
          const s = await la(t, {
            ...a,
            elementContext: "reference"
          }), o = L1(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: z1(o)
            }
          };
        }
        case "escaped": {
          const s = await la(t, {
            ...a,
            altBoundary: !0
          }), o = L1(s, n.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: z1(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Z0(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), o = Wt(n), i = Er(n), c = bn(n) === "y", u = ["left", "top"].includes(o) ? -1 : 1, f = s && c ? -1 : 1, m = Ut(t, e);
  let {
    mainAxis: b,
    crossAxis: _,
    alignmentAxis: j
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: m.mainAxis || 0,
    crossAxis: m.crossAxis || 0,
    alignmentAxis: m.alignmentAxis
  };
  return i && typeof j == "number" && (_ = i === "end" ? j * -1 : j), c ? {
    x: _ * f,
    y: b * u
  } : {
    x: b * u,
    y: _ * f
  };
}
const J0 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: a,
        y: s,
        placement: o,
        middlewareData: i
      } = t, c = await Z0(t, e);
      return o === ((n = i.offset) == null ? void 0 : n.placement) && (r = i.arrow) != null && r.alignmentOffset ? {} : {
        x: a + c.x,
        y: s + c.y,
        data: {
          ...c,
          placement: o
        }
      };
    }
  };
}, Q0 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: s = !0,
        crossAxis: o = !1,
        limiter: i = {
          fn: (v) => {
            let {
              x: h,
              y: g
            } = v;
            return {
              x: h,
              y: g
            };
          }
        },
        ...c
      } = Ut(e, t), u = {
        x: n,
        y: r
      }, f = await la(t, c), m = bn(Wt(a)), b = Mc(m);
      let _ = u[b], j = u[m];
      if (s) {
        const v = b === "y" ? "top" : "left", h = b === "y" ? "bottom" : "right", g = _ + f[v], w = _ - f[h];
        _ = ul(g, _, w);
      }
      if (o) {
        const v = m === "y" ? "top" : "left", h = m === "y" ? "bottom" : "right", g = j + f[v], w = j - f[h];
        j = ul(g, j, w);
      }
      const p = i.fn({
        ...t,
        [b]: _,
        [m]: j
      });
      return {
        ...p,
        data: {
          x: p.x - n,
          y: p.y - r,
          enabled: {
            [b]: s,
            [m]: o
          }
        }
      };
    }
  };
}, eg = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: a,
        rects: s,
        middlewareData: o
      } = t, {
        offset: i = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = Ut(e, t), f = {
        x: n,
        y: r
      }, m = bn(a), b = Mc(m);
      let _ = f[b], j = f[m];
      const p = Ut(i, t), v = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (c) {
        const w = b === "y" ? "height" : "width", x = s.reference[b] - s.floating[w] + v.mainAxis, y = s.reference[b] + s.reference[w] - v.mainAxis;
        _ < x ? _ = x : _ > y && (_ = y);
      }
      if (u) {
        var h, g;
        const w = b === "y" ? "width" : "height", x = ["top", "left"].includes(Wt(a)), y = s.reference[m] - s.floating[w] + (x && ((h = o.offset) == null ? void 0 : h[m]) || 0) + (x ? 0 : v.crossAxis), E = s.reference[m] + s.reference[w] + (x ? 0 : ((g = o.offset) == null ? void 0 : g[m]) || 0) - (x ? v.crossAxis : 0);
        j < y ? j = y : j > E && (j = E);
      }
      return {
        [b]: _,
        [m]: j
      };
    }
  };
}, tg = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        rects: s,
        platform: o,
        elements: i
      } = t, {
        apply: c = () => {
        },
        ...u
      } = Ut(e, t), f = await la(t, u), m = Wt(a), b = Er(a), _ = bn(a) === "y", {
        width: j,
        height: p
      } = s.floating;
      let v, h;
      m === "top" || m === "bottom" ? (v = m, h = b === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (h = m, v = b === "end" ? "top" : "bottom");
      const g = p - f.top - f.bottom, w = j - f.left - f.right, x = fn(p - f[v], g), y = fn(j - f[h], w), E = !t.middlewareData.shift;
      let C = x, S = y;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (S = w), (r = t.middlewareData.shift) != null && r.enabled.y && (C = g), E && !b) {
        const O = it(f.left, 0), L = it(f.right, 0), H = it(f.top, 0), T = it(f.bottom, 0);
        _ ? S = j - 2 * (O !== 0 || L !== 0 ? O + L : it(f.left, f.right)) : C = p - 2 * (H !== 0 || T !== 0 ? H + T : it(f.top, f.bottom));
      }
      await c({
        ...t,
        availableWidth: S,
        availableHeight: C
      });
      const k = await o.getDimensions(i.floating);
      return j !== k.width || p !== k.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function uo() {
  return typeof window < "u";
}
function xr(e) {
  return em(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function lt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Pt(e) {
  var t;
  return (t = (em(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function em(e) {
  return uo() ? e instanceof Node || e instanceof lt(e).Node : !1;
}
function xt(e) {
  return uo() ? e instanceof Element || e instanceof lt(e).Element : !1;
}
function At(e) {
  return uo() ? e instanceof HTMLElement || e instanceof lt(e).HTMLElement : !1;
}
function F1(e) {
  return !uo() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof lt(e).ShadowRoot;
}
function Ea(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = St(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function ng(e) {
  return ["table", "td", "th"].includes(xr(e));
}
function fo(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Nc(e) {
  const t = Dc(), n = xt(e) ? St(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function rg(e) {
  let t = mn(e);
  for (; At(t) && !br(t); ) {
    if (Nc(t))
      return t;
    if (fo(t))
      return null;
    t = mn(t);
  }
  return null;
}
function Dc() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function br(e) {
  return ["html", "body", "#document"].includes(xr(e));
}
function St(e) {
  return lt(e).getComputedStyle(e);
}
function bo(e) {
  return xt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function mn(e) {
  if (xr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    F1(e) && e.host || // Fallback.
    Pt(e)
  );
  return F1(t) ? t.host : t;
}
function tm(e) {
  const t = mn(e);
  return br(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : At(t) && Ea(t) ? t : tm(t);
}
function ca(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = tm(e), s = a === ((r = e.ownerDocument) == null ? void 0 : r.body), o = lt(a);
  if (s) {
    const i = fl(o);
    return t.concat(o, o.visualViewport || [], Ea(a) ? a : [], i && n ? ca(i) : []);
  }
  return t.concat(a, ca(a, [], n));
}
function fl(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function nm(e) {
  const t = St(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = At(e), s = a ? e.offsetWidth : n, o = a ? e.offsetHeight : r, i = Ns(n) !== s || Ns(r) !== o;
  return i && (n = s, r = o), {
    width: n,
    height: r,
    $: i
  };
}
function Ic(e) {
  return xt(e) ? e : e.contextElement;
}
function sr(e) {
  const t = Ic(e);
  if (!At(t))
    return Mt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: s
  } = nm(t);
  let o = (s ? Ns(n.width) : n.width) / r, i = (s ? Ns(n.height) : n.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: o,
    y: i
  };
}
const ag = /* @__PURE__ */ Mt(0);
function rm(e) {
  const t = lt(e);
  return !Dc() || !t.visualViewport ? ag : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function sg(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== lt(e) ? !1 : t;
}
function Pn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), s = Ic(e);
  let o = Mt(1);
  t && (r ? xt(r) && (o = sr(r)) : o = sr(e));
  const i = sg(s, n, r) ? rm(s) : Mt(0);
  let c = (a.left + i.x) / o.x, u = (a.top + i.y) / o.y, f = a.width / o.x, m = a.height / o.y;
  if (s) {
    const b = lt(s), _ = r && xt(r) ? lt(r) : r;
    let j = b, p = fl(j);
    for (; p && r && _ !== j; ) {
      const v = sr(p), h = p.getBoundingClientRect(), g = St(p), w = h.left + (p.clientLeft + parseFloat(g.paddingLeft)) * v.x, x = h.top + (p.clientTop + parseFloat(g.paddingTop)) * v.y;
      c *= v.x, u *= v.y, f *= v.x, m *= v.y, c += w, u += x, j = lt(p), p = fl(j);
    }
  }
  return Is({
    width: f,
    height: m,
    x: c,
    y: u
  });
}
function $c(e, t) {
  const n = bo(e).scrollLeft;
  return t ? t.left + n : Pn(Pt(e)).left + n;
}
function am(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    $c(e, r)
  )), s = r.top + t.scrollTop;
  return {
    x: a,
    y: s
  };
}
function og(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: a
  } = e;
  const s = a === "fixed", o = Pt(r), i = t ? fo(t.floating) : !1;
  if (r === o || i && s)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Mt(1);
  const f = Mt(0), m = At(r);
  if ((m || !m && !s) && ((xr(r) !== "body" || Ea(o)) && (c = bo(r)), At(r))) {
    const _ = Pn(r);
    u = sr(r), f.x = _.x + r.clientLeft, f.y = _.y + r.clientTop;
  }
  const b = o && !m && !s ? am(o, c, !0) : Mt(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + f.x + b.x,
    y: n.y * u.y - c.scrollTop * u.y + f.y + b.y
  };
}
function ig(e) {
  return Array.from(e.getClientRects());
}
function lg(e) {
  const t = Pt(e), n = bo(e), r = e.ownerDocument.body, a = it(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), s = it(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + $c(e);
  const i = -n.scrollTop;
  return St(r).direction === "rtl" && (o += it(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: s,
    x: o,
    y: i
  };
}
function cg(e, t) {
  const n = lt(e), r = Pt(e), a = n.visualViewport;
  let s = r.clientWidth, o = r.clientHeight, i = 0, c = 0;
  if (a) {
    s = a.width, o = a.height;
    const u = Dc();
    (!u || u && t === "fixed") && (i = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: s,
    height: o,
    x: i,
    y: c
  };
}
function ug(e, t) {
  const n = Pn(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, s = At(e) ? sr(e) : Mt(1), o = e.clientWidth * s.x, i = e.clientHeight * s.y, c = a * s.x, u = r * s.y;
  return {
    width: o,
    height: i,
    x: c,
    y: u
  };
}
function H1(e, t, n) {
  let r;
  if (t === "viewport")
    r = cg(e, n);
  else if (t === "document")
    r = lg(Pt(e));
  else if (xt(t))
    r = ug(t, n);
  else {
    const a = rm(e);
    r = {
      x: t.x - a.x,
      y: t.y - a.y,
      width: t.width,
      height: t.height
    };
  }
  return Is(r);
}
function sm(e, t) {
  const n = mn(e);
  return n === t || !xt(n) || br(n) ? !1 : St(n).position === "fixed" || sm(n, t);
}
function dg(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ca(e, [], !1).filter((i) => xt(i) && xr(i) !== "body"), a = null;
  const s = St(e).position === "fixed";
  let o = s ? mn(e) : e;
  for (; xt(o) && !br(o); ) {
    const i = St(o), c = Nc(o);
    !c && i.position === "fixed" && (a = null), (s ? !c && !a : !c && i.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || Ea(o) && !c && sm(e, o)) ? r = r.filter((f) => f !== o) : a = i, o = mn(o);
  }
  return t.set(e, r), r;
}
function fg(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const o = [...n === "clippingAncestors" ? fo(t) ? [] : dg(t, this._c) : [].concat(n), r], i = o[0], c = o.reduce((u, f) => {
    const m = H1(t, f, a);
    return u.top = it(m.top, u.top), u.right = fn(m.right, u.right), u.bottom = fn(m.bottom, u.bottom), u.left = it(m.left, u.left), u;
  }, H1(t, i, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function bg(e) {
  const {
    width: t,
    height: n
  } = nm(e);
  return {
    width: t,
    height: n
  };
}
function mg(e, t, n) {
  const r = At(t), a = Pt(t), s = n === "fixed", o = Pn(e, !0, s, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Mt(0);
  if (r || !r && !s)
    if ((xr(t) !== "body" || Ea(a)) && (i = bo(t)), r) {
      const b = Pn(t, !0, s, t);
      c.x = b.x + t.clientLeft, c.y = b.y + t.clientTop;
    } else a && (c.x = $c(a));
  const u = a && !r && !s ? am(a, i) : Mt(0), f = o.left + i.scrollLeft - c.x - u.x, m = o.top + i.scrollTop - c.y - u.y;
  return {
    x: f,
    y: m,
    width: o.width,
    height: o.height
  };
}
function ii(e) {
  return St(e).position === "static";
}
function B1(e, t) {
  if (!At(e) || St(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Pt(e) === n && (n = n.ownerDocument.body), n;
}
function om(e, t) {
  const n = lt(e);
  if (fo(e))
    return n;
  if (!At(e)) {
    let a = mn(e);
    for (; a && !br(a); ) {
      if (xt(a) && !ii(a))
        return a;
      a = mn(a);
    }
    return n;
  }
  let r = B1(e, t);
  for (; r && ng(r) && ii(r); )
    r = B1(r, t);
  return r && br(r) && ii(r) && !Nc(r) ? n : r || rg(e) || n;
}
const _g = async function(e) {
  const t = this.getOffsetParent || om, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: mg(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function pg(e) {
  return St(e).direction === "rtl";
}
const jg = {
  convertOffsetParentRelativeRectToViewportRelativeRect: og,
  getDocumentElement: Pt,
  getClippingRect: fg,
  getOffsetParent: om,
  getElementRects: _g,
  getClientRects: ig,
  getDimensions: bg,
  getScale: sr,
  isElement: xt,
  isRTL: pg
};
function vg(e, t) {
  let n = null, r;
  const a = Pt(e);
  function s() {
    var i;
    clearTimeout(r), (i = n) == null || i.disconnect(), n = null;
  }
  function o(i, c) {
    i === void 0 && (i = !1), c === void 0 && (c = 1), s();
    const {
      left: u,
      top: f,
      width: m,
      height: b
    } = e.getBoundingClientRect();
    if (i || t(), !m || !b)
      return;
    const _ = Ka(f), j = Ka(a.clientWidth - (u + m)), p = Ka(a.clientHeight - (f + b)), v = Ka(u), g = {
      rootMargin: -_ + "px " + -j + "px " + -p + "px " + -v + "px",
      threshold: it(0, fn(1, c)) || 1
    };
    let w = !0;
    function x(y) {
      const E = y[0].intersectionRatio;
      if (E !== c) {
        if (!w)
          return o();
        E ? o(!1, E) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      w = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...g,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, g);
    }
    n.observe(e);
  }
  return o(!0), s;
}
function hg(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: s = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, u = Ic(e), f = a || s ? [...u ? ca(u) : [], ...ca(t)] : [];
  f.forEach((h) => {
    a && h.addEventListener("scroll", n, {
      passive: !0
    }), s && h.addEventListener("resize", n);
  });
  const m = u && i ? vg(u, n) : null;
  let b = -1, _ = null;
  o && (_ = new ResizeObserver((h) => {
    let [g] = h;
    g && g.target === u && _ && (_.unobserve(t), cancelAnimationFrame(b), b = requestAnimationFrame(() => {
      var w;
      (w = _) == null || w.observe(t);
    })), n();
  }), u && !c && _.observe(u), _.observe(t));
  let j, p = c ? Pn(e) : null;
  c && v();
  function v() {
    const h = Pn(e);
    p && (h.x !== p.x || h.y !== p.y || h.width !== p.width || h.height !== p.height) && n(), p = h, j = requestAnimationFrame(v);
  }
  return n(), () => {
    var h;
    f.forEach((g) => {
      a && g.removeEventListener("scroll", n), s && g.removeEventListener("resize", n);
    }), m == null || m(), (h = _) == null || h.disconnect(), _ = null, c && cancelAnimationFrame(j);
  };
}
const gg = J0, yg = Q0, wg = K0, Cg = tg, Eg = X0, q1 = G0, xg = eg, Sg = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: jg,
    ...n
  }, s = {
    ...a.platform,
    _c: r
  };
  return Y0(e, t, {
    ...a,
    platform: s
  });
};
var hs = typeof document < "u" ? Pf : le;
function $s(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!$s(e[r], t[r]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const s = a[r];
      if (!(s === "_owner" && e.$$typeof) && !$s(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function im(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function U1(e, t) {
  const n = im(e);
  return Math.round(t * n) / n;
}
function li(e) {
  const t = d.useRef(e);
  return hs(() => {
    t.current = e;
  }), t;
}
function kg(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: a,
    elements: {
      reference: s,
      floating: o
    } = {},
    transform: i = !0,
    whileElementsMounted: c,
    open: u
  } = e, [f, m] = d.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [b, _] = d.useState(r);
  $s(b, r) || _(r);
  const [j, p] = d.useState(null), [v, h] = d.useState(null), g = d.useCallback((F) => {
    F !== E.current && (E.current = F, p(F));
  }, []), w = d.useCallback((F) => {
    F !== C.current && (C.current = F, h(F));
  }, []), x = s || j, y = o || v, E = d.useRef(null), C = d.useRef(null), S = d.useRef(f), k = c != null, O = li(c), L = li(a), H = li(u), T = d.useCallback(() => {
    if (!E.current || !C.current)
      return;
    const F = {
      placement: t,
      strategy: n,
      middleware: b
    };
    L.current && (F.platform = L.current), Sg(E.current, C.current, F).then((P) => {
      const A = {
        ...P,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: H.current !== !1
      };
      R.current && !$s(S.current, A) && (S.current = A, yr.flushSync(() => {
        m(A);
      }));
    });
  }, [b, t, n, L, H]);
  hs(() => {
    u === !1 && S.current.isPositioned && (S.current.isPositioned = !1, m((F) => ({
      ...F,
      isPositioned: !1
    })));
  }, [u]);
  const R = d.useRef(!1);
  hs(() => (R.current = !0, () => {
    R.current = !1;
  }), []), hs(() => {
    if (x && (E.current = x), y && (C.current = y), x && y) {
      if (O.current)
        return O.current(x, y, T);
      T();
    }
  }, [x, y, T, O, k]);
  const M = d.useMemo(() => ({
    reference: E,
    floating: C,
    setReference: g,
    setFloating: w
  }), [g, w]), D = d.useMemo(() => ({
    reference: x,
    floating: y
  }), [x, y]), I = d.useMemo(() => {
    const F = {
      position: n,
      left: 0,
      top: 0
    };
    if (!D.floating)
      return F;
    const P = U1(D.floating, f.x), A = U1(D.floating, f.y);
    return i ? {
      ...F,
      transform: "translate(" + P + "px, " + A + "px)",
      ...im(D.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: P,
      top: A
    };
  }, [n, i, D.floating, f.x, f.y]);
  return d.useMemo(() => ({
    ...f,
    update: T,
    refs: M,
    elements: D,
    floatingStyles: I
  }), [f, T, M, D, I]);
}
const Tg = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: a
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? q1({
        element: r.current,
        padding: a
      }).fn(n) : {} : r ? q1({
        element: r,
        padding: a
      }).fn(n) : {};
    }
  };
}, Rg = (e, t) => ({
  ...gg(e),
  options: [e, t]
}), Og = (e, t) => ({
  ...yg(e),
  options: [e, t]
}), Mg = (e, t) => ({
  ...xg(e),
  options: [e, t]
}), Ag = (e, t) => ({
  ...wg(e),
  options: [e, t]
}), Pg = (e, t) => ({
  ...Cg(e),
  options: [e, t]
}), Ng = (e, t) => ({
  ...Eg(e),
  options: [e, t]
}), Dg = (e, t) => ({
  ...Tg(e),
  options: [e, t]
});
function Ig(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function $g(...e) {
  return (t) => e.forEach((n) => Ig(n, t));
}
var lm = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = d.Children.toArray(n), s = a.find(zg);
  if (s) {
    const o = s.props.children, i = a.map((c) => c === s ? d.Children.count(o) > 1 ? d.Children.only(null) : d.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z.jsx(bl, { ...r, ref: t, children: d.isValidElement(o) ? d.cloneElement(o, void 0, i) : null });
  }
  return /* @__PURE__ */ z.jsx(bl, { ...r, ref: t, children: n });
});
lm.displayName = "Slot";
var bl = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const a = Hg(n);
    return d.cloneElement(n, {
      ...Fg(r, n.props),
      // @ts-ignore
      ref: t ? $g(t, a) : a
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
bl.displayName = "SlotClone";
var Lg = ({ children: e }) => /* @__PURE__ */ z.jsx(z.Fragment, { children: e });
function zg(e) {
  return d.isValidElement(e) && e.type === Lg;
}
function Fg(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? a && s ? n[r] = (...i) => {
      s(...i), a(...i);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Hg(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Bg = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], qg = Bg.reduce((e, t) => {
  const n = d.forwardRef((r, a) => {
    const { asChild: s, ...o } = r, i = s ? lm : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ z.jsx(i, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Ug = "Arrow", cm = d.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: a = 5, ...s } = e;
  return /* @__PURE__ */ z.jsx(
    qg.svg,
    {
      ...s,
      ref: t,
      width: r,
      height: a,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ z.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
cm.displayName = Ug;
var Wg = cm;
function Vg(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function um(...e) {
  return (t) => e.forEach((n) => Vg(n, t));
}
function dm(...e) {
  return d.useCallback(um(...e), e);
}
function Yg(e, t = []) {
  let n = [];
  function r(s, o) {
    const i = d.createContext(o), c = n.length;
    n = [...n, o];
    function u(m) {
      const { scope: b, children: _, ...j } = m, p = (b == null ? void 0 : b[e][c]) || i, v = d.useMemo(() => j, Object.values(j));
      return /* @__PURE__ */ z.jsx(p.Provider, { value: v, children: _ });
    }
    function f(m, b) {
      const _ = (b == null ? void 0 : b[e][c]) || i, j = d.useContext(_);
      if (j) return j;
      if (o !== void 0) return o;
      throw new Error(`\`${m}\` must be used within \`${s}\``);
    }
    return u.displayName = s + "Provider", [u, f];
  }
  const a = () => {
    const s = n.map((o) => d.createContext(o));
    return function(i) {
      const c = (i == null ? void 0 : i[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: c } }),
        [i, c]
      );
    };
  };
  return a.scopeName = e, [r, Gg(a, ...t)];
}
function Gg(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(s) {
      const o = r.reduce((i, { useScope: c, scopeName: u }) => {
        const m = c(s)[`__scope${u}`];
        return { ...i, ...m };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var fm = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = d.Children.toArray(n), s = a.find(Xg);
  if (s) {
    const o = s.props.children, i = a.map((c) => c === s ? d.Children.count(o) > 1 ? d.Children.only(null) : d.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z.jsx(ml, { ...r, ref: t, children: d.isValidElement(o) ? d.cloneElement(o, void 0, i) : null });
  }
  return /* @__PURE__ */ z.jsx(ml, { ...r, ref: t, children: n });
});
fm.displayName = "Slot";
var ml = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const a = Jg(n);
    return d.cloneElement(n, {
      ...Zg(r, n.props),
      // @ts-ignore
      ref: t ? um(t, a) : a
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
ml.displayName = "SlotClone";
var Kg = ({ children: e }) => /* @__PURE__ */ z.jsx(z.Fragment, { children: e });
function Xg(e) {
  return d.isValidElement(e) && e.type === Kg;
}
function Zg(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? a && s ? n[r] = (...i) => {
      s(...i), a(...i);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Jg(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Qg = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], bm = Qg.reduce((e, t) => {
  const n = d.forwardRef((r, a) => {
    const { asChild: s, ...o } = r, i = s ? fm : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ z.jsx(i, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function ey(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
var W1 = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, ty = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
};
function mm(e) {
  const [t, n] = d.useState(void 0);
  return ty(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const s = a[0];
        let o, i;
        if ("borderBoxSize" in s) {
          const c = s.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          o = u.inlineSize, i = u.blockSize;
        } else
          o = e.offsetWidth, i = e.offsetHeight;
        n({ width: o, height: i });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Lc = "Popper", [_m, Sr] = Yg(Lc), [ny, pm] = _m(Lc), jm = (e) => {
  const { __scopePopper: t, children: n } = e, [r, a] = d.useState(null);
  return /* @__PURE__ */ z.jsx(ny, { scope: t, anchor: r, onAnchorChange: a, children: n });
};
jm.displayName = Lc;
var vm = "PopperAnchor", hm = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...a } = e, s = pm(vm, n), o = d.useRef(null), i = dm(t, o);
    return d.useEffect(() => {
      s.onAnchorChange((r == null ? void 0 : r.current) || o.current);
    }), r ? null : /* @__PURE__ */ z.jsx(bm.div, { ...a, ref: i });
  }
);
hm.displayName = vm;
var zc = "PopperContent", [ry, ay] = _m(zc), gm = d.forwardRef(
  (e, t) => {
    var K, te, Z, se, ue, X;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: a = 0,
      align: s = "center",
      alignOffset: o = 0,
      arrowPadding: i = 0,
      avoidCollisions: c = !0,
      collisionBoundary: u = [],
      collisionPadding: f = 0,
      sticky: m = "partial",
      hideWhenDetached: b = !1,
      updatePositionStrategy: _ = "optimized",
      onPlaced: j,
      ...p
    } = e, v = pm(zc, n), [h, g] = d.useState(null), w = dm(t, (ie) => g(ie)), [x, y] = d.useState(null), E = mm(x), C = (E == null ? void 0 : E.width) ?? 0, S = (E == null ? void 0 : E.height) ?? 0, k = r + (s !== "center" ? "-" + s : ""), O = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, L = Array.isArray(u) ? u : [u], H = L.length > 0, T = {
      padding: O,
      boundary: L.filter(oy),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: H
    }, { refs: R, floatingStyles: M, placement: D, isPositioned: I, middlewareData: F } = kg({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: k,
      whileElementsMounted: (...ie) => hg(...ie, {
        animationFrame: _ === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        Rg({ mainAxis: a + S, alignmentAxis: o }),
        c && Og({
          mainAxis: !0,
          crossAxis: !1,
          limiter: m === "partial" ? Mg() : void 0,
          ...T
        }),
        c && Ag({ ...T }),
        Pg({
          ...T,
          apply: ({ elements: ie, rects: Ce, availableWidth: ge, availableHeight: Ee }) => {
            const { width: He, height: Re } = Ce.reference, Ie = ie.floating.style;
            Ie.setProperty("--radix-popper-available-width", `${ge}px`), Ie.setProperty("--radix-popper-available-height", `${Ee}px`), Ie.setProperty("--radix-popper-anchor-width", `${He}px`), Ie.setProperty("--radix-popper-anchor-height", `${Re}px`);
          }
        }),
        x && Dg({ element: x, padding: i }),
        iy({ arrowWidth: C, arrowHeight: S }),
        b && Ng({ strategy: "referenceHidden", ...T })
      ]
    }), [P, A] = Cm(D), $ = ey(j);
    W1(() => {
      I && ($ == null || $());
    }, [I, $]);
    const B = (K = F.arrow) == null ? void 0 : K.x, Y = (te = F.arrow) == null ? void 0 : te.y, J = ((Z = F.arrow) == null ? void 0 : Z.centerOffset) !== 0, [W, V] = d.useState();
    return W1(() => {
      h && V(window.getComputedStyle(h).zIndex);
    }, [h]), /* @__PURE__ */ z.jsx(
      "div",
      {
        ref: R.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...M,
          transform: I ? M.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: W,
          "--radix-popper-transform-origin": [
            (se = F.transformOrigin) == null ? void 0 : se.x,
            (ue = F.transformOrigin) == null ? void 0 : ue.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((X = F.hide) == null ? void 0 : X.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ z.jsx(
          ry,
          {
            scope: n,
            placedSide: P,
            onArrowChange: y,
            arrowX: B,
            arrowY: Y,
            shouldHideArrow: J,
            children: /* @__PURE__ */ z.jsx(
              bm.div,
              {
                "data-side": P,
                "data-align": A,
                ...p,
                ref: w,
                style: {
                  ...p.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: I ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
gm.displayName = zc;
var ym = "PopperArrow", sy = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, wm = d.forwardRef(function(t, n) {
  const { __scopePopper: r, ...a } = t, s = ay(ym, r), o = sy[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ z.jsx(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [o]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ z.jsx(
          Wg,
          {
            ...a,
            ref: n,
            style: {
              ...a.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
wm.displayName = ym;
function oy(e) {
  return e !== null;
}
var iy = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, h, g;
    const { placement: n, rects: r, middlewareData: a } = t, o = ((v = a.arrow) == null ? void 0 : v.centerOffset) !== 0, i = o ? 0 : e.arrowWidth, c = o ? 0 : e.arrowHeight, [u, f] = Cm(n), m = { start: "0%", center: "50%", end: "100%" }[f], b = (((h = a.arrow) == null ? void 0 : h.x) ?? 0) + i / 2, _ = (((g = a.arrow) == null ? void 0 : g.y) ?? 0) + c / 2;
    let j = "", p = "";
    return u === "bottom" ? (j = o ? m : `${b}px`, p = `${-c}px`) : u === "top" ? (j = o ? m : `${b}px`, p = `${r.floating.height + c}px`) : u === "right" ? (j = `${-c}px`, p = o ? m : `${_}px`) : u === "left" && (j = `${r.floating.width + c}px`, p = o ? m : `${_}px`), { data: { x: j, y: p } };
  }
});
function Cm(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Fc = jm, mo = hm, Hc = gm, Bc = wm, ly = "Portal", Em = d.forwardRef((e, t) => {
  var i;
  const { container: n, ...r } = e, [a, s] = d.useState(!1);
  cl(() => s(!0), []);
  const o = n || a && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return o ? ja.createPortal(/* @__PURE__ */ z.jsx(Kt.div, { ...r, ref: t }), o) : null;
});
Em.displayName = ly;
function cy(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var xa = (e) => {
  const { present: t, children: n } = e, r = uy(t), a = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), s = Gt(r.ref, dy(a));
  return typeof n == "function" || r.isPresent ? d.cloneElement(a, { ref: s }) : null;
};
xa.displayName = "Presence";
function uy(e) {
  const [t, n] = d.useState(), r = d.useRef({}), a = d.useRef(e), s = d.useRef("none"), o = e ? "mounted" : "unmounted", [i, c] = cy(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const u = Xa(r.current);
    s.current = i === "mounted" ? u : "none";
  }, [i]), cl(() => {
    const u = r.current, f = a.current;
    if (f !== e) {
      const b = s.current, _ = Xa(u);
      e ? c("MOUNT") : _ === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(f && b !== _ ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, c]), cl(() => {
    if (t) {
      const u = (m) => {
        const _ = Xa(r.current).includes(m.animationName);
        m.target === t && _ && yr.flushSync(() => c("ANIMATION_END"));
      }, f = (m) => {
        m.target === t && (s.current = Xa(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: d.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function Xa(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function dy(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function or(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function fy(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function xm(...e) {
  return (t) => e.forEach((n) => fy(n, t));
}
function by(...e) {
  return d.useCallback(xm(...e), e);
}
function my(e, t = []) {
  let n = [];
  function r(s, o) {
    const i = d.createContext(o), c = n.length;
    n = [...n, o];
    function u(m) {
      const { scope: b, children: _, ...j } = m, p = (b == null ? void 0 : b[e][c]) || i, v = d.useMemo(() => j, Object.values(j));
      return /* @__PURE__ */ z.jsx(p.Provider, { value: v, children: _ });
    }
    function f(m, b) {
      const _ = (b == null ? void 0 : b[e][c]) || i, j = d.useContext(_);
      if (j) return j;
      if (o !== void 0) return o;
      throw new Error(`\`${m}\` must be used within \`${s}\``);
    }
    return u.displayName = s + "Provider", [u, f];
  }
  const a = () => {
    const s = n.map((o) => d.createContext(o));
    return function(i) {
      const c = (i == null ? void 0 : i[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: c } }),
        [i, c]
      );
    };
  };
  return a.scopeName = e, [r, _y(a, ...t)];
}
function _y(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(s) {
      const o = r.reduce((i, { useScope: c, scopeName: u }) => {
        const m = c(s)[`__scope${u}`];
        return { ...i, ...m };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var py = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, jy = d.useId || (() => {
}), vy = 0;
function hy(e) {
  const [t, n] = d.useState(jy());
  return py(() => {
    n((r) => r ?? String(vy++));
  }, [e]), t ? `radix-${t}` : "";
}
var Sm = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = d.Children.toArray(n), s = a.find(yy);
  if (s) {
    const o = s.props.children, i = a.map((c) => c === s ? d.Children.count(o) > 1 ? d.Children.only(null) : d.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z.jsx(_l, { ...r, ref: t, children: d.isValidElement(o) ? d.cloneElement(o, void 0, i) : null });
  }
  return /* @__PURE__ */ z.jsx(_l, { ...r, ref: t, children: n });
});
Sm.displayName = "Slot";
var _l = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const a = Cy(n);
    return d.cloneElement(n, {
      ...wy(r, n.props),
      // @ts-ignore
      ref: t ? xm(t, a) : a
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
_l.displayName = "SlotClone";
var gy = ({ children: e }) => /* @__PURE__ */ z.jsx(z.Fragment, { children: e });
function yy(e) {
  return d.isValidElement(e) && e.type === gy;
}
function wy(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? a && s ? n[r] = (...i) => {
      s(...i), a(...i);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Cy(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Ey = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], km = Ey.reduce((e, t) => {
  const n = d.forwardRef((r, a) => {
    const { asChild: s, ...o } = r, i = s ? Sm : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ z.jsx(i, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function qc(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function xy({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = Sy({ defaultProp: t, onChange: n }), s = e !== void 0, o = s ? e : r, i = qc(n), c = d.useCallback(
    (u) => {
      if (s) {
        const m = typeof u == "function" ? u(e) : u;
        m !== e && i(m);
      } else
        a(u);
    },
    [s, e, a, i]
  );
  return [o, c];
}
function Sy({
  defaultProp: e,
  onChange: t
}) {
  const n = d.useState(e), [r] = n, a = d.useRef(r), s = qc(t);
  return d.useEffect(() => {
    a.current !== r && (s(r), a.current = r);
  }, [r, a, s]), n;
}
var ci = "rovingFocusGroup.onEntryFocus", ky = { bubbles: !1, cancelable: !0 }, _o = "RovingFocusGroup", [pl, Tm, Ty] = Wb(_o), [Ry, Rm] = my(
  _o,
  [Ty]
), [Oy, My] = Ry(_o), Om = d.forwardRef(
  (e, t) => /* @__PURE__ */ z.jsx(pl.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ z.jsx(pl.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ z.jsx(Ay, { ...e, ref: t }) }) })
);
Om.displayName = _o;
var Ay = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: a = !1,
    dir: s,
    currentTabStopId: o,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: c,
    onEntryFocus: u,
    preventScrollOnEntryFocus: f = !1,
    ...m
  } = e, b = d.useRef(null), _ = by(t, b), j = Vb(s), [p = null, v] = xy({
    prop: o,
    defaultProp: i,
    onChange: c
  }), [h, g] = d.useState(!1), w = qc(u), x = Tm(n), y = d.useRef(!1), [E, C] = d.useState(0);
  return d.useEffect(() => {
    const S = b.current;
    if (S)
      return S.addEventListener(ci, w), () => S.removeEventListener(ci, w);
  }, [w]), /* @__PURE__ */ z.jsx(
    Oy,
    {
      scope: n,
      orientation: r,
      dir: j,
      loop: a,
      currentTabStopId: p,
      onItemFocus: d.useCallback(
        (S) => v(S),
        [v]
      ),
      onItemShiftTab: d.useCallback(() => g(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => C((S) => S + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => C((S) => S - 1),
        []
      ),
      children: /* @__PURE__ */ z.jsx(
        km.div,
        {
          tabIndex: h || E === 0 ? -1 : 0,
          "data-orientation": r,
          ...m,
          ref: _,
          style: { outline: "none", ...e.style },
          onMouseDown: or(e.onMouseDown, () => {
            y.current = !0;
          }),
          onFocus: or(e.onFocus, (S) => {
            const k = !y.current;
            if (S.target === S.currentTarget && k && !h) {
              const O = new CustomEvent(ci, ky);
              if (S.currentTarget.dispatchEvent(O), !O.defaultPrevented) {
                const L = x().filter((D) => D.focusable), H = L.find((D) => D.active), T = L.find((D) => D.id === p), M = [H, T, ...L].filter(
                  Boolean
                ).map((D) => D.ref.current);
                Pm(M, f);
              }
            }
            y.current = !1;
          }),
          onBlur: or(e.onBlur, () => g(!1))
        }
      )
    }
  );
}), Mm = "RovingFocusGroupItem", Am = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: a = !1,
      tabStopId: s,
      ...o
    } = e, i = hy(), c = s || i, u = My(Mm, n), f = u.currentTabStopId === c, m = Tm(n), { onFocusableItemAdd: b, onFocusableItemRemove: _ } = u;
    return d.useEffect(() => {
      if (r)
        return b(), () => _();
    }, [r, b, _]), /* @__PURE__ */ z.jsx(
      pl.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: a,
        children: /* @__PURE__ */ z.jsx(
          km.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": u.orientation,
            ...o,
            ref: t,
            onMouseDown: or(e.onMouseDown, (j) => {
              r ? u.onItemFocus(c) : j.preventDefault();
            }),
            onFocus: or(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: or(e.onKeyDown, (j) => {
              if (j.key === "Tab" && j.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (j.target !== j.currentTarget) return;
              const p = Dy(j, u.orientation, u.dir);
              if (p !== void 0) {
                if (j.metaKey || j.ctrlKey || j.altKey || j.shiftKey) return;
                j.preventDefault();
                let h = m().filter((g) => g.focusable).map((g) => g.ref.current);
                if (p === "last") h.reverse();
                else if (p === "prev" || p === "next") {
                  p === "prev" && h.reverse();
                  const g = h.indexOf(j.currentTarget);
                  h = u.loop ? Iy(h, g + 1) : h.slice(g + 1);
                }
                setTimeout(() => Pm(h));
              }
            })
          }
        )
      }
    );
  }
);
Am.displayName = Mm;
var Py = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Ny(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Dy(e, t, n) {
  const r = Ny(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Py[r];
}
function Pm(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function Iy(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var $y = Om, Ly = Am, zy = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Hn = /* @__PURE__ */ new WeakMap(), Za = /* @__PURE__ */ new WeakMap(), Ja = {}, ui = 0, Nm = function(e) {
  return e && (e.host || Nm(e.parentNode));
}, Fy = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Nm(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Hy = function(e, t, n, r) {
  var a = Fy(t, Array.isArray(e) ? e : [e]);
  Ja[n] || (Ja[n] = /* @__PURE__ */ new WeakMap());
  var s = Ja[n], o = [], i = /* @__PURE__ */ new Set(), c = new Set(a), u = function(m) {
    !m || i.has(m) || (i.add(m), u(m.parentNode));
  };
  a.forEach(u);
  var f = function(m) {
    !m || c.has(m) || Array.prototype.forEach.call(m.children, function(b) {
      if (i.has(b))
        f(b);
      else
        try {
          var _ = b.getAttribute(r), j = _ !== null && _ !== "false", p = (Hn.get(b) || 0) + 1, v = (s.get(b) || 0) + 1;
          Hn.set(b, p), s.set(b, v), o.push(b), p === 1 && j && Za.set(b, !0), v === 1 && b.setAttribute(n, "true"), j || b.setAttribute(r, "true");
        } catch (h) {
          console.error("aria-hidden: cannot operate on ", b, h);
        }
    });
  };
  return f(t), i.clear(), ui++, function() {
    o.forEach(function(m) {
      var b = Hn.get(m) - 1, _ = s.get(m) - 1;
      Hn.set(m, b), s.set(m, _), b || (Za.has(m) || m.removeAttribute(r), Za.delete(m)), _ || m.removeAttribute(n);
    }), ui--, ui || (Hn = /* @__PURE__ */ new WeakMap(), Hn = /* @__PURE__ */ new WeakMap(), Za = /* @__PURE__ */ new WeakMap(), Ja = {});
  };
}, Uc = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), a = zy(e);
  return a ? (r.push.apply(r, Array.from(a.querySelectorAll("[aria-live]"))), Hy(r, a, n, "aria-hidden")) : function() {
    return null;
  };
}, Ue = function() {
  return Ue = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, Ue.apply(this, arguments);
};
function Sa(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function Wc(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, a = t.length, s; r < a; r++)
    (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var ir = "right-scroll-bar-position", lr = "width-before-scroll-bar", By = "with-scroll-bars-hidden", qy = "--removed-body-scroll-bar-size";
function di(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Uy(e, t) {
  var n = de(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var a = n.value;
          a !== r && (n.value = r, n.callback(r, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Wy = typeof window < "u" ? d.useLayoutEffect : d.useEffect, V1 = /* @__PURE__ */ new WeakMap();
function Vc(e, t) {
  var n = Uy(null, function(r) {
    return e.forEach(function(a) {
      return di(a, r);
    });
  });
  return Wy(function() {
    var r = V1.get(n);
    if (r) {
      var a = new Set(r), s = new Set(e), o = n.current;
      a.forEach(function(i) {
        s.has(i) || di(i, null);
      }), s.forEach(function(i) {
        a.has(i) || di(i, o);
      });
    }
    V1.set(n, e);
  }, [e]), n;
}
function Vy(e) {
  return e;
}
function Yy(e, t) {
  t === void 0 && (t = Vy);
  var n = [], r = !1, a = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var o = t(s, r);
      return n.push(o), function() {
        n = n.filter(function(i) {
          return i !== o;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var o = n;
        n = [], o.forEach(s);
      }
      n = {
        push: function(i) {
          return s(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var o = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(s), o = n;
      }
      var c = function() {
        var f = o;
        o = [], f.forEach(s);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), n = {
        push: function(f) {
          o.push(f), u();
        },
        filter: function(f) {
          return o = o.filter(f), n;
        }
      };
    }
  };
  return a;
}
function Yc(e) {
  e === void 0 && (e = {});
  var t = Yy(null);
  return t.options = Ue({ async: !0, ssr: !1 }, e), t;
}
var Dm = function(e) {
  var t = e.sideCar, n = Sa(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return d.createElement(r, Ue({}, n));
};
Dm.isSideCarExport = !0;
function Gc(e, t) {
  return e.useMedium(t), Dm;
}
var Im = Yc(), fi = function() {
}, po = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: fi,
    onWheelCapture: fi,
    onTouchMoveCapture: fi
  }), a = r[0], s = r[1], o = e.forwardProps, i = e.children, c = e.className, u = e.removeScrollBar, f = e.enabled, m = e.shards, b = e.sideCar, _ = e.noIsolation, j = e.inert, p = e.allowPinchZoom, v = e.as, h = v === void 0 ? "div" : v, g = e.gapMode, w = Sa(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = b, y = Vc([n, t]), E = Ue(Ue({}, w), a);
  return d.createElement(
    d.Fragment,
    null,
    f && d.createElement(x, { sideCar: Im, removeScrollBar: u, shards: m, noIsolation: _, inert: j, setCallbacks: s, allowPinchZoom: !!p, lockRef: n, gapMode: g }),
    o ? d.cloneElement(d.Children.only(i), Ue(Ue({}, E), { ref: y })) : d.createElement(h, Ue({}, E, { className: c, ref: y }), i)
  );
});
po.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
po.classNames = {
  fullWidth: lr,
  zeroRight: ir
};
var Gy = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Ky() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Gy();
  return t && e.setAttribute("nonce", t), e;
}
function Xy(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Zy(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Jy = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Ky()) && (Xy(t, n), Zy(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Qy = function() {
  var e = Jy();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, jo = function() {
  var e = Qy(), t = function(n) {
    var r = n.styles, a = n.dynamic;
    return e(r, a), null;
  };
  return t;
}, ew = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, bi = function(e) {
  return parseInt(e || "", 10) || 0;
}, tw = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [bi(n), bi(r), bi(a)];
}, nw = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ew;
  var t = tw(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, rw = jo(), cr = "data-scroll-locked", aw = function(e, t, n, r) {
  var a = e.left, s = e.top, o = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(By, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(cr, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ir, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(lr, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(ir, " .").concat(ir, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(lr, " .").concat(lr, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(cr, `] {
    `).concat(qy, ": ").concat(i, `px;
  }
`);
}, Y1 = function() {
  var e = parseInt(document.body.getAttribute(cr) || "0", 10);
  return isFinite(e) ? e : 0;
}, sw = function() {
  d.useEffect(function() {
    return document.body.setAttribute(cr, (Y1() + 1).toString()), function() {
      var e = Y1() - 1;
      e <= 0 ? document.body.removeAttribute(cr) : document.body.setAttribute(cr, e.toString());
    };
  }, []);
}, Kc = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, a = r === void 0 ? "margin" : r;
  sw();
  var s = d.useMemo(function() {
    return nw(a);
  }, [a]);
  return d.createElement(rw, { styles: aw(s, !t, a, n ? "" : "!important") });
}, jl = !1;
if (typeof window < "u")
  try {
    var Qa = Object.defineProperty({}, "passive", {
      get: function() {
        return jl = !0, !0;
      }
    });
    window.addEventListener("test", Qa, Qa), window.removeEventListener("test", Qa, Qa);
  } catch {
    jl = !1;
  }
var Bn = jl ? { passive: !1 } : !1, ow = function(e) {
  return e.tagName === "TEXTAREA";
}, $m = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !ow(e) && n[t] === "visible")
  );
}, iw = function(e) {
  return $m(e, "overflowY");
}, lw = function(e) {
  return $m(e, "overflowX");
}, G1 = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var a = Lm(e, r);
    if (a) {
      var s = zm(e, r), o = s[1], i = s[2];
      if (o > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, cw = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, uw = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Lm = function(e, t) {
  return e === "v" ? iw(t) : lw(t);
}, zm = function(e, t) {
  return e === "v" ? cw(t) : uw(t);
}, dw = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, fw = function(e, t, n, r, a) {
  var s = dw(e, window.getComputedStyle(t).direction), o = s * r, i = n.target, c = t.contains(i), u = !1, f = o > 0, m = 0, b = 0;
  do {
    var _ = zm(e, i), j = _[0], p = _[1], v = _[2], h = p - v - s * j;
    (j || h) && Lm(e, i) && (m += h, b += j), i instanceof ShadowRoot ? i = i.host : i = i.parentNode;
  } while (
    // portaled content
    !c && i !== document.body || // self content
    c && (t.contains(i) || t === i)
  );
  return (f && (Math.abs(m) < 1 || !a) || !f && (Math.abs(b) < 1 || !a)) && (u = !0), u;
}, es = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, K1 = function(e) {
  return [e.deltaX, e.deltaY];
}, X1 = function(e) {
  return e && "current" in e ? e.current : e;
}, bw = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, mw = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, _w = 0, qn = [];
function pw(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), a = d.useState(_w++)[0], s = d.useState(jo)[0], o = d.useRef(e);
  d.useEffect(function() {
    o.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = Wc([e.lockRef.current], (e.shards || []).map(X1), !0).filter(Boolean);
      return p.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = d.useCallback(function(p, v) {
    if ("touches" in p && p.touches.length === 2)
      return !o.current.allowPinchZoom;
    var h = es(p), g = n.current, w = "deltaX" in p ? p.deltaX : g[0] - h[0], x = "deltaY" in p ? p.deltaY : g[1] - h[1], y, E = p.target, C = Math.abs(w) > Math.abs(x) ? "h" : "v";
    if ("touches" in p && C === "h" && E.type === "range")
      return !1;
    var S = G1(C, E);
    if (!S)
      return !0;
    if (S ? y = C : (y = C === "v" ? "h" : "v", S = G1(C, E)), !S)
      return !1;
    if (!r.current && "changedTouches" in p && (w || x) && (r.current = y), !y)
      return !0;
    var k = r.current || y;
    return fw(k, v, p, k === "h" ? w : x, !0);
  }, []), c = d.useCallback(function(p) {
    var v = p;
    if (!(!qn.length || qn[qn.length - 1] !== s)) {
      var h = "deltaY" in v ? K1(v) : es(v), g = t.current.filter(function(y) {
        return y.name === v.type && (y.target === v.target || v.target === y.shadowParent) && bw(y.delta, h);
      })[0];
      if (g && g.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!g) {
        var w = (o.current.shards || []).map(X1).filter(Boolean).filter(function(y) {
          return y.contains(v.target);
        }), x = w.length > 0 ? i(v, w[0]) : !o.current.noIsolation;
        x && v.cancelable && v.preventDefault();
      }
    }
  }, []), u = d.useCallback(function(p, v, h, g) {
    var w = { name: p, delta: v, target: h, should: g, shadowParent: jw(h) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(x) {
        return x !== w;
      });
    }, 1);
  }, []), f = d.useCallback(function(p) {
    n.current = es(p), r.current = void 0;
  }, []), m = d.useCallback(function(p) {
    u(p.type, K1(p), p.target, i(p, e.lockRef.current));
  }, []), b = d.useCallback(function(p) {
    u(p.type, es(p), p.target, i(p, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return qn.push(s), e.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: b
    }), document.addEventListener("wheel", c, Bn), document.addEventListener("touchmove", c, Bn), document.addEventListener("touchstart", f, Bn), function() {
      qn = qn.filter(function(p) {
        return p !== s;
      }), document.removeEventListener("wheel", c, Bn), document.removeEventListener("touchmove", c, Bn), document.removeEventListener("touchstart", f, Bn);
    };
  }, []);
  var _ = e.removeScrollBar, j = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    j ? d.createElement(s, { styles: mw(a) }) : null,
    _ ? d.createElement(Kc, { gapMode: e.gapMode }) : null
  );
}
function jw(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const vw = Gc(Im, pw);
var Fm = d.forwardRef(function(e, t) {
  return d.createElement(po, Ue({}, e, { ref: t, sideCar: vw }));
});
Fm.classNames = po.classNames;
var vl = ["Enter", " "], hw = ["ArrowDown", "PageUp", "Home"], Hm = ["ArrowUp", "PageDown", "End"], gw = [...hw, ...Hm], yw = {
  ltr: [...vl, "ArrowRight"],
  rtl: [...vl, "ArrowLeft"]
}, ww = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, ka = "Menu", [ua, Cw, Ew] = Wb(ka), [$n, Bm] = _0(ka, [
  Ew,
  Sr,
  Rm
]), vo = Sr(), qm = Rm(), [xw, Ln] = $n(ka), [Sw, Ta] = $n(ka), Um = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: a, onOpenChange: s, modal: o = !0 } = e, i = vo(t), [c, u] = d.useState(null), f = d.useRef(!1), m = An(s), b = Vb(a);
  return d.useEffect(() => {
    const _ = () => {
      f.current = !0, document.addEventListener("pointerdown", j, { capture: !0, once: !0 }), document.addEventListener("pointermove", j, { capture: !0, once: !0 });
    }, j = () => f.current = !1;
    return document.addEventListener("keydown", _, { capture: !0 }), () => {
      document.removeEventListener("keydown", _, { capture: !0 }), document.removeEventListener("pointerdown", j, { capture: !0 }), document.removeEventListener("pointermove", j, { capture: !0 });
    };
  }, []), /* @__PURE__ */ z.jsx(Fc, { ...i, children: /* @__PURE__ */ z.jsx(
    xw,
    {
      scope: t,
      open: n,
      onOpenChange: m,
      content: c,
      onContentChange: u,
      children: /* @__PURE__ */ z.jsx(
        Sw,
        {
          scope: t,
          onClose: d.useCallback(() => m(!1), [m]),
          isUsingKeyboardRef: f,
          dir: b,
          modal: o,
          children: r
        }
      )
    }
  ) });
};
Um.displayName = ka;
var kw = "MenuAnchor", Xc = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, a = vo(n);
    return /* @__PURE__ */ z.jsx(mo, { ...a, ...r, ref: t });
  }
);
Xc.displayName = kw;
var Zc = "MenuPortal", [Tw, Wm] = $n(Zc, {
  forceMount: void 0
}), Vm = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: a } = e, s = Ln(Zc, t);
  return /* @__PURE__ */ z.jsx(Tw, { scope: t, forceMount: n, children: /* @__PURE__ */ z.jsx(xa, { present: n || s.open, children: /* @__PURE__ */ z.jsx(Em, { asChild: !0, container: a, children: r }) }) });
};
Vm.displayName = Zc;
var pt = "MenuContent", [Rw, Jc] = $n(pt), Ym = d.forwardRef(
  (e, t) => {
    const n = Wm(pt, e.__scopeMenu), { forceMount: r = n.forceMount, ...a } = e, s = Ln(pt, e.__scopeMenu), o = Ta(pt, e.__scopeMenu);
    return /* @__PURE__ */ z.jsx(ua.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ z.jsx(xa, { present: r || s.open, children: /* @__PURE__ */ z.jsx(ua.Slot, { scope: e.__scopeMenu, children: o.modal ? /* @__PURE__ */ z.jsx(Ow, { ...a, ref: t }) : /* @__PURE__ */ z.jsx(Mw, { ...a, ref: t }) }) }) });
  }
), Ow = d.forwardRef(
  (e, t) => {
    const n = Ln(pt, e.__scopeMenu), r = d.useRef(null), a = Gt(t, r);
    return d.useEffect(() => {
      const s = r.current;
      if (s) return Uc(s);
    }, []), /* @__PURE__ */ z.jsx(
      Qc,
      {
        ...e,
        ref: a,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: $e(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), Mw = d.forwardRef((e, t) => {
  const n = Ln(pt, e.__scopeMenu);
  return /* @__PURE__ */ z.jsx(
    Qc,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Qc = d.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: a,
      onOpenAutoFocus: s,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: i,
      onEntryFocus: c,
      onEscapeKeyDown: u,
      onPointerDownOutside: f,
      onFocusOutside: m,
      onInteractOutside: b,
      onDismiss: _,
      disableOutsideScroll: j,
      ...p
    } = e, v = Ln(pt, n), h = Ta(pt, n), g = vo(n), w = qm(n), x = Cw(n), [y, E] = d.useState(null), C = d.useRef(null), S = Gt(t, C, v.onContentChange), k = d.useRef(0), O = d.useRef(""), L = d.useRef(0), H = d.useRef(null), T = d.useRef("right"), R = d.useRef(0), M = j ? Fm : d.Fragment, D = j ? { as: Oc, allowPinchZoom: !0 } : void 0, I = (P) => {
      var K, te;
      const A = O.current + P, $ = x().filter((Z) => !Z.disabled), B = document.activeElement, Y = (K = $.find((Z) => Z.ref.current === B)) == null ? void 0 : K.textValue, J = $.map((Z) => Z.textValue), W = qw(J, A, Y), V = (te = $.find((Z) => Z.textValue === W)) == null ? void 0 : te.ref.current;
      (function Z(se) {
        O.current = se, window.clearTimeout(k.current), se !== "" && (k.current = window.setTimeout(() => Z(""), 1e3));
      })(A), V && setTimeout(() => V.focus());
    };
    d.useEffect(() => () => window.clearTimeout(k.current), []), M0();
    const F = d.useCallback((P) => {
      var $, B;
      return T.current === (($ = H.current) == null ? void 0 : $.side) && Ww(P, (B = H.current) == null ? void 0 : B.area);
    }, []);
    return /* @__PURE__ */ z.jsx(
      Rw,
      {
        scope: n,
        searchRef: O,
        onItemEnter: d.useCallback(
          (P) => {
            F(P) && P.preventDefault();
          },
          [F]
        ),
        onItemLeave: d.useCallback(
          (P) => {
            var A;
            F(P) || ((A = C.current) == null || A.focus(), E(null));
          },
          [F]
        ),
        onTriggerLeave: d.useCallback(
          (P) => {
            F(P) && P.preventDefault();
          },
          [F]
        ),
        pointerGraceTimerRef: L,
        onPointerGraceIntentChange: d.useCallback((P) => {
          H.current = P;
        }, []),
        children: /* @__PURE__ */ z.jsx(M, { ...D, children: /* @__PURE__ */ z.jsx(
          Zb,
          {
            asChild: !0,
            trapped: a,
            onMountAutoFocus: $e(s, (P) => {
              var A;
              P.preventDefault(), (A = C.current) == null || A.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: o,
            children: /* @__PURE__ */ z.jsx(
              Kb,
              {
                asChild: !0,
                disableOutsidePointerEvents: i,
                onEscapeKeyDown: u,
                onPointerDownOutside: f,
                onFocusOutside: m,
                onInteractOutside: b,
                onDismiss: _,
                children: /* @__PURE__ */ z.jsx(
                  $y,
                  {
                    asChild: !0,
                    ...w,
                    dir: h.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: y,
                    onCurrentTabStopIdChange: E,
                    onEntryFocus: $e(c, (P) => {
                      h.isUsingKeyboardRef.current || P.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ z.jsx(
                      Hc,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": c3(v.open),
                        "data-radix-menu-content": "",
                        dir: h.dir,
                        ...g,
                        ...p,
                        ref: S,
                        style: { outline: "none", ...p.style },
                        onKeyDown: $e(p.onKeyDown, (P) => {
                          const $ = P.target.closest("[data-radix-menu-content]") === P.currentTarget, B = P.ctrlKey || P.altKey || P.metaKey, Y = P.key.length === 1;
                          $ && (P.key === "Tab" && P.preventDefault(), !B && Y && I(P.key));
                          const J = C.current;
                          if (P.target !== J || !gw.includes(P.key)) return;
                          P.preventDefault();
                          const V = x().filter((K) => !K.disabled).map((K) => K.ref.current);
                          Hm.includes(P.key) && V.reverse(), Hw(V);
                        }),
                        onBlur: $e(e.onBlur, (P) => {
                          P.currentTarget.contains(P.target) || (window.clearTimeout(k.current), O.current = "");
                        }),
                        onPointerMove: $e(
                          e.onPointerMove,
                          da((P) => {
                            const A = P.target, $ = R.current !== P.clientX;
                            if (P.currentTarget.contains(A) && $) {
                              const B = P.clientX > R.current ? "right" : "left";
                              T.current = B, R.current = P.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ym.displayName = pt;
var Aw = "MenuGroup", eu = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ z.jsx(Kt.div, { role: "group", ...r, ref: t });
  }
);
eu.displayName = Aw;
var Pw = "MenuLabel", Gm = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ z.jsx(Kt.div, { ...r, ref: t });
  }
);
Gm.displayName = Pw;
var Ls = "MenuItem", Z1 = "menu.itemSelect", ho = d.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...a } = e, s = d.useRef(null), o = Ta(Ls, e.__scopeMenu), i = Jc(Ls, e.__scopeMenu), c = Gt(t, s), u = d.useRef(!1), f = () => {
      const m = s.current;
      if (!n && m) {
        const b = new CustomEvent(Z1, { bubbles: !0, cancelable: !0 });
        m.addEventListener(Z1, (_) => r == null ? void 0 : r(_), { once: !0 }), Yb(m, b), b.defaultPrevented ? u.current = !1 : o.onClose();
      }
    };
    return /* @__PURE__ */ z.jsx(
      Km,
      {
        ...a,
        ref: c,
        disabled: n,
        onClick: $e(e.onClick, f),
        onPointerDown: (m) => {
          var b;
          (b = e.onPointerDown) == null || b.call(e, m), u.current = !0;
        },
        onPointerUp: $e(e.onPointerUp, (m) => {
          var b;
          u.current || (b = m.currentTarget) == null || b.click();
        }),
        onKeyDown: $e(e.onKeyDown, (m) => {
          const b = i.searchRef.current !== "";
          n || b && m.key === " " || vl.includes(m.key) && (m.currentTarget.click(), m.preventDefault());
        })
      }
    );
  }
);
ho.displayName = Ls;
var Km = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: a, ...s } = e, o = Jc(Ls, n), i = qm(n), c = d.useRef(null), u = Gt(t, c), [f, m] = d.useState(!1), [b, _] = d.useState("");
    return d.useEffect(() => {
      const j = c.current;
      j && _((j.textContent ?? "").trim());
    }, [s.children]), /* @__PURE__ */ z.jsx(
      ua.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: a ?? b,
        children: /* @__PURE__ */ z.jsx(Ly, { asChild: !0, ...i, focusable: !r, children: /* @__PURE__ */ z.jsx(
          Kt.div,
          {
            role: "menuitem",
            "data-highlighted": f ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...s,
            ref: u,
            onPointerMove: $e(
              e.onPointerMove,
              da((j) => {
                r ? o.onItemLeave(j) : (o.onItemEnter(j), j.defaultPrevented || j.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: $e(
              e.onPointerLeave,
              da((j) => o.onItemLeave(j))
            ),
            onFocus: $e(e.onFocus, () => m(!0)),
            onBlur: $e(e.onBlur, () => m(!1))
          }
        ) })
      }
    );
  }
), Nw = "MenuCheckboxItem", Xm = d.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...a } = e;
    return /* @__PURE__ */ z.jsx(t3, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ z.jsx(
      ho,
      {
        role: "menuitemcheckbox",
        "aria-checked": zs(n) ? "mixed" : n,
        ...a,
        ref: t,
        "data-state": nu(n),
        onSelect: $e(
          a.onSelect,
          () => r == null ? void 0 : r(zs(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Xm.displayName = Nw;
var Zm = "MenuRadioGroup", [Dw, Iw] = $n(
  Zm,
  { value: void 0, onValueChange: () => {
  } }
), Jm = d.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...a } = e, s = An(r);
    return /* @__PURE__ */ z.jsx(Dw, { scope: e.__scopeMenu, value: n, onValueChange: s, children: /* @__PURE__ */ z.jsx(eu, { ...a, ref: t }) });
  }
);
Jm.displayName = Zm;
var Qm = "MenuRadioItem", e3 = d.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, a = Iw(Qm, e.__scopeMenu), s = n === a.value;
    return /* @__PURE__ */ z.jsx(t3, { scope: e.__scopeMenu, checked: s, children: /* @__PURE__ */ z.jsx(
      ho,
      {
        role: "menuitemradio",
        "aria-checked": s,
        ...r,
        ref: t,
        "data-state": nu(s),
        onSelect: $e(
          r.onSelect,
          () => {
            var o;
            return (o = a.onValueChange) == null ? void 0 : o.call(a, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
e3.displayName = Qm;
var tu = "MenuItemIndicator", [t3, $w] = $n(
  tu,
  { checked: !1 }
), n3 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...a } = e, s = $w(tu, n);
    return /* @__PURE__ */ z.jsx(
      xa,
      {
        present: r || zs(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ z.jsx(
          Kt.span,
          {
            ...a,
            ref: t,
            "data-state": nu(s.checked)
          }
        )
      }
    );
  }
);
n3.displayName = tu;
var Lw = "MenuSeparator", r3 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ z.jsx(
      Kt.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
r3.displayName = Lw;
var zw = "MenuArrow", a3 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, a = vo(n);
    return /* @__PURE__ */ z.jsx(Bc, { ...a, ...r, ref: t });
  }
);
a3.displayName = zw;
var Fw = "MenuSub", [YN, s3] = $n(Fw), Yr = "MenuSubTrigger", o3 = d.forwardRef(
  (e, t) => {
    const n = Ln(Yr, e.__scopeMenu), r = Ta(Yr, e.__scopeMenu), a = s3(Yr, e.__scopeMenu), s = Jc(Yr, e.__scopeMenu), o = d.useRef(null), { pointerGraceTimerRef: i, onPointerGraceIntentChange: c } = s, u = { __scopeMenu: e.__scopeMenu }, f = d.useCallback(() => {
      o.current && window.clearTimeout(o.current), o.current = null;
    }, []);
    return d.useEffect(() => f, [f]), d.useEffect(() => {
      const m = i.current;
      return () => {
        window.clearTimeout(m), c(null);
      };
    }, [i, c]), /* @__PURE__ */ z.jsx(Xc, { asChild: !0, ...u, children: /* @__PURE__ */ z.jsx(
      Km,
      {
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": a.contentId,
        "data-state": c3(n.open),
        ...e,
        ref: Rc(t, a.onTriggerChange),
        onClick: (m) => {
          var b;
          (b = e.onClick) == null || b.call(e, m), !(e.disabled || m.defaultPrevented) && (m.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: $e(
          e.onPointerMove,
          da((m) => {
            s.onItemEnter(m), !m.defaultPrevented && !e.disabled && !n.open && !o.current && (s.onPointerGraceIntentChange(null), o.current = window.setTimeout(() => {
              n.onOpenChange(!0), f();
            }, 100));
          })
        ),
        onPointerLeave: $e(
          e.onPointerLeave,
          da((m) => {
            var _, j;
            f();
            const b = (_ = n.content) == null ? void 0 : _.getBoundingClientRect();
            if (b) {
              const p = (j = n.content) == null ? void 0 : j.dataset.side, v = p === "right", h = v ? -5 : 5, g = b[v ? "left" : "right"], w = b[v ? "right" : "left"];
              s.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: m.clientX + h, y: m.clientY },
                  { x: g, y: b.top },
                  { x: w, y: b.top },
                  { x: w, y: b.bottom },
                  { x: g, y: b.bottom }
                ],
                side: p
              }), window.clearTimeout(i.current), i.current = window.setTimeout(
                () => s.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (s.onTriggerLeave(m), m.defaultPrevented) return;
              s.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: $e(e.onKeyDown, (m) => {
          var _;
          const b = s.searchRef.current !== "";
          e.disabled || b && m.key === " " || yw[r.dir].includes(m.key) && (n.onOpenChange(!0), (_ = n.content) == null || _.focus(), m.preventDefault());
        })
      }
    ) });
  }
);
o3.displayName = Yr;
var i3 = "MenuSubContent", l3 = d.forwardRef(
  (e, t) => {
    const n = Wm(pt, e.__scopeMenu), { forceMount: r = n.forceMount, ...a } = e, s = Ln(pt, e.__scopeMenu), o = Ta(pt, e.__scopeMenu), i = s3(i3, e.__scopeMenu), c = d.useRef(null), u = Gt(t, c);
    return /* @__PURE__ */ z.jsx(ua.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ z.jsx(xa, { present: r || s.open, children: /* @__PURE__ */ z.jsx(ua.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ z.jsx(
      Qc,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...a,
        ref: u,
        align: "start",
        side: o.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (f) => {
          var m;
          o.isUsingKeyboardRef.current && ((m = c.current) == null || m.focus()), f.preventDefault();
        },
        onCloseAutoFocus: (f) => f.preventDefault(),
        onFocusOutside: $e(e.onFocusOutside, (f) => {
          f.target !== i.trigger && s.onOpenChange(!1);
        }),
        onEscapeKeyDown: $e(e.onEscapeKeyDown, (f) => {
          o.onClose(), f.preventDefault();
        }),
        onKeyDown: $e(e.onKeyDown, (f) => {
          var _;
          const m = f.currentTarget.contains(f.target), b = ww[o.dir].includes(f.key);
          m && b && (s.onOpenChange(!1), (_ = i.trigger) == null || _.focus(), f.preventDefault());
        })
      }
    ) }) }) });
  }
);
l3.displayName = i3;
function c3(e) {
  return e ? "open" : "closed";
}
function zs(e) {
  return e === "indeterminate";
}
function nu(e) {
  return zs(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Hw(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function Bw(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function qw(e, t, n) {
  const a = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, s = n ? e.indexOf(n) : -1;
  let o = Bw(e, Math.max(s, 0));
  a.length === 1 && (o = o.filter((u) => u !== n));
  const c = o.find(
    (u) => u.toLowerCase().startsWith(a.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function Uw(e, t) {
  const { x: n, y: r } = e;
  let a = !1;
  for (let s = 0, o = t.length - 1; s < t.length; o = s++) {
    const i = t[s].x, c = t[s].y, u = t[o].x, f = t[o].y;
    c > r != f > r && n < (u - i) * (r - c) / (f - c) + i && (a = !a);
  }
  return a;
}
function Ww(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return Uw(n, t);
}
function da(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Vw = Um, Yw = Xc, Gw = Vm, Kw = Ym, Xw = eu, Zw = Gm, Jw = ho, Qw = Xm, eC = Jm, tC = e3, nC = n3, rC = r3, aC = a3, sC = o3, oC = l3, iC = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, lC = d.useId || (() => {
}), cC = 0;
function J1(e) {
  const [t, n] = d.useState(lC());
  return iC(() => {
    e || n((r) => r ?? String(cC++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var ru = "DropdownMenu", [uC, GN] = Zh(
  ru,
  [Bm]
), rt = Bm(), [dC, u3] = uC(ru), d3 = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: a,
    defaultOpen: s,
    onOpenChange: o,
    modal: i = !0
  } = e, c = rt(t), u = d.useRef(null), [f = !1, m] = Qh({
    prop: a,
    defaultProp: s,
    onChange: o
  });
  return /* @__PURE__ */ z.jsx(
    dC,
    {
      scope: t,
      triggerId: J1(),
      triggerRef: u,
      contentId: J1(),
      open: f,
      onOpenChange: m,
      onOpenToggle: d.useCallback(() => m((b) => !b), [m]),
      modal: i,
      children: /* @__PURE__ */ z.jsx(Vw, { ...c, open: f, onOpenChange: m, dir: r, modal: i, children: n })
    }
  );
};
d3.displayName = ru;
var f3 = "DropdownMenuTrigger", b3 = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...a } = e, s = u3(f3, n), o = rt(n);
    return /* @__PURE__ */ z.jsx(Yw, { asChild: !0, ...o, children: /* @__PURE__ */ z.jsx(
      o0.button,
      {
        type: "button",
        id: s.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": s.open,
        "aria-controls": s.open ? s.contentId : void 0,
        "data-state": s.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...a,
        ref: Hb(t, s.triggerRef),
        onPointerDown: Ps(e.onPointerDown, (i) => {
          !r && i.button === 0 && i.ctrlKey === !1 && (s.onOpenToggle(), s.open || i.preventDefault());
        }),
        onKeyDown: Ps(e.onKeyDown, (i) => {
          r || (["Enter", " "].includes(i.key) && s.onOpenToggle(), i.key === "ArrowDown" && s.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(i.key) && i.preventDefault());
        })
      }
    ) });
  }
);
b3.displayName = f3;
var fC = "DropdownMenuPortal", m3 = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = rt(t);
  return /* @__PURE__ */ z.jsx(Gw, { ...r, ...n });
};
m3.displayName = fC;
var _3 = "DropdownMenuContent", p3 = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = u3(_3, n), s = rt(n), o = d.useRef(!1);
    return /* @__PURE__ */ z.jsx(
      Kw,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...s,
        ...r,
        ref: t,
        onCloseAutoFocus: Ps(e.onCloseAutoFocus, (i) => {
          var c;
          o.current || (c = a.triggerRef.current) == null || c.focus(), o.current = !1, i.preventDefault();
        }),
        onInteractOutside: Ps(e.onInteractOutside, (i) => {
          const c = i.detail.originalEvent, u = c.button === 0 && c.ctrlKey === !0, f = c.button === 2 || u;
          (!a.modal || f) && (o.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
p3.displayName = _3;
var bC = "DropdownMenuGroup", mC = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = rt(n);
    return /* @__PURE__ */ z.jsx(Xw, { ...a, ...r, ref: t });
  }
);
mC.displayName = bC;
var _C = "DropdownMenuLabel", j3 = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = rt(n);
    return /* @__PURE__ */ z.jsx(Zw, { ...a, ...r, ref: t });
  }
);
j3.displayName = _C;
var pC = "DropdownMenuItem", v3 = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = rt(n);
    return /* @__PURE__ */ z.jsx(Jw, { ...a, ...r, ref: t });
  }
);
v3.displayName = pC;
var jC = "DropdownMenuCheckboxItem", vC = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = rt(n);
  return /* @__PURE__ */ z.jsx(Qw, { ...a, ...r, ref: t });
});
vC.displayName = jC;
var hC = "DropdownMenuRadioGroup", gC = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = rt(n);
  return /* @__PURE__ */ z.jsx(eC, { ...a, ...r, ref: t });
});
gC.displayName = hC;
var yC = "DropdownMenuRadioItem", wC = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = rt(n);
  return /* @__PURE__ */ z.jsx(tC, { ...a, ...r, ref: t });
});
wC.displayName = yC;
var CC = "DropdownMenuItemIndicator", EC = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = rt(n);
  return /* @__PURE__ */ z.jsx(nC, { ...a, ...r, ref: t });
});
EC.displayName = CC;
var xC = "DropdownMenuSeparator", h3 = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = rt(n);
  return /* @__PURE__ */ z.jsx(rC, { ...a, ...r, ref: t });
});
h3.displayName = xC;
var SC = "DropdownMenuArrow", kC = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, a = rt(n);
    return /* @__PURE__ */ z.jsx(aC, { ...a, ...r, ref: t });
  }
);
kC.displayName = SC;
var TC = "DropdownMenuSubTrigger", RC = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = rt(n);
  return /* @__PURE__ */ z.jsx(sC, { ...a, ...r, ref: t });
});
RC.displayName = TC;
var OC = "DropdownMenuSubContent", MC = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, a = rt(n);
  return /* @__PURE__ */ z.jsx(
    oC,
    {
      ...a,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
MC.displayName = OC;
var AC = d3, PC = b3, NC = m3, DC = p3, IC = j3, g3 = v3, $C = h3;
function LC(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function zC(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
const y3 = (e, t, n) => Math.min(Math.max(n, e), t), tt = {
  duration: 0.3,
  delay: 0,
  endDelay: 0,
  repeat: 0,
  easing: "ease"
}, fa = (e) => typeof e == "number", ur = (e) => Array.isArray(e) && !fa(e[0]), FC = (e, t, n) => {
  const r = t - e;
  return ((n - e) % r + r) % r + e;
};
function w3(e, t) {
  return ur(e) ? e[FC(0, e.length, t)] : e;
}
const au = (e, t, n) => -n * e + n * t + e, C3 = () => {
}, an = (e) => e, go = (e, t, n) => t - e === 0 ? 1 : (n - e) / (t - e);
function su(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const a = go(0, t, r);
    e.push(au(n, 1, a));
  }
}
function E3(e) {
  const t = [0];
  return su(t, e - 1), t;
}
function HC(e, t = E3(e.length), n = an) {
  const r = e.length, a = r - t.length;
  return a > 0 && su(t, a), (s) => {
    let o = 0;
    for (; o < r - 2 && !(s < t[o + 1]); o++)
      ;
    let i = y3(0, 1, go(t[o], t[o + 1], s));
    return i = w3(n, o)(i), au(e[o], e[o + 1], i);
  };
}
const x3 = (e) => Array.isArray(e) && fa(e[0]), Fs = (e) => typeof e == "object" && !!e.createAnimation, mr = (e) => typeof e == "function", S3 = (e) => typeof e == "string", Qr = {
  ms: (e) => e * 1e3,
  s: (e) => e / 1e3
}, k3 = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, BC = 1e-7, qC = 12;
function UC(e, t, n, r, a) {
  let s, o, i = 0;
  do
    o = t + (n - t) / 2, s = k3(o, r, a) - e, s > 0 ? n = o : t = o;
  while (Math.abs(s) > BC && ++i < qC);
  return o;
}
function Gr(e, t, n, r) {
  if (e === t && n === r)
    return an;
  const a = (s) => UC(s, 0, 1, e, n);
  return (s) => s === 0 || s === 1 ? s : k3(a(s), t, r);
}
const WC = (e, t = "end") => (n) => {
  n = t === "end" ? Math.min(n, 0.999) : Math.max(n, 1e-3);
  const r = n * e, a = t === "end" ? Math.floor(r) : Math.ceil(r);
  return y3(0, 1, a / e);
}, VC = {
  ease: Gr(0.25, 0.1, 0.25, 1),
  "ease-in": Gr(0.42, 0, 1, 1),
  "ease-in-out": Gr(0.42, 0, 0.58, 1),
  "ease-out": Gr(0, 0, 0.58, 1)
}, YC = /\((.*?)\)/;
function Q1(e) {
  if (mr(e))
    return e;
  if (x3(e))
    return Gr(...e);
  const t = VC[e];
  if (t)
    return t;
  if (e.startsWith("steps")) {
    const n = YC.exec(e);
    if (n) {
      const r = n[1].split(",");
      return WC(parseFloat(r[0]), r[1].trim());
    }
  }
  return an;
}
class ou {
  constructor(t, n = [0, 1], { easing: r, duration: a = tt.duration, delay: s = tt.delay, endDelay: o = tt.endDelay, repeat: i = tt.repeat, offset: c, direction: u = "normal", autoplay: f = !0 } = {}) {
    if (this.startTime = null, this.rate = 1, this.t = 0, this.cancelTimestamp = null, this.easing = an, this.duration = 0, this.totalDuration = 0, this.repeat = 0, this.playState = "idle", this.finished = new Promise((b, _) => {
      this.resolve = b, this.reject = _;
    }), r = r || tt.easing, Fs(r)) {
      const b = r.createAnimation(n);
      r = b.easing, n = b.keyframes || n, a = b.duration || a;
    }
    this.repeat = i, this.easing = ur(r) ? an : Q1(r), this.updateDuration(a);
    const m = HC(n, c, ur(r) ? r.map(Q1) : an);
    this.tick = (b) => {
      var _;
      s = s;
      let j = 0;
      this.pauseTime !== void 0 ? j = this.pauseTime : j = (b - this.startTime) * this.rate, this.t = j, j /= 1e3, j = Math.max(j - s, 0), this.playState === "finished" && this.pauseTime === void 0 && (j = this.totalDuration);
      const p = j / this.duration;
      let v = Math.floor(p), h = p % 1;
      !h && p >= 1 && (h = 1), h === 1 && v--;
      const g = v % 2;
      (u === "reverse" || u === "alternate" && g || u === "alternate-reverse" && !g) && (h = 1 - h);
      const w = j >= this.totalDuration ? 1 : Math.min(h, 1), x = m(this.easing(w));
      t(x), this.pauseTime === void 0 && (this.playState === "finished" || j >= this.totalDuration + o) ? (this.playState = "finished", (_ = this.resolve) === null || _ === void 0 || _.call(this, x)) : this.playState !== "idle" && (this.frameRequestId = requestAnimationFrame(this.tick));
    }, f && this.play();
  }
  play() {
    const t = performance.now();
    this.playState = "running", this.pauseTime !== void 0 ? this.startTime = t - this.pauseTime : this.startTime || (this.startTime = t), this.cancelTimestamp = this.startTime, this.pauseTime = void 0, this.frameRequestId = requestAnimationFrame(this.tick);
  }
  pause() {
    this.playState = "paused", this.pauseTime = this.t;
  }
  finish() {
    this.playState = "finished", this.tick(0);
  }
  stop() {
    var t;
    this.playState = "idle", this.frameRequestId !== void 0 && cancelAnimationFrame(this.frameRequestId), (t = this.reject) === null || t === void 0 || t.call(this, !1);
  }
  cancel() {
    this.stop(), this.tick(this.cancelTimestamp);
  }
  reverse() {
    this.rate *= -1;
  }
  commitStyles() {
  }
  updateDuration(t) {
    this.duration = t, this.totalDuration = t * (this.repeat + 1);
  }
  get currentTime() {
    return this.t;
  }
  set currentTime(t) {
    this.pauseTime !== void 0 || this.rate === 0 ? this.pauseTime = t : this.startTime = performance.now() - t / this.rate;
  }
  get playbackRate() {
    return this.rate;
  }
  set playbackRate(t) {
    this.rate = t;
  }
}
var Hs = function() {
};
process.env.NODE_ENV !== "production" && (Hs = function(e, t) {
  if (!e)
    throw new Error(t);
});
class GC {
  setAnimation(t) {
    this.animation = t, t == null || t.finished.then(() => this.clearAnimation()).catch(() => {
    });
  }
  clearAnimation() {
    this.animation = this.generator = void 0;
  }
}
const mi = /* @__PURE__ */ new WeakMap();
function T3(e) {
  return mi.has(e) || mi.set(e, {
    transforms: [],
    values: /* @__PURE__ */ new Map()
  }), mi.get(e);
}
function KC(e, t) {
  return e.has(t) || e.set(t, new GC()), e.get(t);
}
const XC = ["", "X", "Y", "Z"], ZC = ["translate", "scale", "rotate", "skew"], Bs = {
  x: "translateX",
  y: "translateY",
  z: "translateZ"
}, ed = {
  syntax: "<angle>",
  initialValue: "0deg",
  toDefaultUnit: (e) => e + "deg"
}, JC = {
  translate: {
    syntax: "<length-percentage>",
    initialValue: "0px",
    toDefaultUnit: (e) => e + "px"
  },
  rotate: ed,
  scale: {
    syntax: "<number>",
    initialValue: 1,
    toDefaultUnit: an
  },
  skew: ed
}, ba = /* @__PURE__ */ new Map(), iu = (e) => `--motion-${e}`, qs = ["x", "y", "z"];
ZC.forEach((e) => {
  XC.forEach((t) => {
    qs.push(e + t), ba.set(iu(e + t), JC[e]);
  });
});
const QC = (e, t) => qs.indexOf(e) - qs.indexOf(t), eE = new Set(qs), R3 = (e) => eE.has(e), tE = (e, t) => {
  Bs[t] && (t = Bs[t]);
  const { transforms: n } = T3(e);
  LC(n, t), e.style.transform = nE(n);
}, nE = (e) => e.sort(QC).reduce(rE, "").trim(), rE = (e, t) => `${e} ${t}(var(${iu(t)}))`, hl = (e) => e.startsWith("--"), td = /* @__PURE__ */ new Set();
function aE(e) {
  if (!td.has(e)) {
    td.add(e);
    try {
      const { syntax: t, initialValue: n } = ba.has(e) ? ba.get(e) : {};
      CSS.registerProperty({
        name: e,
        inherits: !1,
        syntax: t,
        initialValue: n
      });
    } catch {
    }
  }
}
const _i = (e, t) => document.createElement("div").animate(e, t), nd = {
  cssRegisterProperty: () => typeof CSS < "u" && Object.hasOwnProperty.call(CSS, "registerProperty"),
  waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
  partialKeyframes: () => {
    try {
      _i({ opacity: [1] });
    } catch {
      return !1;
    }
    return !0;
  },
  finished: () => !!_i({ opacity: [0, 1] }, { duration: 1e-3 }).finished,
  linearEasing: () => {
    try {
      _i({ opacity: 0 }, { easing: "linear(0, 1)" });
    } catch {
      return !1;
    }
    return !0;
  }
}, pi = {}, tr = {};
for (const e in nd)
  tr[e] = () => (pi[e] === void 0 && (pi[e] = nd[e]()), pi[e]);
const sE = 0.015, oE = (e, t) => {
  let n = "";
  const r = Math.round(t / sE);
  for (let a = 0; a < r; a++)
    n += e(go(0, r - 1, a)) + ", ";
  return n.substring(0, n.length - 2);
}, rd = (e, t) => mr(e) ? tr.linearEasing() ? `linear(${oE(e, t)})` : tt.easing : x3(e) ? iE(e) : e, iE = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`;
function lE(e, t) {
  for (let n = 0; n < e.length; n++)
    e[n] === null && (e[n] = n ? e[n - 1] : t());
  return e;
}
const O3 = (e) => Array.isArray(e) ? e : [e];
function gl(e) {
  return Bs[e] && (e = Bs[e]), R3(e) ? iu(e) : e;
}
const ts = {
  get: (e, t) => {
    t = gl(t);
    let n = hl(t) ? e.style.getPropertyValue(t) : getComputedStyle(e)[t];
    if (!n && n !== 0) {
      const r = ba.get(t);
      r && (n = r.initialValue);
    }
    return n;
  },
  set: (e, t, n) => {
    t = gl(t), hl(t) ? e.style.setProperty(t, n) : e.style[t] = n;
  }
};
function M3(e, t = !0) {
  if (!(!e || e.playState === "finished"))
    try {
      e.stop ? e.stop() : (t && e.commitStyles(), e.cancel());
    } catch {
    }
}
function cE(e, t) {
  var n;
  let r = (t == null ? void 0 : t.toDefaultUnit) || an;
  const a = e[e.length - 1];
  if (S3(a)) {
    const s = ((n = a.match(/(-?[\d.]+)([a-z%]*)/)) === null || n === void 0 ? void 0 : n[2]) || "";
    s && (r = (o) => o + s);
  }
  return r;
}
function uE() {
  return window.__MOTION_DEV_TOOLS_RECORD;
}
function A3(e, t, n, r = {}, a) {
  const s = uE(), o = r.record !== !1 && s;
  let i, { duration: c = tt.duration, delay: u = tt.delay, endDelay: f = tt.endDelay, repeat: m = tt.repeat, easing: b = tt.easing, persist: _ = !1, direction: j, offset: p, allowWebkitAcceleration: v = !1, autoplay: h = !0 } = r;
  const g = T3(e), w = R3(t);
  let x = tr.waapi();
  w && tE(e, t);
  const y = gl(t), E = KC(g.values, y), C = ba.get(y);
  return M3(E.animation, !(Fs(b) && E.generator) && r.record !== !1), () => {
    const S = () => {
      var L, H;
      return (H = (L = ts.get(e, y)) !== null && L !== void 0 ? L : C == null ? void 0 : C.initialValue) !== null && H !== void 0 ? H : 0;
    };
    let k = lE(O3(n), S);
    const O = cE(k, C);
    if (Fs(b)) {
      const L = b.createAnimation(k, t !== "opacity", S, y, E);
      b = L.easing, k = L.keyframes || k, c = L.duration || c;
    }
    if (hl(y) && (tr.cssRegisterProperty() ? aE(y) : x = !1), w && !tr.linearEasing() && (mr(b) || ur(b) && b.some(mr)) && (x = !1), x) {
      C && (k = k.map((T) => fa(T) ? C.toDefaultUnit(T) : T)), k.length === 1 && (!tr.partialKeyframes() || o) && k.unshift(S());
      const L = {
        delay: Qr.ms(u),
        duration: Qr.ms(c),
        endDelay: Qr.ms(f),
        easing: ur(b) ? void 0 : rd(b, c),
        direction: j,
        iterations: m + 1,
        fill: "both"
      };
      i = e.animate({
        [y]: k,
        offset: p,
        easing: ur(b) ? b.map((T) => rd(T, c)) : void 0
      }, L), i.finished || (i.finished = new Promise((T, R) => {
        i.onfinish = T, i.oncancel = R;
      }));
      const H = k[k.length - 1];
      i.finished.then(() => {
        _ || (ts.set(e, y, H), i.cancel());
      }).catch(C3), v || (i.playbackRate = 1.000001);
    } else if (a && w)
      k = k.map((L) => typeof L == "string" ? parseFloat(L) : L), k.length === 1 && k.unshift(parseFloat(S())), i = new a((L) => {
        ts.set(e, y, O ? O(L) : L);
      }, k, Object.assign(Object.assign({}, r), {
        duration: c,
        easing: b
      }));
    else {
      const L = k[k.length - 1];
      ts.set(e, y, C && fa(L) ? C.toDefaultUnit(L) : L);
    }
    return o && s(e, t, k, {
      duration: c,
      delay: u,
      easing: b,
      repeat: m,
      offset: p
    }, "motion-one"), E.setAnimation(i), i && !h && i.pause(), i;
  };
}
const P3 = (e, t) => (
  /**
   * TODO: Make test for this
   * Always return a new object otherwise delay is overwritten by results of stagger
   * and this results in no stagger
   */
  e[t] ? Object.assign(Object.assign({}, e), e[t]) : Object.assign({}, e)
);
function N3(e, t) {
  var n;
  return typeof e == "string" ? t ? ((n = t[e]) !== null && n !== void 0 || (t[e] = document.querySelectorAll(e)), e = t[e]) : e = document.querySelectorAll(e) : e instanceof Element && (e = [e]), Array.from(e || []);
}
const dE = (e) => e(), lu = (e, t, n = tt.duration) => new Proxy({
  animations: e.map(dE).filter(Boolean),
  duration: n,
  options: t
}, bE), fE = (e) => e.animations[0], bE = {
  get: (e, t) => {
    const n = fE(e);
    switch (t) {
      case "duration":
        return e.duration;
      case "currentTime":
        return Qr.s((n == null ? void 0 : n[t]) || 0);
      case "playbackRate":
      case "playState":
        return n == null ? void 0 : n[t];
      case "finished":
        return e.finished || (e.finished = Promise.all(e.animations.map(mE)).catch(C3)), e.finished;
      case "stop":
        return () => {
          e.animations.forEach((r) => M3(r));
        };
      case "forEachNative":
        return (r) => {
          e.animations.forEach((a) => r(a, e));
        };
      default:
        return typeof (n == null ? void 0 : n[t]) > "u" ? void 0 : () => e.animations.forEach((r) => r[t]());
    }
  },
  set: (e, t, n) => {
    switch (t) {
      case "currentTime":
        n = Qr.ms(n);
      case "playbackRate":
        for (let r = 0; r < e.animations.length; r++)
          e.animations[r][t] = n;
        return !0;
    }
    return !1;
  }
}, mE = (e) => e.finished;
function D3(e, t, n) {
  return mr(e) ? e(t, n) : e;
}
function _E(e) {
  return function(n, r, a = {}) {
    n = N3(n);
    const s = n.length;
    Hs(!!s, "No valid element provided."), Hs(!!r, "No keyframes defined.");
    const o = [];
    for (let i = 0; i < s; i++) {
      const c = n[i];
      for (const u in r) {
        const f = P3(a, u);
        f.delay = D3(f.delay, i, s);
        const m = A3(c, u, r[u], f, e);
        o.push(m);
      }
    }
    return lu(
      o,
      a,
      /**
       * TODO:
       * If easing is set to spring or glide, duration will be dynamically
       * generated. Ideally we would dynamically generate this from
       * animation.effect.getComputedTiming().duration but this isn't
       * supported in iOS13 or our number polyfill. Perhaps it's possible
       * to Proxy animations returned from animateStyle that has duration
       * as a getter.
       */
      a.duration
    );
  };
}
const pE = _E(ou);
function ad(e, t, n, r) {
  var a;
  return fa(t) ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? n : (a = r.get(t)) !== null && a !== void 0 ? a : e;
}
function jE(e, t, n) {
  for (let r = 0; r < e.length; r++) {
    const a = e[r];
    a.at > t && a.at < n && (zC(e, a), r--);
  }
}
function vE(e, t, n, r, a, s) {
  jE(e, a, s);
  for (let o = 0; o < t.length; o++)
    e.push({
      value: t[o],
      at: au(a, s, r[o]),
      easing: w3(n, o)
    });
}
function hE(e, t) {
  return e.at === t.at ? e.value === null ? 1 : -1 : e.at - t.at;
}
function Us(e, t = {}) {
  var n;
  const r = gE(e, t), a = r.map((s) => A3(...s, ou)).filter(Boolean);
  return lu(
    a,
    t,
    // Get the duration from the first animation definition
    (n = r[0]) === null || n === void 0 ? void 0 : n[3].duration
  );
}
function gE(e, t = {}) {
  var { defaultOptions: n = {} } = t, r = Sa(t, ["defaultOptions"]);
  const a = [], s = /* @__PURE__ */ new Map(), o = {}, i = /* @__PURE__ */ new Map();
  let c = 0, u = 0, f = 0;
  for (let m = 0; m < e.length; m++) {
    const b = e[m];
    if (S3(b)) {
      i.set(b, u);
      continue;
    } else if (!Array.isArray(b)) {
      i.set(b.name, ad(u, b.at, c, i));
      continue;
    }
    const [_, j, p = {}] = b;
    p.at !== void 0 && (u = ad(u, p.at, c, i));
    let v = 0;
    const h = N3(_, o), g = h.length;
    for (let w = 0; w < g; w++) {
      const x = h[w], y = yE(x, s);
      for (const E in j) {
        const C = wE(E, y);
        let S = O3(j[E]);
        const k = P3(p, E);
        let { duration: O = n.duration || tt.duration, easing: L = n.easing || tt.easing } = k;
        if (Fs(L)) {
          Hs(E === "opacity" || S.length > 1, "spring must be provided 2 keyframes within timeline()");
          const I = L.createAnimation(S, E !== "opacity", () => 0, E);
          L = I.easing, S = I.keyframes || S, O = I.duration || O;
        }
        const H = D3(p.delay, w, g) || 0, T = u + H, R = T + O;
        let { offset: M = E3(S.length) } = k;
        M.length === 1 && M[0] === 0 && (M[1] = 1);
        const D = M.length - S.length;
        D > 0 && su(M, D), S.length === 1 && S.unshift(null), vE(C, S, L, M, T, R), v = Math.max(H + O, v), f = Math.max(R, f);
      }
    }
    c = u, u += v;
  }
  return s.forEach((m, b) => {
    for (const _ in m) {
      const j = m[_];
      j.sort(hE);
      const p = [], v = [], h = [];
      for (let g = 0; g < j.length; g++) {
        const { at: w, value: x, easing: y } = j[g];
        p.push(x), v.push(go(0, f, w)), h.push(y || tt.easing);
      }
      v[0] !== 0 && (v.unshift(0), p.unshift(p[0]), h.unshift("linear")), v[v.length - 1] !== 1 && (v.push(1), p.push(null)), a.push([
        b,
        _,
        p,
        Object.assign(Object.assign(Object.assign({}, n), { duration: f, easing: h, offset: v }), r)
      ]);
    }
  }), a;
}
function yE(e, t) {
  return !t.has(e) && t.set(e, {}), t.get(e);
}
function wE(e, t) {
  return t[e] || (t[e] = []), t[e];
}
function CE(e, t = {}) {
  return lu([
    () => {
      const n = new ou(e, [0, 1], t);
      return n.finished.catch(() => {
      }), n;
    }
  ], t, t.duration);
}
function sd(e, t, n) {
  return (mr(e) ? CE : pE)(e, t, n);
}
var I3 = "_1lj8iuo3 _1lj8iuo1 _1q6d0sx4 _1lj8iuo0 _1lj8iuo2 _1s8b37jc _1s8b37jl9 _1s8b37jlc", $3 = "_1lj8iuo7 _1lj8iuo5 _1q6d0sx4 _1lj8iuo4 _1lj8iuo6 _1s8b37jc _1s8b37jl9 _1s8b37jlc", L3 = "_1lj8iuob _1lj8iuo9 _1q6d0sx4 _1lj8iuo8 _1lj8iuoa _1s8b37jc _1s8b37jl9 _1s8b37jlc", z3 = "_1lj8iuof _1lj8iuod _1q6d0sx4 _1lj8iuoc _1lj8iuoe _1s8b37jc _1s8b37jl9 _1s8b37jlc", F3 = "_1lj8iuoj _1lj8iuoh _1q6d0sx4 _1lj8iuog _1lj8iuoi _1s8b37jc _1s8b37jl9 _1s8b37jlc", H3 = "_1lj8iuon _1lj8iuol _1q6d0sx4 _1lj8iuok _1lj8iuom _1s8b37jc _1s8b37jl9 _1s8b37jlc";
const Un = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  heading1: I3,
  heading2: $3,
  heading3: L3,
  heading4: z3,
  heading5: F3,
  heading6: H3
}, Symbol.toStringTag, { value: "Module" })), kr = l.forwardRef(
  ({ className: e, children: t, level: n = "1", styledAs: r, truncate: a = !1, ...s }, o) => {
    const i = l.useMemo(() => {
      switch (n) {
        case "1":
          return {
            Component: U.h1,
            className: r ? Un[r] : I3
          };
        case "2":
          return {
            Component: U.h2,
            className: r ? Un[r] : $3
          };
        case "3":
          return {
            Component: U.h3,
            className: r ? Un[r] : L3
          };
        case "4":
          return {
            Component: U.h4,
            className: r ? Un[r] : z3
          };
        case "5":
          return {
            Component: U.h5,
            className: r ? Un[r] : F3
          };
        case "6":
          return {
            Component: U.h6,
            className: r ? Un[r] : H3
          };
      }
    }, [n, r]);
    return /* @__PURE__ */ l.createElement(
      i.Component,
      {
        ref: o,
        className: q(e, i.className),
        reset: "all",
        ...s
      },
      a ? /* @__PURE__ */ l.createElement(Zf, null, t) : t
    );
  }
);
var EE = "_1hnwxa15 _1hnwxa14 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37j80 _1s8b37jjz _1s8b37jl3 _1s8b37jcs", xE = "_1hnwxa16", SE = "_1hnwxa17", kE = "_1hnwxa18", TE = "_1hnwxa19", RE = "_1hnwxa1b _1hnwxa1a _1s8b37j27z _1s8b37j23t _1s8b37j257 _1s8b37j26l", OE = "_1hnwxa1e _1hnwxa1d _1s8b37j28e _1s8b37j248 _1s8b37j25m _1s8b37j270 _1s8b37j5g _1s8b37jka _1s8b37jk6", ME = "_1hnwxa1g _1hnwxa1f _1s8b37j2s", AE = "_1hnwxa1i _1hnwxa1h _1s8b37j2s", PE = "_1hnwxa1k _1hnwxa1j _1s8b37j28e _1s8b37j248 _1s8b37j25m _1s8b37j270 _1s8b37jlr", B3 = "_1hnwxa1m _1hnwxa1l _1s8b37j25h _1s8b37j26v _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37j2vq _1s8b37jl5 _1s8b37j135 _1s8b37jl7 _1s8b37jlo _1s8b37j80 _1s8b37j8i", NE = "_1hnwxa1o _1hnwxa1n _1s8b37j293 _1s8b37jf0 _1s8b37j12b _1s8b37j2p7 _1s8b37js", DE = "_1hnwxa1q _1hnwxa1p _1s8b37j80 _1s8b37j8h", q3 = "_1hnwxa1u _1hnwxa1t _1s8b37jll", U3 = "_1hnwxa1y _1hnwxa1x _1s8b37jo", IE = "_1hnwxa110 _1hnwxa1z _1s8b37j2vq";
const W3 = l.createContext({
  isOpen: !1
}), $E = () => l.useContext(W3), LE = ({
  children: e,
  defaultOpen: t,
  isOpen: n,
  onIsOpenChange: r,
  ...a
}) => {
  const [s = !1, o] = nt({
    prop: n,
    defaultProp: t,
    onChange: r
  });
  return /* @__PURE__ */ l.createElement(W3.Provider, { value: { isOpen: s } }, /* @__PURE__ */ l.createElement(
    AC,
    {
      ...a,
      defaultOpen: t,
      open: s,
      onOpenChange: o
    },
    e
  ));
}, zE = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(PC, { asChild: !0 }, /* @__PURE__ */ l.createElement(U.button, { ...t, ref: n }, e))), FE = l.forwardRef(
  ({
    children: e,
    className: t,
    onCloseAutoFocus: n,
    onEscapeKeyDown: r,
    onPointerDownOutside: a,
    onFocusOutside: s,
    onInteractOutside: o,
    portalled: i = !0,
    forceMount: c,
    side: u = "bottom",
    sideOffset: f = 8,
    align: m,
    alignOffset: b,
    avoidCollisions: _,
    collisionPadding: j = 20,
    ...p
  }, v) => {
    const h = $E(), g = i ? NC : va;
    return /* @__PURE__ */ l.createElement(g, null, /* @__PURE__ */ l.createElement(
      DC,
      {
        ref: v,
        onCloseAutoFocus: n,
        onEscapeKeyDown: r,
        onPointerDownOutside: a,
        onFocusOutside: s,
        onInteractOutside: o,
        forceMount: c,
        side: u,
        sideOffset: f,
        align: m,
        alignOffset: b,
        avoidCollisions: _,
        collisionPadding: j
      },
      /* @__PURE__ */ l.createElement(
        U.div,
        {
          ...p,
          className: q(t, EE, {
            [xE]: h.isOpen && u === "top",
            [SE]: h.isOpen && u === "bottom",
            [kE]: h.isOpen && u === "left",
            [TE]: h.isOpen && u === "right"
          })
        },
        e
      )
    ));
  }
), HE = l.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(
  ye,
  {
    ...n,
    ref: r,
    gap: "xsmall",
    className: q(t, RE)
  },
  e
)), V3 = l.createContext({
  isDisabled: !1
}), BE = () => l.useContext(V3), qE = l.forwardRef(
  ({ children: e, className: t, onSelect: n, isDisabled: r, textValue: a, ...s }, o) => /* @__PURE__ */ l.createElement(V3.Provider, { value: { isDisabled: r } }, /* @__PURE__ */ l.createElement(
    g3,
    {
      asChild: !0,
      onSelect: n,
      disabled: r,
      textValue: a
    },
    /* @__PURE__ */ l.createElement(
      re,
      {
        ...s,
        ref: o,
        xAlign: "between",
        className: q(t, B3, {
          [q3]: r
        })
      },
      e
    )
  ))
), UE = l.forwardRef(({ children: e, className: t, ...n }, r) => {
  const a = BE();
  return /* @__PURE__ */ l.createElement(
    ne,
    {
      ...n,
      className: q(t, {
        [U3]: a.isDisabled
      }),
      ref: r
    },
    e
  );
}), Y3 = l.createContext({
  contentRef: null,
  isDisabled: !1
}), G3 = () => l.useContext(Y3), WE = l.forwardRef(({ children: e, className: t, isDisabled: n = !1, ...r }, a) => {
  const s = l.useRef(null), o = l.useRef(null), i = l.useRef(), c = l.useRef(!1), u = l.useRef(!1), f = l.useCallback(async () => {
    const b = [];
    let _ = 0;
    o.current && (b.push([
      o.current,
      { x: [0, -32] },
      { duration: 0.2 }
    ]), _ = _ + 0.2), s.current && (b.push([
      s.current,
      { opacity: [0, 1], scale: [0.75, 1] },
      { duration: 0.1 }
    ]), _ = _ + 0.2), u.current = !0, i.current = Us(b, {
      duration: _,
      delay: 0.2
    }), await i.current.finished, c.current = !0, u.current = !1;
  }, [i, c, u, o, s]), m = l.useCallback(() => {
    const b = [];
    let _ = 0;
    s.current && (b.push([
      s.current,
      { opacity: [1, 0], scale: [1, 0.75] },
      { duration: 0.1 }
    ]), _ = _ + 0.2), o.current && (b.push([
      o.current,
      { x: [-32, 0] },
      { duration: 0.2 }
    ]), _ = _ + 0.2), !u.current && c.current ? Us(b, { duration: _ }).finished : u.current && (i.current.cancel(), u.current = !1);
  }, [i, c, u, o, s]);
  return /* @__PURE__ */ l.createElement(
    Y3.Provider,
    {
      value: { contentRef: o, isDisabled: n }
    },
    /* @__PURE__ */ l.createElement(g3, { asChild: !0 }, /* @__PURE__ */ l.createElement(re, { asChild: !0, xAlign: "between" }, /* @__PURE__ */ l.createElement(
      U.a,
      {
        ...r,
        ref: a,
        className: q(
          t,
          B3,
          DE,
          {
            [q3]: n
          }
        ),
        position: "relative",
        role: "menuitem",
        "aria-disabled": n,
        onFocus: f,
        onBlur: m
      },
      e,
      /* @__PURE__ */ l.createElement(
        re,
        {
          ref: s,
          className: NE,
          "data-testid": "external-link-item-icon"
        },
        /* @__PURE__ */ l.createElement(nb, null)
      )
    )))
  );
}), VE = l.forwardRef(({ children: e, ...t }, n) => {
  const r = G3();
  return /* @__PURE__ */ l.createElement(
    ne,
    {
      ...t,
      ref: n,
      className: q({
        [U3]: r.isDisabled
      })
    },
    e
  );
}), YE = l.forwardRef(({ children: e, ...t }, n) => {
  const r = G3(), a = We([n, r.contentRef]);
  return /* @__PURE__ */ l.createElement(re, { ...t, ref: a }, e);
}), GE = l.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(IC, { asChild: !0 }, /* @__PURE__ */ l.createElement(
  kr,
  {
    ...n,
    ref: r,
    className: q(t, PE),
    level: "6"
  },
  e
))), KE = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.createElement(
  ye,
  {
    ...t,
    ref: n,
    gap: "small",
    className: q(e, OE)
  }
)), XE = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.createElement(
  ne,
  {
    ...t,
    ref: n,
    styledAs: "body2",
    className: q(e, ME)
  }
)), ZE = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.createElement(
  ne,
  {
    ...t,
    ref: n,
    styledAs: "body3",
    className: q(e, AE)
  }
)), JE = l.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.createElement(
  $C,
  {
    ...t,
    className: q(e, IE),
    "data-testid": "dropdown-menu-separator",
    ref: n
  }
)), qr = {
  Root: LE,
  Trigger: zE,
  Content: FE,
  Group: HE,
  Item: qE,
  ItemText: UE,
  Label: GE,
  Header: KE,
  HeaderTitle: XE,
  HeaderDescription: ZE,
  ExternalLinkItem: WE,
  ExternalLinkItemText: VE,
  ExternalLinkItemContent: YE,
  Separator: JE
};
function It(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function QE(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function K3(...e) {
  return (t) => e.forEach((n) => QE(n, t));
}
function Ra(...e) {
  return d.useCallback(K3(...e), e);
}
function e4(e, t = []) {
  let n = [];
  function r(s, o) {
    const i = d.createContext(o), c = n.length;
    n = [...n, o];
    const u = (m) => {
      var h;
      const { scope: b, children: _, ...j } = m, p = ((h = b == null ? void 0 : b[e]) == null ? void 0 : h[c]) || i, v = d.useMemo(() => j, Object.values(j));
      return /* @__PURE__ */ z.jsx(p.Provider, { value: v, children: _ });
    };
    u.displayName = s + "Provider";
    function f(m, b) {
      var p;
      const _ = ((p = b == null ? void 0 : b[e]) == null ? void 0 : p[c]) || i, j = d.useContext(_);
      if (j) return j;
      if (o !== void 0) return o;
      throw new Error(`\`${m}\` must be used within \`${s}\``);
    }
    return [u, f];
  }
  const a = () => {
    const s = n.map((o) => d.createContext(o));
    return function(i) {
      const c = (i == null ? void 0 : i[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: c } }),
        [i, c]
      );
    };
  };
  return a.scopeName = e, [r, t4(a, ...t)];
}
function t4(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(s) {
      const o = r.reduce((i, { useScope: c, scopeName: u }) => {
        const m = c(s)[`__scope${u}`];
        return { ...i, ...m };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var X3 = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = d.Children.toArray(n), s = a.find(n4);
  if (s) {
    const o = s.props.children, i = a.map((c) => c === s ? d.Children.count(o) > 1 ? d.Children.only(null) : d.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z.jsx(yl, { ...r, ref: t, children: d.isValidElement(o) ? d.cloneElement(o, void 0, i) : null });
  }
  return /* @__PURE__ */ z.jsx(yl, { ...r, ref: t, children: n });
});
X3.displayName = "Slot";
var yl = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const a = a4(n);
    return d.cloneElement(n, {
      ...r4(r, n.props),
      // @ts-ignore
      ref: t ? K3(t, a) : a
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
yl.displayName = "SlotClone";
var Z3 = ({ children: e }) => /* @__PURE__ */ z.jsx(z.Fragment, { children: e });
function n4(e) {
  return d.isValidElement(e) && e.type === Z3;
}
function r4(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? a && s ? n[r] = (...i) => {
      s(...i), a(...i);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function a4(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var s4 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], yo = s4.reduce((e, t) => {
  const n = d.forwardRef((r, a) => {
    const { asChild: s, ...o } = r, i = s ? X3 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ z.jsx(i, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function o4(e, t) {
  e && yr.flushSync(() => e.dispatchEvent(t));
}
function cu(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function i4(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = cu(e);
  d.useEffect(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var l4 = "DismissableLayer", wl = "dismissableLayer.update", c4 = "dismissableLayer.pointerDownOutside", u4 = "dismissableLayer.focusOutside", od, J3 = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Q3 = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: a,
      onFocusOutside: s,
      onInteractOutside: o,
      onDismiss: i,
      ...c
    } = e, u = d.useContext(J3), [f, m] = d.useState(null), b = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, _] = d.useState({}), j = Ra(t, (C) => m(C)), p = Array.from(u.layers), [v] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), h = p.indexOf(v), g = f ? p.indexOf(f) : -1, w = u.layersWithOutsidePointerEventsDisabled.size > 0, x = g >= h, y = b4((C) => {
      const S = C.target, k = [...u.branches].some((O) => O.contains(S));
      !x || k || (a == null || a(C), o == null || o(C), C.defaultPrevented || i == null || i());
    }, b), E = m4((C) => {
      const S = C.target;
      [...u.branches].some((O) => O.contains(S)) || (s == null || s(C), o == null || o(C), C.defaultPrevented || i == null || i());
    }, b);
    return i4((C) => {
      g === u.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && i && (C.preventDefault(), i()));
    }, b), d.useEffect(() => {
      if (f)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (od = b.body.style.pointerEvents, b.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(f)), u.layers.add(f), id(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (b.body.style.pointerEvents = od);
        };
    }, [f, b, n, u]), d.useEffect(() => () => {
      f && (u.layers.delete(f), u.layersWithOutsidePointerEventsDisabled.delete(f), id());
    }, [f, u]), d.useEffect(() => {
      const C = () => _({});
      return document.addEventListener(wl, C), () => document.removeEventListener(wl, C);
    }, []), /* @__PURE__ */ z.jsx(
      yo.div,
      {
        ...c,
        ref: j,
        style: {
          pointerEvents: w ? x ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: It(e.onFocusCapture, E.onFocusCapture),
        onBlurCapture: It(e.onBlurCapture, E.onBlurCapture),
        onPointerDownCapture: It(
          e.onPointerDownCapture,
          y.onPointerDownCapture
        )
      }
    );
  }
);
Q3.displayName = l4;
var d4 = "DismissableLayerBranch", f4 = d.forwardRef((e, t) => {
  const n = d.useContext(J3), r = d.useRef(null), a = Ra(t, r);
  return d.useEffect(() => {
    const s = r.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ z.jsx(yo.div, { ...e, ref: a });
});
f4.displayName = d4;
function b4(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = cu(e), r = d.useRef(!1), a = d.useRef(() => {
  });
  return d.useEffect(() => {
    const s = (i) => {
      if (i.target && !r.current) {
        let c = function() {
          e8(
            c4,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = c, t.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", s), t.removeEventListener("click", a.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function m4(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = cu(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const a = (s) => {
      s.target && !r.current && e8(u4, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function id() {
  const e = new CustomEvent(wl);
  document.dispatchEvent(e);
}
function e8(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), r ? o4(a, s) : a.dispatchEvent(s);
}
var _4 = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, p4 = d.useId || (() => {
}), j4 = 0;
function v4(e) {
  const [t, n] = d.useState(p4());
  return _4(() => {
    n((r) => r ?? String(j4++));
  }, [e]), t ? `radix-${t}` : "";
}
var h4 = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, g4 = "Portal", t8 = d.forwardRef((e, t) => {
  var i;
  const { container: n, ...r } = e, [a, s] = d.useState(!1);
  h4(() => s(!0), []);
  const o = n || a && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return o ? ja.createPortal(/* @__PURE__ */ z.jsx(yo.div, { ...r, ref: t }), o) : null;
});
t8.displayName = g4;
var ld = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
};
function y4(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var uu = (e) => {
  const { present: t, children: n } = e, r = w4(t), a = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), s = Ra(r.ref, C4(a));
  return typeof n == "function" || r.isPresent ? d.cloneElement(a, { ref: s }) : null;
};
uu.displayName = "Presence";
function w4(e) {
  const [t, n] = d.useState(), r = d.useRef({}), a = d.useRef(e), s = d.useRef("none"), o = e ? "mounted" : "unmounted", [i, c] = y4(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const u = ns(r.current);
    s.current = i === "mounted" ? u : "none";
  }, [i]), ld(() => {
    const u = r.current, f = a.current;
    if (f !== e) {
      const b = s.current, _ = ns(u);
      e ? c("MOUNT") : _ === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(f && b !== _ ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, c]), ld(() => {
    if (t) {
      let u;
      const f = t.ownerDocument.defaultView ?? window, m = (_) => {
        const p = ns(r.current).includes(_.animationName);
        if (_.target === t && p && (c("ANIMATION_END"), !a.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, b = (_) => {
        _.target === t && (s.current = ns(r.current));
      };
      return t.addEventListener("animationstart", b), t.addEventListener("animationcancel", m), t.addEventListener("animationend", m), () => {
        f.clearTimeout(u), t.removeEventListener("animationstart", b), t.removeEventListener("animationcancel", m), t.removeEventListener("animationend", m);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: d.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function ns(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function C4(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function n8(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function E4({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = x4({ defaultProp: t, onChange: n }), s = e !== void 0, o = s ? e : r, i = n8(n), c = d.useCallback(
    (u) => {
      if (s) {
        const m = typeof u == "function" ? u(e) : u;
        m !== e && i(m);
      } else
        a(u);
    },
    [s, e, a, i]
  );
  return [o, c];
}
function x4({
  defaultProp: e,
  onChange: t
}) {
  const n = d.useState(e), [r] = n, a = d.useRef(r), s = n8(t);
  return d.useEffect(() => {
    a.current !== r && (s(r), a.current = r);
  }, [r, a, s]), n;
}
function S4(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function k4(...e) {
  return (t) => e.forEach((n) => S4(n, t));
}
var r8 = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = d.Children.toArray(n), s = a.find(R4);
  if (s) {
    const o = s.props.children, i = a.map((c) => c === s ? d.Children.count(o) > 1 ? d.Children.only(null) : d.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z.jsx(Cl, { ...r, ref: t, children: d.isValidElement(o) ? d.cloneElement(o, void 0, i) : null });
  }
  return /* @__PURE__ */ z.jsx(Cl, { ...r, ref: t, children: n });
});
r8.displayName = "Slot";
var Cl = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const a = M4(n);
    return d.cloneElement(n, {
      ...O4(r, n.props),
      // @ts-ignore
      ref: t ? k4(t, a) : a
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
Cl.displayName = "SlotClone";
var T4 = ({ children: e }) => /* @__PURE__ */ z.jsx(z.Fragment, { children: e });
function R4(e) {
  return d.isValidElement(e) && e.type === T4;
}
function O4(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? a && s ? n[r] = (...i) => {
      s(...i), a(...i);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function M4(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var A4 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], P4 = A4.reduce((e, t) => {
  const n = d.forwardRef((r, a) => {
    const { asChild: s, ...o } = r, i = s ? r8 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ z.jsx(i, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), N4 = "VisuallyHidden", a8 = d.forwardRef(
  (e, t) => /* @__PURE__ */ z.jsx(
    P4.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
a8.displayName = N4;
var D4 = a8, [wo, KN] = e4("Tooltip", [
  Sr
]), Co = Sr(), s8 = "TooltipProvider", I4 = 700, El = "tooltip.open", [$4, du] = wo(s8), o8 = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = I4,
    skipDelayDuration: r = 300,
    disableHoverableContent: a = !1,
    children: s
  } = e, [o, i] = d.useState(!0), c = d.useRef(!1), u = d.useRef(0);
  return d.useEffect(() => {
    const f = u.current;
    return () => window.clearTimeout(f);
  }, []), /* @__PURE__ */ z.jsx(
    $4,
    {
      scope: t,
      isOpenDelayed: o,
      delayDuration: n,
      onOpen: d.useCallback(() => {
        window.clearTimeout(u.current), i(!1);
      }, []),
      onClose: d.useCallback(() => {
        window.clearTimeout(u.current), u.current = window.setTimeout(
          () => i(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: d.useCallback((f) => {
        c.current = f;
      }, []),
      disableHoverableContent: a,
      children: s
    }
  );
};
o8.displayName = s8;
var Eo = "Tooltip", [L4, Oa] = wo(Eo), i8 = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: a = !1,
    onOpenChange: s,
    disableHoverableContent: o,
    delayDuration: i
  } = e, c = du(Eo, e.__scopeTooltip), u = Co(t), [f, m] = d.useState(null), b = v4(), _ = d.useRef(0), j = o ?? c.disableHoverableContent, p = i ?? c.delayDuration, v = d.useRef(!1), [h = !1, g] = E4({
    prop: r,
    defaultProp: a,
    onChange: (C) => {
      C ? (c.onOpen(), document.dispatchEvent(new CustomEvent(El))) : c.onClose(), s == null || s(C);
    }
  }), w = d.useMemo(() => h ? v.current ? "delayed-open" : "instant-open" : "closed", [h]), x = d.useCallback(() => {
    window.clearTimeout(_.current), _.current = 0, v.current = !1, g(!0);
  }, [g]), y = d.useCallback(() => {
    window.clearTimeout(_.current), _.current = 0, g(!1);
  }, [g]), E = d.useCallback(() => {
    window.clearTimeout(_.current), _.current = window.setTimeout(() => {
      v.current = !0, g(!0), _.current = 0;
    }, p);
  }, [p, g]);
  return d.useEffect(() => () => {
    _.current && (window.clearTimeout(_.current), _.current = 0);
  }, []), /* @__PURE__ */ z.jsx(Fc, { ...u, children: /* @__PURE__ */ z.jsx(
    L4,
    {
      scope: t,
      contentId: b,
      open: h,
      stateAttribute: w,
      trigger: f,
      onTriggerChange: m,
      onTriggerEnter: d.useCallback(() => {
        c.isOpenDelayed ? E() : x();
      }, [c.isOpenDelayed, E, x]),
      onTriggerLeave: d.useCallback(() => {
        j ? y() : (window.clearTimeout(_.current), _.current = 0);
      }, [y, j]),
      onOpen: x,
      onClose: y,
      disableHoverableContent: j,
      children: n
    }
  ) });
};
i8.displayName = Eo;
var xl = "TooltipTrigger", l8 = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, a = Oa(xl, n), s = du(xl, n), o = Co(n), i = d.useRef(null), c = Ra(t, i, a.onTriggerChange), u = d.useRef(!1), f = d.useRef(!1), m = d.useCallback(() => u.current = !1, []);
    return d.useEffect(() => () => document.removeEventListener("pointerup", m), [m]), /* @__PURE__ */ z.jsx(mo, { asChild: !0, ...o, children: /* @__PURE__ */ z.jsx(
      yo.button,
      {
        "aria-describedby": a.open ? a.contentId : void 0,
        "data-state": a.stateAttribute,
        ...r,
        ref: c,
        onPointerMove: It(e.onPointerMove, (b) => {
          b.pointerType !== "touch" && !f.current && !s.isPointerInTransitRef.current && (a.onTriggerEnter(), f.current = !0);
        }),
        onPointerLeave: It(e.onPointerLeave, () => {
          a.onTriggerLeave(), f.current = !1;
        }),
        onPointerDown: It(e.onPointerDown, () => {
          u.current = !0, document.addEventListener("pointerup", m, { once: !0 });
        }),
        onFocus: It(e.onFocus, () => {
          u.current || a.onOpen();
        }),
        onBlur: It(e.onBlur, a.onClose),
        onClick: It(e.onClick, a.onClose)
      }
    ) });
  }
);
l8.displayName = xl;
var fu = "TooltipPortal", [z4, F4] = wo(fu, {
  forceMount: void 0
}), c8 = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: a } = e, s = Oa(fu, t);
  return /* @__PURE__ */ z.jsx(z4, { scope: t, forceMount: n, children: /* @__PURE__ */ z.jsx(uu, { present: n || s.open, children: /* @__PURE__ */ z.jsx(t8, { asChild: !0, container: a, children: r }) }) });
};
c8.displayName = fu;
var _r = "TooltipContent", u8 = d.forwardRef(
  (e, t) => {
    const n = F4(_r, e.__scopeTooltip), { forceMount: r = n.forceMount, side: a = "top", ...s } = e, o = Oa(_r, e.__scopeTooltip);
    return /* @__PURE__ */ z.jsx(uu, { present: r || o.open, children: o.disableHoverableContent ? /* @__PURE__ */ z.jsx(d8, { side: a, ...s, ref: t }) : /* @__PURE__ */ z.jsx(H4, { side: a, ...s, ref: t }) });
  }
), H4 = d.forwardRef((e, t) => {
  const n = Oa(_r, e.__scopeTooltip), r = du(_r, e.__scopeTooltip), a = d.useRef(null), s = Ra(t, a), [o, i] = d.useState(null), { trigger: c, onClose: u } = n, f = a.current, { onPointerInTransitChange: m } = r, b = d.useCallback(() => {
    i(null), m(!1);
  }, [m]), _ = d.useCallback(
    (j, p) => {
      const v = j.currentTarget, h = { x: j.clientX, y: j.clientY }, g = U4(h, v.getBoundingClientRect()), w = W4(h, g), x = V4(p.getBoundingClientRect()), y = G4([...w, ...x]);
      i(y), m(!0);
    },
    [m]
  );
  return d.useEffect(() => () => b(), [b]), d.useEffect(() => {
    if (c && f) {
      const j = (v) => _(v, f), p = (v) => _(v, c);
      return c.addEventListener("pointerleave", j), f.addEventListener("pointerleave", p), () => {
        c.removeEventListener("pointerleave", j), f.removeEventListener("pointerleave", p);
      };
    }
  }, [c, f, _, b]), d.useEffect(() => {
    if (o) {
      const j = (p) => {
        const v = p.target, h = { x: p.clientX, y: p.clientY }, g = (c == null ? void 0 : c.contains(v)) || (f == null ? void 0 : f.contains(v)), w = !Y4(h, o);
        g ? b() : w && (b(), u());
      };
      return document.addEventListener("pointermove", j), () => document.removeEventListener("pointermove", j);
    }
  }, [c, f, o, u, b]), /* @__PURE__ */ z.jsx(d8, { ...e, ref: s });
}), [B4, q4] = wo(Eo, { isInside: !1 }), d8 = d.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": a,
      onEscapeKeyDown: s,
      onPointerDownOutside: o,
      ...i
    } = e, c = Oa(_r, n), u = Co(n), { onClose: f } = c;
    return d.useEffect(() => (document.addEventListener(El, f), () => document.removeEventListener(El, f)), [f]), d.useEffect(() => {
      if (c.trigger) {
        const m = (b) => {
          const _ = b.target;
          _ != null && _.contains(c.trigger) && f();
        };
        return window.addEventListener("scroll", m, { capture: !0 }), () => window.removeEventListener("scroll", m, { capture: !0 });
      }
    }, [c.trigger, f]), /* @__PURE__ */ z.jsx(
      Q3,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: s,
        onPointerDownOutside: o,
        onFocusOutside: (m) => m.preventDefault(),
        onDismiss: f,
        children: /* @__PURE__ */ z.jsxs(
          Hc,
          {
            "data-state": c.stateAttribute,
            ...u,
            ...i,
            ref: t,
            style: {
              ...i.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ z.jsx(Z3, { children: r }),
              /* @__PURE__ */ z.jsx(B4, { scope: n, isInside: !0, children: /* @__PURE__ */ z.jsx(D4, { id: c.contentId, role: "tooltip", children: a || r }) })
            ]
          }
        )
      }
    );
  }
);
u8.displayName = _r;
var f8 = "TooltipArrow", b8 = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, a = Co(n);
    return q4(
      f8,
      n
    ).isInside ? null : /* @__PURE__ */ z.jsx(Bc, { ...a, ...r, ref: t });
  }
);
b8.displayName = f8;
function U4(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), a = Math.abs(t.right - e.x), s = Math.abs(t.left - e.x);
  switch (Math.min(n, r, a, s)) {
    case s:
      return "left";
    case a:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function W4(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function V4(e) {
  const { top: t, right: n, bottom: r, left: a } = e;
  return [
    { x: a, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: a, y: r }
  ];
}
function Y4(e, t) {
  const { x: n, y: r } = e;
  let a = !1;
  for (let s = 0, o = t.length - 1; s < t.length; o = s++) {
    const i = t[s].x, c = t[s].y, u = t[o].x, f = t[o].y;
    c > r != f > r && n < (u - i) * (r - c) / (f - c) + i && (a = !a);
  }
  return a;
}
function G4(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), K4(t);
}
function K4(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const a = e[r];
    for (; t.length >= 2; ) {
      const s = t[t.length - 1], o = t[t.length - 2];
      if ((s.x - o.x) * (a.y - o.y) >= (s.y - o.y) * (a.x - o.x)) t.pop();
      else break;
    }
    t.push(a);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const a = e[r];
    for (; n.length >= 2; ) {
      const s = n[n.length - 1], o = n[n.length - 2];
      if ((s.x - o.x) * (a.y - o.y) >= (s.y - o.y) * (a.x - o.x)) n.pop();
      else break;
    }
    n.push(a);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var X4 = o8, Z4 = i8, J4 = l8, Q4 = c8, e6 = u8, t6 = b8, n6 = "_12q3afg2 _12q3afg1 _1s8b37j25m _1s8b37j270 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jl5", r6 = "_12q3afg3";
const a6 = ({
  children: e,
  isOpen: t,
  defaultOpen: n,
  onOpenChange: r,
  delayDuration: a = 500,
  ...s
}) => /* @__PURE__ */ l.createElement(X4, null, /* @__PURE__ */ l.createElement(
  Z4,
  {
    ...s,
    open: t,
    defaultOpen: n,
    onOpenChange: r,
    delayDuration: a
  },
  e
)), s6 = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(J4, { asChild: !0 }, /* @__PURE__ */ l.createElement(U.button, { ...t, ref: n }, e))), o6 = l.forwardRef(
  ({
    className: e,
    children: t,
    side: n,
    sideOffset: r = 8,
    align: a,
    alignOffset: s,
    avoidCollisions: o,
    collisionPadding: i = 20,
    portalled: c = !0,
    ...u
  }, f) => {
    const m = c ? Q4 : va;
    return /* @__PURE__ */ l.createElement(m, null, /* @__PURE__ */ l.createElement(
      U.div,
      {
        ...u,
        asChild: !0,
        className: q(e, n6)
      },
      /* @__PURE__ */ l.createElement(
        e6,
        {
          side: n,
          sideOffset: r,
          align: a,
          alignOffset: s,
          avoidCollisions: o,
          collisionPadding: i,
          "aria-label": u["aria-label"],
          ref: f
        },
        t,
        /* @__PURE__ */ l.createElement(
          t6,
          {
            className: r6,
            width: 15,
            height: 6
          }
        )
      )
    ));
  }
), i6 = l.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(
    ne,
    {
      ...t,
      textAlign: "center",
      styledAs: "body3",
      textColor: "onBrand",
      ref: n
    },
    e
  )
), _t = {
  Root: a6,
  Trigger: s6,
  Content: o6,
  Text: i6
};
var l6 = "_7ga2wm0", c6 = "_7ga2wm1", u6 = "_7ga2wm2", d6 = "_7ga2wm3", f6 = "_7ga2wm4";
const m8 = 3, b6 = 25, _8 = () => /* @__PURE__ */ l.createElement("li", { role: "separator" }, /* @__PURE__ */ l.createElement(Jf, { className: f6 })), m6 = ({
  children: e,
  menuLabel: t = "Open Collapsed Breadcrumbs"
}) => {
  const n = l.Children.toArray(e).map((r, a) => /* @__PURE__ */ l.createElement(qr.Item, { key: `dropdown-menu-item-${a}` }, r));
  return /* @__PURE__ */ l.createElement("li", null, /* @__PURE__ */ l.createElement(qr.Root, null, /* @__PURE__ */ l.createElement(qr.Trigger, { asChild: !0 }, /* @__PURE__ */ l.createElement(Me, { "aria-label": t }, /* @__PURE__ */ l.createElement(me, { icon: Nh }))), /* @__PURE__ */ l.createElement(qr.Content, { align: "end" }, /* @__PURE__ */ l.createElement(qr.Group, { className: c6 }, n))));
}, cd = ({ children: e, last: t, ...n }) => {
  const r = l.Children.toArray(e);
  if (r.length != 1)
    throw new Error("BreadcrumbListItem can only have one child");
  const [a] = r;
  if (!l.isValidElement(a))
    throw new Error("BreadcrumbListItem child must be a valid React element");
  const s = a.props.children;
  if (typeof s != "string")
    throw new Error("BreadcrumbListItem child must be a string");
  return /* @__PURE__ */ l.createElement(
    re,
    {
      gap: "zero",
      ...n,
      "data-testid": t ? "breadcrumb-list-current-item" : void 0,
      "aria-current": t ? "page" : void 0,
      className: q(
        t && d6,
        u6
      )
    },
    !t && s.length > b6 ? /* @__PURE__ */ l.createElement(_t.Root, null, /* @__PURE__ */ l.createElement(_t.Trigger, { asChild: !0 }, /* @__PURE__ */ l.createElement("li", null, a)), /* @__PURE__ */ l.createElement(_t.Content, { side: "top" }, /* @__PURE__ */ l.createElement(_t.Text, null, s))) : /* @__PURE__ */ l.createElement("li", null, a),
    !t && /* @__PURE__ */ l.createElement(_8, null)
  );
}, _6 = ({
  maxVisibleLinks: e = m8,
  children: t,
  label: n = "Breadcrumb",
  collapsedMenuLabel: r = "Open Collapsed Breadcrumbs",
  ...a
}) => {
  const s = l.Children.toArray(t).filter((u) => l.isValidElement(u)), o = s[s.length - 1], i = s.slice(
    0,
    e >= s.length ? s.length - 1 : e
  ), c = s.length - 1 <= e ? [] : s.slice(e, s.length - 1);
  return /* @__PURE__ */ l.createElement("nav", { "aria-label": n, ...a }, /* @__PURE__ */ l.createElement(re, { asChild: !0, gap: "zero" }, /* @__PURE__ */ l.createElement("ol", { className: l6 }, i.map((u, f) => /* @__PURE__ */ l.createElement(cd, { key: `breadcrumb-list-item-${f}` }, u)), c.length > 0 && /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(m6, { menuLabel: r }, c), /* @__PURE__ */ l.createElement(_8, null)), /* @__PURE__ */ l.createElement(cd, { last: !0 }, o))));
}, XN = ({
  links: e,
  maxVisibleLinks: t = m8,
  label: n = "Breadcrumb",
  collapsedMenuLabel: r = "Open Collapsed Breadcrumbs",
  children: a,
  ...s
}) => /* @__PURE__ */ l.createElement(
  _6,
  {
    label: n,
    collapsedMenuLabel: r,
    maxVisibleLinks: t,
    ...s
  },
  e == null ? void 0 : e.map((o, i) => /* @__PURE__ */ l.createElement("a", { key: `breadcrumb-${i}`, href: o.href }, o.text)),
  a
);
var p8 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(In, function() {
    var n = 1e3, r = 6e4, a = 36e5, s = "millisecond", o = "second", i = "minute", c = "hour", u = "day", f = "week", m = "month", b = "quarter", _ = "year", j = "date", p = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(T) {
      var R = ["th", "st", "nd", "rd"], M = T % 100;
      return "[" + T + (R[(M - 20) % 10] || R[M] || R[0]) + "]";
    } }, w = function(T, R, M) {
      var D = String(T);
      return !D || D.length >= R ? T : "" + Array(R + 1 - D.length).join(M) + T;
    }, x = { s: w, z: function(T) {
      var R = -T.utcOffset(), M = Math.abs(R), D = Math.floor(M / 60), I = M % 60;
      return (R <= 0 ? "+" : "-") + w(D, 2, "0") + ":" + w(I, 2, "0");
    }, m: function T(R, M) {
      if (R.date() < M.date()) return -T(M, R);
      var D = 12 * (M.year() - R.year()) + (M.month() - R.month()), I = R.clone().add(D, m), F = M - I < 0, P = R.clone().add(D + (F ? -1 : 1), m);
      return +(-(D + (M - I) / (F ? I - P : P - I)) || 0);
    }, a: function(T) {
      return T < 0 ? Math.ceil(T) || 0 : Math.floor(T);
    }, p: function(T) {
      return { M: m, y: _, w: f, d: u, D: j, h: c, m: i, s: o, ms: s, Q: b }[T] || String(T || "").toLowerCase().replace(/s$/, "");
    }, u: function(T) {
      return T === void 0;
    } }, y = "en", E = {};
    E[y] = g;
    var C = function(T) {
      return T instanceof L;
    }, S = function T(R, M, D) {
      var I;
      if (!R) return y;
      if (typeof R == "string") {
        var F = R.toLowerCase();
        E[F] && (I = F), M && (E[F] = M, I = F);
        var P = R.split("-");
        if (!I && P.length > 1) return T(P[0]);
      } else {
        var A = R.name;
        E[A] = R, I = A;
      }
      return !D && I && (y = I), I || !D && y;
    }, k = function(T, R) {
      if (C(T)) return T.clone();
      var M = typeof R == "object" ? R : {};
      return M.date = T, M.args = arguments, new L(M);
    }, O = x;
    O.l = S, O.i = C, O.w = function(T, R) {
      return k(T, { locale: R.$L, utc: R.$u, x: R.$x, $offset: R.$offset });
    };
    var L = function() {
      function T(M) {
        this.$L = S(M.locale, null, !0), this.parse(M);
      }
      var R = T.prototype;
      return R.parse = function(M) {
        this.$d = function(D) {
          var I = D.date, F = D.utc;
          if (I === null) return /* @__PURE__ */ new Date(NaN);
          if (O.u(I)) return /* @__PURE__ */ new Date();
          if (I instanceof Date) return new Date(I);
          if (typeof I == "string" && !/Z$/i.test(I)) {
            var P = I.match(v);
            if (P) {
              var A = P[2] - 1 || 0, $ = (P[7] || "0").substring(0, 3);
              return F ? new Date(Date.UTC(P[1], A, P[3] || 1, P[4] || 0, P[5] || 0, P[6] || 0, $)) : new Date(P[1], A, P[3] || 1, P[4] || 0, P[5] || 0, P[6] || 0, $);
            }
          }
          return new Date(I);
        }(M), this.$x = M.x || {}, this.init();
      }, R.init = function() {
        var M = this.$d;
        this.$y = M.getFullYear(), this.$M = M.getMonth(), this.$D = M.getDate(), this.$W = M.getDay(), this.$H = M.getHours(), this.$m = M.getMinutes(), this.$s = M.getSeconds(), this.$ms = M.getMilliseconds();
      }, R.$utils = function() {
        return O;
      }, R.isValid = function() {
        return this.$d.toString() !== p;
      }, R.isSame = function(M, D) {
        var I = k(M);
        return this.startOf(D) <= I && I <= this.endOf(D);
      }, R.isAfter = function(M, D) {
        return k(M) < this.startOf(D);
      }, R.isBefore = function(M, D) {
        return this.endOf(D) < k(M);
      }, R.$g = function(M, D, I) {
        return O.u(M) ? this[D] : this.set(I, M);
      }, R.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, R.valueOf = function() {
        return this.$d.getTime();
      }, R.startOf = function(M, D) {
        var I = this, F = !!O.u(D) || D, P = O.p(M), A = function(te, Z) {
          var se = O.w(I.$u ? Date.UTC(I.$y, Z, te) : new Date(I.$y, Z, te), I);
          return F ? se : se.endOf(u);
        }, $ = function(te, Z) {
          return O.w(I.toDate()[te].apply(I.toDate("s"), (F ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Z)), I);
        }, B = this.$W, Y = this.$M, J = this.$D, W = "set" + (this.$u ? "UTC" : "");
        switch (P) {
          case _:
            return F ? A(1, 0) : A(31, 11);
          case m:
            return F ? A(1, Y) : A(0, Y + 1);
          case f:
            var V = this.$locale().weekStart || 0, K = (B < V ? B + 7 : B) - V;
            return A(F ? J - K : J + (6 - K), Y);
          case u:
          case j:
            return $(W + "Hours", 0);
          case c:
            return $(W + "Minutes", 1);
          case i:
            return $(W + "Seconds", 2);
          case o:
            return $(W + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, R.endOf = function(M) {
        return this.startOf(M, !1);
      }, R.$set = function(M, D) {
        var I, F = O.p(M), P = "set" + (this.$u ? "UTC" : ""), A = (I = {}, I[u] = P + "Date", I[j] = P + "Date", I[m] = P + "Month", I[_] = P + "FullYear", I[c] = P + "Hours", I[i] = P + "Minutes", I[o] = P + "Seconds", I[s] = P + "Milliseconds", I)[F], $ = F === u ? this.$D + (D - this.$W) : D;
        if (F === m || F === _) {
          var B = this.clone().set(j, 1);
          B.$d[A]($), B.init(), this.$d = B.set(j, Math.min(this.$D, B.daysInMonth())).$d;
        } else A && this.$d[A]($);
        return this.init(), this;
      }, R.set = function(M, D) {
        return this.clone().$set(M, D);
      }, R.get = function(M) {
        return this[O.p(M)]();
      }, R.add = function(M, D) {
        var I, F = this;
        M = Number(M);
        var P = O.p(D), A = function(Y) {
          var J = k(F);
          return O.w(J.date(J.date() + Math.round(Y * M)), F);
        };
        if (P === m) return this.set(m, this.$M + M);
        if (P === _) return this.set(_, this.$y + M);
        if (P === u) return A(1);
        if (P === f) return A(7);
        var $ = (I = {}, I[i] = r, I[c] = a, I[o] = n, I)[P] || 1, B = this.$d.getTime() + M * $;
        return O.w(B, this);
      }, R.subtract = function(M, D) {
        return this.add(-1 * M, D);
      }, R.format = function(M) {
        var D = this, I = this.$locale();
        if (!this.isValid()) return I.invalidDate || p;
        var F = M || "YYYY-MM-DDTHH:mm:ssZ", P = O.z(this), A = this.$H, $ = this.$m, B = this.$M, Y = I.weekdays, J = I.months, W = function(Z, se, ue, X) {
          return Z && (Z[se] || Z(D, F)) || ue[se].slice(0, X);
        }, V = function(Z) {
          return O.s(A % 12 || 12, Z, "0");
        }, K = I.meridiem || function(Z, se, ue) {
          var X = Z < 12 ? "AM" : "PM";
          return ue ? X.toLowerCase() : X;
        }, te = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: B + 1, MM: O.s(B + 1, 2, "0"), MMM: W(I.monthsShort, B, J, 3), MMMM: W(J, B), D: this.$D, DD: O.s(this.$D, 2, "0"), d: String(this.$W), dd: W(I.weekdaysMin, this.$W, Y, 2), ddd: W(I.weekdaysShort, this.$W, Y, 3), dddd: Y[this.$W], H: String(A), HH: O.s(A, 2, "0"), h: V(1), hh: V(2), a: K(A, $, !0), A: K(A, $, !1), m: String($), mm: O.s($, 2, "0"), s: String(this.$s), ss: O.s(this.$s, 2, "0"), SSS: O.s(this.$ms, 3, "0"), Z: P };
        return F.replace(h, function(Z, se) {
          return se || te[Z] || P.replace(":", "");
        });
      }, R.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, R.diff = function(M, D, I) {
        var F, P = O.p(D), A = k(M), $ = (A.utcOffset() - this.utcOffset()) * r, B = this - A, Y = O.m(this, A);
        return Y = (F = {}, F[_] = Y / 12, F[m] = Y, F[b] = Y / 3, F[f] = (B - $) / 6048e5, F[u] = (B - $) / 864e5, F[c] = B / a, F[i] = B / r, F[o] = B / n, F)[P] || B, I ? Y : O.a(Y);
      }, R.daysInMonth = function() {
        return this.endOf(m).$D;
      }, R.$locale = function() {
        return E[this.$L];
      }, R.locale = function(M, D) {
        if (!M) return this.$L;
        var I = this.clone(), F = S(M, D, !0);
        return F && (I.$L = F), I;
      }, R.clone = function() {
        return O.w(this.$d, this);
      }, R.toDate = function() {
        return new Date(this.valueOf());
      }, R.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, R.toISOString = function() {
        return this.$d.toISOString();
      }, R.toString = function() {
        return this.$d.toUTCString();
      }, T;
    }(), H = L.prototype;
    return k.prototype = H, [["$ms", s], ["$s", o], ["$m", i], ["$H", c], ["$W", u], ["$M", m], ["$y", _], ["$D", j]].forEach(function(T) {
      H[T[1]] = function(R) {
        return this.$g(R, T[0], T[1]);
      };
    }), k.extend = function(T, R) {
      return T.$i || (T(R, L, k), T.$i = !0), k;
    }, k.locale = S, k.isDayjs = C, k.unix = function(T) {
      return k(1e3 * T);
    }, k.en = E[y], k.Ls = E, k.p = {}, k;
  });
})(p8);
var p6 = p8.exports;
const Q = /* @__PURE__ */ jn(p6);
var j8 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(In, function() {
    return function(n, r, a) {
      r.prototype.isBetween = function(s, o, i, c) {
        var u = a(s), f = a(o), m = (c = c || "()")[0] === "(", b = c[1] === ")";
        return (m ? this.isAfter(u, i) : !this.isBefore(u, i)) && (b ? this.isBefore(f, i) : !this.isAfter(f, i)) || (m ? this.isBefore(u, i) : !this.isAfter(u, i)) && (b ? this.isAfter(f, i) : !this.isBefore(f, i));
      };
    };
  });
})(j8);
var j6 = j8.exports;
const v6 = /* @__PURE__ */ jn(j6);
var v8 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(In, function() {
    return function(n, r, a) {
      r.prototype.isToday = function() {
        var s = "YYYY-MM-DD", o = a();
        return this.format(s) === o.format(s);
      };
    };
  });
})(v8);
var h6 = v8.exports;
const g6 = /* @__PURE__ */ jn(h6);
function ud(e) {
  const t = Q(e), n = t.month(), r = t.year(), a = t.daysInMonth(), s = Q(new Date(r, n, 1)), o = Q(new Date(r, n, a)), i = Math.ceil(
    o.diff(s, "week", !0)
  );
  let c = 1;
  const u = [];
  for (let m = 0; m <= i; m++) {
    const b = Array(7).fill(null);
    for (let _ = 0; _ < 7; _++) {
      const j = Q(new Date(r, n, c));
      c > a ? b[_] = null : _ === j.day() && (b[_] = j, c = c + 1);
    }
    u.push(b);
  }
  return u.filter(
    (m) => !m.every((b) => b === null)
  );
}
function Nt(e, t = 1) {
  const n = [];
  for (let r = 0; r < t; r++)
    r === 0 ? n.push(ud(e)) : n.push(ud(Q(e).add(r, "month").toDate()));
  return n;
}
function h8(e, t) {
  const { numberOfMonths: n = 1 } = t, r = Nt(e, n);
  let a = [0, 0, 0], s = Q(e);
  for (const [o, i] of r.entries())
    for (const [c, u] of i.entries())
      for (const [f, m] of u.entries())
        if (m && m.isSame(Q(e), "day")) {
          a = [o, c, f], s = r[o][c][f];
          break;
        }
  return {
    months: r,
    numberOfMonths: n,
    range: {},
    activeCell: {
      cell: a,
      date: s,
      focus: !1
    }
  };
}
function y6({
  start: e,
  end: t,
  mode: n
}) {
  return n === "range" && e && !(t != null && t.isSelected) ? "preview" : n === "single" && e && !(t != null && t.isSelected) || e && (t != null && t.isSelected) ? "selected" : "none";
}
function w6({
  date: e,
  cell: t,
  start: n,
  end: r,
  maxRange: a,
  min: s,
  max: o
}) {
  return e && (e != null && e.isToday()) && n && e.isSame(n, "day") && r.date && e.isSame(r.date, "day") ? "todayStartEnd" : e && (e != null && e.isToday()) && n && e.isSame(n, "day") ? "todayStart" : e && (e != null && e.isToday()) && r.date && e.isSame(r.date, "day") ? "todayEnd" : e && n && e.isSame(n, "day") ? "start" : e && r.date && e.isSame(r.date, "day") ? "end" : e && n && r.date && e.isBetween(n, r.date, "day", "[]") ? (t[2] === 0 || e.isSame(e.startOf("month"), "day")) && (t[2] === 6 || e.isSame(e.endOf("month"), "day")) ? "betweenBoth" : t[2] === 0 || e.isSame(e.startOf("month"), "day") ? "betweenStart" : t[2] === 6 || e.isSame(e.endOf("month"), "day") ? "betweenEnd" : "between" : a && n && e && (e.isAfter(n.add(a - 1, "days")) || e.isBefore(n)) ? "exceedsRange" : e && (s && e.isBefore(s.startOf("day")) || o && e.isAfter(o)) ? "outOfBounds" : e && (e != null && e.isToday()) && !(n && e.isSame(n, "day")) ? "today" : "neutral";
}
function Ws(e, t, n, r) {
  let a = [0, 0];
  for (const [s, o] of e.entries())
    for (const [i, c] of o.entries())
      if (c) {
        if (a = [s, i], n && t < n.date() && c.isSame(n) || r && t > r.date() && c.isSame(r))
          return a;
        if (c.date() === t) {
          if (!n && !r)
            return a;
          if (n && c.isBefore(n) || r && c.isAfter(r))
            continue;
          return a;
        }
      }
  return a;
}
var mt = /* @__PURE__ */ ((e) => (e.MOVE_RIGHT = "MOVE_RIGHT", e.MOVE_LEFT = "MOVE_LEFT", e.MOVE_UP = "MOVE_UP", e.MOVE_DOWN = "MOVE_DOWN", e.PAGE_UP = "PAGE_UP", e.PAGE_DOWN = "PAGE_DOWN", e.NEXT_MONTH = "NEXT_MONTH", e.PREVIOUS_MONTH = "PREVIOUS_MONTH", e.SET_START_MONTH = "SET_START_MONTH", e))(mt || {});
function C6(e, t) {
  const { cell: n, date: r } = t.payload, [a, s, o] = n;
  let i = n, c = e.months;
  if (r.isSame(r.endOf("month"), "day"))
    if (c.length - 1 === a) {
      const u = c[0][0].find((m) => m !== null);
      c = Nt(
        u == null ? void 0 : u.add(1, "month").toDate(),
        e.numberOfMonths
      );
      const f = c.length - 1;
      i = [
        f,
        0,
        c[f][0].findIndex((m) => m !== null)
      ];
    } else {
      const u = c[a + 1][0].findIndex((f) => f !== null);
      i = [a + 1, 0, u];
    }
  else o === 6 ? i = [a, s + 1, 0] : i = [a, s, o + 1];
  return {
    ...e,
    months: c,
    activeCell: {
      cell: i,
      date: c[i[0]][i[1]][i[2]],
      focus: !0
    }
  };
}
function E6(e, t) {
  const { cell: n, date: r } = t.payload, [a, s, o] = n;
  let i = n, c = e.months;
  if (r.isSame(r.startOf("month"), "day"))
    if (a === 0) {
      const u = c[0][0].find((m) => m !== null).subtract(1, "month");
      c = Nt(u.toDate(), e.numberOfMonths);
      const f = c[0].length - 1;
      i = [
        0,
        f,
        c[0][f].findIndex(
          (m) => m.isSame(m.endOf("month"), "day")
        )
      ];
    } else {
      const u = c[a - 1], f = u[u.length - 1].findIndex(
        (m) => m.isSame(m.endOf("month"), "day")
      );
      i = [a - 1, u.length - 1, f];
    }
  else o === 0 ? i = [a, s - 1, 6] : i = [a, s, o - 1];
  return {
    ...e,
    months: c,
    activeCell: {
      cell: i,
      date: c[i[0]][i[1]][i[2]],
      focus: !0
    }
  };
}
function x6(e, t) {
  const { cell: n, date: r } = t.payload, [a, s, o] = n;
  let i = n, c = e.months;
  if (s === 0 || c[n[0]][n[1] - 1][n[2]] === null) {
    if (a === 0)
      c = Nt(
        r.subtract(1, "month").toDate(),
        e.numberOfMonths
      ), i = [0, c[0].length - 1, o];
    else {
      const u = a - 1;
      i = [u, c[u].length - 1, o];
    }
    c[i[0]][i[1]][i[2]] === null && (i = [
      i[0],
      i[1] - 1,
      i[2]
    ]);
  } else
    i = [a, s - 1, o];
  return {
    ...e,
    months: c,
    activeCell: {
      cell: i,
      date: c[i[0]][i[1]][i[2]],
      focus: !0
    }
  };
}
function S6(e, t) {
  const { cell: n } = t.payload, [r, a, s] = n;
  let o = n, i = e.months;
  if (a === i[r].length - 1 || i[n[0]][n[1] + 1][n[2]] === null) {
    if (r === i.length - 1) {
      const c = i[0][0].find((u) => u !== null);
      i = Nt(
        c.add(1, "month").toDate(),
        e.numberOfMonths
      ), o = [i.length - 1, 0, s];
    } else
      o = [r + 1, 0, s];
    i[o[0]][o[1]][o[2]] === null && (o = [
      o[0],
      o[1] + 1,
      o[2]
    ]);
  } else
    o = [r, a + 1, s];
  return {
    ...e,
    months: i,
    activeCell: {
      cell: o,
      date: i[o[0]][o[1]][o[2]],
      focus: !0
    }
  };
}
function k6(e, t) {
  const { cell: n, date: r, max: a } = t.payload, [s] = n;
  let o = n, i = e.months;
  if (s === i.length - 1) {
    const c = i[0][0].find((f) => f !== null);
    i = Nt(
      c.add(1, "month").toDate(),
      e.numberOfMonths
    );
    const u = i.length - 1;
    o = [
      u,
      ...Ws(i[u], r.date(), void 0, a)
    ];
  } else {
    const c = i[s + 1][0].findIndex((u) => u !== null);
    o = [s + 1, 0, c], o = [
      s + 1,
      ...Ws(i[s + 1], r.date(), void 0, a)
    ];
  }
  return {
    ...e,
    months: i,
    activeCell: {
      cell: o,
      date: i[o[0]][o[1]][o[2]],
      focus: !0
    }
  };
}
function T6(e, t) {
  const { cell: n, date: r, min: a } = t.payload, [s] = n;
  let o = n, i = e.months;
  return s === 0 ? (i = Nt(
    r.subtract(1, "month").toDate(),
    e.numberOfMonths
  ), o = [
    0,
    ...Ws(i[0], r.date(), a)
  ]) : o = [
    s - 1,
    ...Ws(i[s - 1], r.date(), a)
  ], {
    ...e,
    months: i,
    activeCell: {
      cell: o,
      date: i[o[0]][o[1]][o[2]],
      focus: !0
    }
  };
}
function R6(e) {
  const { months: t, numberOfMonths: n } = e, r = e.activeCell.date;
  let a = t, s = e.activeCell.cell;
  const o = a[0][0].find((i) => i !== null);
  if (a = Nt(
    o.add(1, "month").toDate(),
    n
  ), s[0] === 0) {
    for (const [i, c] of a[0].entries())
      for (const [u, f] of c.entries())
        if (f !== null && f.isSame(r == null ? void 0 : r.add(1, "month"), "day")) {
          s = [0, i, u];
          break;
        }
  } else
    s = [
      s[0] - 1,
      s[1],
      s[2]
    ];
  return {
    ...e,
    months: a,
    activeCell: {
      cell: s,
      date: a[s[0]][s[1]][s[2]],
      focus: !1
    }
  };
}
function O6(e) {
  const { months: t, numberOfMonths: n } = e, r = e.activeCell.date;
  let a = t, s = e.activeCell.cell;
  const o = a[0][0].find((i) => i !== null);
  if (a = Nt(
    o.subtract(1, "month").toDate(),
    n
  ), s[0] === a.length - 1) {
    for (const [i, c] of a[a.length - 1].entries())
      for (const [u, f] of c.entries())
        if (f !== null && f.isSame(r == null ? void 0 : r.subtract(1, "month"), "day")) {
          s = [a.length - 1, i, u];
          break;
        }
  } else
    s = [
      s[0] + 1,
      s[1],
      s[2]
    ];
  return {
    ...e,
    months: a,
    activeCell: {
      cell: s,
      date: a[s[0]][s[1]][s[2]],
      focus: !1
    }
  };
}
function M6(e, t) {
  const n = Nt(t.payload.toDate(), e.numberOfMonths);
  return {
    ...e,
    months: n
  };
}
function A6(e, t) {
  switch (t.type) {
    case "MOVE_RIGHT":
      return C6(e, t);
    case "MOVE_LEFT":
      return E6(e, t);
    case "MOVE_UP":
      return x6(e, t);
    case "MOVE_DOWN":
      return S6(e, t);
    case "PAGE_UP":
      return T6(e, t);
    case "PAGE_DOWN":
      return k6(e, t);
    case "NEXT_MONTH":
      return R6(e);
    case "PREVIOUS_MONTH":
      return O6(e);
    case "SET_START_MONTH":
      return M6(e, t);
  }
}
var P6 = "_2j5uxj0", N6 = { 1: "_2j5uxj4 _2j5uxj2 _2j5uxj1 _1s8b37jmh _1s8b37jvs _1s8b37j1iz _1s8b37j29d _1s8b37j2vq _2j5uxj3", 2: "_2j5uxj6 _2j5uxj2 _2j5uxj1 _1s8b37jmh _1s8b37jvs _1s8b37j1iz _1s8b37j29d _1s8b37j2vq _2j5uxj5", 3: "_2j5uxj8 _2j5uxj2 _2j5uxj1 _1s8b37jmh _1s8b37jvs _1s8b37j1iz _1s8b37j29d _1s8b37j2vq _2j5uxj7" }, D6 = "_2j5uxj9", I6 = "_2j5uxjd _2j5uxjb _2j5uxja _1s8b37j293 _2j5uxjc _1s8b37j1b2", $6 = "_2j5uxjf _2j5uxjb _2j5uxja _1s8b37j293 _2j5uxje _1s8b37j29s", L6 = "_2j5uxjh _2j5uxjg _1s8b37jvs", z6 = "_2j5uxjj _2j5uxji _1s8b37jlc _1s8b37j2h0 _1s8b37j1iu", F6 = "_2j5uxjk", H6 = "_2j5uxjm _2j5uxjl _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37jmh _1s8b37jl5 _1s8b37jew _1s8b37jl3 _1s8b37jvn _1s8b37j199 _1s8b37j29d _1s8b37j1iu _1s8b37j2pr", ji = { range: { selected: { todayStart: "_2j5uxjn", todayEnd: "_2j5uxjo", todayStartEnd: "_2j5uxjp", start: "_2j5uxjq", end: "_2j5uxjr", between: "_2j5uxjs", betweenStart: "_2j5uxjt", betweenEnd: "_2j5uxju", betweenBoth: "_2j5uxjv" }, preview: { between: "_2j5uxjw", betweenStart: "_2j5uxjx", betweenEnd: "_2j5uxjy" } } }, B6 = "_2j5uxj10 _2j5uxjz _1s8b37jk8 _1s8b37jkc _1s8b37jkg _1s8b37jkk _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37jmh _1s8b37jao _1s8b37jew _1s8b37jl3 _1s8b37jl5 _1s8b37jl7 _1s8b37jvn _1s8b37jl8 _1s8b37jy5 _1s8b37j12v _1s8b37j199 _1s8b37j293 _1s8b37jg _1s8b37j2pr", vi = { single: { none: { today: "_2j5uxj11", todayStart: "_2j5uxj11", todayEnd: "_2j5uxj11" }, selected: { today: "_2j5uxj11", todayStart: "_2j5uxj12", start: "_2j5uxj12" } }, range: { none: { today: "_2j5uxj11" }, selected: { todayStart: "_2j5uxj12", todayStartEnd: "_2j5uxj12", todayEnd: "_2j5uxj13", start: "_2j5uxj12", end: "_2j5uxj13", between: "_2j5uxj14", betweenStart: "_2j5uxj14", betweenEnd: "_2j5uxj14", betweenBoth: "_2j5uxj14", exceedsRange: "_2j5uxj14" }, preview: { today: "_2j5uxj11", todayStart: "_2j5uxj12", start: "_2j5uxj12" } } }, hi = { single: { selected: { todayStart: "_2j5uxj15", start: "_2j5uxj15" } }, range: { selected: { todayStart: "_2j5uxj15", start: "_2j5uxj15" }, preview: { todayStart: "_2j5uxj15", start: "_2j5uxj15" } } }, q6 = "_2j5uxj17 _2j5uxj16 _1s8b37jmh _1s8b37jwh _1s8b37j121 _1s8b37j199 _1s8b37j3g _1s8b37j2ox", gi = { single: { selected: { todayStart: "_2j5uxj18", start: "_2j5uxj18" } }, range: { selected: { todayStart: "_2j5uxj18", start: "_2j5uxj18" }, preview: { todayStart: "_2j5uxj18", start: "_2j5uxj18" } } };
Q.extend(v6);
Q.extend(g6);
const g8 = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
], y8 = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
function U6(e) {
  return `${g8[e.day()]}, ${y8[e.month()]} ${e.date()}, ${e.year()}`;
}
const w8 = l.createContext({
  state: h8(/* @__PURE__ */ new Date(), {}),
  mode: "range",
  dispatch: () => {
  }
}), Tr = () => l.useContext(w8), C8 = ({
  children: e,
  className: t,
  numberOfMonths: n = 1,
  defaultStart: r,
  defaultEnd: a,
  start: s,
  end: o,
  onStartChange: i,
  onEndChange: c,
  max: u,
  maxRange: f,
  min: m,
  mode: b = "range",
  focusDayOnMount: _ = !1
}) => {
  const [j, p] = l.useReducer(
    A6,
    h8(r || s || /* @__PURE__ */ new Date(), { numberOfMonths: n })
  ), [v, h] = nt({
    prop: s,
    defaultProp: r,
    onChange: i
  }), [g, w] = nt({
    prop: o,
    defaultProp: a,
    onChange: c
  });
  return l.useEffect(() => {
    var y, E, C;
    const x = (C = (E = (y = j.months) == null ? void 0 : y[0]) == null ? void 0 : E[0]) == null ? void 0 : C.find(
      (S) => S !== null
    );
    s && ((x == null ? void 0 : x.year()) !== Q(s).year() || (x == null ? void 0 : x.month()) !== Q(s).month()) && p({
      type: mt.SET_START_MONTH,
      payload: Q(s)
    });
  }, [s]), l.useEffect(() => {
    m && u && Q(m).isAfter(Q(u)) && console.warn(
      "[Calendar] - The provided min date should not come after the max date."
    );
  }, []), /* @__PURE__ */ l.createElement(
    w8.Provider,
    {
      value: {
        state: j,
        maxRange: f,
        start: v || void 0,
        updateStartDate: h,
        end: g,
        focusDayOnMount: _,
        updateEndDate: w,
        max: u ? Q(u) : void 0,
        min: m ? Q(m) : void 0,
        mode: b,
        dispatch: p
      }
    },
    /* @__PURE__ */ l.createElement(ye, { className: q(P6, t), gap: "small" }, e)
  );
}, E8 = l.forwardRef(({ children: e, ...t }, n) => {
  const {
    state: { numberOfMonths: r }
  } = Tr();
  return /* @__PURE__ */ l.createElement(
    U.div,
    {
      ...t,
      ref: n,
      className: N6[r || 1]
    },
    e
  );
}), x8 = l.forwardRef(({ className: e, ...t }, n) => {
  const {
    state: { months: r }
  } = Tr(), a = l.useMemo(() => r.length > 0 ? r.map((s) => {
    var i;
    const o = (i = s == null ? void 0 : s[0]) == null ? void 0 : i.find((c) => c !== null);
    if (o)
      return `${y8[o.month()]} ${o.year()}`;
  }) : [], [r]);
  return /* @__PURE__ */ l.createElement(l.Fragment, null, a.map((s, o) => /* @__PURE__ */ l.createElement(
    ne,
    {
      ...t,
      key: `month-title-${o}`,
      ref: n,
      className: q(e, D6)
    },
    s
  )));
}), S8 = l.forwardRef(({ onClick: e, className: t, ...n }, r) => {
  const {
    dispatch: a,
    max: s,
    state: { activeCell: o }
  } = Tr(), i = l.useCallback(() => {
    a({
      type: mt.NEXT_MONTH,
      payload: void 0
    });
  }, [a]), c = l.useMemo(() => {
    var u;
    return s ? !!(s.isSame(o == null ? void 0 : o.date, "month") || ((u = o == null ? void 0 : o.date) == null ? void 0 : u.add(1, "month").startOf("month")) >= s) : !1;
  }, [o]);
  return /* @__PURE__ */ l.createElement(
    Me,
    {
      ...n,
      ref: r,
      className: q(t, $6),
      onClick: Xe(e, i),
      "aria-label": "next month",
      isDisabled: c
    },
    /* @__PURE__ */ l.createElement(Jf, null)
  );
}), k8 = l.forwardRef(({ onClick: e, className: t, ...n }, r) => {
  const {
    dispatch: a,
    min: s,
    state: { activeCell: o }
  } = Tr(), i = l.useCallback(() => {
    a({
      type: mt.PREVIOUS_MONTH,
      payload: void 0
    });
  }, [a]), c = l.useMemo(() => {
    var u;
    return s ? !!(s.isSame(o == null ? void 0 : o.date, "month") || ((u = o == null ? void 0 : o.date) == null ? void 0 : u.subtract(1, "month").endOf("month")) <= s) : !1;
  }, [o]);
  return /* @__PURE__ */ l.createElement(
    Me,
    {
      ...n,
      ref: r,
      className: q(t, I6),
      onClick: Xe(e, i),
      "aria-label": "previous month",
      isDisabled: c
    },
    /* @__PURE__ */ l.createElement(Xj, null)
  );
}), Cn = l.forwardRef(
  ({ cell: e, className: t, date: n, ...r }, a) => {
    var R, M, D, I, F, P, A, $;
    const s = l.useRef(!1), {
      maxRange: o,
      start: i,
      updateStartDate: c,
      end: u,
      updateEndDate: f,
      min: m,
      max: b,
      mode: _,
      state: { activeCell: j },
      dispatch: p,
      focusDayOnMount: v
    } = Tr(), h = l.useMemo(() => j == null ? void 0 : j.cell.every((B, Y) => e[Y] === B), [j, e]), g = l.useRef(null), w = l.useCallback(
      (B) => {
        h && v && !s.current && (B.focus(), s.current = !0);
      },
      [h, v, s]
    ), x = We([
      g,
      a,
      w
    ]), y = l.useMemo(() => i ? Q(i) : void 0, [i]), E = l.useMemo(() => ({
      ...u,
      date: u ? Q(u.date) : null
    }), [u]), C = l.useCallback(
      (B, Y) => {
        B.preventDefault(), !(Y === mt.PAGE_UP && m && (m.isSame(j == null ? void 0 : j.date, "month") || (j == null ? void 0 : j.date.subtract(1, "month").endOf("month")) <= m)) && (Y === mt.PAGE_DOWN && b && (b.isSame(j == null ? void 0 : j.date, "month") || (j == null ? void 0 : j.date.add(1, "month").startOf("month")) >= b) || p({
          type: Y,
          payload: {
            cell: e,
            date: n,
            min: m,
            max: b
          }
        }));
      },
      [e, n, m, b, p]
    ), S = l.useCallback(() => {
      if (_ === "single")
        return y && (n != null && n.isSame(y)) ? c == null ? void 0 : c(void 0) : c == null ? void 0 : c(n.toDate());
      if (y && (n != null && n.isSame(y)) || y && n && n.isBefore(y)) {
        c == null || c(void 0), f == null || f(void 0);
        return;
      }
      if (y == null) {
        c == null || c(n.toDate());
        return;
      }
      return f == null ? void 0 : f({
        date: n.toDate(),
        isSelected: !0
      });
    }, [n, f, c, y, _]), k = l.useCallback(() => {
      _ === "range" && y && !(E != null && E.isSelected) && (f == null || f({
        date: n.toDate(),
        isSelected: !1
      }));
    }, [y, E, n, _]), O = ao({
      onArrowLeft: (B) => C(B, mt.MOVE_LEFT),
      onArrowRight: (B) => C(B, mt.MOVE_RIGHT),
      onArrowUp: (B) => C(B, mt.MOVE_UP),
      onArrowDown: (B) => C(B, mt.MOVE_DOWN),
      onPageUp: (B) => C(B, mt.PAGE_UP),
      onPageDown: (B) => C(B, mt.PAGE_DOWN)
    }), L = l.useMemo(() => n ? U6(n) : "", [n]), H = l.useMemo(() => y6({
      start: y,
      end: E,
      mode: _
    }), [y, E]), T = l.useMemo(() => w6({
      date: n,
      cell: e,
      start: y,
      end: E,
      maxRange: o,
      min: m,
      max: b
    }), [n, e, y, E, o, m, b]);
    return l.useEffect(() => {
      h && (j != null && j.focus) && g.current && g.current.focus();
    }, [g, h]), n == null ? /* @__PURE__ */ l.createElement("div", null) : /* @__PURE__ */ l.createElement(
      U.div,
      {
        className: q(
          H6,
          (M = (R = ji == null ? void 0 : ji[_]) == null ? void 0 : R[H]) == null ? void 0 : M[T]
        )
      },
      /* @__PURE__ */ l.createElement(
        U.button,
        {
          ...r,
          className: q(
            t,
            B6,
            (I = (D = vi == null ? void 0 : vi[_]) == null ? void 0 : D[H]) == null ? void 0 : I[T]
          ),
          ref: x,
          onClick: S,
          onKeyDown: O,
          onPointerOver: k,
          onFocus: k,
          "aria-label": L,
          "aria-pressed": y && n.isSame(y, "day") || n.isSame(E.date, "day") && E.isSelected,
          disabled: T === "exceedsRange" || T === "outOfBounds",
          tabIndex: h ? 0 : -1
        },
        /* @__PURE__ */ l.createElement(
          "span",
          {
            className: q(
              q6,
              (P = (F = gi == null ? void 0 : gi[_]) == null ? void 0 : F[H]) == null ? void 0 : P[T]
            )
          },
          /* @__PURE__ */ l.createElement(wr, null)
        ),
        /* @__PURE__ */ l.createElement(
          "span",
          {
            className: ($ = (A = hi == null ? void 0 : hi[_]) == null ? void 0 : A[H]) == null ? void 0 : $[T]
          },
          n.date()
        )
      )
    );
  }
), T8 = l.forwardRef(({ className: e, ...t }, n) => {
  const r = Tr();
  return /* @__PURE__ */ l.createElement(re, { gap: "large" }, r.state.months.map((a, s) => /* @__PURE__ */ l.createElement(
    U.div,
    {
      ...t,
      key: `month-${s}`,
      className: q(e, L6),
      ref: n
    },
    g8.map((o, i) => /* @__PURE__ */ l.createElement(ne, { key: `days-${i}`, className: z6 }, o[0])),
    a.map((o, i) => /* @__PURE__ */ l.createElement(l.Fragment, { key: `week-${s}${i}` }, /* @__PURE__ */ l.createElement(Cn, { cell: [s, i, 0], date: o[0] }), /* @__PURE__ */ l.createElement(Cn, { cell: [s, i, 1], date: o[1] }), /* @__PURE__ */ l.createElement(Cn, { cell: [s, i, 2], date: o[2] }), /* @__PURE__ */ l.createElement(Cn, { cell: [s, i, 3], date: o[3] }), /* @__PURE__ */ l.createElement(Cn, { cell: [s, i, 4], date: o[4] }), /* @__PURE__ */ l.createElement(Cn, { cell: [s, i, 5], date: o[5] }), /* @__PURE__ */ l.createElement(Cn, { cell: [s, i, 6], date: o[6] }))),
    a.length < 6 && /* @__PURE__ */ l.createElement(U.div, { className: F6 })
  )));
}), R8 = ({
  numberOfMonths: e = 1,
  defaultValue: t,
  max: n,
  min: r,
  value: a,
  onValueChange: s,
  ...o
}) => /* @__PURE__ */ l.createElement(
  C8,
  {
    ...o,
    numberOfMonths: e,
    max: n,
    min: r,
    mode: "single",
    start: a,
    defaultStart: t,
    onStartChange: s
  },
  /* @__PURE__ */ l.createElement(E8, null, /* @__PURE__ */ l.createElement(k8, null), /* @__PURE__ */ l.createElement(x8, null), /* @__PURE__ */ l.createElement(S8, null)),
  /* @__PURE__ */ l.createElement(T8, null)
), W6 = ({
  numberOfMonths: e = 2,
  ...t
}) => /* @__PURE__ */ l.createElement(C8, { ...t, numberOfMonths: e, mode: "range" }, /* @__PURE__ */ l.createElement(E8, null, /* @__PURE__ */ l.createElement(k8, null), /* @__PURE__ */ l.createElement(x8, null), /* @__PURE__ */ l.createElement(S8, null)), /* @__PURE__ */ l.createElement(T8, null)), dd = {
  // defining some of the animations that we can use
  fadeIn: {
    value: {
      opacity: [0, 1],
      transform: ["scale(0.98)", "scale(1)"]
    },
    options: {
      duration: 0.2,
      easing: "ease-in-out"
    }
  },
  fadeOut: {
    value: {
      opacity: [1, 0],
      transform: ["scale(1)", "scale(0.98)"]
    },
    options: {
      duration: 0.2,
      easing: "ease-in-out"
    }
  },
  flyDown: {
    value: {
      opacity: [0, 0.5, 0.7, 1],
      y: [-15, 0]
    },
    options: {
      duration: 0.2,
      easing: [0.22, 0.69, 0.33, 0.95]
    }
  },
  flyUp: {
    value: {
      opacity: [1, 0],
      y: [0, -5]
    },
    options: {
      duration: 0.2,
      easing: [0.22, 0.69, 0.33, 0.95]
    }
  },
  flyLeft: {
    value: {
      opacity: [0, 1],
      x: [20, 0]
    },
    options: {
      duration: 0.2,
      easing: [0.22, 0.69, 0.33, 0.95]
    }
  }
}, V6 = {
  isEntering: !1,
  isLeaving: !1,
  _isShowing: !1,
  previousIsShowing: !1
};
function Y6(e, t) {
  switch (t.type) {
    case "EnterStart":
      return {
        ...e,
        _isShowing: !0,
        isEntering: !0,
        isLeaving: !1
      };
    case "EnterEnd":
      return {
        ...e,
        isEntering: !1,
        isLeaving: !1,
        previousIsShowing: !0
      };
    case "LeavingStart":
      return {
        ...e,
        isLeaving: !0,
        isEntering: !1
      };
    case "LeavingEnd":
      return {
        ...e,
        isLeaving: !1,
        isEntering: !1,
        _isShowing: !1,
        previousIsShowing: !1
      };
    default:
      throw new Error(
        "Unexpected action type passed to the Transition reducer."
      );
  }
}
const Ma = l.forwardRef((e, t) => {
  const { enter: n, leave: r, isShowing: a, children: s, ...o } = e, [{ previousIsShowing: i, _isShowing: c, isEntering: u, isLeaving: f }, m] = l.useReducer(Y6, {
    ...V6,
    _isShowing: a
  }), b = l.useRef(null), _ = We([t, b]);
  return l.useLayoutEffect(() => {
    async function j() {
      const { value: v, options: h } = dd[n];
      m({
        type: "EnterStart"
        /* EnterStart */
      }), b.current && (await sd(b.current, v, h).finished, m({
        type: "EnterEnd"
        /* EnterEnd */
      }));
    }
    async function p() {
      const { value: v, options: h } = dd[r];
      if (b.current) {
        m({
          type: "LeavingStart"
          /* LeaveStart */
        });
        const g = sd(b.current, v, h);
        await (g == null ? void 0 : g.finished), m({
          type: "LeavingEnd"
          /* LeaveEnd */
        });
      }
    }
    !i && a ? j() : i && !a && p();
  }, [a, b, c, i, n, r]), c ? /* @__PURE__ */ l.createElement(U.div, { ...o, ref: _ }, typeof s == "function" ? s({ isEntering: u, isLeaving: f }) : s) : null;
});
Ma.displayName = "Transition";
var G6 = "_1sxezjl0", gs = /* @__PURE__ */ ((e) => (e.Danger = "danger", e.Warning = "warning", e.Success = "success", e.Neutral = "neutral", e))(gs || {});
const O8 = l.createContext({}), K6 = ({ children: e, appearance: t, isRequired: n }) => {
  const [r, a] = l.useState(""), [s, o] = l.useState(""), [i, c] = l.useState("");
  return /* @__PURE__ */ l.createElement(
    O8.Provider,
    {
      value: {
        appearance: t,
        isRequired: n,
        infoId: r,
        labelId: s,
        labelFor: i,
        setInfoId: a,
        setLabelId: o,
        setLabelFor: c
      }
    },
    e
  );
};
function ut() {
  return l.useContext(O8);
}
const X6 = l.forwardRef(
  ({ children: e, ...t }, n) => {
    const r = ut(), a = kt("rtk-field-info");
    return l.useEffect(() => {
      var s;
      (s = r.setInfoId) == null || s.call(r, a);
    }, []), /* @__PURE__ */ l.createElement(
      ne,
      {
        ...t,
        id: a,
        styledAs: "body5",
        textColor: "secondary",
        ref: n
      },
      e
    );
  }
), Z6 = l.forwardRef(
  ({ children: e, className: t, htmlFor: n, ...r }, a) => {
    const s = ut(), o = kt("rtk-field-label");
    return l.useEffect(() => {
      var i, c;
      (i = s.setLabelId) == null || i.call(s, o), n && ((c = s.setLabelFor) == null || c.call(s, n));
    }, []), /* @__PURE__ */ l.createElement(ne, { styledAs: "body4", asChild: !0 }, /* @__PURE__ */ l.createElement(
      U.label,
      {
        ...r,
        className: q(t, { [G6]: s.isRequired }),
        htmlFor: n,
        ref: a,
        id: o
      },
      e
    ));
  }
), J6 = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(U.div, { ...t, width: "full", ref: n }, e)), Q6 = l.forwardRef(({ children: e, ...t }, n) => {
  const r = ut(), [a, s] = l.useState(r.appearance);
  l.useEffect(() => {
    r.appearance != null && s(r.appearance);
  }, [r]);
  const o = l.useMemo(() => {
    switch (a) {
      case "danger":
        return {
          Icon: wr,
          textColor: "dangerDefault"
        };
      case "warning":
        return {
          Icon: Qf,
          textColor: "warningDefault"
        };
      case "success":
        return {
          Icon: ha,
          textColor: "successDefault"
        };
      default:
        return {
          Icon: null,
          textColor: "body"
        };
    }
  }, [a]);
  return /* @__PURE__ */ l.createElement(U.div, { height: "1rem" }, /* @__PURE__ */ l.createElement(
    Ma,
    {
      isShowing: !!r.appearance,
      enter: "flyDown",
      leave: "flyUp"
    },
    /* @__PURE__ */ l.createElement(
      re,
      {
        ...t,
        gap: "small",
        textColor: o.textColor,
        ref: n
      },
      /* @__PURE__ */ l.createElement(U.div, { display: "flex", alignSelf: "flex-start" }, o.Icon && e && /* @__PURE__ */ l.createElement(o.Icon, { height: "0.75rem" })),
      /* @__PURE__ */ l.createElement(
        ne,
        {
          styledAs: "body5",
          textColor: "inherit",
          style: {
            lineHeight: "16px",
            paddingTop: "3px",
            paddingBottom: "3px"
          }
        },
        e
      )
    )
  ));
}), e5 = ({
  children: e,
  appearance: t,
  isRequired: n,
  ...r
}) => /* @__PURE__ */ l.createElement(K6, { appearance: t, isRequired: n }, /* @__PURE__ */ l.createElement(ye, { gap: "small", width: "full", xAlign: "left", ...r }, e)), Ae = {
  Content: J6,
  Label: Z6,
  Message: Q6,
  Root: e5,
  Info: X6
};
var t5 = "_1y6ylxm1 _1y6ylxm0 _1s8b37j1mq _1s8b37j1ik _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jw7 _1s8b37j8h _1s8b37j26l _1s8b37jlu", n5 = "_1y6ylxm3 _1y6ylxm2 _1s8b37j27u _1s8b37j23o _1s8b37j252 _1s8b37j26g _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jvn _1s8b37jmh _1s8b37j199 _1s8b37j2 _1s8b37j12b _1s8b37jlu _1s8b37j2p7 _1s8b37j29d", r5 = "_1y6ylxm4", a5 = "_1y6ylxm5", s5 = "_1y6ylxm6", o5 = "_1y6ylxm7", i5 = "_1y6ylxm9 _1y6ylxm8 _1s8b37jl5 _1s8b37j257", l5 = "_1y6ylxmb _1y6ylxma _1s8b37jll _1s8b37jk", c5 = "_1y6ylxmd _1y6ylxmc _1s8b37jl2 _1s8b37jvn _1s8b37jx6 _1s8b37j10s _1s8b37j1ip", u5 = "_1y6ylxmf _1y6ylxme _1s8b37j27u _1s8b37j23o _1s8b37j252 _1s8b37j26g _1s8b37jlc _1s8b37jg _1s8b37jya", d5 = "_1y6ylxmh _1y6ylxmg _1s8b37jvn", f5 = "_1y6ylxmj _1y6ylxmi _1s8b37jx6", b5 = "_1y6ylxml _1y6ylxmk _1s8b37jxg _1s8b37j112", m5 = "_1y6ylxmn _1y6ylxmm _1s8b37jy5 _1s8b37j2g";
const M8 = l.createContext({
  name: ""
}), _5 = () => l.useContext(M8), p5 = l.forwardRef(
  ({
    appearance: e,
    className: t,
    children: n,
    label: r,
    helpText: a,
    validationMessage: s,
    isHorizontal: o = !1,
    isRequired: i,
    name: c,
    ...u
  }, f) => {
    const m = kt("rtk-checkbox-group"), b = `${m}_help`, _ = `${m}_validation`, j = [];
    a && j.push(b), s && j.push(_);
    const p = l.useMemo(() => {
      switch (e) {
        case gs.Danger:
          return {
            Icon: wr,
            textColor: "dangerDefault"
          };
        case gs.Warning:
          return {
            Icon: Qf,
            textColor: "warningDefault"
          };
        case gs.Success:
          return {
            Icon: ha,
            textColor: "successDefault"
          };
        default:
          return {
            Icon: null,
            textColor: "body"
          };
      }
    }, [e]);
    return /* @__PURE__ */ l.createElement(
      M8.Provider,
      {
        value: {
          name: c,
          appearance: e,
          isRequired: i
        }
      },
      /* @__PURE__ */ l.createElement(
        "fieldset",
        {
          className: q(t, c5),
          "aria-describedby": j != null && j.length ? j.join(" ") : void 0,
          name: c,
          "aria-invalid": s ? !0 : void 0,
          ...u,
          ref: f
        },
        /* @__PURE__ */ l.createElement("legend", { className: u5 }, r),
        a && /* @__PURE__ */ l.createElement("div", { id: b, className: m5 }, a),
        /* @__PURE__ */ l.createElement(
          "div",
          {
            className: q(
              d5,
              o ? b5 : f5
            ),
            "data-testid": o ? "horizontal-group" : "vertical-group"
          },
          n
        ),
        s && /* @__PURE__ */ l.createElement(Ma, { isShowing: !!s, enter: "flyDown", leave: "flyUp" }, /* @__PURE__ */ l.createElement(re, { gap: "small", textColor: p.textColor, id: _ }, p.Icon && /* @__PURE__ */ l.createElement(p.Icon, { height: "0.75rem" }), /* @__PURE__ */ l.createElement(ne, { styledAs: "body5", textColor: "inherit" }, s)))
      )
    );
  }
), A8 = l.createContext({
  labelId: "",
  isDisabled: !1
}), j5 = () => l.useContext(A8), v5 = l.forwardRef(
  ({
    defaultChecked: e,
    isChecked: t,
    className: n,
    children: r,
    isIndeterminate: a,
    onCheckedChange: s,
    isDisabled: o,
    isRequired: i,
    name: c,
    value: u = "on",
    ...f
  }, m) => {
    const b = kt("rtk-checkbox"), _ = _5(), j = l.useRef(null), p = We([j, m]);
    l.useEffect(() => {
      j.current && (j.current.indeterminate = !!a);
    }, [a]);
    const v = l.useCallback(
      (h) => {
        o && h.preventDefault();
      },
      [o, a]
    );
    return /* @__PURE__ */ l.createElement(A8.Provider, { value: { labelId: b, isDisabled: o } }, /* @__PURE__ */ l.createElement(re, { className: t5, gap: "zero", pointerEvents: o ? "none" : void 0 }, /* @__PURE__ */ l.createElement(
      U.input,
      {
        ...f,
        ref: p,
        type: "checkbox",
        id: b,
        defaultChecked: e,
        checked: t,
        onKeyDown: (h) => {
          var g;
          h.key === " " && v(h), (g = f.onKeyDown) == null || g.call(f, h);
        },
        onClick: (h) => {
          var g;
          v(h), (g = f.onClick) == null || g.call(f, h);
        },
        onChange: (h) => {
          var g;
          return s == null ? void 0 : s(a ? !1 : (g = h.target) == null ? void 0 : g.checked);
        },
        "aria-disabled": o,
        "aria-labelledby": f["aria-labelledby"],
        name: c || (_ == null ? void 0 : _.name) || b,
        value: u,
        required: i,
        "data-indeterminate": a ? "true" : void 0,
        "data-appearance": _.appearance,
        className: q(n, n5, {
          [r5]: (_ == null ? void 0 : _.appearance) == null || (_ == null ? void 0 : _.appearance) === "neutral",
          [a5]: (_ == null ? void 0 : _.appearance) === "danger",
          [s5]: (_ == null ? void 0 : _.appearance) === "warning",
          [o5]: (_ == null ? void 0 : _.appearance) === "success"
        })
      }
    ), r));
  }
), h5 = l.forwardRef(
  ({ children: e, className: t, ...n }, r) => {
    const a = j5();
    return /* @__PURE__ */ l.createElement(ne, { asChild: !0, styledAs: "body3" }, /* @__PURE__ */ l.createElement(
      U.label,
      {
        ...n,
        className: q(t, i5, {
          [l5]: a.isDisabled
        }),
        userSelect: "none",
        ref: r,
        htmlFor: a.labelId
      },
      e
    ));
  }
), ZN = {
  Group: p5,
  Root: v5,
  Text: h5
}, P8 = "fenrir-collection-item", N8 = l.createContext({
  items: /* @__PURE__ */ new Map(),
  collectionRootRef: {
    current: null
  },
  itemDataAttr: P8,
  getItems: () => {
  }
}), Rr = () => l.useContext(N8), JN = () => {
  const e = Rr();
  if (e)
    return e.getItems();
}, D8 = l.forwardRef(({ children: e, itemDataAttr: t = P8, ...n }, r) => {
  const a = l.useRef(null), s = We([a, r]), o = l.useRef(
    /* @__PURE__ */ new Map()
  ).current, i = l.useCallback(() => {
    if (a.current == null)
      return;
    const c = Array.from(
      a.current.querySelectorAll(`[${t}]`)
    );
    return Array.from(o.values()).filter(
      (m) => {
        var b;
        return (b = m.ref.current) == null ? void 0 : b.getAttribute(t);
      }
    ).sort(
      (m, b) => c.indexOf(m.ref.current) - c.indexOf(b.ref.current)
    );
  }, [a, o, t]);
  return /* @__PURE__ */ l.createElement(
    N8.Provider,
    {
      value: { itemDataAttr: t, items: o, collectionRootRef: a, getItems: i }
    },
    /* @__PURE__ */ l.createElement(U.div, { ...n, ref: s }, e)
  );
}), bu = l.forwardRef(({ children: e, ...t }, n) => {
  const r = l.useRef(null), a = We([r, n]), s = Rr();
  return l.useEffect(() => (s.items.set(r, { ref: r }), () => void s.items.delete(r))), /* @__PURE__ */ l.createElement(
    U.div,
    {
      ...t,
      [s.itemDataAttr]: "true",
      ref: a
    },
    e
  );
}), QN = D8, eD = bu;
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function rs(e, t, n) {
  let r = [], a;
  return () => {
    let s;
    n.key && n.debug != null && n.debug() && (s = Date.now());
    const o = e();
    if (!(o.length !== r.length || o.some((u, f) => r[f] !== u)))
      return a;
    r = o;
    let c;
    if (n.key && n.debug != null && n.debug() && (c = Date.now()), a = t(...o), n == null || n.onChange == null || n.onChange(a), n.key && n.debug != null && n.debug()) {
      const u = Math.round((Date.now() - s) * 100) / 100, f = Math.round((Date.now() - c) * 100) / 100, m = f / 16, b = (_, j) => {
        for (_ = String(_); _.length < j; )
          _ = " " + _;
        return _;
      };
      console.info("%c⏱ " + b(f, 5) + " /" + b(u, 5) + " ms", `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(` + Math.max(0, Math.min(120 - 120 * m, 120)) + "deg 100% 31%);", n == null ? void 0 : n.key);
    }
    return a;
  };
}
const g5 = (e) => e, y5 = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let a = t; a <= n; a++)
    r.push(a);
  return r;
}, w5 = (e, t) => {
  const n = new ResizeObserver((r) => {
    var a, s;
    t({
      width: (a = r[0]) == null ? void 0 : a.contentRect.width,
      height: (s = r[0]) == null ? void 0 : s.contentRect.height
    });
  });
  if (e.scrollElement)
    return t(e.scrollElement.getBoundingClientRect()), n.observe(e.scrollElement), () => {
      n.unobserve(e.scrollElement);
    };
}, fd = {
  element: ["scrollLeft", "scrollTop"],
  window: ["scrollX", "scrollY"]
}, C5 = (e) => (t, n) => {
  if (!t.scrollElement)
    return;
  const r = fd[e][0], a = fd[e][1];
  let s = t.scrollElement[r], o = t.scrollElement[a];
  const i = () => {
    n(t.scrollElement[t.options.horizontal ? r : a]);
  };
  i();
  const c = (u) => {
    const f = u.currentTarget, m = f[r], b = f[a];
    (t.options.horizontal ? s - m : o - b) && i(), s = m, o = b;
  };
  return t.scrollElement.addEventListener("scroll", c, {
    capture: !1,
    passive: !0
  }), () => {
    t.scrollElement.removeEventListener("scroll", c);
  };
}, E5 = C5("element"), x5 = (e, t) => e.getBoundingClientRect()[t.options.horizontal ? "width" : "height"], S5 = (e, t, n) => {
  var r;
  (r = n.scrollElement) == null || r.scrollTo == null || r.scrollTo({
    [n.options.horizontal ? "left" : "top"]: e,
    behavior: t ? "smooth" : void 0
  });
};
class k5 {
  constructor(t) {
    var n = this;
    this.unsubs = [], this.scrollElement = null, this.measurementsCache = [], this.itemMeasurementsCache = {}, this.pendingMeasuredCacheIndexes = [], this.measureElementCache = {}, this.range = {
      startIndex: 0,
      endIndex: 0
    }, this.setOptions = (r) => {
      Object.entries(r).forEach((a) => {
        let [s, o] = a;
        typeof o > "u" && delete r[s];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: g5,
        rangeExtractor: y5,
        enableSmoothScroll: !0,
        onChange: () => {
        },
        measureElement: x5,
        initialRect: {
          width: 0,
          height: 0
        },
        ...r
      };
    }, this.notify = () => {
      var r, a;
      (r = (a = this.options).onChange) == null || r.call(a, this);
    }, this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.scrollElement = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      const r = this.options.getScrollElement();
      this.scrollElement !== r && (this.cleanup(), this.scrollElement = r, this._scrollToOffset(this.scrollOffset, !1), this.unsubs.push(this.options.observeElementRect(this, (a) => {
        this.scrollRect = a, this.calculateRange();
      })), this.unsubs.push(this.options.observeElementOffset(this, (a) => {
        this.scrollOffset = a, this.calculateRange();
      })));
    }, this.getSize = () => this.scrollRect[this.options.horizontal ? "width" : "height"], this.getMeasurements = rs(() => [this.options.count, this.options.paddingStart, this.options.getItemKey, this.itemMeasurementsCache], (r, a, s, o) => {
      const i = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
      this.pendingMeasuredCacheIndexes = [];
      const c = this.measurementsCache.slice(0, i);
      for (let u = i; u < r; u++) {
        const f = s(u), m = o[f], b = c[u - 1] ? c[u - 1].end : a, _ = typeof m == "number" ? m : this.options.estimateSize(u), j = b + _;
        c[u] = {
          index: u,
          start: b,
          size: _,
          end: j,
          key: f
        };
      }
      return this.measurementsCache = c, c;
    }, {
      key: process.env.NODE_ENV !== "production" && "getMeasurements",
      debug: () => this.options.debug
    }), this.calculateRange = rs(() => [this.getMeasurements(), this.getSize(), this.scrollOffset], (r, a, s) => {
      const o = R5({
        measurements: r,
        outerSize: a,
        scrollOffset: s
      });
      return (o.startIndex !== this.range.startIndex || o.endIndex !== this.range.endIndex) && (this.range = o, this.notify()), this.range;
    }, {
      key: process.env.NODE_ENV !== "production" && "calculateRange",
      debug: () => this.options.debug
    }), this.getIndexes = rs(() => [this.options.rangeExtractor, this.range, this.options.overscan, this.options.count], (r, a, s, o) => r({
      ...a,
      overscan: s,
      count: o
    }), {
      key: process.env.NODE_ENV !== "production" && "getIndexes",
      debug: () => this.options.debug
    }), this.getVirtualItems = rs(() => [this.getIndexes(), this.getMeasurements(), this.options.measureElement], (r, a, s) => {
      const o = (f) => (m) => {
        var b;
        const _ = this.measurementsCache[f];
        if (!m)
          return;
        const j = s(m, this), p = (b = this.itemMeasurementsCache[_.key]) != null ? b : _.size;
        j !== p && (_.start < this.scrollOffset && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", j - p), this.destinationOffset || this._scrollToOffset(this.scrollOffset + (j - p), !1)), this.pendingMeasuredCacheIndexes.push(f), this.itemMeasurementsCache = {
          ...this.itemMeasurementsCache,
          [_.key]: j
        }, this.notify());
      }, i = [], c = {};
      for (let f = 0, m = r.length; f < m; f++) {
        var u;
        const b = r[f], j = {
          ...a[b],
          measureElement: c[b] = (u = this.measureElementCache[b]) != null ? u : o(b)
        };
        i.push(j);
      }
      return this.measureElementCache = c, i;
    }, {
      key: process.env.NODE_ENV !== "production" && "getIndexes",
      debug: () => this.options.debug
    }), this.scrollToOffset = function(r, a) {
      let {
        align: s = "start",
        smoothScroll: o = n.options.enableSmoothScroll
      } = a === void 0 ? {} : a;
      const i = n.scrollOffset, c = n.getSize();
      s === "auto" && (r <= i ? s = "start" : r >= i + c ? s = "end" : s = "start"), s === "start" ? n._scrollToOffset(r, o) : s === "end" ? n._scrollToOffset(r - c, o) : s === "center" && n._scrollToOffset(r - c / 2, o);
    }, this.scrollToIndex = function(r, a) {
      let {
        align: s = "auto",
        smoothScroll: o = n.options.enableSmoothScroll,
        ...i
      } = a === void 0 ? {} : a;
      const c = n.getMeasurements(), u = n.scrollOffset, f = n.getSize(), {
        count: m
      } = n.options, b = c[Math.max(0, Math.min(r, m - 1))];
      if (!b)
        return;
      if (s === "auto")
        if (b.end >= u + f - n.options.scrollPaddingEnd)
          s = "end";
        else if (b.start <= u + n.options.scrollPaddingStart)
          s = "start";
        else
          return;
      const _ = s === "end" ? b.end + n.options.scrollPaddingEnd : b.start - n.options.scrollPaddingStart;
      n.scrollToOffset(_, {
        align: s,
        smoothScroll: o,
        ...i
      });
    }, this.getTotalSize = () => {
      var r;
      return (((r = this.getMeasurements()[this.options.count - 1]) == null ? void 0 : r.end) || this.options.paddingStart) + this.options.paddingEnd;
    }, this._scrollToOffset = (r, a) => {
      clearTimeout(this.scrollCheckFrame), this.destinationOffset = r, this.options.scrollToFn(r, a, this);
      let s;
      const o = () => {
        let i = this.scrollOffset;
        this.scrollCheckFrame = s = setTimeout(() => {
          if (this.scrollCheckFrame === s) {
            if (this.scrollOffset === i) {
              this.destinationOffset = void 0;
              return;
            }
            i = this.scrollOffset, o();
          }
        }, 100);
      };
      o();
    }, this.measure = () => {
      this.itemMeasurementsCache = {}, this.notify();
    }, this.setOptions(t), this.scrollRect = this.options.initialRect, this.scrollOffset = this.options.initialOffset, this.calculateRange();
  }
}
const T5 = (e, t, n, r) => {
  for (; e <= t; ) {
    const a = (e + t) / 2 | 0, s = n(a);
    if (s < r)
      e = a + 1;
    else if (s > r)
      t = a - 1;
    else
      return a;
  }
  return e > 0 ? e - 1 : 0;
};
function R5(e) {
  let {
    measurements: t,
    outerSize: n,
    scrollOffset: r
  } = e;
  const a = t.length - 1, o = T5(0, a, (c) => t[c].start, r);
  let i = o;
  for (; i < a && t[i].end < r + n; )
    i++;
  return {
    startIndex: o,
    endIndex: i
  };
}
const O5 = typeof window < "u" ? d.useLayoutEffect : d.useEffect;
function M5(e) {
  const t = d.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (a) => {
      t(), e.onChange == null || e.onChange(a);
    }
  }, [r] = d.useState(() => new k5(n));
  return r.setOptions(n), d.useEffect(() => r._didMount(), []), O5(() => r._willUpdate()), r;
}
function A5(e) {
  return M5({
    observeElementRect: w5,
    observeElementOffset: E5,
    scrollToFn: S5,
    ...e
  });
}
var P5 = { neutral: "_8fcy9x2 _8fcy9x0 _1s8b37j25c _1s8b37j26q _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37j12v _1s8b37j80 _1s8b37jl3 _1s8b37jl5 _1s8b37j2vq _1s8b37j1 _1s8b37j29d _8fcy9x1 _1s8b37jcg _1s8b37jau", danger: "_8fcy9x4 _8fcy9x0 _1s8b37j25c _1s8b37j26q _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37j12v _1s8b37j80 _1s8b37jl3 _1s8b37jl5 _1s8b37j2vq _1s8b37j1 _1s8b37j29d _8fcy9x3 _1s8b37jb4 _1s8b37j4", warning: "_8fcy9x6 _8fcy9x0 _1s8b37j25c _1s8b37j26q _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37j12v _1s8b37j80 _1s8b37jl3 _1s8b37jl5 _1s8b37j2vq _1s8b37j1 _1s8b37j29d _8fcy9x5 _1s8b37jbg _1s8b37j7", success: "_8fcy9x8 _8fcy9x0 _1s8b37j25c _1s8b37j26q _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37j12v _1s8b37j80 _1s8b37jl3 _1s8b37jl5 _1s8b37j2vq _1s8b37j1 _1s8b37j29d _8fcy9x7 _1s8b37jbs _1s8b37ja" }, N5 = "_8fcy9x9", I8 = "_8fcy9xb _8fcy9xa _1s8b37j27u _1s8b37j23o _1s8b37j252 _1s8b37j26g _1s8b37jkl _1s8b37jkp _1s8b37jkt _1s8b37jkx _1s8b37j80 _1s8b37jl5 _1s8b37jl8 _1s8b37jyf _1s8b37jg _1s8b37jwm _1s8b37j2vq", Sl = "_8fcy9xc";
const D5 = "neutral", $8 = l.createContext({
  isDisabled: !1
}), I5 = () => l.useContext($8), xo = l.forwardRef(
  ({ appearance: e, children: t, className: n, isDisabled: r, ...a }, s) => {
    const o = ut();
    return /* @__PURE__ */ l.createElement($8.Provider, { value: { isDisabled: r } }, /* @__PURE__ */ l.createElement(
      re,
      {
        ...a,
        className: q(
          n,
          P5[o.appearance ?? e ?? D5],
          {
            [N5]: r
          }
        ),
        gap: "small",
        flexWrap: "nowrap",
        ref: s
      },
      t
    ));
  }
), kl = l.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(
    U.span,
    {
      ...n,
      className: q(t, Sl),
      ref: r
    },
    e
  )
), So = l.forwardRef(
  ({ className: e, ...t }, n) => {
    const r = ut(), a = I5();
    return /* @__PURE__ */ l.createElement(
      U.input,
      {
        ...t,
        ...r.labelFor ? { id: r.labelFor } : {
          "aria-labelledby": t["aria-labelledby"] || r.labelId
        },
        className: q(e, I8),
        ref: n,
        disabled: a.isDisabled,
        "aria-disabled": a.isDisabled,
        "aria-required": r.isRequired,
        "aria-describedby": t["aria-describedby"] || r.infoId
      }
    );
  }
), pr = l.forwardRef(
  ({ appearance: e, className: t, iconLeft: n, iconRight: r, isDisabled: a, ...s }, o) => /* @__PURE__ */ l.createElement(
    xo,
    {
      appearance: e,
      isDisabled: a,
      className: q(t)
    },
    n && /* @__PURE__ */ l.createElement(kl, { className: Sl }, n),
    /* @__PURE__ */ l.createElement(
      So,
      {
        ...s,
        className: I8,
        ref: o
      }
    ),
    r && /* @__PURE__ */ l.createElement(kl, { className: Sl }, r)
  )
), sn = "neutral", Tl = "__choose_option__", $5 = [" ", "Enter", "ArrowUp", "ArrowDown"], L5 = [" ", "Enter"], z5 = "Choose Option", L8 = 300, z8 = 200, F8 = 8;
var et = /* @__PURE__ */ ((e) => (e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.Tab = "Tab", e.Esc = "Escape", e.Space = " ", e))(et || {}), H8 = /* @__PURE__ */ ((e) => (e[e.neutral = 0] = "neutral", e[e.danger = 1] = "danger", e[e.warning = 2] = "warning", e))(H8 || {});
const ko = (e) => {
  let t = [];
  return e == null || e.forEach((n) => {
    const r = n.options;
    r ? t = t.concat(r) : t.push(n);
  }), t;
}, B8 = (e, t) => ko(t).find((n) => n.value === e), q8 = (e, t, n) => {
  const r = ko(t).filter(
    (s) => {
      var o;
      return ((o = s.text) == null ? void 0 : o.toLowerCase().indexOf(e.toLowerCase())) === 0;
    }
  ), a = r.findIndex(
    (s) => s.value === (n == null ? void 0 : n.value) && s.text === (n == null ? void 0 : n.text)
  );
  return a !== -1 ? a === r.length - 1 ? r[0] : r[a + 1] : r[0] || n;
}, U8 = (e, t) => {
  let n = -1, r = 0;
  for (let a = 0; a < t.length; a++) {
    const s = t[a];
    if (e.value === s.value && e.text === s.text) {
      n = a + r;
      break;
    }
    const o = s.options;
    if (o) {
      const i = o.findIndex(
        (c) => c.value === e.value && c.text === e.text
      );
      if (i !== -1) {
        n = a + i + r;
        break;
      }
      r += o.length - 1;
    }
  }
  return n;
}, W8 = (e, t, n, r) => {
  const a = e, s = a.height, o = a.top, i = window.innerHeight - (o + s) - 2 * r, c = {
    width: `${a.width}px`,
    bottom: "",
    maxHeight: "auto"
  };
  let u = !1;
  return i >= t ? c.maxHeight = `${Math.min(
    i,
    n,
    t
  )}px` : o > t || o > i ? (u = !0, c.bottom = `${s + r}px`, c.maxHeight = `${Math.min(
    o,
    n,
    t
  )}px`) : c.maxHeight = `${Math.min(
    i,
    n,
    t
  )}px`, [c, u];
};
var Pe = /* @__PURE__ */ ((e) => (e.FOCUS_FIRST = "FOCUS_FIRST", e.FOCUS_LAST = "FOCUS_LAST", e.MOVE_FOCUS = "MOVE_FOCUS", e.OPEN_CHANGE = "OPEN_CHANGE", e.VALUE_CHANGE = "VALUE_CHANGE", e.SET_SELECTION = "SET_SELECTION", e.CLEAR_SELECTION = "CLEAR_SELECTION", e.SET_FOCUSED_INDEX = "SET_FOCUSED_INDEX", e.SET_FOCUSED_OPTION = "SET_FOCUSED_OPTION", e.SET_CONTENT_REF = "SET_CONTENT_REF", e.SET_OPTIONS = "SET_OPTIONS", e.SET_DISABLED = "SET_DISABLED", e))(Pe || {});
function F5(e, t) {
  return {
    ...e,
    options: t.payload || []
  };
}
function H5(e, t) {
  return {
    ...e,
    value: t.payload ?? ""
  };
}
function B5(e, t) {
  var n, r;
  return {
    ...e,
    isOpen: !!((n = t.payload) != null && n.open),
    triggerPosition: ((r = t.payload) == null ? void 0 : r.triggerPosition) || e.triggerPosition
  };
}
function q5(e) {
  return {
    ...e,
    selectedOption: void 0
  };
}
function U5(e, t) {
  return {
    ...e,
    selectedOption: t.payload
  };
}
function W5(e, t) {
  return t.payload ? {
    ...e,
    contentRef: t.payload
  } : e;
}
function V5(e, t) {
  return {
    ...e,
    focusedItemIdx: t.payload
  };
}
function Y5(e, t) {
  return {
    ...e,
    focusedOption: t.payload
  };
}
function ma(e) {
  return {
    ...e,
    focusedItemIdx: 0
  };
}
function Rl(e) {
  if (!e.options)
    return e;
  const n = ko(e.options).length + (e.isClearable ? 1 : 0);
  return {
    ...e,
    focusedItemIdx: n - 1
  };
}
function G5(e, t) {
  const n = t.payload, r = e.focusedItemIdx, a = ko(e.options), s = (a == null ? void 0 : a.length) + (e.isClearable ? 1 : 0);
  if (!s)
    return e;
  if (r === void 0 && n === et.ArrowUp)
    return Rl(e);
  if (r === void 0 && n === et.ArrowDown)
    return ma(e);
  if (r !== void 0 && n === et.ArrowUp) {
    const o = r - 1;
    return o < 0 ? Rl(e) : {
      ...e,
      focusedItemIdx: o
    };
  } else if (r !== void 0 && n === et.ArrowDown) {
    const o = r + 1;
    return o === s ? ma(e) : {
      ...e,
      focusedItemIdx: o
    };
  }
  return e;
}
function K5(e, t) {
  return {
    ...e,
    disabled: t.payload
  };
}
function V8(e, t) {
  switch (t.type) {
    case "CLEAR_SELECTION":
      return q5(e);
    case "FOCUS_FIRST":
      return ma(e);
    case "FOCUS_LAST":
      return Rl(e);
    case "MOVE_FOCUS":
      return G5(e, t);
    case "OPEN_CHANGE":
      return B5(e, t);
    case "VALUE_CHANGE":
      return H5(e, t);
    case "SET_CONTENT_REF":
      return W5(e, t);
    case "SET_FOCUSED_INDEX":
      return V5(e, t);
    case "SET_FOCUSED_OPTION":
      return Y5(e, t);
    case "SET_OPTIONS":
      return F5(e, t);
    case "SET_SELECTION":
      return U5(e, t);
    case "SET_DISABLED":
      return K5(e, t);
  }
}
var X5 = "_1ifnag51 _1ifnag50 _1s8b37j29d _1s8b37j2vq", Z5 = 4, J5 = 1, Q5 = "_1ifnag54 _1ifnag53 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37jcs _1s8b37jl3 _1s8b37jl5 _1s8b37j80 _1s8b37jjz _1s8b37jli _1s8b37j293 _1s8b37j1mq", ex = "_1ifnag55", bd = "_1ifnag58 _1s8b37jo", md = { danger: "_1ifnag5c _1ifnag5a _1ifnag59 _1s8b37jg _1ifnag5b _1s8b37j14", warning: "_1ifnag5e _1ifnag5a _1ifnag59 _1s8b37jg _1ifnag5d _1s8b37j1g", neutral: "_1ifnag5g _1ifnag5a _1ifnag59 _1s8b37jg _1ifnag5f" }, tx = { danger: "_1ifnag5i _1ifnag57 _1ifnag56 _1s8b37j284 _1s8b37j23y _1s8b37j25c _1s8b37j26q _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37jl3 _1s8b37jl5 _1s8b37j12v _1s8b37jl8 _1s8b37jyf _1s8b37j2vq _1s8b37jm1 _1s8b37jlh _1ifnag5h _1s8b37j80 _1s8b37j69 _1s8b37jb4 _1s8b37jba _1s8b37j3", warning: "_1ifnag5k _1ifnag57 _1ifnag56 _1s8b37j284 _1s8b37j23y _1s8b37j25c _1s8b37j26q _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37jl3 _1s8b37jl5 _1s8b37j12v _1s8b37jl8 _1s8b37jyf _1s8b37j2vq _1s8b37jm1 _1s8b37jlh _1ifnag5j _1s8b37j80 _1s8b37j6p _1s8b37jbg _1s8b37jbm _1s8b37j6", neutral: "_1ifnag5m _1ifnag57 _1ifnag56 _1s8b37j284 _1s8b37j23y _1s8b37j25c _1s8b37j26q _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37jl3 _1s8b37jl5 _1s8b37j12v _1s8b37jl8 _1s8b37jyf _1s8b37j2vq _1s8b37jm1 _1s8b37jlh _1ifnag5l _1s8b37j80 _1s8b37j8h _1s8b37jcg _1s8b37jau _1s8b37j0" }, nx = "_1ifnag5n", rx = { warning: "_1ifnag5q _1ifnag5p _1ifnag5o _1s8b37j25w _1s8b37j270 _1s8b37j289 _1s8b37j243 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37j80 _1s8b37j8h _1s8b37j8i _1s8b37jl5 _1s8b37j130 _1s8b37j29d _1s8b37jg _1s8b37jya _1s8b37j2vq _1s8b37jly", danger: "_1ifnag5r _1ifnag5p _1ifnag5o _1s8b37j25w _1s8b37j270 _1s8b37j289 _1s8b37j243 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37j80 _1s8b37j8h _1s8b37j8i _1s8b37jl5 _1s8b37j130 _1s8b37j29d _1s8b37jg _1s8b37jya _1s8b37j2vq _1s8b37jly", neutral: "_1ifnag5s _1ifnag5p _1ifnag5o _1s8b37j25w _1s8b37j270 _1s8b37j289 _1s8b37j243 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37j80 _1s8b37j8h _1s8b37j8i _1s8b37jl5 _1s8b37j130 _1s8b37j29d _1s8b37jg _1s8b37jya _1s8b37j2vq _1s8b37jly" }, _d = { warning: "_1ifnag5t", danger: "_1ifnag5u", neutral: "_1ifnag5v" }, pd = "_1ifnag5w", ax = "_1ifnag5y _1ifnag5x _1s8b37jvn _1s8b37jmh _1s8b37j199 _1s8b37j293 _1s8b37j1bh", sx = "_1ifnag5z", jd = "_1ifnag511 _1ifnag510 _1s8b37j2g", ox = { danger: "_1ifnag514 _1ifnag512 _1ifnag513 _1s8b37j14", warning: "_1ifnag516 _1ifnag512 _1ifnag515 _1s8b37j1g", neutral: "_1ifnag518 _1ifnag512 _1ifnag517 _1s8b37j24" }, ix = "_1ifnag519 _1s8b37j289 _1s8b37j243 _1s8b37j25h _1s8b37j26v _1s8b37jy5 _1s8b37jlc _1s8b37jlr", lx = "_1ifnag51b", cx = "_1ifnag51d";
const Y8 = {
  options: [],
  triggerPosition: {
    top: 0,
    bottom: 0,
    width: 0,
    height: 0
  }
}, G8 = l.createContext(Y8), jr = () => l.useContext(G8), K8 = ({
  appearance: e = sn,
  disabled: t = !1,
  children: n,
  isClearable: r = !0,
  isOpen: a,
  placeholder: s = z5,
  options: o,
  onOpenChange: i,
  onValueChange: c,
  onSelection: u,
  onChange: f,
  value: m,
  truncateWidth: b
}) => {
  const _ = kt("rtk-select-option"), j = ut(), p = {
    ...Y8,
    appearance: j.appearance || e,
    disabled: t,
    isClearable: r,
    options: o,
    placeholder: s,
    optionsIdPrefix: _,
    isOpen: a || void 0,
    value: m,
    truncateWidth: b
  }, [v, h] = l.useReducer(V8, p);
  return le(() => {
    if (m === void 0)
      return;
    h({
      type: Pe.VALUE_CHANGE,
      payload: m
    });
    const g = B8(m, o);
    h({
      type: Pe.SET_SELECTION,
      payload: g
    });
  }, [m, o]), le(() => {
    h({
      type: Pe.SET_OPTIONS,
      payload: o
    });
  }, [o]), le(() => {
    h({
      type: Pe.SET_DISABLED,
      payload: t
    });
  }, [t]), /* @__PURE__ */ l.createElement(
    G8.Provider,
    {
      value: {
        state: v,
        dispatch: h,
        onValueChange: c,
        onOpenChange: i,
        onSelection: u,
        onChange: f
      }
    },
    /* @__PURE__ */ l.createElement("div", { className: X5 }, n)
  );
}, ux = l.forwardRef(({ className: e, onKeyDown: t, onPointerUp: n, ...r }, a) => {
  var D;
  const s = ut(), { state: o, dispatch: i, onOpenChange: c, onValueChange: u, onChange: f, onSelection: m } = jr(), {
    isOpen: b,
    options: _,
    appearance: j,
    disabled: p,
    selectedOption: v,
    placeholder: h,
    value: g,
    triggerPosition: w,
    focusedItemIdx: x,
    contentRef: y
  } = o, E = l.useRef(null), C = We([E, a]), S = l.useCallback(
    (I) => {
      if (!(E != null && E.current))
        return;
      const F = E.current.parentElement || E.current, P = F == null ? void 0 : F.getBoundingClientRect();
      i({
        type: Pe.OPEN_CHANGE,
        payload: {
          open: I,
          triggerPosition: I ? {
            top: P.top,
            bottom: P.bottom,
            width: P.width,
            height: P.height
          } : void 0
        }
      }), I && !x && i({
        type: Pe.FOCUS_FIRST
      }), I !== b && (c == null || c(I));
    },
    [b]
  ), k = l.useCallback(
    (I) => {
      if (o.disabled)
        return;
      if (!b) {
        S(!0), i({
          type: Pe.FOCUS_FIRST
        });
        return;
      }
      const F = I === et.ArrowUp ? I : et.ArrowDown;
      i({
        type: Pe.MOVE_FOCUS,
        payload: F
      });
    },
    [p, b]
  ), [O, L] = de(), [H, T] = de(""), R = l.useCallback(
    (I) => {
      if (o.disabled && I.key !== et.Tab) {
        I.preventDefault();
        return;
      }
      if (I.key === et.Esc) {
        i({
          type: Pe.VALUE_CHANGE,
          payload: g
        }), S(!1);
        return;
      }
      if ($5.includes(I.key) || I.key === et.ArrowDown || I.key === et.ArrowUp) {
        k(I.key), I.preventDefault();
        return;
      }
      O && clearTimeout(O);
      const F = H.concat(I.key);
      T(F);
      const P = setTimeout(
        () => {
          T("");
          const A = q8(F, _, v);
          A && (i({
            type: Pe.SET_SELECTION,
            payload: A
          }), u == null || u(A.value), f == null || f(A.value), m == null || m(A));
        },
        O ? L8 : 0
      );
      L(P);
    },
    [O, H, v, b]
  );
  le(() => {
    var F;
    if (b === void 0)
      return;
    b ? w != null && w.width || S(!0) : (F = E.current) == null || F.focus();
    const I = () => i({
      type: Pe.OPEN_CHANGE,
      payload: {
        open: !1
      }
    });
    return window.addEventListener("blur", I), window.addEventListener("resize", I), o.isOpen ? Xr() : oc(), () => {
      window.removeEventListener("blur", I), window.removeEventListener("resize", I);
    };
  }, [b]);
  const M = (D = y == null ? void 0 : y.current) == null ? void 0 : D.id;
  return /* @__PURE__ */ l.createElement(re, { asChild: !0, xAlign: "between", yAlign: "center" }, /* @__PURE__ */ l.createElement(
    "div",
    {
      ...r,
      ref: C,
      role: "combobox",
      "aria-disabled": p,
      "aria-required": s.isRequired,
      "aria-labelledby": r["aria-labelledby"] || s.labelId,
      "aria-describedby": r["aria-describedby"] || s.infoId,
      "aria-controls": M,
      "aria-expanded": b,
      tabIndex: 0,
      className: q([
        e,
        tx[j || sn],
        v ? md : bd
      ]),
      "data-appearance": j,
      onPointerUp: Xe(n, (I) => {
        if (o.disabled) {
          I.preventDefault();
          return;
        }
        S(!b), c == null || c(!b);
      }),
      onKeyDown: Xe(t, R)
    },
    /* @__PURE__ */ l.createElement(
      "span",
      {
        className: q(
          {
            [md[j || sn]]: v,
            [bd]: !v
          },
          nx
        )
      },
      (v == null ? void 0 : v.text) || h
    ),
    l.useMemo(
      () => b ? /* @__PURE__ */ l.createElement(ic, { className: q(jd, cx) }) : /* @__PURE__ */ l.createElement(lc, { className: q(jd, lx) }),
      [b]
    )
  ));
}), dx = l.forwardRef(
  ({
    children: e,
    className: t,
    maxContentHeight: n = 300,
    contentTriggerMargin: r = 4,
    ...a
  }, s) => {
    const { state: o, dispatch: i } = jr(), [c, u] = de(!1), {
      isOpen: f,
      triggerPosition: m,
      options: b,
      optionsIdPrefix: _,
      isClearable: j,
      focusedItemIdx: p
    } = o, v = l.useRef(null), h = l.useRef(null), g = We([v, s]), w = kt("rtk-select-content"), [x, y] = de({
      ...m,
      maxHeight: "auto"
    });
    le(() => {
      v && i({
        type: Pe.SET_CONTENT_REF,
        payload: v
      });
    }, [v == null ? void 0 : v.current]), le(() => {
      if (!f || !m || !h.current)
        return;
      const S = h.current, k = (S == null ? void 0 : S.getBoundingClientRect().height) + 2 * (Z5 + J5), [O] = W8(
        m,
        k,
        n,
        r
      );
      y(O);
    }, [m, v == null ? void 0 : v.current, f]);
    const E = l.useMemo(() => {
      let S = 0;
      const k = j ? 1 : 0;
      return b == null ? void 0 : b.map((O, L) => {
        const H = O.options;
        if (H) {
          const R = H.map((D, I) => {
            const F = L + I + S + k;
            return /* @__PURE__ */ l.createElement(
              Ol,
              {
                key: `${D.value}_${D.text}`,
                index: F,
                id: `${_}${F}`,
                icon: D.icon,
                value: D.value,
                text: D.text,
                isDisabled: D.isDisabled
              }
            );
          });
          S += H.length - 1;
          const M = O.label;
          return /* @__PURE__ */ l.createElement(Z8, { key: `${M}_${L}` }, /* @__PURE__ */ l.createElement(J8, null, M), R);
        }
        const T = O;
        return /* @__PURE__ */ l.createElement(
          Ol,
          {
            key: `${T.value}_${T.text}`,
            index: L + S + k,
            id: `${_}${L + S + k}`,
            value: T.value,
            text: T.text,
            icon: T.icon,
            isDisabled: T.isDisabled
          }
        );
      });
    }, [b]);
    le(() => {
      f || u(!1);
    }, [f]), le(() => {
      var S, k;
      if (!c) {
        if (p === 0) {
          (S = v.current) == null || S.scroll(0, 0);
          return;
        }
        (k = document.querySelector(`[id=${_}${p}]`)) == null || k.scrollIntoView({
          block: "nearest"
        });
      }
    }, [p]);
    const C = l.useMemo(
      () => /* @__PURE__ */ l.createElement(
        "div",
        {
          role: "listbox",
          id: w,
          ref: g,
          className: q([
            t,
            Q5,
            { [ex]: !!x.maxHeight }
          ]),
          style: {
            ...x,
            width: "max-content",
            minWidth: z8 + F8
          },
          onMouseOver: () => u(!0),
          onMouseLeave: () => u(!1),
          ...a,
          onMouseDown: (S) => {
            S.stopPropagation(), S.preventDefault();
          }
        },
        /* @__PURE__ */ l.createElement("div", { ref: h }, j && /* @__PURE__ */ l.createElement(fx, { id: `${_}0`, index: 0 }), e || E)
      ),
      [x, E, m, v == null ? void 0 : v.current]
    );
    return f ? C : null;
  }
), Vs = l.forwardRef(({ appearance: e, className: t, children: n, ...r }, a) => {
  const s = jr().state.appearance, o = e || s, i = l.useMemo(() => {
    switch (o) {
      case "danger":
        return /* @__PURE__ */ l.createElement(tb, null);
      case "warning":
        return /* @__PURE__ */ l.createElement(eb, null);
    }
  }, [o]);
  return /* @__PURE__ */ l.createElement(
    U.div,
    {
      ...r,
      className: q([
        t,
        ox[o || sn]
      ]),
      ref: a
    },
    n || i
  );
}), Ol = l.forwardRef(
  ({ children: e, className: t, icon: n, id: r, index: a, value: s, isDisabled: o, text: i, ...c }, u) => {
    const f = Te(null), m = We([u, f]), {
      appearance: b,
      selectedOption: _,
      focusedOption: j,
      focusedItemIdx: p,
      contentRef: v,
      optionsIdPrefix: h,
      options: g,
      isClearable: w,
      truncateWidth: x
    } = jr().state, { dispatch: y, onValueChange: E, onOpenChange: C, onSelection: S, onChange: k } = jr(), O = l.useCallback(() => {
      if (!o) {
        const $ = s === Tl ? "" : s;
        if (y({
          type: Pe.VALUE_CHANGE,
          payload: $
        }), y({
          type: Pe.OPEN_CHANGE,
          payload: {
            open: !1
          }
        }), E == null || E($), k == null || k($), C == null || C(!1), !$) {
          y({
            type: Pe.CLEAR_SELECTION
          }), S == null || S(null);
          return;
        }
        const B = {
          value: $,
          text: i
        };
        y({
          type: Pe.SET_SELECTION,
          payload: B
        }), S == null || S(B);
      }
    }, [i, s]), L = l.useMemo(() => (_ == null ? void 0 : _.value) === s || !_ && s === Tl, [_, s]), H = l.useMemo(
      () => `${h}${p}` === r,
      [p, h, r]
    );
    le(() => {
      L && !p && y({
        type: Pe.SET_FOCUSED_INDEX,
        payload: a
      });
    }, [L]), le(() => {
      var $;
      H && (($ = f.current) == null || $.focus(), y({
        type: Pe.SET_FOCUSED_OPTION,
        payload: {
          value: s,
          text: i
        }
      }));
    }, [H]);
    const T = l.useCallback(() => {
      y({
        type: Pe.SET_FOCUSED_INDEX,
        payload: a
      }), y({
        type: Pe.SET_FOCUSED_OPTION,
        payload: {
          value: s,
          text: i
        }
      });
    }, [r]), R = l.useMemo(() => n ? n === "default" ? /* @__PURE__ */ l.createElement(Vs, null) : /* @__PURE__ */ l.createElement(Vs, null, n) : null, [n]), M = l.useCallback(
      ($) => {
        var J;
        const B = v == null ? void 0 : v.current;
        $.relatedTarget && ((B == null ? void 0 : B.contains($.relatedTarget)) || $.relatedTarget.getAttribute("aria-controls") === ((J = v.current) == null ? void 0 : J.id)) || (y({
          type: Pe.OPEN_CHANGE,
          payload: {
            open: !1
          }
        }), C == null || C(!1));
      },
      [v, s]
    ), [D, I] = de(), [F, P] = de(""), A = l.useCallback(
      ($) => {
        if ($.key === et.Tab) {
          $.preventDefault();
          return;
        }
        if ($.key === et.Esc) {
          y({
            type: Pe.OPEN_CHANGE,
            payload: {
              open: !1
            }
          }), C == null || C(!1);
          return;
        }
        if ($.key === et.ArrowDown || $.key === et.ArrowUp) {
          $.preventDefault(), y({
            type: Pe.MOVE_FOCUS,
            payload: $.key
          });
          return;
        }
        if (L5.includes($.key)) {
          O();
          return;
        }
        D && clearTimeout(D);
        const B = F.concat($.key);
        P(B);
        const Y = setTimeout(
          () => {
            P("");
            const J = q8(B, g, j);
            J && y({
              type: Pe.SET_FOCUSED_INDEX,
              payload: U8(J, g) + (w ? 1 : 0)
            });
          },
          D ? L8 : 0
        );
        I(Y);
      },
      [D, F, j]
    );
    return /* @__PURE__ */ l.createElement(
      re,
      {
        ref: m,
        xAlign: "between",
        className: q([
          t,
          rx[b || sn]
        ]),
        role: "option",
        id: r,
        "data-index": a,
        "data-focused": H,
        "aria-selected": L,
        "aria-disabled": o || void 0,
        tabIndex: -1,
        onBlur: M,
        onMouseOver: Xe(c.onMouseOver, T),
        onPointerDown: Xe(
          c.onPointerUp,
          ($) => {
            $.preventDefault();
          }
        ),
        onPointerUp: Xe(c.onPointerUp, O),
        onKeyDown: Xe(c.onKeyDown, A),
        ...c
      },
      /* @__PURE__ */ l.createElement(Ml, { isSelected: L }),
      x ? /* @__PURE__ */ l.createElement(_t.Root, null, /* @__PURE__ */ l.createElement(_t.Trigger, { asChild: !0 }, /* @__PURE__ */ l.createElement(
        ne,
        {
          styledAs: "body3",
          ...L && {
            className: _d[b || sn]
          },
          ...o && { className: pd },
          style: { maxWidth: x },
          truncate: !!x
        },
        e || i
      )), /* @__PURE__ */ l.createElement(_t.Content, null, /* @__PURE__ */ l.createElement(_t.Text, null, i))) : /* @__PURE__ */ l.createElement(
        ne,
        {
          styledAs: "body3",
          ...L && {
            className: _d[b || sn]
          },
          ...o && { className: pd }
        },
        e || i
      ),
      R
    );
  }
), Ml = l.forwardRef(({ className: e, isSelected: t, ...n }, r) => t ? /* @__PURE__ */ l.createElement(
  "div",
  {
    ...n,
    ref: r,
    className: q([e, ax])
  },
  /* @__PURE__ */ l.createElement(ha, { className: sx })
) : null), fx = ({ id: e, index: t }) => {
  const { value: n, placeholder: r } = jr().state;
  return l.useMemo(
    () => /* @__PURE__ */ l.createElement(
      Ol,
      {
        id: e,
        index: t,
        value: Tl,
        text: r
      },
      r
    ),
    [e, t, n, r]
  );
}, X8 = l.createContext(
  {}
), bx = () => l.useContext(X8), Z8 = l.forwardRef(
  ({ children: e, ...t }, n) => {
    const r = kt("rtk-select-group"), a = {
      id: r
    }, s = l.useRef(null), o = We([s, n]);
    return /* @__PURE__ */ l.createElement(X8.Provider, { value: a }, /* @__PURE__ */ l.createElement("div", { role: "group", "aria-labelledby": r, ref: o, ...t }, e));
  }
), J8 = l.forwardRef(({ children: e, className: t }, n) => {
  const { id: r } = bx();
  return /* @__PURE__ */ l.createElement(ne, { asChild: !0, styledAs: "body5" }, /* @__PURE__ */ l.createElement(
    "div",
    {
      id: r,
      className: q([t, ix]),
      ref: n
    },
    e
  ));
}), Q8 = l.forwardRef(
  ({
    options: e,
    appearance: t = sn,
    disabled: n = !1,
    children: r,
    value: a,
    isClearable: s = !0,
    isOpen: o,
    placeholder: i,
    id: c,
    onSelection: u,
    onValueChange: f,
    onOpenChange: m,
    onChange: b,
    truncateWidth: _
  }, j) => {
    const p = l.useRef(null), v = We([p, j]), h = l.useId();
    return /* @__PURE__ */ l.createElement(
      K8,
      {
        isOpen: o,
        options: e,
        isClearable: s,
        placeholder: i,
        appearance: t,
        value: a,
        disabled: n,
        onSelection: u,
        onOpenChange: m,
        onChange: b,
        onValueChange: f,
        key: `${h}-${t}`,
        truncateWidth: _
      },
      /* @__PURE__ */ l.createElement(ux, { ref: v, id: c }),
      /* @__PURE__ */ l.createElement(dx, null, r)
    );
  }
), Ys = "neutral", mu = "__create_option__", e7 = "Type to search...", mx = "Create", _x = "Loading results...", px = ["Enter"], t7 = 300, jx = 150, vx = 0, vd = 200, hd = 8, hx = H8;
var ht = /* @__PURE__ */ ((e) => (e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.Tab = "Tab", e.Esc = "Escape", e.Space = " ", e.Enter = "Enter", e))(ht || {});
const gd = (e) => {
  let t = 0;
  return e.forEach((n) => {
    n.options ? t += n.options.length : t++;
  }), t;
}, gx = U8, yx = (e, t) => {
  if (!t)
    return [!0, !1];
  const n = e.text.toLowerCase().trim(), r = e.value.toLowerCase().trim(), a = t.toLowerCase().trim();
  return [
    n.indexOf(a) !== -1 || r.indexOf(a) !== -1,
    n === a || r === a
  ];
}, wx = (e, t, n, r) => W8(
  e,
  t,
  n,
  r
);
var ve = /* @__PURE__ */ ((e) => (e.FOCUS_FIRST = "FOCUS_FIRST", e.FOCUS_LAST = "FOCUS_LAST", e.MOVE_FOCUS = "MOVE_FOCUS", e.OPEN_CHANGE = "OPEN_CHANGE", e.VALUE_CHANGE = "VALUE_CHANGE", e.SELECT_FOCUSED = "SELECT_FOCUSED", e.SET_SELECTION = "SET_SELECTION", e.CLEAR_SELECTION = "CLEAR_SELECTION", e.SET_FOCUSED_INDEX = "SET_FOCUSED_INDEX", e.SET_FOCUSED_OPTION = "SET_FOCUSED_OPTION", e.SET_CONTENT_REF = "SET_CONTENT_REF", e.SET_HAS_EXACT_MATCH = "SET_HAS_EXACT_MATCH", e.SET_NUM_MATCHES = "SET_NUM_MATCHES", e.SET_BYPASS_FILTER = "SET_BYPASS_FILTER", e.SET_LOADING = "SET_LOADING", e.SET_LOADING_MESSAGE = "SET_LOADING_MESSAGE", e.SET_OPTIONS = "SET_OPTIONS", e.SET_CREATE_VISIBLE = "SET_CREATE_VISIBLE", e.SET_DISABLED = "SET_DISABLED", e))(ve || {});
function Cx(e, t) {
  return {
    ...e,
    isLoading: t.payload
  };
}
function Ex(e, t) {
  return {
    ...e,
    disabled: t.payload
  };
}
function xx(e, t) {
  return {
    ...e,
    loadingMessage: t.payload
  };
}
function Sx(e, t) {
  return {
    ...e,
    createVisible: !!t.payload
  };
}
function kx(e, t) {
  return {
    ...e,
    numMatches: t.payload || 0
  };
}
function Tx(e, t) {
  return {
    ...e,
    hasExactMatch: t.payload
  };
}
function Rx(e) {
  if (e.focusedItemIdx === void 0)
    return e;
  const n = (e.createVisible ? e.focusedItemIdx - 1 : e.focusedItemIdx) < 0 ? {
    value: e.value ?? "",
    text: e.value ?? ""
  } : e.focusedOption;
  return n ? {
    ...e,
    value: n.value,
    selectedOption: n
  } : e;
}
function Ox(e, t) {
  return {
    ...e,
    bypassFilter: !!t.payload
  };
}
function Al(e) {
  if (!e.numMatches)
    return e;
  const t = e.numMatches + (e.createVisible ? 1 : 0);
  return {
    ...e,
    focusedItemIdx: t - 1
  };
}
function Mx(e, t) {
  const n = t.payload, r = e.focusedItemIdx, a = e.numMatches + (e.createVisible ? 1 : 0);
  if (!a)
    return e;
  if (r === void 0 && n === ht.ArrowUp)
    return Al(e);
  if (r === void 0 && n === ht.ArrowDown)
    return {
      ...e,
      focusedItemIdx: ma(e).focusedItemIdx
    };
  if (r !== void 0 && n === ht.ArrowUp) {
    const s = r - 1;
    return s < 0 ? Al(e) : {
      ...e,
      focusedItemIdx: s
    };
  } else if (r !== void 0 && n === ht.ArrowDown) {
    const s = r + 1;
    return s === a ? {
      ...e,
      focusedItemIdx: ma(e).focusedItemIdx
    } : {
      ...e,
      focusedItemIdx: s
    };
  }
  return e;
}
function Ax(e, t) {
  switch (t.type) {
    case "FOCUS_LAST":
      return Al(e);
    case "MOVE_FOCUS":
      return Mx(e, t);
    case "SELECT_FOCUSED":
      return Rx(e);
    case "SET_HAS_EXACT_MATCH":
      return Tx(e, t);
    case "SET_NUM_MATCHES":
      return kx(e, t);
    case "SET_BYPASS_FILTER":
      return Ox(e, t);
    case "SET_LOADING":
      return Cx(e, t);
    case "SET_LOADING_MESSAGE":
      return xx(e, t);
    case "SET_CREATE_VISIBLE":
      return Sx(e, t);
    case "SET_DISABLED":
      return Ex(e, t);
    default:
      return Object.assign(
        {},
        e,
        V8(e, t)
      );
  }
}
var Px = "v2mthg0 _1s8b37j29d", Nx = "v2mthg1", Dx = 4, Ix = "v2mthg4 v2mthg3 _1s8b37j29d _1s8b37jli", $x = "v2mthg6 v2mthg5 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37jcs _1s8b37jl3 _1s8b37j80 _1s8b37jjz _1s8b37jlh _1s8b37j293 _1s8b37j1mq", Lx = "v2mthg7", zx = "v2mthg9 v2mthg8 _1s8b37jli", Pl = "v2mthgb v2mthga _1s8b37j2g", yi = "v2mthgc _1s8b37j1mq _1s8b37j1ik _1s8b37j1jy _1s8b37j1lc _1s8b37j293 _1s8b37j1b2 _1s8b37j29s", yd = 4, wd = { warning: "v2mthgf v2mthge v2mthgd _1s8b37j289 _1s8b37j243 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jl5 _1s8b37j80 _1s8b37j8h _1s8b37j8i _1s8b37j130 _1s8b37j270 _1s8b37j25w _1s8b37j29d _1s8b37jg _1s8b37jya _1s8b37j2vq _1s8b37jly", danger: "v2mthgg v2mthge v2mthgd _1s8b37j289 _1s8b37j243 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jl5 _1s8b37j80 _1s8b37j8h _1s8b37j8i _1s8b37j130 _1s8b37j270 _1s8b37j25w _1s8b37j29d _1s8b37jg _1s8b37jya _1s8b37j2vq _1s8b37jly", neutral: "v2mthgh v2mthge v2mthgd _1s8b37j289 _1s8b37j243 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jl5 _1s8b37j80 _1s8b37j8h _1s8b37j8i _1s8b37j130 _1s8b37j270 _1s8b37j25w _1s8b37j29d _1s8b37jg _1s8b37jya _1s8b37j2vq _1s8b37jly" }, Fx = "v2mthgi", Hx = "v2mthgj", Bx = 40, qx = "v2mthgl v2mthgk _1s8b37j25h _1s8b37j26v _1s8b37jy5 _1s8b37jg _1s8b37j2vq _1s8b37jjz _1s8b37jm7", Cd = "v2mthgm", Ed = "v2mthgo v2mthgn _1s8b37j2g", Ux = "v2mthgq", Wx = "v2mthgs";
const n7 = {
  isOpen: !1,
  disabled: !1,
  isCreatable: !0,
  placeholder: e7,
  triggerPosition: {
    top: 0,
    width: 0,
    height: 0
  },
  value: "",
  delay: t7
}, r7 = l.createContext(n7), To = () => l.useContext(r7), Vx = ({
  appearance: e = Ys,
  disabled: t = !1,
  delay: n = t7,
  createLabel: r = mx,
  isCreatable: a = !0,
  children: s,
  isLoading: o,
  loadingMessage: i,
  placeholder: c = e7,
  onOpenChange: u,
  onValueChange: f,
  onSelection: m,
  minSearch: b = vx,
  filter: _,
  value: j,
  options: p
}) => {
  const v = ut(), h = kt("rtk-combobox-option");
  let g = v.appearance || e;
  Object.keys(hx).includes(g) || (g = Ys);
  const w = B8(j ?? "", p), x = {
    ...n7,
    appearance: g,
    delay: n,
    disabled: t,
    isCreatable: a,
    isLoading: o,
    loadingMessage: i,
    placeholder: c,
    triggerPosition: {
      top: 0,
      bottom: 0,
      left: 0,
      width: 0,
      height: 0
    },
    minSearch: b,
    contentRef: null,
    createLabel: r,
    value: (w == null ? void 0 : w.text) ?? j ?? "",
    options: p,
    optionsIdPrefix: h,
    selectedOption: w
  };
  _ === "default" ? x.filter = yx : typeof _ == "function" && (x.filter = _);
  const [y, E] = l.useReducer(Ax, x);
  return le(() => {
    E({
      type: ve.VALUE_CHANGE,
      payload: j
    }), (j === void 0 || j === "") && E({
      type: ve.CLEAR_SELECTION
    });
  }, [j]), le(() => {
    E({
      type: ve.SET_DISABLED,
      payload: t
    });
  }, [t]), le(() => {
    E({
      type: ve.SET_LOADING,
      payload: o
    });
  }, [o]), le(() => {
    E({
      type: ve.SET_LOADING_MESSAGE,
      payload: i
    });
  }, [i]), le(() => {
    E({
      type: ve.SET_OPTIONS,
      payload: p
    });
  }, [p]), /* @__PURE__ */ l.createElement(
    r7.Provider,
    {
      value: {
        state: y,
        dispatch: E,
        onValueChange: f,
        onOpenChange: u,
        onSelection: m
      }
    },
    /* @__PURE__ */ l.createElement(K8, { options: p, appearance: e }, /* @__PURE__ */ l.createElement("div", { className: Px }, s))
  );
}, Yx = l.forwardRef(({ className: e, iconRight: t, onKeyDown: n }, r) => {
  var L, H;
  const { state: a, onOpenChange: s, onValueChange: o, onSelection: i, dispatch: c } = To(), u = l.useRef(null), f = We([u, r]);
  le(() => {
    const T = () => c({
      type: ve.OPEN_CHANGE,
      payload: {
        open: !1
      }
    });
    return window.addEventListener("blur", T), window.addEventListener("resize", T), a.isOpen ? Xr() : oc(), () => {
      window.removeEventListener("blur", T), window.removeEventListener("resize", T);
    };
  }, [a == null ? void 0 : a.isOpen]);
  const m = l.useCallback(
    (T) => {
      var F;
      if (!(u != null && u.current))
        return;
      const R = u.current.parentElement || u.current, M = R == null ? void 0 : R.getBoundingClientRect(), D = ((F = a.value) == null ? void 0 : F.length) || 0, I = T !== void 0 ? T : !a.isOpen && D >= a.minSearch;
      c({
        type: ve.OPEN_CHANGE,
        payload: {
          open: I,
          triggerPosition: I ? {
            top: M.top,
            bottom: M.bottom,
            left: M.left,
            width: M.width,
            height: M.height
          } : void 0
        }
      }), I !== a.isOpen && (s == null || s(I));
    },
    [a.isOpen, a.value, u, s]
  ), b = l.useCallback(
    (T) => {
      a.disabled || (T === ht.ArrowDown || T === ht.ArrowUp) && (a.isOpen || m(), c({
        type: ve.MOVE_FOCUS,
        payload: T
      }));
    },
    [a.disabled, a.isOpen]
  ), _ = l.useCallback(() => {
    !a.disabled && a.focusedItemIdx !== void 0 && (c({
      type: ve.SELECT_FOCUSED
    }), c({
      type: ve.SET_HAS_EXACT_MATCH,
      payload: !0
    }), m(!1));
  }, [a.disabled, a.focusedItemIdx]), [j, p] = de(), [v, h] = de(a.value), g = l.useCallback(
    (T) => {
      const R = T.target.value;
      h(R), j && clearTimeout(j);
      const M = setTimeout(
        () => {
          c({
            type: ve.SET_BYPASS_FILTER,
            payload: !1
          }), c({
            type: ve.SET_HAS_EXACT_MATCH,
            payload: !1
          }), c({
            type: ve.VALUE_CHANGE,
            payload: R
          }), o == null || o(R);
          const D = (R == null ? void 0 : R.trim().length) >= a.minSearch;
          m(D), R.trim() || (c({
            type: ve.CLEAR_SELECTION
          }), i == null || i(null));
        },
        j ? a.delay : 0
      );
      p(M);
    },
    [a.isOpen, j]
  ), w = l.useCallback(() => {
    var T;
    j && clearTimeout(j), c({
      type: ve.VALUE_CHANGE,
      payload: v
    }), (!v || ((T = a.selectedOption) == null ? void 0 : T.text) !== v) && c({
      type: ve.CLEAR_SELECTION
    });
  }, [j, v, a.selectedOption]), x = u.current, y = l.useCallback(
    (T) => {
      var D;
      const R = (D = a.contentRef) == null ? void 0 : D.current;
      T.relatedTarget && (R == null ? void 0 : R.contains(T.relatedTarget)) || (w(), m(!1));
    },
    [x, a.contentRef, a.isOpen, j, v]
  ), E = l.useCallback(
    (T) => {
      if (n == null || n(T), a.disabled && T.key !== ht.Tab) {
        T.preventDefault();
        return;
      }
      if (T.key === ht.Esc) {
        w(), m(!1);
        return;
      }
      T.key === ht.ArrowDown || T.key === ht.ArrowUp ? (b(T.key), T.preventDefault()) : px.includes(T.key) && a.isOpen && (_(), T.preventDefault());
    },
    [a.isOpen, a.disabled]
  ), C = l.useCallback(
    (T) => {
      if (a.disabled) {
        T.preventDefault();
        return;
      }
      c({
        type: ve.SET_BYPASS_FILTER,
        payload: !0
      }), m();
    },
    [a.disabled]
  );
  le(() => {
    a.selectedOption && a.hasExactMatch && h(a.selectedOption.text);
  }, [a.selectedOption, a.hasExactMatch]), le(() => {
    var T;
    a.value !== ((T = a.selectedOption) == null ? void 0 : T.value) && h(a.value);
  }, [a.value, a.selectedOption]);
  const S = `${a.optionsIdPrefix}${a.focusedItemIdx}`, k = (H = (L = a.contentRef) == null ? void 0 : L.current) == null ? void 0 : H.id, O = l.useMemo(
    () => /* @__PURE__ */ l.createElement(
      "div",
      {
        "aria-label": (a != null && a.isOpen, "close combobox"),
        onClick: () => {
          var T;
          a.isOpen ? m(!(a != null && a.isOpen)) : (T = u.current) == null || T.focus();
        }
      },
      a != null && a.isOpen ? /* @__PURE__ */ l.createElement(ic, { className: q(Ed, Wx) }) : /* @__PURE__ */ l.createElement(lc, { className: q(Ed, Ux) })
    ),
    [a.isOpen]
  );
  return /* @__PURE__ */ l.createElement(
    pr,
    {
      ref: f,
      appearance: a.appearance,
      className: q([
        e,
        { [Nx]: a.disabled }
      ]),
      iconRight: t ? t === "caret" ? O : t === "search" ? /* @__PURE__ */ l.createElement(Bu, { className: Pl }) : t : /* @__PURE__ */ l.createElement(Bu, { className: Pl }),
      placeholder: a.placeholder,
      role: "combobox",
      "aria-activedescendant": a.isOpen ? S : void 0,
      "aria-controls": k,
      "aria-expanded": a.isOpen,
      "aria-autocomplete": "list",
      isDisabled: a.disabled || void 0,
      value: v,
      onFocus: C,
      onBlur: y,
      onChange: g,
      onKeyDown: E
    }
  );
}), Gx = ({ id: e, index: t }) => {
  const { state: n } = To();
  return l.useMemo(
    () => /* @__PURE__ */ l.createElement(
      Nl,
      {
        id: e,
        index: t,
        value: mu,
        text: n.value ?? n.createLabel
      },
      /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, `${n.createLabel} "${n.value}"`)
    ),
    [e, t, n.value, n.createLabel]
  );
}, Nl = l.forwardRef(
  ({ children: e, className: t, icon: n, id: r, index: a, value: s, isDisabled: o, text: i, ...c }, u) => {
    const f = Te(null), m = We([u, f]), { state: b, dispatch: _, onValueChange: j, onOpenChange: p } = To(), v = l.useCallback(() => {
      if (!o) {
        const y = s === mu ? i : s;
        _({
          type: ve.SET_HAS_EXACT_MATCH,
          payload: !0
        }), _({
          type: ve.VALUE_CHANGE,
          payload: y
        }), _({
          type: ve.OPEN_CHANGE,
          payload: {
            open: !1
          }
        }), j == null || j(y), p == null || p(!1);
        const E = {
          value: y,
          text: i
        };
        _({
          type: ve.SET_SELECTION,
          payload: E
        });
      }
    }, [i, s]), h = l.useMemo(() => {
      var y;
      return ((y = b.selectedOption) == null ? void 0 : y.value) === s;
    }, [b.selectedOption, s]), g = l.useMemo(
      () => `${b.optionsIdPrefix}${b.focusedItemIdx}` === r,
      [b.focusedItemIdx, b.optionsIdPrefix, r]
    );
    le(() => {
      g && _({
        type: ve.SET_FOCUSED_OPTION,
        payload: {
          value: s,
          text: i
        }
      });
    }, [g]);
    const w = l.useCallback(() => {
      _({
        type: ve.SET_FOCUSED_INDEX,
        payload: a
      }), _({
        type: ve.SET_FOCUSED_OPTION,
        payload: {
          value: s,
          text: i
        }
      });
    }, [r]), x = l.useMemo(() => n ? n === "default" ? /* @__PURE__ */ l.createElement(Vs, null) : /* @__PURE__ */ l.createElement(Vs, null, n) : null, [n]);
    return o ? /* @__PURE__ */ l.createElement(
      re,
      {
        ref: m,
        xAlign: "between",
        className: q([
          t,
          wd[b.appearance || Ys]
        ]),
        role: "option",
        id: r,
        "data-index": a,
        "aria-disabled": o,
        tabIndex: -1,
        height: "auto",
        ...c
      },
      /* @__PURE__ */ l.createElement(Ml, { isSelected: h }),
      /* @__PURE__ */ l.createElement(
        ne,
        {
          styledAs: "body3",
          ...o && { className: Hx }
        },
        e
      ),
      x
    ) : /* @__PURE__ */ l.createElement(
      re,
      {
        ref: m,
        xAlign: "between",
        className: q([
          t,
          wd[b.appearance || Ys]
        ]),
        role: "option",
        id: r,
        "data-index": a,
        "data-highlighted": g ? "true" : void 0,
        "aria-selected": h,
        "aria-disabled": o || void 0,
        tabIndex: -1,
        onMouseOver: Xe(c.onMouseOver, w),
        onPointerDown: Xe(c.onPointerUp, (y) => {
          y.preventDefault();
        }),
        onPointerUp: Xe(c.onPointerUp, v),
        height: "auto",
        ...c
      },
      /* @__PURE__ */ l.createElement(Ml, { isSelected: h }),
      /* @__PURE__ */ l.createElement(
        ne,
        {
          styledAs: "body3",
          ...h && { className: Fx }
        },
        e
      ),
      x
    );
  }
), Kx = l.forwardRef(
  ({
    className: e,
    maxContentHeight: t = 300,
    contentTriggerMargin: n = 4,
    defaultText: r = "Start typing to search",
    ...a
  }, s) => {
    const { state: o, dispatch: i, onSelection: c } = To(), {
      isOpen: u,
      triggerPosition: f,
      isCreatable: m,
      isLoading: b,
      loadingMessage: _,
      hasExactMatch: j,
      options: p,
      numMatches: v,
      value: h,
      bypassFilter: g,
      minSearch: w,
      createVisible: x,
      optionsIdPrefix: y,
      selectedOption: E,
      filter: C
    } = o, S = l.useRef(null), k = We([S, s]), O = kt("rtk-combobox-content"), [L, H] = de({
      ...f,
      maxHeight: 0
    }), [T, R] = de(!1), [M, D] = de(!1), [I, F] = de([]), [P, A] = de(0), [$, B] = de(), Y = l.useRef(null);
    le(() => {
      i({
        type: ve.SET_CREATE_VISIBLE,
        payload: !!(m && !j && h)
      });
    }, [h, j]);
    const J = l.useCallback((ie) => {
      i({
        type: ve.SET_HAS_EXACT_MATCH,
        payload: !0
      }), i({
        type: ve.SET_SELECTION,
        payload: ie
      });
    }, []);
    le(() => {
      if (g) {
        F(p);
        const ge = gd(p);
        i({
          type: ve.SET_NUM_MATCHES,
          payload: ge
        });
        return;
      }
      const ie = [];
      p.forEach((ge) => {
        const Ee = ge.options;
        if (Ee) {
          const He = Ee.filter((Re) => {
            const [Ie, at] = (C == null ? void 0 : C(Re, h ?? "")) || [
              !0,
              !1
            ];
            return at && J(Re), Ie;
          });
          He != null && He.length && ie.push({
            ...ge,
            options: He
          });
        } else {
          const [He, Re] = (C == null ? void 0 : C(
            ge,
            h ?? ""
          )) || [!0, !1];
          He && ie.push(ge), Re && J(ge);
        }
      }), F(ie);
      const Ce = gd(ie);
      i({
        type: ve.SET_NUM_MATCHES,
        payload: Ce
      });
    }, [u, h, C, p]);
    const W = A5({
      count: (I == null ? void 0 : I.length) + (x ? 1 : 0),
      getScrollElement: () => Y.current,
      estimateSize: () => 40,
      // initial estimate of item size, items will actually be dynamically sized
      measureElement: (ie) => {
        var ge, Ee;
        const Ce = ie.querySelector("[role=group]");
        return Ce ? Ce.clientHeight + yd : ((Ee = (ge = Array.from(ie.querySelectorAll("[role=option]"))) == null ? void 0 : ge.map((He) => He.clientHeight)) == null ? void 0 : Ee.reduce((He, Re) => He + Re, 0)) + yd;
      }
    }), V = W.getVirtualItems(), K = x ? 1 : 0;
    let te = 0;
    const Z = V.map((ie) => {
      if (x && ie.index === 0)
        return /* @__PURE__ */ l.createElement(
          "div",
          {
            className: yi,
            key: mu,
            ref: ie.measureElement,
            style: {
              height: `${ie.size}px`,
              top: `${ie.start}px`
            }
          },
          /* @__PURE__ */ l.createElement(Gx, { index: 0, id: `${y}0` })
        );
      const Ce = ie.index - K, ge = I[Ce];
      if (!ge)
        return;
      const Ee = ge;
      if (Ee.value && Ee.text)
        return /* @__PURE__ */ l.createElement(
          "div",
          {
            className: yi,
            key: Ee.value + Ee.text,
            ref: ie.measureElement,
            style: {
              height: `${ie.size}px`,
              top: `${ie.start}px`
            },
            tabIndex: -1
          },
          /* @__PURE__ */ l.createElement(
            Nl,
            {
              id: `${y}${Ce + te + K}`,
              icon: Ee.icon,
              index: Ce + te + K,
              value: Ee.value,
              text: Ee.text,
              isDisabled: Ee.isDisabled
            },
            Ee.text
          )
        );
      const He = ge.options;
      if (He) {
        const Re = He.map((at, gn) => {
          const Xt = ie.index + gn + te;
          return /* @__PURE__ */ l.createElement(
            U.div,
            {
              position: "relative",
              key: at.value + at.text,
              tabIndex: -1
            },
            /* @__PURE__ */ l.createElement(
              Nl,
              {
                id: `${y}${Xt}`,
                icon: at.icon,
                index: Xt,
                value: at.value,
                text: at.text,
                isDisabled: Ee.isDisabled
              },
              at.text
            )
          );
        });
        te += He.length - 1;
        const Ie = ge.label;
        return /* @__PURE__ */ l.createElement(
          "div",
          {
            key: Ie + ie.index + te,
            ref: ie.measureElement,
            className: yi,
            style: {
              top: `${ie.start}px`,
              height: `${ie.size}px`
            }
          },
          /* @__PURE__ */ l.createElement(Z8, null, /* @__PURE__ */ l.createElement(J8, null, Ie), Re)
        );
      }
    }), se = W.getTotalSize();
    se !== P && A(se), le(() => {
      if (!(b ? 0 : v)) {
        i({
          type: ve.FOCUS_FIRST
        });
        return;
      }
      if (E) {
        const Ce = gx(E, I);
        if (Ce !== -1) {
          i({
            type: ve.SET_FOCUSED_INDEX,
            payload: Ce + K
          }), i({
            type: ve.SET_FOCUSED_OPTION,
            payload: E
          });
          return;
        }
      }
      i({
        type: ve.FOCUS_FIRST
      });
    }, [v, b, u, K]), le(() => {
      if ($ && clearTimeout($), !u || M)
        return;
      const ie = setTimeout(() => {
        var Ce;
        o.focusedItemIdx !== void 0 && ((Ce = W.scrollToIndex) == null || Ce.call(W, o.focusedItemIdx, { align: "end" }));
      }, jx);
      B(ie);
    }, [o.focusedItemIdx, u]), le(() => {
      if (!u || !f)
        return;
      const ie = f, Ce = ie.height, ge = ie.top;
      let Ee = {
        width: `${ie.width}px`
      };
      const He = 2 * Dx, Re = P + He + Bx, Ie = Re;
      if (T)
        R(!0), Ee.bottom = `${Ce + n}px`, Ee.maxHeight = `${Math.min(
          Math.min(ge, t, Ie),
          Re
        )}px`;
      else {
        const [at, gn] = wx(
          ie,
          Ie,
          t,
          n
        );
        Ee = at, R(gn);
      }
      H(Ee);
    }, [u, f, b, P]), le(() => {
      u || (D(!1), R(!1), o.selectedOption && (c == null || c(o.selectedOption)));
    }, [u]), le(() => {
      S && i({
        type: ve.SET_CONTENT_REF,
        payload: S
      });
    }, [S == null ? void 0 : S.current]);
    const ue = l.useMemo(() => (L == null ? void 0 : L.width) || b, [L, b]), X = l.useMemo(() => /* @__PURE__ */ l.createElement(
      ye,
      {
        gap: "zero",
        yAlign: "center",
        ref: k,
        className: q([
          e,
          $x,
          { [Lx]: ue }
        ]),
        style: {
          ...L,
          minWidth: vd + hd,
          maxHeight: P && L.maxHeight ? L.maxHeight : "auto"
        },
        onMouseOver: () => D(!0),
        onMouseLeave: () => D(!1),
        ...a
      },
      !!P && !b && /* @__PURE__ */ l.createElement(
        "div",
        {
          ref: Y,
          className: Ix,
          style: {
            width: L.width ? L.width : "auto",
            height: !b && L.maxHeight ? L.maxHeight : "auto",
            minWidth: vd + hd
          }
        },
        /* @__PURE__ */ l.createElement(
          "div",
          {
            role: "listbox",
            id: O,
            className: zx,
            style: {
              height: !b && P ? `${P}px` : "auto"
            }
          },
          Z
        )
      ),
      /* @__PURE__ */ l.createElement(ye, { gap: "zero", role: "status", yAlign: "center", width: "full" }, b && /* @__PURE__ */ l.createElement(
        re,
        {
          xAlign: "center",
          yAlign: "center",
          gap: "zero",
          width: "full",
          paddingY: "default"
        },
        /* @__PURE__ */ l.createElement(
          so,
          {
            className: Pl,
            "aria-label": _ ? void 0 : _x
          }
        ),
        _ && /* @__PURE__ */ l.createElement(ne, { className: Cd }, _)
      ), !b && !v && !x && /* @__PURE__ */ l.createElement(ne, { className: Cd }, h && (h == null ? void 0 : h.length) >= w ? "No matching results." : r), !b && /* @__PURE__ */ l.createElement(re, { xAlign: "left", className: qx }, v, " ", v === 1 ? "Result" : "Results"))
    ), [u, L, v, Z]);
    return u && Z ? X : null;
  }
), tD = l.forwardRef(
  ({
    appearance: e,
    disabled: t,
    delay: n,
    filter: r,
    children: a,
    createLabel: s,
    isCreatable: o,
    isLoading: i,
    loadingMessage: c,
    options: u,
    placeholder: f,
    value: m,
    icon: b,
    defaultText: _,
    ...j
  }, p) => {
    const v = ut(), h = l.useRef(null), g = We([h, p]);
    return /* @__PURE__ */ l.createElement(
      Vx,
      {
        options: u,
        delay: n,
        isCreatable: o,
        createLabel: s,
        isLoading: i,
        loadingMessage: c,
        placeholder: f,
        appearance: e,
        triggerRef: h,
        disabled: t,
        filter: r,
        value: m,
        defaultText: _,
        "aria-required": v.isRequired,
        "aria-labelledby": j["aria-labelledby"] || v.labelId,
        "aria-describedby": j["aria-describedby"] || v.infoId,
        ...j
      },
      /* @__PURE__ */ l.createElement(Yx, { iconRight: b, ref: g }),
      /* @__PURE__ */ l.createElement(Kx, { defaultText: _ }, a)
    );
  }
), Xx = () => {
  const e = nn("tablet"), t = nn("laptop"), n = nn("monitor"), r = nn("ultrawide");
  return d.useMemo(() => ({
    mobile: !0,
    tablet: e,
    laptop: t,
    monitor: n,
    ultrawide: r
  }), [r, n, t, e]);
}, Zx = (e, t) => {
  const [n, r] = d.useState(!1);
  return d.useLayoutEffect(() => {
    const { current: a } = e;
    if (!a) return;
    const s = () => {
      const o = a.scrollWidth > a.clientWidth;
      r(o), t == null || t(o);
    };
    window.ResizeObserver && new ResizeObserver(s).observe(a), s();
  }, [e, t]), n;
};
var Jx = "_1glff3s1";
const Qx = jt(
  ({ className: e, ...t }, n) => /* @__PURE__ */ l.createElement(
    U.div,
    {
      ref: n,
      role: "status",
      "aria-label": "Loading...",
      className: q(Jx, e),
      margin: "small",
      height: "1rem",
      width: "auto",
      borderRadius: "default",
      ...t
    }
  )
);
var e9 = "qj40w20";
const nD = l.forwardRef(
  ({
    collapseLabel: e = "Collapse",
    expandLabel: t = "Expand",
    expanded: n,
    className: r,
    horizontal: a,
    ...s
  }, o) => {
    const i = n ? e : t, c = a ? Fb : Ah;
    return /* @__PURE__ */ l.createElement(
      Me,
      {
        ref: o,
        "aria-label": i,
        appearance: n ? "default" : "neutral",
        className: q(e9, r),
        "data-expanded": n,
        ...s
      },
      /* @__PURE__ */ l.createElement(me, { icon: c })
    );
  }
);
var t9 = "puafr00", n9 = "puafr01";
const rD = ({
  expanded: e,
  children: t,
  forceEllipsis: n = !0,
  className: r
}) => /* @__PURE__ */ l.createElement("div", { "data-expanded": e, className: q(t9, r) }, /* @__PURE__ */ l.createElement("div", { className: n9 }, t, n && !e && /* @__PURE__ */ l.createElement("span", null, "...")));
var r9 = "_18ygzw20", a9 = "_18ygzw21", s9 = "_18ygzw22", o9 = "_18ygzw24 _18ygzw23 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37jcs _1s8b37jl3 _1s8b37j80 _1s8b37jjz _1s8b37j1mq", i9 = "_18ygzw25", l9 = "_18ygzw26", c9 = "_18ygzw27", u9 = "_18ygzw28", d9 = "_18ygzw2b", f9 = "_18ygzw2c", a7 = "_18ygzw2e", b9 = "_18ygzw2f", s7 = "_18ygzw2g";
const o7 = "data-value", i7 = d.createContext(
  {
    uniqueId: "",
    emptyText: "No matching results.",
    createText: "Create",
    optionsSelected: [],
    setOptionsSelected: () => {
    },
    filterString: "",
    setActiveOption: () => {
    },
    setFilterString: () => {
    },
    inputRef: { current: null }
  }
), vr = () => d.useContext(i7), _u = d.forwardRef(
  ({
    children: e,
    className: t,
    emptyText: n = "No matching results.",
    createText: r = "Create",
    defaultOptionsSelected: a,
    optionsSelected: s,
    onSelectedOptionsChange: o,
    onFilterChange: i
  }, c) => {
    const [u, f] = nt({
      prop: s,
      defaultProp: a,
      onChange: o
    }), m = d.useRef(null), [b, _] = d.useState({
      index: -1,
      item: void 0
    }), [j, p] = d.useState(""), v = (g) => {
      p(g), i == null || i(g);
    };
    d.useImperativeHandle(
      c,
      () => ({
        resetActiveItem: () => {
          _({
            index: -1,
            item: void 0
          });
        }
      }),
      [_]
    );
    const h = d.useId();
    return /* @__PURE__ */ d.createElement(
      i7.Provider,
      {
        value: {
          uniqueId: h,
          emptyText: n,
          createText: r,
          optionsSelected: u,
          setOptionsSelected: f,
          activeOption: b,
          setActiveOption: _,
          filterString: j,
          setFilterString: v,
          inputRef: m
        }
      },
      /* @__PURE__ */ d.createElement(
        D8,
        {
          className: q(t, c9),
          itemDataAttr: "data-rtk-multi-select-list-option"
        },
        e
      )
    );
  }
), pu = d.forwardRef(
  ({ className: e, isCreatable: t, handleCreate: n, inputRef: r, options: a, ...s }, o) => {
    var h, g, w, x;
    const i = vr(), c = We([i.inputRef, o]), { getItems: u } = Rr(), [f, m] = d.useState(!1);
    d.useEffect(() => {
      m(
        !!(a != null && a.find(
          (y) => y.label.toLowerCase() === i.filterString.toLowerCase()
        ))
      );
    }, [i.filterString, a]);
    const b = d.useCallback(
      (y) => {
        if (i.setFilterString(y.target.value), t)
          i.setActiveOption({
            index: -1,
            item: void 0
          });
        else {
          const E = u();
          i.setActiveOption({
            index: (E == null ? void 0 : E.length) === 0 ? -1 : 0,
            item: E == null ? void 0 : E[0]
          });
        }
      },
      [i, u, t]
    ), _ = d.useCallback(
      (y, E) => {
        y.preventDefault();
        const C = u() ?? [];
        i.setActiveOption((S) => {
          var O, L, H, T;
          if (!S) return;
          const k = E === "down" ? S.index === C.length - 1 ? S.index : S.index + 1 : S.index === -1 ? C.length - 1 : S.index === 0 ? S.index : S.index - 1;
          return (T = (H = (L = (O = C[k]) == null ? void 0 : O.ref) == null ? void 0 : L.current) == null ? void 0 : H.scrollIntoView) == null || T.call(H, {
            behavior: "auto",
            block: "nearest",
            inline: "nearest"
          }), {
            index: k,
            item: C[k]
          };
        });
      },
      [i, u]
    ), j = () => {
      i.setOptionsSelected((y) => {
        var k, O, L, H, T, R;
        const E = y || [], C = (L = (O = (k = i.activeOption) == null ? void 0 : k.item) == null ? void 0 : O.ref.current) == null ? void 0 : L.getAttribute(o7), S = (R = (T = (H = i.activeOption) == null ? void 0 : H.item) == null ? void 0 : T.ref.current) == null ? void 0 : R.getAttribute("aria-label");
        return C && S ? E.some((M) => M.value === C) ? [...E].filter((M) => M.value !== C) : [...E, { value: C, label: S }] : E;
      }), i.inputRef.current && i.inputRef.current.focus(), i.setFilterString("");
    }, v = ao({
      onArrowDown: (y) => _(y, "down"),
      onArrowUp: (y) => _(y, "up"),
      onSpace: (y) => {
        var C, S, k, O;
        const E = (k = (S = (C = i.activeOption) == null ? void 0 : C.item) == null ? void 0 : S.ref.current) == null ? void 0 : k.getAttribute("aria-label");
        (O = i == null ? void 0 : i.activeOption) != null && O.item && (t && n && (E != null && E.includes("create")) ? xs(() => {
          n(i.filterString, i.setFilterString);
        }) : j(), y.preventDefault(), y.stopPropagation());
      },
      onEnter: () => {
        var E, C, S, k;
        const y = (S = (C = (E = i.activeOption) == null ? void 0 : E.item) == null ? void 0 : C.ref.current) == null ? void 0 : S.getAttribute("aria-label");
        t && n && !f && i.filterString.trim() && (!(y != null && y.trim()) || y.includes("create")) ? (xs(() => {
          n(i.filterString, i.setFilterString);
        }), (k = r == null ? void 0 : r.current) == null || k.focus()) : j();
      }
    });
    return /* @__PURE__ */ d.createElement(
      U.input,
      {
        ...s,
        className: q(e),
        ref: c,
        value: i.filterString,
        onChange: b,
        onKeyDown: v,
        onBlur: (y) => {
          y.stopPropagation(), y.preventDefault();
        },
        role: "combobox",
        "aria-autocomplete": "list",
        "aria-owns": `rtk-multi-select-list-options-${i.uniqueId}`,
        "aria-activedescendant": (x = (w = (g = (h = i.activeOption) == null ? void 0 : h.item) == null ? void 0 : g.ref) == null ? void 0 : w.current) == null ? void 0 : x.id
      }
    );
  }
), m9 = ({
  isCreatable: e,
  handleCreate: t,
  filterString: n,
  createText: r,
  setFilterString: a,
  inputRef: s
}) => {
  var m, b, _, j;
  const o = () => {
    var p;
    t && (xs(() => {
      t(n, a);
    }), (p = s == null ? void 0 : s.current) == null || p.focus());
  }, i = d.useId(), c = vr(), u = Rr(), f = d.useCallback(() => {
    const p = u.getItems();
    p && c.setActiveOption((v) => {
      const h = p.findIndex(
        (g) => {
          var w, x;
          return ((x = (w = g == null ? void 0 : g.ref) == null ? void 0 : w.current) == null ? void 0 : x.id) === i;
        }
      );
      return h >= 0 ? {
        index: h,
        item: p[h]
      } : v;
    });
  }, [u, c, i]);
  return /* @__PURE__ */ d.createElement(bu, { id: i, asChild: !0 }, /* @__PURE__ */ d.createElement(
    "li",
    {
      style: {
        display: e && n.trim() ? "flex" : "none"
      },
      className: a7,
      onMouseOver: f,
      "data-highlighted": ((j = (_ = (b = (m = c.activeOption) == null ? void 0 : m.item) == null ? void 0 : b.ref) == null ? void 0 : _.current) == null ? void 0 : j.id) === i ? "true" : "false",
      onClick: o,
      "aria-label": "create"
    },
    /* @__PURE__ */ d.createElement(
      ne,
      {
        styledAs: "body3",
        className: s7
      },
      `${r} "${n}"`
    )
  ));
}, ju = d.forwardRef(
  ({
    children: e,
    options: t,
    className: n,
    isCreatable: r,
    handleCreate: a,
    inputRef: s,
    style: o,
    ...i
  }, c) => {
    const u = vr(), [f, m] = d.useState(!1), [b, _] = d.useState(!1), { emptyText: j, filterString: p, createText: v, setFilterString: h } = vr();
    d.useEffect(() => {
      _(
        !!t.find(
          (w) => w.label.toLowerCase() === p.toLowerCase()
        )
      ), m(
        !t.find(
          (w) => w.label.toLowerCase().includes(p.toLocaleLowerCase())
        ) && !r
      );
    }, [p, r, t]);
    const g = d.useMemo(() => ({
      minWidth: z8 + F8,
      ...o
    }), [o]);
    return /* @__PURE__ */ d.createElement(ye, { asChild: !0, gap: "xsmall" }, /* @__PURE__ */ d.createElement(
      "ul",
      {
        ...i,
        ref: c,
        className: q(n, d9),
        id: `rtk-multi-select-list-options-${u.uniqueId}`,
        role: "listbox",
        tabIndex: -1,
        style: g
      },
      /* @__PURE__ */ d.createElement(
        "li",
        {
          style: {
            display: f && !r || r && !p.trim() && p ? "block" : "none"
          }
        },
        /* @__PURE__ */ d.createElement(ne, { styledAs: "body3", className: f9 }, j)
      ),
      e,
      r && p.trim() && !b ? /* @__PURE__ */ d.createElement(
        m9,
        {
          isCreatable: r,
          handleCreate: a,
          filterString: p,
          createText: v,
          setFilterString: h,
          inputRef: s
        }
      ) : null
    ));
  }
), vu = d.forwardRef(({ children: e, className: t, value: n, label: r, onClick: a, ...s }, o) => {
  var v, h, g, w;
  const i = d.useId(), c = d.useRef(null), u = We([c, o]), f = vr(), m = Rr(), b = d.useCallback(() => {
    const x = m.getItems();
    x && f.setActiveOption((y) => {
      const E = x.findIndex(
        (C) => {
          var S, k;
          return ((k = (S = C == null ? void 0 : C.ref) == null ? void 0 : S.current) == null ? void 0 : k.id) === i;
        }
      );
      return E >= 0 ? {
        index: E,
        item: {
          ref: c
        }
      } : y;
    });
  }, [f, i, c, m]), _ = d.useCallback(() => {
    f.setOptionsSelected((x) => {
      const y = x || [];
      return y.some((E) => E.value === n) ? [...y].filter((E) => E.value !== n) : [...y, { value: n, label: r }];
    }), f.inputRef.current && f.inputRef.current.focus(), f.setFilterString("");
  }, [f, n, r]), j = d.useMemo(() => f.filterString.length > 0 ? r.toLowerCase().includes(f.filterString.toLowerCase()) : !0, [r, f]), p = d.useMemo(() => {
    var x;
    return ((x = f.optionsSelected) == null ? void 0 : x.some((y) => y.value === n)) || !1;
  }, [f, n]);
  return j ? /* @__PURE__ */ d.createElement(bu, { id: i, asChild: !0 }, /* @__PURE__ */ d.createElement(re, { asChild: !0, gap: "small" }, /* @__PURE__ */ d.createElement(
    "li",
    {
      ...s,
      className: q(t, a7),
      "data-value": n,
      ref: u,
      onClick: Xe(_, a),
      onMouseOver: b,
      role: "option",
      "data-highlighted": ((w = (g = (h = (v = f.activeOption) == null ? void 0 : v.item) == null ? void 0 : h.ref) == null ? void 0 : g.current) == null ? void 0 : w.id) === i ? "true" : "false",
      "aria-selected": p,
      "aria-label": r,
      tabIndex: -1
    },
    p && /* @__PURE__ */ d.createElement(ha, { className: b9 }),
    e
  ))) : null;
}), hu = d.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ d.createElement(
  ne,
  {
    ...n,
    className: q(t, s7),
    ref: r
  },
  e
));
_u.displayName = "MultiSelectList";
ju.displayName = "MultiSelectListItems";
vu.displayName = "MultiSelectListItem";
pu.displayName = "MultiSelectListInput";
hu.displayName = "MultiSelectListItemText";
function on(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function _9(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function l7(...e) {
  return (t) => e.forEach((n) => _9(n, t));
}
function Or(...e) {
  return d.useCallback(l7(...e), e);
}
function p9(e, t = []) {
  let n = [];
  function r(s, o) {
    const i = d.createContext(o), c = n.length;
    n = [...n, o];
    function u(m) {
      const { scope: b, children: _, ...j } = m, p = (b == null ? void 0 : b[e][c]) || i, v = d.useMemo(() => j, Object.values(j));
      return /* @__PURE__ */ z.jsx(p.Provider, { value: v, children: _ });
    }
    function f(m, b) {
      const _ = (b == null ? void 0 : b[e][c]) || i, j = d.useContext(_);
      if (j) return j;
      if (o !== void 0) return o;
      throw new Error(`\`${m}\` must be used within \`${s}\``);
    }
    return u.displayName = s + "Provider", [u, f];
  }
  const a = () => {
    const s = n.map((o) => d.createContext(o));
    return function(i) {
      const c = (i == null ? void 0 : i[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: c } }),
        [i, c]
      );
    };
  };
  return a.scopeName = e, [r, j9(a, ...t)];
}
function j9(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(s) {
      const o = r.reduce((i, { useScope: c, scopeName: u }) => {
        const m = c(s)[`__scope${u}`];
        return { ...i, ...m };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var gu = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = d.Children.toArray(n), s = a.find(h9);
  if (s) {
    const o = s.props.children, i = a.map((c) => c === s ? d.Children.count(o) > 1 ? d.Children.only(null) : d.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z.jsx(Dl, { ...r, ref: t, children: d.isValidElement(o) ? d.cloneElement(o, void 0, i) : null });
  }
  return /* @__PURE__ */ z.jsx(Dl, { ...r, ref: t, children: n });
});
gu.displayName = "Slot";
var Dl = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const a = y9(n);
    return d.cloneElement(n, {
      ...g9(r, n.props),
      // @ts-ignore
      ref: t ? l7(t, a) : a
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
Dl.displayName = "SlotClone";
var v9 = ({ children: e }) => /* @__PURE__ */ z.jsx(z.Fragment, { children: e });
function h9(e) {
  return d.isValidElement(e) && e.type === v9;
}
function g9(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? a && s ? n[r] = (...i) => {
      s(...i), a(...i);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function y9(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var w9 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Mr = w9.reduce((e, t) => {
  const n = d.forwardRef((r, a) => {
    const { asChild: s, ...o } = r, i = s ? gu : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ z.jsx(i, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function C9(e, t) {
  e && yr.flushSync(() => e.dispatchEvent(t));
}
function Nn(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function E9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Nn(e);
  d.useEffect(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var x9 = "DismissableLayer", Il = "dismissableLayer.update", S9 = "dismissableLayer.pointerDownOutside", k9 = "dismissableLayer.focusOutside", xd, c7 = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), u7 = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: a,
      onFocusOutside: s,
      onInteractOutside: o,
      onDismiss: i,
      ...c
    } = e, u = d.useContext(c7), [f, m] = d.useState(null), b = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, _] = d.useState({}), j = Or(t, (C) => m(C)), p = Array.from(u.layers), [v] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), h = p.indexOf(v), g = f ? p.indexOf(f) : -1, w = u.layersWithOutsidePointerEventsDisabled.size > 0, x = g >= h, y = O9((C) => {
      const S = C.target, k = [...u.branches].some((O) => O.contains(S));
      !x || k || (a == null || a(C), o == null || o(C), C.defaultPrevented || i == null || i());
    }, b), E = M9((C) => {
      const S = C.target;
      [...u.branches].some((O) => O.contains(S)) || (s == null || s(C), o == null || o(C), C.defaultPrevented || i == null || i());
    }, b);
    return E9((C) => {
      g === u.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && i && (C.preventDefault(), i()));
    }, b), d.useEffect(() => {
      if (f)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (xd = b.body.style.pointerEvents, b.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(f)), u.layers.add(f), Sd(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (b.body.style.pointerEvents = xd);
        };
    }, [f, b, n, u]), d.useEffect(() => () => {
      f && (u.layers.delete(f), u.layersWithOutsidePointerEventsDisabled.delete(f), Sd());
    }, [f, u]), d.useEffect(() => {
      const C = () => _({});
      return document.addEventListener(Il, C), () => document.removeEventListener(Il, C);
    }, []), /* @__PURE__ */ z.jsx(
      Mr.div,
      {
        ...c,
        ref: j,
        style: {
          pointerEvents: w ? x ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: on(e.onFocusCapture, E.onFocusCapture),
        onBlurCapture: on(e.onBlurCapture, E.onBlurCapture),
        onPointerDownCapture: on(
          e.onPointerDownCapture,
          y.onPointerDownCapture
        )
      }
    );
  }
);
u7.displayName = x9;
var T9 = "DismissableLayerBranch", R9 = d.forwardRef((e, t) => {
  const n = d.useContext(c7), r = d.useRef(null), a = Or(t, r);
  return d.useEffect(() => {
    const s = r.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ z.jsx(Mr.div, { ...e, ref: a });
});
R9.displayName = T9;
function O9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Nn(e), r = d.useRef(!1), a = d.useRef(() => {
  });
  return d.useEffect(() => {
    const s = (i) => {
      if (i.target && !r.current) {
        let c = function() {
          d7(
            S9,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = c, t.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", a.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", s), t.removeEventListener("click", a.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function M9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Nn(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const a = (s) => {
      s.target && !r.current && d7(k9, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Sd() {
  const e = new CustomEvent(Il);
  document.dispatchEvent(e);
}
function d7(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && a.addEventListener(e, t, { once: !0 }), r ? C9(a, s) : a.dispatchEvent(s);
}
var wi = 0;
function A9() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? kd()), document.body.insertAdjacentElement("beforeend", e[1] ?? kd()), wi++, () => {
      wi === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), wi--;
    };
  }, []);
}
function kd() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Ci = "focusScope.autoFocusOnMount", Ei = "focusScope.autoFocusOnUnmount", Td = { bubbles: !1, cancelable: !0 }, P9 = "FocusScope", f7 = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: s,
    ...o
  } = e, [i, c] = d.useState(null), u = Nn(a), f = Nn(s), m = d.useRef(null), b = Or(t, (p) => c(p)), _ = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (r) {
      let p = function(w) {
        if (_.paused || !i) return;
        const x = w.target;
        i.contains(x) ? m.current = x : en(m.current, { select: !0 });
      }, v = function(w) {
        if (_.paused || !i) return;
        const x = w.relatedTarget;
        x !== null && (i.contains(x) || en(m.current, { select: !0 }));
      }, h = function(w) {
        if (document.activeElement === document.body)
          for (const y of w)
            y.removedNodes.length > 0 && en(i);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", v);
      const g = new MutationObserver(h);
      return i && g.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", v), g.disconnect();
      };
    }
  }, [r, i, _.paused]), d.useEffect(() => {
    if (i) {
      Od.add(_);
      const p = document.activeElement;
      if (!i.contains(p)) {
        const h = new CustomEvent(Ci, Td);
        i.addEventListener(Ci, u), i.dispatchEvent(h), h.defaultPrevented || (N9(z9(b7(i)), { select: !0 }), document.activeElement === p && en(i));
      }
      return () => {
        i.removeEventListener(Ci, u), setTimeout(() => {
          const h = new CustomEvent(Ei, Td);
          i.addEventListener(Ei, f), i.dispatchEvent(h), h.defaultPrevented || en(p ?? document.body, { select: !0 }), i.removeEventListener(Ei, f), Od.remove(_);
        }, 0);
      };
    }
  }, [i, u, f, _]);
  const j = d.useCallback(
    (p) => {
      if (!n && !r || _.paused) return;
      const v = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, h = document.activeElement;
      if (v && h) {
        const g = p.currentTarget, [w, x] = D9(g);
        w && x ? !p.shiftKey && h === x ? (p.preventDefault(), n && en(w, { select: !0 })) : p.shiftKey && h === w && (p.preventDefault(), n && en(x, { select: !0 })) : h === g && p.preventDefault();
      }
    },
    [n, r, _.paused]
  );
  return /* @__PURE__ */ z.jsx(Mr.div, { tabIndex: -1, ...o, ref: b, onKeyDown: j });
});
f7.displayName = P9;
function N9(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (en(r, { select: t }), document.activeElement !== n) return;
}
function D9(e) {
  const t = b7(e), n = Rd(t, e), r = Rd(t.reverse(), e);
  return [n, r];
}
function b7(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Rd(e, t) {
  for (const n of e)
    if (!I9(n, { upTo: t })) return n;
}
function I9(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function $9(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function en(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && $9(e) && t && e.select();
  }
}
var Od = L9();
function L9() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Md(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Md(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Md(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function z9(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Gs = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, F9 = d.useId || (() => {
}), H9 = 0;
function B9(e) {
  const [t, n] = d.useState(F9());
  return Gs(() => {
    e || n((r) => r ?? String(H9++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var q9 = "Portal", m7 = d.forwardRef((e, t) => {
  var i;
  const { container: n, ...r } = e, [a, s] = d.useState(!1);
  Gs(() => s(!0), []);
  const o = n || a && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return o ? ja.createPortal(/* @__PURE__ */ z.jsx(Mr.div, { ...r, ref: t }), o) : null;
});
m7.displayName = q9;
function U9(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var yu = (e) => {
  const { present: t, children: n } = e, r = W9(t), a = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), s = Or(r.ref, V9(a));
  return typeof n == "function" || r.isPresent ? d.cloneElement(a, { ref: s }) : null;
};
yu.displayName = "Presence";
function W9(e) {
  const [t, n] = d.useState(), r = d.useRef({}), a = d.useRef(e), s = d.useRef("none"), o = e ? "mounted" : "unmounted", [i, c] = U9(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const u = as(r.current);
    s.current = i === "mounted" ? u : "none";
  }, [i]), Gs(() => {
    const u = r.current, f = a.current;
    if (f !== e) {
      const b = s.current, _ = as(u);
      e ? c("MOUNT") : _ === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(f && b !== _ ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, c]), Gs(() => {
    if (t) {
      const u = (m) => {
        const _ = as(r.current).includes(m.animationName);
        m.target === t && _ && yr.flushSync(() => c("ANIMATION_END"));
      }, f = (m) => {
        m.target === t && (s.current = as(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: d.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function as(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function V9(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Y9({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = G9({ defaultProp: t, onChange: n }), s = e !== void 0, o = s ? e : r, i = Nn(n), c = d.useCallback(
    (u) => {
      if (s) {
        const m = typeof u == "function" ? u(e) : u;
        m !== e && i(m);
      } else
        a(u);
    },
    [s, e, a, i]
  );
  return [o, c];
}
function G9({
  defaultProp: e,
  onChange: t
}) {
  const n = d.useState(e), [r] = n, a = d.useRef(r), s = Nn(t);
  return d.useEffect(() => {
    a.current !== r && (s(r), a.current = r);
  }, [r, a, s]), n;
}
var _7 = Yc(), xi = function() {
}, Ro = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: xi,
    onWheelCapture: xi,
    onTouchMoveCapture: xi
  }), a = r[0], s = r[1], o = e.forwardProps, i = e.children, c = e.className, u = e.removeScrollBar, f = e.enabled, m = e.shards, b = e.sideCar, _ = e.noIsolation, j = e.inert, p = e.allowPinchZoom, v = e.as, h = v === void 0 ? "div" : v, g = e.gapMode, w = Sa(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = b, y = Vc([n, t]), E = Ue(Ue({}, w), a);
  return d.createElement(
    d.Fragment,
    null,
    f && d.createElement(x, { sideCar: _7, removeScrollBar: u, shards: m, noIsolation: _, inert: j, setCallbacks: s, allowPinchZoom: !!p, lockRef: n, gapMode: g }),
    o ? d.cloneElement(d.Children.only(i), Ue(Ue({}, E), { ref: y })) : d.createElement(h, Ue({}, E, { className: c, ref: y }), i)
  );
});
Ro.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ro.classNames = {
  fullWidth: lr,
  zeroRight: ir
};
var $l = !1;
if (typeof window < "u")
  try {
    var ss = Object.defineProperty({}, "passive", {
      get: function() {
        return $l = !0, !0;
      }
    });
    window.addEventListener("test", ss, ss), window.removeEventListener("test", ss, ss);
  } catch {
    $l = !1;
  }
var Wn = $l ? { passive: !1 } : !1, K9 = function(e) {
  return e.tagName === "TEXTAREA";
}, p7 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !K9(e) && n[t] === "visible")
  );
}, X9 = function(e) {
  return p7(e, "overflowY");
}, Z9 = function(e) {
  return p7(e, "overflowX");
}, Ad = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var a = j7(e, r);
    if (a) {
      var s = v7(e, r), o = s[1], i = s[2];
      if (o > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, J9 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Q9 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, j7 = function(e, t) {
  return e === "v" ? X9(t) : Z9(t);
}, v7 = function(e, t) {
  return e === "v" ? J9(t) : Q9(t);
}, eS = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, tS = function(e, t, n, r, a) {
  var s = eS(e, window.getComputedStyle(t).direction), o = s * r, i = n.target, c = t.contains(i), u = !1, f = o > 0, m = 0, b = 0;
  do {
    var _ = v7(e, i), j = _[0], p = _[1], v = _[2], h = p - v - s * j;
    (j || h) && j7(e, i) && (m += h, b += j), i instanceof ShadowRoot ? i = i.host : i = i.parentNode;
  } while (
    // portaled content
    !c && i !== document.body || // self content
    c && (t.contains(i) || t === i)
  );
  return (f && (Math.abs(m) < 1 || !a) || !f && (Math.abs(b) < 1 || !a)) && (u = !0), u;
}, os = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Pd = function(e) {
  return [e.deltaX, e.deltaY];
}, Nd = function(e) {
  return e && "current" in e ? e.current : e;
}, nS = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, rS = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, aS = 0, Vn = [];
function sS(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), a = d.useState(aS++)[0], s = d.useState(jo)[0], o = d.useRef(e);
  d.useEffect(function() {
    o.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = Wc([e.lockRef.current], (e.shards || []).map(Nd), !0).filter(Boolean);
      return p.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = d.useCallback(function(p, v) {
    if ("touches" in p && p.touches.length === 2)
      return !o.current.allowPinchZoom;
    var h = os(p), g = n.current, w = "deltaX" in p ? p.deltaX : g[0] - h[0], x = "deltaY" in p ? p.deltaY : g[1] - h[1], y, E = p.target, C = Math.abs(w) > Math.abs(x) ? "h" : "v";
    if ("touches" in p && C === "h" && E.type === "range")
      return !1;
    var S = Ad(C, E);
    if (!S)
      return !0;
    if (S ? y = C : (y = C === "v" ? "h" : "v", S = Ad(C, E)), !S)
      return !1;
    if (!r.current && "changedTouches" in p && (w || x) && (r.current = y), !y)
      return !0;
    var k = r.current || y;
    return tS(k, v, p, k === "h" ? w : x, !0);
  }, []), c = d.useCallback(function(p) {
    var v = p;
    if (!(!Vn.length || Vn[Vn.length - 1] !== s)) {
      var h = "deltaY" in v ? Pd(v) : os(v), g = t.current.filter(function(y) {
        return y.name === v.type && (y.target === v.target || v.target === y.shadowParent) && nS(y.delta, h);
      })[0];
      if (g && g.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!g) {
        var w = (o.current.shards || []).map(Nd).filter(Boolean).filter(function(y) {
          return y.contains(v.target);
        }), x = w.length > 0 ? i(v, w[0]) : !o.current.noIsolation;
        x && v.cancelable && v.preventDefault();
      }
    }
  }, []), u = d.useCallback(function(p, v, h, g) {
    var w = { name: p, delta: v, target: h, should: g, shadowParent: oS(h) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(x) {
        return x !== w;
      });
    }, 1);
  }, []), f = d.useCallback(function(p) {
    n.current = os(p), r.current = void 0;
  }, []), m = d.useCallback(function(p) {
    u(p.type, Pd(p), p.target, i(p, e.lockRef.current));
  }, []), b = d.useCallback(function(p) {
    u(p.type, os(p), p.target, i(p, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return Vn.push(s), e.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: b
    }), document.addEventListener("wheel", c, Wn), document.addEventListener("touchmove", c, Wn), document.addEventListener("touchstart", f, Wn), function() {
      Vn = Vn.filter(function(p) {
        return p !== s;
      }), document.removeEventListener("wheel", c, Wn), document.removeEventListener("touchmove", c, Wn), document.removeEventListener("touchstart", f, Wn);
    };
  }, []);
  var _ = e.removeScrollBar, j = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    j ? d.createElement(s, { styles: rS(a) }) : null,
    _ ? d.createElement(Kc, { gapMode: e.gapMode }) : null
  );
}
function oS(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const iS = Gc(_7, sS);
var h7 = d.forwardRef(function(e, t) {
  return d.createElement(Ro, Ue({}, e, { ref: t, sideCar: iS }));
});
h7.classNames = Ro.classNames;
var wu = "Popover", [g7, aD] = p9(wu, [
  Sr
]), Aa = Sr(), [lS, vn] = g7(wu), y7 = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: a,
    onOpenChange: s,
    modal: o = !1
  } = e, i = Aa(t), c = d.useRef(null), [u, f] = d.useState(!1), [m = !1, b] = Y9({
    prop: r,
    defaultProp: a,
    onChange: s
  });
  return /* @__PURE__ */ z.jsx(Fc, { ...i, children: /* @__PURE__ */ z.jsx(
    lS,
    {
      scope: t,
      contentId: B9(),
      triggerRef: c,
      open: m,
      onOpenChange: b,
      onOpenToggle: d.useCallback(() => b((_) => !_), [b]),
      hasCustomAnchor: u,
      onCustomAnchorAdd: d.useCallback(() => f(!0), []),
      onCustomAnchorRemove: d.useCallback(() => f(!1), []),
      modal: o,
      children: n
    }
  ) });
};
y7.displayName = wu;
var w7 = "PopoverAnchor", cS = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, a = vn(w7, n), s = Aa(n), { onCustomAnchorAdd: o, onCustomAnchorRemove: i } = a;
    return d.useEffect(() => (o(), () => i()), [o, i]), /* @__PURE__ */ z.jsx(mo, { ...s, ...r, ref: t });
  }
);
cS.displayName = w7;
var C7 = "PopoverTrigger", E7 = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, a = vn(C7, n), s = Aa(n), o = Or(t, a.triggerRef), i = /* @__PURE__ */ z.jsx(
      Mr.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": R7(a.open),
        ...r,
        ref: o,
        onClick: on(e.onClick, a.onOpenToggle)
      }
    );
    return a.hasCustomAnchor ? i : /* @__PURE__ */ z.jsx(mo, { asChild: !0, ...s, children: i });
  }
);
E7.displayName = C7;
var Cu = "PopoverPortal", [uS, dS] = g7(Cu, {
  forceMount: void 0
}), x7 = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: a } = e, s = vn(Cu, t);
  return /* @__PURE__ */ z.jsx(uS, { scope: t, forceMount: n, children: /* @__PURE__ */ z.jsx(yu, { present: n || s.open, children: /* @__PURE__ */ z.jsx(m7, { asChild: !0, container: a, children: r }) }) });
};
x7.displayName = Cu;
var hr = "PopoverContent", S7 = d.forwardRef(
  (e, t) => {
    const n = dS(hr, e.__scopePopover), { forceMount: r = n.forceMount, ...a } = e, s = vn(hr, e.__scopePopover);
    return /* @__PURE__ */ z.jsx(yu, { present: r || s.open, children: s.modal ? /* @__PURE__ */ z.jsx(fS, { ...a, ref: t }) : /* @__PURE__ */ z.jsx(bS, { ...a, ref: t }) });
  }
);
S7.displayName = hr;
var fS = d.forwardRef(
  (e, t) => {
    const n = vn(hr, e.__scopePopover), r = d.useRef(null), a = Or(t, r), s = d.useRef(!1);
    return d.useEffect(() => {
      const o = r.current;
      if (o) return Uc(o);
    }, []), /* @__PURE__ */ z.jsx(h7, { as: gu, allowPinchZoom: !0, children: /* @__PURE__ */ z.jsx(
      k7,
      {
        ...e,
        ref: a,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: on(e.onCloseAutoFocus, (o) => {
          var i;
          o.preventDefault(), s.current || (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: on(
          e.onPointerDownOutside,
          (o) => {
            const i = o.detail.originalEvent, c = i.button === 0 && i.ctrlKey === !0, u = i.button === 2 || c;
            s.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: on(
          e.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), bS = d.forwardRef(
  (e, t) => {
    const n = vn(hr, e.__scopePopover), r = d.useRef(!1), a = d.useRef(!1);
    return /* @__PURE__ */ z.jsx(
      k7,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var o, i;
          (o = e.onCloseAutoFocus) == null || o.call(e, s), s.defaultPrevented || (r.current || (i = n.triggerRef.current) == null || i.focus(), s.preventDefault()), r.current = !1, a.current = !1;
        },
        onInteractOutside: (s) => {
          var c, u;
          (c = e.onInteractOutside) == null || c.call(e, s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const o = s.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(o)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && a.current && s.preventDefault();
        }
      }
    );
  }
), k7 = d.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: a,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: c,
      onFocusOutside: u,
      onInteractOutside: f,
      ...m
    } = e, b = vn(hr, n), _ = Aa(n);
    return A9(), /* @__PURE__ */ z.jsx(
      f7,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: a,
        onUnmountAutoFocus: s,
        children: /* @__PURE__ */ z.jsx(
          u7,
          {
            asChild: !0,
            disableOutsidePointerEvents: o,
            onInteractOutside: f,
            onEscapeKeyDown: i,
            onPointerDownOutside: c,
            onFocusOutside: u,
            onDismiss: () => b.onOpenChange(!1),
            children: /* @__PURE__ */ z.jsx(
              Hc,
              {
                "data-state": R7(b.open),
                role: "dialog",
                id: b.contentId,
                ..._,
                ...m,
                ref: t,
                style: {
                  ...m.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), T7 = "PopoverClose", mS = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, a = vn(T7, n);
    return /* @__PURE__ */ z.jsx(
      Mr.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: on(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
mS.displayName = T7;
var _S = "PopoverArrow", pS = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, a = Aa(n);
    return /* @__PURE__ */ z.jsx(Bc, { ...a, ...r, ref: t });
  }
);
pS.displayName = _S;
function R7(e) {
  return e ? "open" : "closed";
}
var jS = y7, vS = E7, hS = x7, gS = S7, yS = "_1ew81g95 _1ew81g94 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37j80 _1s8b37jjz _1s8b37jl3 _1s8b37jcs";
const wS = ({
  children: e,
  defaultOpen: t,
  isOpen: n,
  onIsOpenChange: r,
  ...a
}) => /* @__PURE__ */ l.createElement(
  jS,
  {
    ...a,
    defaultOpen: t,
    open: n,
    onOpenChange: r
  },
  e
), CS = l.forwardRef(
  ({
    children: e,
    className: t,
    onOpenAutoFocus: n,
    onCloseAutoFocus: r,
    onEscapeKeyDown: a,
    onPointerDownOutside: s,
    onFocusOutside: o,
    onInteractOutside: i,
    forceMount: c,
    side: u,
    sideOffset: f = 8,
    align: m,
    alignOffset: b,
    avoidCollisions: _,
    collisionPadding: j = 20,
    portalled: p = !0,
    "aria-labelledby": v,
    "aria-describedby": h,
    ...g
  }, w) => {
    const x = p ? hS : va;
    return /* @__PURE__ */ l.createElement(x, null, /* @__PURE__ */ l.createElement(
      gS,
      {
        ref: w,
        onOpenAutoFocus: n,
        onCloseAutoFocus: r,
        onEscapeKeyDown: a,
        onPointerDownOutside: s,
        onFocusOutside: o,
        onInteractOutside: i,
        forceMount: c,
        side: u,
        sideOffset: f,
        align: m,
        alignOffset: b,
        avoidCollisions: _,
        collisionPadding: j,
        ...v && { "aria-labelledby": v },
        ...h && { "aria-describedby": h }
      },
      /* @__PURE__ */ l.createElement(
        U.div,
        {
          ...g,
          className: q(t, yS)
        },
        e
      )
    ));
  }
), ES = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(vS, { ref: n, asChild: !0 }, /* @__PURE__ */ l.createElement(U.button, { ...t }, e))), Fe = {
  Root: wS,
  Trigger: ES,
  Content: CS
};
var xS = "yco5bb0", SS = "yco5bb1", kS = "yco5bb2";
const TS = ({
  getIsKeyDownDisabled: e,
  items: t
}) => {
  const n = vr(), r = Rr();
  return l.useEffect(() => {
    const a = (s) => {
      const o = r.getItems() ?? [], i = !!(e != null && e());
      if (!(!o.length || i))
        switch (s.code) {
          case "ArrowDown":
          case "ArrowUp": {
            s.preventDefault(), n.setActiveOption((c) => {
              var f, m, b, _;
              if (!c) return;
              const u = s.code === "ArrowDown" ? c.index === o.length - 1 ? c.index : c.index + 1 : c.index === -1 ? o.length - 1 : c.index === 0 ? c.index : c.index - 1;
              return (_ = (b = (m = (f = o[u]) == null ? void 0 : f.ref) == null ? void 0 : m.current) == null ? void 0 : b.scrollIntoView) == null || _.call(b, {
                behavior: "auto",
                block: "nearest",
                inline: "nearest"
              }), {
                index: u,
                item: o[u]
              };
            });
            break;
          }
          case "Space":
          case "Enter": {
            s.preventDefault(), n.setOptionsSelected((c = []) => {
              var _, j, p, v;
              const { activeOption: u } = n, f = (j = (_ = u == null ? void 0 : u.item) == null ? void 0 : _.ref.current) == null ? void 0 : j.getAttribute(o7), m = (v = (p = u == null ? void 0 : u.item) == null ? void 0 : p.ref.current) == null ? void 0 : v.getAttribute("aria-label");
              if (!f || !m)
                return c;
              if (c.some((h) => h.value === f))
                return c.filter((h) => h.value !== f);
              const b = c ? [...c] : [];
              return b.push({ value: f, label: m }), b;
            });
            break;
          }
        }
    };
    return document.addEventListener("keydown", a), () => document.removeEventListener("keydown", a);
  }, [n, r]), /* @__PURE__ */ l.createElement("div", { className: xS }, /* @__PURE__ */ l.createElement(ju, { className: SS, options: t }, t.map((a) => /* @__PURE__ */ l.createElement(
    vu,
    {
      className: kS,
      key: a.value,
      value: a.value,
      label: a.label
    },
    /* @__PURE__ */ l.createElement(hu, null, a.label)
  ))));
};
var RS = "wvon2q0";
const OS = Fe.Trigger, MS = ({
  children: e,
  defaultOptionsSelected: t,
  isOpen: n,
  items: r,
  onIsOpenChange: a,
  onSelectedOptionsChange: s,
  optionsSelected: o,
  placeholder: i,
  searchable: c
}) => {
  const u = Te(null), [f, m] = nt({
    defaultProp: t,
    onChange: s,
    prop: o
  }), b = () => {
    var _;
    return c ? !0 : !((_ = u.current) != null && _.contains(document.activeElement));
  };
  return /* @__PURE__ */ d.createElement(Fe.Root, { isOpen: n, onIsOpenChange: a }, e, /* @__PURE__ */ d.createElement(Fe.Content, { align: "end", ref: u }, /* @__PURE__ */ d.createElement(
    _u,
    {
      optionsSelected: f,
      defaultOptionsSelected: t,
      onSelectedOptionsChange: m
    },
    c && /* @__PURE__ */ d.createElement("div", { className: RS }, /* @__PURE__ */ d.createElement(pu, { asChild: !0, options: r }, /* @__PURE__ */ d.createElement(pr, { placeholder: i }))),
    /* @__PURE__ */ d.createElement(
      TS,
      {
        items: r,
        getIsKeyDownDisabled: b
      }
    )
  )));
}, sD = ({
  "aria-label": e = "Filter",
  column: t,
  selector: n,
  searchable: r
}) => {
  const [a, s] = de(!1), o = t.getFilterValue(), i = t.getFacetedUniqueValues(), c = Le(() => {
    const m = {};
    return i.forEach((b, _) => {
      const j = String(n ? n(_) : _);
      m[j] = { value: j, label: j };
    }), Object.values(m);
  }, [i, n]), u = Le(() => o ? Array.from(o).map((m) => ({ value: m, label: m })) : [], [o]);
  le(() => {
    !a && (o == null ? void 0 : o.size) === c.length && t.setFilterValue(/* @__PURE__ */ new Set());
  }, [t, o == null ? void 0 : o.size, a, c.length]);
  const f = (m) => {
    t.setFilterValue(new Set(m.map(({ value: b }) => b)));
  };
  return /* @__PURE__ */ l.createElement(
    MS,
    {
      isOpen: a,
      items: c,
      onIsOpenChange: s,
      onSelectedOptionsChange: f,
      optionsSelected: u,
      searchable: r
    },
    /* @__PURE__ */ l.createElement(OS, { asChild: !0 }, /* @__PURE__ */ l.createElement(Me, { "aria-label": e, appearance: o != null && o.size ? "default" : "neutral" }, /* @__PURE__ */ l.createElement(me, { icon: $h })))
  );
};
/*!
 * Font Awesome Pro 5.15.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
var AS = {
  prefix: "fad",
  iconName: "sort",
  icon: [320, 512, [], "f0dc", ["M279.05 288.05h-238c-21.4 0-32.07 25.95-17 41l119.1 119 .1.1a23.9 23.9 0 0 0 33.8-.1l119-119c15.1-15.05 4.4-41-17-41zm-238-64h238c21.4 0 32.1-25.9 17-41l-119-119a.94.94 0 0 0-.1-.1 23.9 23.9 0 0 0-33.8.1l-119.1 119c-15.05 15.1-4.4 41 17 41z", ""]]
}, PS = {
  prefix: "fad",
  iconName: "sort-down",
  icon: [320, 512, [], "f0dd", ["M279.07 224.05h-238c-21.4 0-32.1-25.9-17-41l119-119a23.9 23.9 0 0 1 33.8-.1l.1.1 119.1 119c15.07 15.05 4.4 41-17 41z", "M296.07 329.05L177 448.05a23.9 23.9 0 0 1-33.8.1l-.1-.1-119-119c-15.1-15.1-4.4-41 17-41h238c21.37 0 32.04 25.95 16.97 41z"]]
}, NS = {
  prefix: "fad",
  iconName: "sort-up",
  icon: [320, 512, [], "f0de", ["M41.05 288.05h238c21.4 0 32.1 25.9 17 41l-119 119a23.9 23.9 0 0 1-33.8.1l-.1-.1-119.1-119c-15.05-15.05-4.4-41 17-41z", "M24.05 183.05l119.1-119A23.9 23.9 0 0 1 177 64a.94.94 0 0 1 .1.1l119 119c15.1 15.1 4.4 41-17 41h-238c-21.45-.05-32.1-25.95-17.05-41.05z"]]
};
const DS = ({ "aria-label": e = "Sort", direction: t, ...n }) => {
  const r = Le(() => t === "asc" ? /* @__PURE__ */ l.createElement(me, { icon: NS }) : t === "desc" ? /* @__PURE__ */ l.createElement(me, { icon: PS }) : /* @__PURE__ */ l.createElement(me, { icon: AS }), [t]);
  return /* @__PURE__ */ l.createElement(Me, { "aria-label": e, appearance: t ? "default" : "neutral", position: "relative", ...n }, r);
};
var IS = "_40d8uv0";
const $S = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ d.createElement("table", { ref: n, className: q(IS, e), ...t })
);
var LS = "_1lzly4v0";
const O7 = l.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ l.createElement("tbody", { ref: n, className: q(LS, e), ...t })
);
var zS = "_6c042j0 _1bsolbf0";
const Ll = d.forwardRef(
  ({
    align: e = "left",
    className: t,
    minWidth: n = "auto",
    shadowLeft: r,
    stickyRight: a,
    style: s,
    width: o,
    ...i
  }, c) => /* @__PURE__ */ d.createElement(
    "td",
    {
      ref: c,
      className: q(zS, t),
      "data-align": e,
      "data-shadow-left": r,
      "data-sticky-right": a,
      style: { minWidth: n, width: o, ...s },
      ...i
    }
  )
);
var FS = "_5m851z0 _1bsolbf0";
const HS = d.forwardRef(
  ({
    align: e = "left",
    className: t,
    minWidth: n = "auto",
    shadowLeft: r,
    stickyRight: a,
    style: s,
    onClick: o,
    width: i,
    ...c
  }, u) => {
    const f = o ? "pointer" : "default";
    return /* @__PURE__ */ d.createElement(
      "th",
      {
        ref: u,
        className: q(FS, t),
        "data-align": e,
        "data-shadow-left": r,
        "data-sticky-right": a,
        onClick: o,
        style: { minWidth: n, width: i, cursor: f, ...s },
        ...c
      }
    );
  }
), BS = d.forwardRef(
  (e, t) => /* @__PURE__ */ d.createElement("thead", { ref: t, ...e })
);
var qS = "_129ve5q0";
const Ks = d.forwardRef(
  ({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ d.createElement(
    "tr",
    {
      ref: r,
      "data-sub-row": t === "subrow",
      "data-header": t === "header",
      "data-expanded": t === "expanded",
      className: q(qS, e),
      ...n
    }
  )
), oD = ({
  table: e,
  clearFiltersButton: t,
  ...n
}) => /* @__PURE__ */ l.createElement(
  U.div,
  {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "medium",
    ...n
  },
  /* @__PURE__ */ l.createElement(ne, { styledAs: "body4" }, "No data exists."),
  t && /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(
    Et,
    {
      variant: "link",
      marginX: "xsmall",
      onClick: () => e.setColumnFilters([])
    },
    "Clear filters"
  ), /* @__PURE__ */ l.createElement(ne, { styledAs: "body4" }, "and try again."))
), US = l.forwardRef(
  ({
    isScrolledLeft: e,
    row: t,
    stickyLastColumn: n,
    renderSubComponent: r,
    onKeyDown: a,
    ...s
  }, o) => {
    const i = Le(() => r == null ? void 0 : r({ row: t }), [r, t]), c = t.getIsExpanded() && i, u = t.getVisibleCells();
    return /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(
      Ks,
      {
        ref: o,
        variant: c ? "expanded" : void 0,
        onKeyDown: a,
        tabIndex: a ? 0 : -1,
        ...s
      },
      u.map((f, m, b) => {
        var p, v;
        const _ = m === b.length - 1, { columnDef: j } = f.column;
        return /* @__PURE__ */ l.createElement(
          Ll,
          {
            key: f.id,
            align: (p = j.meta) == null ? void 0 : p.align,
            minWidth: j.minSize,
            shadowLeft: n && _ && e,
            stickyRight: n && _,
            width: ((v = j.meta) == null ? void 0 : v.width) ?? f.column.getSize()
          },
          Df(j.cell, f.getContext())
        );
      })
    ), c && /* @__PURE__ */ l.createElement(Ks, { variant: "subrow" }, /* @__PURE__ */ l.createElement(Ll, { colSpan: u.length }, i)));
  }
), WS = ({
  table: e,
  stickyLastColumn: t,
  isScrolledLeft: n,
  captureFocus: r,
  renderSubComponent: a,
  onRowKeyDown: s,
  ...o
}) => {
  const i = Te(null), c = e.getRowModel().rows, u = _e((b) => {
    var j;
    const _ = (j = i.current) == null ? void 0 : j.children[b];
    _ == null || _.focus();
  }, []), f = l.useCallback(
    (b) => {
      const _ = Number(b.currentTarget.getAttribute("data-index"));
      !s || isNaN(_) || (s(b, c[_]), (b.altKey && b.code === "ArrowDown" || b.code === "KeyJ") && (b.preventDefault(), u(_ + 1)), (b.altKey && b.code === "ArrowUp" || b.code === "KeyK") && (b.preventDefault(), u(_ - 1)));
    },
    [u, s, c]
  ), m = (b) => {
    if (!r) return;
    const _ = Number(b.currentTarget.getAttribute("data-index"));
    isNaN(_) || u(_);
  };
  return l.useEffect(() => {
    function b(_) {
      !s || !r || document.activeElement === document.body && (_.code === "KeyJ" || _.altKey && _.code === "ArrowDown") && u(0);
    }
    return document.body.addEventListener("keydown", b), () => {
      document.body.removeEventListener("keydown", b);
    };
  }, [r, u, s]), /* @__PURE__ */ l.createElement(O7, { ref: i, ...o }, c.map((b, _) => /* @__PURE__ */ l.createElement(
    US,
    {
      isScrolledLeft: n,
      key: b.id,
      onKeyDown: f,
      "data-index": _,
      onMouseEnter: m,
      renderSubComponent: a,
      row: b,
      stickyLastColumn: t
    }
  )));
};
var VS = "_7skz1p0", YS = "_7skz1p1", GS = "_7skz1p2";
const KS = (e, t, n) => e ? {
  cursor: n ? "grabbing" : "grab",
  ...t && {
    opacity: 0.5,
    backgroundColor: `rgba(${be.background.brand.default}, 0.1)`,
    outline: `2px solid rgb(${be.accent.blue.default})`,
    outlineOffset: "-2px"
  }
} : {}, XS = (e, t, n) => {
  const r = [...n], a = n.indexOf(e), s = n.indexOf(t);
  return r.splice(a, 1), r.splice(s, 0, e), r;
}, ZS = ({
  table: e,
  stickyLastColumn: t,
  isScrolledLeft: n,
  isHeaderRowSticky: r
}) => {
  const {
    dragStartData: a,
    dragOverData: s,
    handleDragEnd: o,
    handleDragLeave: i,
    handleDragOver: c,
    handleDragStart: u,
    handleDrop: f
  } = xj({
    onDrop(m, b) {
      if (!m || !b)
        return;
      const { getState: _, setColumnOrder: j } = e, { columnOrder: p } = _(), v = XS(
        m,
        b,
        p
      );
      j(v);
    }
  });
  return /* @__PURE__ */ l.createElement(BS, null, e.getHeaderGroups().map((m) => /* @__PURE__ */ l.createElement(Ks, { key: m.id, variant: "header" }, m.headers.map((b, _, j) => {
    var R, M, D, I, F, P;
    const p = _ === j.length - 1, {
      columnDef: v,
      getCanSort: h,
      getCanFilter: g,
      getToggleSortingHandler: w,
      getIsSorted: x
    } = b.column, y = v.enableSorting && h(), E = (R = v.meta) == null ? void 0 : R.Filter, C = E && v.filterFn && g(), S = (M = v.meta) == null ? void 0 : M.enableDragging, k = s === b.id, O = typeof a == "string", L = t && p, H = v.enableResizing && !L, T = !b.isPlaceholder && Df(v.header, b.getContext());
    return /* @__PURE__ */ l.createElement(
      HS,
      {
        key: b.id,
        align: (D = v.meta) == null ? void 0 : D.align,
        minWidth: v.minSize,
        scope: "col",
        shadowLeft: L && n,
        stickyRight: L,
        width: ((I = v.meta) == null ? void 0 : I.width) ?? b.getSize(),
        className: r ? GS : void 0
      },
      /* @__PURE__ */ l.createElement(
        U.div,
        {
          className: YS,
          draggable: S,
          onDragStart: S ? () => u(b.id) : void 0,
          onDragOver: S ? (A) => c(b.id, A) : void 0,
          onDragLeave: S ? () => i() : void 0,
          onDragEnd: S ? () => o() : void 0,
          onDrop: S ? (A) => f(b.id, A) : void 0,
          style: {
            ...KS(
              S ?? !1,
              k,
              O
            )
          }
        },
        /* @__PURE__ */ l.createElement(
          U.span,
          {
            style: {
              whiteSpace: "nowrap",
              // `<Text truncate />`/`<Truncate />` doesn't work well here.
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            ...typeof T == "string" && {
              title: T
            }
          },
          T
        ),
        y && /* @__PURE__ */ l.createElement(
          DS,
          {
            "aria-label": (F = v.meta) == null ? void 0 : F.sortLabel,
            onClick: w(),
            marginLeft: "small",
            direction: x()
          }
        ),
        C && /* @__PURE__ */ l.createElement(U.span, null, /* @__PURE__ */ l.createElement(E, { ...b.getContext() })),
        ((P = v.meta) == null ? void 0 : P.PopoverContent) && /* @__PURE__ */ l.createElement(Fe.Root, null, /* @__PURE__ */ l.createElement(Fe.Trigger, { asChild: !0 }, /* @__PURE__ */ l.createElement(Me, { "aria-label": "Column menu" }, /* @__PURE__ */ l.createElement(me, { icon: Dh }))), /* @__PURE__ */ l.createElement(Fe.Content, null, /* @__PURE__ */ l.createElement(
          v.meta.PopoverContent,
          {
            ...b.getContext()
          }
        )))
      ),
      H && /* @__PURE__ */ l.createElement(
        U.span,
        {
          "data-testid": "resizer",
          onMouseDown: b.getResizeHandler(),
          className: VS
        }
      )
    );
  }))));
};
var JS = "_1itwrj90";
const iD = ({
  caption: e,
  onRowKeyDown: t,
  renderSubComponent: n,
  stickyLastColumn: r,
  isHeaderRowSticky: a,
  skeletonRows: s,
  table: o,
  className: i,
  Footer: c,
  verticalAlign: u = "middle",
  captureFocus: f = !0,
  ...m
}) => {
  const b = d.useRef(null), [_, j] = d.useState(!1);
  Zx(b, j);
  const p = Xx();
  d.useEffect(() => {
    (() => {
      const x = o.getAllColumns().reduce((y, E) => {
        var S;
        const C = (S = E.columnDef.meta) == null ? void 0 : S.minBreakpoint;
        return y[E.id] = C ? p[C] : !0, y;
      }, {});
      o.setColumnVisibility(x);
    })();
  }, [o, p]);
  const v = d.useCallback(
    (w) => {
      const { scrollLeft: x, clientWidth: y, scrollWidth: E } = w.target;
      j(Math.ceil(x + y) < E);
    },
    [j]
  ), h = d.useMemo(() => {
    if (s)
      return /* @__PURE__ */ d.createElement(O7, null, [...Array(s).keys()].map((w) => /* @__PURE__ */ d.createElement(Ks, { key: `skeleton-${w}` }, /* @__PURE__ */ d.createElement(Ll, { colSpan: "100%" }, /* @__PURE__ */ d.createElement(Qx, null)))));
  }, [s]), g = o.getFlatHeaders().some((w) => w.column.columnDef.enableResizing);
  return /* @__PURE__ */ d.createElement(
    U.div,
    {
      className: q(JS, i),
      onScroll: v,
      ref: b,
      ...m
    },
    /* @__PURE__ */ d.createElement(
      $S,
      {
        style: {
          ...g && {
            width: o.getCenterTotalSize(),
            tableLayout: "fixed"
          },
          ...a && {
            borderCollapse: "separate",
            borderSpacing: 0
          }
        }
      },
      e && /* @__PURE__ */ d.createElement("caption", null, e),
      /* @__PURE__ */ d.createElement(
        ZS,
        {
          table: o,
          isScrolledLeft: _,
          stickyLastColumn: r,
          isHeaderRowSticky: a
        }
      ),
      h ?? /* @__PURE__ */ d.createElement(
        WS,
        {
          table: o,
          isScrolledLeft: _,
          stickyLastColumn: r,
          onRowKeyDown: t,
          renderSubComponent: n,
          captureFocus: f,
          style: { verticalAlign: u }
        }
      ),
      c && /* @__PURE__ */ d.createElement(
        c,
        {
          table: o,
          isScrolledLeft: _,
          stickyLastColumn: r
        }
      )
    )
  );
};
var M7 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(In, function() {
    var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, a = /([+-]|\d\d)/g;
    return function(s, o, i) {
      var c = o.prototype;
      i.utc = function(p) {
        var v = { date: p, utc: !0, args: arguments };
        return new o(v);
      }, c.utc = function(p) {
        var v = i(this.toDate(), { locale: this.$L, utc: !0 });
        return p ? v.add(this.utcOffset(), n) : v;
      }, c.local = function() {
        return i(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var u = c.parse;
      c.parse = function(p) {
        p.utc && (this.$u = !0), this.$utils().u(p.$offset) || (this.$offset = p.$offset), u.call(this, p);
      };
      var f = c.init;
      c.init = function() {
        if (this.$u) {
          var p = this.$d;
          this.$y = p.getUTCFullYear(), this.$M = p.getUTCMonth(), this.$D = p.getUTCDate(), this.$W = p.getUTCDay(), this.$H = p.getUTCHours(), this.$m = p.getUTCMinutes(), this.$s = p.getUTCSeconds(), this.$ms = p.getUTCMilliseconds();
        } else f.call(this);
      };
      var m = c.utcOffset;
      c.utcOffset = function(p, v) {
        var h = this.$utils().u;
        if (h(p)) return this.$u ? 0 : h(this.$offset) ? m.call(this) : this.$offset;
        if (typeof p == "string" && (p = function(y) {
          y === void 0 && (y = "");
          var E = y.match(r);
          if (!E) return null;
          var C = ("" + E[0]).match(a) || ["-", 0, 0], S = C[0], k = 60 * +C[1] + +C[2];
          return k === 0 ? 0 : S === "+" ? k : -k;
        }(p), p === null)) return this;
        var g = Math.abs(p) <= 16 ? 60 * p : p, w = this;
        if (v) return w.$offset = g, w.$u = p === 0, w;
        if (p !== 0) {
          var x = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (w = this.local().add(g + x, n)).$offset = g, w.$x.$localOffset = x;
        } else w = this.utc();
        return w;
      };
      var b = c.format;
      c.format = function(p) {
        var v = p || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return b.call(this, v);
      }, c.valueOf = function() {
        var p = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * p;
      }, c.isUTC = function() {
        return !!this.$u;
      }, c.toISOString = function() {
        return this.toDate().toISOString();
      }, c.toString = function() {
        return this.toDate().toUTCString();
      };
      var _ = c.toDate;
      c.toDate = function(p) {
        return p === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : _.call(this);
      };
      var j = c.diff;
      c.diff = function(p, v, h) {
        if (p && this.$u === p.$u) return j.call(this, p, v, h);
        var g = this.local(), w = i(p).local();
        return j.call(g, w, v, h);
      };
    };
  });
})(M7);
var QS = M7.exports;
const A7 = /* @__PURE__ */ jn(QS);
var P7 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(In, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, r = {};
    return function(a, s, o) {
      var i, c = function(b, _, j) {
        j === void 0 && (j = {});
        var p = new Date(b), v = function(h, g) {
          g === void 0 && (g = {});
          var w = g.timeZoneName || "short", x = h + "|" + w, y = r[x];
          return y || (y = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: h, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: w }), r[x] = y), y;
        }(_, j);
        return v.formatToParts(p);
      }, u = function(b, _) {
        for (var j = c(b, _), p = [], v = 0; v < j.length; v += 1) {
          var h = j[v], g = h.type, w = h.value, x = n[g];
          x >= 0 && (p[x] = parseInt(w, 10));
        }
        var y = p[3], E = y === 24 ? 0 : y, C = p[0] + "-" + p[1] + "-" + p[2] + " " + E + ":" + p[4] + ":" + p[5] + ":000", S = +b;
        return (o.utc(C).valueOf() - (S -= S % 1e3)) / 6e4;
      }, f = s.prototype;
      f.tz = function(b, _) {
        b === void 0 && (b = i);
        var j = this.utcOffset(), p = this.toDate(), v = p.toLocaleString("en-US", { timeZone: b }), h = Math.round((p - new Date(v)) / 1e3 / 60), g = o(v).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(p.getTimezoneOffset() / 15) - h, !0);
        if (_) {
          var w = g.utcOffset();
          g = g.add(j - w, "minute");
        }
        return g.$x.$timezone = b, g;
      }, f.offsetName = function(b) {
        var _ = this.$x.$timezone || o.tz.guess(), j = c(this.valueOf(), _, { timeZoneName: b }).find(function(p) {
          return p.type.toLowerCase() === "timezonename";
        });
        return j && j.value;
      };
      var m = f.startOf;
      f.startOf = function(b, _) {
        if (!this.$x || !this.$x.$timezone) return m.call(this, b, _);
        var j = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"));
        return m.call(j, b, _).tz(this.$x.$timezone, !0);
      }, o.tz = function(b, _, j) {
        var p = j && _, v = j || _ || i, h = u(+o(), v);
        if (typeof b != "string") return o(b).tz(v);
        var g = function(E, C, S) {
          var k = E - 60 * C * 1e3, O = u(k, S);
          if (C === O) return [k, C];
          var L = u(k -= 60 * (O - C) * 1e3, S);
          return O === L ? [k, O] : [E - 60 * Math.min(O, L) * 1e3, Math.max(O, L)];
        }(o.utc(b, p).valueOf(), h, v), w = g[0], x = g[1], y = o(w).utcOffset(x);
        return y.$x.$timezone = v, y;
      }, o.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, o.tz.setDefault = function(b) {
        i = b;
      };
    };
  });
})(P7);
var ek = P7.exports;
const tk = /* @__PURE__ */ jn(ek);
var N7 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(In, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(r, a, s) {
      var o = a.prototype, i = o.format;
      s.en.formats = n, o.format = function(c) {
        c === void 0 && (c = "YYYY-MM-DDTHH:mm:ssZ");
        var u = this.$locale().formats, f = function(m, b) {
          return m.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(_, j, p) {
            var v = p && p.toUpperCase();
            return j || b[p] || n[p] || b[v].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(h, g, w) {
              return g || w.slice(1);
            });
          });
        }(c, u === void 0 ? {} : u);
        return i.call(this, f);
      };
    };
  });
})(N7);
var nk = N7.exports;
const rk = /* @__PURE__ */ jn(nk);
var D7 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(In, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, a = /\d\d/, s = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, i = {}, c = function(p) {
      return (p = +p) + (p > 68 ? 1900 : 2e3);
    }, u = function(p) {
      return function(v) {
        this[p] = +v;
      };
    }, f = [/[+-]\d\d:?(\d\d)?|Z/, function(p) {
      (this.zone || (this.zone = {})).offset = function(v) {
        if (!v || v === "Z") return 0;
        var h = v.match(/([+-]|\d\d)/g), g = 60 * h[1] + (+h[2] || 0);
        return g === 0 ? 0 : h[0] === "+" ? -g : g;
      }(p);
    }], m = function(p) {
      var v = i[p];
      return v && (v.indexOf ? v : v.s.concat(v.f));
    }, b = function(p, v) {
      var h, g = i.meridiem;
      if (g) {
        for (var w = 1; w <= 24; w += 1) if (p.indexOf(g(w, 0, v)) > -1) {
          h = w > 12;
          break;
        }
      } else h = p === (v ? "pm" : "PM");
      return h;
    }, _ = { A: [o, function(p) {
      this.afternoon = b(p, !1);
    }], a: [o, function(p) {
      this.afternoon = b(p, !0);
    }], S: [/\d/, function(p) {
      this.milliseconds = 100 * +p;
    }], SS: [a, function(p) {
      this.milliseconds = 10 * +p;
    }], SSS: [/\d{3}/, function(p) {
      this.milliseconds = +p;
    }], s: [s, u("seconds")], ss: [s, u("seconds")], m: [s, u("minutes")], mm: [s, u("minutes")], H: [s, u("hours")], h: [s, u("hours")], HH: [s, u("hours")], hh: [s, u("hours")], D: [s, u("day")], DD: [a, u("day")], Do: [o, function(p) {
      var v = i.ordinal, h = p.match(/\d+/);
      if (this.day = h[0], v) for (var g = 1; g <= 31; g += 1) v(g).replace(/\[|\]/g, "") === p && (this.day = g);
    }], M: [s, u("month")], MM: [a, u("month")], MMM: [o, function(p) {
      var v = m("months"), h = (m("monthsShort") || v.map(function(g) {
        return g.slice(0, 3);
      })).indexOf(p) + 1;
      if (h < 1) throw new Error();
      this.month = h % 12 || h;
    }], MMMM: [o, function(p) {
      var v = m("months").indexOf(p) + 1;
      if (v < 1) throw new Error();
      this.month = v % 12 || v;
    }], Y: [/[+-]?\d+/, u("year")], YY: [a, function(p) {
      this.year = c(p);
    }], YYYY: [/\d{4}/, u("year")], Z: f, ZZ: f };
    function j(p) {
      var v, h;
      v = p, h = i && i.formats;
      for (var g = (p = v.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(k, O, L) {
        var H = L && L.toUpperCase();
        return O || h[L] || n[L] || h[H].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(T, R, M) {
          return R || M.slice(1);
        });
      })).match(r), w = g.length, x = 0; x < w; x += 1) {
        var y = g[x], E = _[y], C = E && E[0], S = E && E[1];
        g[x] = S ? { regex: C, parser: S } : y.replace(/^\[|\]$/g, "");
      }
      return function(k) {
        for (var O = {}, L = 0, H = 0; L < w; L += 1) {
          var T = g[L];
          if (typeof T == "string") H += T.length;
          else {
            var R = T.regex, M = T.parser, D = k.slice(H), I = R.exec(D)[0];
            M.call(O, I), k = k.replace(I, "");
          }
        }
        return function(F) {
          var P = F.afternoon;
          if (P !== void 0) {
            var A = F.hours;
            P ? A < 12 && (F.hours += 12) : A === 12 && (F.hours = 0), delete F.afternoon;
          }
        }(O), O;
      };
    }
    return function(p, v, h) {
      h.p.customParseFormat = !0, p && p.parseTwoDigitYear && (c = p.parseTwoDigitYear);
      var g = v.prototype, w = g.parse;
      g.parse = function(x) {
        var y = x.date, E = x.utc, C = x.args;
        this.$u = E;
        var S = C[1];
        if (typeof S == "string") {
          var k = C[2] === !0, O = C[3] === !0, L = k || O, H = C[2];
          O && (H = C[2]), i = this.$locale(), !k && H && (i = h.Ls[H]), this.$d = function(D, I, F) {
            try {
              if (["x", "X"].indexOf(I) > -1) return new Date((I === "X" ? 1e3 : 1) * D);
              var P = j(I)(D), A = P.year, $ = P.month, B = P.day, Y = P.hours, J = P.minutes, W = P.seconds, V = P.milliseconds, K = P.zone, te = /* @__PURE__ */ new Date(), Z = B || (A || $ ? 1 : te.getDate()), se = A || te.getFullYear(), ue = 0;
              A && !$ || (ue = $ > 0 ? $ - 1 : te.getMonth());
              var X = Y || 0, ie = J || 0, Ce = W || 0, ge = V || 0;
              return K ? new Date(Date.UTC(se, ue, Z, X, ie, Ce, ge + 60 * K.offset * 1e3)) : F ? new Date(Date.UTC(se, ue, Z, X, ie, Ce, ge)) : new Date(se, ue, Z, X, ie, Ce, ge);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(y, S, E), this.init(), H && H !== !0 && (this.$L = this.locale(H).$L), L && y != this.format(S) && (this.$d = /* @__PURE__ */ new Date("")), i = {};
        } else if (S instanceof Array) for (var T = S.length, R = 1; R <= T; R += 1) {
          C[1] = S[R - 1];
          var M = h.apply(this, C);
          if (M.isValid()) {
            this.$d = M.$d, this.$L = M.$L, this.init();
            break;
          }
          R === T && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else w.call(this, x);
      };
    };
  });
})(D7);
var ak = D7.exports;
const I7 = /* @__PURE__ */ jn(ak);
var Dt = /* @__PURE__ */ ((e) => (e.MOVE_RIGHT = "MOVE_RIGHT", e.MOVE_LEFT = "MOVE_LEFT", e.MOVE_UP = "MOVE_UP", e.MOVE_DOWN = "MOVE_DOWN", e.PAGE_UP = "PAGE_UP", e.PAGE_DOWN = "PAGE_DOWN", e.SET_ACTIVE_CELL = "SET_ACTIVE_CELL", e))(Dt || {});
function sk(e, t) {
  var r, a;
  const n = e.activeCell.cell;
  switch (t.payload.timeType) {
    case "hours": {
      const s = n[1] + 1, o = e.timeMatrix[0].length - 1;
      return {
        ...e,
        activeCell: {
          cell: [0, s > o ? o : s],
          timeType: "hours",
          focus: !0
        }
      };
    }
    case "minutes": {
      const s = n[1] + 1, o = e.timeMatrix[1].length - 1;
      return {
        ...e,
        activeCell: {
          cell: [
            1,
            s > o ? o : s
          ],
          timeType: "minutes",
          focus: !0
        }
      };
    }
    case "seconds": {
      if (e.timeMatrix[2]) {
        const s = n[1] + 1, o = ((r = e.timeMatrix) == null ? void 0 : r[2].length) - 1;
        return {
          ...e,
          activeCell: {
            cell: [
              2,
              s > o ? o : s
            ],
            timeType: "seconds",
            focus: !0
          }
        };
      }
      return e;
    }
    case "amPM": {
      const s = e.timeMatrix.length - 1;
      if (e.timeMatrix[s] && e.timeMatrix[s].length === 2) {
        const o = n[1] + 1, i = ((a = e.timeMatrix) == null ? void 0 : a[s].length) - 1;
        return {
          ...e,
          activeCell: {
            cell: [
              s,
              o > i ? i : o
            ],
            timeType: "amPM",
            focus: !0
          }
        };
      }
      return e;
    }
  }
}
function ok(e, t) {
  const n = e.activeCell.cell;
  switch (t.payload.timeType) {
    case "hours": {
      const r = n[1] - 1, a = 0;
      return {
        ...e,
        activeCell: {
          cell: [0, r < a ? a : r],
          timeType: "hours",
          focus: !0
        }
      };
    }
    case "minutes": {
      const r = n[1] - 1, a = 0;
      return {
        ...e,
        activeCell: {
          cell: [
            1,
            r < a ? a : r
          ],
          timeType: "minutes",
          focus: !0
        }
      };
    }
    case "seconds": {
      if (e.timeMatrix[2]) {
        const r = n[1] - 1, a = 0;
        return {
          ...e,
          activeCell: {
            cell: [
              2,
              r < a ? a : r
            ],
            timeType: "seconds",
            focus: !0
          }
        };
      }
      return e;
    }
    case "amPM": {
      const r = e.timeMatrix.length - 1;
      if (e.timeMatrix[r] && e.timeMatrix[r].length === 2) {
        const a = n[1] - 1, s = 0;
        return {
          ...e,
          activeCell: {
            cell: [
              r,
              a < s ? s : a
            ],
            timeType: "amPM",
            focus: !0
          }
        };
      }
      return e;
    }
  }
}
function ik(e, t) {
  var n, r, a, s, o, i, c, u;
  switch (t.payload.timeType) {
    case "hours": {
      let f = [1, 0];
      if ((n = t.payload.currentValue) != null && n.minutes) {
        const { minutes: m } = t.payload.currentValue;
        f = [1, e.timeMatrix[1].findIndex(
          (_) => _ === m
        )];
      }
      return {
        ...e,
        activeCell: {
          cell: f,
          timeType: "minutes",
          focus: !0
        }
      };
    }
    case "minutes": {
      if (e.timeMatrix.length > 2) {
        let f = [2, 0], m = "seconds";
        if (((a = (r = e.timeMatrix) == null ? void 0 : r[2]) == null ? void 0 : a.length) === 2)
          if ((s = t.payload.currentValue) != null && s.amPM) {
            const { amPM: b } = t.payload.currentValue;
            f = [2, e.timeMatrix[2].findIndex((j) => j === b) || 0], m = "amPM";
          } else
            f = [2, 0], m = "amPM";
        else if ((o = t.payload.currentValue) != null && o.seconds) {
          const { seconds: b } = t.payload.currentValue;
          f = [2, ((c = (i = e.timeMatrix) == null ? void 0 : i[2]) == null ? void 0 : c.findIndex(
            (j) => j === b
          )) || 0], m = "seconds";
        } else
          f = [2, 0], m = "seconds";
        return {
          ...e,
          activeCell: {
            cell: f,
            timeType: m,
            focus: !0
          }
        };
      }
      return e;
    }
    case "seconds": {
      if (e.timeMatrix[e.timeMatrix.length - 1].length === 2) {
        let f = [3, 0];
        if ((u = t.payload.currentValue) != null && u.amPM) {
          const { amPM: m } = t.payload.currentValue;
          f = [3, e.timeMatrix[e.timeMatrix.length - 1].findIndex((_) => _ === m)];
        }
        return {
          ...e,
          activeCell: {
            cell: f,
            timeType: "amPM",
            focus: !0
          }
        };
      }
      return e;
    }
    case "amPM":
      return e;
  }
}
function lk(e, t) {
  var n, r, a, s, o, i, c, u;
  switch (t.payload.timeType) {
    case "hours":
      return e;
    case "minutes": {
      let f = [0, 0];
      if ((n = t.payload.currentValue) != null && n.hours) {
        const { hours: m } = t.payload.currentValue;
        f = [0, e.timeMatrix[0].findIndex((_) => _ === m)];
      }
      return {
        ...e,
        activeCell: {
          cell: f,
          timeType: "hours",
          focus: !0
        }
      };
    }
    case "seconds": {
      if (e.timeMatrix.length > 2) {
        let f = [1, 0];
        if ((r = t.payload.currentValue) != null && r.minutes) {
          const { minutes: m } = t.payload.currentValue;
          f = [1, e.timeMatrix[1].findIndex(
            (_) => _ === m
          )];
        }
        return {
          ...e,
          activeCell: {
            cell: f,
            timeType: "minutes",
            focus: !0
          }
        };
      }
      return e;
    }
    case "amPM": {
      if (e.timeMatrix[e.timeMatrix.length - 1].length === 2) {
        let f = [e.timeMatrix.length - 2, 0], m = "seconds";
        if ((a = t.payload.currentValue) != null && a.seconds) {
          const { seconds: b } = t.payload.currentValue, _ = (o = (s = e.timeMatrix) == null ? void 0 : s[e.timeMatrix.length - 2]) == null ? void 0 : o.findIndex((j) => j === b);
          f = [e.timeMatrix.length - 2, _ || 0];
        } else if ((i = t.payload.currentValue) != null && i.minutes) {
          const { minutes: b } = t.payload.currentValue, _ = (u = (c = e.timeMatrix) == null ? void 0 : c[e.timeMatrix.length - 2]) == null ? void 0 : u.findIndex((j) => j === b);
          f = [e.timeMatrix.length - 2, _ || 0], m = "minutes";
        }
        return {
          ...e,
          activeCell: {
            cell: f,
            timeType: m,
            focus: !0
          }
        };
      }
      return e;
    }
  }
}
function ck(e, t) {
  switch (t.payload.timeType) {
    case "hours":
      return {
        ...e,
        activeCell: {
          ...e.activeCell,
          cell: [0, 0],
          focus: !0
        }
      };
    case "minutes":
      return {
        ...e,
        activeCell: {
          ...e.activeCell,
          cell: [1, 0],
          focus: !0
        }
      };
    case "seconds":
      return {
        ...e,
        activeCell: {
          ...e.activeCell,
          cell: [2, 0],
          focus: !0
        }
      };
    case "amPM":
      return {
        ...e,
        activeCell: {
          ...e.activeCell,
          cell: [e.timeMatrix.length - 1, 0],
          focus: !0
        }
      };
  }
}
function uk(e, t) {
  switch (t.payload.timeType) {
    case "hours":
      return {
        ...e,
        activeCell: {
          ...e.activeCell,
          cell: [0, e.timeMatrix[0].length - 1],
          focus: !0
        }
      };
    case "minutes":
      return {
        ...e,
        activeCell: {
          ...e.activeCell,
          cell: [1, e.timeMatrix[1].length - 1],
          focus: !0
        }
      };
    case "seconds": {
      if (e.timeMatrix[2]) {
        const n = e.timeMatrix[2].length - 1;
        return {
          ...e,
          activeCell: {
            ...e.activeCell,
            cell: [2, n],
            focus: !0
          }
        };
      }
      return e;
    }
    case "amPM":
      return {
        ...e,
        activeCell: {
          ...e.activeCell,
          cell: [e.timeMatrix.length - 1, 1],
          focus: !0
        }
      };
  }
}
function dk(e, t) {
  switch (t.type) {
    case "MOVE_RIGHT":
      return ik(e, t);
    case "MOVE_LEFT":
      return lk(e, t);
    case "MOVE_UP":
      return ok(e, t);
    case "MOVE_DOWN":
      return sk(e, t);
    case "PAGE_UP":
      return ck(e, t);
    case "PAGE_DOWN":
      return uk(e, t);
    case "SET_ACTIVE_CELL":
      return {
        ...e,
        activeCell: {
          ...e.activeCell,
          ...t.payload
        }
      };
  }
}
const Dd = [...Array(12).keys()].map(
  (e) => `${e + 1}`.padStart(2, "0")
), Id = [...Array(24).keys()].map(
  (e) => `${e}`.padStart(2, "0")
), is = [...Array(60).keys()].map((e) => `${e}`.padStart(2, "0")), $d = [...Array(60).keys()].map((e) => `${e}`.padStart(2, "0")), Ld = ["AM", "PM"], fk = /(?<hours>\d{1,2}):?(?<minutes>[0-5]\d)?:?(?<seconds>[0-5]\d)?\s*(?<amPM>[a|p|A|P]\.?[m|M])?/i;
var Be = /* @__PURE__ */ ((e) => (e.TwelveHour = "12hour", e.TwentyFourHour = "24hour", e.TwelveHourWithSeconds = "12hourWithSeconds", e.TwentyFourHourWithSeconds = "24hourWithSeconds", e))(Be || {});
function bk({
  time: e,
  timeType: t,
  min: n,
  max: r,
  value: a
}) {
  if (t === "amPM")
    return !1;
  if (n || r) {
    const s = parseInt(e, 10);
    if (t === "hours")
      return n && Yn(
        { hours: e, amPM: a == null ? void 0 : a.amPM },
        { hours: n.hours, amPM: n.amPM }
      ) && (n != null && n.minutes && parseInt(n.minutes, 10) > 0) || r && Yn(
        { hours: e, amPM: a == null ? void 0 : a.amPM },
        { hours: r.hours, amPM: r.amPM }
      ) && (r != null && r.minutes && parseInt(r.minutes, 10) > 0) ? !1 : n && ys({ hours: e, amPM: a == null ? void 0 : a.amPM }, n) || r && ws({ hours: e, amPM: a == null ? void 0 : a.amPM }, r);
    if (t === "minutes") {
      const o = { hours: a == null ? void 0 : a.hours, amPM: a == null ? void 0 : a.amPM };
      if (n && ys(o, { hours: n.hours, amPM: n.amPM }))
        return !0;
      if (n && Yn(o, { hours: n.hours, amPM: n.amPM })) {
        const i = parseInt(n[t], 10);
        return s < i;
      } else {
        if (r && ws(o, { hours: r.hours, amPM: r.amPM }))
          return !0;
        if (r && Yn(o, { hours: r.hours, amPM: r.amPM })) {
          const i = parseInt(r[t], 10);
          return s > i;
        }
      }
    } else if (t === "seconds") {
      const o = {
        hours: a == null ? void 0 : a.hours,
        minutes: a == null ? void 0 : a.minutes,
        amPM: a == null ? void 0 : a.amPM
      };
      if (n && ys(o, {
        hours: n.hours,
        minutes: n.minutes,
        amPM: n.amPM
      }))
        return !0;
      if (n && Yn(o, {
        hours: n.hours,
        minutes: n.minutes,
        amPM: n.amPM
      })) {
        const i = parseInt(n[t], 10);
        return s < i;
      } else {
        if (r && ws(o, {
          hours: r.hours,
          minutes: r.minutes,
          amPM: r.amPM
        }))
          return !0;
        if (r && Yn(o, {
          hours: r.hours,
          minutes: r.minutes,
          amPM: r.amPM
        })) {
          const i = parseInt(r[t], 10);
          return s > i;
        }
      }
    }
  }
  return !1;
}
function ot(e) {
  var r, a;
  const t = (r = e.match(fk)) == null ? void 0 : r.groups, n = ((a = e.match(/:/g)) == null ? void 0 : a.length) ?? 0;
  if (t != null && t.amPM && (t.amPM = t.amPM.replace(/\./g, "").toUpperCase()), !t || n === 1 && !t.minutes || n === 2 && !t.minutes && !t.seconds)
    throw new Error(
      "Invalid Time - Expected time to conform to either 12 or 24 hour clock refer to ISO 8601"
    );
  if (t.hours) {
    const s = parseInt(t.hours, 10);
    if (s > 12 && t.amPM)
      throw new Error(
        "Invalid Time - Expected hours to conform to 12Hour clock with amPM set"
      );
    if (s > 23)
      throw new Error(
        "Invalid Time - Expected hours to conform to 24Hour clock"
      );
  }
  return t;
}
function mk(e) {
  switch (e) {
    case "12hour":
      return [Dd, is, Ld];
    case "12hourWithSeconds":
      return [Dd, is, $d, Ld];
    case "24hour":
      return [Id, is];
    case "24hourWithSeconds":
      return [Id, is, $d];
  }
}
function $7(e) {
  switch (e) {
    case "12hour":
      return "hh:mm A";
    case "12hourWithSeconds":
      return "hh:mm:ss A";
    case "24hour":
      return "HH:mm";
    case "24hourWithSeconds":
      return "HH:mm:ss";
  }
}
function L7(e, t) {
  let n = {
    cell: [0, 0],
    timeType: "hours",
    focus: !1
  };
  const r = mk(e);
  return t != null && t.defaultValue && (n = {
    cell: [
      0,
      r[0].findIndex((a) => {
        var s;
        return a === ((s = t == null ? void 0 : t.defaultValue) == null ? void 0 : s.hours);
      }) || 0
    ],
    timeType: "hours",
    focus: !1
  }), {
    activeCell: n,
    timeMatrix: r
  };
}
function Rt(e, t = "00") {
  return e ? e.padStart(2, "0") : t;
}
function Lt(e, t) {
  var n, r;
  if (e === "12hour" || e === "12hourWithSeconds") {
    let a, s;
    return t != null && t.hours ? (a = parseInt(t == null ? void 0 : t.hours, 10), t.amPM ? s = t.amPM.toUpperCase() : a === 0 ? (a = 12, s = "AM") : a > 12 ? (a = a - 12, s = "PM") : s = "AM") : (a = 12, s = "AM"), e === "12hour" ? `${Rt(`${a}`)}:${Rt(
      t == null ? void 0 : t.minutes
    )} ${s}` : `${Rt(`${a}`)}:${Rt(
      t == null ? void 0 : t.minutes
    )}:${Rt(t == null ? void 0 : t.seconds)} ${s}`;
  } else {
    let a = t != null && t.hours ? parseInt(t == null ? void 0 : t.hours, 10) : 0;
    return ((n = t == null ? void 0 : t.amPM) == null ? void 0 : n.toUpperCase()) === "PM" && a !== 12 ? a = a + 12 : ((r = t == null ? void 0 : t.amPM) == null ? void 0 : r.toUpperCase()) === "AM" && a == 12 && (a = 0), e === "24hour" ? `${Rt(`${a}`)}:${Rt(
      t == null ? void 0 : t.minutes
    )}` : `${Rt(`${a}`)}:${Rt(
      t == null ? void 0 : t.minutes
    )}:${Rt(t == null ? void 0 : t.seconds)}`;
  }
}
function ys(e, t) {
  const n = _n(e), r = _n(t);
  return n < r;
}
function Yn(e, t) {
  const n = _n(e), r = _n(t);
  return n === r;
}
function ws(e, t) {
  const n = _n(e), r = _n(t);
  return n > r;
}
function _n(e) {
  var a, s;
  let t = e.hours ? parseInt(e.hours, 10) : 0;
  t !== 12 && ((a = e.amPM) == null ? void 0 : a.toUpperCase()) === "PM" && (t = t + 12), t === 12 && ((s = e.amPM) == null ? void 0 : s.toUpperCase()) === "AM" && (t = 0);
  const n = e.minutes ? parseInt(e.minutes) : 0, r = e.seconds ? parseInt(e.seconds) : 0;
  return t * 60 * 60 + n * 60 + r;
}
function _k(e, t) {
  const n = _n(e), r = _n(t);
  return (n - r) / 60 / 60;
}
const pk = (e, t) => {
  let n = Number(t.hours);
  return n === 12 && t.amPM === "AM" && (n = 0), n !== 12 && t.amPM === "PM" && (n += 12), Q(e).set("hour", n).set("minute", Number(t.minutes)).set("second", Number(t.seconds));
};
var jk = "yg2mxv1", vk = "yg2mxv2", hk = "yg2mxv3", gk = "yg2mxv5 yg2mxv4 _1s8b37j25m _1s8b37j270 _1s8b37j284 _1s8b37j23y _1s8b37jkl _1s8b37jkp _1s8b37jkt _1s8b37jkx _1s8b37jao _1s8b37j8h _1s8b37j8i _1s8b37jl7 _1s8b37jl8 _1s8b37jy5 _1s8b37jg _1s8b37j2vq";
const zd = 0, Fd = 1, Hd = 2, z7 = l.createContext({
  state: L7(Be.TwelveHour),
  dispatch: () => {
  },
  updateValue: () => {
  }
}), Pa = () => l.useContext(z7), yk = ({
  children: e,
  className: t,
  defaultValue: n,
  focusOnMount: r = !1,
  format: a = Be.TwelveHour,
  max: s,
  min: o,
  value: i,
  onValueChange: c,
  ...u
}) => {
  const f = l.useRef(), [m, b] = l.useReducer(
    dk,
    L7(a, { defaultValue: n || i })
  ), [_, j] = nt({
    prop: i,
    defaultProp: n,
    onChange: c
  });
  l.useEffect(() => {
    f.current = i;
  }, [i]);
  const p = l.useMemo(() => {
    const v = {};
    if (f.current && i)
      for (const [h, g] of Object.entries(i))
        f.current[h] !== g && (v[h] = g);
    return v;
  }, [f, i]);
  return /* @__PURE__ */ l.createElement(
    z7.Provider,
    {
      value: {
        state: m,
        dispatch: b,
        focusOnMount: r,
        format: a,
        max: s,
        min: o,
        value: _,
        valueDiff: p,
        updateValue: j
      }
    },
    /* @__PURE__ */ l.createElement(
      re,
      {
        ...u,
        gap: "zero",
        yAlign: "top",
        className: q(t, jk)
      },
      e
    )
  );
}, Oo = l.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(ye, { gap: "zero", yAlign: "top", asChild: !0 }, /* @__PURE__ */ l.createElement(
    "ul",
    {
      ...n,
      ref: r,
      role: "listbox",
      className: q(t, vk)
    },
    e
  ))
), Mo = l.forwardRef(
  ({ className: e, cell: t, time: n, timeType: r, ...a }, s) => {
    const o = l.useRef(!1), i = l.useRef(null), {
      state: { activeCell: c },
      dispatch: u,
      focusOnMount: f,
      max: m,
      min: b,
      value: _,
      valueDiff: j,
      updateValue: p
    } = Pa(), v = l.useMemo(() => c == null ? void 0 : c.cell.every((k, O) => t[O] === k), [c, t]), h = l.useMemo(() => (_ == null ? void 0 : _[r]) === n, [_, n, r]), g = l.useMemo(() => bk({ time: n, timeType: r, min: b, max: m, value: _ }), [_, m, b, n, r]), w = l.useCallback(
      (k) => {
        v && f && !o.current && (k.focus(), o.current = !0);
      },
      [v, f, o]
    ), x = We([
      s,
      i,
      w
    ]), y = l.useCallback(
      (k, O) => {
        k.preventDefault(), u({
          type: O,
          payload: {
            cell: t,
            timeType: r,
            currentValue: _
          }
        });
      },
      [u, t, r, _]
    ), E = l.useCallback(() => {
      const k = {
        ..._,
        [r]: n
      };
      p == null || p(k);
    }, [_, p, n, r]), C = l.useCallback(() => {
      u({
        type: Dt.SET_ACTIVE_CELL,
        payload: {
          cell: t,
          timeType: r,
          focus: !0
        }
      });
    }, [u, t, r]), S = ao({
      onArrowDown: (k) => y(k, Dt.MOVE_DOWN),
      onArrowUp: (k) => y(k, Dt.MOVE_UP),
      onArrowLeft: (k) => y(k, Dt.MOVE_LEFT),
      onArrowRight: (k) => y(k, Dt.MOVE_RIGHT),
      onPageUp: (k) => y(k, Dt.PAGE_UP),
      onPageDown: (k) => y(k, Dt.PAGE_DOWN)
    });
    return l.useEffect(() => {
      v && c.focus && i.current && i.current.focus();
    }, [v, i]), l.useEffect(() => {
      var k;
      if (h && i.current) {
        const O = i.current, { top: L, bottom: H } = O.getBoundingClientRect(), { top: T, bottom: R } = ((k = O == null ? void 0 : O.parentElement) == null ? void 0 : k.getBoundingClientRect()) ?? { bottom: 0, top: 0 };
        (H > R || L < T) && i.current.scrollIntoView({
          behavior: "auto",
          block: "nearest",
          inline: "nearest"
        });
      }
    }, [i, h]), l.useEffect(() => {
      j && j[r] === n && u({
        type: Dt.SET_ACTIVE_CELL,
        payload: {
          cell: t,
          timeType: r,
          focus: !0
        }
      });
    }, [j]), /* @__PURE__ */ l.createElement(
      "li",
      {
        ...a,
        className: q(e, gk, {
          [hk]: h
        }),
        onClick: C,
        onFocus: E,
        onKeyDown: S,
        role: "option",
        tabIndex: v && !g ? 0 : -1,
        "aria-disabled": g,
        "aria-selected": h,
        ref: x
      },
      n
    );
  }
), ls = l.forwardRef(
  (e, t) => {
    const {
      state: { timeMatrix: n }
    } = Pa();
    return /* @__PURE__ */ l.createElement(Oo, { ...e, ref: t }, n[zd].map((r, a) => /* @__PURE__ */ l.createElement(
      Mo,
      {
        key: `${r}-hours`,
        cell: [zd, a],
        time: r,
        timeType: "hours",
        "data-time-type": "hours"
      }
    )));
  }
), cs = l.forwardRef(
  (e, t) => {
    const {
      state: { timeMatrix: n }
    } = Pa();
    return /* @__PURE__ */ l.createElement(Oo, { ...e, ref: t }, n[Fd].map((r, a) => /* @__PURE__ */ l.createElement(
      Mo,
      {
        key: `${r}-minutes`,
        cell: [Fd, a],
        time: r,
        timeType: "minutes",
        "data-time-type": "minutes"
      }
    )));
  }
), Bd = l.forwardRef(
  (e, t) => {
    var r;
    const {
      state: { timeMatrix: n }
    } = Pa();
    return /* @__PURE__ */ l.createElement(Oo, { ...e, ref: t }, (r = n == null ? void 0 : n[Hd]) == null ? void 0 : r.map((a, s) => /* @__PURE__ */ l.createElement(
      Mo,
      {
        key: `${a}-seconds`,
        cell: [Hd, s],
        time: a,
        timeType: "seconds",
        "data-time-type": "seconds"
      }
    )));
  }
), qd = l.forwardRef(
  (e, t) => {
    const {
      state: { timeMatrix: n }
    } = Pa(), r = l.useMemo(() => n.length - 1, [n]);
    return /* @__PURE__ */ l.createElement(Oo, { ...e, ref: t }, n[r].map((a, s) => /* @__PURE__ */ l.createElement(
      Mo,
      {
        key: `${a}-amPM`,
        cell: [r, s],
        time: a,
        timeType: "amPM",
        "data-time-type": "amPM"
      }
    )));
  }
), F7 = ({
  className: e,
  format: t = Be.TwelveHour,
  ...n
}) => {
  const r = l.useMemo(() => {
    switch (t) {
      case Be.TwelveHour:
        return /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(ls, null), /* @__PURE__ */ l.createElement(cs, null), /* @__PURE__ */ l.createElement(qd, null));
      case Be.TwelveHourWithSeconds:
        return /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(ls, null), /* @__PURE__ */ l.createElement(cs, null), /* @__PURE__ */ l.createElement(Bd, null), /* @__PURE__ */ l.createElement(qd, null));
      case Be.TwentyFourHour:
        return /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(ls, null), /* @__PURE__ */ l.createElement(cs, null));
      case Be.TwentyFourHourWithSeconds:
        return /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(ls, null), /* @__PURE__ */ l.createElement(cs, null), /* @__PURE__ */ l.createElement(Bd, null));
    }
  }, [t]);
  return /* @__PURE__ */ l.createElement(yk, { ...n, format: t, className: q(e) }, r);
};
Q.extend(A7);
Q.extend(tk);
Q.extend(I7);
Q.extend(I7);
Q.extend(rk);
function pn(e, t, n) {
  const r = t === "utc" ? e.utc() : e;
  switch (n) {
    case "prettyDate":
      return r.format("ll");
    case "prettyMonthDate":
      return r.format("MMM D");
    case "prettyDateTime":
      return r.format("lll");
    case "prettyMonthDateTime":
      return r.format("MMM D, LT");
    case "prettyDateTimeSeconds":
      return r.format("ll LTS");
    case "prettyMonthDateTimeSeconds":
      return r.format("MMM D, LTS");
    case "logDate":
      return r.format("YYYY-MM-DD");
    case "logDateTime": {
      const a = r.get("milliseconds") > 0;
      return t === "local" && a ? r.format("YYYY-MM-DDTHH:mm:ss.SSSZ") : t === "local" ? r.format("YYYY-MM-DDTHH:mm:ssZ") : t === "utc" && a ? r.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : r.format("YYYY-MM-DDTHH:mm:ss[Z]");
    }
  }
}
function _a(e, t) {
  return Q(e, t || "YYYY-MM-DD", !0).isValid();
}
function lD(e, t) {
  return Q(e, t ? "HH:mm" : "LT", !0).isValid();
}
function Ud(e, t) {
  try {
    const n = window.localStorage.getItem(e);
    return n ?? t;
  } catch (n) {
    return console.warn(
      `Failed to get item: ${e} from localStorage. Error: ${n}`
    ), t;
  }
}
function Wd(e, t) {
  try {
    window.localStorage.setItem(e, t);
  } catch (n) {
    console.warn(`Failed to set item: ${e} in localStorage. Error: ${n}`);
  }
}
const Ur = (e) => e.split(new RegExp("(?<=^[^ T]+)[ T]")), cD = (e) => {
  const t = new Date(e);
  return !Number.isNaN(t.valueOf()) && t.toISOString() === e;
};
function zt(e, t) {
  return Q(
    e,
    t || [
      "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
      "YYYY-MM-DD HH:mm",
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DD hh:mm A",
      "YYYY-MM-DD hh:mm:ss A"
    ],
    !0
  ).isValid();
}
function Vd(e) {
  return `YYYY-MM-DD ${$7(e)}`;
}
function Gn(e) {
  try {
    return new Date(Q(e).toISOString());
  } catch {
    return;
  }
}
const H7 = l.createContext({
  format: "prettyDateTime",
  timezone: "local",
  setTimezone: () => {
  },
  setFormat: () => {
  }
}), Na = () => l.useContext(H7), uD = (e, t) => {
  const { timezone: n, format: r } = Na();
  return l.useMemo(() => pn(Q(e), n, t || r), [e, n, r, t]);
}, dD = ({
  defaultTimezone: e = "local",
  defaultFormat: t = "prettyDateTime",
  children: n
}) => {
  const [r, a] = l.useState(
    Ud(
      "awTimezone",
      e
    )
  ), [s, o] = l.useState(
    Ud(
      "awTimeFormat",
      t
    )
  ), i = l.useCallback(
    (u) => {
      o(u), Wd("awTimeFormat", u);
    },
    []
  ), c = l.useCallback(
    (u) => {
      a(u), Wd("awTimezone", u);
    },
    []
  );
  return /* @__PURE__ */ l.createElement(
    H7.Provider,
    {
      value: { format: s, timezone: r, setFormat: i, setTimezone: c }
    },
    n
  );
}, us = {
  invalidFormat: () => "Invalid format. Enter the date in ISO8601 format.",
  beforeMin: (e) => `Invalid date. Ensure the date comes after ${e}.`,
  afterMax: (e) => `Invalid date. Ensure the date comes before ${e}.`,
  valid: () => ""
}, Xs = ({
  min: e,
  max: t,
  validationMessage: n = us.valid()
} = {}) => {
  const { timezone: r } = Na(), [a, s] = de({
    isValid: !0,
    message: n
  });
  return l.useEffect(() => {
    if (n)
      return s({
        isValid: !1,
        message: n
      });
  }, [n]), {
    validate: l.useCallback(
      (i) => {
        if (!_a(i))
          return s({
            isValid: !1,
            message: us.invalidFormat()
          });
        if (e && Q(i).isBefore(e, "day")) {
          const u = pn(Q(e), r, "logDate");
          return s({
            isValid: !1,
            message: us.beforeMin(u)
          });
        }
        if (t && Q(i).isAfter(t, "day")) {
          const u = pn(Q(t), r, "logDate");
          return s({
            isValid: !1,
            message: us.afterMax(u)
          });
        }
        return s({
          isValid: !0,
          message: n
        });
      },
      [t, e, r, n]
    ),
    validationStatus: a
  };
}, ds = {
  invalidFormat: (e, t) => `Invalid format. Enter the time in ${t === Be.TwelveHour || t === Be.TwelveHourWithSeconds ? "12 hour clock" : "24 hour clock"} format ${e}.`,
  beforeMin: (e) => `Invalid time. Ensure the time comes after ${e}.`,
  afterMax: (e) => `Invalid time. Ensure the time comes before ${e}.`,
  valid: () => ""
}, Zs = ({
  min: e,
  max: t,
  format: n = Be.TwentyFourHour,
  validationMessage: r = ds.valid()
} = {}) => {
  const [a, s] = de({
    isValid: !0,
    message: r
  });
  return l.useEffect(() => {
    if (r)
      return s({
        isValid: !1,
        message: r
      });
  }, [r]), {
    validate: l.useCallback(
      (i) => {
        const c = Lt(n);
        try {
          const u = ot(i ?? "");
          return e && ys(u, ot(e)) ? s({
            isValid: !1,
            message: ds.beforeMin(e)
          }) : t && ws(u, ot(t)) ? s({
            isValid: !1,
            message: ds.afterMax(t)
          }) : s({
            isValid: !0,
            message: r
          });
        } catch {
          return s({
            isValid: !1,
            message: ds.invalidFormat(c, n)
          });
        }
      },
      [n, t, e, r]
    ),
    validationStatus: a
  };
}, Yd = (e, t, n) => (t === "utc" ? e.utc() : e).format(n), wk = (e, t) => (t === "utc" ? Q(e).utcOffset(0, !0) : e).toISOString(), Gd = (e) => {
  if (e && e !== "")
    return Q(e);
}, Ar = ({
  value: e,
  timeFormat: t
}) => {
  const { timezone: n } = Na(), r = t || (n === "utc" ? Be.TwentyFourHourWithSeconds : Be.TwelveHourWithSeconds), a = Le(() => Vd(t || r), [r, t]), s = _e(
    (b, _) => b ? !!zt(b, [
      "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
      "YYYY-MM-DDTHH:mm:ss[Z]",
      _ ? Vd(_) : a
    ]) : !1,
    [a]
  ), o = _e(
    (b, _ = !1) => {
      if (_ && typeof b == "string" && !s(b))
        return b;
      const j = Gd(b);
      return j != null && j.isValid() ? j ? wk(j, n) : void 0 : j == null ? void 0 : j.format();
    },
    [n, s]
  ), i = _e(
    (b) => {
      const _ = o(b);
      return _ ? Q(_).toDate() : void 0;
    },
    [o]
  ), c = _e(
    (b, _ = !1) => {
      if (_ && typeof b == "string" && !s(b))
        return b;
      const j = Gd(b);
      return j != null && j.isValid() ? j ? Yd(j, n, a) : void 0 : j == null ? void 0 : j.format();
    },
    [a, n, s]
  ), u = _e(
    (b) => {
      const _ = c(b);
      return _ ? Q(_, a).toDate() : void 0;
    },
    [c, a]
  ), f = _e(
    () => Q(Yd(Q(), n, a)),
    [a, n]
  ), m = Le(
    () => e ? c(e, !0) : void 0,
    [c, e]
  );
  return {
    appliedTimeFormat: r,
    dateTimeFormat: a,
    getNow: f,
    timezone: n,
    toLocalDate: i,
    toLocalDateString: o,
    toTimezoneDate: u,
    toTimezoneDateString: c,
    valueInTimezone: m,
    validateDateTimeFormat: s
  };
}, Kd = ({
  min: e,
  max: t,
  format: n
} = {}) => {
  const [r, a] = de(), { valueInTimezone: s, toTimezoneDateString: o } = Ar({
    value: r,
    timeFormat: n
  }), i = Le(() => {
    const _ = o(e, !0), j = o(t, !0), [p] = Ur(s ?? r ?? ""), [v, h] = Ur(_ ?? e ?? ""), [g, w] = Ur(j ?? t ?? "");
    return {
      date: {
        max: g,
        min: v
      },
      time: {
        max: p === g ? w : void 0,
        min: p === v ? h : void 0,
        format: n
      }
    };
  }, [n, t, e, o, r, s]), { validate: c, validationStatus: u } = Xs(i.date), { validate: f, validationStatus: m } = Zs(i.time), b = _e(
    (_) => {
      a(_ ?? "");
      const [j, p] = Ur(
        o(_, !0) ?? _ ?? ""
      );
      !j && !p || (c(j), f(p));
    },
    [o, c, f]
  );
  return le(() => {
    const [, _] = Ur(s ?? r ?? "");
    _ && f(_);
  }, [f, r, s]), {
    validate: b,
    validationStatus: u.isValid ? m : u
  };
}, Si = {
  maxRange: (e) => `The maximum range is ${e} days.`,
  valid: () => ""
}, Ck = ({
  min: e,
  max: t,
  maxRange: n
} = {}) => {
  const [r, a] = de([]), [s, o] = de({
    isValid: !0,
    message: Si.valid()
  }), [i, c] = r, u = Le(() => ({
    start: {
      max: c || t,
      min: e
    },
    end: {
      max: t,
      min: i || e
    }
  }), [i, t, e, c]), { validate: f, validationStatus: m } = Xs(u.start), { validate: b, validationStatus: _ } = Xs(u.end), j = _e(
    (p, v) => {
      if (!m.isValid || !_.isValid || !p || !v || !n)
        return;
      const h = Q(v).diff(Q(p), "day");
      o(
        h > n ? {
          isValid: !1,
          message: Si.maxRange(n)
        } : {
          isValid: !0,
          message: Si.valid()
        }
      );
    },
    [
      n,
      o,
      m.isValid,
      _.isValid
    ]
  );
  return le(() => {
    !i && !c || (f(i ?? ""), b(c ?? ""), j(i, c));
  }, [i, c, f, j, b]), {
    validate: a,
    validationStatuses: {
      start: m,
      range: s,
      end: _
    }
  };
}, ki = {
  maxRange: (e) => `The maximum range is ${e} days`,
  valid: () => ""
}, Ek = ({
  min: e,
  max: t,
  maxRange: n,
  startTimeFormat: r,
  endTimeFormat: a
} = {}) => {
  const [s, o] = de([]), [i, c] = de({
    isValid: !0,
    message: ki.valid()
  }), [u, f] = s, m = Le(() => ({
    start: {
      max: f || t,
      min: e,
      format: r
    },
    end: {
      max: t,
      min: u || e,
      format: a
    }
  }), [f, t, e, r, u, a]), { validate: b, validationStatus: _ } = Kd(m.start), { validate: j, validationStatus: p } = Kd(m.end), v = _e(
    (h, g) => {
      if (!_.isValid || !p.isValid || !h || !g || !n)
        return;
      const w = Q(g).diff(Q(h), "day");
      c(
        w > n ? {
          isValid: !1,
          message: ki.maxRange(n)
        } : {
          isValid: !0,
          message: ki.valid()
        }
      );
    },
    [
      n,
      c,
      _.isValid,
      p.isValid
    ]
  );
  return le(() => {
    !u && !f || (b(u ?? ""), j(f ?? ""), v(u, f));
  }, [u, f, b, v, j]), {
    validate: o,
    validationStatuses: {
      start: _,
      range: i,
      end: p
    }
  };
}, Ti = {
  maxRange: (e) => `The maximum range is ${e} hours`,
  valid: () => ""
}, fD = ({
  min: e,
  max: t,
  maxRange: n
} = {}) => {
  const [r, a] = de([]), [s, o] = de({
    isValid: !0,
    message: Ti.valid()
  }), [i, c] = r, u = Le(() => ({
    start: {
      max: c || t,
      min: e
    },
    end: {
      max: t,
      min: i || e
    }
  }), [i, t, e, c]), { validate: f, validationStatus: m } = Zs(u.start), { validate: b, validationStatus: _ } = Zs(u.end), j = _e(
    (p, v) => {
      if (!(!m.isValid || !_.isValid || !p || !v || !n))
        try {
          const h = ot(p ?? ""), g = ot(v ?? ""), w = _k(g, h);
          w > n && o(
            w > n ? {
              isValid: !1,
              message: Ti.maxRange(n)
            } : {
              isValid: !0,
              message: Ti.valid()
            }
          );
        } catch {
        }
    },
    [
      n,
      o,
      m.isValid,
      _.isValid
    ]
  );
  return le(() => {
    !i && !c || (f(i ?? ""), b(c ?? ""), j(i, c));
  }, [i, c, f, j, b]), {
    validate: a,
    validationStatuses: {
      start: m,
      range: s,
      end: _
    }
  };
}, Js = l.forwardRef(
  ({
    appearance: e,
    className: t,
    isDisabled: n,
    placeholder: r = "yyyy-mm-dd",
    value: a,
    defaultValue: s,
    onValueChange: o,
    onPaste: i,
    endAdornment: c,
    ...u
  }, f) => {
    const { timezone: m } = Na(), [b, _] = nt({
      prop: a,
      defaultProp: s,
      onChange: o
    }), j = (v) => {
      _(v.target.value);
    }, p = l.useCallback(
      (v) => {
        v.preventDefault();
        const h = v.clipboardData.getData("text");
        try {
          const g = Q(h), w = pn(
            g,
            m,
            "logDate"
          );
          if (!Q(w).isValid())
            throw new Error("Invalid date pasted");
          _(w);
        } catch {
          _(h);
        }
      },
      [_, m]
    );
    return /* @__PURE__ */ l.createElement(
      xo,
      {
        isDisabled: n,
        appearance: e,
        className: t
      },
      /* @__PURE__ */ l.createElement(
        So,
        {
          ...u,
          onChange: j,
          value: b || "",
          placeholder: r,
          onPaste: Xe(i, p),
          ref: f
        }
      ),
      c
    );
  }
);
var xk = "_1l4kaev0", Sk = "_1l4kaev1", kk = "_1l4kaev2", Tk = "_1l4kaev3";
const B7 = l.forwardRef(
  ({
    isDisabled: e,
    appearance: t,
    className: n,
    format: r = Be.TwentyFourHour,
    value: a,
    defaultValue: s,
    onValueChange: o,
    onBlur: i,
    endAdornment: c,
    ...u
  }, f) => {
    const [m, b] = nt({
      prop: a,
      defaultProp: s,
      onChange: o
    });
    l.useEffect(() => {
      if (s)
        try {
          const v = ot(s);
          b(Lt(r, v));
        } catch {
        }
    }, [s, r, b]);
    const _ = (v) => {
      b(v.target.value);
    }, j = l.useCallback(
      (v) => {
        const h = v.target.value;
        try {
          const g = ot(h), w = Lt(r, g);
          h !== w && b(w);
        } catch {
        }
      },
      [r, b]
    ), p = l.useMemo(() => Lt(r), [r]);
    return /* @__PURE__ */ l.createElement(
      xo,
      {
        isDisabled: e,
        appearance: t,
        className: n
      },
      /* @__PURE__ */ l.createElement(
        So,
        {
          ...u,
          onBlur: Xe(j, i),
          onChange: _,
          value: m || "",
          placeholder: p,
          ref: f
        }
      ),
      c
    );
  }
), Xd = ({
  id: e,
  name: t,
  value: n,
  defaultValue: r,
  isDisabled: a,
  dateFieldProps: s,
  timeFieldProps: o,
  onValueChange: i,
  onBlur: c
}) => {
  const {
    onValueChange: u,
    isDisabled: f,
    ...m
  } = s || {}, {
    onValueChange: b,
    isDisabled: _,
    format: j,
    ...p
  } = o || {}, {
    valueInTimezone: v,
    toTimezoneDateString: h,
    toLocalDateString: g,
    dateTimeFormat: w,
    appliedTimeFormat: x,
    validateDateTimeFormat: y
  } = Ar({ value: n, timeFormat: j }), [E, C] = l.useState(""), [S, k] = l.useState(""), [O, L] = nt({
    prop: v,
    defaultProp: h(r),
    onChange: ($) => {
      i == null || i(g($, !0));
    }
  }), H = l.useId(), T = `${e ?? H}-date`, R = `${e ?? H}-time`, M = l.useCallback(
    ($) => {
      if (!$ || !y($)) return;
      const B = Q($, w);
      k(pn(B, "local", "logDate"));
      try {
        const Y = ot(
          B.format($7(x))
        ), J = Lt(x, Y);
        C(J);
      } catch {
      }
    },
    [y, x, w]
  );
  l.useEffect(() => {
    if (!r) return;
    const $ = h(r);
    $ && zt($) && M($);
  }, [r, M, h]), l.useEffect(() => {
    if (!O) {
      k(""), C("");
      return;
    }
    zt(O) && M(O), _a(O) && k(O);
  }, [O, M]);
  const D = l.useCallback(() => {
    c == null || c();
    const $ = [S, E].join(" ").trimEnd();
    L($);
  }, [c, S, E, L]), I = l.useCallback(
    ($) => {
      k($), u == null || u($);
      const B = [$, E].join(" ").trimEnd();
      L(B);
    },
    [u, E, L]
  ), F = l.useCallback(
    ($) => {
      C($), b == null || b($);
      const B = [S, $].join(" ").trimEnd();
      L(B);
    },
    [b, S, L]
  ), P = l.useCallback(
    ($) => {
      const B = $.clipboardData.getData("text");
      if (zt(B, [
        "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
        "YYYY-MM-DDTHH:mm:ss[Z]"
      ])) {
        $.preventDefault();
        const Y = h(B);
        Y && M(Y);
      }
    },
    [M, h]
  ), A = l.useCallback(
    ($) => {
      c == null || c();
      const B = $.target.value;
      try {
        const J = ot(B), W = Lt(x, J);
        if (B !== W && W !== E) {
          F(W);
          return;
        }
      } catch {
      }
      const Y = [S, E].join(" ").trimEnd();
      L(Y);
    },
    [
      c,
      S,
      E,
      L,
      x,
      F
    ]
  );
  return /* @__PURE__ */ l.createElement(U.div, { display: "flex" }, /* @__PURE__ */ l.createElement(U.div, { className: xk }, /* @__PURE__ */ l.createElement(
    Js,
    {
      id: T,
      name: `${t}-date`,
      className: Sk,
      value: S,
      onBlur: D,
      onValueChange: I,
      isDisabled: a || f,
      onPaste: P,
      ...m
    }
  )), /* @__PURE__ */ l.createElement(U.div, { className: kk }, /* @__PURE__ */ l.createElement(
    B7,
    {
      id: R,
      name: `${t}-time`,
      className: Tk,
      value: E,
      onBlur: A,
      onValueChange: F,
      isDisabled: a || _,
      onPaste: P,
      ...p,
      format: x
    }
  )));
}, Rk = (e) => {
  const {
    value: t,
    onValueChange: n,
    timeFormat: r = Be.TwentyFourHourWithSeconds,
    ...a
  } = e, { timezone: s, toTimezoneDate: o } = Ar({}), i = s === "utc" ? Q(t).utc() : Q(t), c = {
    amPM: r != Be.TwelveHour && r != Be.TwelveHourWithSeconds ? void 0 : i.format("A"),
    hours: r != Be.TwelveHour && r != Be.TwelveHourWithSeconds ? i.format("HH") : i.format("hh"),
    //00-12 12h clock
    minutes: i.format("mm"),
    seconds: i.format("ss")
  }, u = (m) => {
    if (!n || !m)
      return;
    const b = i.set("date", m.getDate()).set("month", m.getMonth()).set("year", m.getFullYear());
    n(b.toDate());
  }, f = (m) => {
    n && n(pk(i, m).toDate());
  };
  return /* @__PURE__ */ l.createElement(re, { ...a }, /* @__PURE__ */ l.createElement(
    R8,
    {
      value: t && o(t),
      onValueChange: u
    }
  ), /* @__PURE__ */ l.createElement(
    F7,
    {
      value: c,
      onValueChange: f,
      format: r
    }
  ));
};
function q7(...e) {
  return (t) => e.forEach((n) => function(r, a) {
    typeof r == "function" ? r(a) : r != null && (r.current = a);
  }(n, t));
}
function Pr(...e) {
  return d.useCallback(q7(...e), e);
}
function we() {
  return we = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, we.apply(null, arguments);
}
const Eu = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  return d.Children.toArray(n).some(Zd) ? /* @__PURE__ */ d.createElement(d.Fragment, null, d.Children.map(n, (a) => Zd(a) ? /* @__PURE__ */ d.createElement(zl, we({}, r, { ref: t }), a.props.children) : a)) : /* @__PURE__ */ d.createElement(zl, we({}, r, { ref: t }), n);
});
Eu.displayName = "Slot";
const zl = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  return d.isValidElement(n) ? /* @__PURE__ */ d.cloneElement(n, { ...Mk(r, n.props), ref: q7(t, n.ref) }) : d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
zl.displayName = "SlotClone";
const Ok = ({ children: e }) => /* @__PURE__ */ d.createElement(d.Fragment, null, e);
function Zd(e) {
  return d.isValidElement(e) && e.type === Ok;
}
function Mk(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? n[r] = (...o) => {
      s == null || s(...o), a == null || a(...o);
    } : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
var U7 = Yc(), Ri = function() {
}, Ao = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: Ri,
    onWheelCapture: Ri,
    onTouchMoveCapture: Ri
  }), a = r[0], s = r[1], o = e.forwardProps, i = e.children, c = e.className, u = e.removeScrollBar, f = e.enabled, m = e.shards, b = e.sideCar, _ = e.noIsolation, j = e.inert, p = e.allowPinchZoom, v = e.as, h = v === void 0 ? "div" : v, g = e.gapMode, w = Sa(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = b, y = Vc([n, t]), E = Ue(Ue({}, w), a);
  return d.createElement(
    d.Fragment,
    null,
    f && d.createElement(x, { sideCar: U7, removeScrollBar: u, shards: m, noIsolation: _, inert: j, setCallbacks: s, allowPinchZoom: !!p, lockRef: n, gapMode: g }),
    o ? d.cloneElement(d.Children.only(i), Ue(Ue({}, E), { ref: y })) : d.createElement(h, Ue({}, E, { className: c, ref: y }), i)
  );
});
Ao.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ao.classNames = {
  fullWidth: lr,
  zeroRight: ir
};
var Fl = !1;
if (typeof window < "u")
  try {
    var fs = Object.defineProperty({}, "passive", {
      get: function() {
        return Fl = !0, !0;
      }
    });
    window.addEventListener("test", fs, fs), window.removeEventListener("test", fs, fs);
  } catch {
    Fl = !1;
  }
var Kn = Fl ? { passive: !1 } : !1, Ak = function(e) {
  return e.tagName === "TEXTAREA";
}, W7 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Ak(e) && n[t] === "visible")
  );
}, Pk = function(e) {
  return W7(e, "overflowY");
}, Nk = function(e) {
  return W7(e, "overflowX");
}, Jd = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var a = V7(e, r);
    if (a) {
      var s = Y7(e, r), o = s[1], i = s[2];
      if (o > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Dk = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Ik = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, V7 = function(e, t) {
  return e === "v" ? Pk(t) : Nk(t);
}, Y7 = function(e, t) {
  return e === "v" ? Dk(t) : Ik(t);
}, $k = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Lk = function(e, t, n, r, a) {
  var s = $k(e, window.getComputedStyle(t).direction), o = s * r, i = n.target, c = t.contains(i), u = !1, f = o > 0, m = 0, b = 0;
  do {
    var _ = Y7(e, i), j = _[0], p = _[1], v = _[2], h = p - v - s * j;
    (j || h) && V7(e, i) && (m += h, b += j), i instanceof ShadowRoot ? i = i.host : i = i.parentNode;
  } while (
    // portaled content
    !c && i !== document.body || // self content
    c && (t.contains(i) || t === i)
  );
  return (f && (Math.abs(m) < 1 || !a) || !f && (Math.abs(b) < 1 || !a)) && (u = !0), u;
}, bs = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Qd = function(e) {
  return [e.deltaX, e.deltaY];
}, ef = function(e) {
  return e && "current" in e ? e.current : e;
}, zk = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Fk = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Hk = 0, Xn = [];
function Bk(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), a = d.useState(Hk++)[0], s = d.useState(jo)[0], o = d.useRef(e);
  d.useEffect(function() {
    o.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = Wc([e.lockRef.current], (e.shards || []).map(ef), !0).filter(Boolean);
      return p.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = d.useCallback(function(p, v) {
    if ("touches" in p && p.touches.length === 2)
      return !o.current.allowPinchZoom;
    var h = bs(p), g = n.current, w = "deltaX" in p ? p.deltaX : g[0] - h[0], x = "deltaY" in p ? p.deltaY : g[1] - h[1], y, E = p.target, C = Math.abs(w) > Math.abs(x) ? "h" : "v";
    if ("touches" in p && C === "h" && E.type === "range")
      return !1;
    var S = Jd(C, E);
    if (!S)
      return !0;
    if (S ? y = C : (y = C === "v" ? "h" : "v", S = Jd(C, E)), !S)
      return !1;
    if (!r.current && "changedTouches" in p && (w || x) && (r.current = y), !y)
      return !0;
    var k = r.current || y;
    return Lk(k, v, p, k === "h" ? w : x, !0);
  }, []), c = d.useCallback(function(p) {
    var v = p;
    if (!(!Xn.length || Xn[Xn.length - 1] !== s)) {
      var h = "deltaY" in v ? Qd(v) : bs(v), g = t.current.filter(function(y) {
        return y.name === v.type && (y.target === v.target || v.target === y.shadowParent) && zk(y.delta, h);
      })[0];
      if (g && g.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!g) {
        var w = (o.current.shards || []).map(ef).filter(Boolean).filter(function(y) {
          return y.contains(v.target);
        }), x = w.length > 0 ? i(v, w[0]) : !o.current.noIsolation;
        x && v.cancelable && v.preventDefault();
      }
    }
  }, []), u = d.useCallback(function(p, v, h, g) {
    var w = { name: p, delta: v, target: h, should: g, shadowParent: qk(h) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(x) {
        return x !== w;
      });
    }, 1);
  }, []), f = d.useCallback(function(p) {
    n.current = bs(p), r.current = void 0;
  }, []), m = d.useCallback(function(p) {
    u(p.type, Qd(p), p.target, i(p, e.lockRef.current));
  }, []), b = d.useCallback(function(p) {
    u(p.type, bs(p), p.target, i(p, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return Xn.push(s), e.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: b
    }), document.addEventListener("wheel", c, Kn), document.addEventListener("touchmove", c, Kn), document.addEventListener("touchstart", f, Kn), function() {
      Xn = Xn.filter(function(p) {
        return p !== s;
      }), document.removeEventListener("wheel", c, Kn), document.removeEventListener("touchmove", c, Kn), document.removeEventListener("touchstart", f, Kn);
    };
  }, []);
  var _ = e.removeScrollBar, j = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    j ? d.createElement(s, { styles: Fk(a) }) : null,
    _ ? d.createElement(Kc, { gapMode: e.gapMode }) : null
  );
}
function qk(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Uk = Gc(U7, Bk);
var G7 = d.forwardRef(function(e, t) {
  return d.createElement(Ao, Ue({}, e, { ref: t, sideCar: Uk }));
});
G7.classNames = Ao.classNames;
let Oi = 0;
function Wk() {
  d.useEffect(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : tf()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : tf()), Oi++, () => {
      Oi === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((r) => r.remove()), Oi--;
    };
  }, []);
}
function tf() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const hn = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((e, t) => ({ ...e, [t]: /* @__PURE__ */ d.forwardRef((n, r) => {
  const { asChild: a, ...s } = n, o = a ? Eu : t;
  return d.useEffect(() => {
    window[Symbol.for("radix-ui")] = !0;
  }, []), /* @__PURE__ */ d.createElement(o, we({}, s, { ref: r }));
}) }), {}), Qs = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, Po = (e) => {
  const { present: t, children: n } = e, r = function(o) {
    const [i, c] = d.useState(), u = d.useRef({}), f = d.useRef(o), m = d.useRef("none"), b = o ? "mounted" : "unmounted", [_, j] = function(p, v) {
      return d.useReducer((h, g) => {
        const w = v[h][g];
        return w ?? h;
      }, p);
    }(b, { mounted: { UNMOUNT: "unmounted", ANIMATION_OUT: "unmountSuspended" }, unmountSuspended: { MOUNT: "mounted", ANIMATION_END: "unmounted" }, unmounted: { MOUNT: "mounted" } });
    return d.useEffect(() => {
      const p = ms(u.current);
      m.current = _ === "mounted" ? p : "none";
    }, [_]), Qs(() => {
      const p = u.current, v = f.current;
      if (v !== o) {
        const h = m.current, g = ms(p);
        o ? j("MOUNT") : g === "none" || (p == null ? void 0 : p.display) === "none" ? j("UNMOUNT") : j(v && h !== g ? "ANIMATION_OUT" : "UNMOUNT"), f.current = o;
      }
    }, [o, j]), Qs(() => {
      if (i) {
        const p = (h) => {
          const g = ms(u.current).includes(h.animationName);
          h.target === i && g && j("ANIMATION_END");
        }, v = (h) => {
          h.target === i && (m.current = ms(u.current));
        };
        return i.addEventListener("animationstart", v), i.addEventListener("animationcancel", p), i.addEventListener("animationend", p), () => {
          i.removeEventListener("animationstart", v), i.removeEventListener("animationcancel", p), i.removeEventListener("animationend", p);
        };
      }
      j("ANIMATION_END");
    }, [i, j]), { isPresent: ["mounted", "unmountSuspended"].includes(_), ref: d.useCallback((p) => {
      p && (u.current = getComputedStyle(p)), c(p);
    }, []) };
  }(t), a = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), s = Pr(r.ref, a.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ d.cloneElement(a, { ref: s }) : null;
};
function ms(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
Po.displayName = "Presence";
const Vk = /* @__PURE__ */ d.forwardRef((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...a } = e;
  return r ? /* @__PURE__ */ ja.createPortal(/* @__PURE__ */ d.createElement(hn.div, we({}, a, { ref: t })), r) : null;
});
function Dn(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
  }, []);
}
const nf = { bubbles: !1, cancelable: !0 }, Yk = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: a, onUnmountAutoFocus: s, ...o } = e, [i, c] = d.useState(null), u = Dn(a), f = Dn(s), m = d.useRef(null), b = Pr(t, (p) => c(p)), _ = d.useRef({ paused: !1, pause() {
    this.paused = !0;
  }, resume() {
    this.paused = !1;
  } }).current;
  d.useEffect(() => {
    if (r) {
      let p = function(h) {
        if (_.paused || !i) return;
        const g = h.target;
        i.contains(g) ? m.current = g : En(m.current, { select: !0 });
      }, v = function(h) {
        !_.paused && i && (i.contains(h.relatedTarget) || En(m.current, { select: !0 }));
      };
      return document.addEventListener("focusin", p), document.addEventListener("focusout", v), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", v);
      };
    }
  }, [r, i, _.paused]), d.useEffect(() => {
    if (i) {
      sf.add(_);
      const v = document.activeElement;
      if (!i.contains(v)) {
        const h = new Event("focusScope.autoFocusOnMount", nf);
        i.addEventListener("focusScope.autoFocusOnMount", u), i.dispatchEvent(h), h.defaultPrevented || (function(g, { select: w = !1 } = {}) {
          const x = document.activeElement;
          for (const y of g) if (En(y, { select: w }), document.activeElement !== x) return;
        }((p = rf(i), p.filter((g) => g.tagName !== "A")), { select: !0 }), document.activeElement === v && En(i));
      }
      return () => {
        i.removeEventListener("focusScope.autoFocusOnMount", u), setTimeout(() => {
          const h = new Event("focusScope.autoFocusOnUnmount", nf);
          i.addEventListener("focusScope.autoFocusOnUnmount", f), i.dispatchEvent(h), h.defaultPrevented || En(v ?? document.body, { select: !0 }), i.removeEventListener("focusScope.autoFocusOnUnmount", f), sf.remove(_);
        }, 0);
      };
    }
    var p;
  }, [i, u, f, _]);
  const j = d.useCallback((p) => {
    if (!n && !r || _.paused) return;
    const v = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, h = document.activeElement;
    if (v && h) {
      const g = p.currentTarget, [w, x] = function(y) {
        const E = rf(y), C = af(E, y), S = af(E.reverse(), y);
        return [C, S];
      }(g);
      w && x ? p.shiftKey || h !== x ? p.shiftKey && h === w && (p.preventDefault(), n && En(x, { select: !0 })) : (p.preventDefault(), n && En(w, { select: !0 })) : h === g && p.preventDefault();
    }
  }, [n, r, _.paused]);
  return d.createElement(hn.div, we({ tabIndex: -1 }, o, { ref: b, onKeyDown: j }));
});
function rf(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: (r) => {
    const a = r.tagName === "INPUT" && r.type === "hidden";
    return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
  } });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function af(e, t) {
  for (const n of e) if (!Gk(n, { upTo: t })) return n;
}
function Gk(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function En(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && function(r) {
      return r instanceof HTMLInputElement && "select" in r;
    }(e) && t && e.select();
  }
}
const sf = /* @__PURE__ */ function() {
  let e = [];
  return { add(t) {
    const n = e[0];
    t !== n && (n == null || n.pause()), e = of(e, t), e.unshift(t);
  }, remove(t) {
    var n;
    e = of(e, t), (n = e[0]) === null || n === void 0 || n.resume();
  } };
}();
function of(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Kk(e) {
  const t = Dn(e);
  d.useEffect(() => {
    const n = (r) => {
      r.key === "Escape" && t(r);
    };
    return document.addEventListener("keydown", n), () => document.removeEventListener("keydown", n);
  }, [t]);
}
let lf, _s = 0;
function Xk({ disabled: e }) {
  const t = d.useRef(!1);
  Qs(() => {
    if (e) {
      let n = function() {
        _s--, _s === 0 && (document.body.style.pointerEvents = lf);
      }, r = function(a) {
        t.current = a.pointerType !== "mouse";
      };
      return _s === 0 && (lf = document.body.style.pointerEvents), document.body.style.pointerEvents = "none", _s++, document.addEventListener("pointerup", r), () => {
        t.current ? document.addEventListener("click", n, { once: !0 }) : n(), document.removeEventListener("pointerup", r);
      };
    }
  }, [e]);
}
function ln(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented) return t == null ? void 0 : t(r);
  };
}
const Zk = /* @__PURE__ */ d.createContext({ layers: /* @__PURE__ */ new Set(), layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(), branches: /* @__PURE__ */ new Set() }), Jk = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { disableOutsidePointerEvents: n = !1, onEscapeKeyDown: r, onPointerDownOutside: a, onFocusOutside: s, onInteractOutside: o, onDismiss: i, ...c } = e, u = d.useContext(Zk), [f, m] = d.useState(null), [, b] = d.useState({}), _ = Pr(t, (E) => m(E)), j = Array.from(u.layers), [p] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), v = j.indexOf(p), h = f ? j.indexOf(f) : -1, g = u.layersWithOutsidePointerEventsDisabled.size > 0, w = h >= v, x = function(E) {
    const C = Dn(E), S = d.useRef(!1);
    return d.useEffect(() => {
      const k = (L) => {
        L.target && !S.current && uf("dismissableLayer.pointerDownOutside", C, { originalEvent: L }), S.current = !1;
      }, O = window.setTimeout(() => {
        document.addEventListener("pointerdown", k);
      }, 0);
      return () => {
        window.clearTimeout(O), document.removeEventListener("pointerdown", k);
      };
    }, [C]), { onPointerDownCapture: () => S.current = !0 };
  }((E) => {
    const C = E.target, S = [...u.branches].some((k) => k.contains(C));
    w && !S && (a == null || a(E), o == null || o(E), E.defaultPrevented || i == null || i());
  }), y = function(E) {
    const C = Dn(E), S = d.useRef(!1);
    return d.useEffect(() => {
      const k = (O) => {
        O.target && !S.current && uf("dismissableLayer.focusOutside", C, { originalEvent: O });
      };
      return document.addEventListener("focusin", k), () => document.removeEventListener("focusin", k);
    }, [C]), { onFocusCapture: () => S.current = !0, onBlurCapture: () => S.current = !1 };
  }((E) => {
    const C = E.target;
    [...u.branches].some((S) => S.contains(C)) || (s == null || s(E), o == null || o(E), E.defaultPrevented || i == null || i());
  });
  return Kk((E) => {
    h === u.layers.size - 1 && (r == null || r(E), E.defaultPrevented || i == null || i());
  }), Xk({ disabled: n }), d.useEffect(() => {
    f && (n && u.layersWithOutsidePointerEventsDisabled.add(f), u.layers.add(f), cf());
  }, [f, n, u]), d.useEffect(() => () => {
    f && (u.layers.delete(f), u.layersWithOutsidePointerEventsDisabled.delete(f), cf());
  }, [f, u]), d.useEffect(() => {
    const E = () => b({});
    return document.addEventListener("dismissableLayer.update", E), () => document.removeEventListener("dismissableLayer.update", E);
  }, []), /* @__PURE__ */ d.createElement(hn.div, we({}, c, { ref: _, style: { pointerEvents: g ? w ? "auto" : "none" : void 0, ...e.style }, onFocusCapture: ln(e.onFocusCapture, y.onFocusCapture), onBlurCapture: ln(e.onBlurCapture, y.onBlurCapture), onPointerDownCapture: ln(e.onPointerDownCapture, x.onPointerDownCapture) }));
});
function cf() {
  const e = new Event("dismissableLayer.update");
  document.dispatchEvent(e);
}
function uf(e, t, n) {
  const r = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  return t && r.addEventListener(e, t, { once: !0 }), !r.dispatchEvent(a);
}
function Qk({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, a] = function({ defaultProp: c, onChange: u }) {
    const f = d.useState(c), [m] = f, b = d.useRef(m), _ = Dn(u);
    return d.useEffect(() => {
      b.current !== m && (_(m), b.current = m);
    }, [m, b, _]), f;
  }({ defaultProp: t, onChange: n }), s = e !== void 0, o = s ? e : r, i = Dn(n);
  return [o, d.useCallback((c) => {
    if (s) {
      const u = c, f = typeof c == "function" ? u(e) : c;
      f !== e && i(f);
    } else a(c);
  }, [s, e, a, i])];
}
const eT = d.useId || (() => {
});
let tT = 0;
function Mi(e) {
  const [t, n] = d.useState(eT());
  return Qs(() => {
    e || n((r) => r ?? String(tT++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function nT(e, t = []) {
  let n = [];
  const r = () => {
    const a = n.map((s) => /* @__PURE__ */ d.createContext(s));
    return function(s) {
      const o = (s == null ? void 0 : s[e]) || a;
      return d.useMemo(() => ({ [`__scope${e}`]: { ...s, [e]: o } }), [s, o]);
    };
  };
  return r.scopeName = e, [function(a, s) {
    const o = /* @__PURE__ */ d.createContext(s), i = n.length;
    function c(u) {
      const { scope: f, children: m, ...b } = u, _ = (f == null ? void 0 : f[e][i]) || o, j = d.useMemo(() => b, Object.values(b));
      return d.createElement(_.Provider, { value: j }, m);
    }
    return n = [...n, s], c.displayName = a + "Provider", [c, function(u, f) {
      const m = (f == null ? void 0 : f[e][i]) || o, b = d.useContext(m);
      if (b) return b;
      if (s !== void 0) return s;
      throw new Error(`\`${u}\` must be used within \`${a}\``);
    }];
  }, rT(r, ...t)];
}
function rT(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({ useScope: a(), scopeName: a.scopeName }));
    return function(a) {
      const s = r.reduce((o, { useScope: i, scopeName: c }) => ({ ...o, ...i(a)[`__scope${c}`] }), {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
const [aT, bD] = nT("Dialog"), [sT, Tt] = aT("Dialog"), oT = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: a, onOpenChange: s, modal: o = !0, allowPinchZoom: i } = e, c = d.useRef(null), u = d.useRef(null), [f = !1, m] = Qk({ prop: r, defaultProp: a, onChange: s });
  return d.createElement(sT, { scope: t, triggerRef: c, contentRef: u, contentId: Mi(), titleId: Mi(), descriptionId: Mi(), open: f, onOpenChange: m, onOpenToggle: d.useCallback(() => m((b) => !b), [m]), modal: o, allowPinchZoom: i }, n);
}, iT = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { __scopeDialog: n, ...r } = e, a = Tt("DialogTrigger", n), s = Pr(t, a.triggerRef);
  return d.createElement(hn.button, we({ type: "button", "aria-haspopup": "dialog", "aria-expanded": a.open, "aria-controls": a.contentId, "data-state": xu(a.open) }, r, { ref: s, onClick: ln(e.onClick, a.onOpenToggle) }));
}), lT = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: a } = e, s = Tt("DialogPortal", t);
  return d.createElement(d.Fragment, null, d.Children.map(r, (o) => /* @__PURE__ */ d.createElement(Po, { present: n || s.open }, /* @__PURE__ */ d.createElement(Vk, { asChild: !0, container: a }, o))));
}, cT = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, a = Tt("DialogOverlay", e.__scopeDialog);
  return a.modal ? /* @__PURE__ */ d.createElement(Po, { present: n || a.open }, /* @__PURE__ */ d.createElement(uT, we({}, r, { ref: t }))) : null;
}), uT = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { __scopeDialog: n, ...r } = e, a = Tt("DialogOverlay", n);
  return d.createElement(G7, { as: Eu, allowPinchZoom: a.allowPinchZoom, shards: [a.contentRef] }, /* @__PURE__ */ d.createElement(hn.div, we({ "data-state": xu(a.open) }, r, { ref: t, style: { pointerEvents: "auto", ...r.style } })));
}), dT = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, a = Tt("DialogContent", e.__scopeDialog);
  return d.createElement(Po, { present: n || a.open }, a.modal ? /* @__PURE__ */ d.createElement(fT, we({}, r, { ref: t })) : /* @__PURE__ */ d.createElement(bT, we({}, r, { ref: t })));
}), fT = /* @__PURE__ */ d.forwardRef((e, t) => {
  const n = Tt("DialogContent", e.__scopeDialog), r = d.useRef(null), a = Pr(t, n.contentRef, r);
  return d.useEffect(() => {
    const s = r.current;
    if (s) return Uc(s);
  }, []), /* @__PURE__ */ d.createElement(K7, we({}, e, { ref: a, trapFocus: n.open, disableOutsidePointerEvents: !0, onCloseAutoFocus: ln(e.onCloseAutoFocus, (s) => {
    var o;
    s.preventDefault(), (o = n.triggerRef.current) === null || o === void 0 || o.focus();
  }), onPointerDownOutside: ln(e.onPointerDownOutside, (s) => {
    const o = s.detail.originalEvent, i = o.button === 0 && o.ctrlKey === !0;
    (o.button === 2 || i) && s.preventDefault();
  }), onFocusOutside: ln(e.onFocusOutside, (s) => s.preventDefault()) }));
}), bT = /* @__PURE__ */ d.forwardRef((e, t) => {
  const n = Tt("DialogContent", e.__scopeDialog), r = d.useRef(!1);
  return d.createElement(K7, we({}, e, { ref: t, trapFocus: !1, disableOutsidePointerEvents: !1, onCloseAutoFocus: (a) => {
    var s, o;
    (s = e.onCloseAutoFocus) === null || s === void 0 || s.call(e, a), a.defaultPrevented || (r.current || (o = n.triggerRef.current) === null || o === void 0 || o.focus(), a.preventDefault()), r.current = !1;
  }, onInteractOutside: (a) => {
    var s, o;
    (s = e.onInteractOutside) === null || s === void 0 || s.call(e, a), a.defaultPrevented || (r.current = !0);
    const i = a.target;
    !((o = n.triggerRef.current) === null || o === void 0) && o.contains(i) && a.preventDefault();
  } }));
}), K7 = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: a, onCloseAutoFocus: s, ...o } = e, i = Tt("DialogContent", n), c = d.useRef(null), u = Pr(t, c);
  return Wk(), /* @__PURE__ */ d.createElement(d.Fragment, null, /* @__PURE__ */ d.createElement(Yk, { asChild: !0, loop: !0, trapped: r, onMountAutoFocus: a, onUnmountAutoFocus: s }, /* @__PURE__ */ d.createElement(Jk, we({ role: "dialog", id: i.contentId, "aria-describedby": i.descriptionId, "aria-labelledby": i.titleId, "data-state": xu(i.open) }, o, { ref: u, onDismiss: () => i.onOpenChange(!1) }))), !1);
}), mT = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { __scopeDialog: n, ...r } = e, a = Tt("DialogTitle", n);
  return d.createElement(hn.h2, we({ id: a.titleId }, r, { ref: t }));
}), _T = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { __scopeDialog: n, ...r } = e, a = Tt("DialogDescription", n);
  return d.createElement(hn.p, we({ id: a.descriptionId }, r, { ref: t }));
}), pT = /* @__PURE__ */ d.forwardRef((e, t) => {
  const { __scopeDialog: n, ...r } = e, a = Tt("DialogClose", n);
  return d.createElement(hn.button, we({ type: "button" }, r, { ref: t, onClick: ln(e.onClick, () => a.onOpenChange(!1)) }));
});
function xu(e) {
  return e ? "open" : "closed";
}
const jT = oT, vT = iT, hT = lT, gT = cT, yT = dT, wT = mT, CT = _T, ET = pT;
var xT = "dzwcae3 dzwcae2 _1s8b37j298 _1s8b37jag _1s8b37jh0 _1s8b37j18u _1s8b37j2vq _1s8b37j2hf", ST = "dzwcae5 dzwcae4 _1s8b37jk7 _1s8b37jkb _1s8b37jkf _1s8b37jkj _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37j80 _1s8b37jjz _1s8b37jl3 _1s8b37jcs _1s8b37jl5 _1s8b37j298 _1s8b37j1hb _1s8b37jvn _1s8b37jx6", kT = "dzwcae7 dzwcae6 _1s8b37j25w _1s8b37j27a _1s8b37j28o _1s8b37j248 _1s8b37jl5", TT = "dzwcae9 dzwcae8 _1s8b37j27z _1s8b37j243", RT = "dzwcaeb dzwcaea _1s8b37j25w _1s8b37j27a _1s8b37j284 _1s8b37j248 _1s8b37jl5", OT = "dzwcaed dzwcaec _1s8b37j25w _1s8b37j27a _1s8b37j84 _1s8b37jkf _1s8b37jkj _1s8b37jl5 _1s8b37j13z", MT = "dzwcaef dzwcaee _1s8b37j293 _1s8b37j2hp _1s8b37j2a2";
const X7 = l.createContext({
  isModal: !0,
  isAlertDialog: !1,
  isOpen: !1,
  setIsOpen: () => {
  }
}), Su = () => l.useContext(X7), AT = ({
  defaultOpen: e,
  onIsOpenChange: t,
  isOpen: n,
  isModal: r = !0,
  isAlertDialog: a = !1,
  children: s
}) => {
  const [o = !1, i] = nt({
    prop: n,
    defaultProp: e,
    onChange: t
  });
  return /* @__PURE__ */ l.createElement(
    X7.Provider,
    {
      value: { isModal: r, isAlertDialog: a, isOpen: o, setIsOpen: i }
    },
    /* @__PURE__ */ l.createElement(
      jT,
      {
        defaultOpen: e,
        open: o,
        onOpenChange: i
      },
      s
    )
  );
}, PT = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(vT, { asChild: !0 }, /* @__PURE__ */ l.createElement(U.button, { ...t, ref: n }, e))), NT = ({
  children: e,
  ...t
}) => /* @__PURE__ */ l.createElement(hT, { ...t }, e), DT = l.forwardRef(({ children: e, forceMount: t, className: n, ...r }, a) => /* @__PURE__ */ l.createElement(gT, { asChild: !0, forceMount: t }, /* @__PURE__ */ l.createElement(
  U.div,
  {
    ...r,
    className: q(n, xT),
    ref: a
  },
  e
))), IT = l.forwardRef(
  ({
    children: e,
    verticalAlign: t = "center",
    onEscapeKeyDown: n,
    onPointerDownOutside: r,
    onInteractOutside: a,
    onOpenAutoFocus: s,
    onCloseAutoFocus: o,
    forceMount: i,
    className: c,
    ...u
  }, f) => {
    const { isModal: m, isAlertDialog: b } = Su(), _ = l.useMemo(() => {
      switch (t) {
        case "top":
          return {
            top: "25%"
          };
        case "center":
          return {
            top: "50%"
          };
        case "bottom":
          return {
            top: "75%"
          };
      }
    }, [t]), j = l.useCallback(
      (p) => {
        (m || b) && p.preventDefault();
      },
      [m, b]
    );
    return /* @__PURE__ */ l.createElement(NT, null, /* @__PURE__ */ l.createElement(DT, null), /* @__PURE__ */ l.createElement(
      yT,
      {
        asChild: !0,
        onEscapeKeyDown: n,
        onPointerDownOutside: Xe(
          j,
          r
        ),
        onInteractOutside: a,
        onOpenAutoFocus: s,
        onCloseAutoFocus: o,
        forceMount: i
      },
      /* @__PURE__ */ l.createElement(
        U.div,
        {
          ...u,
          "aria-modal": b || m ? !0 : void 0,
          role: b ? "alertdialog" : "dialog",
          ref: f,
          className: q(c, ST),
          ..._
        },
        e
      )
    ));
  }
), $T = l.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(
    ye,
    {
      ...n,
      ref: r,
      className: q(t, kT)
    },
    e
  )
), LT = l.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(wT, { asChild: !0 }, /* @__PURE__ */ l.createElement(kr, { ...t, ref: n, level: "2", styledAs: "heading3" }, e))
), zT = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(CT, { asChild: !0 }, /* @__PURE__ */ l.createElement(
  ne,
  {
    ...t,
    ref: n,
    className: TT
  },
  e
))), FT = l.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ l.createElement(ET, { asChild: !0 }, /* @__PURE__ */ l.createElement(
    Me,
    {
      ...t,
      ref: n,
      className: q(e, MT),
      "aria-label": "close dialog",
      "data-testid": "dialog-close-button"
    },
    /* @__PURE__ */ l.createElement(wr, null)
  ))
), HT = l.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(
    U.div,
    {
      ...n,
      ref: r,
      className: q(t, RT)
    },
    e
  )
), BT = l.forwardRef(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ l.createElement(
    re,
    {
      ...n,
      ref: r,
      className: q(t, OT),
      xAlign: "right"
    },
    e
  )
), qT = l.forwardRef(
  ({ children: e, onClick: t, ...n }, r) => {
    const a = Su(), s = l.useCallback(
      (o) => {
        t == null || t(o), a.setIsOpen(!1);
      },
      [a, t]
    );
    return /* @__PURE__ */ l.createElement(
      Et,
      {
        ...n,
        ref: r,
        variant: "tertiary",
        onClick: s
      },
      e
    );
  }
), UT = l.forwardRef(
  ({ children: e, onClick: t, ...n }, r) => {
    const a = Su(), s = l.useCallback(
      (o) => {
        t == null || t(o), a.setIsOpen(!1);
      },
      [a, t]
    );
    return /* @__PURE__ */ l.createElement(
      Et,
      {
        ...n,
        ref: r,
        variant: "primary",
        onClick: s
      },
      e
    );
  }
), mD = {
  Root: AT,
  Trigger: PT,
  Content: IT,
  Close: FT,
  Header: $T,
  HeaderTitle: LT,
  HeaderDescription: zT,
  Body: HT,
  Footer: BT,
  FooterCancel: qT,
  FooterAction: UT
};
function nr(e, t) {
  if (typeof t == "string")
    return t;
  if (typeof t == "object")
    switch (e) {
      case "ultrawide":
        return t.ultrawide == null ? nr("monitor", t) : t.ultrawide;
      case "monitor":
        return t.monitor == null ? nr("laptop", t) : t.monitor;
      case "laptop":
        return t.laptop == null ? nr("tablet", t) : t.laptop;
      case "tablet":
        return t.tablet == null ? nr("mobile", t) : t.tablet;
      default:
        return t.mobile;
    }
}
function WT() {
  const e = yj();
  return l.useCallback(
    (t) => nr(e, t),
    [e]
  );
}
const VT = l.forwardRef(
  (e, t) => {
    const { area: n, children: r, place: a, style: s, ...o } = e;
    return /* @__PURE__ */ l.createElement(
      U.div,
      {
        ref: t,
        placeContent: a,
        style: {
          gridArea: n,
          ...s
        },
        ...o
      },
      r
    );
  }
), Z7 = l.forwardRef(
  (e, t) => {
    const {
      gap: n,
      areas: r,
      columns: a,
      rows: s,
      autoRows: o,
      autoColumns: i,
      place: c,
      style: u,
      ...f
    } = e, m = WT();
    return /* @__PURE__ */ l.createElement(
      U.div,
      {
        ref: t,
        display: "grid",
        gap: n,
        placeContent: c,
        style: {
          gridAutoRows: o,
          gridAutoColumns: i,
          gridTemplateAreas: m(r),
          gridTemplateRows: m(s),
          gridTemplateColumns: m(a),
          ...u
        },
        ...f
      }
    );
  }
);
Z7.displayName = "Grid.Root";
const _D = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Item: VT,
  Root: Z7,
  computeBreakpointStyles: nr
}, Symbol.toStringTag, { value: "Module" })), YT = 60, GT = 0.03, KT = 100, pD = ({
  isLoading: e,
  caption: t
}) => {
  const [n, r] = l.useState(0), a = l.useRef(e), s = l.useCallback((u) => {
    r((f) => u <= 1e3 / YT + 1 ? (f + u * GT) % 100 : f);
  }, []), { stop: o, start: i } = rj(s);
  l.useEffect(() => {
    n >= KT && r(0);
  }, [n]), l.useEffect(() => (e && i(), () => o()), [e]);
  const c = l.useMemo(
    () => 100 - n,
    [n, a]
  );
  return /* @__PURE__ */ l.createElement(ye, { xAlign: "center" }, /* @__PURE__ */ l.createElement(
    "svg",
    {
      height: "100",
      viewBox: "0 0 121 100",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "triangle" }, /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M60.0882 0L119.722 100H0.45396L60.0882 0Z",
        fill: "rgb(var(--aw-color-mono-grey-5))"
      }
    ))),
    /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M60.0882 0L119.722 100H0.45396L60.0882 0Z",
        style: { fill: `rgb(${be.background.widget.tertiary})` }
      }
    ),
    /* @__PURE__ */ l.createElement(
      "rect",
      {
        width: "120",
        height: "100",
        y: c,
        style: {
          clipPath: "url(#triangle)",
          fill: `rgb(${be.background.brand.default})`
        }
      }
    ),
    /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M80.1678 98.0648L77.2292 91.2039L79.6335 92.0835L77.2292 84.6948L78.654 84.7828L76.784 78.7135L78.654 79.1533L76.4278 67.6305L79.1883 60.5937L80.7021 51.9736L80.2569 49.3348L78.0307 48.3672L74.2906 52.5893L72.4206 42.8257L69.0368 38.9555L64.0501 35.9648L56.2138 51.5338L50.3366 53.8208L46.9528 57.6031L43.3908 64.2001L39.8289 68.862L37.6917 72.9961L27.0059 82.2319L33.8627 83.6393L41.6989 83.1116L46.3294 80.6487L41.788 84.6948L33.8627 83.6393L29.4102 91.2039L25.0469 95.1621L26.7388 94.9862L21.9302 99.9999H80.6131L80.1678 98.0648ZM49.3571 63.4964L54.0766 55.6679L54.4328 59.1864L49.3571 63.4964ZM67.5229 56.3716L69.8382 47.5756L68.5915 40.011L71.352 44.0572L72.5097 53.6449L67.5229 56.3716ZM76.0716 66.575L75.0921 62.8807L76.2497 60.5058L76.0716 66.575Z",
        style: { fill: `rgb(${be.background.widget.default})` }
      }
    )
  ), t && /* @__PURE__ */ l.createElement(ne, null, t));
};
var No = "_1hld4zp1 _1hld4zp0 _1s8b37j25m _1s8b37j270 _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37j2vq _1s8b37jl5 _1s8b37j135 _1s8b37jl7 _1s8b37jlo _1s8b37j2", J7 = "_1hld4zp3 _1hld4zp2 _1s8b37j80 _1s8b37j8h", XT = "_1hld4zp5 _1hld4zp4 _1s8b37j7k _1s8b37jll", Q7 = "_1hld4zp7 _1hld4zp6 _1s8b37jll", ZT = "_1hld4zp9 _1hld4zp8 _1s8b37jlc _1s8b37js", e_ = "_1hld4zpb _1hld4zpa _1s8b37jo", t_ = "_1hld4zpc", JT = "_1hld4zpd", n_ = "_1hld4zpe", QT = "_1hld4zpg _1hld4zpf _1s8b37j2vq _1s8b37j2";
const eR = l.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(ye, { asChild: !0, gap: "xsmall" }, /* @__PURE__ */ l.createElement(
    U.ul,
    {
      ...t,
      ref: n,
      backgroundColor: "widgetDefault",
      width: "full",
      padding: "zero",
      margin: "zero",
      role: "menu"
    },
    e
  ))
), r_ = l.createContext({
  isSelected: !1,
  isDisabled: !1
}), tR = () => l.useContext(r_), nR = l.forwardRef(
  ({
    children: e,
    className: t,
    isDisabled: n = !1,
    isSelected: r = !1,
    onClick: a,
    onKeyDown: s,
    onSelect: o,
    ...i
  }, c) => {
    const u = l.useCallback(
      (m) => {
        o == null || o(m);
      },
      [o]
    ), f = ao({
      // @ts-ignore TODO: Fix types
      onEnter: u,
      // @ts-ignore TODO: Fix types
      onSpace: u
    });
    return /* @__PURE__ */ l.createElement(r_.Provider, { value: { isSelected: r, isDisabled: n } }, /* @__PURE__ */ l.createElement(re, { asChild: !0, xAlign: "between" }, /* @__PURE__ */ l.createElement(
      U.li,
      {
        ...i,
        ref: c,
        role: "menuitem",
        "aria-disabled": n,
        "aria-selected": r,
        className: q(t, No, {
          [XT]: r,
          [J7]: !r,
          [Q7]: n
        }),
        onClick: Xe(a, u),
        onKeyDown: Xe(s, f)
      },
      e
    )));
  }
), rR = l.forwardRef(({ children: e, ...t }, n) => {
  const r = tR();
  return /* @__PURE__ */ l.createElement(
    ne,
    {
      ...t,
      ref: n,
      className: q({
        [ZT]: r.isSelected,
        [e_]: r.isDisabled
      })
    },
    e
  );
}), aR = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(re, { ...t, ref: n }, e)), a_ = l.createContext({
  contentRef: null,
  isDisabled: !1
}), s_ = () => l.useContext(a_), sR = l.forwardRef(({ children: e, className: t, isDisabled: n = !1, ...r }, a) => {
  const s = l.useRef(null), o = l.useRef(null), i = l.useRef(), c = l.useRef(!1), u = l.useRef(!1), f = l.useCallback(async () => {
    const b = [];
    let _ = 0;
    o.current && (b.push([
      o.current,
      { x: [0, -32] },
      { duration: 0.2 }
    ]), _ = _ + 0.2), s.current && (b.push([
      s.current,
      { opacity: [0, 1], scale: [0.75, 1] },
      { duration: 0.1 }
    ]), _ = _ + 0.2), u.current = !0, i.current = Us(b, {
      duration: _,
      delay: 0.2
    }), await i.current.finished, c.current = !0, u.current = !1;
  }, [i, c, u, o, s]), m = l.useCallback(() => {
    const b = [];
    let _ = 0;
    s.current && (b.push([
      s.current,
      { opacity: [1, 0], scale: [1, 0.75] },
      { duration: 0.1 }
    ]), _ = _ + 0.2), o.current && (b.push([
      o.current,
      { x: [-32, 0] },
      { duration: 0.2 }
    ]), _ = _ + 0.2), !u.current && c.current ? Us(b, { duration: _ }).finished : u.current && (i.current.cancel(), u.current = !1);
  }, [i, c, u, o, s]);
  return /* @__PURE__ */ l.createElement(a_.Provider, { value: { contentRef: o, isDisabled: n } }, /* @__PURE__ */ l.createElement(re, { asChild: !0, xAlign: "between" }, /* @__PURE__ */ l.createElement(
    U.a,
    {
      ...r,
      ref: a,
      className: q(
        t,
        No,
        J7,
        {
          [Q7]: n
        }
      ),
      position: "relative",
      role: "menuitem",
      "aria-disabled": n,
      onMouseEnter: f,
      onMouseLeave: m,
      onFocus: f,
      onBlur: m
    },
    e,
    /* @__PURE__ */ l.createElement(
      re,
      {
        ref: s,
        position: "absolute",
        opacity: "0",
        height: "1rem",
        width: "1rem",
        textColor: "brandDefault",
        "data-testid": "external-link-item-icon",
        style: { right: 16 }
      },
      /* @__PURE__ */ l.createElement(nb, null)
    )
  )));
}), oR = l.forwardRef(({ children: e, ...t }, n) => {
  const r = s_();
  return /* @__PURE__ */ l.createElement(
    ne,
    {
      ...t,
      ref: n,
      className: q({ [e_]: r.isDisabled })
    },
    e
  );
}), iR = l.forwardRef(({ children: e, ...t }, n) => {
  const r = s_(), a = We([n, r.contentRef]);
  return /* @__PURE__ */ l.createElement(re, { ...t, ref: a }, e);
}), lR = l.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(
    re,
    {
      height: "2.5rem",
      xAlign: "between",
      yAlign: "center",
      backgroundColor: "widgetDefault",
      asChild: !0
    },
    /* @__PURE__ */ l.createElement(
      U.li,
      {
        ...t,
        className: q(
          No,
          t_,
          JT
        ),
        ref: n
      },
      /* @__PURE__ */ l.createElement(ne, { styledAs: "body5", className: n_ }, e)
    )
  )
), cR = l.forwardRef(
  ({ defaultCollapse: e = !1, title: t, children: n, className: r, ...a }, s) => {
    const [o, i] = l.useState(e), c = l.useCallback(() => {
      i(!o);
    }, [i, o]);
    return /* @__PURE__ */ l.createElement(
      U.li,
      {
        ...a,
        ref: s,
        "aria-haspopup": "menu",
        gap: "xsmall",
        className: q(r, QT)
      },
      t && /* @__PURE__ */ l.createElement(
        re,
        {
          height: "2.5rem",
          backgroundColor: "widgetDefault",
          xAlign: "between",
          yAlign: "center",
          width: "full",
          className: q(No, t_),
          onClick: c
        },
        /* @__PURE__ */ l.createElement(ne, { styledAs: "body5", className: n_ }, t),
        /* @__PURE__ */ l.createElement(
          Me,
          {
            "aria-label": "Toggle expand submenu",
            onClick: c
          },
          o ? /* @__PURE__ */ l.createElement(Jj, null) : /* @__PURE__ */ l.createElement(Zj, null)
        )
      ),
      /* @__PURE__ */ l.createElement(
        Ma,
        {
          isShowing: !o,
          enter: "flyDown",
          leave: "flyUp",
          asChild: !0
        },
        /* @__PURE__ */ l.createElement(
          U.ul,
          {
            width: "full",
            padding: "zero",
            margin: "zero",
            role: "menu",
            "data-testid": "submenu"
          },
          n
        )
      )
    );
  }
), Ai = {
  Root: eR,
  Title: lR,
  CollapseItem: cR,
  Item: nR,
  ItemText: rR,
  ItemContent: aR,
  ExternalLinkItem: sR,
  ExternalLinkItemText: oR,
  ExternalLinkItemContent: iR
};
var uR = "_1k76nc71 _1k76nc70 _1s8b37j25c _1s8b37j26q _1s8b37j27z _1s8b37j23t _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jmh _1s8b37jl5 _1s8b37jw7 _1s8b37jxg _1s8b37j199 _1s8b37j29d _1s8b37jm1 _1s8b37j12l", dR = { primary: "_1k76nc72 _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37jl3", secondary: "_1k76nc73 _1s8b37jew" }, fR = { danger: "_1k76nc74 _1s8b37j68 _1s8b37jb4 _1s8b37j14", warning: "_1k76nc75 _1s8b37j6o _1s8b37jbg _1s8b37j1g", success: "_1k76nc76 _1s8b37j74 _1s8b37jbs _1s8b37j1s", neutral: "_1k76nc77 _1s8b37j88 _1s8b37jcg _1s8b37jk", default: "_1k76nc78 _1s8b37j7k _1s8b37jas _1s8b37js" };
const o_ = l.forwardRef((e, t) => {
  const {
    children: n,
    className: r,
    appearance: a = "default",
    iconLeft: s,
    iconRight: o,
    itemKey: i,
    isRemoveable: c,
    onRemoveClick: u,
    variant: f = "primary",
    ...m
  } = e, b = l.useCallback(
    (_) => {
      u && i && u(i, _);
    },
    [i, u]
  );
  return /* @__PURE__ */ l.createElement(
    re,
    {
      ...m,
      className: q(
        uR,
        dR[f],
        fR[a],
        r
      ),
      gap: "xsmall",
      ref: t
    },
    s && s,
    /* @__PURE__ */ l.createElement(ne, { styledAs: "body3", textColor: "inherit", fontWeight: "bold" }, n),
    o && !c && o,
    c && /* @__PURE__ */ l.createElement(
      Me,
      {
        "aria-label": `Remove ${n} tag`,
        size: "small",
        appearance: a,
        onClick: b ?? void 0
      },
      /* @__PURE__ */ l.createElement(wr, null)
    )
  );
});
o_.displayName = "Tag";
const Pi = {
  exceedMaxLimit: (e) => `Invalid selection. The number of selected option exceeds limit of ${e}.`,
  minLimitRequired: (e) => `Invalid selection. Please select at least ${e} options.`,
  required: "Required."
}, jD = ({
  appearance: e,
  defaultOptionsSelected: t,
  defaultIsOpen: n,
  emptyText: r,
  createText: a,
  helpText: s,
  isDisabled: o = !1,
  isOpen: i,
  isRequired: c = !1,
  isCreatable: u = !1,
  label: f,
  maxContentHeight: m = 300,
  maxInputLength: b,
  maxLimit: _,
  minLimit: j,
  numberOfTags: p,
  options: v,
  optionListPadding: h = 8,
  placeholder: g = "Type to add",
  selectedOptions: w,
  selectedOptionsCallbackDebounceTime: x,
  validationMessage: y,
  useCustomValidations: E = !1,
  onBlur: C,
  onFocus: S,
  onIsOpenChange: k,
  onSelectedOptionsChange: O,
  onFilterChange: L,
  handleCreate: H
}) => {
  var Ir, $r, Zt, $a, Lr;
  const [T, R] = d.useState(!1), [M, D] = nt({
    prop: i,
    defaultProp: n,
    onChange: k
  }), [I, F] = d.useState(0), [P, A] = d.useState(!1), [$, B] = d.useState(!1), [Y, J] = d.useState(!1), W = d.useRef(null), V = d.useRef(null), K = d.useRef(null), te = d.useRef(null), Z = d.useRef(null), se = d.useMemo(() => {
    let ce = O;
    return x && O && (ce = Fu(
      O,
      x
    )), ce;
  }, [O, x, Fu]), [ue, X] = nt({
    prop: w,
    defaultProp: t,
    onChange: se
  }), ie = d.useCallback(
    (ce, Ke) => {
      Ke.stopPropagation(), Ke.preventDefault(), R(!0), X((dt) => (dt || []).filter((yn) => yn.value !== ce)), setTimeout(() => {
        var dt, Je;
        (Je = (dt = W == null ? void 0 : W.current) == null ? void 0 : dt.querySelector("button, input")) == null || Je.focus();
      });
    },
    [X, R]
  ), Ce = d.useCallback(
    (ce) => {
      var Ke, dt, Je;
      (Ke = Z.current) != null && Ke.contains(ce.relatedTarget) || (oc(), J(!1), A(!1), D(!1), te.current && te.current.resetActiveItem()), R(!0), ce.stopPropagation(), ce.preventDefault(), $ && !((dt = W == null ? void 0 : W.current) != null && dt.contains(ce.relatedTarget)) && !((Je = Z == null ? void 0 : Z.current) != null && Je.contains(ce.relatedTarget)) && (B(!1), C && C(ce));
    },
    [
      R,
      A,
      D,
      V,
      te,
      Z,
      B,
      $,
      C
    ]
  ), ge = d.useCallback(
    (ce) => {
      ce.code === "ArrowDown" ? (ce.preventDefault(), !i && !Y && (J(!0), Xr()), D(!0)) : setTimeout(() => {
        var Ke;
        Dr(
          P,
          m,
          h,
          (Ke = W == null ? void 0 : W.current) == null ? void 0 : Ke.getBoundingClientRect(),
          K
        );
      });
    },
    [
      i,
      Y,
      D,
      P,
      m,
      h,
      (Ir = W == null ? void 0 : W.current) == null ? void 0 : Ir.getBoundingClientRect(),
      ($r = K == null ? void 0 : K.current) == null ? void 0 : $r.getBoundingClientRect().height,
      P
    ]
  ), Ee = d.useCallback(() => {
    var ce;
    V.current && ((ce = V.current) == null || ce.focus());
  }, []), He = d.useCallback(
    (ce) => {
      _ && ce && ce.length > _ && ue && ce.length >= ue.length || X(ce);
    },
    [_, X, ue]
  ), Re = d.useMemo(() => !ue || (ue == null ? void 0 : ue.length) === 0 ? null : ue.map((ce) => /* @__PURE__ */ d.createElement(
    o_,
    {
      className: q(u9),
      appearance: o ? "neutral" : "default",
      variant: "secondary",
      key: ce.value,
      itemKey: ce.value,
      isRemoveable: !o,
      onRemoveClick: ie,
      "data-testid": "multi-select-tag",
      paddingBottom: "zero"
    },
    ce.label
  )), [ue, p, ie, o]), Ie = d.useMemo(() => {
    if (_ && ue && ue.length > _)
      return {
        isValid: !1,
        message: Pi.exceedMaxLimit(_)
      };
    if (j && ue && (ue == null ? void 0 : ue.length) < j)
      return {
        isValid: !1,
        message: Pi.minLimitRequired(j)
      };
    if (c && T && !(ue != null && ue.length))
      return {
        isValid: !1,
        message: Pi.required
      };
  }, [_, j, ue, T, c]), at = d.useCallback(() => {
    var ce;
    !i && !Y && (J(!0), Xr()), D(!0), Dr(
      P,
      m,
      h,
      (ce = W == null ? void 0 : W.current) == null ? void 0 : ce.getBoundingClientRect(),
      K
    );
  }, [
    m,
    D,
    h,
    i,
    Y,
    J,
    Xr,
    K,
    W,
    P
  ]), gn = d.useCallback(
    (ce) => {
      var Ke;
      ce.stopPropagation(), ce.preventDefault(), !ce.relatedTarget && ce.target.nodeName !== "BUTTON" && ce.target.nodeName !== "INPUT" && ((Ke = V == null ? void 0 : V.current) == null || Ke.focus()), $ || (B(!0), S && S(ce));
    },
    [V, $, B, S]
  ), Xt = d.useCallback(
    (ce) => {
      ce.stopPropagation(), ce.preventDefault(), $ && (B(!1), C && C(ce));
    },
    [V, $, B, C]
  ), Dr = (ce, Ke, dt, Je, yn) => {
    setTimeout(() => {
      var La;
      const zr = (La = yn == null ? void 0 : yn.current) == null ? void 0 : La.getBoundingClientRect();
      let Fr = Ke;
      zr && zr.height < Ke && (Fr = zr.height);
      const Lo = Fr + ((Je == null ? void 0 : Je.bottom) ?? 0);
      !ce && Lo <= (window.innerHeight || document.documentElement.clientHeight) ? F(dt) : (A(!0), F(
        0 - (Fr + ((Je == null ? void 0 : Je.height) ?? 0) + dt)
      ));
    });
  };
  d.useEffect(() => {
    var ce;
    i && Dr(
      P,
      m,
      h,
      (ce = W == null ? void 0 : W.current) == null ? void 0 : ce.getBoundingClientRect(),
      K
    );
  }, [
    i,
    m,
    (Zt = W == null ? void 0 : W.current) == null ? void 0 : Zt.getBoundingClientRect().top,
    (Lr = ($a = K == null ? void 0 : K.current) == null ? void 0 : $a.getBoundingClientRect()) == null ? void 0 : Lr.height,
    h,
    P
  ]);
  const $o = d.useMemo(() => Ie && !Ie.isValid ? Ie.message : y, [y, Ie]);
  return /* @__PURE__ */ d.createElement(
    _u,
    {
      emptyText: r,
      createText: a,
      defaultOptionsSelected: t,
      optionsSelected: ue,
      onSelectedOptionsChange: He,
      onFilterChange: L,
      ref: te
    },
    /* @__PURE__ */ d.createElement(
      Ae.Root,
      {
        appearance: Ie && !Ie.isValid ? "danger" : e || void 0,
        isRequired: c
      },
      f && /* @__PURE__ */ d.createElement(Ae.Label, null, f),
      s && /* @__PURE__ */ d.createElement(Ae.Info, null, s),
      /* @__PURE__ */ d.createElement(
        Ae.Content,
        {
          onFocus: gn,
          tabIndex: -1,
          onBlur: Xt
        },
        /* @__PURE__ */ d.createElement(
          xo,
          {
            ref: W,
            isDisabled: o,
            className: r9
          },
          /* @__PURE__ */ d.createElement(U.div, { className: q(i9) }, /* @__PURE__ */ d.createElement(
            re,
            {
              paddingX: "zero",
              gap: "xsmall",
              flexWrap: "wrap",
              width: "full",
              height: "full"
            },
            p ? Re == null ? void 0 : Re.slice(0, p) : Re,
            p && Re && (Re == null ? void 0 : Re.length) - p > 0 && /* @__PURE__ */ d.createElement(ne, { whiteSpace: "nowrap" }, (Re == null ? void 0 : Re.length) - p, " more..."),
            /* @__PURE__ */ d.createElement(
              pu,
              {
                asChild: !0,
                isCreatable: u,
                handleCreate: H,
                inputRef: V,
                options: v
              },
              /* @__PURE__ */ d.createElement(
                So,
                {
                  className: q(l9),
                  ref: V,
                  placeholder: g,
                  onKeyDown: ge,
                  onFocus: at,
                  onBlur: Ce,
                  "aria-expanded": M,
                  maxLength: b
                }
              )
            )
          ), /* @__PURE__ */ d.createElement(U.div, { paddingTop: "xsmall" }, /* @__PURE__ */ d.createElement(
            kl,
            {
              onClick: Ee,
              className: a9
            },
            M ? /* @__PURE__ */ d.createElement(ic, null) : /* @__PURE__ */ d.createElement(lc, null)
          )))
        ),
        /* @__PURE__ */ d.createElement(
          "div",
          {
            className: s9,
            ref: Z
          },
          /* @__PURE__ */ d.createElement(
            ju,
            {
              ref: K,
              className: o9,
              options: v,
              isCreatable: u,
              handleCreate: H,
              inputRef: V,
              "aria-label": f,
              style: M ? {
                display: "block",
                maxHeight: `${m}px`,
                top: `${I}px`
              } : { display: "none" }
            },
            v.map((ce) => /* @__PURE__ */ d.createElement(
              vu,
              {
                key: ce.value,
                value: ce.value,
                label: ce.label
              },
              /* @__PURE__ */ d.createElement(hu, null, ce.label)
            ))
          )
        )
      ),
      !E && /* @__PURE__ */ d.createElement(Ae.Message, null, $o)
    )
  );
}, df = {
  light: ["light", "light-theme"],
  dark: ["dark", "dark-theme"]
}, i_ = l.createContext({
  themeMode: "light",
  setThemeMode: () => {
  }
});
function bR() {
  return l.useContext(i_);
}
const vD = ({
  children: e,
  themeMode: t
}) => {
  const [n, r] = l.useState(
    t ?? "light"
  ), [a, s] = l.useState(!1), o = l.useCallback(
    (m, b, _) => {
      for (const j of df[b])
        m.classList.remove(j);
      for (const j of df[_])
        m.classList.add(j);
    },
    []
  ), i = l.useCallback(
    (m) => {
      const b = document.querySelector("html");
      b && (b.style.colorScheme = m, b.setAttribute("data-theme-mode", m), m === "light" && o(b, "dark", "light"), m === "dark" && o(b, "light", "dark"));
    },
    [o]
  ), c = l.useCallback(() => window.localStorage.getItem("awThemeMode"), []), u = l.useCallback(
    (m) => window.localStorage.setItem("awThemeMode", m),
    []
  );
  l.useEffect(() => {
    const m = c();
    return m ? f(m) : t ? f(t) : window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? f("dark") : f("light");
  }, []);
  const f = l.useCallback(
    (m) => {
      u(m), i(m), r(m), a || s(!0);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a]
  );
  return /* @__PURE__ */ l.createElement(
    i_.Provider,
    {
      value: {
        themeMode: n,
        setThemeMode: f
      }
    },
    a ? e : null
  );
}, mR = (e) => /* @__PURE__ */ l.createElement(
  Me,
  {
    ...e,
    "aria-label": "nav-menu",
    display: { mobile: "block", monitor: "none", ultrawide: "none" }
  },
  /* @__PURE__ */ l.createElement(
    U.svg,
    {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "bars",
      className: "svg-inline--fa fa-bars fa-w-14",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512"
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
      }
    )
  )
), _R = () => {
  const e = bR(), t = l.useMemo(() => (e == null ? void 0 : e.themeMode) === "light", [e]);
  return /* @__PURE__ */ l.createElement(U.div, { height: { mobile: "1.5rem", tablet: "2rem" } }, /* @__PURE__ */ l.createElement(
    "svg",
    {
      height: "100%",
      viewBox: "0 0 323 114",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0)" }, /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M79.0999 45.2L80.3999 53.7999L77.8999 63.7999L83.4999 60.7L82.1999 49.7999L79.0999 45.2Z",
        fill: t ? `rgb(${be.background.brand.default})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M54 91.3L48.8 94.1L40 94.8L49 96L54 91.3Z",
        fill: t ? `rgb(${be.background.brand.default})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M57.5 71.9L63.2 67L62.8 63L57.5 71.9Z",
        fill: t ? `rgb(${be.background.brand.default})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M87.5 75.4L87.8 68.5L86.5 71.2L87.5 75.4Z",
        fill: t ? `rgb(${be.background.brand.default})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M54 91.3L48.8 94.1L40 94.8L49 96L54 91.3Z",
        fill: t ? `rgb(${be.background.brand.default})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M57.5 71.9L63.2 67L62.8 63L57.5 71.9Z",
        fill: t ? `rgb(${be.background.brand.default})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M79.0999 45.2L80.3999 53.7999L77.8999 63.7999L83.4999 60.7L82.1999 49.7999L79.0999 45.2Z",
        fill: t ? `rgb(${be.background.brand.default})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M30.3 108L35.2 103.5L40 94.8L32.4 93.2L44.5 82.7L46.8 78L50.7 72.7L54.7 65.2L58.6 60.9L65.1 58.2L74 40.6L79.6 44L83.2 48.4L85.3 59.5L89.5 54.6L92.1 55.8L92.6 58.8L90.9 68.6L87.8 76.6L90.4 89.7L88.3 89.3L90.4 96.1L88.8 96L91.4 104.5L88.7 103.5L92.1 111.2L92.7 113.5H137L68.5 0L0 113.5H26.8L32.2 107.8L30.3 108Z",
        fill: t ? `rgb(${be.background.brand.default})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M87.5 75.4L87.8 68.5L86.5 71.2L87.5 75.4Z",
        fill: t ? `rgb(${be.background.brand.default})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M92.0999 111.2L88.8 103.4L91.5 104.4L88.8 96.0001L90.4 96.1001L88.3 89.2001L90.4 89.7001L87.9 76.6001L91 68.6001L92.7 58.8001L92.2 55.8001L89.6999 54.7001L85.5 59.5001L83.4 48.4001L79.5999 44.0001L74 40.6001L65.1999 58.3001L58.5999 60.9001L54.7999 65.2001L50.7999 72.7001L46.7999 78.0001L44.4 82.7001L32.4 93.2001L40.0999 94.8001L48.9 94.2001L54.0999 91.4001L49 96.0001L40 94.7001L35.0999 103.4L30.2 107.9L32.0999 107.7L26.7 113.4H92.5999L92.0999 111.2ZM57.5 71.9001L62.7999 63.0001L63.2 67.0001L57.5 71.9001ZM77.9 63.8001L80.5 53.8001L79.0999 45.2001L82.1999 49.8001L83.5 60.7001L77.9 63.8001ZM87.5 75.4001L86.4 71.2001L87.6999 68.5001L87.5 75.4001Z",
        fill: `rgb(${be.background.widget.default})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M274.5 67.7C284.6 67.7 292.5 67.7 302.6 67.7C302.6 70 302.6 72.3 302.6 74.8C295.1 74.8 289.9 74.8 282.3 74.8C282.3 78.9 282.3 82.9 282.3 87.1C288.6 87.1 292.8 87.1 299.2 87.1C299.2 89.5 299.2 91.7 299.2 94.1C292.8 94.1 288.7 94.1 282.2 94.1C282.2 100.6 282.2 106.9 282.2 113.2C279.5 113.2 277.1 113.2 274.5 113.2C274.5 98.1 274.5 83 274.5 67.7Z",
        fill: t ? `rgb(${be.text.default.secondary})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M247.6 67.7C250.1 67.7 252.6 67.7 255.3 67.7C255.3 80.4 255.3 93.1 255.3 106C263 106 263.7 106 271.2 106C271.2 108.5 271.2 110.8 271.2 113.2C261.1 113.2 257.8 113.2 247.6 113.2C247.6 98 247.6 82.9 247.6 67.7Z",
        fill: t ? `rgb(${be.text.default.secondary})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M241.2 84.7C241.2 74.5 235 67.9 225 67.3H224.7H224.6H223.3C213 67.8 206.7 74.4 206.7 84.8C206.7 89.7 206.5 94.6 207 99.5C208 109.1 215.2 113.7 223.2 113.8C223.2 113.8 223.2 113.8 223.3 113.8H224.6C224.6 113.8 224.6 113.8 224.7 113.8H225C232.9 113.6 239.9 109 240.9 99.5C241.4 94.6 241.2 89.6 241.2 84.7ZM233.1 97.5C232.9 101 231.4 103.9 228 105.4C226.9 105.9 225.7 106.2 224.6 106.3H223.2C222.1 106.2 221 105.9 219.8 105.4C216.4 103.9 214.9 101 214.7 97.5C214.5 92.8 214.5 88.1 214.7 83.4C214.9 78.4 218.4 75.1 223.1 74.8H224.6C229.3 75 232.8 78.4 233 83.4C233.3 88.1 233.3 92.8 233.1 97.5Z",
        fill: t ? `rgb(${be.text.default.secondary})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M195.2 67.7C194 72.3 189.6 89.3 187.6 97.4C187.5 97.6 187.5 97.8 187.3 98.5C186.9 97.3 186.6 96.6 186.4 95.9C183.9 87.4 180.6 76.4 178.1 67.7H174.8H171.5C169 76.5 165.7 87.5 163.2 95.9C163 96.6 162.7 97.3 162.3 98.5C162.1 97.8 162.1 97.6 162 97.4C160 89.3 155.6 72.3 154.4 67.7H145.4C149.7 82.7 153.9 98.7 158 113.3C160.5 113.3 163.1 113.3 165.6 113.3C168.6 103.2 171.6 93.9 174.7 83.3C177.8 93.9 180.8 103.2 183.8 113.3C186.3 113.3 188.9 113.3 191.4 113.3C195.5 98.7 199.8 82.7 204 67.7H195.2Z",
        fill: t ? `rgb(${be.text.default.secondary})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M314.8 41.2999C317.2 42.2999 319.7 43.2999 322.1 44.3999C320.3 50.3999 315 54.5999 308.2 54.8999C305 54.9999 301.7 54.6999 298.7 53.5999C293 51.5999 290 46.8999 289.6 41.0999C289.1 34.9999 289.1 28.7999 289.6 22.6999C290.3 14.0999 297.9 8.19993 306.8 8.69993C314.4 9.09993 319.9 12.8999 322 19.3999C319.6 20.2999 317.2 21.2999 314.7 22.2999C313 17.9999 309.8 15.9999 305.4 16.2999C301.1 16.5999 297.9 19.1999 297.5 23.4999C297.1 28.9999 297.1 34.5999 297.5 39.9999C297.8 44.2999 300.9 46.9999 304.7 47.4999C309.4 48.0999 312.5 46.2999 314.4 41.9999C314.5 41.6999 314.7 41.5999 314.8 41.2999Z",
        fill: t ? `rgb(${be.text.default.secondary})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M233 19.2C230.5 20.2 228.1 21.1 225.7 22.1C223.9 17.7 220.6 15.7 216 16.2C211.6 16.7 208.6 19.4 208.3 24C207.9 29.1 207.9 34.3 208.3 39.4C208.7 44 211.7 46.8 215.5 47.3C220.2 47.9 223.3 46.1 225.3 41.6C225.4 41.5 225.5 41.4 225.7 41.2C228.1 42.2 230.5 43.2 232.9 44.2C231.2 50.1 225.8 54.4 219.1 54.7C215.9 54.9 212.6 54.5 209.6 53.4C204 51.4 200.9 46.8 200.5 41.1C200 34.9 200 28.5 200.5 22.3C201.2 13.8 208.8 7.99996 217.7 8.49996C224.5 8.79996 229.6 11.6 232.6 17.9C232.7 18.4 232.8 18.7 233 19.2Z",
        fill: t ? `rgb(${be.text.default.secondary})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M268.7 15.9999C264.5 15.9999 260.4 15.9999 256.1 15.9999C256.1 28.8999 256.1 41.6999 256.1 54.4999C253.4 54.4999 250.9 54.4999 248.2 54.4999C248.2 41.6999 248.2 28.9999 248.2 15.9999C243.9 15.9999 239.8 15.9999 235.6 15.9999C235.6 13.4999 235.6 11.2999 235.6 8.8999C246.6 8.8999 257.6 8.8999 268.7 8.8999C268.7 11.2999 268.7 13.5999 268.7 15.9999Z",
        fill: t ? `rgb(${be.text.default.secondary})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M275 9C277.6 9 280.1 9 282.7 9C282.7 24.1 282.7 39.3 282.7 54.5C280.1 54.5 277.6 54.5 275 54.5C275 39.4 275 24.2 275 9Z",
        fill: t ? `rgb(${be.text.default.secondary})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M119.3 49.3999C118.7 51.0999 118.1 52.6999 117.4 54.5999H125.8C126.9 51.5999 129.3 44.4999 129.3 44.4999C129.3 44.4999 130.4 44.4999 135.4 44.5999C138.5 44.6999 141.5 44.5999 144.6 44.4999C146 44.4999 146.4 44.5999 146.4 44.5999C146.4 44.5999 148.8 51.3999 149.9 54.5999H158.3C157.9 53.3999 157.6 52.4999 157.3 51.6999C152.8 39.6999 145.9 21.5999 141.2 8.8999H134.8C129.8 21.4999 123.9 37.0999 119.3 49.3999ZM143.9 37.6999H131.7C133.7 31.5999 135.6 25.4999 137.6 19.4999C137.8 19.4999 137.8 19.4999 138 19.4999C139.9 25.4999 141.9 31.5999 143.9 37.6999Z",
        fill: t ? `rgb(${be.text.default.secondary})` : `rgb(${be.text.default.body})`
      }
    ), /* @__PURE__ */ l.createElement(
      "path",
      {
        d: "M187.3 33.9999C192.9 31.3999 195.9 25.8999 194.9 19.9999C194 13.9999 189.8 9.6999 183.5 9.1999C177.5 8.6999 171.4 8.9999 165.4 8.8999C164.2 8.8999 163 8.8999 161.7 8.8999C161.7 24.1999 161.7 39.2999 161.7 54.4999H169.5C169.5 48.2999 169.5 42.1999 169.5 35.8999H178.1C180.2 40.9999 184 49.8999 186 54.4999H194.8C191.9 48.0999 188.7 40.8999 185.9 34.6999C186.5 34.3999 186.9 34.1999 187.3 33.9999ZM180.6 28.5999C177 28.7999 173.4 28.5999 169.6 28.5999C169.6 24.2999 169.6 20.2999 169.6 16.1999C173.9 16.1999 178.2 15.8999 182.3 16.2999C185.5 16.5999 187.1 19.2999 186.8 22.4999C186.6 25.9999 184.2 28.3999 180.6 28.5999Z",
        fill: t ? `rgb(${be.text.default.secondary})` : `rgb(${be.text.default.body})`
      }
    )),
    /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0" }, /* @__PURE__ */ l.createElement("rect", { width: "322.1", height: "113.7", fill: "white" })))
  ));
}, hD = ({
  appName: e,
  accessoryContent: t,
  children: n,
  homeURL: r = "/",
  navLogo: a,
  onMenuButtonClick: s
}) => /* @__PURE__ */ l.createElement(
  re,
  {
    borderWidth: "zero",
    borderBottomWidth: "default",
    borderStyle: "solid",
    borderColor: "neutralDefault",
    boxSizing: "border-box",
    backgroundColor: "widgetDefault",
    height: { mobile: "3rem", tablet: "4rem" },
    xAlign: "between",
    paddingX: { mobile: "default", laptop: "large" },
    position: "fixed",
    top: "0",
    width: "full",
    zIndex: 3
  },
  /* @__PURE__ */ l.createElement(re, { gap: { mobile: "default", monitor: "default" }, height: "full" }, /* @__PURE__ */ l.createElement(mR, { onClick: s }), /* @__PURE__ */ l.createElement("a", { href: r, "aria-label": "Return to home page" }, a || /* @__PURE__ */ l.createElement(_R, null)), /* @__PURE__ */ l.createElement(
    re,
    {
      display: { mobile: "none", monitor: "flex", ultrawide: "flex" },
      gap: "large",
      height: "full",
      paddingY: "default",
      boxSizing: "border-box"
    },
    /* @__PURE__ */ l.createElement(ne, { styledAs: "body2", color: "secondary" }, e),
    t && /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(
      U.div,
      {
        height: "full",
        borderWidth: "zero",
        borderLeftWidth: "default",
        borderStyle: "solid",
        borderColor: "neutralDefault",
        style: { width: "1px" }
      }
    ), t)
  )),
  /* @__PURE__ */ l.createElement(re, { gap: "small" }, n)
);
var pR = "_10seo091 _10seo090 _1s8b37jl7 _1s8b37jw7", jR = "_10seo093 _10seo092 _1s8b37jlo", vR = "_10seo095 _10seo094 _1s8b37jmh _1s8b37jvn _1s8b37j199 _1s8b37j12b _1s8b37jg _1s8b37j2p7", hR = "_10seo097 _10seo096 _1s8b37j126 _1s8b37j2p2", gR = "_10seo099", yR = "_10seo09b _10seo09a _1s8b37jkl _1s8b37jkp _1s8b37jkt _1s8b37jky _1s8b37jck _1s8b37jl3 _1s8b37jl5 _1s8b37j29d", wR = "_10seo09d _10seo09c _1s8b37j25m _1s8b37j270 _1s8b37j284 _1s8b37j23y _1s8b37jl5 _1s8b37jlo", CR = "_10seo09f _10seo09e _1s8b37jlc _1s8b37js", ER = "_10seo09i _10seo09h _1s8b37jk8 _1s8b37jkc _1s8b37jkg _1s8b37jkk _1s8b37j5g _1s8b37j293 _1s8b37jm7";
function l_(e) {
  return `#${e.toLocaleLowerCase().replaceAll(" ", "-")}`;
}
const c_ = l.createContext({
  // sections: new Map(),
  headings: /* @__PURE__ */ new Map(),
  activeSectionHash: void 0,
  sectionOffset: -30,
  registerHeading: () => {
  },
  unregisterHeading: () => {
  },
  registerSection: () => {
  },
  unregisterSection: () => {
  },
  scrollToHash: () => {
  }
}), Do = () => l.useContext(c_), xR = ({
  children: e,
  sectionOffset: t = -80,
  ...n
}) => {
  const r = l.useRef(null), [a, s] = l.useState(
    /* @__PURE__ */ new Map()
  ), [o, i] = l.useState(""), [c, u] = l.useState(""), [f, m] = l.useState(!1), [b, _] = l.useState(/* @__PURE__ */ new Map()), j = l.useCallback(
    (E) => {
      _((C) => {
        const S = new Map(C);
        for (const k of E)
          S.set(k.target, k);
        return S;
      });
    },
    []
  ), p = new IntersectionObserver(j, {
    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    rootMargin: `${t}px`
  }), v = l.useCallback((E, C) => {
    s((S) => {
      const k = new Map(S);
      return k.set(E, C), k;
    });
  }, []), h = l.useCallback(
    (E) => {
      s((C) => {
        const S = new Map(C);
        return S.delete(E), S;
      });
    },
    [a]
  ), g = l.useCallback(
    (E) => {
      p.observe(E);
    },
    [p]
  ), w = l.useCallback(
    (E) => {
      p.unobserve(E), _((C) => {
        const S = new Map(C);
        return S.delete(E), S;
      });
    },
    [p]
  );
  function x(E) {
    if (E == null)
      return null;
    const C = E.scrollHeight > E.clientHeight, k = window.getComputedStyle(E).overflowY.indexOf("auto") !== -1;
    return C && k && E.tagName !== "BODY" ? E : x(E.parentElement);
  }
  l.useEffect(() => {
    var C, S;
    if (!f)
      return;
    if (c) {
      const k = Array.from(b).find(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ([O, L]) => {
          var H;
          return ((H = O == null ? void 0 : O.querySelector("a[data-fenrir-page-heading='true']")) == null ? void 0 : H.getAttribute("href")) === c;
        }
      );
      if ((C = k == null ? void 0 : k[1]) != null && C.isIntersecting) {
        i(c);
        return;
      } else
        u("");
    }
    const E = Array.from(b).find(
      ([, k]) => k == null ? void 0 : k.isIntersecting
    );
    if (E) {
      const k = ((S = E == null ? void 0 : E[0].querySelector("a[data-fenrir-page-heading='true']")) == null ? void 0 : S.getAttribute("href")) ?? void 0;
      k != null && i(k);
    }
  }, [b, f]);
  const y = l.useCallback(
    (E) => {
      var S;
      const C = (S = document.querySelectorAll(
        `a[href="${E}"][data-fenrir-page-heading='true']`
      )) == null ? void 0 : S[0];
      if (C) {
        u(E), i(E);
        const k = C.getBoundingClientRect(), O = x(r.current);
        if (O) {
          const L = k.top + O.scrollTop - -1 * t;
          O.scrollTop = L;
        } else {
          const L = k.top + window.scrollY - -1 * t;
          window.scrollTo({ top: L });
        }
      }
    },
    [b]
  );
  return l.useEffect(() => {
    if (!r.current)
      return;
    y(window.location.hash);
    const E = new ResizeObserver(() => {
      y(window.location.hash);
    });
    E.observe(r.current), setTimeout(() => {
      m(!0), E.disconnect();
    }, 2e3);
  }, [r.current]), /* @__PURE__ */ l.createElement(
    c_.Provider,
    {
      value: {
        headings: a,
        activeSectionHash: o,
        sectionOffset: t,
        registerHeading: v,
        unregisterHeading: h,
        registerSection: g,
        unregisterSection: w,
        scrollToHash: y
      }
    },
    /* @__PURE__ */ l.createElement(U.div, { ...n, ref: r }, e)
  );
}, SR = l.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(kr, { ...t, ref: n }, e)
), kR = l.forwardRef(
  ({ children: e, ...t }, n) => {
    const r = l.useRef(!1), a = l.useRef(null), s = Do();
    l.useEffect(() => {
      const i = a.current;
      return !r.current && i && (s == null || s.registerSection(i), r.current = !0), () => {
        i && (s == null || s.unregisterSection(i), r.current = !1);
      };
    }, []);
    const o = We([a, n]);
    return /* @__PURE__ */ l.createElement(U.section, { ...t, ref: o }, e);
  }
), TR = l.forwardRef(({ children: e, className: t, styledAs: n = "heading2", ...r }, a) => {
  const s = l.useRef(!1), o = l_(e), i = l.useRef(null), c = Do(), u = kt("fenrir-section-heading");
  l.useEffect(() => {
    !s.current && i.current && (c == null || c.registerHeading(u, {
      text: e,
      element: i.current
    }), s.current = !0);
  }, [u]);
  const f = We([i, a]);
  l.useEffect(() => () => {
    c == null || c.unregisterHeading(u), s.current = !1;
  }, []);
  const m = l.useCallback(() => {
    c.scrollToHash(o);
  }, [c, o]);
  return /* @__PURE__ */ l.createElement(
    re,
    {
      className: q(t, pR),
      gap: "small",
      onClick: m,
      asChild: !0
    },
    /* @__PURE__ */ l.createElement(
      U.a,
      {
        ...r,
        className: jR,
        href: o,
        ref: f,
        "data-fenrir-page-heading": !0
      },
      /* @__PURE__ */ l.createElement(kr, { level: "2", styledAs: n }, e),
      /* @__PURE__ */ l.createElement(U.div, { className: vR }, /* @__PURE__ */ l.createElement(e2, { className: hR }))
    )
  );
}), RR = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(U.div, { ...t, ref: n }, e)), OR = l.forwardRef(({ children: e, className: t, ...n }, r) => {
  const a = Do();
  return a.headings == null || a.headings.size === 0 ? null : /* @__PURE__ */ l.createElement(
    ye,
    {
      ...n,
      ref: r,
      className: q(gR, t)
    },
    e
  );
}), MR = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(kr, { ...t, level: "2", styledAs: "heading5", ref: n }, e)), AR = l.forwardRef((e, t) => {
  var f;
  const n = l.useRef(/* @__PURE__ */ new Map()), r = l.useRef(null), a = We([t, r]), { activeSectionHash: s, ...o } = Do(), i = l.useCallback(
    (m, b) => {
      n.current.set(m, b);
    },
    [n]
  ), c = l.useCallback(
    (m) => {
      o.scrollToHash(m);
    },
    [o]
  ), u = l.useMemo(() => {
    var _, j;
    const m = (_ = n.current.get(s || "")) == null ? void 0 : _.getBoundingClientRect(), b = (j = r.current) == null ? void 0 : j.getBoundingClientRect();
    return !m || !b ? {
      opacity: 0
    } : {
      top: m.top - b.top,
      opacity: 1
    };
  }, [s, n, r]);
  return /* @__PURE__ */ l.createElement(
    ye,
    {
      ...e,
      gap: "small",
      className: yR,
      ref: a
    },
    /* @__PURE__ */ l.createElement(
      U.span,
      {
        className: ER,
        style: { ...u }
      }
    ),
    o.headings != null && ((f = Array.from(o.headings)) == null ? void 0 : f.map(([, { text: m }], b) => {
      const _ = l_(m);
      return /* @__PURE__ */ l.createElement(
        U.a,
        {
          key: b,
          href: _,
          className: q(wR),
          ref: (j) => i(_, j),
          onClick: () => c(_)
        },
        /* @__PURE__ */ l.createElement(
          ne,
          {
            styledAs: "body1",
            className: q({
              [CR]: _ === s
            })
          },
          m
        )
      );
    }))
  );
}), gD = {
  Root: xR,
  Title: SR,
  Section: kR,
  SectionHeading: TR,
  SectionContent: RR,
  TableOfContents: OR,
  TableOfContentsTitle: MR,
  TableOfContentsItems: AR
};
var PR = "_16cn2g70", NR = "_16cn2g71";
const DR = [
  { value: "10", text: "10" },
  { value: "25", text: "25" },
  { value: "50", text: "50" },
  { value: "100", text: "100" }
], ff = ({
  currentRows: e,
  hasNextPage: t,
  hasPreviousPage: n,
  onNextPage: r,
  onPreviousPage: a,
  onSetPageIndex: s,
  onPageSizeChange: o,
  pageCount: i,
  pageIndex: c,
  rowsPerPage: u,
  totalRows: f,
  firstPageButtonAriaLabel: m = "Go to first page",
  previousPageButtonAriaLabel: b = "Go to previous page",
  pageInputAriaLabel: _ = "Current page",
  nextPageButtonAriaLabel: j = "Go to next page",
  lastPageButtonAriaLabel: p = "Go to last page",
  informationLabel: v,
  pageCountLabel: h,
  label: g,
  showRowsPerPageSelector: w = !1,
  ...x
}) => {
  const [y, E] = l.useState(""), C = Te(null);
  le(() => {
    E(String(c + 1));
  }, [c]);
  const S = Le(() => g === void 0 ? `Pagination: page ${c + 1} of ${i} pages` : typeof g == "function" ? g(c, i) : g, [g, c, i]), k = Le(() => h === void 0 ? `of ${i} pages` : typeof h == "function" ? h(i) : h, [h, i]), O = Le(() => {
    if (v === void 0) {
      const M = c * u, D = Vo(M + 1), I = Vo(M + e), F = Vo(f);
      return `Showing ${D} - ${I} of ${F} matches`;
    }
    return typeof v == "function" ? v(c, u, e, f) : v;
  }, [v, c, u, e, f]), L = (M) => {
    const D = M.target.value;
    E(D);
  }, H = _e(
    (M) => {
      const D = M.target.value ? Number(M.target.value) : c + 1;
      if (M.target.value || E(String(D)), D > i)
        return s(i - 1);
      if (D < 1)
        return E(String(1)), s(0);
      s(D - 1);
    },
    [c]
  ), T = _e(
    (M) => {
      var D;
      M.key === "Enter" && ((D = C == null ? void 0 : C.current) == null || D.blur());
    },
    [C]
  ), R = (M) => {
    M && o(parseInt(M.value));
  };
  return /* @__PURE__ */ l.createElement(
    U.div,
    {
      alignItems: "center",
      "aria-label": S,
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "flex-end",
      marginTop: "medium",
      role: "navigation",
      ...x
    },
    w && /* @__PURE__ */ l.createElement(
      U.div,
      {
        display: "flex",
        alignItems: "center",
        gap: "small",
        marginRight: "medium"
      },
      /* @__PURE__ */ l.createElement(U.div, null, "Rows per page:"),
      /* @__PURE__ */ l.createElement(U.div, null, /* @__PURE__ */ l.createElement(
        Q8,
        {
          value: u.toString(),
          options: DR,
          onSelection: R,
          isClearable: !1
        }
      ))
    ),
    O && /* @__PURE__ */ l.createElement(U.div, { marginRight: "small" }, O),
    /* @__PURE__ */ l.createElement(U.div, { display: "flex", alignItems: "center", flexWrap: "wrap" }, /* @__PURE__ */ l.createElement(
      Me,
      {
        appearance: "default",
        "aria-label": m,
        isDisabled: !n,
        marginRight: "small",
        onClick: () => s(0)
      },
      /* @__PURE__ */ l.createElement(me, { icon: Oh })
    ), /* @__PURE__ */ l.createElement(
      Me,
      {
        appearance: "default",
        "aria-label": b,
        isDisabled: !n,
        marginRight: "small",
        onClick: a
      },
      /* @__PURE__ */ l.createElement(me, { icon: Fb })
    ), /* @__PURE__ */ l.createElement(
      U.div,
      {
        alignItems: "center",
        display: "flex",
        justifyContent: "center"
      },
      /* @__PURE__ */ l.createElement(
        pr,
        {
          "aria-label": _,
          className: PR,
          max: i,
          min: 1,
          onChange: L,
          onBlur: H,
          onKeyDown: T,
          type: "number",
          value: y,
          ref: C
        }
      ),
      /* @__PURE__ */ l.createElement(U.span, { marginLeft: "small", className: NR }, k)
    ), /* @__PURE__ */ l.createElement(
      Me,
      {
        appearance: "default",
        "aria-label": j,
        isDisabled: !t,
        marginLeft: "small",
        onClick: r
      },
      /* @__PURE__ */ l.createElement(me, { icon: Ph })
    ), /* @__PURE__ */ l.createElement(
      Me,
      {
        appearance: "default",
        "aria-label": p,
        isDisabled: !t,
        marginLeft: "small",
        onClick: () => s(i - 1)
      },
      /* @__PURE__ */ l.createElement(me, { icon: Mh })
    ))
  );
};
function yD(e) {
  const { table: t, ...n } = e;
  if (t) {
    const { pagination: r } = t.getState();
    return /* @__PURE__ */ l.createElement(
      ff,
      {
        currentRows: t.getRowModel().rows.length,
        hasNextPage: t.getCanNextPage(),
        hasPreviousPage: t.getCanPreviousPage(),
        onNextPage: t.nextPage,
        onPreviousPage: t.previousPage,
        onSetPageIndex: t.setPageIndex,
        onPageSizeChange: t.setPageSize,
        pageCount: t.getPageCount(),
        pageIndex: r.pageIndex,
        rowsPerPage: r.pageSize,
        totalRows: t.getCoreRowModel().rows.length,
        ...n
      }
    );
  }
  return /* @__PURE__ */ l.createElement(ff, { ...e });
}
var IR = "_1rjx1q40", $R = "_1rjx1q41";
Q.extend(A7);
function Ni(e) {
  return new Date(Q(e).utc().toISOString());
}
const wD = ({
  appearance: e,
  defaultValue: t,
  label: n,
  isRequired: r,
  isDisabled: a,
  helpText: s,
  max: o,
  min: i,
  onValueChange: c,
  value: u,
  validationMessage: f,
  useCustomValidations: m = !1
}) => {
  const [b, _] = l.useState(!1), { validate: j, validationStatus: p } = Xs({
    min: i,
    max: o,
    validationMessage: f
  }), [v, h] = nt({
    prop: u,
    defaultProp: t,
    onChange: (C) => {
      c == null || c(C), j(C);
    }
  }), g = l.createRef(), w = l.useMemo(() => {
    if (v === "")
      return null;
    if (v && _a(v))
      return Ni(v);
  }, [v]), x = (C) => {
    h(C);
  }, y = (C, S) => {
    g.current.contains(C == null ? void 0 : C.target) && C.type === "dismissableLayer.pointerDownOutside" || (C.preventDefault(), _(S));
  }, E = l.useCallback(
    (C) => {
      if (C == null) {
        h("");
        return;
      }
      const S = pn(
        Q(C),
        "local",
        "logDate"
      );
      h(S), _(!1);
    },
    [h]
  );
  return /* @__PURE__ */ l.createElement(
    Ae.Root,
    {
      appearance: p.isValid ? e || void 0 : "danger",
      isRequired: r
    },
    n && /* @__PURE__ */ l.createElement(Ae.Label, null, n),
    s && /* @__PURE__ */ l.createElement(Ae.Info, null, s),
    /* @__PURE__ */ l.createElement(Ae.Content, null, /* @__PURE__ */ l.createElement(
      Js,
      {
        isDisabled: a,
        value: v || "",
        defaultValue: t,
        onValueChange: x,
        "aria-invalid": !p.isValid,
        endAdornment: /* @__PURE__ */ l.createElement(Fe.Root, { isOpen: b }, /* @__PURE__ */ l.createElement(Fe.Trigger, { asChild: !0 }, /* @__PURE__ */ l.createElement("div", { ref: g }, /* @__PURE__ */ l.createElement(
          Me,
          {
            "aria-label": b ? "close calendar" : "open calendar",
            onClick: (C) => y(C, !b),
            className: $R,
            isDisabled: a
          },
          /* @__PURE__ */ l.createElement(na, null)
        ))), /* @__PURE__ */ l.createElement(
          Fe.Content,
          {
            className: IR,
            onOpenAutoFocus: (C) => C.preventDefault(),
            onEscapeKeyDown: () => _(!1),
            onPointerDownOutside: (C) => y(C, !1),
            sideOffset: 12,
            align: "end"
          },
          /* @__PURE__ */ l.createElement(
            R8,
            {
              max: o ? Ni(o) : void 0,
              min: i ? Ni(i) : void 0,
              value: w,
              onValueChange: E,
              focusDayOnMount: !0
            }
          )
        ))
      }
    )),
    m ? null : /* @__PURE__ */ l.createElement(Ae.Message, null, p.message)
  );
};
var LR = "_10lb3t50", zR = "_10lb3t51";
const CD = ({
  appearance: e,
  defaultValue: t,
  format: n = Be.TwentyFourHour,
  label: r,
  isRequired: a,
  isDisabled: s,
  helpText: o,
  max: i,
  min: c,
  onValueChange: u,
  value: f,
  validationMessage: m,
  hideNow: b
}) => {
  const { validate: _, validationStatus: j } = Zs({
    min: c,
    max: i,
    format: n,
    validationMessage: m
  }), [p, v] = l.useState(!1), [h, g] = l.useState(), [w, x] = nt({
    prop: f,
    defaultProp: t,
    onChange: (T) => {
      _(T), u == null || u(T);
    }
  });
  le(() => {
    if (t)
      try {
        const T = ot(t);
        g(T), x(Lt(n, T));
      } catch {
      }
  }, [t, n, x]), le(() => {
    if (w)
      try {
        const T = ot(w);
        g(T);
      } catch {
      }
  }, [w]);
  const { timezone: y } = Na(), E = l.createRef(), C = l.createRef(), S = l.useCallback(
    (T) => {
      x(Lt(n, T)), g(T);
    },
    [n, x]
  ), k = l.useCallback(
    (T) => {
      if (w && !T)
        try {
          g(ot(w));
        } catch {
        }
    },
    [w]
  ), O = l.useCallback(
    (T, R) => {
      E.current.contains(T == null ? void 0 : T.target) && T.type === "dismissableLayer.pointerDownOutside" || v(R);
    },
    [E]
  ), L = l.useCallback(
    (T) => {
      var I, F;
      const R = /* @__PURE__ */ new Date(), M = y === "utc" ? R.getUTCHours() : R.getHours(), D = {
        hours: `${M}`.padStart(2, "0"),
        minutes: `${y === "utc" ? R.getUTCMinutes() : R.getMinutes()}`.padStart(2, "0"),
        seconds: `${y === "utc" ? R.getUTCSeconds() : R.getSeconds()}`.padStart(2, "0")
      };
      (n === Be.TwelveHour || Be.TwelveHourWithSeconds) && (M === 0 ? (D.hours = "12", D.amPM = "AM") : M === 12 ? D.amPM = "PM" : M <= 11 ? D.amPM = "AM" : (D.hours = `${M - 12}`.padStart(2, "0"), D.amPM = "PM")), g(D), x(Lt(n, D)), (F = (I = E.current) == null ? void 0 : I.querySelector("button")) == null || F.focus(), O(T, !1);
    },
    [n, x, E, y, O]
  ), H = (T) => {
    var R, M;
    p && (T.code === "Enter" || T.code === "Space") && (T.preventDefault(), T.stopPropagation(), (M = (R = E.current) == null ? void 0 : R.querySelector("button")) == null || M.focus(), O(T, !1));
  };
  return /* @__PURE__ */ l.createElement(
    Ae.Root,
    {
      appearance: j.isValid ? e || void 0 : "danger",
      isRequired: a
    },
    r && /* @__PURE__ */ l.createElement(Ae.Label, null, r),
    o && /* @__PURE__ */ l.createElement(Ae.Info, null, o),
    /* @__PURE__ */ l.createElement(Ae.Content, null, /* @__PURE__ */ l.createElement(
      B7,
      {
        isDisabled: s,
        value: w || "",
        defaultValue: t,
        onValueChange: x,
        "aria-invalid": !j.isValid,
        format: n,
        endAdornment: /* @__PURE__ */ l.createElement(
          Fe.Root,
          {
            isOpen: p,
            onIsOpenChange: k
          },
          /* @__PURE__ */ l.createElement(Fe.Trigger, { asChild: !0 }, /* @__PURE__ */ l.createElement("div", { ref: E }, /* @__PURE__ */ l.createElement(
            Me,
            {
              "aria-label": p ? "close time picker" : "open time picker",
              onClick: (T) => O(T, !p),
              className: zR,
              isDisabled: s
            },
            /* @__PURE__ */ l.createElement(Hi, null)
          ))),
          /* @__PURE__ */ l.createElement(
            Fe.Content,
            {
              className: LR,
              onOpenAutoFocus: (T) => T.preventDefault(),
              onEscapeKeyDown: () => v(!1),
              onPointerDownOutside: (T) => O(T, !1),
              sideOffset: 12,
              align: "end",
              padding: "large"
            },
            /* @__PURE__ */ l.createElement("div", { ref: C, onKeyDown: H }, /* @__PURE__ */ l.createElement(
              F7,
              {
                format: n,
                min: c ? ot(c) : void 0,
                max: i ? ot(i) : void 0,
                value: h,
                onValueChange: S,
                focusOnMount: !0
              }
            )),
            /* @__PURE__ */ l.createElement(
              re,
              {
                yAlign: "center",
                xAlign: "center",
                padding: "zero",
                paddingTop: "large"
              },
              !b && /* @__PURE__ */ l.createElement(U.div, { padding: "zero", paddingRight: "small" }, /* @__PURE__ */ l.createElement(Et, { variant: "tertiary", onClick: L }, "Now")),
              /* @__PURE__ */ l.createElement(U.div, { padding: "zero" }, /* @__PURE__ */ l.createElement(
                Et,
                {
                  variant: "primary",
                  onClick: (T) => O(T, !1)
                },
                "Apply"
              ))
            )
          )
        )
      }
    )),
    j.message && j.message !== "" && /* @__PURE__ */ l.createElement(Ae.Message, null, j.message)
  );
}, u_ = ({ fieldLayout: e, children: t, ...n }) => /* @__PURE__ */ l.createElement(
  ye,
  {
    marginBottom: e == "hstack" ? "large" : "medium",
    ...n
  },
  /* @__PURE__ */ l.createElement(ne, { styledAs: "body4" }, t)
), eo = ({
  appearance: e,
  label: t,
  helpText: n,
  validationMessage: r = "",
  isRequired: a,
  children: s
}) => /* @__PURE__ */ l.createElement(Ae.Root, { appearance: e, isRequired: a }, t && /* @__PURE__ */ l.createElement(Ae.Label, null, t), n && /* @__PURE__ */ l.createElement(Ae.Info, null, n), /* @__PURE__ */ l.createElement(Ae.Content, null, s), /* @__PURE__ */ l.createElement(Ae.Message, null, r)), d_ = ({ fieldLayout: e = "hstack", children: t }) => e === "hstack" ? /* @__PURE__ */ l.createElement(
  re,
  {
    alignItems: "flex-end",
    width: {
      monitor: "40rem",
      tablet: "full"
    },
    asChild: !0
  },
  t
) : /* @__PURE__ */ l.createElement(ye, { asChild: !0, gap: "small" }, t), Hl = ({
  id: e,
  name: t,
  value: n,
  defaultValue: r,
  onValueChange: a,
  separator: s = "-",
  max: o,
  min: i,
  isRequired: c,
  isDisabled: u,
  onValidationChange: f,
  maxRange: m,
  fieldLayout: b = "hstack",
  startFieldProps: _,
  endFieldProps: j,
  startInputProps: p,
  endInputProps: v
}) => {
  const {
    validate: h,
    validationStatuses: {
      start: g,
      end: w,
      range: x
    }
  } = Ck({
    max: o,
    maxRange: m,
    min: i
  }), [y, E] = l.useState(), [C, S] = l.useState(), k = l.useId(), O = `${e ?? k}-start`, L = `${e ?? k}-end`;
  l.useEffect(() => {
    if (!n) return;
    const [T, R] = n;
    E(T), S(R);
  }, [n, E, S]), l.useEffect(() => {
    if (!r) return;
    const [T, R] = r;
    E(T), S(R);
  }, [r]), l.useEffect(() => {
    h([
      y ?? "",
      C ?? ""
    ]);
  }, [C, y, h]), l.useEffect(() => {
    f == null || f(
      g.isValid && w.isValid && x.isValid
    );
  }, [
    g.isValid,
    f,
    x.isValid,
    w.isValid
  ]);
  const H = l.useCallback(
    (T, R) => {
      R === "start" && (a == null || a([T, C])), R === "end" && (a == null || a([y, T]));
    },
    [a, C, y]
  );
  return /* @__PURE__ */ l.createElement(d_, { fieldLayout: b }, /* @__PURE__ */ l.createElement(U.div, null, /* @__PURE__ */ l.createElement(
    eo,
    {
      appearance: g.isValid && x.isValid ? (_ == null ? void 0 : _.appearance) ?? void 0 : "danger",
      label: _ == null ? void 0 : _.label,
      helpText: _ == null ? void 0 : _.helpText,
      isRequired: c || (_ == null ? void 0 : _.isRequired),
      validationMessage: g.message || x.message || (_ == null ? void 0 : _.validationMessage)
    },
    /* @__PURE__ */ l.createElement(
      Js,
      {
        id: O,
        name: t,
        value: y,
        isDisabled: u,
        onValueChange: (T) => {
          E(T), H(T, "start");
        },
        "data-testid": "start-date-field",
        "aria-invalid": !g.isValid,
        ...p
      }
    )
  ), s && /* @__PURE__ */ l.createElement(u_, { fieldLayout: b }, s), /* @__PURE__ */ l.createElement(
    eo,
    {
      appearance: w.isValid ? (j == null ? void 0 : j.appearance) ?? void 0 : "danger",
      label: j == null ? void 0 : j.label,
      isRequired: c || (j == null ? void 0 : j.isRequired),
      helpText: j == null ? void 0 : j.helpText,
      validationMessage: w.message || (j == null ? void 0 : j.validationMessage)
    },
    /* @__PURE__ */ l.createElement(
      Js,
      {
        id: L,
        name: t,
        value: C,
        isDisabled: u,
        onValueChange: (T) => {
          S(T), H(T, "end");
        },
        "data-testid": "end-date-field",
        "aria-invalid": !w.isValid,
        ...v
      }
    )
  )));
}, Bl = ({
  id: e,
  name: t,
  value: n,
  defaultValue: r,
  onValueChange: a,
  separator: s = "-",
  max: o,
  min: i,
  isRequired: c,
  isDisabled: u,
  onValidationChange: f,
  maxRange: m,
  fieldLayout: b = "hstack",
  startFieldProps: _,
  endFieldProps: j,
  startInputProps: p,
  endInputProps: v
}) => {
  const {
    timezone: h,
    appliedTimeFormat: g,
    validateDateTimeFormat: w
  } = Ar({}), { format: x = g } = (p == null ? void 0 : p.timeFieldProps) || {}, { format: y = g } = (p == null ? void 0 : p.timeFieldProps) || {}, {
    validate: E,
    validationStatuses: {
      start: C,
      end: S,
      range: k
    }
  } = Ek({
    max: o,
    maxRange: m,
    min: i,
    startTimeFormat: x,
    endTimeFormat: y
  }), [O, L] = l.useState(), [H, T] = l.useState(), R = l.useId(), M = `${e ?? R}-start`, D = `${e ?? R}-end`;
  l.useEffect(() => {
    if (!n) return;
    const [P, A] = n;
    L(P), T(A);
  }, [
    n,
    L,
    T,
    h,
    x,
    y,
    g
  ]), l.useEffect(() => {
    if (!r) return;
    const [P, A] = r;
    L(P), T(A);
  }, [r]), l.useEffect(() => {
    E([
      O ?? "",
      H ?? ""
    ]);
  }, [H, O, E]), l.useEffect(() => {
    f == null || f(
      C.isValid && S.isValid && k.isValid
    );
  }, [
    C.isValid,
    f,
    k.isValid,
    S.isValid
  ]);
  const I = l.useCallback(
    (P, A) => {
      if (P && !w(P, A === "start" ? x : y)) return;
      const B = P && Q(P).toISOString();
      if (A === "start") {
        const Y = H && w(H, y) ? Q(H).toISOString() : H;
        a == null || a([B, Y]);
      }
      if (A === "end") {
        const Y = O && w(O, x) ? Q(O).toISOString() : O;
        a == null || a([Y, B]);
      }
    },
    [
      y,
      a,
      x,
      H,
      O,
      w
    ]
  ), F = l.useCallback(() => {
    const P = O && zt(O) ? Q(O).toISOString() : O, A = H && zt(H) ? Q(H).toISOString() : H;
    a == null || a([P, A]);
  }, [a, H, O]);
  return /* @__PURE__ */ l.createElement(d_, { fieldLayout: b }, /* @__PURE__ */ l.createElement(U.div, null, /* @__PURE__ */ l.createElement(
    eo,
    {
      appearance: C.isValid && k.isValid ? (_ == null ? void 0 : _.appearance) ?? void 0 : "danger",
      label: _ == null ? void 0 : _.label,
      helpText: _ == null ? void 0 : _.helpText,
      isRequired: c || (_ == null ? void 0 : _.isRequired),
      validationMessage: C.message || (_ == null ? void 0 : _.validationMessage) || k.message
    },
    /* @__PURE__ */ l.createElement(
      Xd,
      {
        id: M,
        name: t,
        value: O,
        isDisabled: u,
        onValueChange: (P) => {
          I(P, "start"), L(P);
        },
        onBlur: F,
        "data-testid": "start-datetime-field",
        "aria-invalid": !C.isValid,
        ...p
      }
    )
  ), s && /* @__PURE__ */ l.createElement(u_, { fieldLayout: b }, s), /* @__PURE__ */ l.createElement(
    eo,
    {
      appearance: S.isValid ? (j == null ? void 0 : j.appearance) ?? void 0 : "danger",
      label: j == null ? void 0 : j.label,
      isRequired: c || (j == null ? void 0 : j.isRequired),
      helpText: j == null ? void 0 : j.helpText,
      validationMessage: S.message || (j == null ? void 0 : j.validationMessage)
    },
    /* @__PURE__ */ l.createElement(
      Xd,
      {
        id: D,
        name: t,
        value: H,
        isDisabled: u,
        onValueChange: (P) => {
          I(P, "end"), T(P);
        },
        onBlur: F,
        "data-testid": "end-datetime-field",
        "aria-invalid": !S.isValid,
        ...v
      }
    )
  )));
}, FR = ({
  title: e,
  options: t,
  value: n,
  onSelection: r,
  onValueChange: a,
  variant: s
}) => /* @__PURE__ */ l.createElement(Ai.Root, { minWidth: "max-content", maxWidth: "full" }, e && /* @__PURE__ */ l.createElement(Ai.Title, null, e), t.map((o) => {
  const i = o.value === n;
  return /* @__PURE__ */ l.createElement(
    Ai.Item,
    {
      key: `${o.value}`,
      isSelected: i,
      onSelect: () => {
        a == null || a(o.value), r == null || r(o);
      }
    },
    /* @__PURE__ */ l.createElement(re, { gap: "small", alignItems: "flex-start" }, s === "check" && /* @__PURE__ */ l.createElement(U.div, { width: "0.75rem", height: "0.75rem" }, i && /* @__PURE__ */ l.createElement(ha, null)), o.text)
  );
})), HR = ({ value: e, options: t, onValueChange: n, ...r }) => {
  const a = (o) => {
    if (!n || !o)
      return;
    const i = [
      Q().add(o, "hour").toDate(),
      Q().toDate()
    ];
    n(i);
  }, s = l.useMemo(() => e && Q(e[1]).diff(Q(), "hour") === 0 ? Q(e[0]).diff(Q(), "hour") : void 0, [e]);
  return /* @__PURE__ */ l.createElement(
    FR,
    {
      ...r,
      options: t,
      value: s,
      onValueChange: a
    }
  );
}, BR = ({
  value: e,
  onValueChange: t,
  min: n,
  max: r,
  numberOfMonths: a = 2
}) => {
  const { toTimezoneDate: s } = Ar({}), [o, i] = e ?? [], c = (f) => {
    if (t)
      if (f) {
        const m = Q(o).year(f.getFullYear()).month(f.getMonth()).date(f.getDate());
        t([m.toDate(), i]);
      } else
        t([void 0, void 0]);
  }, u = (f) => {
    if (t)
      if (f) {
        const m = Q(i).year(f.getFullYear()).month(f.getMonth()).date(f.getDate());
        if (i || !o) {
          t([o, m.toDate()]);
          return;
        }
        const b = Q(o), _ = m.hour(b.hour()).minute(b.minute()).second(b.second()).millisecond(b.millisecond());
        t([o, _.toDate()]);
      } else
        t([void 0, void 0]);
  };
  return /* @__PURE__ */ l.createElement(
    W6,
    {
      min: s(n),
      max: s(r),
      start: s(o) || null,
      end: i ? {
        date: s(i) || i,
        isSelected: !0
      } : void 0,
      onStartChange: c,
      onEndChange: (f) => {
        (!f || f != null && f.isSelected) && u(f == null ? void 0 : f.date);
      },
      numberOfMonths: a
    }
  );
}, qR = ({
  value: e,
  onValueChange: t,
  variant: n = "range",
  direction: r,
  min: a,
  max: s,
  todayButtonLabel: o = "Today",
  applyButtonLabel: i = "Apply",
  maxRangeLabel: c,
  calendarMode: u = "double",
  timeFormat: f = Be.TwentyFourHourWithSeconds,
  onTodayClick: m,
  onApplyClick: b
}) => {
  const [_, j] = l.useState(e), [p, v] = _, h = () => {
    const w = [
      Q().startOf("day").toDate(),
      Q().endOf("day").toDate()
    ];
    t(w), m == null || m(w);
  }, g = () => {
    t(_), b == null || b(_);
  };
  return l.useEffect(() => {
    j(e);
  }, [e]), /* @__PURE__ */ l.createElement(ye, { style: { minWidth: "33rem" } }, /* @__PURE__ */ l.createElement(
    re,
    {
      alignItems: "flex-start",
      padding: "medium",
      paddingBottom: "zero",
      width: "full",
      boxSizing: "border-box"
    },
    n === "range" && /* @__PURE__ */ l.createElement(
      BR,
      {
        min: a,
        max: s,
        value: _,
        onValueChange: (w) => {
          j(w), t == null || t(w);
        },
        numberOfMonths: u === "single" ? 1 : 2
      }
    ),
    n === "datetime" && /* @__PURE__ */ l.createElement(
      Rk,
      {
        width: "full",
        justifyContent: "space-between",
        alignItems: "flex-start",
        value: r === "start" ? p : v,
        timeFormat: f,
        onValueChange: (w) => {
          r === "start" ? (j([w, v]), t == null || t([w, v])) : (j([p, w]), t == null || t([p, w]));
        }
      }
    )
  ), /* @__PURE__ */ l.createElement(
    re,
    {
      width: "full",
      justifyContent: "space-between",
      style: {
        alignItems: "baseline"
      },
      boxSizing: "border-box",
      paddingLeft: "medium"
    },
    /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, u === "double" && c),
    /* @__PURE__ */ l.createElement(
      re,
      {
        justifyContent: "flex-end",
        padding: "medium",
        paddingTop: "zero",
        boxSizing: "border-box"
      },
      /* @__PURE__ */ l.createElement(Et, { variant: "tertiary", onClick: h }, o),
      /* @__PURE__ */ l.createElement(Et, { onClick: g }, i)
    )
  ));
};
var $t = /* @__PURE__ */ ((e) => (e.Range = "range", e.DateTime = "datetime", e))($t || {}), gt = /* @__PURE__ */ ((e) => (e.Menu = "menu", e.Picker = "picker", e.PickerMenu = "pickerMenu", e))(gt || {}), Rn = /* @__PURE__ */ ((e) => (e.Date = "date", e.DateTime = "datetime", e))(Rn || {}), UR = "_16r8j4o0", WR = "_16r8j4o1", VR = "_16r8j4o2";
const f_ = ({
  value: e,
  defaultValue: t,
  min: n,
  max: r,
  todayButtonLabel: a = "Today",
  applyButtonLabel: s = "Apply",
  maxRangeLabel: o,
  maxRange: i,
  menuOptions: c,
  menuLabel: u = "Quick Select",
  rangeMenuConfig: f,
  direction: m = "start",
  onValueChange: b,
  onTodayClick: _,
  onApplyClick: j,
  onMenuClick: p,
  fieldProps: v
}) => {
  const { appliedTimeFormat: h } = Ar({
    timeFormat: f == null ? void 0 : f.timeFormat
  }), [g, w] = l.useState(), [x, y] = l.useState(), E = (f == null ? void 0 : f.variant) === gt.Menu || (f == null ? void 0 : f.variant) === gt.PickerMenu, C = !f || !(f != null && f.variant) || // if no config is supplied default to picker
  (f == null ? void 0 : f.variant) === gt.Picker || (f == null ? void 0 : f.variant) === gt.PickerMenu, S = (f == null ? void 0 : f.showField) && C, k = (f == null ? void 0 : f.showField) && (f == null ? void 0 : f.variant) === gt.Menu, O = (f == null ? void 0 : f.mode) || Rn.Date, [L, H] = l.useState(
    []
  ), T = l.useCallback(
    (W) => {
      if (W) {
        const [V, K] = W, te = V && Q(V).isValid() ? Q(V) : void 0, Z = K && Q(K).isValid() ? Q(K) : void 0;
        if (O === Rn.Date)
          return [
            te ? pn(te, "local", "logDate") : void 0,
            Z ? pn(Z, "local", "logDate") : void 0
          ];
        if (O === Rn.DateTime)
          return [
            te ? te.toISOString() : void 0,
            Z ? Z.toISOString() : void 0
          ];
      }
      return [void 0, void 0];
    },
    [O]
  ), [R, M] = l.useState(m);
  l.useEffect(() => {
    m && M(m);
  }, [m]);
  const [D, I] = l.useState();
  l.useEffect(() => {
    I((f == null ? void 0 : f.pickerVariant) ?? "range");
  }, [f == null ? void 0 : f.pickerVariant]), l.useEffect(() => {
    if (!e) return;
    const [W, V] = T(e);
    w(W), y(V), H([
      W ? Gn(W) : void 0,
      V ? Gn(V) : void 0
    ]);
  }, [
    e,
    w,
    y,
    H,
    T
  ]), l.useEffect(() => {
    if (!t) return;
    const [W, V] = T(t);
    w(W), y(V), H([
      W ? Gn(W) : void 0,
      V ? Gn(V) : void 0
    ]);
  }, [
    t,
    w,
    y,
    H,
    T
  ]), l.useEffect(() => {
    if (!(f != null && f.showField)) return;
    const [W, V] = T(L);
    w(W), y(V);
  }, [
    f == null ? void 0 : f.showField,
    T,
    w,
    y,
    L
  ]);
  const F = l.useCallback(
    (W) => {
      W && H([
        g ? Gn(g) : void 0,
        x ? Gn(x) : void 0
      ]);
    },
    [g, x, H]
  ), P = l.useCallback(
    (W) => {
      const [V, K] = W;
      O === Rn.DateTime ? (V && zt(V) && w(V), K && zt(K) && y(K)) : (V && _a(V) && w(V), K && _a(K) && y(K));
    },
    [O]
  ), A = l.useCallback(
    (W) => {
      var K;
      if ((f == null ? void 0 : f.variant) === gt.Menu) return;
      const V = (K = W == null ? void 0 : W.target) == null ? void 0 : K.id;
      V != null && V.includes("start") ? M("start") : M("end"), V != null && V.includes("time") ? I("datetime") : I("range");
    },
    [f == null ? void 0 : f.variant, M, I]
  ), $ = l.useCallback(
    (W) => {
      H(W);
      const V = T(W);
      b == null || b(V), p == null || p(V);
    },
    [
      p,
      b,
      H,
      T
    ]
  ), B = l.useCallback(
    (W) => {
      const [V, K] = T(W);
      w(V || void 0), y(K || void 0), b == null || b([V, K]);
    },
    [w, y, b, T]
  ), Y = l.useCallback(
    (W) => {
      H(W);
      const V = T(W);
      b == null || b(V), _ == null || _(V);
    },
    [
      H,
      T,
      _,
      b
    ]
  ), J = l.useCallback(
    (W) => {
      H(W), I("range");
      const V = T(W);
      b == null || b(V), j == null || j(V);
    },
    [
      j,
      b,
      H,
      T
    ]
  );
  return /* @__PURE__ */ l.createElement(re, { alignItems: "flex-start", backgroundColor: "widgetDefault", gap: "zero" }, E && /* @__PURE__ */ l.createElement(ye, null, k && //field
  /* @__PURE__ */ l.createElement(
    ye,
    {
      boxSizing: "border-box",
      padding: "medium",
      gap: "zero",
      backgroundColor: "widgetHighlight"
    },
    O === "date" && /* @__PURE__ */ l.createElement(
      Hl,
      {
        fieldLayout: "vstack",
        value: [g, x],
        onValueChange: P,
        onValidationChange: F,
        startInputProps: {
          onFocus: A
        },
        endInputProps: {
          onFocus: A
        },
        min: n,
        max: r,
        maxRange: i,
        ...v
      }
    ),
    O === "datetime" && /* @__PURE__ */ l.createElement(
      Bl,
      {
        fieldLayout: "vstack",
        value: [g, x],
        onValueChange: P,
        onValidationChange: F,
        min: n,
        max: r,
        maxRange: i,
        startInputProps: {
          dateFieldProps: { onFocus: A },
          timeFieldProps: {
            onFocus: A,
            format: h
          }
        },
        endInputProps: {
          dateFieldProps: { onFocus: A },
          timeFieldProps: {
            onFocus: A,
            format: h
          }
        },
        ...v
      }
    )
  ), /* @__PURE__ */ l.createElement("div", { className: WR }, /* @__PURE__ */ l.createElement(
    HR,
    {
      title: u,
      variant: "check",
      options: c || [],
      value: L,
      onValueChange: $
    }
  ))), C && /* @__PURE__ */ l.createElement(
    ye,
    {
      style: { maxWidth: "33rem" },
      className: UR
    },
    S && /* @__PURE__ */ l.createElement(
      re,
      {
        boxSizing: "border-box",
        padding: "medium",
        backgroundColor: "widgetHighlight",
        className: VR
      },
      O === "date" && /* @__PURE__ */ l.createElement(
        Hl,
        {
          fieldLayout: "hstack",
          value: [g, x],
          onValueChange: P,
          onValidationChange: F,
          min: n,
          max: r,
          maxRange: i,
          startInputProps: {
            onFocus: A
          },
          endInputProps: {
            onFocus: A
          },
          ...v
        }
      ),
      O === "datetime" && /* @__PURE__ */ l.createElement(
        Bl,
        {
          fieldLayout: "hstack",
          value: [g, x],
          onValueChange: P,
          onValidationChange: F,
          min: n,
          max: r,
          maxRange: i,
          startInputProps: {
            dateFieldProps: { onFocus: A },
            timeFieldProps: {
              onFocus: A,
              format: h
            }
          },
          endInputProps: {
            dateFieldProps: { onFocus: A },
            timeFieldProps: {
              onFocus: A,
              format: h
            }
          },
          ...v
        }
      )
    ),
    /* @__PURE__ */ l.createElement(
      qR,
      {
        variant: D,
        timeFormat: h,
        direction: R,
        value: L,
        onValueChange: B,
        min: n ? Q(n).toDate() : void 0,
        max: r ? Q(r).toDate() : void 0,
        onTodayClick: Y,
        onApplyClick: J,
        todayButtonLabel: a,
        applyButtonLabel: s,
        maxRangeLabel: o,
        calendarMode: f == null ? void 0 : f.calendarMode
      }
    )
  ));
}, ED = ({
  value: e,
  defaultValue: t,
  onValueChange: n,
  applyButtonLabel: r,
  todayButtonLabel: a,
  max: s,
  min: o,
  maxRangeLabel: i,
  maxRange: c,
  menuOptions: u,
  menuLabel: f,
  fieldLayout: m = "hstack",
  startInputProps: b,
  endInputProps: _,
  menuVariant: j = gt.Picker,
  isDisabled: p,
  onApplyClick: v,
  onTodayClick: h,
  onMenuClick: g,
  ...w
}) => {
  const [x, y] = l.useState([]), [E, C] = l.useState([
    void 0,
    void 0
  ]);
  l.useEffect(() => {
    e && (y(e), C(e));
  }, [e, y, C]), l.useEffect(() => {
    t && (e && t || (y(t), C(t)));
  }, [t, e, y, C]);
  const [S, k] = l.useState(), O = l.useRef(null), L = l.useRef(null);
  l.useEffect(() => {
    document.addEventListener("click", (D) => {
      var F, P;
      !!((F = O.current) != null && F.contains(D.target) || (P = L.current) != null && P.contains(D.target)) || k(void 0);
    });
  }, []);
  const H = l.useCallback(
    (D) => {
      y(D), n == null || n(D);
    },
    [y, n]
  ), T = l.useCallback(() => {
    C(x), n == null || n(x), k(void 0), v == null || v(x);
  }, [x, C, k, n]), R = l.useCallback(
    (D) => {
      C(D), n == null || n(D), k(void 0), h == null || h(D);
    },
    [x, C, k, n]
  ), M = l.useCallback(
    (D) => {
      j !== gt.Picker && (C(D), n == null || n(D), k(void 0), g == null || g(D));
    },
    [j, C, n, k, g]
  );
  return /* @__PURE__ */ l.createElement(Fe.Root, { isOpen: !!S }, /* @__PURE__ */ l.createElement(Fe.Trigger, { asChild: !0, ref: O }, /* @__PURE__ */ l.createElement(re, null, /* @__PURE__ */ l.createElement(
    Hl,
    {
      fieldLayout: m,
      isDisabled: p,
      value: E,
      defaultValue: t,
      onValueChange: H,
      startInputProps: {
        endAdornment: /* @__PURE__ */ l.createElement(
          Me,
          {
            "aria-label": "open calendar",
            isDisabled: p,
            onClick: () => k({
              direction: "start",
              variant: $t.Range
            })
          },
          /* @__PURE__ */ l.createElement(na, null)
        ),
        ...b
      },
      endInputProps: {
        endAdornment: /* @__PURE__ */ l.createElement(
          Me,
          {
            "aria-label": "open calendar",
            isDisabled: p,
            onClick: () => k({
              direction: "end",
              variant: $t.Range
            })
          },
          /* @__PURE__ */ l.createElement(na, null)
        ),
        ..._
      },
      min: o,
      max: s,
      maxRange: c,
      ...w
    }
  ))), /* @__PURE__ */ l.createElement(Fe.Content, { ref: L }, S && /* @__PURE__ */ l.createElement(
    f_,
    {
      value: x,
      onValueChange: y,
      min: o,
      max: s,
      direction: "start",
      menuLabel: f,
      maxRangeLabel: i,
      maxRange: c,
      menuOptions: u,
      rangeMenuConfig: {
        mode: Rn.Date,
        variant: j
      },
      todayButtonLabel: a,
      applyButtonLabel: r,
      onApplyClick: T,
      onTodayClick: R,
      onMenuClick: M
    }
  )));
}, xD = ({
  value: e,
  timeFormat: t,
  defaultValue: n,
  onValueChange: r,
  applyButtonLabel: a,
  todayButtonLabel: s,
  max: o,
  min: i,
  maxRangeLabel: c,
  maxRange: u,
  menuOptions: f,
  menuLabel: m,
  fieldLayout: b = "hstack",
  startInputProps: _,
  endInputProps: j,
  menuVariant: p = gt.Picker,
  isDisabled: v,
  onApplyClick: h,
  onTodayClick: g,
  onMenuClick: w,
  ...x
}) => {
  const [y, E] = l.useState([]), [C, S] = l.useState([
    void 0,
    void 0
  ]);
  l.useEffect(() => {
    e && (E(e), S(e));
  }, [e, E, S]), l.useEffect(() => {
    n && (E(n), S(n));
  }, [n, E, S]);
  const [k, O] = l.useState(), L = l.useRef(null), H = l.useRef(null);
  l.useEffect(() => {
    document.addEventListener("click", (P) => {
      var $, B;
      !!(($ = L.current) != null && $.contains(P.target) || (B = H.current) != null && B.contains(P.target)) || O(void 0);
    });
  }, [O]);
  const T = _e(
    (P) => P && zt(P) ? Q(P).toISOString() : P,
    []
  ), R = l.useCallback(
    (P) => {
      E(P), r == null || r(P);
    },
    [E, r]
  ), M = l.useCallback(
    (P) => {
      var B;
      if (!k) return;
      const A = (B = P == null ? void 0 : P.target) == null ? void 0 : B.id, $ = {
        direction: "start",
        variant: $t.Range
      };
      A != null && A.includes("end") && ($.direction = "end"), A != null && A.includes("time") && ($.variant = $t.DateTime), O($);
    },
    [k, O]
  ), D = l.useCallback(() => {
    const P = y.map((A) => T(A));
    S(P), r == null || r(P), O(void 0), h == null || h(P);
  }, [y, r, h, T]), I = l.useCallback(
    (P) => {
      if (p !== gt.Picker) {
        const A = P.map(
          ($) => T($)
        );
        S(A), r == null || r(A), O(void 0), w == null || w(A);
      }
    },
    [
      p,
      T,
      S,
      r,
      O,
      w
    ]
  ), F = l.useCallback(
    (P) => {
      const A = P.map(
        ($) => T($)
      );
      S(A), r == null || r(A), O(void 0), g == null || g(A);
    },
    [r, g, T]
  );
  return /* @__PURE__ */ l.createElement(Fe.Root, { isOpen: !!k }, /* @__PURE__ */ l.createElement(Fe.Trigger, { asChild: !0, ref: L }, /* @__PURE__ */ l.createElement(re, null, /* @__PURE__ */ l.createElement(
    Bl,
    {
      fieldLayout: b,
      value: C,
      defaultValue: n,
      onValueChange: R,
      isDisabled: v,
      startInputProps: {
        dateFieldProps: {
          onFocus: M,
          endAdornment: /* @__PURE__ */ l.createElement(
            Me,
            {
              "aria-label": "open calendar",
              isDisabled: v,
              onClick: () => O({
                direction: "start",
                variant: $t.Range
              })
            },
            /* @__PURE__ */ l.createElement(na, null)
          )
        },
        timeFieldProps: {
          format: t,
          onFocus: M,
          endAdornment: /* @__PURE__ */ l.createElement(
            Me,
            {
              key: "start-time",
              "aria-label": "open datetime picker",
              isDisabled: v,
              onClick: () => O({
                direction: "start",
                variant: $t.DateTime
              })
            },
            /* @__PURE__ */ l.createElement(Hi, null)
          )
        },
        ..._
      },
      endInputProps: {
        dateFieldProps: {
          onFocus: M,
          endAdornment: /* @__PURE__ */ l.createElement(
            Me,
            {
              "aria-label": "open calendar",
              isDisabled: v,
              onClick: () => O({
                direction: "end",
                variant: $t.Range
              })
            },
            /* @__PURE__ */ l.createElement(na, null)
          )
        },
        timeFieldProps: {
          format: t,
          onFocus: M,
          endAdornment: /* @__PURE__ */ l.createElement(
            Me,
            {
              key: "end-time",
              "aria-label": "open datetime picker",
              isDisabled: v,
              onClick: () => O({
                direction: "end",
                variant: $t.DateTime
              })
            },
            /* @__PURE__ */ l.createElement(Hi, null)
          )
        },
        ...j
      },
      min: i,
      max: o,
      maxRange: u,
      ...x
    }
  ))), /* @__PURE__ */ l.createElement(Fe.Content, { ref: H }, k && /* @__PURE__ */ l.createElement(
    f_,
    {
      value: y,
      onValueChange: E,
      direction: k.direction,
      min: i,
      max: o,
      maxRangeLabel: c,
      maxRange: u,
      menuLabel: m,
      menuOptions: f,
      rangeMenuConfig: {
        mode: Rn.DateTime,
        variant: p,
        pickerVariant: k.variant,
        timeFormat: t
      },
      todayButtonLabel: s,
      applyButtonLabel: a,
      onApplyClick: D,
      onTodayClick: F,
      onMenuClick: I
    }
  )));
}, YR = l.forwardRef(
  function(t, n) {
    const { className: r, container: a, ...s } = t;
    return ja.createPortal(
      /* @__PURE__ */ l.createElement(U.div, { ref: n, className: r, ...s }),
      a ?? document.body,
      t.key
    );
  }
);
YR.displayName = "Portal";
function Ft(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented) return t == null ? void 0 : t(a);
  };
}
function GR(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function b_(...e) {
  return (t) => e.forEach(
    (n) => GR(n, t)
  );
}
function gr(...e) {
  return _e(b_(...e), e);
}
function Io(e, t = []) {
  let n = [];
  function r(s, o) {
    const i = /* @__PURE__ */ Cs(o), c = n.length;
    n = [
      ...n,
      o
    ];
    function u(m) {
      const { scope: b, children: _, ...j } = m, p = (b == null ? void 0 : b[e][c]) || i, v = Le(
        () => j,
        Object.values(j)
      );
      return /* @__PURE__ */ ze(p.Provider, {
        value: v
      }, _);
    }
    function f(m, b) {
      const _ = (b == null ? void 0 : b[e][c]) || i, j = Nf(_);
      if (j) return j;
      if (o !== void 0) return o;
      throw new Error(`\`${m}\` must be used within \`${s}\``);
    }
    return u.displayName = s + "Provider", [
      u,
      f
    ];
  }
  const a = () => {
    const s = n.map((o) => /* @__PURE__ */ Cs(o));
    return function(i) {
      const c = (i == null ? void 0 : i[e]) || s;
      return Le(
        () => ({
          [`__scope${e}`]: {
            ...i,
            [e]: c
          }
        }),
        [
          i,
          c
        ]
      );
    };
  };
  return a.scopeName = e, [
    r,
    KR(a, ...t)
  ];
}
function KR(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(s) {
      const o = r.reduce((i, { useScope: c, scopeName: u }) => {
        const m = c(s)[`__scope${u}`];
        return {
          ...i,
          ...m
        };
      }, {});
      return Le(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const to = /* @__PURE__ */ jt((e, t) => {
  const { children: n, ...r } = e, a = rr.toArray(n), s = a.find(ZR);
  if (s) {
    const o = s.props.children, i = a.map((c) => c === s ? rr.count(o) > 1 ? rr.only(null) : /* @__PURE__ */ Es(o) ? o.props.children : null : c);
    return /* @__PURE__ */ ze(ql, we({}, r, {
      ref: t
    }), /* @__PURE__ */ Es(o) ? /* @__PURE__ */ Yl(o, void 0, i) : null);
  }
  return /* @__PURE__ */ ze(ql, we({}, r, {
    ref: t
  }), n);
});
to.displayName = "Slot";
const ql = /* @__PURE__ */ jt((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Es(n) ? /* @__PURE__ */ Yl(n, {
    ...JR(r, n.props),
    ref: t ? b_(t, n.ref) : n.ref
  }) : rr.count(n) > 1 ? rr.only(null) : null;
});
ql.displayName = "SlotClone";
const XR = ({ children: e }) => /* @__PURE__ */ ze(Z_, null, e);
function ZR(e) {
  return /* @__PURE__ */ Es(e) && e.type === XR;
}
function JR(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? a && s ? n[r] = (...i) => {
      s(...i), a(...i);
    } : a && (n[r] = a) : r === "style" ? n[r] = {
      ...a,
      ...s
    } : r === "className" && (n[r] = [
      a,
      s
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const QR = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Da = QR.reduce((e, t) => {
  const n = /* @__PURE__ */ jt((r, a) => {
    const { asChild: s, ...o } = r, i = s ? to : t;
    return le(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ ze(i, we({}, o, {
      ref: a
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function eO(e) {
  const t = e + "CollectionProvider", [n, r] = Io(t), [a, s] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), o = (_) => {
    const { scope: j, children: p } = _, v = l.useRef(null), h = l.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l.createElement(a, {
      scope: j,
      itemMap: h,
      collectionRef: v
    }, p);
  }, i = e + "CollectionSlot", c = /* @__PURE__ */ l.forwardRef((_, j) => {
    const { scope: p, children: v } = _, h = s(i, p), g = gr(j, h.collectionRef);
    return /* @__PURE__ */ l.createElement(to, {
      ref: g
    }, v);
  }), u = e + "CollectionItemSlot", f = "data-radix-collection-item", m = /* @__PURE__ */ l.forwardRef((_, j) => {
    const { scope: p, children: v, ...h } = _, g = l.useRef(null), w = gr(j, g), x = s(u, p);
    return l.useEffect(() => (x.itemMap.set(g, {
      ref: g,
      ...h
    }), () => void x.itemMap.delete(g))), /* @__PURE__ */ l.createElement(to, {
      [f]: "",
      ref: w
    }, v);
  });
  function b(_) {
    const j = s(e + "CollectionConsumer", _);
    return l.useCallback(() => {
      const v = j.collectionRef.current;
      if (!v) return [];
      const h = Array.from(v.querySelectorAll(`[${f}]`));
      return Array.from(j.itemMap.values()).sort(
        (x, y) => h.indexOf(x.ref.current) - h.indexOf(y.ref.current)
      );
    }, [
      j.collectionRef,
      j.itemMap
    ]);
  }
  return [
    {
      Provider: o,
      Slot: c,
      ItemSlot: m
    },
    b,
    r
  ];
}
const no = globalThis != null && globalThis.document ? Pf : () => {
}, tO = d.useId || (() => {
});
let nO = 0;
function rO(e) {
  const [t, n] = d.useState(tO());
  return no(() => {
    n(
      (r) => r ?? String(nO++)
    );
  }, [
    e
  ]), t ? `radix-${t}` : "";
}
function ku(e) {
  const t = Te(e);
  return le(() => {
    t.current = e;
  }), Le(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function m_({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, a] = aO({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, o = s ? e : r, i = ku(n), c = _e((u) => {
    if (s) {
      const m = typeof u == "function" ? u(e) : u;
      m !== e && i(m);
    } else a(u);
  }, [
    s,
    e,
    a,
    i
  ]);
  return [
    o,
    c
  ];
}
function aO({ defaultProp: e, onChange: t }) {
  const n = de(e), [r] = n, a = Te(r), s = ku(t);
  return le(() => {
    a.current !== r && (s(r), a.current = r);
  }, [
    r,
    a,
    s
  ]), n;
}
const sO = /* @__PURE__ */ Cs(void 0);
function __(e) {
  const t = Nf(sO);
  return e || t || "ltr";
}
const Di = "rovingFocusGroup.onEntryFocus", oO = {
  bubbles: !1,
  cancelable: !0
}, Tu = "RovingFocusGroup", [Ul, p_, iO] = eO(Tu), [lO, j_] = Io(Tu, [
  iO
]), [cO, uO] = lO(Tu), dO = /* @__PURE__ */ jt((e, t) => /* @__PURE__ */ ze(Ul.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ ze(Ul.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ ze(fO, we({}, e, {
  ref: t
}))))), fO = /* @__PURE__ */ jt((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: a = !1, dir: s, currentTabStopId: o, defaultCurrentTabStopId: i, onCurrentTabStopIdChange: c, onEntryFocus: u, ...f } = e, m = Te(null), b = gr(t, m), _ = __(s), [j = null, p] = m_({
    prop: o,
    defaultProp: i,
    onChange: c
  }), [v, h] = de(!1), g = ku(u), w = p_(n), x = Te(!1), [y, E] = de(0);
  return le(() => {
    const C = m.current;
    if (C)
      return C.addEventListener(Di, g), () => C.removeEventListener(Di, g);
  }, [
    g
  ]), /* @__PURE__ */ ze(cO, {
    scope: n,
    orientation: r,
    dir: _,
    loop: a,
    currentTabStopId: j,
    onItemFocus: _e(
      (C) => p(C),
      [
        p
      ]
    ),
    onItemShiftTab: _e(
      () => h(!0),
      []
    ),
    onFocusableItemAdd: _e(
      () => E(
        (C) => C + 1
      ),
      []
    ),
    onFocusableItemRemove: _e(
      () => E(
        (C) => C - 1
      ),
      []
    )
  }, /* @__PURE__ */ ze(Da.div, we({
    tabIndex: v || y === 0 ? -1 : 0,
    "data-orientation": r
  }, f, {
    ref: b,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: Ft(e.onMouseDown, () => {
      x.current = !0;
    }),
    onFocus: Ft(e.onFocus, (C) => {
      const S = !x.current;
      if (C.target === C.currentTarget && S && !v) {
        const k = new CustomEvent(Di, oO);
        if (C.currentTarget.dispatchEvent(k), !k.defaultPrevented) {
          const O = w().filter(
            (M) => M.focusable
          ), L = O.find(
            (M) => M.active
          ), H = O.find(
            (M) => M.id === j
          ), R = [
            L,
            H,
            ...O
          ].filter(Boolean).map(
            (M) => M.ref.current
          );
          v_(R);
        }
      }
      x.current = !1;
    }),
    onBlur: Ft(
      e.onBlur,
      () => h(!1)
    )
  })));
}), bO = "RovingFocusGroupItem", mO = /* @__PURE__ */ jt((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: a = !1, tabStopId: s, ...o } = e, i = rO(), c = s || i, u = uO(bO, n), f = u.currentTabStopId === c, m = p_(n), { onFocusableItemAdd: b, onFocusableItemRemove: _ } = u;
  return le(() => {
    if (r)
      return b(), () => _();
  }, [
    r,
    b,
    _
  ]), /* @__PURE__ */ ze(Ul.ItemSlot, {
    scope: n,
    id: c,
    focusable: r,
    active: a
  }, /* @__PURE__ */ ze(Da.span, we({
    tabIndex: f ? 0 : -1,
    "data-orientation": u.orientation
  }, o, {
    ref: t,
    onMouseDown: Ft(e.onMouseDown, (j) => {
      r ? u.onItemFocus(c) : j.preventDefault();
    }),
    onFocus: Ft(
      e.onFocus,
      () => u.onItemFocus(c)
    ),
    onKeyDown: Ft(e.onKeyDown, (j) => {
      if (j.key === "Tab" && j.shiftKey) {
        u.onItemShiftTab();
        return;
      }
      if (j.target !== j.currentTarget) return;
      const p = jO(j, u.orientation, u.dir);
      if (p !== void 0) {
        j.preventDefault();
        let h = m().filter(
          (g) => g.focusable
        ).map(
          (g) => g.ref.current
        );
        if (p === "last") h.reverse();
        else if (p === "prev" || p === "next") {
          p === "prev" && h.reverse();
          const g = h.indexOf(j.currentTarget);
          h = u.loop ? vO(h, g + 1) : h.slice(g + 1);
        }
        setTimeout(
          () => v_(h)
        );
      }
    })
  })));
}), _O = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function pO(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function jO(e, t, n) {
  const r = pO(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return _O[r];
}
function v_(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function vO(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const hO = dO, gO = mO;
function yO(e) {
  const [t, n] = de(void 0);
  return no(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length) return;
        const s = a[0];
        let o, i;
        if ("borderBoxSize" in s) {
          const c = s.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          o = u.inlineSize, i = u.blockSize;
        } else
          o = e.offsetWidth, i = e.offsetHeight;
        n({
          width: o,
          height: i
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
function wO(e) {
  const t = Te({
    value: e,
    previous: e
  });
  return Le(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
function CO(e, t) {
  return J_((n, r) => {
    const a = t[n][r];
    return a ?? n;
  }, e);
}
const h_ = (e) => {
  const { present: t, children: n } = e, r = EO(t), a = typeof n == "function" ? n({
    present: r.isPresent
  }) : rr.only(n), s = gr(r.ref, a.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Yl(a, {
    ref: s
  }) : null;
};
h_.displayName = "Presence";
function EO(e) {
  const [t, n] = de(), r = Te({}), a = Te(e), s = Te("none"), o = e ? "mounted" : "unmounted", [i, c] = CO(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return le(() => {
    const u = ps(r.current);
    s.current = i === "mounted" ? u : "none";
  }, [
    i
  ]), no(() => {
    const u = r.current, f = a.current;
    if (f !== e) {
      const b = s.current, _ = ps(u);
      e ? c("MOUNT") : _ === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(f && b !== _ ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    c
  ]), no(() => {
    if (t) {
      const u = (m) => {
        const _ = ps(r.current).includes(m.animationName);
        m.target === t && _ && xs(
          () => c("ANIMATION_END")
        );
      }, f = (m) => {
        m.target === t && (s.current = ps(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(i),
    ref: _e((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function ps(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const g_ = "Radio", [xO, y_] = Io(g_), [SO, kO] = xO(g_), TO = /* @__PURE__ */ jt((e, t) => {
  const { __scopeRadio: n, name: r, checked: a = !1, required: s, disabled: o, value: i = "on", onCheck: c, ...u } = e, [f, m] = de(null), b = gr(
    t,
    (p) => m(p)
  ), _ = Te(!1), j = f ? !!f.closest("form") : !0;
  return /* @__PURE__ */ ze(SO, {
    scope: n,
    checked: a,
    disabled: o
  }, /* @__PURE__ */ ze(Da.button, we({
    type: "button",
    role: "radio",
    "aria-checked": a,
    "data-state": w_(a),
    "data-disabled": o ? "" : void 0,
    disabled: o,
    value: i
  }, u, {
    ref: b,
    onClick: Ft(e.onClick, (p) => {
      a || c == null || c(), j && (_.current = p.isPropagationStopped(), _.current || p.stopPropagation());
    })
  })), j && /* @__PURE__ */ ze(MO, {
    control: f,
    bubbles: !_.current,
    name: r,
    value: i,
    checked: a,
    required: s,
    disabled: o,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), RO = "RadioIndicator", OO = /* @__PURE__ */ jt((e, t) => {
  const { __scopeRadio: n, forceMount: r, ...a } = e, s = kO(RO, n);
  return /* @__PURE__ */ ze(h_, {
    present: r || s.checked
  }, /* @__PURE__ */ ze(Da.span, we({
    "data-state": w_(s.checked),
    "data-disabled": s.disabled ? "" : void 0
  }, a, {
    ref: t
  })));
}), MO = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...a } = e, s = Te(null), o = wO(n), i = yO(t);
  return le(() => {
    const c = s.current, u = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (o !== n && m) {
      const b = new Event("click", {
        bubbles: r
      });
      m.call(c, n), c.dispatchEvent(b);
    }
  }, [
    o,
    n,
    r
  ]), /* @__PURE__ */ ze("input", we({
    type: "radio",
    "aria-hidden": !0,
    defaultChecked: n
  }, a, {
    tabIndex: -1,
    ref: s,
    style: {
      ...e.style,
      ...i,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function w_(e) {
  return e ? "checked" : "unchecked";
}
const AO = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], C_ = "RadioGroup", [PO, SD] = Io(C_, [
  j_,
  y_
]), E_ = j_(), x_ = y_(), [NO, DO] = PO(C_), IO = /* @__PURE__ */ jt((e, t) => {
  const { __scopeRadioGroup: n, name: r, defaultValue: a, value: s, required: o = !1, disabled: i = !1, orientation: c, dir: u, loop: f = !0, onValueChange: m, ...b } = e, _ = E_(n), j = __(u), [p, v] = m_({
    prop: s,
    defaultProp: a,
    onChange: m
  });
  return /* @__PURE__ */ ze(NO, {
    scope: n,
    name: r,
    required: o,
    disabled: i,
    value: p,
    onValueChange: v
  }, /* @__PURE__ */ ze(hO, we({
    asChild: !0
  }, _, {
    orientation: c,
    dir: j,
    loop: f
  }), /* @__PURE__ */ ze(Da.div, we({
    role: "radiogroup",
    "aria-required": o,
    "aria-orientation": c,
    "data-disabled": i ? "" : void 0,
    dir: j
  }, b, {
    ref: t
  }))));
}), $O = "RadioGroupItem", LO = /* @__PURE__ */ jt((e, t) => {
  const { __scopeRadioGroup: n, disabled: r, ...a } = e, s = DO($O, n), o = s.disabled || r, i = E_(n), c = x_(n), u = Te(null), f = gr(t, u), m = s.value === a.value, b = Te(!1);
  return le(() => {
    const _ = (p) => {
      AO.includes(p.key) && (b.current = !0);
    }, j = () => b.current = !1;
    return document.addEventListener("keydown", _), document.addEventListener("keyup", j), () => {
      document.removeEventListener("keydown", _), document.removeEventListener("keyup", j);
    };
  }, []), /* @__PURE__ */ ze(gO, we({
    asChild: !0
  }, i, {
    focusable: !o,
    active: m
  }), /* @__PURE__ */ ze(TO, we({
    disabled: o,
    required: s.required,
    checked: m
  }, c, a, {
    name: s.name,
    ref: f,
    onCheck: () => s.onValueChange(a.value),
    onKeyDown: Ft((_) => {
      _.key === "Enter" && _.preventDefault();
    }),
    onFocus: Ft(a.onFocus, () => {
      var _;
      b.current && ((_ = u.current) === null || _ === void 0 || _.click());
    })
  })));
}), zO = /* @__PURE__ */ jt((e, t) => {
  const { __scopeRadioGroup: n, ...r } = e, a = x_(n);
  return /* @__PURE__ */ ze(OO, we({}, a, r, {
    ref: t
  }));
}), FO = IO, HO = LO, BO = zO;
var qO = "_1rxtjcr1 _1rxtjcr0 _1s8b37j1mv _1s8b37j1ip _1s8b37j29d", UO = "_1rxtjcr2", WO = "_1rxtjcr4 _1rxtjcr3 _1s8b37jll", VO = "_1rxtjcr5 _1s8b37j27u _1s8b37j23o _1s8b37j252 _1s8b37j26g _1s8b37jk8 _1s8b37jkc _1s8b37jkg _1s8b37jkk _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37j12b _1s8b37j2p7 _1s8b37j80 _1s8b37jl3 _1s8b37jl5", YO = "_1rxtjcr7 _1rxtjcr6 _1s8b37jcg _1s8b37jat _1s8b37jau _1s8b37j2", GO = "_1rxtjcr9 _1rxtjcr8 _1s8b37jb4 _1s8b37j5", KO = "_1rxtjcrb _1rxtjcra _1s8b37jbg _1s8b37j8", XO = "_1rxtjcrd _1rxtjcrc _1s8b37jbs _1s8b37jb", ZO = "_1rxtjcrf _1rxtjcre _1s8b37jvn _1s8b37jmh _1s8b37j199 _1s8b37j2vq _1s8b37j18u _1s8b37j29d", JO = "_1rxtjcrg", QO = "_1rxtjcrh", eM = "_1rxtjcri";
const tM = l.forwardRef(
  ({ children: e, className: t, defaultValue: n, value: r, onValueChange: a, name: s, ...o }, i) => {
    const c = ut();
    return /* @__PURE__ */ l.createElement(
      FO,
      {
        asChild: !0,
        defaultValue: n,
        name: s,
        value: r,
        onValueChange: a
      },
      /* @__PURE__ */ l.createElement(
        ye,
        {
          ...o,
          className: q(t, qO),
          "aria-labelledby": c.labelId || o["aria-labelledby"],
          "aria-describedby": c.infoId || o["aria-describedby"],
          ref: i
        },
        e
      )
    );
  }
), S_ = l.createContext({
  isDisabled: !1,
  id: ""
}), nM = () => l.useContext(S_), rM = l.forwardRef(
  ({ children: e, className: t, value: n, isDisabled: r, required: a, ...s }, o) => {
    const i = ut(), c = kt("rtk-radio-item");
    return /* @__PURE__ */ l.createElement(S_.Provider, { value: { isDisabled: r, id: c } }, /* @__PURE__ */ l.createElement(
      re,
      {
        gap: "small",
        className: q(UO, {
          [WO]: r
        })
      },
      /* @__PURE__ */ l.createElement(
        HO,
        {
          asChild: !0,
          value: n,
          disabled: r,
          required: a,
          id: c
        },
        /* @__PURE__ */ l.createElement(
          U.button,
          {
            ...s,
            className: q(t, VO, {
              [YO]: (i == null ? void 0 : i.appearance) == null || i.appearance === "neutral",
              [GO]: (i == null ? void 0 : i.appearance) === "danger",
              [KO]: (i == null ? void 0 : i.appearance) === "warning",
              [XO]: (i == null ? void 0 : i.appearance) === "success"
            }),
            ref: o
          },
          /* @__PURE__ */ l.createElement(
            BO,
            {
              className: q(ZO, {
                [JO]: r
              })
            }
          )
        )
      ),
      e
    ));
  }
), aM = l.forwardRef(({ children: e, className: t, ...n }, r) => {
  const a = nM();
  return /* @__PURE__ */ l.createElement(ne, { asChild: !0, styledAs: "body3" }, /* @__PURE__ */ l.createElement(
    U.label,
    {
      ...n,
      ref: r,
      htmlFor: a.id,
      className: q(t, QO, {
        [eM]: a.isDisabled
      })
    },
    e
  ));
}), kD = {
  Root: tM,
  Item: rM,
  ItemText: aM
}, sM = {
  dependencies: [zf],
  export: (e) => qp(e) ? "***" : null,
  regExp: /^(---|\*\*\*|___)\s?$/,
  replace: (e, t, n, r) => {
    const a = Up();
    r || e.getNextSibling() != null ? e.replace(a) : e.insertBefore(a), a.selectNext();
  },
  type: "element"
}, k_ = /^(?:\|)(.+)(?:\|)\s?$/, oM = /^(\| ?:?-*:? ?)+\|\s?$/, iM = {
  dependencies: [Zl, $f, Jl],
  export: (e) => {
    if (!Kr(e))
      return null;
    const t = [];
    for (const n of e.getChildren()) {
      const r = [];
      if (!dr(n))
        continue;
      let a = !1;
      for (const s of n.getChildren())
        vt(s) && (r.push(
          Kl(Gl, s).replace(/\n/g, "\\n")
        ), s.__headerState === bt.ROW && (a = !0));
      t.push(`| ${r.join(" | ")} |`), a && t.push(`| ${r.map(() => "---").join(" | ")} |`);
    }
    return t.join(`
`);
  },
  regExp: k_,
  replace: (e, t, n) => {
    if (oM.test(n[0])) {
      const u = e.getPreviousSibling();
      if (!u || !Kr(u))
        return;
      const f = u.getChildren(), m = f[f.length - 1];
      if (!m || !dr(m))
        return;
      m.getChildren().forEach((b) => {
        vt(b) && b.setHeaderStyles(
          bt.ROW,
          bt.ROW
        );
      }), e.remove();
      return;
    }
    const r = bf(n[0]);
    if (r == null)
      return;
    const a = [r];
    let s = e.getPreviousSibling(), o = r.length;
    for (; s && !(!ec(s) || s.getChildrenSize() !== 1); ) {
      const u = s.getFirstChild();
      if (!Ff(u))
        break;
      const f = bf(u.getTextContent());
      if (f == null)
        break;
      o = Math.max(o, f.length), a.unshift(f);
      const m = s.getPreviousSibling();
      s.remove(), s = m;
    }
    const i = bp();
    for (const u of a) {
      const f = mp();
      i.append(f);
      for (let m = 0; m < o; m++)
        f.append(m < u.length ? u[m] : T_(""));
    }
    const c = e.getPreviousSibling();
    Kr(c) && lM(c) === o ? (c.append(...i.getChildren()), e.remove()) : e.replace(i), i.selectEnd();
  },
  type: "element"
};
function lM(e) {
  const t = e.getFirstChild();
  return dr(t) ? t.getChildrenSize() : 0;
}
const T_ = (e) => {
  e = e.replace(/\\n/g, `
`);
  const t = _p(bt.NO_STATUS);
  return Xl(e, Gl, t), t;
}, bf = (e) => {
  const t = e.match(k_);
  return !t || !t[1] ? null : t[1].split("|").map((n) => T_(n));
}, pa = [
  iM,
  sM,
  lp,
  ...cp,
  ...up,
  ...dp,
  ...fp,
  ...Gl
], cM = ({
  onChange: e,
  onBlur: t,
  isDisabled: n,
  formatAs: r
}) => {
  const [a] = Ze(), s = d.useCallback(() => {
    const i = ea();
    return r === "editorState" ? JSON.stringify(a.getEditorState().toJSON()) : r === "markdown" ? Kl(pa) : r === "html" ? ej(a, null) : i.getTextContent();
  }, [a, r]), o = d.useCallback(
    (i) => {
      i.read(() => {
        const c = s();
        e == null || e(c);
      });
    },
    [e, s]
  );
  return d.useEffect(() => {
    a.registerCommand(
      Wp,
      () => {
        const i = s();
        return t == null || t(i), !1;
      },
      ta
    );
  }, [a, t, s]), d.useEffect(() => {
    a.setEditable(!n);
  }, [a, n]), /* @__PURE__ */ d.createElement(tj, { onChange: o });
};
let Wl = !1;
const uM = [
  "#d0021b",
  "#f5a623",
  "#f8e71c",
  "#8b572a",
  "#7ed321",
  "#417505",
  "#bd10e0",
  "#9013fe",
  "#4a90e2",
  "#50e3c2",
  "#b8e986",
  "#000000",
  "#4a4a4a",
  "#9b9b9b",
  "#ffffff"
], Wr = 214, mf = 150;
function dM({
  color: e,
  onChange: t
}) {
  const [n, r] = de(Zn("hex", e)), [a, s] = de(e), o = Te(null), i = Le(
    () => ({
      x: n.hsv.s / 100 * Wr,
      y: (100 - n.hsv.v) / 100 * mf
    }),
    [n.hsv.s, n.hsv.v]
  ), c = Le(
    () => ({
      x: n.hsv.h / 360 * Wr
    }),
    [n.hsv]
  ), u = (b) => {
    if (s(b), /^#[0-9A-Fa-f]{6}$/i.test(b)) {
      const _ = Zn("hex", b);
      r(_);
    }
  }, f = ({ x: b, y: _ }) => {
    const j = {
      ...n.hsv,
      s: b / Wr * 100,
      v: 100 - _ / mf * 100
    }, p = Zn("hsv", j);
    r(p), s(p.hex);
  }, m = ({ x: b }) => {
    const _ = { ...n.hsv, h: b / Wr * 360 }, j = Zn("hsv", _);
    r(j), s(j.hex);
  };
  return le(() => {
    o.current !== null && t && (t(n.hex, Wl), s(n.hex));
  }, [n, t]), le(() => {
    if (e === void 0)
      return;
    const b = Zn("hex", e);
    r(b), s(b.hex);
  }, [e]), /* @__PURE__ */ d.createElement(
    ye,
    {
      className: "color-picker-wrapper",
      style: { width: Wr },
      ref: o,
      gap: "small"
    },
    /* @__PURE__ */ d.createElement(
      pr,
      {
        id: "hex",
        onChange: (b) => u(b.target.value),
        value: a
      }
    ),
    /* @__PURE__ */ d.createElement("div", { className: "color-picker-basic-color" }, uM.map((b) => /* @__PURE__ */ d.createElement(
      "button",
      {
        className: b === n.hex ? " active" : "",
        key: b,
        style: { backgroundColor: b },
        onClick: () => {
          s(b), r(Zn("hex", b));
        }
      }
    ))),
    /* @__PURE__ */ d.createElement(
      _f,
      {
        className: "color-picker-saturation",
        style: { backgroundColor: `hsl(${n.hsv.h}, 100%, 50%)` },
        onChange: f
      },
      /* @__PURE__ */ d.createElement(
        "div",
        {
          className: "color-picker-saturation_cursor",
          style: {
            backgroundColor: n.hex,
            left: i.x,
            top: i.y
          }
        }
      )
    ),
    /* @__PURE__ */ d.createElement(_f, { className: "color-picker-hue", onChange: m }, /* @__PURE__ */ d.createElement(
      "div",
      {
        className: "color-picker-hue_cursor",
        style: {
          backgroundColor: `hsl(${n.hsv.h}, 100%, 50%)`,
          left: c.x
        }
      }
    )),
    /* @__PURE__ */ d.createElement(
      "div",
      {
        className: "color-picker-color",
        style: { backgroundColor: n.hex }
      }
    )
  );
}
function _f({ className: e, style: t, onChange: n, children: r }) {
  const a = Te(null), s = Te(!1), o = (c) => {
    if (a.current) {
      const { current: u } = a, { width: f, height: m, left: b, top: _ } = u.getBoundingClientRect(), j = zi(u), p = pf(c.clientX / j - b, f, 0), v = pf(c.clientY / j - _, m, 0);
      n({ x: p, y: v });
    }
  }, i = (c) => {
    if (c.button !== 0)
      return;
    o(c);
    const u = (m) => {
      s.current = !0, Wl = !0, o(m);
    }, f = (m) => {
      s.current && (Wl = !1), document.removeEventListener("mousemove", u, !1), document.removeEventListener("mouseup", f, !1), o(m), s.current = !1;
    };
    document.addEventListener("mousemove", u, !1), document.addEventListener("mouseup", f, !1);
  };
  return /* @__PURE__ */ d.createElement(
    "div",
    {
      ref: a,
      className: e,
      style: t,
      onMouseDown: i
    },
    r
  );
}
function pf(e, t, n) {
  return e > t ? t : e < n ? n : e;
}
function jf(e) {
  if (e.startsWith("#")) {
    if (e.length === 4 || e.length === 5)
      return e = e.split("").map((t, n) => n ? t + t : "#").join(""), e;
    if (e.length === 7 || e.length === 9)
      return e;
  } else {
    const t = document.createElement("canvas").getContext("2d");
    if (!t)
      throw new Error("2d context not supported or canvas already initialized");
    return t.fillStyle = e, t.fillStyle;
  }
  return "#000000";
}
function vf(e) {
  const t = (e.replace(
    /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    (n, r, a, s) => "#" + r + r + a + a + s + s
  ).substring(1).match(/.{2}/g) || []).map((n) => parseInt(n, 16));
  return {
    b: t[2],
    g: t[1],
    r: t[0]
  };
}
function Ii({ r: e, g: t, b: n }) {
  e /= 255, t /= 255, n /= 255;
  const r = Math.max(e, t, n), a = r - Math.min(e, t, n), s = a ? (r === e ? (t - n) / a + (t < n ? 6 : 0) : r === t ? 2 + (n - e) / a : 4 + (e - t) / a) * 60 : 0, o = r ? a / r * 100 : 0, i = r * 100;
  return { h: s, s: o, v: i };
}
function fM({ h: e, s: t, v: n }) {
  t /= 100, n /= 100;
  const r = ~~(e / 60), a = e / 60 - r, s = n * (1 - t), o = n * (1 - t * a), i = n * (1 - t * (1 - a)), c = r % 6, u = Math.round([n, o, s, s, i, n][c] * 255), f = Math.round([i, n, n, o, s, s][c] * 255);
  return { b: Math.round([s, s, i, n, n, o][c] * 255), g: f, r: u };
}
function hf({ b: e, g: t, r: n }) {
  return "#" + [n, t, e].map((r) => r.toString(16).padStart(2, "0")).join("");
}
function Zn(e, t) {
  let n = jf("#121212"), r = vf(n), a = Ii(r);
  return e === "hex" ? (n = jf(t), r = vf(n), a = Ii(r)) : e === "rgb" ? (r = t, n = hf(r), a = Ii(r)) : e === "hsv" && (a = t, r = fM(a), n = hf(r)), { hex: n, hsv: a, rgb: r };
}
function bM({
  onClose: e,
  children: t,
  title: n,
  closeOnClickOutside: r
}) {
  const a = Te(null);
  return le(() => {
    a.current !== null && a.current.focus();
  }, []), le(() => {
    let s = null;
    const o = (u) => {
      u.key === "Escape" && e();
    }, i = (u) => {
      const f = u.target;
      a.current !== null && !a.current.contains(f) && r && e();
    }, c = a.current;
    return c !== null && (s = c.parentElement, s !== null && s.addEventListener("click", i)), window.addEventListener("keydown", o), () => {
      window.removeEventListener("keydown", o), s !== null && (s == null || s.removeEventListener("click", i));
    };
  }, [r, e]), /* @__PURE__ */ d.createElement("div", { className: "Modal__overlay", role: "dialog" }, /* @__PURE__ */ d.createElement("div", { className: "Modal__modal", tabIndex: -1, ref: a }, /* @__PURE__ */ d.createElement(ne, { styledAs: "body2", className: "Modal__title" }, n), /* @__PURE__ */ d.createElement(
    Me,
    {
      className: "Modal__closeButton",
      "aria-label": "Close modal",
      type: "button",
      onClick: e
    },
    /* @__PURE__ */ d.createElement(me, { icon: Vh })
  ), /* @__PURE__ */ d.createElement("div", { className: "Modal__content" }, t)));
}
function mM({
  onClose: e,
  children: t,
  title: n,
  closeOnClickOutside: r = !1
}) {
  return ro(
    /* @__PURE__ */ d.createElement(
      bM,
      {
        onClose: e,
        title: n,
        closeOnClickOutside: r
      },
      t
    ),
    document.body
  );
}
function _M() {
  const [e, t] = de(null), n = _e(() => {
    t(null);
  }, []), r = Le(() => {
    if (e === null)
      return null;
    const { title: s, content: o, closeOnClickOutside: i } = e;
    return /* @__PURE__ */ d.createElement(
      mM,
      {
        onClose: n,
        title: s,
        closeOnClickOutside: i
      },
      o
    );
  }, [e, n]), a = _e(
    (s, o, i = !1) => {
      t({
        closeOnClickOutside: i,
        content: o(n),
        title: s
      });
    },
    [n]
  );
  return [r, a];
}
function $i(e) {
  const t = e.getShape();
  return {
    columns: t.toX - t.fromX + 1,
    rows: t.toY - t.fromY + 1
  };
}
function pM() {
  const e = wt();
  if (Ct(e) && !e.isCollapsed() || Sn(e) && !e.anchor.is(e.focus) || !Ct(e) && !Sn(e))
    return !1;
  const [t] = Ql(e.anchor);
  return t.__colSpan > 1 || t.__rowSpan > 1;
}
function gf(e) {
  if (e.getChildrenSize() !== 1)
    return !1;
  const t = e.getFirstChildOrThrow();
  return !(!ec(t) || !t.isEmpty());
}
function jM(e) {
  const t = e.getLastDescendant();
  Ff(t) ? t.select() : Vp(t) ? t.selectEnd() : t !== null && t.selectNext();
}
function yf(e) {
  return e.getEditorState().read(() => {
    const t = wt();
    if (Ct(t) || Sn(t)) {
      const [n] = Ql(t.anchor);
      if (vt(n))
        return n.getBackgroundColor();
    }
    return null;
  });
}
function vM({
  onClose: e,
  tableCellNode: t,
  setIsMenuOpen: n,
  contextRef: r,
  cellMerge: a,
  showColorPickerModal: s
}) {
  const [o] = Ze(), i = Te(null), [c, u] = de(t), [f, m] = de({
    columns: 1,
    rows: 1
  }), [b, _] = de(!1), [j, p] = de(!1), [v, h] = de(
    () => yf(o) || ""
  );
  le(() => o.registerMutationListener(
    Jl,
    (R) => {
      R.get(c.getKey()) === "updated" && (o.getEditorState().read(() => {
        u(c.getLatest());
      }), h(yf(o) || ""));
    },
    { skipInitialization: !0 }
  ), [o, c]), le(() => {
    o.getEditorState().read(() => {
      const R = wt();
      if (Sn(R)) {
        const M = $i(R);
        m($i(R)), _(
          M.columns > 1 || M.rows > 1
        );
      }
      p(pM());
    });
  }, [o]), le(() => {
    const R = r.current, M = i.current, D = o.getRootElement();
    if (R != null && M != null && D != null) {
      const I = D.getBoundingClientRect(), F = R.getBoundingClientRect();
      M.style.opacity = "1";
      const P = M.getBoundingClientRect(), A = 5;
      let $ = F.right + A;
      if ($ + P.width > window.innerWidth || $ + P.width > I.right) {
        const Y = F.left - P.width - A;
        $ = (Y < 0 ? A : Y) + window.pageXOffset;
      }
      M.style.left = `${$ + window.pageXOffset}px`;
      let B = F.top;
      if (B + P.height > window.innerHeight) {
        const Y = F.bottom - P.height;
        B = (Y < 0 ? A : Y) + window.pageYOffset;
      }
      M.style.top = `${B + +window.pageYOffset}px`;
    }
  }, [r, i, o]), le(() => {
    function R(M) {
      i.current != null && r.current != null && !i.current.contains(M.target) && !r.current.contains(M.target) && n(!1);
    }
    return window.addEventListener("click", R), () => window.removeEventListener("click", R);
  }, [n, r]);
  const g = _e(() => {
    o.update(() => {
      if (c.isAttached()) {
        const M = tn(c), D = o.getElementByKey(
          M.getKey()
        );
        if (!D)
          throw new Error("Expected to find tableElement in DOM");
        const I = jp(D);
        I !== null && I.clearHighlight(), M.markDirty(), u(c.getLatest());
      }
      ea().selectStart();
    });
  }, [o, c]), w = () => {
    o.update(() => {
      const R = wt();
      if (Sn(R)) {
        const { columns: M, rows: D } = $i(R), I = R.getNodes();
        let F = null;
        for (let P = 0; P < I.length; P++) {
          const A = I[P];
          if (vt(A))
            if (F === null) {
              A.setColSpan(M).setRowSpan(D), F = A;
              const $ = gf(A);
              let B;
              $ && ec(B = A.getFirstChild()) && B.remove();
            } else vt(F) && (gf(A) || F.append(...A.getChildren()), A.remove());
        }
        F !== null && (F.getChildrenSize() === 0 && F.append(tc()), jM(F)), e();
      }
    });
  }, x = () => {
    o.update(() => {
      Cp();
    });
  }, y = _e(
    (R) => {
      o.update(() => {
        vp(R), e();
      });
    },
    [o, e]
  ), E = _e(
    (R) => {
      o.update(() => {
        for (let M = 0; M < f.columns; M++)
          hp(R);
        e();
      });
    },
    [o, e, f.columns]
  ), C = _e(() => {
    o.update(() => {
      gp(), e();
    });
  }, [o, e]), S = _e(() => {
    o.update(() => {
      tn(c).remove(), g(), e();
    });
  }, [o, c, g, e]), k = _e(() => {
    o.update(() => {
      yp(), e();
    });
  }, [o, e]), O = _e(() => {
    o.update(() => {
      const R = tn(c), M = Lf(c), D = R.getChildren();
      if (M >= D.length || M < 0)
        throw new Error("Expected table cell to be inside of table row.");
      const I = D[M];
      if (!dr(I))
        throw new Error("Expected table row");
      const F = c.getHeaderStyles() ^ bt.ROW;
      I.getChildren().forEach((P) => {
        if (!vt(P))
          throw new Error("Expected table cell");
        P.setHeaderStyles(F, bt.ROW);
      }), g(), e();
    });
  }, [o, c, g, e]), L = _e(() => {
    o.update(() => {
      const R = tn(c), M = wp(c), D = R.getChildren(), I = Math.max(
        ...D.map((P) => P.getChildren().length)
      );
      if (M >= I || M < 0)
        throw new Error("Expected table cell to be inside of table row.");
      const F = c.getHeaderStyles() ^ bt.COLUMN;
      for (let P = 0; P < D.length; P++) {
        const A = D[P];
        if (!dr(A))
          throw new Error("Expected table row");
        const $ = A.getChildren();
        if (M >= $.length)
          continue;
        const B = $[M];
        if (!vt(B))
          throw new Error("Expected table cell");
        B.setHeaderStyles(F, bt.COLUMN);
      }
      g(), e();
    });
  }, [o, c, g, e]);
  _e(() => {
    o.update(() => {
      if (c.isAttached()) {
        const R = tn(c);
        R && R.setRowStriping(!R.getRowStriping());
      }
      g(), e();
    });
  }, [o, c, g, e]);
  const H = _e(
    (R) => {
      o.update(() => {
        const M = wt();
        if (Ct(M) || Sn(M)) {
          const [D] = Ql(M.anchor);
          if (vt(D) && D.setBackgroundColor(R), Sn(M)) {
            const I = M.getNodes();
            for (let F = 0; F < I.length; F++) {
              const P = I[F];
              vt(P) && P.setBackgroundColor(R);
            }
          }
        }
      });
    },
    [o]
  );
  let T = null;
  return a && (b ? T = /* @__PURE__ */ d.createElement(
    "button",
    {
      type: "button",
      className: "item",
      onClick: () => w(),
      "data-test-id": "table-merge-cells"
    },
    "Merge cells"
  ) : j && (T = /* @__PURE__ */ d.createElement(
    "button",
    {
      type: "button",
      className: "item",
      onClick: () => x(),
      "data-test-id": "table-unmerge-cells"
    },
    "Unmerge cells"
  ))), ro(
    /* @__PURE__ */ d.createElement(
      "div",
      {
        className: "dropdown",
        ref: i,
        onClick: (R) => {
          R.stopPropagation();
        }
      },
      T,
      /* @__PURE__ */ d.createElement(
        "button",
        {
          type: "button",
          className: "item",
          onClick: () => s("Cell background color", () => /* @__PURE__ */ d.createElement(
            dM,
            {
              color: v,
              onChange: H
            }
          )),
          "data-test-id": "table-background-color"
        },
        /* @__PURE__ */ d.createElement(ne, { textColor: "monoBlack", styledAs: "body3" }, "Background color")
      ),
      /* @__PURE__ */ d.createElement("hr", null),
      /* @__PURE__ */ d.createElement(
        "button",
        {
          type: "button",
          className: "item",
          onClick: () => y(!1),
          "data-test-id": "table-insert-row-above"
        },
        /* @__PURE__ */ d.createElement(ne, { textColor: "monoBlack", styledAs: "body3" }, "Insert", " ", f.rows === 1 ? "row" : `${f.rows} rows`, " ", "above")
      ),
      /* @__PURE__ */ d.createElement(
        "button",
        {
          type: "button",
          className: "item",
          onClick: () => y(!0),
          "data-test-id": "table-insert-row-below"
        },
        /* @__PURE__ */ d.createElement(ne, { textColor: "monoBlack", styledAs: "body3" }, "Insert", " ", f.rows === 1 ? "row" : `${f.rows} rows`, " ", "below")
      ),
      /* @__PURE__ */ d.createElement("hr", null),
      /* @__PURE__ */ d.createElement(
        "button",
        {
          type: "button",
          className: "item",
          onClick: () => E(!1),
          "data-test-id": "table-insert-column-before"
        },
        /* @__PURE__ */ d.createElement(ne, { textColor: "monoBlack", styledAs: "body3" }, "Insert", " ", f.columns === 1 ? "column" : `${f.columns} columns`, " ", "left")
      ),
      /* @__PURE__ */ d.createElement(
        "button",
        {
          type: "button",
          className: "item",
          onClick: () => E(!0),
          "data-test-id": "table-insert-column-after"
        },
        /* @__PURE__ */ d.createElement(ne, { textColor: "monoBlack", styledAs: "body3" }, "Insert", " ", f.columns === 1 ? "column" : `${f.columns} columns`, " ", "right")
      ),
      /* @__PURE__ */ d.createElement("hr", null),
      /* @__PURE__ */ d.createElement(
        "button",
        {
          type: "button",
          className: "item",
          onClick: () => k(),
          "data-test-id": "table-delete-columns"
        },
        /* @__PURE__ */ d.createElement(ne, { textColor: "monoBlack", styledAs: "body3" }, "Delete column")
      ),
      /* @__PURE__ */ d.createElement(
        "button",
        {
          type: "button",
          className: "item",
          onClick: () => C(),
          "data-test-id": "table-delete-rows"
        },
        /* @__PURE__ */ d.createElement(ne, { textColor: "monoBlack", styledAs: "body3" }, "Delete row")
      ),
      /* @__PURE__ */ d.createElement(
        "button",
        {
          type: "button",
          className: "item",
          onClick: () => S(),
          "data-test-id": "table-delete"
        },
        /* @__PURE__ */ d.createElement(ne, { textColor: "monoBlack", styledAs: "body3" }, "Delete table")
      ),
      /* @__PURE__ */ d.createElement("hr", null),
      /* @__PURE__ */ d.createElement(
        "button",
        {
          type: "button",
          className: "item",
          onClick: () => O()
        },
        /* @__PURE__ */ d.createElement(ne, { textColor: "monoBlack", styledAs: "body3" }, (c.__headerState & bt.ROW) === bt.ROW ? "Remove" : "Add", " ", "row header")
      ),
      /* @__PURE__ */ d.createElement(
        "button",
        {
          type: "button",
          className: "item",
          onClick: () => L(),
          "data-test-id": "table-column-header"
        },
        /* @__PURE__ */ d.createElement(ne, { textColor: "monoBlack", styledAs: "body3" }, (c.__headerState & bt.COLUMN) === bt.COLUMN ? "Remove" : "Add", " ", "column header")
      )
    ),
    document.body
  );
}
function hM({
  anchorElem: e,
  cellMerge: t
}) {
  const [n] = Ze(), r = Te(null), a = Te(null), [s, o] = de(!1), [i, c] = de(
    null
  ), [u, f] = _M(), m = _e(() => {
    const _ = r.current, j = wt(), p = window.getSelection(), v = document.activeElement;
    if (j == null || _ == null) {
      c(null);
      return;
    }
    const h = n.getRootElement();
    if (Ct(j) && h !== null && p !== null && h.contains(p.anchorNode)) {
      const g = pp(
        j.anchor.getNode()
      );
      if (g == null) {
        c(null);
        return;
      }
      if (n.getElementByKey(
        g.getKey()
      ) == null) {
        c(null);
        return;
      }
      c(g);
    } else v || c(null);
  }, [n]);
  le(() => n.registerUpdateListener(() => {
    n.getEditorState().read(() => {
      m();
    });
  })), le(() => {
    const _ = r.current;
    if (_ != null && i != null) {
      const j = n.getElementByKey(i.getKey());
      if (j != null) {
        const p = j.getBoundingClientRect(), v = _.getBoundingClientRect(), h = e.getBoundingClientRect(), g = p.top - h.top + 4, w = p.right - v.width - 10 - h.left;
        _.style.opacity = "1", _.style.transform = `translate(${w}px, ${g}px)`;
      } else
        _.style.opacity = "0", _.style.transform = "translate(-10000px, -10000px)";
    }
  }, [r, i, n, e]);
  const b = Te(i);
  return le(() => {
    b.current !== i && o(!1), b.current = i;
  }, [b, i]), /* @__PURE__ */ d.createElement("div", { className: "table-cell-action-button-container", ref: r }, i != null && /* @__PURE__ */ d.createElement(d.Fragment, null, /* @__PURE__ */ d.createElement(
    Me,
    {
      type: "button",
      className: "table-cell-action-button chevron-down",
      onClick: (_) => {
        _.stopPropagation(), o(!s);
      },
      "aria-label": "open cell menu",
      size: "small",
      ref: a
    },
    /* @__PURE__ */ d.createElement(
      me,
      {
        icon: Rh
      }
    )
  ), u, s && /* @__PURE__ */ d.createElement(
    vM,
    {
      contextRef: a,
      setIsMenuOpen: o,
      onClose: () => o(!1),
      tableCellNode: i,
      cellMerge: t,
      showColorPickerModal: f
    }
  )));
}
function gM({
  anchorElem: e = document.body,
  cellMerge: t = !1
}) {
  const n = Uf();
  return ro(
    n ? /* @__PURE__ */ d.createElement(
      hM,
      {
        anchorElem: e,
        cellMerge: t
      }
    ) : null,
    e
  );
}
var yM = "_18cjkvw0", wM = "_18cjkvw1", CM = "_18cjkvw2", EM = "_18cjkvw3", xM = "_18cjkvw4", SM = "_18cjkvw5", kM = "_18cjkvw6", TM = "_18cjkvw7", RM = "_18cjkvw8", OM = "_18cjkvw9", MM = "_18cjkvwa", AM = "_18cjkvwb", PM = "_18cjkvwe _18cjkvwc _18cjkvwd", NM = "_18cjkvwf _18cjkvwc _18cjkvwd", DM = "_18cjkvwg", IM = "_18cjkvwh", $M = "_18cjkvwi", LM = "_18cjkvwj", zM = "_18cjkvwk", FM = "_18cjkvwl", HM = "_18cjkvwm", BM = "_18cjkvwn", qM = "_18cjkvwo", UM = "_18cjkvwp", wf = "_18cjkvwq", WM = "_18cjkvwr", VM = "_18cjkvws", YM = "_18cjkvwt", GM = "_18cjkvwu", Cf = "_18cjkvwv", KM = "_18cjkvww", XM = "_18cjkvwx", ZM = "_18cjkvwy", JM = "_18cjkvwz", QM = "_18cjkvw10", eA = "_18cjkvw12";
const tA = 33, Ef = 92;
function nA({ editor: e }) {
  const t = Te(null), n = Te(null), r = Te(null), a = Te(null), [s, o] = de(null), [i, c] = de(null), [u, f] = de(!1), [m, b] = de(null), _ = _e(() => {
    c(null), t.current = null, b(null), a.current = null, r.current = null;
  }, []), j = (S) => (S.buttons & 1) === 1;
  le(() => e.registerNodeTransform(Zl, (S) => {
    if (S.getColWidths())
      return S;
    const k = S.getColumnCount(), O = Ef;
    return S.setColWidths(Array(k).fill(O)), S;
  }), [e]), le(() => {
    const S = (H) => {
      setTimeout(() => {
        const T = H.target;
        if (m) {
          o({
            x: H.clientX,
            y: H.clientY
          });
          return;
        }
        if (f(j(H)), !(n.current && n.current.contains(T)) && t.current !== T) {
          t.current = T;
          const R = xp(T);
          R && i !== R ? e.update(() => {
            const M = qo(R.elem);
            if (!M)
              throw new Error("TableCellResizer: Table cell node not found.");
            const D = tn(M), I = e.getElementByKey(D.getKey());
            if (!I)
              throw new Error("TableCellResizer: Table element not found.");
            t.current = T, r.current = I.getBoundingClientRect(), c(R);
          }) : R == null && _();
        }
      }, 0);
    }, k = () => {
      setTimeout(() => {
        f(!0);
      }, 0);
    }, O = () => {
      setTimeout(() => {
        f(!1);
      }, 0);
    }, L = e.registerRootListener(
      (H, T) => {
        T == null || T.removeEventListener("mousemove", S), T == null || T.removeEventListener("mousedown", k), T == null || T.removeEventListener("mouseup", O), H == null || H.addEventListener("mousemove", S), H == null || H.addEventListener("mousedown", k), H == null || H.addEventListener("mouseup", O);
      }
    );
    return () => {
      L();
    };
  }, [i, m, e, _]);
  const p = (S) => S === "bottom", v = _e(
    (S) => {
      if (!i)
        throw new Error("TableCellResizer: Expected active cell.");
      e.update(
        () => {
          const k = qo(i.elem);
          if (!vt(k))
            throw new Error("TableCellResizer: Table cell node not found.");
          const O = tn(k), L = Lf(k) + k.getRowSpan() - 1, H = O.getChildren();
          if (L >= H.length || L < 0)
            throw new Error("Expected table cell to be inside of table row.");
          const T = H[L];
          if (!dr(T))
            throw new Error("Expected table row");
          let R = T.getHeight();
          if (R === void 0) {
            const D = T.getChildren();
            R = Math.min(
              ...D.map(
                (I) => h(I, e) ?? 1 / 0
              )
            );
          }
          const M = Math.max(R + S, tA);
          T.setHeight(M);
        },
        { tag: "skip-scroll-into-view" }
      );
    },
    [i, e]
  ), h = (S, k) => {
    const O = k.getElementByKey(S.getKey());
    return O == null ? void 0 : O.clientHeight;
  }, g = (S, k) => {
    for (let O = 0; O < k.length; O++)
      for (let L = 0; L < k[O].length; L++)
        if (k[O][L].cell === S)
          return L;
  }, w = _e(
    (S) => {
      if (!i)
        throw new Error("TableCellResizer: Expected active cell.");
      e.update(
        () => {
          const k = qo(i.elem);
          if (!vt(k))
            throw new Error("TableCellResizer: Table cell node not found.");
          const O = tn(k), [L] = Ep(
            O,
            null,
            null
          ), H = g(k, L);
          if (H === void 0)
            throw new Error("TableCellResizer: Table column not found.");
          const T = O.getColWidths();
          if (!T)
            return;
          const R = T[H];
          if (R === void 0)
            return;
          const M = [...T], D = Math.max(R + S, Ef);
          M[H] = D, O.setColWidths(M);
        },
        { tag: "skip-scroll-into-view" }
      );
    },
    [i, e]
  ), x = _e(
    (S) => {
      const k = (O) => {
        if (O.preventDefault(), O.stopPropagation(), !i)
          throw new Error("TableCellResizer: Expected active cell.");
        if (a.current) {
          const { x: L, y: H } = a.current;
          if (i === null)
            return;
          const T = zi(O.target);
          if (p(S)) {
            const R = (O.clientY - H) / T;
            v(R);
          } else {
            const R = (O.clientX - L) / T;
            w(R);
          }
          _(), document.removeEventListener("mouseup", k);
        }
      };
      return k;
    },
    [i, _, w, v]
  ), y = _e(
    (S) => (k) => {
      if (k.preventDefault(), k.stopPropagation(), !i)
        throw new Error("TableCellResizer: Expected active cell.");
      a.current = {
        x: k.clientX,
        y: k.clientY
      }, o(a.current), b(S), document.addEventListener("mouseup", x(S));
    },
    [i, x]
  ), C = _e(() => {
    if (i) {
      const { height: S, width: k, top: O, left: L } = i.elem.getBoundingClientRect(), H = zi(i.elem), T = 10, R = {
        bottom: {
          backgroundColor: "none",
          cursor: "row-resize",
          height: `${T}px`,
          left: `${window.pageXOffset + L}px`,
          top: `${window.pageYOffset + O + S - T / 2}px`,
          width: `${k}px`
        },
        right: {
          backgroundColor: "none",
          cursor: "col-resize",
          height: `${S}px`,
          left: `${window.pageXOffset + L + k - T / 2}px`,
          top: `${window.pageYOffset + O}px`,
          width: `${T}px`
        }
      }, M = r.current;
      return m && s && M && (p(m) ? (R[m].left = `${window.pageXOffset + M.left}px`, R[m].top = `${window.pageYOffset + s.y / H}px`, R[m].height = "3px", R[m].width = `${M.width}px`) : (R[m].top = `${window.pageYOffset + M.top}px`, R[m].left = `${window.pageXOffset + s.x / H}px`, R[m].width = "3px", R[m].height = `${M.height}px`), R[m].backgroundColor = "#adf"), R;
    }
    return {
      bottom: null,
      left: null,
      right: null,
      top: null
    };
  }, [i, m, s])();
  return /* @__PURE__ */ d.createElement("div", { ref: n }, i != null && !u && /* @__PURE__ */ d.createElement(d.Fragment, null, /* @__PURE__ */ d.createElement(
    "div",
    {
      className: Cf,
      style: C.right || void 0,
      onMouseDown: y("right")
    }
  ), /* @__PURE__ */ d.createElement(
    "div",
    {
      className: Cf,
      style: C.bottom || void 0,
      onMouseDown: y("bottom")
    }
  )));
}
function rA() {
  const [e] = Ze(), t = Uf();
  return Le(
    () => t ? ro(/* @__PURE__ */ d.createElement(nA, { editor: e }), document.body) : null,
    [e, t]
  );
}
Yp("INSERT_NEW_TABLE_COMMAND");
const aA = Cs({
  cellEditorConfig: null,
  cellEditorPlugins: null,
  set: () => {
  }
});
function sA({ children: e }) {
  const [t, n] = de({
    cellEditorConfig: null,
    cellEditorPlugins: null
  });
  return /* @__PURE__ */ d.createElement(
    aA.Provider,
    {
      value: Le(
        () => ({
          cellEditorConfig: t.cellEditorConfig,
          cellEditorPlugins: t.cellEditorPlugins,
          set: (r, a) => {
            n({ cellEditorConfig: r, cellEditorPlugins: a });
          }
        }),
        [t.cellEditorConfig, t.cellEditorPlugins]
      )
    },
    e
  );
}
var oA = "_1l0bdoz0", iA = { danger: "_1l0bdoz5 _1l0bdoz1 _1s8b37j4", warning: "_1l0bdoz6 _1l0bdoz2 _1s8b37j7", success: "_1l0bdoz7 _1l0bdoz3 _1s8b37ja", neutral: "_1l0bdoz8 _1l0bdoz4 _1s8b37j1" }, lA = "_1l0bdoz9", cA = "_1l0bdoza", uA = "_1l0bdozb", dA = "_1l0bdozc";
const fA = {
  ltr: yM,
  rtl: wM,
  paragraph: CM,
  heading: {
    h1: EM,
    h2: xM,
    h3: SM,
    h4: kM,
    h5: TM,
    h6: RM
  },
  list: {
    nested: {
      listitem: DM
    },
    ol: OM,
    ul: MM,
    listitem: AM,
    listitemChecked: PM,
    listitemUnchecked: NM
  },
  text: {
    bold: IM,
    italic: $M,
    underline: LM,
    strikethrough: zM,
    underlineStrikethrough: FM,
    code: HM
  },
  quote: qM,
  code: BM,
  table: UM,
  tableCell: YM,
  tableRow: wf,
  tableAddColumns: eA,
  tableCellHeader: XM,
  tableCellSelected: ZM,
  tableCellPrimarySelected: JM,
  tableCellSortedIndicator: GM,
  tableCellResizer: KM,
  tableCellEditing: QM,
  tableSelected: VM,
  tableSelection: WM,
  tableRowStripping: wf
};
var bA = "atqxrg0", xn = "atqxrg1", mA = "_18trixj0", _A = "_18trixj1", pA = "_18trixj2", jA = "_18trixj3";
const Vt = ({
  label: e,
  icon: t,
  onClick: n,
  pressed: r,
  shortcut: a,
  text: s,
  toggle: o = !0,
  isDisabled: i = !1,
  className: c,
  ...u
}) => {
  const [f, m] = nt({
    prop: r,
    defaultProp: !1
  }), b = l.useCallback(() => {
    o && m(!f), n == null || n();
  }, [o, n, m, f]);
  return /* @__PURE__ */ l.createElement(_t.Root, null, /* @__PURE__ */ l.createElement(_t.Trigger, { asChild: !0 }, /* @__PURE__ */ l.createElement(
    U.button,
    {
      ...u,
      type: "button",
      "aria-label": e,
      onClick: b,
      ...o && { "aria-pressed": f },
      className: q(
        pA,
        c,
        f && jA
      ),
      disabled: i
    },
    t
  )), /* @__PURE__ */ l.createElement(_t.Content, { className: mA }, /* @__PURE__ */ l.createElement(_t.Text, null, s), /* @__PURE__ */ l.createElement("div", { className: _A }, a == null ? void 0 : a.map((_) => /* @__PURE__ */ l.createElement("kbd", { key: _ }, _)))));
}, vA = ({ isDisabled: e, className: t }) => {
  const [n] = Ze(), r = l.useCallback(
    (s) => n.dispatchCommand(Gp, s),
    [n]
  ), a = l.useMemo(() => ({
    left: {
      text: "Left Align",
      icon: /* @__PURE__ */ l.createElement(me, { icon: Sh }),
      shortcut: [],
      onClick: () => {
        r("left");
      }
    },
    center: {
      text: "Center Align",
      icon: /* @__PURE__ */ l.createElement(me, { icon: Eh }),
      onClick: () => {
        r("center");
      },
      shortcut: []
    },
    right: {
      text: "Right Align",
      icon: /* @__PURE__ */ l.createElement(me, { icon: kh }),
      onClick: () => {
        r("right");
      },
      shortcut: []
    },
    justify: {
      text: "Justify Align",
      icon: /* @__PURE__ */ l.createElement(me, { icon: xh }),
      onClick: () => {
        r("justify");
      },
      shortcut: []
    }
  }), [r]);
  return /* @__PURE__ */ l.createElement(re, { gap: "zero", className: t }, Object.entries(a).map(([s, o]) => /* @__PURE__ */ l.createElement(
    Vt,
    {
      key: s,
      text: o.text,
      label: `${o.text}`,
      onClick: o.onClick,
      icon: o.icon,
      shortcut: o.shortcut,
      toggle: !1,
      isDisabled: e
    }
  )));
};
var hA = {
  prefix: "fas",
  iconName: "strikethrough",
  icon: [512, 512, [], "f0cc", "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"]
}, gA = {
  prefix: "fas",
  iconName: "list",
  icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"]
}, yA = {
  prefix: "fas",
  iconName: "underline",
  icon: [448, 512, [], "f0cd", "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
}, wA = {
  prefix: "fas",
  iconName: "bold",
  icon: [384, 512, [], "f032", "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"]
}, CA = {
  prefix: "fas",
  iconName: "rotate-left",
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"]
}, EA = {
  prefix: "fas",
  iconName: "italic",
  icon: [384, 512, [], "f033", "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"]
}, xA = {
  prefix: "fas",
  iconName: "list-ol",
  icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
}, SA = {
  prefix: "fas",
  iconName: "code",
  icon: [640, 512, [], "f121", "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"]
}, kA = {
  prefix: "fas",
  iconName: "rotate-right",
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"]
};
const TA = ({
  isDisabled: e,
  className: t
}) => {
  const [n] = Ze(), { markdownView: r } = Nr(), { isCode: a } = Ia(), s = l.useCallback(
    (i) => n.dispatchCommand(Hf, i),
    [n]
  );
  l.useEffect(() => n.registerCommand(
    nc,
    (i) => {
      const c = i, { code: u, ctrlKey: f, metaKey: m, shiftKey: b } = c;
      return u === "KeyC" && (f || m) && b ? (c.preventDefault(), s("code")) : !1;
    },
    rc
  ), [n, s]);
  const o = l.useMemo(() => ({
    code: {
      text: "Inline code",
      icon: /* @__PURE__ */ l.createElement(me, { icon: SA }),
      shortcut: ["⌘", "⇧", "C"],
      pressed: a,
      onClick: () => {
        s("code");
      }
    }
  }), [a, s]);
  return /* @__PURE__ */ l.createElement(re, { gap: "zero", className: t }, Object.entries(o).map(([i, c]) => /* @__PURE__ */ l.createElement(
    Vt,
    {
      key: i,
      text: c.text,
      pressed: c.pressed,
      label: `Format text as ${c.text}`,
      onClick: c.onClick,
      icon: c.icon,
      shortcut: c.shortcut,
      isDisabled: r || e
    }
  )));
};
var RA = /* @__PURE__ */ ((e) => (e.Bullet = "bullet", e.Number = "number", e))(RA || {});
const OA = ({
  listType: e = [
    "bullet",
    "number"
    /* Number */
  ],
  isDisabled: t,
  className: n
}) => {
  const [r] = Ze(), { markdownView: a } = Nr(), { blockType: s } = Ia(), o = l.useCallback(
    (u) => e.includes(u),
    [e]
  ), i = l.useCallback(
    (u) => {
      let f = rp;
      switch (u) {
        case "number":
          s !== "number" && (f = sp);
          break;
        case "bullet":
          s !== "bullet" && (f = ap);
          break;
      }
      return r.dispatchCommand(f, void 0);
    },
    [r, s]
  );
  l.useEffect(() => r.registerCommand(
    nc,
    (u) => {
      const f = u, { code: m, ctrlKey: b, metaKey: _, shiftKey: j } = f;
      return o(
        "bullet"
        /* Bullet */
      ) && m === "Digit7" && (b || _) && j ? (f.preventDefault(), i(
        "bullet"
        /* Bullet */
      )) : o(
        "number"
        /* Number */
      ) && m === "Digit8" && (b || _) && j ? (f.preventDefault(), i(
        "number"
        /* Number */
      )) : !1;
    },
    rc
  ), [r, i, o]);
  const c = l.useMemo(() => ({
    bullet: {
      text: "Bulleted list",
      icon: /* @__PURE__ */ l.createElement(me, { icon: gA }),
      shortcut: ["⌘", "⇧", "7"],
      pressed: s === "bullet",
      onClick: () => {
        i(
          "bullet"
          /* Bullet */
        );
      }
    },
    number: {
      text: "Numbered list",
      icon: /* @__PURE__ */ l.createElement(me, { icon: xA }),
      shortcut: ["⌘", "⇧", "8"],
      pressed: s === "number",
      onClick: () => {
        i(
          "number"
          /* Number */
        );
      }
    }
  }), [s, i]);
  return /* @__PURE__ */ l.createElement(re, { gap: "zero", className: n }, Object.entries(c).map(([u, f]) => {
    if (e.includes(u))
      return /* @__PURE__ */ l.createElement(
        Vt,
        {
          key: u,
          text: f.text,
          pressed: f.pressed,
          label: `Create ${f.text}`,
          onClick: f.onClick,
          icon: f.icon,
          shortcut: f.shortcut,
          isDisabled: a || t
        }
      );
  }));
}, MA = (e) => {
  const t = e.anchor, n = e.focus, r = e.anchor.getNode(), a = e.focus.getNode();
  return r === a ? r : e.isBackward() ? ks(n) ? r : a : ks(t) ? a : r;
}, AA = ({
  linkUrlLabel: e = "URL",
  linkTitleLabel: t = "Link title",
  linkEditorSaveButtonLabel: n = "Save",
  linkEditorCancelButtonLabel: r = "Cancel",
  onSave: a,
  onCancel: s
}) => {
  const [o] = Ze(), [i, c] = l.useState(""), [u, f] = l.useState(""), [m, b] = l.useState(""), [_, j] = l.useState(null), p = l.useCallback(() => {
    const h = wt();
    if (Ct(h)) {
      const g = MA(h), w = g.getParent();
      Ss(w) ? (c(w.getURL()), f(w.getTitle()), b(w.getTarget())) : Ss(g) ? (c(g.getURL()), f(g.getTitle()), b(g.getTarget())) : c(""), j(h);
    }
    return !0;
  }, [o]);
  l.useEffect(() => ac(
    o.registerUpdateListener(({ editorState: h }) => {
      h.read(() => {
        p();
      });
    }),
    o.registerCommand(
      Bf,
      () => (p(), !0),
      ta
    )
  ), [o, p]), l.useEffect(() => {
    o.getEditorState().read(() => {
      p();
    });
  }, [o, p]);
  const v = l.useCallback(() => {
    _ !== null && i !== "" && o.dispatchCommand(Li, {
      url: i,
      title: u,
      target: m
    }), a == null || a();
  }, [o, _, i, u]);
  return /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(Ae.Root, null, /* @__PURE__ */ l.createElement(Ae.Label, { htmlFor: "link-input" }, e), /* @__PURE__ */ l.createElement(Ae.Content, null, /* @__PURE__ */ l.createElement(
    pr,
    {
      value: i,
      required: !0,
      onChange: (h) => {
        c(h.target.value);
      },
      name: "link-input",
      id: "link-input"
    }
  ))), /* @__PURE__ */ l.createElement(Ae.Root, null, /* @__PURE__ */ l.createElement(Ae.Label, { htmlFor: "link-title" }, t), /* @__PURE__ */ l.createElement(Ae.Content, null, /* @__PURE__ */ l.createElement(
    pr,
    {
      value: u ?? "",
      onChange: (h) => {
        f(h.target.value);
      },
      name: "link-title",
      id: "link-title"
    }
  ))), /* @__PURE__ */ l.createElement(re, null, /* @__PURE__ */ l.createElement(Et, { onClick: v }, n), /* @__PURE__ */ l.createElement(Et, { variant: "tertiary", onClick: s }, r)));
}, PA = ({
  isDisabled: e,
  linkEditorHeading: t = "Link Details",
  className: n,
  ...r
}) => {
  const [a] = Ze(), { markdownView: s } = Nr(), { isLink: o } = Ia(), [i, c] = l.useState(!1), u = l.useCallback(() => {
    o ? c(!i) : (a.dispatchCommand(Li, "https://"), c(!0));
  }, [a, o, c, i]), f = l.useCallback(() => {
    c(!1);
  }, [c]);
  return /* @__PURE__ */ l.createElement(re, { gap: "zero", className: n }, /* @__PURE__ */ l.createElement(Fe.Root, { isOpen: i }, /* @__PURE__ */ l.createElement(
    Vt,
    {
      text: "Link",
      pressed: o,
      label: "Insert/Edit Link",
      onClick: u,
      icon: /* @__PURE__ */ l.createElement(Fe.Trigger, { asChild: !0 }, /* @__PURE__ */ l.createElement(me, { icon: Bh })),
      isDisabled: s || e
    }
  ), /* @__PURE__ */ l.createElement(Fe.Content, { "aria-labelledby": "link-input" }, /* @__PURE__ */ l.createElement(ye, { padding: "default" }, /* @__PURE__ */ l.createElement(kr, { level: "2", styledAs: "heading5", id: "linkDetailsPopOver" }, t), /* @__PURE__ */ l.createElement(
    AA,
    {
      onSave: f,
      onCancel: f,
      ...r
    }
  )))), /* @__PURE__ */ l.createElement(
    Vt,
    {
      text: "Unlink",
      label: "Remove Link",
      toggle: !1,
      onClick: () => {
        a.dispatchCommand(Li, null);
      },
      icon: /* @__PURE__ */ l.createElement(me, { icon: Yh }),
      isDisabled: s || e
    }
  ));
}, NA = ({
  isDisabled: e,
  className: t
}) => {
  const [n] = Ze(), { setMarkdownView: r } = Nr(), a = l.useCallback(() => {
    n.update(() => {
      const s = ea(), o = s.getFirstChild();
      if (Q_(o) && o.getLanguage() === "markdown")
        Xl(
          o.getTextContent(),
          pa
        ), r(!1);
      else {
        const i = Kl(pa);
        s.clear().append(
          ep("markdown").append(qf(i))
        ), r(!0);
      }
      s.selectEnd();
    });
  }, [n, r]);
  return /* @__PURE__ */ l.createElement(re, { className: t }, /* @__PURE__ */ l.createElement(
    Vt,
    {
      text: "Markdown Preview",
      label: "Markdown Preview",
      onClick: a,
      icon: /* @__PURE__ */ l.createElement(me, { icon: Ih }),
      isDisabled: e
    }
  ));
};
var DA = /* @__PURE__ */ ((e) => (e.Strikethrough = "strikethrough", e.Underline = "underline", e.Bold = "bold", e.Italic = "italic", e.InlineCode = "code", e))(DA || {});
const IA = ({
  formatButtons: e = ["bold", "italic", "underline", "strikethrough"],
  isDisabled: t,
  className: n
}) => {
  const { isBold: r, isItalic: a, isUnderline: s, isStrikethrough: o } = Ia(), [i] = Ze(), { markdownView: c } = Nr(), u = l.useCallback(
    (b) => e.includes(b),
    [e]
  ), f = l.useCallback(
    (b) => i.dispatchCommand(Hf, b),
    [i]
  );
  l.useEffect(() => i.registerCommand(
    nc,
    (b) => {
      const _ = b, { code: j, ctrlKey: p, metaKey: v } = _;
      return u(
        "strikethrough"
        /* Strikethrough */
      ) && j === "KeyD" && (p || v) ? (_.preventDefault(), f(
        "strikethrough"
        /* Strikethrough */
      )) : !1;
    },
    rc
  ), [i, f, u]);
  const m = l.useMemo(() => ({
    bold: {
      text: "Bold",
      icon: /* @__PURE__ */ l.createElement(me, { icon: wA }),
      shortcut: ["⌘", "B"],
      pressed: r,
      onClick: () => {
        f(
          "bold"
          /* Bold */
        );
      }
    },
    italic: {
      text: "Italic",
      icon: /* @__PURE__ */ l.createElement(me, { icon: EA }),
      shortcut: ["⌘", "I"],
      pressed: a,
      onClick: () => {
        f(
          "italic"
          /* Italic */
        );
      }
    },
    /*
     * Currently not supported in zendesk markdown*/
    underline: {
      text: "Underline",
      icon: /* @__PURE__ */ l.createElement(me, { icon: yA }),
      shortcut: ["⌘", "U"],
      pressed: s,
      onClick: () => {
        f(
          "underline"
          /* Underline */
        );
      }
    },
    strikethrough: {
      text: "Strikethrough",
      icon: /* @__PURE__ */ l.createElement(me, { icon: hA }),
      shortcut: ["⌘", "D"],
      pressed: o,
      onClick: () => {
        f(
          "strikethrough"
          /* Strikethrough */
        );
      }
    }
  }), [r, a, s, o, f]);
  return /* @__PURE__ */ l.createElement(re, { gap: "zero", className: n }, Object.entries(m).map(([b, _]) => {
    if (e.includes(b))
      return /* @__PURE__ */ l.createElement(
        Vt,
        {
          key: b,
          text: _.text,
          pressed: _.pressed,
          label: `Format text as ${_.text}`,
          onClick: _.onClick,
          icon: _.icon,
          shortcut: _.shortcut,
          isDisabled: c || t
        }
      );
  }));
}, $A = ({
  isDisabled: e,
  className: t
}) => {
  const [n] = Ze(), { markdownView: r } = Nr(), { blockType: a } = Ia(), s = l.useCallback(
    (i) => {
      if (i !== a)
        if (i === "paragraph")
          n.update(() => {
            const c = wt();
            Ct(c) && Uo(c, () => tc());
          });
        else if (i === "quote")
          n.update(() => {
            const c = wt();
            Ct(c) && Uo(c, () => Lp());
          });
        else {
          const c = i;
          n.update(() => {
            const u = wt();
            Ct(u) && Uo(u, () => zp(c));
          });
        }
    },
    [n, a]
  ), o = [
    {
      icon: /* @__PURE__ */ l.createElement(me, { icon: qh }),
      text: "Paragraph",
      value: "paragraph"
    },
    {
      icon: /* @__PURE__ */ l.createElement(me, { icon: Lh }),
      text: "Heading 1",
      value: "h1"
    },
    {
      icon: /* @__PURE__ */ l.createElement(me, { icon: zh }),
      text: "Heading 2",
      value: "h2"
    },
    {
      icon: /* @__PURE__ */ l.createElement(me, { icon: Fh }),
      text: "Heading 3",
      value: "h3"
    },
    {
      icon: /* @__PURE__ */ l.createElement(me, { icon: Hh }),
      text: "Heading 4",
      value: "h4"
    },
    {
      icon: /* @__PURE__ */ l.createElement(me, { icon: S1 }),
      text: "Heading 5",
      value: "h5"
    },
    {
      icon: /* @__PURE__ */ l.createElement(me, { icon: S1 }),
      text: "Heading 6",
      value: "h6"
    }
  ];
  return /* @__PURE__ */ l.createElement(re, { width: "20%", gap: "zero", className: t }, /* @__PURE__ */ l.createElement(
    Q8,
    {
      placeholder: "Select format",
      isClearable: !1,
      onChange: s,
      options: o,
      value: a,
      disabled: r || e
    }
  ));
}, LA = ({ isDisabled: e }) => {
  const [t, n] = l.useState(!1), [r, a] = l.useState(!1), [s] = Ze();
  l.useEffect(() => ac(
    s.registerCommand(
      Kp,
      (i) => (n(i), !1),
      ta
    ),
    s.registerCommand(
      Xp,
      (i) => (a(i), !1),
      ta
    )
  ), [s]);
  const o = l.useMemo(() => ({
    undo: {
      text: "Undo",
      icon: /* @__PURE__ */ l.createElement(me, { icon: CA }),
      shortcut: ["⌘", "Z"],
      onClick: () => {
        s.dispatchCommand(Zp, void 0);
      },
      toggle: !1,
      isDisabled: !t
    },
    redo: {
      text: "Redo",
      icon: /* @__PURE__ */ l.createElement(me, { icon: kA }),
      shortcut: ["⌘", "Y"],
      onClick: () => {
        s.dispatchCommand(Jp, void 0);
      },
      toggle: !1,
      isDisabled: !r
    }
  }), [t, r, s]);
  return /* @__PURE__ */ l.createElement(re, { gap: "zero" }, Object.entries(o).map(([i, c]) => /* @__PURE__ */ l.createElement(
    Vt,
    {
      key: i,
      text: c.text,
      label: c.text,
      onClick: c.onClick,
      icon: c.icon,
      shortcut: c.shortcut,
      toggle: !1,
      isDisabled: c.isDisabled || e
    }
  )));
}, zA = ({
  isDisabled: e,
  ...t
}) => {
  const [n] = Ze(), r = l.useCallback(() => {
    n.dispatchCommand(Sp, { columns: "4", rows: "4" });
  }, [n]);
  return /* @__PURE__ */ l.createElement(
    Vt,
    {
      text: "Insert Table",
      onClick: r,
      icon: /* @__PURE__ */ l.createElement(me, { icon: Wh }),
      label: "Insert Table",
      isDisabled: e,
      ...t
    }
  );
}, FA = {
  bullet: "Bulleted List",
  check: "Check List",
  code: "Code Block",
  h1: "Heading 1",
  h2: "Heading 2",
  h3: "Heading 3",
  h4: "Heading 4",
  h5: "Heading 5",
  h6: "Heading 6",
  number: "Numbered List",
  paragraph: "Paragraph",
  quote: "Quote",
  table: "Table"
}, R_ = l.createContext({
  isBold: !1,
  isItalic: !1,
  isUnderline: !1,
  isCode: !1,
  isStrikethrough: !1,
  blockType: "paragraph",
  rootType: "Root",
  isLink: !1
}), Ia = () => l.useContext(R_), HA = ({ children: e }) => {
  const [, t] = l.useState(!1), [n, r] = l.useState(!1), [a, s] = l.useState(!1), [o, i] = l.useState(!1), [c, u] = l.useState(!1), [f, m] = l.useState(!1), [b, _] = l.useState(!1), [j, p] = l.useState("paragraph"), [v, h] = de("root"), [g] = Ze(), w = l.useCallback((y) => {
    const E = y.anchor, C = y.focus, S = y.anchor.getNode(), k = y.focus.getNode();
    return S === k ? S : y.isBackward() ? ks(C) ? S : k : ks(E) ? k : S;
  }, []), x = l.useCallback(() => {
    g.getEditorState().read(() => {
      if (g.isComposing())
        return;
      const y = wt(), E = window.getSelection(), C = g.getRootElement();
      if (E !== null && (!Ct(y) || C === null || !C.contains(E.anchorNode))) {
        t(!1);
        return;
      }
      if (!Ct(y))
        return;
      const S = y.anchor.getNode();
      let k = S.getKey() === "root" ? S : Lu(S, (M) => {
        const D = M.getParent();
        return D !== null && Qp(D);
      });
      k === null && (k = S.getTopLevelElementOrThrow());
      const O = k.getKey(), L = g.getElementByKey(O), H = w(y), T = Lu(H, Kr);
      if (Kr(T) ? h("table") : h("root"), L !== null)
        if (op(k)) {
          const M = nj(
            S,
            If
          ), D = M ? M.getListType() : k.getListType();
          p(D);
        } else {
          const M = Fp(k) ? k.getTag() : k.getType();
          M in FA && p(M);
        }
      r(y.hasFormat("bold")), s(y.hasFormat("italic")), i(y.hasFormat("underline")), u(y.hasFormat("strikethrough")), _(y.hasFormat("code"));
      const R = H.getParent();
      Ss(R) || Ss(H) ? m(!0) : m(!1);
    });
  }, [g, w]);
  return l.useEffect(() => ac(
    g.registerUpdateListener(() => {
      x();
    }),
    g.registerRootListener(() => {
      g.getRootElement() === null && t(!1);
    }),
    g.registerCommand(
      Bf,
      () => (x(), !1),
      ta
    )
  ), [g, x]), /* @__PURE__ */ l.createElement(
    R_.Provider,
    {
      value: {
        isBold: n,
        isCode: b,
        isItalic: a,
        isStrikethrough: c,
        isUnderline: o,
        blockType: j,
        rootType: v,
        isLink: f
      }
    },
    /* @__PURE__ */ l.createElement(
      re,
      {
        className: bA,
        gap: "xsmall",
        "data-testid": "fenrir-rte-toolbar"
      },
      e
    )
  );
}, BA = ({
  isDisabled: e = !1,
  enableTables: t
}) => /* @__PURE__ */ l.createElement(HA, null, /* @__PURE__ */ l.createElement(
  $A,
  {
    isDisabled: e,
    className: xn
  }
), /* @__PURE__ */ l.createElement(
  IA,
  {
    isDisabled: e,
    className: xn
  }
), /* @__PURE__ */ l.createElement(
  OA,
  {
    isDisabled: e,
    className: xn
  }
), /* @__PURE__ */ l.createElement(PA, { isDisabled: e, className: xn }), /* @__PURE__ */ l.createElement(vA, { isDisabled: e, className: xn }), /* @__PURE__ */ l.createElement(
  TA,
  {
    isDisabled: e,
    className: xn
  }
), t && /* @__PURE__ */ l.createElement(
  zA,
  {
    isDisabled: e,
    className: xn
  }
), /* @__PURE__ */ l.createElement(LA, { isDisabled: e }));
var qA = "_16u0onv1", xf = "_16u0onv2", Sf = "_16u0onv3", kf = "_16u0onv4";
const UA = () => {
  const e = [
    {
      element: "Heading",
      syntax: /* @__PURE__ */ l.createElement(ye, null, /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "# H1"), /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "## H2"), /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "### H3"), /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "#### H4"), /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "##### H5"))
    },
    {
      element: "Bold",
      syntax: /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "**bold text**")
    },
    {
      element: "Italic",
      syntax: /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "*italicized text*")
    },
    {
      element: "Ordered List",
      syntax: /* @__PURE__ */ l.createElement(ye, null, /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "1. First item"), /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "2. Second item"), /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "3. Third item"))
    },
    {
      element: "Unordered List",
      syntax: /* @__PURE__ */ l.createElement(ye, null, /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "- First item"), /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "- Second item"), /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "- Third item"))
    },
    {
      element: "Code",
      syntax: /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "`code`")
    },
    {
      element: "Blockquote",
      syntax: /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, "> blockquote")
    },
    {
      element: "Link",
      syntax: /* @__PURE__ */ l.createElement(ne, { styledAs: "body3" }, '[title](https://www.example.com "Visit example.com")')
    }
  ];
  return /* @__PURE__ */ l.createElement(Fe.Root, null, /* @__PURE__ */ l.createElement(Fe.Trigger, { asChild: !0 }, /* @__PURE__ */ l.createElement(Et, { variant: "tertiary" }, "Markdown Cheatsheet")), /* @__PURE__ */ l.createElement(Fe.Content, null, /* @__PURE__ */ l.createElement(ye, { padding: "small" }, /* @__PURE__ */ l.createElement("table", { className: qA }, /* @__PURE__ */ l.createElement("thead", null, /* @__PURE__ */ l.createElement("tr", { className: kf }, /* @__PURE__ */ l.createElement("th", { className: xf }, "Element"), /* @__PURE__ */ l.createElement("th", { className: xf }, "Markdown Syntax"))), /* @__PURE__ */ l.createElement("tbody", null, e.map((t, n) => /* @__PURE__ */ l.createElement("tr", { key: n, className: kf }, /* @__PURE__ */ l.createElement("td", { className: Sf, valign: "top" }, /* @__PURE__ */ l.createElement(ne, null, t.element)), /* @__PURE__ */ l.createElement("td", { className: Sf }, t.syntax))))))));
}, WA = ({ placeholder: e }) => {
  const [t] = Ze(), n = () => {
    t.focus();
  };
  return /* @__PURE__ */ d.createElement("div", { className: dA, onClick: n }, e ?? "Enter some text");
}, O_ = d.createContext({
  markdownView: !1,
  setMarkdownView: () => {
  }
}), Nr = () => d.useContext(O_), TD = ({
  className: e,
  defaultValue: t,
  name: n,
  onChange: r,
  onBlur: a,
  placeholder: s,
  isDisabled: o,
  useMarkdown: i = !0,
  plugins: c,
  textFormat: u = "markdown",
  nodes: f = [],
  children: m,
  enableTables: b,
  minWidth: _ = "50rem"
}) => {
  const [j, p] = d.useState(!1), [v, h] = d.useState(null), [g, w] = d.useState(!1), x = (k) => {
    k !== null && h(k);
  };
  d.useEffect(() => {
    const k = () => {
      const O = window.matchMedia(
        "(max-width: 1025px)"
      ).matches;
      O !== g && w(O);
    };
    return k(), window.addEventListener("resize", k), () => {
      window.removeEventListener("resize", k);
    };
  }, [g]);
  const y = d.useCallback(() => {
    if (u === "plaintext") {
      const k = ea();
      if (k.getFirstChild() === null) {
        const O = tc(), L = qf(t ?? "");
        O.append(L), ea().append(O), k.selectEnd();
      }
    }
    Xl(t ?? "", pa);
  }, [u, t]), E = d.useMemo(() => ({
    namespace: n,
    editorState: () => y(),
    theme: fA,
    nodes: [
      Hp,
      Bp,
      If,
      ip,
      np,
      tp,
      Zl,
      Jl,
      $f,
      zf,
      ...f
    ],
    onError: (k) => {
      console.log(k);
    },
    editable: !o
  }), [f, n, o, y]), { appearance: C } = ut(), S = b ? sA : d.Fragment;
  return /* @__PURE__ */ d.createElement(
    O_.Provider,
    {
      value: { markdownView: j, setMarkdownView: p }
    },
    /* @__PURE__ */ d.createElement(Tp, { initialConfig: E }, /* @__PURE__ */ d.createElement(S, null, /* @__PURE__ */ d.createElement(
      "div",
      {
        className: q(
          oA,
          iA[C ?? "neutral"],
          {
            [lA]: o
          }
        ),
        "data-testid": "fenrir-rte",
        style: { minWidth: _ }
      },
      m ?? /* @__PURE__ */ d.createElement(BA, { isDisabled: o, enableTables: b }),
      /* @__PURE__ */ d.createElement(
        "div",
        {
          className: q(cA, e),
          "data-testid": "fenrir-rte-input"
        },
        /* @__PURE__ */ d.createElement(
          Dp,
          {
            contentEditable: /* @__PURE__ */ d.createElement(
              "div",
              {
                style: { position: "relative", display: "flex" },
                ref: x
              },
              /* @__PURE__ */ d.createElement(Rp, { className: uA })
            ),
            placeholder: /* @__PURE__ */ d.createElement(WA, { placeholder: s }),
            ErrorBoundary: Op
          }
        ),
        /* @__PURE__ */ d.createElement(Pp, null),
        /* @__PURE__ */ d.createElement(kp, null),
        /* @__PURE__ */ d.createElement(Ip, null),
        /* @__PURE__ */ d.createElement(Ap, null),
        c,
        /* @__PURE__ */ d.createElement(
          cM,
          {
            onChange: r,
            onBlur: a,
            isDisabled: o,
            formatAs: u
          }
        ),
        i && /* @__PURE__ */ d.createElement(Np, { transformers: pa }),
        /* @__PURE__ */ d.createElement(Mp, null),
        b && /* @__PURE__ */ d.createElement(d.Fragment, null, /* @__PURE__ */ d.createElement($p, null), /* @__PURE__ */ d.createElement(rA, null), v && /* @__PURE__ */ d.createElement(
          gM,
          {
            anchorElem: v,
            cellMerge: !0
          }
        ))
      ),
      i && !o && /* @__PURE__ */ d.createElement(re, { padding: "small", justifyContent: "flex-end" }, /* @__PURE__ */ d.createElement(UA, null), /* @__PURE__ */ d.createElement(NA, null))
    )))
  );
};
function VA(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function YA(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function M_(...e) {
  return (t) => e.forEach((n) => YA(n, t));
}
function GA(...e) {
  return d.useCallback(M_(...e), e);
}
function KA(e, t = []) {
  let n = [];
  function r(s, o) {
    const i = d.createContext(o), c = n.length;
    n = [...n, o];
    function u(m) {
      const { scope: b, children: _, ...j } = m, p = (b == null ? void 0 : b[e][c]) || i, v = d.useMemo(() => j, Object.values(j));
      return /* @__PURE__ */ z.jsx(p.Provider, { value: v, children: _ });
    }
    function f(m, b) {
      const _ = (b == null ? void 0 : b[e][c]) || i, j = d.useContext(_);
      if (j) return j;
      if (o !== void 0) return o;
      throw new Error(`\`${m}\` must be used within \`${s}\``);
    }
    return u.displayName = s + "Provider", [u, f];
  }
  const a = () => {
    const s = n.map((o) => d.createContext(o));
    return function(i) {
      const c = (i == null ? void 0 : i[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: c } }),
        [i, c]
      );
    };
  };
  return a.scopeName = e, [r, XA(a, ...t)];
}
function XA(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(s) {
      const o = r.reduce((i, { useScope: c, scopeName: u }) => {
        const m = c(s)[`__scope${u}`];
        return { ...i, ...m };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function A_(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function ZA({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, a] = JA({ defaultProp: t, onChange: n }), s = e !== void 0, o = s ? e : r, i = A_(n), c = d.useCallback(
    (u) => {
      if (s) {
        const m = typeof u == "function" ? u(e) : u;
        m !== e && i(m);
      } else
        a(u);
    },
    [s, e, a, i]
  );
  return [o, c];
}
function JA({
  defaultProp: e,
  onChange: t
}) {
  const n = d.useState(e), [r] = n, a = d.useRef(r), s = A_(t);
  return d.useEffect(() => {
    a.current !== r && (s(r), a.current = r);
  }, [r, a, s]), n;
}
function QA(e) {
  const t = d.useRef({ value: e, previous: e });
  return d.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var P_ = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, a = d.Children.toArray(n), s = a.find(tP);
  if (s) {
    const o = s.props.children, i = a.map((c) => c === s ? d.Children.count(o) > 1 ? d.Children.only(null) : d.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ z.jsx(Vl, { ...r, ref: t, children: d.isValidElement(o) ? d.cloneElement(o, void 0, i) : null });
  }
  return /* @__PURE__ */ z.jsx(Vl, { ...r, ref: t, children: n });
});
P_.displayName = "Slot";
var Vl = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const a = rP(n);
    return d.cloneElement(n, {
      ...nP(r, n.props),
      // @ts-ignore
      ref: t ? M_(t, a) : a
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
Vl.displayName = "SlotClone";
var eP = ({ children: e }) => /* @__PURE__ */ z.jsx(z.Fragment, { children: e });
function tP(e) {
  return d.isValidElement(e) && e.type === eP;
}
function nP(e, t) {
  const n = { ...t };
  for (const r in t) {
    const a = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? a && s ? n[r] = (...i) => {
      s(...i), a(...i);
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...s } : r === "className" && (n[r] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function rP(e) {
  var r, a;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var aP = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], N_ = aP.reduce((e, t) => {
  const n = d.forwardRef((r, a) => {
    const { asChild: s, ...o } = r, i = s ? P_ : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ z.jsx(i, { ...o, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Ru = "Switch", [sP, RD] = KA(Ru), [oP, iP] = sP(Ru), D_ = d.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: a,
      defaultChecked: s,
      required: o,
      disabled: i,
      value: c = "on",
      onCheckedChange: u,
      ...f
    } = e, [m, b] = d.useState(null), _ = GA(t, (g) => b(g)), j = d.useRef(!1), p = m ? !!m.closest("form") : !0, [v = !1, h] = ZA({
      prop: a,
      defaultProp: s,
      onChange: u
    });
    return /* @__PURE__ */ z.jsxs(oP, { scope: n, checked: v, disabled: i, children: [
      /* @__PURE__ */ z.jsx(
        N_.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": v,
          "aria-required": o,
          "data-state": L_(v),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: c,
          ...f,
          ref: _,
          onClick: VA(e.onClick, (g) => {
            h((w) => !w), p && (j.current = g.isPropagationStopped(), j.current || g.stopPropagation());
          })
        }
      ),
      p && /* @__PURE__ */ z.jsx(
        lP,
        {
          control: m,
          bubbles: !j.current,
          name: r,
          value: c,
          checked: v,
          required: o,
          disabled: i,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
D_.displayName = Ru;
var I_ = "SwitchThumb", $_ = d.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, a = iP(I_, n);
    return /* @__PURE__ */ z.jsx(
      N_.span,
      {
        "data-state": L_(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
$_.displayName = I_;
var lP = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...a } = e, s = d.useRef(null), o = QA(n), i = mm(t);
  return d.useEffect(() => {
    const c = s.current, u = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (o !== n && m) {
      const b = new Event("click", { bubbles: r });
      m.call(c, n), c.dispatchEvent(b);
    }
  }, [o, n, r]), /* @__PURE__ */ z.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...a,
      tabIndex: -1,
      ref: s,
      style: {
        ...e.style,
        ...i,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function L_(e) {
  return e ? "checked" : "unchecked";
}
var cP = D_, uP = $_, dP = "_1s2iguy1 _1s2iguy0 _1s8b37j27u _1s8b37j23o _1s8b37j252 _1s8b37j26g _1s8b37jk8 _1s8b37jkc _1s8b37jkg _1s8b37jkk _1s8b37jkl _1s8b37jkp _1s8b37jkt _1s8b37jkx _1s8b37j12g _1s8b37j2q1 _1s8b37jl5 _1s8b37j8c _1s8b37j29d _1s8b37j2 _1s8b37jlu _1s8b37jl7", fP = "_1s2iguy3 _1s2iguy2 _1s8b37jk8 _1s8b37jkc _1s8b37jkg _1s8b37jkk _1s8b37j12b _1s8b37j2p7 _1s8b37j80 _1s8b37jjz _1s8b37jvi _1s8b37j293";
const bP = l.forwardRef(
  ({
    isChecked: e,
    defaultIsChecked: t,
    onCheckedChange: n,
    isDisabled: r,
    value: a,
    className: s,
    children: o,
    ...i
  }, c) => /* @__PURE__ */ l.createElement(
    cP,
    {
      asChild: !0,
      checked: e,
      defaultChecked: t,
      onCheckedChange: n,
      disabled: r,
      value: a
    },
    /* @__PURE__ */ l.createElement(
      U.button,
      {
        ...i,
        className: q(s, dP),
        ref: c,
        "aria-label": i["aria-label"]
      },
      o
    )
  )
), mP = l.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ l.createElement(uP, { asChild: !0 }, /* @__PURE__ */ l.createElement(
    U.span,
    {
      className: q(e, fP),
      ref: n,
      ...t
    }
  ))
), OD = {
  Root: bP,
  Thumb: mP
}, MD = l.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(U.tbody, { ...t, ref: n }, e)
), AD = l.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(U.tfoot, { ...t, ref: n }, e)
), PD = l.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(U.thead, { ...t, ref: n }, e)
), ND = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(U.td, { ...t, ref: n }, e)), DD = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(U.th, { ...t, ref: n }, e)), ID = l.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(U.th, { ...t, ref: n }, e)), $D = l.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(U.tr, { ...t, ref: n }, e)
), LD = l.forwardRef(
  ({ children: e, ...t }, n) => /* @__PURE__ */ l.createElement(U.table, { ...t, ref: n }, e)
);
function _P(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function pP(e) {
  var t = _P(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function jP(e, t, n) {
  return t = pP(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Tf(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Tf(Object(n), !0).forEach(function(r) {
      jP(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Tf(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Of(e, t) {
  var n = {};
  for (var r in e)
    n[r] = t(e[r], r);
  return n;
}
var vP = (e, t, n) => {
  for (var r of Object.keys(e)) {
    var a;
    if (e[r] !== ((a = t[r]) !== null && a !== void 0 ? a : n[r]))
      return !1;
  }
  return !0;
}, hP = (e) => {
  var t = (n) => {
    var r = e.defaultClassName, a = Rf(Rf({}, e.defaultVariants), n);
    for (var s in a) {
      var o, i = (o = a[s]) !== null && o !== void 0 ? o : e.defaultVariants[s];
      if (i != null) {
        var c = i;
        typeof c == "boolean" && (c = c === !0 ? "true" : "false");
        var u = (
          // @ts-expect-error
          e.variantClassNames[s][c]
        );
        u && (r += " " + u);
      }
    }
    for (var [f, m] of e.compoundVariants)
      vP(f, a, e.defaultVariants) && (r += " " + m);
    return r;
  };
  return t.variants = () => Object.keys(e.variantClassNames), t.classNames = {
    get base() {
      return e.defaultClassName.split(" ")[0];
    },
    get variants() {
      return Of(e.variantClassNames, (n) => Of(n, (r) => r.split(" ")[0]));
    }
  }, t;
}, gP = "_58c7u31 _58c7u30 _1s8b37j22f _1s8b37jl7", yP = "_58c7u32 _1s8b37jll", wP = hP({ defaultClassName: "_58c7u38 _58c7u33 _1s8b37j1k8 _1s8b37j1lm _1s8b37jlo _1s8b37j1n0", variantClassNames: { textColor: { default: "_58c7u39 _58c7u34 _1s8b37jg _1s8b37jt", dimmed: "_58c7u3a _58c7u35 _1s8b37jg _1s8b37ji0" }, fontWeight: { normal: "_58c7u3b _58c7u36 _1s8b37jlb", bold: "_58c7u3c _58c7u37 _1s8b37jlc" } }, defaultVariants: {}, compoundVariants: [] }), CP = "_58c7u3d _1s8b37j11w _1s8b37j2vq", Mf = { default: "_58c7u3e _1s8b37jao", active: "_58c7u3f _1s8b37j5g" }, EP = "_58c7u3g _1s8b37jl3 _1s8b37jck _1s8b37jku _1s8b37jkl _1s8b37jkp _1s8b37jkx", Af = { hide: "_58c7u3h", show: "_58c7u3i" };
const Ou = d.createContext({}), xP = l.forwardRef((e, t) => {
  const {
    children: n,
    tabKey: r,
    className: a,
    isActive: s = !1,
    isDisabled: o = !1,
    onClick: i,
    ...c
  } = e, { activeTabKey: u, setActiveTab: f } = l.useContext(Ou), [m, b] = l.useState(!1), _ = u ? u === r : s, j = o ? "dimmed" : "default", p = _ ? "bold" : "normal", v = l.useCallback(
    (g) => {
      o || (f && r && f(r), i && i(g));
    },
    [o, r, i, f]
  ), h = l.useCallback(
    (g) => {
      if (m)
        switch (g.key) {
          case "Enter":
          case "Space": {
            !o && f && r && f(r);
            break;
          }
          case "ArrowLeft": {
            let w = g.currentTarget.previousElementSibling;
            for (; w && w.getAttribute("aria-disabled") === "true"; )
              w = w.previousElementSibling;
            w && (w.focus(), g.currentTarget.blur());
            break;
          }
          case "ArrowRight": {
            let w = g.currentTarget.nextElementSibling;
            for (; w && w.getAttribute("aria-disabled") === "true"; )
              w = w.nextElementSibling;
            w && (w.focus(), g.currentTarget.blur());
            break;
          }
        }
    },
    [m, o, f, r]
  );
  return /* @__PURE__ */ l.createElement(
    ye,
    {
      ...c,
      className: q(a, gP, { [yP]: o }),
      ref: t,
      onClick: v,
      onFocus: () => b(!0),
      onBlur: () => b(!1),
      onKeyDown: h,
      "aria-disabled": o,
      "aria-selected": _,
      tabIndex: _ ? 0 : -1,
      role: "tab",
      gap: "small"
    },
    /* @__PURE__ */ l.createElement(
      U.div,
      {
        className: q(wP({ textColor: j, fontWeight: p }))
      },
      n
    ),
    /* @__PURE__ */ l.createElement(
      U.div,
      {
        className: q(
          CP,
          { [Mf.default]: !_ },
          { [Mf.active]: _ }
        )
      }
    )
  );
}), SP = l.forwardRef(
  (e, t) => {
    const { children: n, tabKey: r, className: a, ...s } = e, { activeTabKey: o } = l.useContext(Ou), i = !o || o === r;
    return /* @__PURE__ */ l.createElement(
      ye,
      {
        ...s,
        className: q(
          a,
          i ? Af.show : Af.hide
        ),
        ref: t,
        role: "tabpanel",
        tabIndex: i ? 0 : -1
      },
      n
    );
  }
);
xP.displayName = "Tab";
SP.displayName = "TabPanel";
const kP = l.forwardRef(
  (e, t) => {
    const { className: n, children: r, ...a } = e;
    return /* @__PURE__ */ l.createElement(
      re,
      {
        className: q(EP, n),
        ref: t,
        ...a,
        role: "tablist",
        "aria-orientation": "horizontal"
      },
      r
    );
  }
), TP = l.forwardRef((e, t) => {
  const { className: n, children: r, ...a } = e;
  return /* @__PURE__ */ l.createElement(ye, { ...a, className: n, ref: t }, r);
}), RP = l.forwardRef(
  (e, t) => {
    const { defaultActiveTabKey: n, className: r, children: a, ...s } = e, [o, i] = l.useState(n), c = l.useCallback(
      (u) => {
        u !== o && i(u);
      },
      [o, i]
    );
    return /* @__PURE__ */ l.createElement(ye, { className: r, ...s, ref: t }, /* @__PURE__ */ l.createElement(Ou.Provider, { value: { activeTabKey: o, setActiveTab: c } }, a));
  }
);
RP.displayName = "Tabs";
kP.displayName = "TabList";
TP.displayName = "TabContent";
var OP = "_1co3ikw1 _1co3ikw0 _1s8b37j284 _1s8b37j23y _1s8b37j25c _1s8b37j26q _1s8b37jk6 _1s8b37jka _1s8b37jke _1s8b37jki _1s8b37jkm _1s8b37jkq _1s8b37jku _1s8b37jky _1s8b37j80 _1s8b37jl3 _1s8b37jl5 _1s8b37j2 _1s8b37jl8 _1s8b37jlb _1s8b37jg _1s8b37j2vq", MP = "_1co3ikw3 _1co3ikw2 _1s8b37jcg _1s8b37jau _1s8b37j2", AP = "_1co3ikw5 _1co3ikw4 _1s8b37jb4 _1s8b37j5", PP = "_1co3ikw7 _1co3ikw6 _1s8b37jbg _1s8b37j8", NP = "_1co3ikw9 _1co3ikw8 _1s8b37jbs _1s8b37jb";
const zD = l.forwardRef(({ className: e, isDisabled: t, ...n }, r) => {
  const a = ut();
  return /* @__PURE__ */ l.createElement(
    U.textarea,
    {
      ...n,
      ...a.labelFor ? { id: a.labelFor } : {
        "aria-labelledby": n["aria-labelledby"] || a.labelId
      },
      disabled: t,
      className: q(e, OP, {
        [MP]: (a == null ? void 0 : a.appearance) == null || (a == null ? void 0 : a.appearance) === "neutral",
        [AP]: (a == null ? void 0 : a.appearance) == "danger",
        [PP]: (a == null ? void 0 : a.appearance) == "warning",
        [NP]: (a == null ? void 0 : a.appearance) == "success"
      }),
      ref: r
    }
  );
});
var DP = "_13jn1r91", IP = "_13jn1r94", $P = "_13jn1r95", LP = "_13jn1r96", zP = "_13jn1r97", FP = { danger: "_13jn1r9a _13jn1r98 _13jn1r99", warning: "_13jn1r9c _13jn1r98 _13jn1r9b", success: "_13jn1r9e _13jn1r98 _13jn1r9d", info: "_13jn1r9g _13jn1r98 _13jn1r9f" }, HP = "_13jn1r9h", BP = "_13jn1r9i";
const qP = 3, UP = ({
  className: e,
  title: t,
  appearance: n,
  message: r,
  id: a,
  duration: s,
  isDismissible: o = !0
}) => {
  const { clearToast: i, addToastTimer: c, removeToastTimer: u, disableTimers: f } = F_(), m = l.createRef(), b = l.useRef(!1), [_, j] = l.useState(), [p, v] = l.useState(null), h = l.useCallback(() => {
    if (!f && s && !_) {
      const w = s >= 5 ? s : 5, x = setTimeout(() => {
        i(a);
      }, w * 1e3);
      setTimeout(() => {
        j(x);
      }), c(x), v(w);
    }
  }, [s]), g = l.useCallback(() => {
    _ && (clearTimeout(_), u(_), j(void 0));
  }, [_]);
  return l.useEffect(() => {
    b.current || (b.current = !0, h());
  }, []), /* @__PURE__ */ l.createElement(
    cc,
    {
      ref: m,
      className: q(e, IP, DP),
      appearance: n || "info",
      onBlur: h,
      onFocus: g,
      onTouchStart: g,
      onMouseEnter: g,
      onMouseLeave: h,
      role: n === "danger" ? "alert" : "status"
    },
    /* @__PURE__ */ l.createElement(uc, null, /* @__PURE__ */ l.createElement(dc, null), /* @__PURE__ */ l.createElement(fc, null, /* @__PURE__ */ l.createElement(bc, null, t), typeof r == "string" ? /* @__PURE__ */ l.createElement(mc, null, r) : /* @__PURE__ */ l.createElement("div", { className: rb }, r), s && !f && /* @__PURE__ */ l.createElement(
      "div",
      {
        className: LP,
        "data-testid": "auto-dismiss-warning",
        "data-duration": p
      },
      `This message will be dismissed in ${p} seconds. Press Ctrl+Space to keep it open.`
    ), /* @__PURE__ */ l.createElement(
      "div",
      {
        style: { display: f || !s ? "none" : "block" },
        className: zP
      },
      /* @__PURE__ */ l.createElement(
        "div",
        {
          style: {
            opacity: _ ? 1 : 0,
            transitionDuration: _ ? `${p}s` : "unset"
          },
          className: q(
            FP[n || "info"],
            {
              [HP]: _
            }
          ),
          "data-testid": "timer-indicator",
          "data-timer-active": !!_
        }
      )
    ))),
    o && /* @__PURE__ */ l.createElement(
      ib,
      {
        onClick: () => {
          i(a);
        }
      }
    )
  );
}, WP = ({
  maxDisplayedToasts: e = qP
}) => {
  const { toasts: t, disableTimers: n } = F_(), r = l.useMemo(() => t.slice(0, e), [t]);
  return /* @__PURE__ */ l.createElement("div", { className: $P }, n && /* @__PURE__ */ l.createElement(
    "div",
    {
      role: "status",
      className: BP,
      "data-testid": "auto-dismiss-disabled"
    },
    "Message auto-dismiss timer has been disabled."
  ), r.map((a) => /* @__PURE__ */ l.createElement(
    UP,
    {
      key: a.id,
      id: a.id,
      title: a.title,
      message: a.message,
      appearance: a.appearance,
      duration: a.duration,
      isDismissible: a.isDismissible
    }
  )).reverse());
}, z_ = l.createContext({
  toasts: [],
  disableTimers: !1,
  addToastTimer: () => {
  },
  removeToastTimer: () => {
  },
  addToast: () => "",
  clearToast: () => {
  }
}), F_ = () => l.useContext(z_), FD = ({
  maxDisplayedToasts: e,
  children: t
}) => {
  const [n, r] = l.useState([]), [a, s] = l.useState([]), [o, i] = l.useState(!1), c = l.useCallback((_) => {
    r((j) => j.filter((p) => p.id !== _));
  }, []), u = l.useCallback((_) => {
    const j = `toast-${Date.now()}-${Math.floor(Math.random() * 1e5)}`;
    return r((p) => [...p, { ..._, id: j }]), j;
  }, []), f = l.useCallback(
    (_) => {
      s(a.concat([_]));
    },
    [a]
  ), m = l.useCallback(
    (_) => {
      s(a.filter((j) => j !== _));
    },
    [a]
  ), b = l.useCallback(
    (_) => {
      _.ctrlKey && _.key === " " && (_.preventDefault(), i(!0), a.forEach((j) => {
        j && clearTimeout(j);
      }));
    },
    [a == null ? void 0 : a.length]
  );
  return l.useEffect(() => (document.body.addEventListener("keydown", b), () => {
    document.body.removeEventListener("keydown", b);
  }), [b]), /* @__PURE__ */ l.createElement(
    z_.Provider,
    {
      value: {
        toasts: n,
        addToast: u,
        clearToast: c,
        addToastTimer: f,
        removeToastTimer: m,
        disableTimers: o
      }
    },
    /* @__PURE__ */ l.createElement(WP, { maxDisplayedToasts: e }),
    t
  );
}, VP = ({ sources: e, errors: t, refetch: n }) => /* @__PURE__ */ l.createElement(ye, { gap: "small" }, /* @__PURE__ */ l.createElement(re, { gap: "small", alignItems: "center" }, /* @__PURE__ */ l.createElement(
  me,
  {
    color: `rgb(${be.background.danger.default})`,
    icon: x1
  }
), `Loaded data from ${e - t} out of ${e} sources`), /* @__PURE__ */ l.createElement(cc, { appearance: "danger" }, /* @__PURE__ */ l.createElement(uc, null, /* @__PURE__ */ l.createElement(dc, null, /* @__PURE__ */ l.createElement(
  me,
  {
    icon: x1
  }
)), /* @__PURE__ */ l.createElement(fc, null, /* @__PURE__ */ l.createElement(bc, { level: "3" }, "Load failure"), /* @__PURE__ */ l.createElement(mc, null, `Data from ${t} source(s) failed to load.`))), /* @__PURE__ */ l.createElement(ob, null, n && /* @__PURE__ */ l.createElement(
  w2,
  {
    onClick: n,
    iconLeft: /* @__PURE__ */ l.createElement(
      me,
      {
        icon: Uh
      }
    )
  },
  "Retry"
)))), YP = ({
  loadings: e,
  sources: t
}) => /* @__PURE__ */ l.createElement(re, { gap: "small", alignItems: "center" }, /* @__PURE__ */ l.createElement(so, { width: "1rem", height: "1rem" }), `Loading data from ${e} out of ${t} sources`), GP = ({ successes: e, sources: t }) => /* @__PURE__ */ l.createElement(re, { gap: "small" }, /* @__PURE__ */ l.createElement(
  me,
  {
    color: `rgb(${be.background.success.default})`,
    icon: Th
  }
), `Loaded data from ${e} out of ${t} sources`), KP = (e) => Le(() => e.reduce(
  (n, r) => ((r.isLoading || r.isFetching || r.isRefetching) && (n.loadings += 1), (r.isError || r.isRefetchError) && (n.errors += 1), r.isSuccess && (n.successes += 1), n),
  { loadings: 0, errors: 0, successes: 0 }
), [e]), HD = ({
  sources: e,
  skipAnimationOnSuccess: t,
  ...n
}) => {
  const [r, a] = de(!0), { loadings: s, successes: o, errors: i } = KP(e);
  le(() => {
    if (o === e.length) {
      const b = setTimeout(() => {
        a(!1);
      }, 3e3);
      return () => clearTimeout(b);
    }
  }, [e.length, o]);
  const c = () => {
    const b = e.reduce((_, j) => ((j.isError || j.isRefetchError) && j.refetch && _.push(j.refetch), _), []);
    if (b.length)
      return () => b.forEach((_) => _());
  }, u = !!s, f = !u && !!i, m = !u && o === e.length;
  return t && m ? null : /* @__PURE__ */ l.createElement(Ma, { enter: "fadeIn", leave: "fadeOut", isShowing: r, ...n }, u && /* @__PURE__ */ l.createElement(YP, { loadings: s, sources: e.length }), f && /* @__PURE__ */ l.createElement(
    VP,
    {
      sources: e.length,
      errors: i,
      refetch: c()
    }
  ), m && /* @__PURE__ */ l.createElement(GP, { successes: o, sources: e.length }));
};
export {
  Pe as ActionEnums,
  vA as AlignControl,
  gs as AppearanceEnum,
  UN as Badge,
  VN as Banner,
  ob as BannerAccessoryContent,
  w2 as BannerButton,
  uc as BannerContent,
  mc as BannerDescription,
  ib as BannerDismissButton,
  dc as BannerIcon,
  cc as BannerRoot,
  fc as BannerTextContent,
  bc as BannerTitle,
  _8 as BreadcrumbLinkSeparator,
  XN as Breadcrumbs,
  m6 as BreadcrumbsCollapsed,
  _6 as BreadcrumbsRoot,
  Et as Button,
  R8 as Calendar,
  Cn as CalendarDay,
  E8 as CalendarHeader,
  x8 as CalendarHeaderTitle,
  na as CalendarIcon,
  T8 as CalendarMonths,
  S8 as CalendarNextButton,
  k8 as CalendarPreviousButton,
  W6 as CalendarRange,
  BR as CalendarRangeWrapper,
  C8 as CalendarRoot,
  lc as CaretDown,
  ic as CaretUp,
  ha as Check,
  Kj as CheckCircle,
  ZN as Checkbox,
  h5 as CheckboxText,
  Jj as ChevronDown,
  Xj as ChevronLeft,
  Jf as ChevronRight,
  Zj as ChevronUp,
  Hi as Clock,
  TA as CodeFormatControl,
  bu as CollectionItem,
  D8 as CollectionRoot,
  tD as Combobox,
  Kx as ComboboxContent,
  Z8 as ComboboxGroup,
  J8 as ComboboxGroupLabel,
  Nl as ComboboxItem,
  Ml as ComboboxItemCheck,
  Vx as ComboboxRoot,
  Yx as ComboboxTrigger,
  sn as DEFAULT_APPEARANCE,
  z5 as DEFAULT_PLACEHOLDER_LABEL,
  L8 as DEFAULT_QUERY_DELAY,
  Tl as DEFAULT_VALUE,
  iD as DataTable,
  Js as DateField,
  wD as DatePicker,
  Hl as DateRangeField,
  f_ as DateRangeMenu,
  gt as DateRangeMenuVariant,
  ED as DateRangePicker,
  HR as DateRangeSelectMenu,
  Rk as DateTime,
  Xd as DateTimeField,
  $t as DateTimeMenuVariant,
  dD as DateTimeProvider,
  Bl as DateTimeRangeField,
  xD as DateTimeRangePicker,
  qR as DateTimeRangeSelector,
  mD as Dialog,
  qr as DropdownMenu,
  WE as DropdownMenuExternalLinkItem,
  Qf as Exclamation,
  eb as ExclamationCircle,
  tb as ExclamationTriangle,
  nD as ExpandIconButton,
  rD as ExpandableContent,
  nb as ExternalLink,
  Ae as Field,
  Rn as FieldMode,
  sD as FilterMultiSelect,
  _D as Grid,
  re as HStack,
  kr as Heading,
  Me as IconButton,
  Qj as InfoCircle,
  eD as Item,
  et as KeyboardActions,
  z8 as LISTBOX_MIN_WIDTH,
  F8 as LISTBOX_SCROLL_WIDTH,
  e2 as Link,
  PA as LinkControl,
  RA as ListFormat,
  OA as ListFormatControl,
  so as Loading,
  HD as LoadingStatus,
  pD as LoadingWolf,
  UA as MarkdownCheatsheet,
  NA as MarkdownToggleControl,
  Ai as Menu,
  iR as MenuExternalLinkItemContent,
  WN as Minus,
  jD as MultiSelect,
  MS as MultiSelectDropdown,
  OS as MultiSelectDropdownTrigger,
  hD as Navbar,
  oD as NoDataMessage,
  $5 as OPEN_KEYS,
  gD as Page,
  yD as Pagination,
  Fe as Popover,
  YR as Portal,
  U as Primitive,
  kD as Radio,
  eo as RangeField,
  d_ as RangeFieldRoot,
  u_ as RangeSeparator,
  TD as RichTextEditor,
  QN as Root,
  L5 as SELECTION_KEYS,
  Bu as Search,
  Q8 as Select,
  H8 as SelectAppearanceEnum,
  dx as SelectContent,
  Z8 as SelectGroup,
  J8 as SelectGroupLabel,
  Ol as SelectItem,
  Ml as SelectItemCheck,
  Vs as SelectItemIcon,
  FR as SelectMenu,
  K8 as SelectRoot,
  ux as SelectTrigger,
  Qx as Skeleton,
  va as Slot,
  Sj as Slottable,
  DS as SortIconButton,
  OD as Switch,
  fk as TIME_REGEX,
  xP as Tab,
  TP as TabContent,
  kP as TabList,
  SP as TabPanel,
  $S as Table,
  MD as TableBody,
  ND as TableBodyCell,
  AD as TableFooter,
  ID as TableFooterCell,
  PD as TableHead,
  DD as TableHeadCell,
  LD as TableRoot,
  $D as TableRow,
  RP as Tabs,
  o_ as Tag,
  O7 as Tbody,
  Ll as Td,
  ne as Text,
  pr as TextField,
  kl as TextFieldIcon,
  So as TextFieldInput,
  xo as TextFieldRoot,
  DA as TextFormat,
  IA as TextFormatControl,
  $A as TextStyleControl,
  zD as TextareaField,
  HS as Th,
  BS as Thead,
  i_ as ThemeContext,
  vD as ThemeProvider,
  F7 as Time,
  qd as TimeAmPm,
  B7 as TimeField,
  Be as TimeFormat,
  ls as TimeHours,
  cs as TimeMinutes,
  CD as TimePicker,
  yk as TimeRoot,
  Bd as TimeSeconds,
  wr as Times,
  UP as Toast,
  FD as ToastProvider,
  BA as Toolbar,
  HA as ToolbarRoot,
  _t as Tooltip,
  Ks as Tr,
  Ma as Transition,
  Zf as Truncate,
  LA as UndoRedoControl,
  ds as VALIDATION_MESSAGES,
  ye as VStack,
  ON as allSizes,
  pk as applyTimeValue,
  Kf as atoms,
  xN as backgroundColorsRaw,
  SN as borderColorsRaw,
  IN as borderRadius,
  RN as borderWidths,
  DN as boxShadow,
  bj as breakpoints,
  i2 as buttonStyle,
  b2 as buttonVariants,
  q5 as clearSelectedOption,
  _j as colorStyles,
  be as colors,
  Xe as composeEventHandlers,
  Vf as composeRefs,
  bk as computeTimeDisabledState,
  LN as darkThemeColors,
  Fu as debounce,
  Xr as disableBodyScrolling,
  ma as focusFirst,
  Rl as focusLast,
  mj as focusOutlineStyles,
  zN as fontStyles,
  pn as formatDateString,
  Vo as formatDecimal,
  Lt as formatTimeValue,
  gj as getAtomProps,
  Vd as getDateTimeFormatString,
  ko as getFlatOptionsList,
  Ud as getFromLocalStorage,
  U6 as getHumanReadableDate,
  L7 as getInitialState,
  B8 as getOptionFromValue,
  U8 as getOptionIndex,
  W8 as getPosition,
  _k as getTimeDifference,
  $7 as getTimeFormatString,
  mk as getTimeMatrix,
  q8 as getTypeaheadMatch,
  ws as isAfter,
  ys as isBefore,
  cD as isISOString,
  Yn as isSame,
  $N as lightThemeColors,
  Ts as mapResponsiveValue,
  MN as maxWidths,
  AN as minHeights,
  PN as minWidths,
  G5 as moveFocus,
  ot as parseTimeValue,
  V8 as reducer,
  vj as responsiveStyles,
  oc as restoreBodyScrolling,
  qN as rgbToHex,
  Gn as serializeDate,
  W5 as setContentRef,
  K5 as setDisabled,
  V5 as setFocusedItemIdx,
  Y5 as setFocusedOption,
  Wd as setInLocalStorage,
  F5 as setOptions,
  U5 as setSelectedOption,
  BN as size,
  kN as sizes,
  Jx as skeleton,
  TN as spacing,
  Ur as splitDateTime,
  FN as text,
  EN as textColorsRaw,
  HN as themeSizes,
  NN as transitions,
  jj as unconditionalStyles,
  B5 as updateOpenState,
  H5 as updateValue,
  rj as useAnimationFrame,
  nn as useBreakpoint,
  yj as useBreakpoints,
  Tr as useCalendarContext,
  Xf as useCallbackRef,
  j5 as useCheckboxContext,
  _5 as useCheckboxGroupContext,
  JN as useCollection,
  Rr as useCollectionContext,
  We as useComposeRefs,
  nt as useControllableState,
  Ck as useDateRangeValidation,
  Na as useDateTimeContext,
  Ar as useDateTimeRangeInTimezone,
  Ek as useDateTimeRangeValidation,
  Kd as useDateTimeValidation,
  Xs as useDateValidation,
  xj as useDragAndDrop,
  ut as useFieldContext,
  uD as useFormattedDate,
  kt as useId,
  ao as useKeydown,
  KP as useLoadingStatus,
  Nr as useRichTextEditorContext,
  bR as useTheme,
  fD as useTimeRangeValidation,
  Zs as useTimeValidation,
  F_ as useToastContext,
  Ia as useToolbarContext,
  _a as validateDateString,
  zt as validateDateTimeString,
  lD as validateTimeString
};
